(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('isomorphic-fetch')) :
  typeof define === 'function' && define.amd ? define(['isomorphic-fetch'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.CirclesCore = factory(global.fetch));
})(this, (function (fetch) { 'use strict';

  function _typeof$1(obj) {
    "@babel/helpers - typeof";
    return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$1(obj);
  }

  function _toPrimitive(input, hint) {
    if (_typeof$1(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof$1(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }

  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof$1(key) === "symbol" ? key : String(key);
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct$1()) {
      _construct = Reflect.construct.bind();
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }

  function createSymbolObject(values) {
    return values.reduce(function (acc, type) {
      acc[type] = Symbol(type);
      return acc;
    }, {});
  }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var ErrorCodes = createSymbolObject(['FAILED_REQUEST', 'INSUFFICIENT_FUNDS', 'INVALID_OPTIONS', 'INVALID_TRANSFER', 'SAFE_NOT_FOUND', 'TOKEN_NOT_FOUND', 'TOO_COMPLEX_TRANSFER', 'TOO_MANY_ATTEMPTS', 'TRANSFER_NOT_FOUND', 'UNKNOWN_ERROR']);
  var CoreError = function (_Error) {
    _inherits(CoreError, _Error);
    var _super = _createSuper(CoreError);
    function CoreError() {
      var _this;
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown error occurred';
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ErrorCodes.UNKNOWN_ERROR;
      _classCallCheck(this, CoreError);
      _this = _super.call(this, message);
      _this.name = 'CoreError';
      if (typeof Error.captureStackTrace === 'function') {
        Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
      } else {
        _this.stack = new Error(message).stack;
      }
      _this.code = code;
      return _this;
    }
    return _createClass(CoreError);
  }( _wrapNativeSuper(Error));
  var RequestError = function (_CoreError) {
    _inherits(RequestError, _CoreError);
    var _super2 = _createSuper(RequestError);
    function RequestError(url, body, status) {
      var _this2;
      _classCallCheck(this, RequestError);
      _this2 = _super2.call(this, "Request failed @ ".concat(url, " with error ").concat(status), ErrorCodes.FAILED_REQUEST);
      _this2.name = 'RequestError';
      _this2.request = {
        url: url,
        body: body,
        status: status
      };
      return _this2;
    }
    return _createClass(RequestError);
  }(CoreError);
  var TransferError = function (_CoreError2) {
    _inherits(TransferError, _CoreError2);
    var _super3 = _createSuper(TransferError);
    function TransferError(message, code) {
      var _this3;
      var transferData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, TransferError);
      _this3 = _super3.call(this, message, code);
      _this3.name = 'TransferError';
      _this3.transfer = transferData;
      return _this3;
    }
    return _createClass(TransferError);
  }(CoreError);

  var DEFAULT_TYPE = 'string';
  var validators = {
    "boolean": function boolean(value) {
      return typeof value === 'boolean';
    },
    number: function number(value) {
      return typeof value === 'number';
    },
    string: function string(value) {
      return typeof value === 'string';
    },
    object: function object(value) {
      return _typeof$1(value) === 'object';
    },
    array: function array(value) {
      return Array.isArray(value);
    }
  };
  function safelyValidate(validatorFn, value) {
    if (!(typeof validatorFn === 'function')) {
      throw Error('Validation for "checkOptions" has to be of type function');
    }
    try {
      return !!validatorFn(value);
    } catch (_unused) {
      return false;
    }
  }
  function checkOptions(options, fields) {
    if (!options || _typeof$1(options) !== 'object') {
      throw new CoreError('Options missing', ErrorCodes.INVALID_OPTIONS);
    }
    return Object.keys(fields).reduce(function (acc, key) {
      var type = fields[key] && 'type' in fields[key] ? fields[key].type : DEFAULT_TYPE;
      var validatorFn = typeof type === 'function' ? type : validators[type];
      var defaultValue = fields[key] && 'default' in fields[key] ? fields[key]["default"] : null;
      if (defaultValue !== null && !safelyValidate(validatorFn, defaultValue)) {
        throw new CoreError("Field \"".concat(key, "\" has invalid default type"), ErrorCodes.INVALID_OPTIONS);
      }
      if (!(key in options) || typeof options[key] === 'undefined') {
        if (defaultValue === null) {
          throw new CoreError("\"".concat(key, "\" is missing in options"), ErrorCodes.INVALID_OPTIONS);
        }
        acc[key] = defaultValue;
      } else if (safelyValidate(validatorFn, options[key])) {
        acc[key] = options[key];
      } else {
        throw new CoreError("\"".concat(key, "\" has invalid type"), ErrorCodes.INVALID_OPTIONS);
      }
      return acc;
    }, {});
  }

  var _format$1 = "hh-sol-artifact-1";
  var contractName$4 = "GnosisSafeL2";
  var sourceName$1 = "contracts/GnosisSafeL2.sol";
  var abi$4 = [
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "AddedOwner",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "bytes32",
  				name: "approvedHash",
  				type: "bytes32"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "ApproveHash",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "handler",
  				type: "address"
  			}
  		],
  		name: "ChangedFallbackHandler",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "guard",
  				type: "address"
  			}
  		],
  		name: "ChangedGuard",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "threshold",
  				type: "uint256"
  			}
  		],
  		name: "ChangedThreshold",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "DisabledModule",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "EnabledModule",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "bytes32",
  				name: "txHash",
  				type: "bytes32"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "payment",
  				type: "uint256"
  			}
  		],
  		name: "ExecutionFailure",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "ExecutionFromModuleFailure",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "ExecutionFromModuleSuccess",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "bytes32",
  				name: "txHash",
  				type: "bytes32"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "payment",
  				type: "uint256"
  			}
  		],
  		name: "ExecutionSuccess",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "RemovedOwner",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				indexed: false,
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				indexed: false,
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "SafeModuleTransaction",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				indexed: false,
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				indexed: false,
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address payable",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "bytes",
  				name: "signatures",
  				type: "bytes"
  			},
  			{
  				indexed: false,
  				internalType: "bytes",
  				name: "additionalInfo",
  				type: "bytes"
  			}
  		],
  		name: "SafeMultiSigTransaction",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "sender",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			}
  		],
  		name: "SafeReceived",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "initiator",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address[]",
  				name: "owners",
  				type: "address[]"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "threshold",
  				type: "uint256"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "initializer",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "fallbackHandler",
  				type: "address"
  			}
  		],
  		name: "SafeSetup",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "bytes32",
  				name: "msgHash",
  				type: "bytes32"
  			}
  		],
  		name: "SignMsg",
  		type: "event"
  	},
  	{
  		stateMutability: "nonpayable",
  		type: "fallback"
  	},
  	{
  		inputs: [
  		],
  		name: "VERSION",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			}
  		],
  		name: "addOwnerWithThreshold",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "bytes32",
  				name: "hashToApprove",
  				type: "bytes32"
  			}
  		],
  		name: "approveHash",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			},
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		name: "approvedHashes",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			}
  		],
  		name: "changeThreshold",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "bytes32",
  				name: "dataHash",
  				type: "bytes32"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "bytes",
  				name: "signatures",
  				type: "bytes"
  			},
  			{
  				internalType: "uint256",
  				name: "requiredSignatures",
  				type: "uint256"
  			}
  		],
  		name: "checkNSignatures",
  		outputs: [
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "bytes32",
  				name: "dataHash",
  				type: "bytes32"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "bytes",
  				name: "signatures",
  				type: "bytes"
  			}
  		],
  		name: "checkSignatures",
  		outputs: [
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "prevModule",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "disableModule",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "domainSeparator",
  		outputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "enableModule",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_nonce",
  				type: "uint256"
  			}
  		],
  		name: "encodeTransactionData",
  		outputs: [
  			{
  				internalType: "bytes",
  				name: "",
  				type: "bytes"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				internalType: "address payable",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "signatures",
  				type: "bytes"
  			}
  		],
  		name: "execTransaction",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "payable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "execTransactionFromModule",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "success",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "execTransactionFromModuleReturnData",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "success",
  				type: "bool"
  			},
  			{
  				internalType: "bytes",
  				name: "returnData",
  				type: "bytes"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "getChainId",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "start",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "pageSize",
  				type: "uint256"
  			}
  		],
  		name: "getModulesPaginated",
  		outputs: [
  			{
  				internalType: "address[]",
  				name: "array",
  				type: "address[]"
  			},
  			{
  				internalType: "address",
  				name: "next",
  				type: "address"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "getOwners",
  		outputs: [
  			{
  				internalType: "address[]",
  				name: "",
  				type: "address[]"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "offset",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "length",
  				type: "uint256"
  			}
  		],
  		name: "getStorageAt",
  		outputs: [
  			{
  				internalType: "bytes",
  				name: "",
  				type: "bytes"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "getThreshold",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_nonce",
  				type: "uint256"
  			}
  		],
  		name: "getTransactionHash",
  		outputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "isModuleEnabled",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "isOwner",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "nonce",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "prevOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			}
  		],
  		name: "removeOwner",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "requiredTxGas",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "handler",
  				type: "address"
  			}
  		],
  		name: "setFallbackHandler",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "guard",
  				type: "address"
  			}
  		],
  		name: "setGuard",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address[]",
  				name: "_owners",
  				type: "address[]"
  			},
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "address",
  				name: "fallbackHandler",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "paymentToken",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "payment",
  				type: "uint256"
  			},
  			{
  				internalType: "address payable",
  				name: "paymentReceiver",
  				type: "address"
  			}
  		],
  		name: "setup",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		name: "signedMessages",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "targetContract",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "calldataPayload",
  				type: "bytes"
  			}
  		],
  		name: "simulateAndRevert",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "prevOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "oldOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "newOwner",
  				type: "address"
  			}
  		],
  		name: "swapOwner",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		stateMutability: "payable",
  		type: "receive"
  	}
  ];
  var bytecode$4 = "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";
  var deployedBytecode$4 = "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";
  var linkReferences$1 = {
  };
  var deployedLinkReferences$1 = {
  };
  var GnosisSafeContract = {
  	_format: _format$1,
  	contractName: contractName$4,
  	sourceName: sourceName$1,
  	abi: abi$4,
  	bytecode: bytecode$4,
  	deployedBytecode: deployedBytecode$4,
  	linkReferences: linkReferences$1,
  	deployedLinkReferences: deployedLinkReferences$1
  };

  var contractName$3 = "GnosisSafe";
  var abi$3 = [
  	{
  		inputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "constructor"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "AddedOwner",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "bytes32",
  				name: "approvedHash",
  				type: "bytes32"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "ApproveHash",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "masterCopy",
  				type: "address"
  			}
  		],
  		name: "ChangedMasterCopy",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "threshold",
  				type: "uint256"
  			}
  		],
  		name: "ChangedThreshold",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "contract Module",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "DisabledModule",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "contract Module",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "EnabledModule",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "bytes32",
  				name: "txHash",
  				type: "bytes32"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "payment",
  				type: "uint256"
  			}
  		],
  		name: "ExecutionFailure",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "ExecutionFromModuleFailure",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "ExecutionFromModuleSuccess",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "bytes32",
  				name: "txHash",
  				type: "bytes32"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "payment",
  				type: "uint256"
  			}
  		],
  		name: "ExecutionSuccess",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "RemovedOwner",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "bytes32",
  				name: "msgHash",
  				type: "bytes32"
  			}
  		],
  		name: "SignMsg",
  		type: "event"
  	},
  	{
  		payable: true,
  		stateMutability: "payable",
  		type: "fallback"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "NAME",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "VERSION",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			}
  		],
  		name: "addOwnerWithThreshold",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			},
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		name: "approvedHashes",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_masterCopy",
  				type: "address"
  			}
  		],
  		name: "changeMasterCopy",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			}
  		],
  		name: "changeThreshold",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "contract Module",
  				name: "prevModule",
  				type: "address"
  			},
  			{
  				internalType: "contract Module",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "disableModule",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "domainSeparator",
  		outputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "contract Module",
  				name: "module",
  				type: "address"
  			}
  		],
  		name: "enableModule",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "execTransactionFromModule",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "success",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "execTransactionFromModuleReturnData",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "success",
  				type: "bool"
  			},
  			{
  				internalType: "bytes",
  				name: "returnData",
  				type: "bytes"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "getModules",
  		outputs: [
  			{
  				internalType: "address[]",
  				name: "",
  				type: "address[]"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "start",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "pageSize",
  				type: "uint256"
  			}
  		],
  		name: "getModulesPaginated",
  		outputs: [
  			{
  				internalType: "address[]",
  				name: "array",
  				type: "address[]"
  			},
  			{
  				internalType: "address",
  				name: "next",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "getOwners",
  		outputs: [
  			{
  				internalType: "address[]",
  				name: "",
  				type: "address[]"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "getThreshold",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			}
  		],
  		name: "isOwner",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "nonce",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "prevOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			}
  		],
  		name: "removeOwner",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "handler",
  				type: "address"
  			}
  		],
  		name: "setFallbackHandler",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		name: "signedMessages",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "prevOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "oldOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "newOwner",
  				type: "address"
  			}
  		],
  		name: "swapOwner",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address[]",
  				name: "_owners",
  				type: "address[]"
  			},
  			{
  				internalType: "uint256",
  				name: "_threshold",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "address",
  				name: "fallbackHandler",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "paymentToken",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "payment",
  				type: "uint256"
  			},
  			{
  				internalType: "address payable",
  				name: "paymentReceiver",
  				type: "address"
  			}
  		],
  		name: "setup",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				internalType: "address payable",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "signatures",
  				type: "bytes"
  			}
  		],
  		name: "execTransaction",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "success",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			}
  		],
  		name: "requiredTxGas",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "bytes32",
  				name: "hashToApprove",
  				type: "bytes32"
  			}
  		],
  		name: "approveHash",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "bytes",
  				name: "_data",
  				type: "bytes"
  			}
  		],
  		name: "signMessage",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "bytes",
  				name: "_data",
  				type: "bytes"
  			},
  			{
  				internalType: "bytes",
  				name: "_signature",
  				type: "bytes"
  			}
  		],
  		name: "isValidSignature",
  		outputs: [
  			{
  				internalType: "bytes4",
  				name: "",
  				type: "bytes4"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "bytes",
  				name: "message",
  				type: "bytes"
  			}
  		],
  		name: "getMessageHash",
  		outputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_nonce",
  				type: "uint256"
  			}
  		],
  		name: "encodeTransactionData",
  		outputs: [
  			{
  				internalType: "bytes",
  				name: "",
  				type: "bytes"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			},
  			{
  				internalType: "enum Enum.Operation",
  				name: "operation",
  				type: "uint8"
  			},
  			{
  				internalType: "uint256",
  				name: "safeTxGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "baseGas",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "gasPrice",
  				type: "uint256"
  			},
  			{
  				internalType: "address",
  				name: "gasToken",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "refundReceiver",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_nonce",
  				type: "uint256"
  			}
  		],
  		name: "getTransactionHash",
  		outputs: [
  			{
  				internalType: "bytes32",
  				name: "",
  				type: "bytes32"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	}
  ];
  var bytecode$3 = "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";
  var deployedBytecode$3 = "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";
  var sourceMap$2 = "652:19113:0:-;;;2456:255;8:9:-1;5:2;;;30:1;27;20:12;5:2;2456:255:0;2703:1;2691:9;:13;;;;652:19113;;;;;;";
  var deployedSourceMap$2 = "652:19113:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1251:1:3;1239:9;:13;:37;;;;1275:1;1256:8;;:15;;:20;1239:37;1235:74;;;1292:7;;1235:74;1318:12;376:66;1333:29;;1318:44;;1372:15;1501:4;1495:11;1484:22;;1549:1;1530:21;;:7;:21;;;1526:437;;1681:14;1678:1;1675;1662:34;1772:1;1769;1753:14;1750:1;1747;1738:7;1733:3;1728:46;1812:16;1809:1;1806;1791:38;1861:1;1852:7;1849:14;1846:2;;;1876:16;1873:1;1866:27;1846:2;1922:16;1919:1;1912:27;1644:309;1108:861;;;652:19113:0;16841:367;;8:9:-1;5:2;;;30:1;27;20:12;5:2;16841:367:0;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;16841:367:0;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;16841:367:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;16841:367:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;16841:367:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;16841:367:0;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;2296:645:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2296:645:6;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2296:645:6;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;16176:507:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;16176:507:0;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;16176:507:0;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;16176:507:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;16176:507:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;16176:507:0;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;16176:507:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;16176:507:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;16176:507:0;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;6068:166:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6068:166:6;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6068:166:6;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;3039:603:5;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3039:603:5;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;3039:603:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;3039:603:5;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;3039:603:5;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;3039:603:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;3039:603:5;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;3993:949;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3993:949:5;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;3993:949:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;3993:949:5;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;3993:949:5;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;3993:949:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;3993:949:5;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;3993:949:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2115:49:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2115:49:0;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2115:49:0;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;1337:540:5;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1337:540:5;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1337:540:5;;;;;;;;;;;;;;;;;;;:::i;:::-;;5500:441:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5500:441:6;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5500:441:6;;;;;;;;;;;;;;;;;:::i;:::-;;5479:1886:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5479:1886:0;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;5479:1886:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;5479:1886:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;5479:1886:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;5479:1886:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;5479:1886:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;5479:1886:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;5479:1886:0;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;2275:69;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2275:69:0;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2275:69:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;794:302:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;794:302:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;794:302:9;;;;;;;;;;;;;;;;;;;:::i;:::-;;15353:207:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;15353:207:0;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;15353:207:0;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;15353:207:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;15353:207:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;15353:207:0;;;;;;;;;;;;:::i;:::-;;6316:465:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6316:465:6;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;6316:465:6;;;;;;;;;;;;;;;;;846:43:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;846:43:0;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;846:43:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1956:20;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1956:20:0;;;:::i;:::-;;;;;;;;;;;;;;;;;;;5030:197:5;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5030:197:5;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;5030:197:5;;;;;;;;;;;;;;;;;3327:1122:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3327:1122:0;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;3327:1122:0;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;3327:1122:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;3327:1122:0;;;;;;101:9:-1;95:2;81:12;77:21;67:8;63:36;60:51;39:11;25:12;22:29;11:108;8:2;;;132:1;129;122:12;8:2;3327:1122:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;3327:1122:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;3327:1122:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;3327:1122:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;14099:583;;8:9:-1;5:2;;;30:1;27;20:12;5:2;14099:583:0;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;14099:583:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;14099:583:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;14099:583:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;14099:583:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;5421:808:5;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5421:808:5;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5421:808:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;5421:808:5;;;;;;;;;;;;;;;;;;14926:265:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;14926:265:0;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;14926:265:0;;;;;;;;;;;;;;;;;:::i;:::-;;19259:504;;8:9:-1;5:2;;;30:1;27;20:12;5:2;19259:504:0;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;19259:504:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;19259:504:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;19259:504:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;19259:504:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;19259:504:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;2138:565:5;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2138:565:5;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2138:565:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;4452:859:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4452:859:6;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;4452:859:6;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;5947:115;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5947:115:6;;;:::i;:::-;;;;;;;;;;;;;;;;;;;17921:652:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;17921:652:0;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;17921:652:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;21:11:-1;8;5:28;2:2;;;46:1;43;36:12;2:2;17921:652:0;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;17921:652:0;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;39:11;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;17921:652:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;17921:652:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;17921:652:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;967:135:3;;8:9:-1;5:2;;;30:1;27;20:12;5:2;967:135:3;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;967:135:3;;;;;;;;;;;;;;;;;;;:::i;:::-;;1982:30:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1982:30:0;;;:::i;:::-;;;;;;;;;;;;;;;;;;;3283:835:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3283:835:6;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3283:835:6;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;895:40:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;895:40:0;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;895:40:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;16841:367;16946:7;16969:23;1576:66;17029:17;;17058:7;17048:18;;;;;;17018:49;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;17018::0;;;16995:82;;;;;;16969:108;;17139:4;17134:10;;17151:4;17146:10;;17158:15;;17175;17117:74;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;17117:74:0;;;17094:107;;;;;;17087:114;;;16841:367;;;:::o;2296:645:6:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2476:1:6;2459:19;;:5;:19;;;;:47;;;;;479:3;2482:24;;:5;:24;;;;2459:47;2451:90;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2624:1;2599:27;;:6;:13;2606:5;2599:13;;;;;;;;;;;;;;;;;;;;;;;;;:27;;;2591:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2684:6;:23;479:3;2684:23;;;;;;;;;;;;;;;;;;;;;;;;;2668:6;:13;2675:5;2668:13;;;;;;;;;;;;;;;;:39;;;;;;;;;;;;;;;;;;2743:5;2717:6;:23;479:3;2717:23;;;;;;;;;;;;;;;;:31;;;;;;;;;;;;;;;;;;2758:10;;:12;;;;;;;;;;;;;2785:17;2796:5;2785:17;;;;;;;;;;;;;;;;;;;;;;2883:10;2870:9;;:23;2866:68;;2907:27;2923:10;2907:15;:27::i;:::-;2866:68;2296:645;;:::o;16176:507:0:-;16285:6;16307:19;16329:21;16344:5;;16329:21;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;16329:21:0;;;;;;:14;:21::i;:::-;16307:43;;16385:1;16364:10;;:17;;:22;16360:281;;;16441:1;16410:14;:27;16425:11;16410:27;;;;;;;;;;;;:32;;16402:62;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;16360:281;;;16576:54;16592:11;16605:5;;16576:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;16576:54:0;;;;;;16612:10;;16576:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;16576:54:0;;;;;;16624:5;16576:15;:54::i;:::-;16360:281;181:10:18;16657:19:0;;16650:26;;;16176:507;;;;;;:::o;6068:166:6:-;6145:4;479:3;6172:24;;:5;:24;;;;:55;;;;;6225:1;6200:27;;:6;:13;6207:5;6200:13;;;;;;;;;;;;;;;;;;;;;;;;;:27;;;;6172:55;6165:62;;6068:166;;;:::o;3039:603:5:-;3178:12;673:3;3263:30;;:10;:30;;;;:67;;;;;3328:1;3297:33;;:7;:19;3305:10;3297:19;;;;;;;;;;;;;;;;;;;;;;;;;:33;;;;3263:67;3255:128;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3465:46;3473:2;3477:5;3484:4;3490:9;3501;3465:7;:46::i;:::-;3455:56;;3525:7;3521:114;;;3566:10;3539:38;;;;;;;;;;;;3521:114;;;3624:10;3597:38;;;;;;;;;;;;3521:114;3039:603;;;;;;:::o;3993:949::-;4142:12;4156:23;4205:53;4231:2;4235:5;4242:4;4248:9;4205:25;:53::i;:::-;4195:63;;4413:4;4407:11;4655:4;4637:16;4633:27;4628:3;4624:37;4618:4;4611:51;4717:16;4712:3;4705:29;4811:16;4808:1;4801:4;4796:3;4792:14;4777:51;4923:3;4909:17;;4341:595;;;;;;;;:::o;2115:49:0:-;;;;;;;;;;;;;;;;;:::o;1337:540:5:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1511:1:5;1484:29;;1492:6;1484:29;;;;:68;;;;;673:3;1517:35;;1525:6;1517:35;;;;1484:68;1476:112;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1683:1;1647:38;;:7;:24;1663:6;1647:24;;;;;;;;;;;;;;;;;;;;;;;;;:38;;;1639:80;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1756:7;:25;673:3;1756:25;;;;;;;;;;;;;;;;;;;;;;;;;1729:7;:24;1745:6;1729:24;;;;;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;1827:6;1791:7;:25;673:3;1791:25;;;;;;;;;;;;;;;;:43;;;;;;;;;;;;;;;;;;1849:21;1863:6;1849:21;;;;;;;;;;;;;;;;;;;;;;1337:540;:::o;5500:441:6:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5684:10:6;;5670;:24;;5662:72;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5818:1;5804:10;:15;;5796:64;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5882:10;5870:9;:22;;;;5907:27;5924:9;;5907:27;;;;;;;;;;;;;;;;;;5500:441;:::o;5479:1886:0:-;5829:12;5857:14;5984:23;6010:210;6049:2;6053:5;6060:4;;6010:210;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;6010:210:0;;;;;;6066:9;6113;6124:7;6133:8;6143;6153:14;6201:5;;6010:21;:210::i;:::-;5984:236;;6289:5;;:7;;;;;;;;;;;;;6329:10;6319:21;;;;;;6310:30;;6354:53;6370:6;6378:10;6390;;6354:53;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;6354:53:0;;;;;;6402:4;6354:15;:53::i;:::-;5479:1886;6448:9;6435;:22;;6427:77;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6617:15;6635:9;6617:27;;6779:92;6787:2;6791:5;6798:4;;6779:92;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;6779:92:0;;;;;;6804:9;6828:1;6815:9;:14;:31;;;;;6845:1;6833:8;:13;6815:31;:55;;6861:9;6815:55;;;6849:9;6815:55;6779:7;:92::i;:::-;6769:102;;6895:22;6907:9;6895:7;:11;;:22;;;;:::i;:::-;6885:32;;7066:15;7084:1;7066:19;;7114:1;7103:8;:12;7099:128;;;7145:67;7159:7;7168;7177:8;7187;7197:14;7145:13;:67::i;:::-;7135:77;;7099:128;7244:7;7240:108;;;7258:33;7275:6;7283:7;7258:33;;;;;;;;;;;;;;;;;;;;;;;;7240:108;;;7315:33;7332:6;7340:7;7315:33;;;;;;;;;;;;;;;;;;;;;;;;7240:108;5479:1886;;;;;;;;;;;;;;;;;:::o;2275:69::-;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;794:302:9:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;967:1:9;944:25;;:11;:25;;;;936:74;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1033:11;1020:10;;:24;;;;;;;;;;;;;;;;;;1059:30;1077:11;1059:30;;;;;;;;;;;;;;;;;;;;;;794:302;:::o;15353:207:0:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15446:15:0;15464:21;15479:5;;15464:21;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;15464:21:0;;;;;;:14;:21::i;:::-;15446:39;;15521:1;15495:14;:23;15510:7;15495:23;;;;;;;;;;;:27;;;;15545:7;15537:16;;;;;;;;;;316:1:11;15353:207:0;;:::o;6316:465:6:-;6382:16;6414:22;6453:10;;6439:25;;;;;;;;;;;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;148:4;140:6;136:17;126:27;;0:157;6439:25:6;;;;6414:50;;6508:13;6524:1;6508:17;;6535:20;6558:6;:23;479:3;6558:23;;;;;;;;;;;;;;;;;;;;;;;;;6535:46;;6591:162;479:3;6597:31;;:12;:31;;;6591:162;;6659:12;6644:5;6650;6644:12;;;;;;;;;;;;;:27;;;;;;;;;;;6700:6;:20;6707:12;6700:20;;;;;;;;;;;;;;;;;;;;;;;;;6685:35;;6734:8;;;;;;;6591:162;;;6769:5;6762:12;;;;;6316:465;:::o;846:43:0:-;;;;;;;;;;;;;;;;;;;:::o;1956:20::-;;;;:::o;5030:197:5:-;5097:16;5130:22;5157:41;673:3;5195:2;5157:19;:41::i;:::-;5129:69;;;5215:5;5208:12;;;5030:197;:::o;3327:1122:0:-;3648:1;3629:20;;:15;;:20;3621:62;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1073:66;3732:25;;3759:4;3721:43;;;;;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;3721:43:0;;;3711:54;;;;;;3693:15;:72;;;;3775:32;3787:7;;3775:32;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;3775:32:0;;;;;;3796:10;3775:11;:32::i;:::-;3848:1;3821:29;;:15;:29;;;3817:78;;3852:43;3879:15;3852:26;:43::i;:::-;3817:78;4030:22;4043:2;4047:4;;4030:22;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;4030:22:0;;;;;;:12;:22::i;:::-;4077:1;4067:7;:11;4063:380;;;4373:59;4387:7;4396:1;4399;4402:12;4416:15;4373:13;:59::i;:::-;;4063:380;3327:1122;;;;;;;;;;:::o;14099:583::-;14249:7;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14272:16:0;14291:9;14272:28;;14454:46;14462:2;14466:5;14473:4;;14454:46;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;93:3;85:6;81:16;74:27;137:4;133:9;126:4;121:3;117:14;113:30;106:37;;169:3;161:6;157:16;147:26;;14454:46:0;;;;;;14479:9;14490;14454:7;:46::i;:::-;14446:55;;;;;;14511:19;14544:9;14533:8;:20;14511:42;;14661:11;14644:29;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;14644:29:0;;;14630:45;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;14630:45:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5421:808:5;5528:22;5552:12;5643:8;5629:23;;;;;;;;;;;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;148:4;140:6;136:17;126:27;;0:157;5629:23:5;;;;5621:31;;5696:19;5718:1;5696:23;;5729:21;5753:7;:14;5761:5;5753:14;;;;;;;;;;;;;;;;;;;;;;;;;5729:38;;5777:238;5808:3;5783:29;;:13;:29;;;;:66;;;;;673:3;5816:33;;:13;:33;;;;5783:66;:92;;;;;5867:8;5853:11;:22;5783:92;5777:238;;;5912:13;5891:5;5897:11;5891:18;;;;;;;;;;;;;:34;;;;;;;;;;;5955:7;:22;5963:13;5955:22;;;;;;;;;;;;;;;;;;;;;;;;;5939:38;;5991:13;;;;;;;5777:238;;;6031:13;6024:20;;6201:11;6194:5;6187:26;6173:50;;;;;;;:::o;14926:265:0:-;15039:1;15009:32;;:6;:18;15016:10;15009:18;;;;;;;;;;;;;;;;;;;;;;;;;:32;;;;15001:75;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15130:1;15086:14;:26;15101:10;15086:26;;;;;;;;;;;;;;;:41;15113:13;15086:41;;;;;;;;;;;:45;;;;15173:10;15146:38;;15158:13;15146:38;;;;;;;;;;14926:265;:::o;19259:504::-;19602:7;19642:113;19664:2;19668:5;19675:4;19681:9;19692;19703:7;19712:8;19722;19732:14;19748:6;19642:21;:113::i;:::-;19632:124;;;;;;19625:131;;19259:504;;;;;;;;;;;;:::o;2138:565:5:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2360:1:5;2333:29;;2341:6;2333:29;;;;:68;;;;;673:3;2366:35;;2374:6;2366:35;;;;2333:68;2325:112;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2495:6;2455:47;;:7;:28;2471:10;2455:28;;;;;;;;;;;;;;;;;;;;;;;;;:47;;;2447:100;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2588:7;:24;2604:6;2588:24;;;;;;;;;;;;;;;;;;;;;;;;;2557:7;:28;2573:10;2557:28;;;;;;;;;;;;;;;;:55;;;;;;;;;;;;;;;;;;2657:1;2622:7;:24;2638:6;2622:24;;;;;;;;;;;;;;;;:37;;;;;;;;;;;;;;;;;;2674:22;2689:6;2674:22;;;;;;;;;;;;;;;;;;;;;;2138:565;;:::o;4452:859:6:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4643:1:6;4623:22;;:8;:22;;;;:53;;;;;479:3;4649:27;;:8;:27;;;;4623:53;4615:96;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4797:1;4769:30;;:6;:16;4776:8;4769:16;;;;;;;;;;;;;;;;;;;;;;;;;:30;;;4761:70;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4952:1;4932:22;;:8;:22;;;;:53;;;;;479:3;4958:27;;:8;:27;;;;4932:53;4924:96;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5059:8;5038:29;;:6;:17;5045:9;5038:17;;;;;;;;;;;;;;;;;;;;;;;;;:29;;;5030:80;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5139:6;:16;5146:8;5139:16;;;;;;;;;;;;;;;;;;;;;;;;;5120:6;:16;5127:8;5120:16;;;;;;;;;;;;;;;;:35;;;;;;;;;;;;;;;;;;5185:8;5165:6;:17;5172:9;5165:17;;;;;;;;;;;;;;;;:28;;;;;;;;;;;;;;;;;;5230:1;5203:6;:16;5210:8;5203:16;;;;;;;;;;;;;;;;:29;;;;;;;;;;;;;;;;;;5247:22;5260:8;5247:22;;;;;;;;;;;;;;;;;;;;;;5284:20;5295:8;5284:20;;;;;;;;;;;;;;;;;;;;;;4452:859;;;:::o;5947:115::-;6016:7;6046:9;;6039:16;;5947:115;:::o;17921:652:0:-;18267:12;18295:18;1393:66;18350:16;;18368:2;18372:5;18389:4;18379:15;;;;;;18396:9;18407;18418:7;18427:8;18437;18447:14;18463:6;18339:131;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;18339:131:0;;;18316:164;;;;;;18295:185;;18519:4;18514:10;;18531:4;18526:10;;18538:15;;18555:10;18497:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;18497:69:0;;;18490:76;;;17921:652;;;;;;;;;;;;:::o;967:135:3:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1060:35:3;1087:7;1060:26;:35::i;:::-;967:135;:::o;1982:30:0:-;;;;:::o;3283:835:6:-;252:4:11;230:27;;:10;:27;;;222:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3509:10:6;3504:1;3491:10;;:14;:28;;3483:94;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3692:1;3675:19;;:5;:19;;;;:47;;;;;479:3;3698:24;;:5;:24;;;;3675:47;3667:90;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3796:5;3775:26;;:6;:17;3782:9;3775:17;;;;;;;;;;;;;;;;;;;;;;;;;:26;;;3767:77;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3874:6;:13;3881:5;3874:13;;;;;;;;;;;;;;;;;;;;;;;;;3854:6;:17;3861:9;3854:17;;;;;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;3921:1;3897:6;:13;3904:5;3897:13;;;;;;;;;;;;;;;;:26;;;;;;;;;;;;;;;;;;3933:10;;:12;;;;;;;;;;;;;;3960:19;3973:5;3960:19;;;;;;;;;;;;;;;;;;;;;;4060:10;4047:9;;:23;4043:68;;4084:27;4100:10;4084:15;:27::i;:::-;4043:68;3283:835;;;:::o;895:40:0:-;;;;;;;;;;;;;;;;;;;:::o;8878:4309::-;9072:18;9093:9;;9072:30;;9174:1;9161:10;:14;9153:57;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9316:18;9331:2;9316:10;:14;;:18;;;;:::i;:::-;9295:10;:17;:39;;9287:77;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9426:17;9454:1;9426:30;;9466:20;9496:7;9513:9;9532;9551;9579:1;9575:5;;9570:3611;9586:10;9582:1;:14;9570:3611;;;9629:29;9644:10;9656:1;9629:14;:29::i;:::-;9617:41;;;;;;;;;;;;9738:1;9733;:6;;;9729:3211;;;9889:1;9881:10;;9858:34;;10293:18;10308:2;10293:10;:14;;:18;;;;:::i;:::-;10287:1;10279:10;;:32;;10271:100;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10533:10;:17;10511:18;10526:2;10519:1;10511:10;;:14;;:18;;;;:::i;:::-;:39;;10503:107;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10754:28;10957:4;10953:1;10941:10;10937:18;10933:29;10927:36;10903:60;;11054:10;:17;11006:44;11029:20;11006:18;11021:2;11014:1;11006:10;;:14;;:18;;;;:::i;:::-;:22;;:44;;;;:::i;:::-;:65;;10998:132;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11184:30;11519:4;11515:1;11503:10;11499:18;11495:29;11474:50;;181:10:18;11646:19:0;;11567:98;;;11587:12;11567:50;;;11618:4;11624:17;11567:75;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;11567:75:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;11567:75:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;11567:75:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;11567:75:0;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;11567:75:0;;;;;;;;;;;;;;;;:98;;;;11559:146;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9729:3211;;;;;11788:1;11783;:6;;;11779:1161;;;11935:1;11927:10;;11904:34;;12123:12;12109:26;;:10;:26;;;:73;;;;12181:1;12139:14;:28;12154:12;12139:28;;;;;;;;;;;;;;;:38;12168:8;12139:38;;;;;;;;;;;;:43;;12109:73;12101:112;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;12335:11;:41;;;;;12364:12;12350:26;;:10;:26;;;;12335:41;12331:130;;;12441:1;12400:14;:28;12415:12;12400:28;;;;;;;;;;;;;;;:38;12429:8;12400:38;;;;;;;;;;;:42;;;;12331:130;11779:1161;;;12489:2;12485:1;:6;;;12481:459;;;12673:97;12746:8;12693:62;;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;12693:62:0;;;12683:73;;;;;;12762:1;12758;:5;12765:1;12768;12673:97;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;12673:97:0;;;;;;;;12658:112;;12481:459;;;12897:28;12907:8;12917:1;12920;12923;12897:28;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;12897:28:0;;;;;;;;12882:43;;12481:459;11779:1161;9729:3211;12994:9;12979:24;;:12;:24;;;:62;;;;;13039:1;13007:34;;:6;:20;13014:12;13007:20;;;;;;;;;;;;;;;;;;;;;;;;;:34;;;;12979:62;:97;;;;;479:3:6;13045:31:0;;:12;:31;;;;12979:97;12953:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13158:12;13146:24;;9598:3;;;;;;;9570:3611;;;8878:4309;;;;;;;;;;;:::o;202:429:2:-;340:12;385:19;372:32;;;;;;;;:9;:32;;;;;;;;;368:256;;;428:35;440:2;444:5;451:4;457:5;428:11;:35::i;:::-;418:45;;368:256;;;495:27;482:40;;;;;;;;:9;:40;;;;;;;;;478:146;;;546:36;566:2;570:4;576:5;546:19;:36::i;:::-;536:46;;478:146;;;619:5;609:15;;478:146;368:256;202:429;;;;;;;:::o;1141:131:13:-;1199:7;1227:1;1222;:6;;1214:15;;;;;;1235:9;1251:1;1247;:5;1235:17;;1266:1;1259:8;;;1141:131;;;;:::o;7371:952:0:-;7575:15;7664:24;7717:1;7691:28;;:14;:28;;;:57;;7734:14;7691:57;;;7722:9;7691:57;7664:84;;7782:1;7762:22;;:8;:22;;;7758:559;;;7915:73;7951:11;7940:8;:22;:47;;7976:11;7940:47;;;7965:8;7940:47;7915:20;7927:7;7915;:11;;:20;;;;:::i;:::-;:24;;:73;;;;:::i;:::-;7905:83;;8067:8;:13;;:22;8081:7;8067:22;;;;;;;;;;;;;;;;;;;;;;;8059:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7758:559;;;8169:34;8194:8;8169:20;8181:7;8169;:11;;:20;;;;:::i;:::-;:24;;:34;;;;:::i;:::-;8159:44;;8225:42;8239:8;8249;8259:7;8225:13;:42::i;:::-;8217:89;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7758:559;7371:952;;;;;;;;:::o;785:1271:6:-;1028:1;1015:9;;:14;1007:57;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1171:7;:14;1157:10;:28;;1149:76;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1309:1;1295:10;:15;;1287:64;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1398:20;479:3;1398:38;;1451:9;1463:1;1451:13;;1446:487;1470:7;:14;1466:1;:18;1446:487;;;1550:13;1566:7;1574:1;1566:10;;;;;;;;;;;;;;1550:26;;1615:1;1598:19;;:5;:19;;;;:47;;;;;479:3;1621:24;;:5;:24;;;;1598:47;1590:90;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1771:1;1746:27;;:6;:13;1753:5;1746:13;;;;;;;;;;;;;;;;;;;;;;;;;:27;;;1738:72;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1847:5;1824:6;:20;1831:12;1824:20;;;;;;;;;;;;;;;;:28;;;;;;;;;;;;;;;;;;1881:5;1866:20;;1905:17;1916:5;1905:17;;;;;;;;;;;;;;;;;;;;;;1446:487;1486:3;;;;;;;1446:487;;;;479:3;1942:6;:20;1949:12;1942:20;;;;;;;;;;;;;;;;:38;;;;;;;;;;;;;;;;;;2003:7;:14;1990:10;:27;;;;2039:10;2027:9;:22;;;;785:1271;;;:::o;449:250:3:-;521:12;376:66;536:29;;521:44;;675:7;669:4;662:21;648:45;;:::o;736:434:5:-;865:1;828:39;;:7;:25;673:3;828:25;;;;;;;;;;;;;;;;;;;;;;;;;:39;;;820:89;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;673:3;919:7;:25;673:3;919:25;;;;;;;;;;;;;;;;:44;;;;;;;;;;;;;;;;;;991:1;977:16;;:2;:16;;;973:190;;1087:40;1107:2;1111:4;1117:9;1087:19;:40::i;:::-;1079:84;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;973:190;736:434;;:::o;267:381:13:-;325:7;554:1;549;:6;545:35;;;572:1;565:8;;;;545:35;586:9;602:1;598;:5;586:17;;626:1;621;617;:5;;;;;;:10;609:19;;;;;;642:1;635:8;;;267:381;;;;;:::o;1223:921:12:-;1332:7;1341:9;1352;1652:3;1646:4;1642:14;1714:4;1700:12;1696:23;1684:10;1680:40;1674:47;1669:52;;1779:4;1765:12;1761:23;1749:10;1745:40;1739:47;1734:52;;2123:4;2114;2100:12;2096:23;2084:10;2080:40;2074:47;2070:58;2065:63;;1608:530;;;;;;:::o;1335:131:13:-;1393:7;1408:9;1424:1;1420;:5;1408:17;;1444:1;1439;:6;;1431:15;;;;;;1460:1;1453:8;;;1335:131;;;;:::o;637:316:2:-;753:12;935:1;932;925:4;919:11;912:4;906;902:15;895:5;891:2;884:5;879:58;868:69;;854:93;;;;;;:::o;959:310::-;1068:12;1251:1;1248;1241:4;1235:11;1228:4;1222;1218:15;1214:2;1207:5;1194:59;1183:70;;1169:94;;;;;:::o;438:807:10:-;575:16;607:17;680:8;690:6;627:70;;;;;;;;;;;;;;;;;;;;;;;;;49:4:-1;39:7;30;26:21;22:32;13:7;6:49;627:70:10;;;;;;;38:4:-1;29:7;25:18;67:10;61:17;96:58;199:8;192:4;186;182:15;179:29;167:10;160:49;0:215;;;627:70:10;607:90;;874:1;871;864:4;858:11;851:4;845;841:15;838:1;831:5;823;818:3;814:15;809:67;906:4;900:11;946:16;941:3;937:26;931:4;924:40;1000:16;997:1;992:3;977:40;1037:16;1071:1;1066:33;;;;1117:4;1112:76;;;;1226:1;1211:16;;1030:199;;1066:33;1090:7;1075:22;;1066:33;;1112:76;1179:3;1173:10;1166:18;1156:7;1149:15;1146:39;1139:47;1124:62;;1030:199;;780:459;;;;;;;;:::o";
  var source$2 = "pragma solidity >=0.5.0 <0.7.0;\nimport \"./base/ModuleManager.sol\";\nimport \"./base/OwnerManager.sol\";\nimport \"./base/FallbackManager.sol\";\nimport \"./common/MasterCopy.sol\";\nimport \"./common/SignatureDecoder.sol\";\nimport \"./common/SecuredTokenTransfer.sol\";\nimport \"./interfaces/ISignatureValidator.sol\";\nimport \"./external/SafeMath.sol\";\n\n/// @title Gnosis Safe - A multisignature wallet with support for confirmations using signed messages based on ERC191.\n/// @author Stefan George - <stefan@gnosis.io>\n/// @author Richard Meissner - <richard@gnosis.io>\n/// @author Ricardo Guilherme Schmidt - (Status Research & Development GmbH) - Gas Token Payment\ncontract GnosisSafe\n    is MasterCopy, ModuleManager, OwnerManager, SignatureDecoder, SecuredTokenTransfer, ISignatureValidatorConstants, FallbackManager {\n\n    using SafeMath for uint256;\n\n    string public constant NAME = \"Gnosis Safe\";\n    string public constant VERSION = \"1.1.1\";\n\n    //keccak256(\n    //    \"EIP712Domain(address verifyingContract)\"\n    //);\n    bytes32 private constant DOMAIN_SEPARATOR_TYPEHASH = 0x035aff83d86937d35b32e04f0ddc6ff469290eef2f1b692d8a815c89404d4749;\n\n    //keccak256(\n    //    \"SafeTx(address to,uint256 value,bytes data,uint8 operation,uint256 safeTxGas,uint256 baseGas,uint256 gasPrice,address gasToken,address refundReceiver,uint256 nonce)\"\n    //);\n    bytes32 private constant SAFE_TX_TYPEHASH = 0xbb8310d486368db6bd6f849402fdd73ad53d316b5a4b2644ad6efe0f941286d8;\n\n    //keccak256(\n    //    \"SafeMessage(bytes message)\"\n    //);\n    bytes32 private constant SAFE_MSG_TYPEHASH = 0x60b3cbf8b4a223d68d641b3b6ddf9a298e7f33710cf3d3a9d1146b5a6150fbca;\n\n    event ApproveHash(\n        bytes32 indexed approvedHash,\n        address indexed owner\n    );\n    event SignMsg(\n        bytes32 indexed msgHash\n    );\n    event ExecutionFailure(\n        bytes32 txHash, uint256 payment\n    );\n    event ExecutionSuccess(\n        bytes32 txHash, uint256 payment\n    );\n\n    uint256 public nonce;\n    bytes32 public domainSeparator;\n    // Mapping to keep track of all message hashes that have been approve by ALL REQUIRED owners\n    mapping(bytes32 => uint256) public signedMessages;\n    // Mapping to keep track of all hashes (message or transaction) that have been approve by ANY owners\n    mapping(address => mapping(bytes32 => uint256)) public approvedHashes;\n\n    // This constructor ensures that this contract can only be used as a master copy for Proxy contracts\n    constructor() public {\n        // By setting the threshold it is not possible to call setup anymore,\n        // so we create a Safe with 0 owners and threshold 1.\n        // This is an unusable Safe, perfect for the mastercopy\n        threshold = 1;\n    }\n\n    /// @dev Setup function sets initial storage of contract.\n    /// @param _owners List of Safe owners.\n    /// @param _threshold Number of required confirmations for a Safe transaction.\n    /// @param to Contract address for optional delegate call.\n    /// @param data Data payload for optional delegate call.\n    /// @param fallbackHandler Handler for fallback calls to this contract\n    /// @param paymentToken Token that should be used for the payment (0 is ETH)\n    /// @param payment Value that should be paid\n    /// @param paymentReceiver Adddress that should receive the payment (or 0 if tx.origin)\n    function setup(\n        address[] calldata _owners,\n        uint256 _threshold,\n        address to,\n        bytes calldata data,\n        address fallbackHandler,\n        address paymentToken,\n        uint256 payment,\n        address payable paymentReceiver\n    )\n        external\n    {\n        require(domainSeparator == 0, \"Domain Separator already set!\");\n        domainSeparator = keccak256(abi.encode(DOMAIN_SEPARATOR_TYPEHASH, this));\n        setupOwners(_owners, _threshold);\n        if (fallbackHandler != address(0)) internalSetFallbackHandler(fallbackHandler);\n        // As setupOwners can only be called if the contract has not been initialized we don't need a check for setupModules\n        setupModules(to, data);\n\n        if (payment > 0) {\n            // To avoid running into issues with EIP-170 we reuse the handlePayment function (to avoid adjusting code of that has been verified we do not adjust the method itself)\n            // baseGas = 0, gasPrice = 1 and gas = payment => amount = (payment + 0) * 1 = payment\n            handlePayment(payment, 0, 1, paymentToken, paymentReceiver);\n        }\n    }\n\n    /// @dev Allows to execute a Safe transaction confirmed by required number of owners and then pays the account that submitted the transaction.\n    ///      Note: The fees are always transfered, even if the user transaction fails.\n    /// @param to Destination address of Safe transaction.\n    /// @param value Ether value of Safe transaction.\n    /// @param data Data payload of Safe transaction.\n    /// @param operation Operation type of Safe transaction.\n    /// @param safeTxGas Gas that should be used for the Safe transaction.\n    /// @param baseGas Gas costs for that are indipendent of the transaction execution(e.g. base transaction fee, signature check, payment of the refund)\n    /// @param gasPrice Gas price that should be used for the payment calculation.\n    /// @param gasToken Token address (or 0 if ETH) that is used for the payment.\n    /// @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n    /// @param signatures Packed signature data ({bytes32 r}{bytes32 s}{uint8 v})\n    function execTransaction(\n        address to,\n        uint256 value,\n        bytes calldata data,\n        Enum.Operation operation,\n        uint256 safeTxGas,\n        uint256 baseGas,\n        uint256 gasPrice,\n        address gasToken,\n        address payable refundReceiver,\n        bytes calldata signatures\n    )\n        external\n        returns (bool success)\n    {\n        bytes32 txHash;\n        // Use scope here to limit variable lifetime and prevent `stack too deep` errors\n        {\n            bytes memory txHashData = encodeTransactionData(\n                to, value, data, operation, // Transaction info\n                safeTxGas, baseGas, gasPrice, gasToken, refundReceiver, // Payment info\n                nonce\n            );\n            // Increase nonce and execute transaction.\n            nonce++;\n            txHash = keccak256(txHashData);\n            checkSignatures(txHash, txHashData, signatures, true);\n        }\n        require(gasleft() >= safeTxGas, \"Not enough gas to execute safe transaction\");\n        // Use scope here to limit variable lifetime and prevent `stack too deep` errors\n        {\n            uint256 gasUsed = gasleft();\n            // If no safeTxGas has been set and the gasPrice is 0 we assume that all available gas can be used\n            success = execute(to, value, data, operation, safeTxGas == 0 && gasPrice == 0 ? gasleft() : safeTxGas);\n            gasUsed = gasUsed.sub(gasleft());\n            // We transfer the calculated tx costs to the tx.origin to avoid sending it to intermediate contracts that have made calls\n            uint256 payment = 0;\n            if (gasPrice > 0) {\n                payment = handlePayment(gasUsed, baseGas, gasPrice, gasToken, refundReceiver);\n            }\n            if (success) emit ExecutionSuccess(txHash, payment);\n            else emit ExecutionFailure(txHash, payment);\n        }\n    }\n\n    function handlePayment(\n        uint256 gasUsed,\n        uint256 baseGas,\n        uint256 gasPrice,\n        address gasToken,\n        address payable refundReceiver\n    )\n        private\n        returns (uint256 payment)\n    {\n        // solium-disable-next-line security/no-tx-origin\n        address payable receiver = refundReceiver == address(0) ? tx.origin : refundReceiver;\n        if (gasToken == address(0)) {\n            // For ETH we will only adjust the gas price to not be higher than the actual used gas price\n            payment = gasUsed.add(baseGas).mul(gasPrice < tx.gasprice ? gasPrice : tx.gasprice);\n            // solium-disable-next-line security/no-send\n            require(receiver.send(payment), \"Could not pay gas costs with ether\");\n        } else {\n            payment = gasUsed.add(baseGas).mul(gasPrice);\n            require(transferToken(gasToken, receiver, payment), \"Could not pay gas costs with token\");\n        }\n    }\n\n    /**\n    * @dev Checks whether the signature provided is valid for the provided data, hash. Will revert otherwise.\n    * @param dataHash Hash of the data (could be either a message hash or transaction hash)\n    * @param data That should be signed (this is passed to an external validator contract)\n    * @param signatures Signature data that should be verified. Can be ECDSA signature, contract signature (EIP-1271) or approved hash.\n    * @param consumeHash Indicates that in case of an approved hash the storage can be freed to save gas\n    */\n    function checkSignatures(bytes32 dataHash, bytes memory data, bytes memory signatures, bool consumeHash)\n        internal\n    {\n        // Load threshold to avoid multiple storage loads\n        uint256 _threshold = threshold;\n        // Check that a threshold is set\n        require(_threshold > 0, \"Threshold needs to be defined!\");\n        // Check that the provided signature data is not too short\n        require(signatures.length >= _threshold.mul(65), \"Signatures data too short\");\n        // There cannot be an owner with address 0.\n        address lastOwner = address(0);\n        address currentOwner;\n        uint8 v;\n        bytes32 r;\n        bytes32 s;\n        uint256 i;\n        for (i = 0; i < _threshold; i++) {\n            (v, r, s) = signatureSplit(signatures, i);\n            // If v is 0 then it is a contract signature\n            if (v == 0) {\n                // When handling contract signatures the address of the contract is encoded into r\n                currentOwner = address(uint256(r));\n\n                // Check that signature data pointer (s) is not pointing inside the static part of the signatures bytes\n                // This check is not completely accurate, since it is possible that more signatures than the threshold are send.\n                // Here we only check that the pointer is not pointing inside the part that is being processed\n                require(uint256(s) >= _threshold.mul(65), \"Invalid contract signature location: inside static part\");\n\n                // Check that signature data pointer (s) is in bounds (points to the length of data -> 32 bytes)\n                require(uint256(s).add(32) <= signatures.length, \"Invalid contract signature location: length not present\");\n\n                // Check if the contract signature is in bounds: start of data is s + 32 and end is start + signature length\n                uint256 contractSignatureLen;\n                // solium-disable-next-line security/no-inline-assembly\n                assembly {\n                    contractSignatureLen := mload(add(add(signatures, s), 0x20))\n                }\n                require(uint256(s).add(32).add(contractSignatureLen) <= signatures.length, \"Invalid contract signature location: data not complete\");\n\n                // Check signature\n                bytes memory contractSignature;\n                // solium-disable-next-line security/no-inline-assembly\n                assembly {\n                    // The signature data for contract signatures is appended to the concatenated signatures and the offset is stored in s\n                    contractSignature := add(add(signatures, s), 0x20)\n                }\n                require(ISignatureValidator(currentOwner).isValidSignature(data, contractSignature) == EIP1271_MAGIC_VALUE, \"Invalid contract signature provided\");\n            // If v is 1 then it is an approved hash\n            } else if (v == 1) {\n                // When handling approved hashes the address of the approver is encoded into r\n                currentOwner = address(uint256(r));\n                // Hashes are automatically approved by the sender of the message or when they have been pre-approved via a separate transaction\n                require(msg.sender == currentOwner || approvedHashes[currentOwner][dataHash] != 0, \"Hash has not been approved\");\n                // Hash has been marked for consumption. If this hash was pre-approved free storage\n                if (consumeHash && msg.sender != currentOwner) {\n                    approvedHashes[currentOwner][dataHash] = 0;\n                }\n            } else if (v > 30) {\n                // To support eth_sign and similar we adjust v and hash the messageHash with the Ethereum message prefix before applying ecrecover\n                currentOwner = ecrecover(keccak256(abi.encodePacked(\"\\x19Ethereum Signed Message:\\n32\", dataHash)), v - 4, r, s);\n            } else {\n                // Use ecrecover with the messageHash for EOA signatures\n                currentOwner = ecrecover(dataHash, v, r, s);\n            }\n            require (\n                currentOwner > lastOwner && owners[currentOwner] != address(0) && currentOwner != SENTINEL_OWNERS,\n                \"Invalid owner provided\"\n            );\n            lastOwner = currentOwner;\n        }\n    }\n\n    /// @dev Allows to estimate a Safe transaction.\n    ///      This method is only meant for estimation purpose, therefore two different protection mechanism against execution in a transaction have been made:\n    ///      1.) The method can only be called from the safe itself\n    ///      2.) The response is returned with a revert\n    ///      When estimating set `from` to the address of the safe.\n    ///      Since the `estimateGas` function includes refunds, call this method to get an estimated of the costs that are deducted from the safe with `execTransaction`\n    /// @param to Destination address of Safe transaction.\n    /// @param value Ether value of Safe transaction.\n    /// @param data Data payload of Safe transaction.\n    /// @param operation Operation type of Safe transaction.\n    /// @return Estimate without refunds and overhead fees (base transaction and payload data gas costs).\n    function requiredTxGas(address to, uint256 value, bytes calldata data, Enum.Operation operation)\n        external\n        authorized\n        returns (uint256)\n    {\n        uint256 startGas = gasleft();\n        // We don't provide an error message here, as we use it to return the estimate\n        // solium-disable-next-line error-reason\n        require(execute(to, value, data, operation, gasleft()));\n        uint256 requiredGas = startGas - gasleft();\n        // Convert response to string and return via error message\n        revert(string(abi.encodePacked(requiredGas)));\n    }\n\n    /**\n    * @dev Marks a hash as approved. This can be used to validate a hash that is used by a signature.\n    * @param hashToApprove The hash that should be marked as approved for signatures that are verified by this contract.\n    */\n    function approveHash(bytes32 hashToApprove)\n        external\n    {\n        require(owners[msg.sender] != address(0), \"Only owners can approve a hash\");\n        approvedHashes[msg.sender][hashToApprove] = 1;\n        emit ApproveHash(hashToApprove, msg.sender);\n    }\n\n    /**\n    * @dev Marks a message as signed\n    * @param _data Arbitrary length data that should be marked as signed on the behalf of address(this)\n    */\n    function signMessage(bytes calldata _data)\n        external\n        authorized\n    {\n        bytes32 msgHash = getMessageHash(_data);\n        signedMessages[msgHash] = 1;\n        emit SignMsg(msgHash);\n    }\n\n    /**\n    * Implementation of ISignatureValidator (see `interfaces/ISignatureValidator.sol`)\n    * @dev Should return whether the signature provided is valid for the provided data.\n    *       The save does not implement the interface since `checkSignatures` is not a view method.\n    *       The method will not perform any state changes (see parameters of `checkSignatures`)\n    * @param _data Arbitrary length data signed on the behalf of address(this)\n    * @param _signature Signature byte array associated with _data\n    * @return a bool upon valid or invalid signature with corresponding _data\n    */\n    function isValidSignature(bytes calldata _data, bytes calldata _signature)\n        external\n        returns (bytes4)\n    {\n        bytes32 messageHash = getMessageHash(_data);\n        if (_signature.length == 0) {\n            require(signedMessages[messageHash] != 0, \"Hash not approved\");\n        } else {\n            // consumeHash needs to be false, as the state should not be changed\n            checkSignatures(messageHash, _data, _signature, false);\n        }\n        return EIP1271_MAGIC_VALUE;\n    }\n\n    /// @dev Returns hash of a message that can be signed by owners.\n    /// @param message Message that should be hashed\n    /// @return Message hash.\n    function getMessageHash(\n        bytes memory message\n    )\n        public\n        view\n        returns (bytes32)\n    {\n        bytes32 safeMessageHash = keccak256(\n            abi.encode(SAFE_MSG_TYPEHASH, keccak256(message))\n        );\n        return keccak256(\n            abi.encodePacked(byte(0x19), byte(0x01), domainSeparator, safeMessageHash)\n        );\n    }\n\n    /// @dev Returns the bytes that are hashed to be signed by owners.\n    /// @param to Destination address.\n    /// @param value Ether value.\n    /// @param data Data payload.\n    /// @param operation Operation type.\n    /// @param safeTxGas Fas that should be used for the safe transaction.\n    /// @param baseGas Gas costs for data used to trigger the safe transaction.\n    /// @param gasPrice Maximum gas price that should be used for this transaction.\n    /// @param gasToken Token address (or 0 if ETH) that is used for the payment.\n    /// @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n    /// @param _nonce Transaction nonce.\n    /// @return Transaction hash bytes.\n    function encodeTransactionData(\n        address to,\n        uint256 value,\n        bytes memory data,\n        Enum.Operation operation,\n        uint256 safeTxGas,\n        uint256 baseGas,\n        uint256 gasPrice,\n        address gasToken,\n        address refundReceiver,\n        uint256 _nonce\n    )\n        public\n        view\n        returns (bytes memory)\n    {\n        bytes32 safeTxHash = keccak256(\n            abi.encode(SAFE_TX_TYPEHASH, to, value, keccak256(data), operation, safeTxGas, baseGas, gasPrice, gasToken, refundReceiver, _nonce)\n        );\n        return abi.encodePacked(byte(0x19), byte(0x01), domainSeparator, safeTxHash);\n    }\n\n    /// @dev Returns hash to be signed by owners.\n    /// @param to Destination address.\n    /// @param value Ether value.\n    /// @param data Data payload.\n    /// @param operation Operation type.\n    /// @param safeTxGas Fas that should be used for the safe transaction.\n    /// @param baseGas Gas costs for data used to trigger the safe transaction.\n    /// @param gasPrice Maximum gas price that should be used for this transaction.\n    /// @param gasToken Token address (or 0 if ETH) that is used for the payment.\n    /// @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n    /// @param _nonce Transaction nonce.\n    /// @return Transaction hash.\n    function getTransactionHash(\n        address to,\n        uint256 value,\n        bytes memory data,\n        Enum.Operation operation,\n        uint256 safeTxGas,\n        uint256 baseGas,\n        uint256 gasPrice,\n        address gasToken,\n        address refundReceiver,\n        uint256 _nonce\n    )\n        public\n        view\n        returns (bytes32)\n    {\n        return keccak256(encodeTransactionData(to, value, data, operation, safeTxGas, baseGas, gasPrice, gasToken, refundReceiver, _nonce));\n    }\n}\n";
  var sourcePath$2 = "/media/000/Documents/Circles/safe-contracts/contracts/GnosisSafe.sol";
  var ast$2 = {
  	absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/GnosisSafe.sol",
  	exportedSymbols: {
  		GnosisSafe: [
  			903
  		]
  	},
  	id: 904,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1,
  			literals: [
  				"solidity",
  				">=",
  				"0.5",
  				".0",
  				"<",
  				"0.7",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:31:0"
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/base/ModuleManager.sol",
  			file: "./base/ModuleManager.sol",
  			id: 2,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 1519,
  			src: "32:34:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/base/OwnerManager.sol",
  			file: "./base/OwnerManager.sol",
  			id: 3,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 1989,
  			src: "67:33:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/base/FallbackManager.sol",
  			file: "./base/FallbackManager.sol",
  			id: 4,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 1107,
  			src: "101:36:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/common/MasterCopy.sol",
  			file: "./common/MasterCopy.sol",
  			id: 5,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2039,
  			src: "138:33:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/common/SignatureDecoder.sol",
  			file: "./common/SignatureDecoder.sol",
  			id: 6,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2137,
  			src: "172:39:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/common/SecuredTokenTransfer.sol",
  			file: "./common/SecuredTokenTransfer.sol",
  			id: 7,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2064,
  			src: "212:43:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/interfaces/ISignatureValidator.sol",
  			file: "./interfaces/ISignatureValidator.sol",
  			id: 8,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2440,
  			src: "256:46:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/external/SafeMath.sol",
  			file: "./external/SafeMath.sol",
  			id: 9,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2265,
  			src: "303:33:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 10,
  						name: "MasterCopy",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2038,
  						src: "679:10:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_MasterCopy_$2038",
  							typeString: "contract MasterCopy"
  						}
  					},
  					id: 11,
  					nodeType: "InheritanceSpecifier",
  					src: "679:10:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 12,
  						name: "ModuleManager",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1518,
  						src: "691:13:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ModuleManager_$1518",
  							typeString: "contract ModuleManager"
  						}
  					},
  					id: 13,
  					nodeType: "InheritanceSpecifier",
  					src: "691:13:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 14,
  						name: "OwnerManager",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1988,
  						src: "706:12:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_OwnerManager_$1988",
  							typeString: "contract OwnerManager"
  						}
  					},
  					id: 15,
  					nodeType: "InheritanceSpecifier",
  					src: "706:12:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 16,
  						name: "SignatureDecoder",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2136,
  						src: "720:16:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SignatureDecoder_$2136",
  							typeString: "contract SignatureDecoder"
  						}
  					},
  					id: 17,
  					nodeType: "InheritanceSpecifier",
  					src: "720:16:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 18,
  						name: "SecuredTokenTransfer",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2063,
  						src: "738:20:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SecuredTokenTransfer_$2063",
  							typeString: "contract SecuredTokenTransfer"
  						}
  					},
  					id: 19,
  					nodeType: "InheritanceSpecifier",
  					src: "738:20:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 20,
  						name: "ISignatureValidatorConstants",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2427,
  						src: "760:28:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ISignatureValidatorConstants_$2427",
  							typeString: "contract ISignatureValidatorConstants"
  						}
  					},
  					id: 21,
  					nodeType: "InheritanceSpecifier",
  					src: "760:28:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 22,
  						name: "FallbackManager",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1106,
  						src: "790:15:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_FallbackManager_$1106",
  							typeString: "contract FallbackManager"
  						}
  					},
  					id: 23,
  					nodeType: "InheritanceSpecifier",
  					src: "790:15:0"
  				}
  			],
  			contractDependencies: [
  				1041,
  				1106,
  				1518,
  				1988,
  				2038,
  				2063,
  				2080,
  				2136,
  				2427
  			],
  			contractKind: "contract",
  			documentation: "@title Gnosis Safe - A multisignature wallet with support for confirmations using signed messages based on ERC191.\n @author Stefan George - <stefan@gnosis.io>\n @author Richard Meissner - <richard@gnosis.io>\n @author Ricardo Guilherme Schmidt - (Status Research & Development GmbH) - Gas Token Payment",
  			fullyImplemented: true,
  			id: 903,
  			linearizedBaseContracts: [
  				903,
  				1106,
  				2427,
  				2063,
  				2136,
  				1988,
  				1518,
  				1041,
  				2038,
  				2080
  			],
  			name: "GnosisSafe",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 26,
  					libraryName: {
  						contractScope: null,
  						id: 24,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2264,
  						src: "819:8:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$2264",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "813:27:0",
  					typeName: {
  						id: 25,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "832:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: true,
  					id: 29,
  					name: "NAME",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "846:43:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_memory",
  						typeString: "string"
  					},
  					typeName: {
  						id: 27,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "846:6:0",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "476e6f7369732053616665",
  						id: 28,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "string",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "876:13:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_stringliteral_72ec6775392f699e8ffd72b7c600556d49bdc746bf22bce93d3ae6019cdaff63",
  							typeString: "literal_string \"Gnosis Safe\""
  						},
  						value: "Gnosis Safe"
  					},
  					visibility: "public"
  				},
  				{
  					constant: true,
  					id: 32,
  					name: "VERSION",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "895:40:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_memory",
  						typeString: "string"
  					},
  					typeName: {
  						id: 30,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "895:6:0",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "312e312e31",
  						id: 31,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "string",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "928:7:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_stringliteral_9dd6d964e72a376a8989d1d2720ab48ff4f2ad77466fb517dabc84f4a79478d4",
  							typeString: "literal_string \"1.1.1\""
  						},
  						value: "1.1.1"
  					},
  					visibility: "public"
  				},
  				{
  					constant: true,
  					id: 35,
  					name: "DOMAIN_SEPARATOR_TYPEHASH",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1020:119:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 33,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1020:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "307830333561666638336438363933376433356233326530346630646463366666343639323930656566326631623639326438613831356338393430346434373439",
  						id: 34,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "1073:66:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_1517718281442037948617199096126532355110765202990829672390711201829802035017_by_1",
  							typeString: "int_const 1517...(68 digits omitted)...5017"
  						},
  						value: "0x035aff83d86937d35b32e04f0ddc6ff469290eef2f1b692d8a815c89404d4749"
  					},
  					visibility: "private"
  				},
  				{
  					constant: true,
  					id: 38,
  					name: "SAFE_TX_TYPEHASH",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1349:110:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 36,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1349:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "307862623833313064343836333638646236626436663834393430326664643733616435336433313662356134623236343461643665666530663934313238366438",
  						id: 37,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "1393:66:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_84814075808141314178395468817534025465894426928601295766380145544921651250904_by_1",
  							typeString: "int_const 8481...(69 digits omitted)...0904"
  						},
  						value: "0xbb8310d486368db6bd6f849402fdd73ad53d316b5a4b2644ad6efe0f941286d8"
  					},
  					visibility: "private"
  				},
  				{
  					constant: true,
  					id: 41,
  					name: "SAFE_MSG_TYPEHASH",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1531:111:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 39,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1531:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "307836306233636266386234613232336436386436343162336236646466396132393865376633333731306366336433613964313134366235613631353066626361",
  						id: 40,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "1576:66:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_43739706848186989041152069077571617734008543096732098246335109361212071148490_by_1",
  							typeString: "int_const 4373...(69 digits omitted)...8490"
  						},
  						value: "0x60b3cbf8b4a223d68d641b3b6ddf9a298e7f33710cf3d3a9d1146b5a6150fbca"
  					},
  					visibility: "private"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 47,
  					name: "ApproveHash",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 46,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 43,
  								indexed: true,
  								name: "approvedHash",
  								nodeType: "VariableDeclaration",
  								scope: 47,
  								src: "1676:28:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 42,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1676:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 45,
  								indexed: true,
  								name: "owner",
  								nodeType: "VariableDeclaration",
  								scope: 47,
  								src: "1714:21:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 44,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1714:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1666:75:0"
  					},
  					src: "1649:93:0"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 51,
  					name: "SignMsg",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 50,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 49,
  								indexed: true,
  								name: "msgHash",
  								nodeType: "VariableDeclaration",
  								scope: 51,
  								src: "1770:23:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 48,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1770:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1760:39:0"
  					},
  					src: "1747:53:0"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 57,
  					name: "ExecutionFailure",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 56,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 53,
  								indexed: false,
  								name: "txHash",
  								nodeType: "VariableDeclaration",
  								scope: 57,
  								src: "1837:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 52,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1837:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 55,
  								indexed: false,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 57,
  								src: "1853:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 54,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1853:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1827:47:0"
  					},
  					src: "1805:70:0"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 63,
  					name: "ExecutionSuccess",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 62,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 59,
  								indexed: false,
  								name: "txHash",
  								nodeType: "VariableDeclaration",
  								scope: 63,
  								src: "1912:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 58,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1912:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 61,
  								indexed: false,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 63,
  								src: "1928:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 60,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1928:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1902:47:0"
  					},
  					src: "1880:70:0"
  				},
  				{
  					constant: false,
  					id: 65,
  					name: "nonce",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1956:20:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 64,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "1956:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 67,
  					name: "domainSeparator",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1982:30:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 66,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1982:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 71,
  					name: "signedMessages",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "2115:49:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  						typeString: "mapping(bytes32 => uint256)"
  					},
  					typeName: {
  						id: 70,
  						keyType: {
  							id: 68,
  							name: "bytes32",
  							nodeType: "ElementaryTypeName",
  							src: "2123:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_bytes32",
  								typeString: "bytes32"
  							}
  						},
  						nodeType: "Mapping",
  						src: "2115:27:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  							typeString: "mapping(bytes32 => uint256)"
  						},
  						valueType: {
  							id: 69,
  							name: "uint256",
  							nodeType: "ElementaryTypeName",
  							src: "2134:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 77,
  					name: "approvedHashes",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "2275:69:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  						typeString: "mapping(address => mapping(bytes32 => uint256))"
  					},
  					typeName: {
  						id: 76,
  						keyType: {
  							id: 72,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "2283:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "2275:47:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  							typeString: "mapping(address => mapping(bytes32 => uint256))"
  						},
  						valueType: {
  							id: 75,
  							keyType: {
  								id: 73,
  								name: "bytes32",
  								nodeType: "ElementaryTypeName",
  								src: "2302:7:0",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								}
  							},
  							nodeType: "Mapping",
  							src: "2294:27:0",
  							typeDescriptions: {
  								typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  								typeString: "mapping(bytes32 => uint256)"
  							},
  							valueType: {
  								id: 74,
  								name: "uint256",
  								nodeType: "ElementaryTypeName",
  								src: "2313:7:0",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 84,
  						nodeType: "Block",
  						src: "2477:234:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 82,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 80,
  										name: "threshold",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1548,
  										src: "2691:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "31",
  										id: 81,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2703:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "2691:13:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 83,
  								nodeType: "ExpressionStatement",
  								src: "2691:13:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 85,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 78,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2467:2:0"
  					},
  					returnParameters: {
  						id: 79,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2477:0:0"
  					},
  					scope: 903,
  					src: "2456:255:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 155,
  						nodeType: "Block",
  						src: "3611:838:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											},
  											id: 108,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 106,
  												name: "domainSeparator",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 67,
  												src: "3629:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes32",
  													typeString: "bytes32"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 107,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3648:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3629:20:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "446f6d61696e20536570617261746f7220616c72656164792073657421",
  											id: 109,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "3651:31:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_a2e1f2db9cd32eaa6a2caa3d6caa726a30dc0417d866440bfe13d6a6d030e5e2",
  												typeString: "literal_string \"Domain Separator already set!\""
  											},
  											value: "Domain Separator already set!"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_a2e1f2db9cd32eaa6a2caa3d6caa726a30dc0417d866440bfe13d6a6d030e5e2",
  												typeString: "literal_string \"Domain Separator already set!\""
  											}
  										],
  										id: 105,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "3621:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 110,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3621:62:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 111,
  								nodeType: "ExpressionStatement",
  								src: "3621:62:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 120,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 112,
  										name: "domainSeparator",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 67,
  										src: "3693:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 116,
  														name: "DOMAIN_SEPARATOR_TYPEHASH",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 35,
  														src: "3732:25:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 117,
  														name: "this",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5208,
  														src: "3759:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_GnosisSafe_$903",
  															typeString: "contract GnosisSafe"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_contract$_GnosisSafe_$903",
  															typeString: "contract GnosisSafe"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 114,
  														name: "abi",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5155,
  														src: "3721:3:0",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_abi",
  															typeString: "abi"
  														}
  													},
  													id: 115,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													memberName: "encode",
  													nodeType: "MemberAccess",
  													referencedDeclaration: null,
  													src: "3721:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
  														typeString: "function () pure returns (bytes memory)"
  													}
  												},
  												id: 118,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "3721:43:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes_memory_ptr",
  													typeString: "bytes memory"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_bytes_memory_ptr",
  													typeString: "bytes memory"
  												}
  											],
  											id: 113,
  											name: "keccak256",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5162,
  											src: "3711:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  												typeString: "function (bytes memory) pure returns (bytes32)"
  											}
  										},
  										id: 119,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3711:54:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										}
  									},
  									src: "3693:72:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								id: 121,
  								nodeType: "ExpressionStatement",
  								src: "3693:72:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 123,
  											name: "_owners",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 88,
  											src: "3787:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_calldata_ptr",
  												typeString: "address[] calldata"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 124,
  											name: "_threshold",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 90,
  											src: "3796:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_array$_t_address_$dyn_calldata_ptr",
  												typeString: "address[] calldata"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 122,
  										name: "setupOwners",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1655,
  										src: "3775:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_array$_t_address_$dyn_memory_ptr_$_t_uint256_$returns$__$",
  											typeString: "function (address[] memory,uint256)"
  										}
  									},
  									id: 125,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3775:32:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 126,
  								nodeType: "ExpressionStatement",
  								src: "3775:32:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									},
  									id: 131,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 127,
  										name: "fallbackHandler",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 96,
  										src: "3821:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "!=",
  									rightExpression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												hexValue: "30",
  												id: 129,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3848:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												}
  											],
  											id: 128,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "3840:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: "address"
  										},
  										id: 130,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3840:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "3821:29:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 136,
  								nodeType: "IfStatement",
  								src: "3817:78:0",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 133,
  												name: "fallbackHandler",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 96,
  												src: "3879:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 132,
  											name: "internalSetFallbackHandler",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1060,
  											src: "3852:26:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$returns$__$",
  												typeString: "function (address)"
  											}
  										},
  										id: 134,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3852:43:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 135,
  									nodeType: "ExpressionStatement",
  									src: "3852:43:0"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 138,
  											name: "to",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 92,
  											src: "4043:2:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 139,
  											name: "data",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 94,
  											src: "4047:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										],
  										id: 137,
  										name: "setupModules",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1227,
  										src: "4030:12:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_bytes_memory_ptr_$returns$__$",
  											typeString: "function (address,bytes memory)"
  										}
  									},
  									id: 140,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4030:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 141,
  								nodeType: "ExpressionStatement",
  								src: "4030:22:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 144,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 142,
  										name: "payment",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 100,
  										src: "4067:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 143,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "4077:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "4067:11:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 154,
  								nodeType: "IfStatement",
  								src: "4063:380:0",
  								trueBody: {
  									id: 153,
  									nodeType: "Block",
  									src: "4080:363:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 146,
  														name: "payment",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 100,
  														src: "4387:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "30",
  														id: 147,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "4396:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													},
  													{
  														argumentTypes: null,
  														hexValue: "31",
  														id: 148,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "4399:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_1_by_1",
  															typeString: "int_const 1"
  														},
  														value: "1"
  													},
  													{
  														argumentTypes: null,
  														id: 149,
  														name: "paymentToken",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 98,
  														src: "4402:12:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 150,
  														name: "paymentReceiver",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 102,
  														src: "4416:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														{
  															typeIdentifier: "t_rational_1_by_1",
  															typeString: "int_const 1"
  														},
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													],
  													id: 145,
  													name: "handlePayment",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 370,
  													src: "4373:13:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_payable_$returns$_t_uint256_$",
  														typeString: "function (uint256,uint256,uint256,address,address payable) returns (uint256)"
  													}
  												},
  												id: 151,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "4373:59:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 152,
  											nodeType: "ExpressionStatement",
  											src: "4373:59:0"
  										}
  									]
  								}
  							}
  						]
  					},
  					documentation: "@dev Setup function sets initial storage of contract.\n @param _owners List of Safe owners.\n @param _threshold Number of required confirmations for a Safe transaction.\n @param to Contract address for optional delegate call.\n @param data Data payload for optional delegate call.\n @param fallbackHandler Handler for fallback calls to this contract\n @param paymentToken Token that should be used for the payment (0 is ETH)\n @param payment Value that should be paid\n @param paymentReceiver Adddress that should receive the payment (or 0 if tx.origin)",
  					id: 156,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "setup",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 103,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 88,
  								name: "_owners",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3351:26:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_array$_t_address_$dyn_calldata_ptr",
  									typeString: "address[]"
  								},
  								typeName: {
  									baseType: {
  										id: 86,
  										name: "address",
  										nodeType: "ElementaryTypeName",
  										src: "3351:7:0",
  										stateMutability: "nonpayable",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									id: 87,
  									length: null,
  									nodeType: "ArrayTypeName",
  									src: "3351:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  										typeString: "address[]"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 90,
  								name: "_threshold",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3387:18:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 89,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3387:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 92,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3415:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 91,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3415:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 94,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3435:19:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 93,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "3435:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 96,
  								name: "fallbackHandler",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3464:23:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 95,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3464:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 98,
  								name: "paymentToken",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3497:20:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 97,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3497:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 100,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3527:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 99,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3527:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 102,
  								name: "paymentReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3552:31:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address_payable",
  									typeString: "address payable"
  								},
  								typeName: {
  									id: 101,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3552:15:0",
  									stateMutability: "payable",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3341:248:0"
  					},
  					returnParameters: {
  						id: 104,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3611:0:0"
  					},
  					scope: 903,
  					src: "3327:1122:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 289,
  						nodeType: "Block",
  						src: "5847:1518:0",
  						statements: [
  							{
  								assignments: [
  									182
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 182,
  										name: "txHash",
  										nodeType: "VariableDeclaration",
  										scope: 289,
  										src: "5857:14:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 181,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "5857:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 183,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "5857:14:0"
  							},
  							{
  								id: 215,
  								nodeType: "Block",
  								src: "5970:448:0",
  								statements: [
  									{
  										assignments: [
  											185
  										],
  										declarations: [
  											{
  												constant: false,
  												id: 185,
  												name: "txHashData",
  												nodeType: "VariableDeclaration",
  												scope: 215,
  												src: "5984:23:0",
  												stateVariable: false,
  												storageLocation: "memory",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes_memory_ptr",
  													typeString: "bytes"
  												},
  												typeName: {
  													id: 184,
  													name: "bytes",
  													nodeType: "ElementaryTypeName",
  													src: "5984:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_storage_ptr",
  														typeString: "bytes"
  													}
  												},
  												value: null,
  												visibility: "internal"
  											}
  										],
  										id: 198,
  										initialValue: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 187,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 158,
  													src: "6049:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 188,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 160,
  													src: "6053:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 189,
  													name: "data",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 162,
  													src: "6060:4:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 190,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 164,
  													src: "6066:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 191,
  													name: "safeTxGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 166,
  													src: "6113:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 192,
  													name: "baseGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 168,
  													src: "6124:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 193,
  													name: "gasPrice",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 170,
  													src: "6133:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 194,
  													name: "gasToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 172,
  													src: "6143:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 195,
  													name: "refundReceiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 174,
  													src: "6153:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 196,
  													name: "nonce",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 65,
  													src: "6201:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												id: 186,
  												name: "encodeTransactionData",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 861,
  												src: "6010:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_$_t_uint256_$returns$_t_bytes_memory_ptr_$",
  													typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256,uint256,uint256,address,address,uint256) view returns (bytes memory)"
  												}
  											},
  											id: 197,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6010:210:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										},
  										nodeType: "VariableDeclarationStatement",
  										src: "5984:236:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 200,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "UnaryOperation",
  											operator: "++",
  											prefix: false,
  											src: "6289:7:0",
  											subExpression: {
  												argumentTypes: null,
  												id: 199,
  												name: "nonce",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 65,
  												src: "6289:5:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 201,
  										nodeType: "ExpressionStatement",
  										src: "6289:7:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 206,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftHandSide: {
  												argumentTypes: null,
  												id: 202,
  												name: "txHash",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "6310:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes32",
  													typeString: "bytes32"
  												}
  											},
  											nodeType: "Assignment",
  											operator: "=",
  											rightHandSide: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 204,
  														name: "txHashData",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 185,
  														src: "6329:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_memory_ptr",
  															typeString: "bytes memory"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes_memory_ptr",
  															typeString: "bytes memory"
  														}
  													],
  													id: 203,
  													name: "keccak256",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5162,
  													src: "6319:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  														typeString: "function (bytes memory) pure returns (bytes32)"
  													}
  												},
  												id: 205,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6319:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes32",
  													typeString: "bytes32"
  												}
  											},
  											src: "6310:30:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										id: 207,
  										nodeType: "ExpressionStatement",
  										src: "6310:30:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 209,
  													name: "txHash",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 182,
  													src: "6370:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 210,
  													name: "txHashData",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 185,
  													src: "6378:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 211,
  													name: "signatures",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 176,
  													src: "6390:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													}
  												},
  												{
  													argumentTypes: null,
  													hexValue: "74727565",
  													id: 212,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "bool",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "6402:4:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													},
  													value: "true"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													},
  													{
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													},
  													{
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													}
  												],
  												id: 208,
  												name: "checkSignatures",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 622,
  												src: "6354:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_nonpayable$_t_bytes32_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$_t_bool_$returns$__$",
  													typeString: "function (bytes32,bytes memory,bytes memory,bool)"
  												}
  											},
  											id: 213,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6354:53:0",
  											typeDescriptions: {
  												typeIdentifier: "t_tuple$__$",
  												typeString: "tuple()"
  											}
  										},
  										id: 214,
  										nodeType: "ExpressionStatement",
  										src: "6354:53:0"
  									}
  								]
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 220,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  												],
  												expression: {
  													argumentTypes: [
  													],
  													id: 217,
  													name: "gasleft",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5161,
  													src: "6435:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  														typeString: "function () view returns (uint256)"
  													}
  												},
  												id: 218,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6435:9:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 219,
  												name: "safeTxGas",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 166,
  												src: "6448:9:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6435:22:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f7420656e6f7567682067617320746f20657865637574652073616665207472616e73616374696f6e",
  											id: 221,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6459:44:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_e7ccb05a0f2c66d12451cdfc6bbab488c38ab704d0f6af9ad18763542e9e5f18",
  												typeString: "literal_string \"Not enough gas to execute safe transaction\""
  											},
  											value: "Not enough gas to execute safe transaction"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_e7ccb05a0f2c66d12451cdfc6bbab488c38ab704d0f6af9ad18763542e9e5f18",
  												typeString: "literal_string \"Not enough gas to execute safe transaction\""
  											}
  										],
  										id: 216,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "6427:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 222,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6427:77:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 223,
  								nodeType: "ExpressionStatement",
  								src: "6427:77:0"
  							},
  							{
  								id: 288,
  								nodeType: "Block",
  								src: "6603:756:0",
  								statements: [
  									{
  										assignments: [
  											225
  										],
  										declarations: [
  											{
  												constant: false,
  												id: 225,
  												name: "gasUsed",
  												nodeType: "VariableDeclaration",
  												scope: 288,
  												src: "6617:15:0",
  												stateVariable: false,
  												storageLocation: "default",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												typeName: {
  													id: 224,
  													name: "uint256",
  													nodeType: "ElementaryTypeName",
  													src: "6617:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												value: null,
  												visibility: "internal"
  											}
  										],
  										id: 228,
  										initialValue: {
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 226,
  												name: "gasleft",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 5161,
  												src: "6635:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 227,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6635:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "VariableDeclarationStatement",
  										src: "6617:27:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 247,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftHandSide: {
  												argumentTypes: null,
  												id: 229,
  												name: "success",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 179,
  												src: "6769:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											nodeType: "Assignment",
  											operator: "=",
  											rightHandSide: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 231,
  														name: "to",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 158,
  														src: "6787:2:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 232,
  														name: "value",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 160,
  														src: "6791:5:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 233,
  														name: "data",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 162,
  														src: "6798:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 234,
  														name: "operation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 164,
  														src: "6804:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_enum$_Operation_$1993",
  															typeString: "enum Enum.Operation"
  														}
  													},
  													{
  														argumentTypes: null,
  														condition: {
  															argumentTypes: null,
  															commonType: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															id: 241,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																id: 237,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 235,
  																	name: "safeTxGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 166,
  																	src: "6815:9:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "==",
  																rightExpression: {
  																	argumentTypes: null,
  																	hexValue: "30",
  																	id: 236,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "number",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "6828:1:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_rational_0_by_1",
  																		typeString: "int_const 0"
  																	},
  																	value: "0"
  																},
  																src: "6815:14:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "&&",
  															rightExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																id: 240,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 238,
  																	name: "gasPrice",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 170,
  																	src: "6833:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "==",
  																rightExpression: {
  																	argumentTypes: null,
  																	hexValue: "30",
  																	id: 239,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "number",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "6845:1:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_rational_0_by_1",
  																		typeString: "int_const 0"
  																	},
  																	value: "0"
  																},
  																src: "6833:13:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															src: "6815:31:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														falseExpression: {
  															argumentTypes: null,
  															id: 244,
  															name: "safeTxGas",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 166,
  															src: "6861:9:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 245,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "Conditional",
  														src: "6815:55:0",
  														trueExpression: {
  															argumentTypes: null,
  															"arguments": [
  															],
  															expression: {
  																argumentTypes: [
  																],
  																id: 242,
  																name: "gasleft",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 5161,
  																src: "6849:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  																	typeString: "function () view returns (uint256)"
  																}
  															},
  															id: 243,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "6849:9:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														{
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														},
  														{
  															typeIdentifier: "t_enum$_Operation_$1993",
  															typeString: "enum Enum.Operation"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 230,
  													name: "execute",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1012,
  													src: "6779:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$returns$_t_bool_$",
  														typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256) returns (bool)"
  													}
  												},
  												id: 246,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6779:92:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											src: "6769:102:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										id: 248,
  										nodeType: "ExpressionStatement",
  										src: "6769:102:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 255,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftHandSide: {
  												argumentTypes: null,
  												id: 249,
  												name: "gasUsed",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 225,
  												src: "6885:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "Assignment",
  											operator: "=",
  											rightHandSide: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  														],
  														expression: {
  															argumentTypes: [
  															],
  															id: 252,
  															name: "gasleft",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 5161,
  															src: "6907:7:0",
  															typeDescriptions: {
  																typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  																typeString: "function () view returns (uint256)"
  															}
  														},
  														id: 253,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6907:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 250,
  														name: "gasUsed",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 225,
  														src: "6895:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 251,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sub",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2219,
  													src: "6895:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 254,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6895:22:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6885:32:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 256,
  										nodeType: "ExpressionStatement",
  										src: "6885:32:0"
  									},
  									{
  										assignments: [
  											258
  										],
  										declarations: [
  											{
  												constant: false,
  												id: 258,
  												name: "payment",
  												nodeType: "VariableDeclaration",
  												scope: 288,
  												src: "7066:15:0",
  												stateVariable: false,
  												storageLocation: "default",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												typeName: {
  													id: 257,
  													name: "uint256",
  													nodeType: "ElementaryTypeName",
  													src: "7066:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												value: null,
  												visibility: "internal"
  											}
  										],
  										id: 260,
  										initialValue: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 259,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "7084:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										nodeType: "VariableDeclarationStatement",
  										src: "7066:19:0"
  									},
  									{
  										condition: {
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 263,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 261,
  												name: "gasPrice",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 170,
  												src: "7103:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 262,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "7114:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "7103:12:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										falseBody: null,
  										id: 275,
  										nodeType: "IfStatement",
  										src: "7099:128:0",
  										trueBody: {
  											id: 274,
  											nodeType: "Block",
  											src: "7117:110:0",
  											statements: [
  												{
  													expression: {
  														argumentTypes: null,
  														id: 272,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftHandSide: {
  															argumentTypes: null,
  															id: 264,
  															name: "payment",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 258,
  															src: "7135:7:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														nodeType: "Assignment",
  														operator: "=",
  														rightHandSide: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 266,
  																	name: "gasUsed",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 225,
  																	src: "7159:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 267,
  																	name: "baseGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 168,
  																	src: "7168:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 268,
  																	name: "gasPrice",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 170,
  																	src: "7177:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 269,
  																	name: "gasToken",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 172,
  																	src: "7187:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 270,
  																	name: "refundReceiver",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 174,
  																	src: "7197:14:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	{
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	{
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																],
  																id: 265,
  																name: "handlePayment",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 370,
  																src: "7145:13:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_payable_$returns$_t_uint256_$",
  																	typeString: "function (uint256,uint256,uint256,address,address payable) returns (uint256)"
  																}
  															},
  															id: 271,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "7145:67:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														src: "7135:77:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 273,
  													nodeType: "ExpressionStatement",
  													src: "7135:77:0"
  												}
  											]
  										}
  									},
  									{
  										condition: {
  											argumentTypes: null,
  											id: 276,
  											name: "success",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 179,
  											src: "7244:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										falseBody: {
  											eventCall: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 283,
  														name: "txHash",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 182,
  														src: "7332:6:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 284,
  														name: "payment",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 258,
  														src: "7340:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 282,
  													name: "ExecutionFailure",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 57,
  													src: "7315:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$_t_uint256_$returns$__$",
  														typeString: "function (bytes32,uint256)"
  													}
  												},
  												id: 285,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7315:33:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 286,
  											nodeType: "EmitStatement",
  											src: "7310:38:0"
  										},
  										id: 287,
  										nodeType: "IfStatement",
  										src: "7240:108:0",
  										trueBody: {
  											eventCall: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 278,
  														name: "txHash",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 182,
  														src: "7275:6:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 279,
  														name: "payment",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 258,
  														src: "7283:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 277,
  													name: "ExecutionSuccess",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 63,
  													src: "7258:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$_t_uint256_$returns$__$",
  														typeString: "function (bytes32,uint256)"
  													}
  												},
  												id: 280,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7258:33:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 281,
  											nodeType: "EmitStatement",
  											src: "7253:38:0"
  										}
  									}
  								]
  							}
  						]
  					},
  					documentation: "@dev Allows to execute a Safe transaction confirmed by required number of owners and then pays the account that submitted the transaction.\n      Note: The fees are always transfered, even if the user transaction fails.\n @param to Destination address of Safe transaction.\n @param value Ether value of Safe transaction.\n @param data Data payload of Safe transaction.\n @param operation Operation type of Safe transaction.\n @param safeTxGas Gas that should be used for the Safe transaction.\n @param baseGas Gas costs for that are indipendent of the transaction execution(e.g. base transaction fee, signature check, payment of the refund)\n @param gasPrice Gas price that should be used for the payment calculation.\n @param gasToken Token address (or 0 if ETH) that is used for the payment.\n @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n @param signatures Packed signature data ({bytes32 r}{bytes32 s}{uint8 v})",
  					id: 290,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "execTransaction",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 177,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 158,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5513:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 157,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5513:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 160,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5533:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 159,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5533:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 162,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5556:19:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 161,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "5556:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 164,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5585:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 163,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "5585:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 166,
  								name: "safeTxGas",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5619:17:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 165,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5619:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 168,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5646:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 167,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5646:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 170,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5671:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 169,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5671:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 172,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5697:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 171,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5697:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 174,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5723:30:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address_payable",
  									typeString: "address payable"
  								},
  								typeName: {
  									id: 173,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5723:15:0",
  									stateMutability: "payable",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 176,
  								name: "signatures",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5763:25:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 175,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "5763:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "5503:291:0"
  					},
  					returnParameters: {
  						id: 180,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 179,
  								name: "success",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5829:12:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 178,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "5829:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "5828:14:0"
  					},
  					scope: 903,
  					src: "5479:1886:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 369,
  						nodeType: "Block",
  						src: "7596:727:0",
  						statements: [
  							{
  								assignments: [
  									306
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 306,
  										name: "receiver",
  										nodeType: "VariableDeclaration",
  										scope: 369,
  										src: "7664:24:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										},
  										typeName: {
  											id: 305,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "7664:15:0",
  											stateMutability: "payable",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 316,
  								initialValue: {
  									argumentTypes: null,
  									condition: {
  										argumentTypes: null,
  										commonType: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										},
  										id: 311,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											argumentTypes: null,
  											id: 307,
  											name: "refundReceiver",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 300,
  											src: "7691:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													hexValue: "30",
  													id: 309,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "7717:1:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													},
  													value: "0"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													}
  												],
  												id: 308,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "7709:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 310,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "7709:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										src: "7691:28:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									falseExpression: {
  										argumentTypes: null,
  										id: 314,
  										name: "refundReceiver",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 300,
  										src: "7734:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									id: 315,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "Conditional",
  									src: "7691:57:0",
  									trueExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 312,
  											name: "tx",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5180,
  											src: "7722:2:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_transaction",
  												typeString: "tx"
  											}
  										},
  										id: 313,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "origin",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "7722:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7664:84:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									},
  									id: 321,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 317,
  										name: "gasToken",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 298,
  										src: "7762:8:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												hexValue: "30",
  												id: 319,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "7782:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												}
  											],
  											id: 318,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "7774:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: "address"
  										},
  										id: 320,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7774:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "7762:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: {
  									id: 367,
  									nodeType: "Block",
  									src: "8145:172:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 356,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 348,
  													name: "payment",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 303,
  													src: "8159:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 354,
  															name: "gasPrice",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 296,
  															src: "8194:8:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 351,
  																	name: "baseGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 294,
  																	src: "8181:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	id: 349,
  																	name: "gasUsed",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 292,
  																	src: "8169:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 350,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "add",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2243,
  																src: "8169:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 352,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "8169:20:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 353,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2171,
  														src: "8169:24:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 355,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "8169:34:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "8159:44:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 357,
  											nodeType: "ExpressionStatement",
  											src: "8159:44:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 360,
  																name: "gasToken",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 298,
  																src: "8239:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															{
  																argumentTypes: null,
  																id: 361,
  																name: "receiver",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 306,
  																src: "8249:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															{
  																argumentTypes: null,
  																id: 362,
  																name: "payment",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 303,
  																src: "8259:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																{
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																},
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															id: 359,
  															name: "transferToken",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2062,
  															src: "8225:13:0",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  																typeString: "function (address,address,uint256) returns (bool)"
  															}
  														},
  														id: 363,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "8225:42:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "436f756c64206e6f74207061792067617320636f737473207769746820746f6b656e",
  														id: 364,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "8269:36:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_8560a13547eca5648355c8db1a9f8653b6f657d31d476c36bca25e47b45b08f4",
  															typeString: "literal_string \"Could not pay gas costs with token\""
  														},
  														value: "Could not pay gas costs with token"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_8560a13547eca5648355c8db1a9f8653b6f657d31d476c36bca25e47b45b08f4",
  															typeString: "literal_string \"Could not pay gas costs with token\""
  														}
  													],
  													id: 358,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "8217:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 365,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "8217:89:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 366,
  											nodeType: "ExpressionStatement",
  											src: "8217:89:0"
  										}
  									]
  								},
  								id: 368,
  								nodeType: "IfStatement",
  								src: "7758:559:0",
  								trueBody: {
  									id: 347,
  									nodeType: "Block",
  									src: "7786:353:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 337,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 322,
  													name: "payment",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 303,
  													src: "7905:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															condition: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																id: 331,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 328,
  																	name: "gasPrice",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 296,
  																	src: "7940:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "<",
  																rightExpression: {
  																	argumentTypes: null,
  																	expression: {
  																		argumentTypes: null,
  																		id: 329,
  																		name: "tx",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 5180,
  																		src: "7951:2:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_magic_transaction",
  																			typeString: "tx"
  																		}
  																	},
  																	id: 330,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "gasprice",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: null,
  																	src: "7951:11:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																src: "7940:22:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															falseExpression: {
  																argumentTypes: null,
  																expression: {
  																	argumentTypes: null,
  																	id: 333,
  																	name: "tx",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 5180,
  																	src: "7976:2:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_magic_transaction",
  																		typeString: "tx"
  																	}
  																},
  																id: 334,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "gasprice",
  																nodeType: "MemberAccess",
  																referencedDeclaration: null,
  																src: "7976:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 335,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "Conditional",
  															src: "7940:47:0",
  															trueExpression: {
  																argumentTypes: null,
  																id: 332,
  																name: "gasPrice",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 296,
  																src: "7965:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 325,
  																	name: "baseGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 294,
  																	src: "7927:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	id: 323,
  																	name: "gasUsed",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 292,
  																	src: "7915:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 324,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "add",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2243,
  																src: "7915:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 326,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "7915:20:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 327,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2171,
  														src: "7915:24:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 336,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "7915:73:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "7905:83:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 338,
  											nodeType: "ExpressionStatement",
  											src: "7905:83:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 342,
  																name: "payment",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 303,
  																src: "8081:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 340,
  																name: "receiver",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 306,
  																src: "8067:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															id: 341,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "send",
  															nodeType: "MemberAccess",
  															referencedDeclaration: null,
  															src: "8067:13:0",
  															typeDescriptions: {
  																typeIdentifier: "t_function_send_nonpayable$_t_uint256_$returns$_t_bool_$",
  																typeString: "function (uint256) returns (bool)"
  															}
  														},
  														id: 343,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "8067:22:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "436f756c64206e6f74207061792067617320636f7374732077697468206574686572",
  														id: 344,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "8091:36:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_e2a11e15f7be1214c1340779ad55027af8aa33aee6cb521776a28a0a44aea377",
  															typeString: "literal_string \"Could not pay gas costs with ether\""
  														},
  														value: "Could not pay gas costs with ether"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_e2a11e15f7be1214c1340779ad55027af8aa33aee6cb521776a28a0a44aea377",
  															typeString: "literal_string \"Could not pay gas costs with ether\""
  														}
  													],
  													id: 339,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "8059:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 345,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "8059:69:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 346,
  											nodeType: "ExpressionStatement",
  											src: "8059:69:0"
  										}
  									]
  								}
  							}
  						]
  					},
  					documentation: null,
  					id: 370,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "handlePayment",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 301,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 292,
  								name: "gasUsed",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7403:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 291,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7403:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 294,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7428:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 293,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7428:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 296,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7453:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 295,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7453:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 298,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7479:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 297,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7479:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 300,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7505:30:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address_payable",
  									typeString: "address payable"
  								},
  								typeName: {
  									id: 299,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7505:15:0",
  									stateMutability: "payable",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7393:148:0"
  					},
  					returnParameters: {
  						id: 304,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 303,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7575:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 302,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7575:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7574:17:0"
  					},
  					scope: 903,
  					src: "7371:952:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "private"
  				},
  				{
  					body: {
  						id: 621,
  						nodeType: "Block",
  						src: "9004:4183:0",
  						statements: [
  							{
  								assignments: [
  									382
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 382,
  										name: "_threshold",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9072:18:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 381,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "9072:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 384,
  								initialValue: {
  									argumentTypes: null,
  									id: 383,
  									name: "threshold",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 1548,
  									src: "9093:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9072:30:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 388,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 386,
  												name: "_threshold",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 382,
  												src: "9161:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 387,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9174:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "9161:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "5468726573686f6c64206e6565647320746f20626520646566696e656421",
  											id: 389,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9177:32:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_1e23ab3cb6407b7a5fa3f757d0ea5696352121927cbe8de469caec8b2f834565",
  												typeString: "literal_string \"Threshold needs to be defined!\""
  											},
  											value: "Threshold needs to be defined!"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_1e23ab3cb6407b7a5fa3f757d0ea5696352121927cbe8de469caec8b2f834565",
  												typeString: "literal_string \"Threshold needs to be defined!\""
  											}
  										],
  										id: 385,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "9153:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 390,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9153:57:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 391,
  								nodeType: "ExpressionStatement",
  								src: "9153:57:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 399,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 393,
  													name: "signatures",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 376,
  													src: "9295:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												},
  												id: 394,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9295:17:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "3635",
  														id: 397,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "9331:2:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_65_by_1",
  															typeString: "int_const 65"
  														},
  														value: "65"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_65_by_1",
  															typeString: "int_const 65"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 395,
  														name: "_threshold",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 382,
  														src: "9316:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 396,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "mul",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2171,
  													src: "9316:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 398,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "9316:18:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "9295:39:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "5369676e617475726573206461746120746f6f2073686f7274",
  											id: 400,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9336:27:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_17122174e7c2d723217ce151aacf64aec6d32748978cfd1a9479e00b57ac7dd5",
  												typeString: "literal_string \"Signatures data too short\""
  											},
  											value: "Signatures data too short"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_17122174e7c2d723217ce151aacf64aec6d32748978cfd1a9479e00b57ac7dd5",
  												typeString: "literal_string \"Signatures data too short\""
  											}
  										],
  										id: 392,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "9287:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 401,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9287:77:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 402,
  								nodeType: "ExpressionStatement",
  								src: "9287:77:0"
  							},
  							{
  								assignments: [
  									404
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 404,
  										name: "lastOwner",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9426:17:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 403,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "9426:7:0",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 408,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											hexValue: "30",
  											id: 406,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9454:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											}
  										],
  										id: 405,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										lValueRequested: false,
  										nodeType: "ElementaryTypeNameExpression",
  										src: "9446:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_type$_t_address_$",
  											typeString: "type(address)"
  										},
  										typeName: "address"
  									},
  									id: 407,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "typeConversion",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9446:10:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9426:30:0"
  							},
  							{
  								assignments: [
  									410
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 410,
  										name: "currentOwner",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9466:20:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 409,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "9466:7:0",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 411,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9466:20:0"
  							},
  							{
  								assignments: [
  									413
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 413,
  										name: "v",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9496:7:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint8",
  											typeString: "uint8"
  										},
  										typeName: {
  											id: 412,
  											name: "uint8",
  											nodeType: "ElementaryTypeName",
  											src: "9496:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint8",
  												typeString: "uint8"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 414,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9496:7:0"
  							},
  							{
  								assignments: [
  									416
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 416,
  										name: "r",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9513:9:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 415,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "9513:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 417,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9513:9:0"
  							},
  							{
  								assignments: [
  									419
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 419,
  										name: "s",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9532:9:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 418,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "9532:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 420,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9532:9:0"
  							},
  							{
  								assignments: [
  									422
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 422,
  										name: "i",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9551:9:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 421,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "9551:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 423,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9551:9:0"
  							},
  							{
  								body: {
  									id: 619,
  									nodeType: "Block",
  									src: "9603:3578:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 442,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													components: [
  														{
  															argumentTypes: null,
  															id: 434,
  															name: "v",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 413,
  															src: "9618:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint8",
  																typeString: "uint8"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 435,
  															name: "r",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 416,
  															src: "9621:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes32",
  																typeString: "bytes32"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 436,
  															name: "s",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 419,
  															src: "9624:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes32",
  																typeString: "bytes32"
  															}
  														}
  													],
  													id: 437,
  													isConstant: false,
  													isInlineArray: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													nodeType: "TupleExpression",
  													src: "9617:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_tuple$_t_uint8_$_t_bytes32_$_t_bytes32_$",
  														typeString: "tuple(uint8,bytes32,bytes32)"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 439,
  															name: "signatures",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 376,
  															src: "9644:10:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 440,
  															name: "i",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 422,
  															src: "9656:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														id: 438,
  														name: "signatureSplit",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2135,
  														src: "9629:14:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$_t_uint256_$returns$_t_uint8_$_t_bytes32_$_t_bytes32_$",
  															typeString: "function (bytes memory,uint256) pure returns (uint8,bytes32,bytes32)"
  														}
  													},
  													id: 441,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "9629:29:0",
  													typeDescriptions: {
  														typeIdentifier: "t_tuple$_t_uint8_$_t_bytes32_$_t_bytes32_$",
  														typeString: "tuple(uint8,bytes32,bytes32)"
  													}
  												},
  												src: "9617:41:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 443,
  											nodeType: "ExpressionStatement",
  											src: "9617:41:0"
  										},
  										{
  											condition: {
  												argumentTypes: null,
  												commonType: {
  													typeIdentifier: "t_uint8",
  													typeString: "uint8"
  												},
  												id: 446,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													argumentTypes: null,
  													id: 444,
  													name: "v",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 413,
  													src: "9733:1:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint8",
  														typeString: "uint8"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: "==",
  												rightExpression: {
  													argumentTypes: null,
  													hexValue: "30",
  													id: 445,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "9738:1:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													},
  													value: "0"
  												},
  												src: "9733:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											falseBody: {
  												condition: {
  													argumentTypes: null,
  													commonType: {
  														typeIdentifier: "t_uint8",
  														typeString: "uint8"
  													},
  													id: 520,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													leftExpression: {
  														argumentTypes: null,
  														id: 518,
  														name: "v",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 413,
  														src: "11783:1:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint8",
  															typeString: "uint8"
  														}
  													},
  													nodeType: "BinaryOperation",
  													operator: "==",
  													rightExpression: {
  														argumentTypes: null,
  														hexValue: "31",
  														id: 519,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "11788:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_1_by_1",
  															typeString: "int_const 1"
  														},
  														value: "1"
  													},
  													src: "11783:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													}
  												},
  												falseBody: {
  													condition: {
  														argumentTypes: null,
  														commonType: {
  															typeIdentifier: "t_uint8",
  															typeString: "uint8"
  														},
  														id: 564,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															argumentTypes: null,
  															id: 562,
  															name: "v",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 413,
  															src: "12485:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint8",
  																typeString: "uint8"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: ">",
  														rightExpression: {
  															argumentTypes: null,
  															hexValue: "3330",
  															id: 563,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "12489:2:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_30_by_1",
  																typeString: "int_const 30"
  															},
  															value: "30"
  														},
  														src: "12485:6:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													falseBody: {
  														id: 592,
  														nodeType: "Block",
  														src: "12791:149:0",
  														statements: [
  															{
  																expression: {
  																	argumentTypes: null,
  																	id: 590,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftHandSide: {
  																		argumentTypes: null,
  																		id: 583,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "12882:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "Assignment",
  																	operator: "=",
  																	rightHandSide: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 585,
  																				name: "dataHash",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 372,
  																				src: "12907:8:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 586,
  																				name: "v",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 413,
  																				src: "12917:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 587,
  																				name: "r",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 416,
  																				src: "12920:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 588,
  																				name: "s",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 419,
  																				src: "12923:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 584,
  																			name: "ecrecover",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 5160,
  																			src: "12897:9:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_ecrecover_pure$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_address_$",
  																				typeString: "function (bytes32,uint8,bytes32,bytes32) pure returns (address)"
  																			}
  																		},
  																		id: 589,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "12897:28:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	src: "12882:43:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																id: 591,
  																nodeType: "ExpressionStatement",
  																src: "12882:43:0"
  															}
  														]
  													},
  													id: 593,
  													nodeType: "IfStatement",
  													src: "12481:459:0",
  													trueBody: {
  														id: 582,
  														nodeType: "Block",
  														src: "12493:292:0",
  														statements: [
  															{
  																expression: {
  																	argumentTypes: null,
  																	id: 580,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftHandSide: {
  																		argumentTypes: null,
  																		id: 565,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "12658:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "Assignment",
  																	operator: "=",
  																	rightHandSide: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						"arguments": [
  																							{
  																								argumentTypes: null,
  																								hexValue: "19457468657265756d205369676e6564204d6573736167653a0a3332",
  																								id: 570,
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								kind: "string",
  																								lValueRequested: false,
  																								nodeType: "Literal",
  																								src: "12710:34:0",
  																								subdenomination: null,
  																								typeDescriptions: {
  																									typeIdentifier: "t_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73",
  																									typeString: "literal_string \"\u0019Ethereum Signed Message:\n32\""
  																								},
  																								value: "\u0019Ethereum Signed Message:\n32"
  																							},
  																							{
  																								argumentTypes: null,
  																								id: 571,
  																								name: "dataHash",
  																								nodeType: "Identifier",
  																								overloadedDeclarations: [
  																								],
  																								referencedDeclaration: 372,
  																								src: "12746:8:0",
  																								typeDescriptions: {
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							}
  																						],
  																						expression: {
  																							argumentTypes: [
  																								{
  																									typeIdentifier: "t_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73",
  																									typeString: "literal_string \"\u0019Ethereum Signed Message:\n32\""
  																								},
  																								{
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							],
  																							expression: {
  																								argumentTypes: null,
  																								id: 568,
  																								name: "abi",
  																								nodeType: "Identifier",
  																								overloadedDeclarations: [
  																								],
  																								referencedDeclaration: 5155,
  																								src: "12693:3:0",
  																								typeDescriptions: {
  																									typeIdentifier: "t_magic_abi",
  																									typeString: "abi"
  																								}
  																							},
  																							id: 569,
  																							isConstant: false,
  																							isLValue: false,
  																							isPure: true,
  																							lValueRequested: false,
  																							memberName: "encodePacked",
  																							nodeType: "MemberAccess",
  																							referencedDeclaration: null,
  																							src: "12693:16:0",
  																							typeDescriptions: {
  																								typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  																								typeString: "function () pure returns (bytes memory)"
  																							}
  																						},
  																						id: 572,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						kind: "functionCall",
  																						lValueRequested: false,
  																						names: [
  																						],
  																						nodeType: "FunctionCall",
  																						src: "12693:62:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_bytes_memory_ptr",
  																							typeString: "bytes memory"
  																						}
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_bytes_memory_ptr",
  																							typeString: "bytes memory"
  																						}
  																					],
  																					id: 567,
  																					name: "keccak256",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 5162,
  																					src: "12683:9:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  																						typeString: "function (bytes memory) pure returns (bytes32)"
  																					}
  																				},
  																				id: 573,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "functionCall",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "12683:73:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				commonType: {
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				},
  																				id: 576,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				leftExpression: {
  																					argumentTypes: null,
  																					id: 574,
  																					name: "v",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 413,
  																					src: "12758:1:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_uint8",
  																						typeString: "uint8"
  																					}
  																				},
  																				nodeType: "BinaryOperation",
  																				operator: "-",
  																				rightExpression: {
  																					argumentTypes: null,
  																					hexValue: "34",
  																					id: 575,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: true,
  																					kind: "number",
  																					lValueRequested: false,
  																					nodeType: "Literal",
  																					src: "12762:1:0",
  																					subdenomination: null,
  																					typeDescriptions: {
  																						typeIdentifier: "t_rational_4_by_1",
  																						typeString: "int_const 4"
  																					},
  																					value: "4"
  																				},
  																				src: "12758:5:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 577,
  																				name: "r",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 416,
  																				src: "12765:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 578,
  																				name: "s",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 419,
  																				src: "12768:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 566,
  																			name: "ecrecover",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 5160,
  																			src: "12673:9:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_ecrecover_pure$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_address_$",
  																				typeString: "function (bytes32,uint8,bytes32,bytes32) pure returns (address)"
  																			}
  																		},
  																		id: 579,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "12673:97:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	src: "12658:112:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																id: 581,
  																nodeType: "ExpressionStatement",
  																src: "12658:112:0"
  															}
  														]
  													}
  												},
  												id: 594,
  												nodeType: "IfStatement",
  												src: "11779:1161:0",
  												trueBody: {
  													id: 561,
  													nodeType: "Block",
  													src: "11791:684:0",
  													statements: [
  														{
  															expression: {
  																argumentTypes: null,
  																id: 527,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftHandSide: {
  																	argumentTypes: null,
  																	id: 521,
  																	name: "currentOwner",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 410,
  																	src: "11904:12:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																nodeType: "Assignment",
  																operator: "=",
  																rightHandSide: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			"arguments": [
  																				{
  																					argumentTypes: null,
  																					id: 524,
  																					name: "r",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 416,
  																					src: "11935:1:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				}
  																			],
  																			expression: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				],
  																				id: 523,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				nodeType: "ElementaryTypeNameExpression",
  																				src: "11927:7:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_type$_t_uint256_$",
  																					typeString: "type(uint256)"
  																				},
  																				typeName: "uint256"
  																			},
  																			id: 525,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			kind: "typeConversion",
  																			lValueRequested: false,
  																			names: [
  																			],
  																			nodeType: "FunctionCall",
  																			src: "11927:10:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		id: 522,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		nodeType: "ElementaryTypeNameExpression",
  																		src: "11919:7:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_type$_t_address_$",
  																			typeString: "type(address)"
  																		},
  																		typeName: "address"
  																	},
  																	id: 526,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "typeConversion",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "11919:19:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																},
  																src: "11904:34:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															id: 528,
  															nodeType: "ExpressionStatement",
  															src: "11904:34:0"
  														},
  														{
  															expression: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		commonType: {
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		},
  																		id: 541,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		leftExpression: {
  																			argumentTypes: null,
  																			commonType: {
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			id: 533,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			leftExpression: {
  																				argumentTypes: null,
  																				expression: {
  																					argumentTypes: null,
  																					id: 530,
  																					name: "msg",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 5168,
  																					src: "12109:3:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_magic_message",
  																						typeString: "msg"
  																					}
  																				},
  																				id: 531,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				memberName: "sender",
  																				nodeType: "MemberAccess",
  																				referencedDeclaration: null,
  																				src: "12109:10:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_address_payable",
  																					typeString: "address payable"
  																				}
  																			},
  																			nodeType: "BinaryOperation",
  																			operator: "==",
  																			rightExpression: {
  																				argumentTypes: null,
  																				id: 532,
  																				name: "currentOwner",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 410,
  																				src: "12123:12:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_address",
  																					typeString: "address"
  																				}
  																			},
  																			src: "12109:26:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bool",
  																				typeString: "bool"
  																			}
  																		},
  																		nodeType: "BinaryOperation",
  																		operator: "||",
  																		rightExpression: {
  																			argumentTypes: null,
  																			commonType: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			},
  																			id: 540,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			leftExpression: {
  																				argumentTypes: null,
  																				baseExpression: {
  																					argumentTypes: null,
  																					baseExpression: {
  																						argumentTypes: null,
  																						id: 534,
  																						name: "approvedHashes",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 77,
  																						src: "12139:14:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  																							typeString: "mapping(address => mapping(bytes32 => uint256))"
  																						}
  																					},
  																					id: 536,
  																					indexExpression: {
  																						argumentTypes: null,
  																						id: 535,
  																						name: "currentOwner",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 410,
  																						src: "12154:12:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					},
  																					isConstant: false,
  																					isLValue: true,
  																					isPure: false,
  																					lValueRequested: false,
  																					nodeType: "IndexAccess",
  																					src: "12139:28:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  																						typeString: "mapping(bytes32 => uint256)"
  																					}
  																				},
  																				id: 538,
  																				indexExpression: {
  																					argumentTypes: null,
  																					id: 537,
  																					name: "dataHash",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 372,
  																					src: "12168:8:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				},
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				nodeType: "IndexAccess",
  																				src: "12139:38:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			nodeType: "BinaryOperation",
  																			operator: "!=",
  																			rightExpression: {
  																				argumentTypes: null,
  																				hexValue: "30",
  																				id: 539,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "12181:1:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				},
  																				value: "0"
  																			},
  																			src: "12139:43:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bool",
  																				typeString: "bool"
  																			}
  																		},
  																		src: "12109:73:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		}
  																	},
  																	{
  																		argumentTypes: null,
  																		hexValue: "4861736820686173206e6f74206265656e20617070726f766564",
  																		id: 542,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		kind: "string",
  																		lValueRequested: false,
  																		nodeType: "Literal",
  																		src: "12184:28:0",
  																		subdenomination: null,
  																		typeDescriptions: {
  																			typeIdentifier: "t_stringliteral_d7f4b4187d31f59e4128c96e91f8a3de36d0b0c16e067e93136a6935459cd4c4",
  																			typeString: "literal_string \"Hash has not been approved\""
  																		},
  																		value: "Hash has not been approved"
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		},
  																		{
  																			typeIdentifier: "t_stringliteral_d7f4b4187d31f59e4128c96e91f8a3de36d0b0c16e067e93136a6935459cd4c4",
  																			typeString: "literal_string \"Hash has not been approved\""
  																		}
  																	],
  																	id: 529,
  																	name: "require",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																		5171,
  																		5172
  																	],
  																	referencedDeclaration: 5172,
  																	src: "12101:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																		typeString: "function (bool,string memory) pure"
  																	}
  																},
  																id: 543,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "12101:112:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_tuple$__$",
  																	typeString: "tuple()"
  																}
  															},
  															id: 544,
  															nodeType: "ExpressionStatement",
  															src: "12101:112:0"
  														},
  														{
  															condition: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																},
  																id: 550,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 545,
  																	name: "consumeHash",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 378,
  																	src: "12335:11:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "&&",
  																rightExpression: {
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	id: 549,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 546,
  																			name: "msg",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 5168,
  																			src: "12350:3:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_magic_message",
  																				typeString: "msg"
  																			}
  																		},
  																		id: 547,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "sender",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: null,
  																		src: "12350:10:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address_payable",
  																			typeString: "address payable"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "!=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		id: 548,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "12364:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	src: "12350:26:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																src: "12335:41:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															falseBody: null,
  															id: 560,
  															nodeType: "IfStatement",
  															src: "12331:130:0",
  															trueBody: {
  																id: 559,
  																nodeType: "Block",
  																src: "12378:83:0",
  																statements: [
  																	{
  																		expression: {
  																			argumentTypes: null,
  																			id: 557,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			leftHandSide: {
  																				argumentTypes: null,
  																				baseExpression: {
  																					argumentTypes: null,
  																					baseExpression: {
  																						argumentTypes: null,
  																						id: 551,
  																						name: "approvedHashes",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 77,
  																						src: "12400:14:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  																							typeString: "mapping(address => mapping(bytes32 => uint256))"
  																						}
  																					},
  																					id: 554,
  																					indexExpression: {
  																						argumentTypes: null,
  																						id: 552,
  																						name: "currentOwner",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 410,
  																						src: "12415:12:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					},
  																					isConstant: false,
  																					isLValue: true,
  																					isPure: false,
  																					lValueRequested: false,
  																					nodeType: "IndexAccess",
  																					src: "12400:28:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  																						typeString: "mapping(bytes32 => uint256)"
  																					}
  																				},
  																				id: 555,
  																				indexExpression: {
  																					argumentTypes: null,
  																					id: 553,
  																					name: "dataHash",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 372,
  																					src: "12429:8:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				},
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: true,
  																				nodeType: "IndexAccess",
  																				src: "12400:38:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			nodeType: "Assignment",
  																			operator: "=",
  																			rightHandSide: {
  																				argumentTypes: null,
  																				hexValue: "30",
  																				id: 556,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "12441:1:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				},
  																				value: "0"
  																			},
  																			src: "12400:42:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		},
  																		id: 558,
  																		nodeType: "ExpressionStatement",
  																		src: "12400:42:0"
  																	}
  																]
  															}
  														}
  													]
  												}
  											},
  											id: 595,
  											nodeType: "IfStatement",
  											src: "9729:3211:0",
  											trueBody: {
  												id: 517,
  												nodeType: "Block",
  												src: "9741:2032:0",
  												statements: [
  													{
  														expression: {
  															argumentTypes: null,
  															id: 453,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																argumentTypes: null,
  																id: 447,
  																name: "currentOwner",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 410,
  																src: "9858:12:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 450,
  																				name: "r",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 416,
  																				src: "9889:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 449,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "9881:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_uint256_$",
  																				typeString: "type(uint256)"
  																			},
  																			typeName: "uint256"
  																		},
  																		id: 451,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "9881:10:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	id: 448,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	lValueRequested: false,
  																	nodeType: "ElementaryTypeNameExpression",
  																	src: "9873:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_type$_t_address_$",
  																		typeString: "type(address)"
  																	},
  																	typeName: "address"
  																},
  																id: 452,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "typeConversion",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "9873:19:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															src: "9858:34:0",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														id: 454,
  														nodeType: "ExpressionStatement",
  														src: "9858:34:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	id: 463,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 457,
  																				name: "s",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 419,
  																				src: "10287:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 456,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "10279:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_uint256_$",
  																				typeString: "type(uint256)"
  																			},
  																			typeName: "uint256"
  																		},
  																		id: 458,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "10279:10:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: ">=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				hexValue: "3635",
  																				id: 461,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "10308:2:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_65_by_1",
  																					typeString: "int_const 65"
  																				},
  																				value: "65"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_rational_65_by_1",
  																					typeString: "int_const 65"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				id: 459,
  																				name: "_threshold",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 382,
  																				src: "10293:10:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			id: 460,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "mul",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2171,
  																			src: "10293:14:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																				typeString: "function (uint256,uint256) pure returns (uint256)"
  																			}
  																		},
  																		id: 462,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "10293:18:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	src: "10279:32:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e6174757265206c6f636174696f6e3a20696e73696465207374617469632070617274",
  																	id: 464,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "10313:57:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_bfb239616a9951d5fab065a9a51a4efbfefb4123cc2bd6ca3a42ba9495d0b860",
  																		typeString: "literal_string \"Invalid contract signature location: inside static part\""
  																	},
  																	value: "Invalid contract signature location: inside static part"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_bfb239616a9951d5fab065a9a51a4efbfefb4123cc2bd6ca3a42ba9495d0b860",
  																		typeString: "literal_string \"Invalid contract signature location: inside static part\""
  																	}
  																],
  																id: 455,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "10271:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 465,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10271:100:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 466,
  														nodeType: "ExpressionStatement",
  														src: "10271:100:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	id: 476,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				hexValue: "3332",
  																				id: 472,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "10526:2:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_32_by_1",
  																					typeString: "int_const 32"
  																				},
  																				value: "32"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_rational_32_by_1",
  																					typeString: "int_const 32"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						id: 469,
  																						name: "s",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 419,
  																						src: "10519:1:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_bytes32",
  																							typeString: "bytes32"
  																						}
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_bytes32",
  																							typeString: "bytes32"
  																						}
  																					],
  																					id: 468,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: true,
  																					lValueRequested: false,
  																					nodeType: "ElementaryTypeNameExpression",
  																					src: "10511:7:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_type$_t_uint256_$",
  																						typeString: "type(uint256)"
  																					},
  																					typeName: "uint256"
  																				},
  																				id: 470,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "typeConversion",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "10511:10:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			id: 471,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "add",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2243,
  																			src: "10511:14:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																				typeString: "function (uint256,uint256) pure returns (uint256)"
  																			}
  																		},
  																		id: 473,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "10511:18:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "<=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 474,
  																			name: "signatures",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 376,
  																			src: "10533:10:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bytes_memory_ptr",
  																				typeString: "bytes memory"
  																			}
  																		},
  																		id: 475,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "length",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: null,
  																		src: "10533:17:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	src: "10511:39:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e6174757265206c6f636174696f6e3a206c656e677468206e6f742070726573656e74",
  																	id: 477,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "10552:57:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_dc0d1c56ccf75f8c8c8a674b5193ee8ed08d0760e044e48d340712e3fcc404fc",
  																		typeString: "literal_string \"Invalid contract signature location: length not present\""
  																	},
  																	value: "Invalid contract signature location: length not present"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_dc0d1c56ccf75f8c8c8a674b5193ee8ed08d0760e044e48d340712e3fcc404fc",
  																		typeString: "literal_string \"Invalid contract signature location: length not present\""
  																	}
  																],
  																id: 467,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "10503:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 478,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10503:107:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 479,
  														nodeType: "ExpressionStatement",
  														src: "10503:107:0"
  													},
  													{
  														assignments: [
  															481
  														],
  														declarations: [
  															{
  																constant: false,
  																id: 481,
  																name: "contractSignatureLen",
  																nodeType: "VariableDeclaration",
  																scope: 517,
  																src: "10754:28:0",
  																stateVariable: false,
  																storageLocation: "default",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																typeName: {
  																	id: 480,
  																	name: "uint256",
  																	nodeType: "ElementaryTypeName",
  																	src: "10754:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																value: null,
  																visibility: "internal"
  															}
  														],
  														id: 482,
  														initialValue: null,
  														nodeType: "VariableDeclarationStatement",
  														src: "10754:28:0"
  													},
  													{
  														externalReferences: [
  															{
  																contractSignatureLen: {
  																	declaration: 481,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "10903:20:0",
  																	valueSize: 1
  																}
  															},
  															{
  																signatures: {
  																	declaration: 376,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "10941:10:0",
  																	valueSize: 1
  																}
  															},
  															{
  																s: {
  																	declaration: 419,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "10953:1:0",
  																	valueSize: 1
  																}
  															}
  														],
  														id: 483,
  														nodeType: "InlineAssembly",
  														operations: "{\n    contractSignatureLen := mload(add(add(signatures, s), 0x20))\n}",
  														src: "10872:109:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	id: 496,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 492,
  																				name: "contractSignatureLen",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 481,
  																				src: "11029:20:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						hexValue: "3332",
  																						id: 489,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						kind: "number",
  																						lValueRequested: false,
  																						nodeType: "Literal",
  																						src: "11021:2:0",
  																						subdenomination: null,
  																						typeDescriptions: {
  																							typeIdentifier: "t_rational_32_by_1",
  																							typeString: "int_const 32"
  																						},
  																						value: "32"
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_rational_32_by_1",
  																							typeString: "int_const 32"
  																						}
  																					],
  																					expression: {
  																						argumentTypes: null,
  																						"arguments": [
  																							{
  																								argumentTypes: null,
  																								id: 486,
  																								name: "s",
  																								nodeType: "Identifier",
  																								overloadedDeclarations: [
  																								],
  																								referencedDeclaration: 419,
  																								src: "11014:1:0",
  																								typeDescriptions: {
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							}
  																						],
  																						expression: {
  																							argumentTypes: [
  																								{
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							],
  																							id: 485,
  																							isConstant: false,
  																							isLValue: false,
  																							isPure: true,
  																							lValueRequested: false,
  																							nodeType: "ElementaryTypeNameExpression",
  																							src: "11006:7:0",
  																							typeDescriptions: {
  																								typeIdentifier: "t_type$_t_uint256_$",
  																								typeString: "type(uint256)"
  																							},
  																							typeName: "uint256"
  																						},
  																						id: 487,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						kind: "typeConversion",
  																						lValueRequested: false,
  																						names: [
  																						],
  																						nodeType: "FunctionCall",
  																						src: "11006:10:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_uint256",
  																							typeString: "uint256"
  																						}
  																					},
  																					id: 488,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: false,
  																					lValueRequested: false,
  																					memberName: "add",
  																					nodeType: "MemberAccess",
  																					referencedDeclaration: 2243,
  																					src: "11006:14:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																						typeString: "function (uint256,uint256) pure returns (uint256)"
  																					}
  																				},
  																				id: 490,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "functionCall",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "11006:18:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			id: 491,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "add",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2243,
  																			src: "11006:22:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																				typeString: "function (uint256,uint256) pure returns (uint256)"
  																			}
  																		},
  																		id: 493,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "11006:44:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "<=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 494,
  																			name: "signatures",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 376,
  																			src: "11054:10:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bytes_memory_ptr",
  																				typeString: "bytes memory"
  																			}
  																		},
  																		id: 495,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "length",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: null,
  																		src: "11054:17:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	src: "11006:65:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e6174757265206c6f636174696f6e3a2064617461206e6f7420636f6d706c657465",
  																	id: 497,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "11073:56:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_ac9b3d17bcf94bcca27fad9236a2ce28cd2180227f36ea63832457691c24a721",
  																		typeString: "literal_string \"Invalid contract signature location: data not complete\""
  																	},
  																	value: "Invalid contract signature location: data not complete"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_ac9b3d17bcf94bcca27fad9236a2ce28cd2180227f36ea63832457691c24a721",
  																		typeString: "literal_string \"Invalid contract signature location: data not complete\""
  																	}
  																],
  																id: 484,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "10998:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 498,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10998:132:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 499,
  														nodeType: "ExpressionStatement",
  														src: "10998:132:0"
  													},
  													{
  														assignments: [
  															501
  														],
  														declarations: [
  															{
  																constant: false,
  																id: 501,
  																name: "contractSignature",
  																nodeType: "VariableDeclaration",
  																scope: 517,
  																src: "11184:30:0",
  																stateVariable: false,
  																storageLocation: "memory",
  																typeDescriptions: {
  																	typeIdentifier: "t_bytes_memory_ptr",
  																	typeString: "bytes"
  																},
  																typeName: {
  																	id: 500,
  																	name: "bytes",
  																	nodeType: "ElementaryTypeName",
  																	src: "11184:5:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bytes_storage_ptr",
  																		typeString: "bytes"
  																	}
  																},
  																value: null,
  																visibility: "internal"
  															}
  														],
  														id: 502,
  														initialValue: null,
  														nodeType: "VariableDeclarationStatement",
  														src: "11184:30:0"
  													},
  													{
  														externalReferences: [
  															{
  																contractSignature: {
  																	declaration: 501,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "11474:17:0",
  																	valueSize: 1
  																}
  															},
  															{
  																signatures: {
  																	declaration: 376,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "11503:10:0",
  																	valueSize: 1
  																}
  															},
  															{
  																s: {
  																	declaration: 419,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "11515:1:0",
  																	valueSize: 1
  																}
  															}
  														],
  														id: 503,
  														nodeType: "InlineAssembly",
  														operations: "{\n    contractSignature := add(add(signatures, s), 0x20)\n}",
  														src: "11304:238:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_bytes4",
  																		typeString: "bytes4"
  																	},
  																	id: 513,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 509,
  																				name: "data",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 374,
  																				src: "11618:4:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 510,
  																				name: "contractSignature",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 501,
  																				src: "11624:17:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				},
  																				{
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						id: 506,
  																						name: "currentOwner",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 410,
  																						src: "11587:12:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					],
  																					id: 505,
  																					name: "ISignatureValidator",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 2439,
  																					src: "11567:19:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_type$_t_contract$_ISignatureValidator_$2439_$",
  																						typeString: "type(contract ISignatureValidator)"
  																					}
  																				},
  																				id: 507,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "typeConversion",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "11567:33:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_ISignatureValidator_$2439",
  																					typeString: "contract ISignatureValidator"
  																				}
  																			},
  																			id: 508,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "isValidSignature",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2438,
  																			src: "11567:50:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_external_view$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$returns$_t_bytes4_$",
  																				typeString: "function (bytes memory,bytes memory) view external returns (bytes4)"
  																			}
  																		},
  																		id: 511,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "11567:75:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_bytes4",
  																			typeString: "bytes4"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "==",
  																	rightExpression: {
  																		argumentTypes: null,
  																		id: 512,
  																		name: "EIP1271_MAGIC_VALUE",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 2426,
  																		src: "11646:19:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_bytes4",
  																			typeString: "bytes4"
  																		}
  																	},
  																	src: "11567:98:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e61747572652070726f7669646564",
  																	id: 514,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "11667:37:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_390c7641d6d34f7efe51534140db10473a63d1356be81e211b820ef38d63c7ad",
  																		typeString: "literal_string \"Invalid contract signature provided\""
  																	},
  																	value: "Invalid contract signature provided"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_390c7641d6d34f7efe51534140db10473a63d1356be81e211b820ef38d63c7ad",
  																		typeString: "literal_string \"Invalid contract signature provided\""
  																	}
  																],
  																id: 504,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "11559:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 515,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "11559:146:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 516,
  														nodeType: "ExpressionStatement",
  														src: "11559:146:0"
  													}
  												]
  											}
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														id: 611,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															argumentTypes: null,
  															commonType: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															id: 607,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																id: 599,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 597,
  																	name: "currentOwner",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 410,
  																	src: "12979:12:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: ">",
  																rightExpression: {
  																	argumentTypes: null,
  																	id: 598,
  																	name: "lastOwner",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 404,
  																	src: "12994:9:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																src: "12979:24:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "&&",
  															rightExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																id: 606,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	baseExpression: {
  																		argumentTypes: null,
  																		id: 600,
  																		name: "owners",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1544,
  																		src: "13007:6:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  																			typeString: "mapping(address => address)"
  																		}
  																	},
  																	id: 602,
  																	indexExpression: {
  																		argumentTypes: null,
  																		id: 601,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "13014:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	isConstant: false,
  																	isLValue: true,
  																	isPure: false,
  																	lValueRequested: false,
  																	nodeType: "IndexAccess",
  																	src: "13007:20:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "!=",
  																rightExpression: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			hexValue: "30",
  																			id: 604,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			kind: "number",
  																			lValueRequested: false,
  																			nodeType: "Literal",
  																			src: "13039:1:0",
  																			subdenomination: null,
  																			typeDescriptions: {
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			},
  																			value: "0"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		id: 603,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		nodeType: "ElementaryTypeNameExpression",
  																		src: "13031:7:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_type$_t_address_$",
  																			typeString: "type(address)"
  																		},
  																		typeName: "address"
  																	},
  																	id: 605,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "typeConversion",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "13031:10:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																},
  																src: "13007:34:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															src: "12979:62:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: "&&",
  														rightExpression: {
  															argumentTypes: null,
  															commonType: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															id: 610,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																argumentTypes: null,
  																id: 608,
  																name: "currentOwner",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 410,
  																src: "13045:12:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "!=",
  															rightExpression: {
  																argumentTypes: null,
  																id: 609,
  																name: "SENTINEL_OWNERS",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1540,
  																src: "13061:15:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															src: "13045:31:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														src: "12979:97:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "496e76616c6964206f776e65722070726f7669646564",
  														id: 612,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "13094:24:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_8ee2555cd581859d0f0126c1bf87e0d45ed61a2e38322e0cb3c328581d2d4b32",
  															typeString: "literal_string \"Invalid owner provided\""
  														},
  														value: "Invalid owner provided"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_8ee2555cd581859d0f0126c1bf87e0d45ed61a2e38322e0cb3c328581d2d4b32",
  															typeString: "literal_string \"Invalid owner provided\""
  														}
  													],
  													id: 596,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "12953:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 613,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "12953:179:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 614,
  											nodeType: "ExpressionStatement",
  											src: "12953:179:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 617,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 615,
  													name: "lastOwner",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 404,
  													src: "13146:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													id: 616,
  													name: "currentOwner",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 410,
  													src: "13158:12:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												src: "13146:24:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											id: 618,
  											nodeType: "ExpressionStatement",
  											src: "13146:24:0"
  										}
  									]
  								},
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 430,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 428,
  										name: "i",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 422,
  										src: "9582:1:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										id: 429,
  										name: "_threshold",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 382,
  										src: "9586:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "9582:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 620,
  								initializationExpression: {
  									expression: {
  										argumentTypes: null,
  										id: 426,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftHandSide: {
  											argumentTypes: null,
  											id: 424,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 422,
  											src: "9575:1:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "Assignment",
  										operator: "=",
  										rightHandSide: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 425,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9579:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										src: "9575:5:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 427,
  									nodeType: "ExpressionStatement",
  									src: "9575:5:0"
  								},
  								loopExpression: {
  									expression: {
  										argumentTypes: null,
  										id: 432,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "++",
  										prefix: false,
  										src: "9598:3:0",
  										subExpression: {
  											argumentTypes: null,
  											id: 431,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 422,
  											src: "9598:1:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 433,
  									nodeType: "ExpressionStatement",
  									src: "9598:3:0"
  								},
  								nodeType: "ForStatement",
  								src: "9570:3611:0"
  							}
  						]
  					},
  					documentation: "@dev Checks whether the signature provided is valid for the provided data, hash. Will revert otherwise.\n@param dataHash Hash of the data (could be either a message hash or transaction hash)\n@param data That should be signed (this is passed to an external validator contract)\n@param signatures Signature data that should be verified. Can be ECDSA signature, contract signature (EIP-1271) or approved hash.\n@param consumeHash Indicates that in case of an approved hash the storage can be freed to save gas",
  					id: 622,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "checkSignatures",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 379,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 372,
  								name: "dataHash",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8903:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 371,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "8903:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 374,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8921:17:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 373,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "8921:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 376,
  								name: "signatures",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8940:23:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 375,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "8940:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 378,
  								name: "consumeHash",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8965:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 377,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "8965:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8902:80:0"
  					},
  					returnParameters: {
  						id: 380,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "9004:0:0"
  					},
  					scope: 903,
  					src: "8878:4309:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 669,
  						nodeType: "Block",
  						src: "14262:420:0",
  						statements: [
  							{
  								assignments: [
  									638
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 638,
  										name: "startGas",
  										nodeType: "VariableDeclaration",
  										scope: 669,
  										src: "14272:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 637,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "14272:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 641,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 639,
  										name: "gasleft",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5161,
  										src: "14291:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  											typeString: "function () view returns (uint256)"
  										}
  									},
  									id: 640,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14291:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "14272:28:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 644,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 624,
  													src: "14462:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 645,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 626,
  													src: "14466:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 646,
  													name: "data",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 628,
  													src: "14473:4:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 647,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 630,
  													src: "14479:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														id: 648,
  														name: "gasleft",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5161,
  														src: "14490:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  															typeString: "function () view returns (uint256)"
  														}
  													},
  													id: 649,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "14490:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												id: 643,
  												name: "execute",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1012,
  												src: "14454:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256) returns (bool)"
  												}
  											},
  											id: 650,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "14454:46:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 642,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5171,
  										src: "14446:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 651,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14446:55:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 652,
  								nodeType: "ExpressionStatement",
  								src: "14446:55:0"
  							},
  							{
  								assignments: [
  									654
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 654,
  										name: "requiredGas",
  										nodeType: "VariableDeclaration",
  										scope: 669,
  										src: "14511:19:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 653,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "14511:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 659,
  								initialValue: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 658,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 655,
  										name: "startGas",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 638,
  										src: "14533:8:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "-",
  									rightExpression: {
  										argumentTypes: null,
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											id: 656,
  											name: "gasleft",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5161,
  											src: "14544:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  												typeString: "function () view returns (uint256)"
  											}
  										},
  										id: 657,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "14544:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "14533:20:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "14511:42:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 664,
  															name: "requiredGas",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 654,
  															src: "14661:11:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 662,
  															name: "abi",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 5155,
  															src: "14644:3:0",
  															typeDescriptions: {
  																typeIdentifier: "t_magic_abi",
  																typeString: "abi"
  															}
  														},
  														id: 663,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														memberName: "encodePacked",
  														nodeType: "MemberAccess",
  														referencedDeclaration: null,
  														src: "14644:16:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  															typeString: "function () pure returns (bytes memory)"
  														}
  													},
  													id: 665,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "14644:29:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												],
  												id: 661,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "14637:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_string_storage_ptr_$",
  													typeString: "type(string storage pointer)"
  												},
  												typeName: "string"
  											},
  											id: 666,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "14637:37:0",
  											typeDescriptions: {
  												typeIdentifier: "t_string_memory_ptr",
  												typeString: "string memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_string_memory_ptr",
  												typeString: "string memory"
  											}
  										],
  										id: 660,
  										name: "revert",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5173,
  											5174
  										],
  										referencedDeclaration: 5174,
  										src: "14630:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (string memory) pure"
  										}
  									},
  									id: 667,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14630:45:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 668,
  								nodeType: "ExpressionStatement",
  								src: "14630:45:0"
  							}
  						]
  					},
  					documentation: "@dev Allows to estimate a Safe transaction.\n      This method is only meant for estimation purpose, therefore two different protection mechanism against execution in a transaction have been made:\n      1.) The method can only be called from the safe itself\n      2.) The response is returned with a revert\n      When estimating set `from` to the address of the safe.\n      Since the `estimateGas` function includes refunds, call this method to get an estimated of the costs that are deducted from the safe with `execTransaction`\n @param to Destination address of Safe transaction.\n @param value Ether value of Safe transaction.\n @param data Data payload of Safe transaction.\n @param operation Operation type of Safe transaction.\n @return Estimate without refunds and overhead fees (base transaction and payload data gas costs).",
  					id: 670,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 633,
  							modifierName: {
  								argumentTypes: null,
  								id: 632,
  								name: "authorized",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 2079,
  								src: "14221:10:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "14221:10:0"
  						}
  					],
  					name: "requiredTxGas",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 631,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 624,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14122:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 623,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "14122:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 626,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14134:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 625,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "14134:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 628,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14149:19:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 627,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "14149:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 630,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14170:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 629,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "14170:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "14121:74:0"
  					},
  					returnParameters: {
  						id: 636,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 635,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14249:7:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 634,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "14249:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "14248:9:0"
  					},
  					scope: 903,
  					src: "14099:583:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 702,
  						nodeType: "Block",
  						src: "14991:200:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 683,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												baseExpression: {
  													argumentTypes: null,
  													id: 676,
  													name: "owners",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1544,
  													src: "15009:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  														typeString: "mapping(address => address)"
  													}
  												},
  												id: 679,
  												indexExpression: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 677,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5168,
  														src: "15016:3:0",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 678,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													referencedDeclaration: null,
  													src: "15016:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "15009:18:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "30",
  														id: 681,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "15039:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 680,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "15031:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: "address"
  												},
  												id: 682,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "15031:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "15009:32:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4f6e6c79206f776e6572732063616e20617070726f766520612068617368",
  											id: 684,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "15043:32:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_60f21058f4a7689ef29853b3c9c17c9bf69856a949794649bb68878f00552475",
  												typeString: "literal_string \"Only owners can approve a hash\""
  											},
  											value: "Only owners can approve a hash"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_60f21058f4a7689ef29853b3c9c17c9bf69856a949794649bb68878f00552475",
  												typeString: "literal_string \"Only owners can approve a hash\""
  											}
  										],
  										id: 675,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "15001:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 685,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15001:75:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 686,
  								nodeType: "ExpressionStatement",
  								src: "15001:75:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 694,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 687,
  												name: "approvedHashes",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 77,
  												src: "15086:14:0",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  													typeString: "mapping(address => mapping(bytes32 => uint256))"
  												}
  											},
  											id: 691,
  											indexExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 688,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5168,
  													src: "15101:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 689,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "15101:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "15086:26:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  												typeString: "mapping(bytes32 => uint256)"
  											}
  										},
  										id: 692,
  										indexExpression: {
  											argumentTypes: null,
  											id: 690,
  											name: "hashToApprove",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 672,
  											src: "15113:13:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "15086:41:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "31",
  										id: 693,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "15130:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "15086:45:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 695,
  								nodeType: "ExpressionStatement",
  								src: "15086:45:0"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 697,
  											name: "hashToApprove",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 672,
  											src: "15158:13:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 698,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 5168,
  												src: "15173:3:0",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 699,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "15173:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										],
  										id: 696,
  										name: "ApproveHash",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 47,
  										src: "15146:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$_t_address_$returns$__$",
  											typeString: "function (bytes32,address)"
  										}
  									},
  									id: 700,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15146:38:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 701,
  								nodeType: "EmitStatement",
  								src: "15141:43:0"
  							}
  						]
  					},
  					documentation: "@dev Marks a hash as approved. This can be used to validate a hash that is used by a signature.\n@param hashToApprove The hash that should be marked as approved for signatures that are verified by this contract.",
  					id: 703,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "approveHash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 673,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 672,
  								name: "hashToApprove",
  								nodeType: "VariableDeclaration",
  								scope: 703,
  								src: "14947:21:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 671,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "14947:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "14946:23:0"
  					},
  					returnParameters: {
  						id: 674,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "14991:0:0"
  					},
  					scope: 903,
  					src: "14926:265:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 726,
  						nodeType: "Block",
  						src: "15436:124:0",
  						statements: [
  							{
  								assignments: [
  									711
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 711,
  										name: "msgHash",
  										nodeType: "VariableDeclaration",
  										scope: 726,
  										src: "15446:15:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 710,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "15446:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 715,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 713,
  											name: "_data",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 705,
  											src: "15479:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										],
  										id: 712,
  										name: "getMessageHash",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 802,
  										src: "15464:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) view returns (bytes32)"
  										}
  									},
  									id: 714,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15464:21:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "15446:39:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 720,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 716,
  											name: "signedMessages",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 71,
  											src: "15495:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  												typeString: "mapping(bytes32 => uint256)"
  											}
  										},
  										id: 718,
  										indexExpression: {
  											argumentTypes: null,
  											id: 717,
  											name: "msgHash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 711,
  											src: "15510:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "15495:23:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "31",
  										id: 719,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "15521:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "15495:27:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 721,
  								nodeType: "ExpressionStatement",
  								src: "15495:27:0"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 723,
  											name: "msgHash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 711,
  											src: "15545:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										],
  										id: 722,
  										name: "SignMsg",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 51,
  										src: "15537:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$returns$__$",
  											typeString: "function (bytes32)"
  										}
  									},
  									id: 724,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15537:16:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 725,
  								nodeType: "EmitStatement",
  								src: "15532:21:0"
  							}
  						]
  					},
  					documentation: "@dev Marks a message as signed\n@param _data Arbitrary length data that should be marked as signed on the behalf of address(this)",
  					id: 727,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 708,
  							modifierName: {
  								argumentTypes: null,
  								id: 707,
  								name: "authorized",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 2079,
  								src: "15421:10:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "15421:10:0"
  						}
  					],
  					name: "signMessage",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 706,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 705,
  								name: "_data",
  								nodeType: "VariableDeclaration",
  								scope: 727,
  								src: "15374:20:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 704,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "15374:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "15373:22:0"
  					},
  					returnParameters: {
  						id: 709,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "15436:0:0"
  					},
  					scope: 903,
  					src: "15353:207:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 767,
  						nodeType: "Block",
  						src: "16297:386:0",
  						statements: [
  							{
  								assignments: [
  									737
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 737,
  										name: "messageHash",
  										nodeType: "VariableDeclaration",
  										scope: 767,
  										src: "16307:19:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 736,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "16307:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 741,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 739,
  											name: "_data",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 729,
  											src: "16344:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										],
  										id: 738,
  										name: "getMessageHash",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 802,
  										src: "16329:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) view returns (bytes32)"
  										}
  									},
  									id: 740,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "16329:21:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "16307:43:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 745,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 742,
  											name: "_signature",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 731,
  											src: "16364:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										},
  										id: 743,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "16364:17:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 744,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "16385:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "16364:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: {
  									id: 763,
  									nodeType: "Block",
  									src: "16481:160:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 757,
  														name: "messageHash",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 737,
  														src: "16592:11:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 758,
  														name: "_data",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 729,
  														src: "16605:5:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 759,
  														name: "_signature",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 731,
  														src: "16612:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "66616c7365",
  														id: 760,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "bool",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "16624:5:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														value: "false"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														},
  														{
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														},
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													],
  													id: 756,
  													name: "checkSignatures",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 622,
  													src: "16576:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_bytes32_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$_t_bool_$returns$__$",
  														typeString: "function (bytes32,bytes memory,bytes memory,bool)"
  													}
  												},
  												id: 761,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16576:54:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 762,
  											nodeType: "ExpressionStatement",
  											src: "16576:54:0"
  										}
  									]
  								},
  								id: 764,
  								nodeType: "IfStatement",
  								src: "16360:281:0",
  								trueBody: {
  									id: 755,
  									nodeType: "Block",
  									src: "16388:87:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														id: 751,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															argumentTypes: null,
  															baseExpression: {
  																argumentTypes: null,
  																id: 747,
  																name: "signedMessages",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 71,
  																src: "16410:14:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  																	typeString: "mapping(bytes32 => uint256)"
  																}
  															},
  															id: 749,
  															indexExpression: {
  																argumentTypes: null,
  																id: 748,
  																name: "messageHash",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 737,
  																src: "16425:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bytes32",
  																	typeString: "bytes32"
  																}
  															},
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "IndexAccess",
  															src: "16410:27:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: "!=",
  														rightExpression: {
  															argumentTypes: null,
  															hexValue: "30",
  															id: 750,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "16441:1:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_0_by_1",
  																typeString: "int_const 0"
  															},
  															value: "0"
  														},
  														src: "16410:32:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "48617368206e6f7420617070726f766564",
  														id: 752,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "16444:19:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_fd8211c71ab965565e8a56b84284a02d17d4d89e6f05f14b26449d5de3a8c5b6",
  															typeString: "literal_string \"Hash not approved\""
  														},
  														value: "Hash not approved"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_fd8211c71ab965565e8a56b84284a02d17d4d89e6f05f14b26449d5de3a8c5b6",
  															typeString: "literal_string \"Hash not approved\""
  														}
  													],
  													id: 746,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "16402:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 753,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16402:62:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 754,
  											nodeType: "ExpressionStatement",
  											src: "16402:62:0"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 765,
  									name: "EIP1271_MAGIC_VALUE",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2426,
  									src: "16657:19:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes4",
  										typeString: "bytes4"
  									}
  								},
  								functionReturnParameters: 735,
  								id: 766,
  								nodeType: "Return",
  								src: "16650:26:0"
  							}
  						]
  					},
  					documentation: "Implementation of ISignatureValidator (see `interfaces/ISignatureValidator.sol`)\n@dev Should return whether the signature provided is valid for the provided data.\n      The save does not implement the interface since `checkSignatures` is not a view method.\n      The method will not perform any state changes (see parameters of `checkSignatures`)\n@param _data Arbitrary length data signed on the behalf of address(this)\n@param _signature Signature byte array associated with _data\n@return a bool upon valid or invalid signature with corresponding _data",
  					id: 768,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "isValidSignature",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 732,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 729,
  								name: "_data",
  								nodeType: "VariableDeclaration",
  								scope: 768,
  								src: "16202:20:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 728,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "16202:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 731,
  								name: "_signature",
  								nodeType: "VariableDeclaration",
  								scope: 768,
  								src: "16224:25:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 730,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "16224:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16201:49:0"
  					},
  					returnParameters: {
  						id: 735,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 734,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 768,
  								src: "16285:6:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes4",
  									typeString: "bytes4"
  								},
  								typeName: {
  									id: 733,
  									name: "bytes4",
  									nodeType: "ElementaryTypeName",
  									src: "16285:6:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes4",
  										typeString: "bytes4"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16284:8:0"
  					},
  					scope: 903,
  					src: "16176:507:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 801,
  						nodeType: "Block",
  						src: "16959:249:0",
  						statements: [
  							{
  								assignments: [
  									776
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 776,
  										name: "safeMessageHash",
  										nodeType: "VariableDeclaration",
  										scope: 801,
  										src: "16969:23:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 775,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "16969:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 786,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 780,
  													name: "SAFE_MSG_TYPEHASH",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 41,
  													src: "17029:17:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 782,
  															name: "message",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 770,
  															src: "17058:7:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														],
  														id: 781,
  														name: "keccak256",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5162,
  														src: "17048:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  															typeString: "function (bytes memory) pure returns (bytes32)"
  														}
  													},
  													id: 783,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "17048:18:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 778,
  													name: "abi",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5155,
  													src: "17018:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_abi",
  														typeString: "abi"
  													}
  												},
  												id: 779,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												memberName: "encode",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "17018:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
  													typeString: "function () pure returns (bytes memory)"
  												}
  											},
  											id: 784,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "17018:49:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 777,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "16995:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 785,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "16995:82:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "16969:108:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															hexValue: "30783139",
  															id: 791,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "17139:4:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_25_by_1",
  																typeString: "int_const 25"
  															},
  															value: "0x19"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_25_by_1",
  																typeString: "int_const 25"
  															}
  														],
  														id: 790,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "17134:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_bytes1_$",
  															typeString: "type(bytes1)"
  														},
  														typeName: "byte"
  													},
  													id: 792,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "17134:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															hexValue: "30783031",
  															id: 794,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "17151:4:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_1_by_1",
  																typeString: "int_const 1"
  															},
  															value: "0x01"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_1_by_1",
  																typeString: "int_const 1"
  															}
  														],
  														id: 793,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "17146:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_bytes1_$",
  															typeString: "type(bytes1)"
  														},
  														typeName: "byte"
  													},
  													id: 795,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "17146:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 796,
  													name: "domainSeparator",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 67,
  													src: "17158:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 797,
  													name: "safeMessageHash",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 776,
  													src: "17175:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													},
  													{
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 788,
  													name: "abi",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5155,
  													src: "17117:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_abi",
  														typeString: "abi"
  													}
  												},
  												id: 789,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												memberName: "encodePacked",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "17117:16:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  													typeString: "function () pure returns (bytes memory)"
  												}
  											},
  											id: 798,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "17117:74:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 787,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "17094:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 799,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "17094:107:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								functionReturnParameters: 774,
  								id: 800,
  								nodeType: "Return",
  								src: "17087:114:0"
  							}
  						]
  					},
  					documentation: "@dev Returns hash of a message that can be signed by owners.\n @param message Message that should be hashed\n @return Message hash.",
  					id: 802,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getMessageHash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 771,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 770,
  								name: "message",
  								nodeType: "VariableDeclaration",
  								scope: 802,
  								src: "16874:20:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 769,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "16874:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16864:36:0"
  					},
  					returnParameters: {
  						id: 774,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 773,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 802,
  								src: "16946:7:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 772,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "16946:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16945:9:0"
  					},
  					scope: 903,
  					src: "16841:367:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 860,
  						nodeType: "Block",
  						src: "18285:288:0",
  						statements: [
  							{
  								assignments: [
  									828
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 828,
  										name: "safeTxHash",
  										nodeType: "VariableDeclaration",
  										scope: 860,
  										src: "18295:18:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 827,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "18295:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 847,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 832,
  													name: "SAFE_TX_TYPEHASH",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 38,
  													src: "18350:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 833,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 804,
  													src: "18368:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 834,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 806,
  													src: "18372:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 836,
  															name: "data",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 808,
  															src: "18389:4:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														],
  														id: 835,
  														name: "keccak256",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5162,
  														src: "18379:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  															typeString: "function (bytes memory) pure returns (bytes32)"
  														}
  													},
  													id: 837,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "18379:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 838,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 810,
  													src: "18396:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 839,
  													name: "safeTxGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 812,
  													src: "18407:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 840,
  													name: "baseGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 814,
  													src: "18418:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 841,
  													name: "gasPrice",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 816,
  													src: "18427:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 842,
  													name: "gasToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 818,
  													src: "18437:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 843,
  													name: "refundReceiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 820,
  													src: "18447:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 844,
  													name: "_nonce",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 822,
  													src: "18463:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 830,
  													name: "abi",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5155,
  													src: "18339:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_abi",
  														typeString: "abi"
  													}
  												},
  												id: 831,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												memberName: "encode",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "18339:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
  													typeString: "function () pure returns (bytes memory)"
  												}
  											},
  											id: 845,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "18339:131:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 829,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "18316:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 846,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "18316:164:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "18295:185:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													hexValue: "30783139",
  													id: 851,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "18519:4:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_25_by_1",
  														typeString: "int_const 25"
  													},
  													value: "0x19"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_25_by_1",
  														typeString: "int_const 25"
  													}
  												],
  												id: 850,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "18514:4:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_bytes1_$",
  													typeString: "type(bytes1)"
  												},
  												typeName: "byte"
  											},
  											id: 852,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "18514:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											}
  										},
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													hexValue: "30783031",
  													id: 854,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "18531:4:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_1_by_1",
  														typeString: "int_const 1"
  													},
  													value: "0x01"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_1_by_1",
  														typeString: "int_const 1"
  													}
  												],
  												id: 853,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "18526:4:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_bytes1_$",
  													typeString: "type(bytes1)"
  												},
  												typeName: "byte"
  											},
  											id: 855,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "18526:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 856,
  											name: "domainSeparator",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 67,
  											src: "18538:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 857,
  											name: "safeTxHash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 828,
  											src: "18555:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											},
  											{
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											},
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											},
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 848,
  											name: "abi",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5155,
  											src: "18497:3:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_abi",
  												typeString: "abi"
  											}
  										},
  										id: 849,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										lValueRequested: false,
  										memberName: "encodePacked",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "18497:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  											typeString: "function () pure returns (bytes memory)"
  										}
  									},
  									id: 858,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "18497:69:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_memory_ptr",
  										typeString: "bytes memory"
  									}
  								},
  								functionReturnParameters: 826,
  								id: 859,
  								nodeType: "Return",
  								src: "18490:76:0"
  							}
  						]
  					},
  					documentation: "@dev Returns the bytes that are hashed to be signed by owners.\n @param to Destination address.\n @param value Ether value.\n @param data Data payload.\n @param operation Operation type.\n @param safeTxGas Fas that should be used for the safe transaction.\n @param baseGas Gas costs for data used to trigger the safe transaction.\n @param gasPrice Maximum gas price that should be used for this transaction.\n @param gasToken Token address (or 0 if ETH) that is used for the payment.\n @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n @param _nonce Transaction nonce.\n @return Transaction hash bytes.",
  					id: 861,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "encodeTransactionData",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 823,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 804,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "17961:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 803,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "17961:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 806,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "17981:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 805,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "17981:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 808,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18004:17:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 807,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "18004:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 810,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18031:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 809,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "18031:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 812,
  								name: "safeTxGas",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18065:17:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 811,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18065:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 814,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18092:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 813,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18092:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 816,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18117:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 815,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18117:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 818,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18143:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 817,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "18143:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 820,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18169:22:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 819,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "18169:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 822,
  								name: "_nonce",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18201:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 821,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18201:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "17951:270:0"
  					},
  					returnParameters: {
  						id: 826,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 825,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18267:12:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 824,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "18267:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "18266:14:0"
  					},
  					scope: 903,
  					src: "17921:652:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 901,
  						nodeType: "Block",
  						src: "19615:148:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 888,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 863,
  													src: "19664:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 889,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 865,
  													src: "19668:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 890,
  													name: "data",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 867,
  													src: "19675:4:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 891,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 869,
  													src: "19681:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 892,
  													name: "safeTxGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 871,
  													src: "19692:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 893,
  													name: "baseGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 873,
  													src: "19703:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 894,
  													name: "gasPrice",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 875,
  													src: "19712:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 895,
  													name: "gasToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 877,
  													src: "19722:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 896,
  													name: "refundReceiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 879,
  													src: "19732:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 897,
  													name: "_nonce",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 881,
  													src: "19748:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												id: 887,
  												name: "encodeTransactionData",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 861,
  												src: "19642:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_$_t_uint256_$returns$_t_bytes_memory_ptr_$",
  													typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256,uint256,uint256,address,address,uint256) view returns (bytes memory)"
  												}
  											},
  											id: 898,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "19642:113:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 886,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "19632:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 899,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "19632:124:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								functionReturnParameters: 885,
  								id: 900,
  								nodeType: "Return",
  								src: "19625:131:0"
  							}
  						]
  					},
  					documentation: "@dev Returns hash to be signed by owners.\n @param to Destination address.\n @param value Ether value.\n @param data Data payload.\n @param operation Operation type.\n @param safeTxGas Fas that should be used for the safe transaction.\n @param baseGas Gas costs for data used to trigger the safe transaction.\n @param gasPrice Maximum gas price that should be used for this transaction.\n @param gasToken Token address (or 0 if ETH) that is used for the payment.\n @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n @param _nonce Transaction nonce.\n @return Transaction hash.",
  					id: 902,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getTransactionHash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 882,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 863,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19296:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 862,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "19296:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 865,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19316:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 864,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19316:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 867,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19339:17:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 866,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "19339:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 869,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19366:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 868,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "19366:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 871,
  								name: "safeTxGas",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19400:17:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 870,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19400:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 873,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19427:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 872,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19427:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 875,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19452:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 874,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19452:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 877,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19478:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 876,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "19478:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 879,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19504:22:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 878,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "19504:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 881,
  								name: "_nonce",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19536:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 880,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19536:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "19286:270:0"
  					},
  					returnParameters: {
  						id: 885,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 884,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19602:7:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 883,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "19602:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "19601:9:0"
  					},
  					scope: 903,
  					src: "19259:504:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				}
  			],
  			scope: 904,
  			src: "652:19113:0"
  		}
  	],
  	src: "0:19766:0"
  };
  var legacyAST$2 = {
  	absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/GnosisSafe.sol",
  	exportedSymbols: {
  		GnosisSafe: [
  			903
  		]
  	},
  	id: 904,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1,
  			literals: [
  				"solidity",
  				">=",
  				"0.5",
  				".0",
  				"<",
  				"0.7",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:31:0"
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/base/ModuleManager.sol",
  			file: "./base/ModuleManager.sol",
  			id: 2,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 1519,
  			src: "32:34:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/base/OwnerManager.sol",
  			file: "./base/OwnerManager.sol",
  			id: 3,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 1989,
  			src: "67:33:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/base/FallbackManager.sol",
  			file: "./base/FallbackManager.sol",
  			id: 4,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 1107,
  			src: "101:36:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/common/MasterCopy.sol",
  			file: "./common/MasterCopy.sol",
  			id: 5,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2039,
  			src: "138:33:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/common/SignatureDecoder.sol",
  			file: "./common/SignatureDecoder.sol",
  			id: 6,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2137,
  			src: "172:39:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/common/SecuredTokenTransfer.sol",
  			file: "./common/SecuredTokenTransfer.sol",
  			id: 7,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2064,
  			src: "212:43:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/interfaces/ISignatureValidator.sol",
  			file: "./interfaces/ISignatureValidator.sol",
  			id: 8,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2440,
  			src: "256:46:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/media/000/Documents/Circles/safe-contracts/contracts/external/SafeMath.sol",
  			file: "./external/SafeMath.sol",
  			id: 9,
  			nodeType: "ImportDirective",
  			scope: 904,
  			sourceUnit: 2265,
  			src: "303:33:0",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 10,
  						name: "MasterCopy",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2038,
  						src: "679:10:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_MasterCopy_$2038",
  							typeString: "contract MasterCopy"
  						}
  					},
  					id: 11,
  					nodeType: "InheritanceSpecifier",
  					src: "679:10:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 12,
  						name: "ModuleManager",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1518,
  						src: "691:13:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ModuleManager_$1518",
  							typeString: "contract ModuleManager"
  						}
  					},
  					id: 13,
  					nodeType: "InheritanceSpecifier",
  					src: "691:13:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 14,
  						name: "OwnerManager",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1988,
  						src: "706:12:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_OwnerManager_$1988",
  							typeString: "contract OwnerManager"
  						}
  					},
  					id: 15,
  					nodeType: "InheritanceSpecifier",
  					src: "706:12:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 16,
  						name: "SignatureDecoder",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2136,
  						src: "720:16:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SignatureDecoder_$2136",
  							typeString: "contract SignatureDecoder"
  						}
  					},
  					id: 17,
  					nodeType: "InheritanceSpecifier",
  					src: "720:16:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 18,
  						name: "SecuredTokenTransfer",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2063,
  						src: "738:20:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SecuredTokenTransfer_$2063",
  							typeString: "contract SecuredTokenTransfer"
  						}
  					},
  					id: 19,
  					nodeType: "InheritanceSpecifier",
  					src: "738:20:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 20,
  						name: "ISignatureValidatorConstants",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2427,
  						src: "760:28:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ISignatureValidatorConstants_$2427",
  							typeString: "contract ISignatureValidatorConstants"
  						}
  					},
  					id: 21,
  					nodeType: "InheritanceSpecifier",
  					src: "760:28:0"
  				},
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 22,
  						name: "FallbackManager",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1106,
  						src: "790:15:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_FallbackManager_$1106",
  							typeString: "contract FallbackManager"
  						}
  					},
  					id: 23,
  					nodeType: "InheritanceSpecifier",
  					src: "790:15:0"
  				}
  			],
  			contractDependencies: [
  				1041,
  				1106,
  				1518,
  				1988,
  				2038,
  				2063,
  				2080,
  				2136,
  				2427
  			],
  			contractKind: "contract",
  			documentation: "@title Gnosis Safe - A multisignature wallet with support for confirmations using signed messages based on ERC191.\n @author Stefan George - <stefan@gnosis.io>\n @author Richard Meissner - <richard@gnosis.io>\n @author Ricardo Guilherme Schmidt - (Status Research & Development GmbH) - Gas Token Payment",
  			fullyImplemented: true,
  			id: 903,
  			linearizedBaseContracts: [
  				903,
  				1106,
  				2427,
  				2063,
  				2136,
  				1988,
  				1518,
  				1041,
  				2038,
  				2080
  			],
  			name: "GnosisSafe",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 26,
  					libraryName: {
  						contractScope: null,
  						id: 24,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2264,
  						src: "819:8:0",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$2264",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "813:27:0",
  					typeName: {
  						id: 25,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "832:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: true,
  					id: 29,
  					name: "NAME",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "846:43:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_memory",
  						typeString: "string"
  					},
  					typeName: {
  						id: 27,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "846:6:0",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "476e6f7369732053616665",
  						id: 28,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "string",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "876:13:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_stringliteral_72ec6775392f699e8ffd72b7c600556d49bdc746bf22bce93d3ae6019cdaff63",
  							typeString: "literal_string \"Gnosis Safe\""
  						},
  						value: "Gnosis Safe"
  					},
  					visibility: "public"
  				},
  				{
  					constant: true,
  					id: 32,
  					name: "VERSION",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "895:40:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_memory",
  						typeString: "string"
  					},
  					typeName: {
  						id: 30,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "895:6:0",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "312e312e31",
  						id: 31,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "string",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "928:7:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_stringliteral_9dd6d964e72a376a8989d1d2720ab48ff4f2ad77466fb517dabc84f4a79478d4",
  							typeString: "literal_string \"1.1.1\""
  						},
  						value: "1.1.1"
  					},
  					visibility: "public"
  				},
  				{
  					constant: true,
  					id: 35,
  					name: "DOMAIN_SEPARATOR_TYPEHASH",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1020:119:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 33,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1020:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "307830333561666638336438363933376433356233326530346630646463366666343639323930656566326631623639326438613831356338393430346434373439",
  						id: 34,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "1073:66:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_1517718281442037948617199096126532355110765202990829672390711201829802035017_by_1",
  							typeString: "int_const 1517...(68 digits omitted)...5017"
  						},
  						value: "0x035aff83d86937d35b32e04f0ddc6ff469290eef2f1b692d8a815c89404d4749"
  					},
  					visibility: "private"
  				},
  				{
  					constant: true,
  					id: 38,
  					name: "SAFE_TX_TYPEHASH",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1349:110:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 36,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1349:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "307862623833313064343836333638646236626436663834393430326664643733616435336433313662356134623236343461643665666530663934313238366438",
  						id: 37,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "1393:66:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_84814075808141314178395468817534025465894426928601295766380145544921651250904_by_1",
  							typeString: "int_const 8481...(69 digits omitted)...0904"
  						},
  						value: "0xbb8310d486368db6bd6f849402fdd73ad53d316b5a4b2644ad6efe0f941286d8"
  					},
  					visibility: "private"
  				},
  				{
  					constant: true,
  					id: 41,
  					name: "SAFE_MSG_TYPEHASH",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1531:111:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 39,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1531:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "307836306233636266386234613232336436386436343162336236646466396132393865376633333731306366336433613964313134366235613631353066626361",
  						id: 40,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "1576:66:0",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_43739706848186989041152069077571617734008543096732098246335109361212071148490_by_1",
  							typeString: "int_const 4373...(69 digits omitted)...8490"
  						},
  						value: "0x60b3cbf8b4a223d68d641b3b6ddf9a298e7f33710cf3d3a9d1146b5a6150fbca"
  					},
  					visibility: "private"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 47,
  					name: "ApproveHash",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 46,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 43,
  								indexed: true,
  								name: "approvedHash",
  								nodeType: "VariableDeclaration",
  								scope: 47,
  								src: "1676:28:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 42,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1676:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 45,
  								indexed: true,
  								name: "owner",
  								nodeType: "VariableDeclaration",
  								scope: 47,
  								src: "1714:21:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 44,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1714:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1666:75:0"
  					},
  					src: "1649:93:0"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 51,
  					name: "SignMsg",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 50,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 49,
  								indexed: true,
  								name: "msgHash",
  								nodeType: "VariableDeclaration",
  								scope: 51,
  								src: "1770:23:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 48,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1770:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1760:39:0"
  					},
  					src: "1747:53:0"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 57,
  					name: "ExecutionFailure",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 56,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 53,
  								indexed: false,
  								name: "txHash",
  								nodeType: "VariableDeclaration",
  								scope: 57,
  								src: "1837:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 52,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1837:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 55,
  								indexed: false,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 57,
  								src: "1853:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 54,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1853:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1827:47:0"
  					},
  					src: "1805:70:0"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 63,
  					name: "ExecutionSuccess",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 62,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 59,
  								indexed: false,
  								name: "txHash",
  								nodeType: "VariableDeclaration",
  								scope: 63,
  								src: "1912:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 58,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "1912:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 61,
  								indexed: false,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 63,
  								src: "1928:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 60,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1928:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1902:47:0"
  					},
  					src: "1880:70:0"
  				},
  				{
  					constant: false,
  					id: 65,
  					name: "nonce",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1956:20:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 64,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "1956:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 67,
  					name: "domainSeparator",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "1982:30:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bytes32",
  						typeString: "bytes32"
  					},
  					typeName: {
  						id: 66,
  						name: "bytes32",
  						nodeType: "ElementaryTypeName",
  						src: "1982:7:0",
  						typeDescriptions: {
  							typeIdentifier: "t_bytes32",
  							typeString: "bytes32"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 71,
  					name: "signedMessages",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "2115:49:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  						typeString: "mapping(bytes32 => uint256)"
  					},
  					typeName: {
  						id: 70,
  						keyType: {
  							id: 68,
  							name: "bytes32",
  							nodeType: "ElementaryTypeName",
  							src: "2123:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_bytes32",
  								typeString: "bytes32"
  							}
  						},
  						nodeType: "Mapping",
  						src: "2115:27:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  							typeString: "mapping(bytes32 => uint256)"
  						},
  						valueType: {
  							id: 69,
  							name: "uint256",
  							nodeType: "ElementaryTypeName",
  							src: "2134:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 77,
  					name: "approvedHashes",
  					nodeType: "VariableDeclaration",
  					scope: 903,
  					src: "2275:69:0",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  						typeString: "mapping(address => mapping(bytes32 => uint256))"
  					},
  					typeName: {
  						id: 76,
  						keyType: {
  							id: 72,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "2283:7:0",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "2275:47:0",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  							typeString: "mapping(address => mapping(bytes32 => uint256))"
  						},
  						valueType: {
  							id: 75,
  							keyType: {
  								id: 73,
  								name: "bytes32",
  								nodeType: "ElementaryTypeName",
  								src: "2302:7:0",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								}
  							},
  							nodeType: "Mapping",
  							src: "2294:27:0",
  							typeDescriptions: {
  								typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  								typeString: "mapping(bytes32 => uint256)"
  							},
  							valueType: {
  								id: 74,
  								name: "uint256",
  								nodeType: "ElementaryTypeName",
  								src: "2313:7:0",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							}
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 84,
  						nodeType: "Block",
  						src: "2477:234:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 82,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 80,
  										name: "threshold",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1548,
  										src: "2691:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "31",
  										id: 81,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2703:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "2691:13:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 83,
  								nodeType: "ExpressionStatement",
  								src: "2691:13:0"
  							}
  						]
  					},
  					documentation: null,
  					id: 85,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 78,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2467:2:0"
  					},
  					returnParameters: {
  						id: 79,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2477:0:0"
  					},
  					scope: 903,
  					src: "2456:255:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 155,
  						nodeType: "Block",
  						src: "3611:838:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											},
  											id: 108,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 106,
  												name: "domainSeparator",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 67,
  												src: "3629:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes32",
  													typeString: "bytes32"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 107,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3648:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "3629:20:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "446f6d61696e20536570617261746f7220616c72656164792073657421",
  											id: 109,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "3651:31:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_a2e1f2db9cd32eaa6a2caa3d6caa726a30dc0417d866440bfe13d6a6d030e5e2",
  												typeString: "literal_string \"Domain Separator already set!\""
  											},
  											value: "Domain Separator already set!"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_a2e1f2db9cd32eaa6a2caa3d6caa726a30dc0417d866440bfe13d6a6d030e5e2",
  												typeString: "literal_string \"Domain Separator already set!\""
  											}
  										],
  										id: 105,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "3621:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 110,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3621:62:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 111,
  								nodeType: "ExpressionStatement",
  								src: "3621:62:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 120,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 112,
  										name: "domainSeparator",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 67,
  										src: "3693:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 116,
  														name: "DOMAIN_SEPARATOR_TYPEHASH",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 35,
  														src: "3732:25:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 117,
  														name: "this",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5208,
  														src: "3759:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_GnosisSafe_$903",
  															typeString: "contract GnosisSafe"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_contract$_GnosisSafe_$903",
  															typeString: "contract GnosisSafe"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 114,
  														name: "abi",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5155,
  														src: "3721:3:0",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_abi",
  															typeString: "abi"
  														}
  													},
  													id: 115,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													memberName: "encode",
  													nodeType: "MemberAccess",
  													referencedDeclaration: null,
  													src: "3721:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
  														typeString: "function () pure returns (bytes memory)"
  													}
  												},
  												id: 118,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "3721:43:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes_memory_ptr",
  													typeString: "bytes memory"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_bytes_memory_ptr",
  													typeString: "bytes memory"
  												}
  											],
  											id: 113,
  											name: "keccak256",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5162,
  											src: "3711:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  												typeString: "function (bytes memory) pure returns (bytes32)"
  											}
  										},
  										id: 119,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3711:54:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										}
  									},
  									src: "3693:72:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								id: 121,
  								nodeType: "ExpressionStatement",
  								src: "3693:72:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 123,
  											name: "_owners",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 88,
  											src: "3787:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_calldata_ptr",
  												typeString: "address[] calldata"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 124,
  											name: "_threshold",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 90,
  											src: "3796:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_array$_t_address_$dyn_calldata_ptr",
  												typeString: "address[] calldata"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 122,
  										name: "setupOwners",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1655,
  										src: "3775:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_array$_t_address_$dyn_memory_ptr_$_t_uint256_$returns$__$",
  											typeString: "function (address[] memory,uint256)"
  										}
  									},
  									id: 125,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3775:32:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 126,
  								nodeType: "ExpressionStatement",
  								src: "3775:32:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									},
  									id: 131,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 127,
  										name: "fallbackHandler",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 96,
  										src: "3821:15:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "!=",
  									rightExpression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												hexValue: "30",
  												id: 129,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "3848:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												}
  											],
  											id: 128,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "3840:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: "address"
  										},
  										id: 130,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3840:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "3821:29:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 136,
  								nodeType: "IfStatement",
  								src: "3817:78:0",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 133,
  												name: "fallbackHandler",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 96,
  												src: "3879:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 132,
  											name: "internalSetFallbackHandler",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1060,
  											src: "3852:26:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$returns$__$",
  												typeString: "function (address)"
  											}
  										},
  										id: 134,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3852:43:0",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 135,
  									nodeType: "ExpressionStatement",
  									src: "3852:43:0"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 138,
  											name: "to",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 92,
  											src: "4043:2:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 139,
  											name: "data",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 94,
  											src: "4047:4:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										],
  										id: 137,
  										name: "setupModules",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1227,
  										src: "4030:12:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_bytes_memory_ptr_$returns$__$",
  											typeString: "function (address,bytes memory)"
  										}
  									},
  									id: 140,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4030:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 141,
  								nodeType: "ExpressionStatement",
  								src: "4030:22:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 144,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 142,
  										name: "payment",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 100,
  										src: "4067:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 143,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "4077:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "4067:11:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 154,
  								nodeType: "IfStatement",
  								src: "4063:380:0",
  								trueBody: {
  									id: 153,
  									nodeType: "Block",
  									src: "4080:363:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 146,
  														name: "payment",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 100,
  														src: "4387:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "30",
  														id: 147,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "4396:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													},
  													{
  														argumentTypes: null,
  														hexValue: "31",
  														id: 148,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "4399:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_1_by_1",
  															typeString: "int_const 1"
  														},
  														value: "1"
  													},
  													{
  														argumentTypes: null,
  														id: 149,
  														name: "paymentToken",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 98,
  														src: "4402:12:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 150,
  														name: "paymentReceiver",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 102,
  														src: "4416:15:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														{
  															typeIdentifier: "t_rational_1_by_1",
  															typeString: "int_const 1"
  														},
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													],
  													id: 145,
  													name: "handlePayment",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 370,
  													src: "4373:13:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_payable_$returns$_t_uint256_$",
  														typeString: "function (uint256,uint256,uint256,address,address payable) returns (uint256)"
  													}
  												},
  												id: 151,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "4373:59:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 152,
  											nodeType: "ExpressionStatement",
  											src: "4373:59:0"
  										}
  									]
  								}
  							}
  						]
  					},
  					documentation: "@dev Setup function sets initial storage of contract.\n @param _owners List of Safe owners.\n @param _threshold Number of required confirmations for a Safe transaction.\n @param to Contract address for optional delegate call.\n @param data Data payload for optional delegate call.\n @param fallbackHandler Handler for fallback calls to this contract\n @param paymentToken Token that should be used for the payment (0 is ETH)\n @param payment Value that should be paid\n @param paymentReceiver Adddress that should receive the payment (or 0 if tx.origin)",
  					id: 156,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "setup",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 103,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 88,
  								name: "_owners",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3351:26:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_array$_t_address_$dyn_calldata_ptr",
  									typeString: "address[]"
  								},
  								typeName: {
  									baseType: {
  										id: 86,
  										name: "address",
  										nodeType: "ElementaryTypeName",
  										src: "3351:7:0",
  										stateMutability: "nonpayable",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									id: 87,
  									length: null,
  									nodeType: "ArrayTypeName",
  									src: "3351:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  										typeString: "address[]"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 90,
  								name: "_threshold",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3387:18:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 89,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3387:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 92,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3415:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 91,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3415:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 94,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3435:19:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 93,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "3435:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 96,
  								name: "fallbackHandler",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3464:23:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 95,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3464:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 98,
  								name: "paymentToken",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3497:20:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 97,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3497:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 100,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3527:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 99,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3527:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 102,
  								name: "paymentReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 156,
  								src: "3552:31:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address_payable",
  									typeString: "address payable"
  								},
  								typeName: {
  									id: 101,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3552:15:0",
  									stateMutability: "payable",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3341:248:0"
  					},
  					returnParameters: {
  						id: 104,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3611:0:0"
  					},
  					scope: 903,
  					src: "3327:1122:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 289,
  						nodeType: "Block",
  						src: "5847:1518:0",
  						statements: [
  							{
  								assignments: [
  									182
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 182,
  										name: "txHash",
  										nodeType: "VariableDeclaration",
  										scope: 289,
  										src: "5857:14:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 181,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "5857:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 183,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "5857:14:0"
  							},
  							{
  								id: 215,
  								nodeType: "Block",
  								src: "5970:448:0",
  								statements: [
  									{
  										assignments: [
  											185
  										],
  										declarations: [
  											{
  												constant: false,
  												id: 185,
  												name: "txHashData",
  												nodeType: "VariableDeclaration",
  												scope: 215,
  												src: "5984:23:0",
  												stateVariable: false,
  												storageLocation: "memory",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes_memory_ptr",
  													typeString: "bytes"
  												},
  												typeName: {
  													id: 184,
  													name: "bytes",
  													nodeType: "ElementaryTypeName",
  													src: "5984:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_storage_ptr",
  														typeString: "bytes"
  													}
  												},
  												value: null,
  												visibility: "internal"
  											}
  										],
  										id: 198,
  										initialValue: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 187,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 158,
  													src: "6049:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 188,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 160,
  													src: "6053:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 189,
  													name: "data",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 162,
  													src: "6060:4:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 190,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 164,
  													src: "6066:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 191,
  													name: "safeTxGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 166,
  													src: "6113:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 192,
  													name: "baseGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 168,
  													src: "6124:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 193,
  													name: "gasPrice",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 170,
  													src: "6133:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 194,
  													name: "gasToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 172,
  													src: "6143:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 195,
  													name: "refundReceiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 174,
  													src: "6153:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 196,
  													name: "nonce",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 65,
  													src: "6201:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												id: 186,
  												name: "encodeTransactionData",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 861,
  												src: "6010:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_$_t_uint256_$returns$_t_bytes_memory_ptr_$",
  													typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256,uint256,uint256,address,address,uint256) view returns (bytes memory)"
  												}
  											},
  											id: 197,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6010:210:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										},
  										nodeType: "VariableDeclarationStatement",
  										src: "5984:236:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 200,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "UnaryOperation",
  											operator: "++",
  											prefix: false,
  											src: "6289:7:0",
  											subExpression: {
  												argumentTypes: null,
  												id: 199,
  												name: "nonce",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 65,
  												src: "6289:5:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 201,
  										nodeType: "ExpressionStatement",
  										src: "6289:7:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 206,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftHandSide: {
  												argumentTypes: null,
  												id: 202,
  												name: "txHash",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 182,
  												src: "6310:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes32",
  													typeString: "bytes32"
  												}
  											},
  											nodeType: "Assignment",
  											operator: "=",
  											rightHandSide: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 204,
  														name: "txHashData",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 185,
  														src: "6329:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_memory_ptr",
  															typeString: "bytes memory"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes_memory_ptr",
  															typeString: "bytes memory"
  														}
  													],
  													id: 203,
  													name: "keccak256",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5162,
  													src: "6319:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  														typeString: "function (bytes memory) pure returns (bytes32)"
  													}
  												},
  												id: 205,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6319:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bytes32",
  													typeString: "bytes32"
  												}
  											},
  											src: "6310:30:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										id: 207,
  										nodeType: "ExpressionStatement",
  										src: "6310:30:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 209,
  													name: "txHash",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 182,
  													src: "6370:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 210,
  													name: "txHashData",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 185,
  													src: "6378:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 211,
  													name: "signatures",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 176,
  													src: "6390:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													}
  												},
  												{
  													argumentTypes: null,
  													hexValue: "74727565",
  													id: 212,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "bool",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "6402:4:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													},
  													value: "true"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													},
  													{
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													},
  													{
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													}
  												],
  												id: 208,
  												name: "checkSignatures",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 622,
  												src: "6354:15:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_nonpayable$_t_bytes32_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$_t_bool_$returns$__$",
  													typeString: "function (bytes32,bytes memory,bytes memory,bool)"
  												}
  											},
  											id: 213,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6354:53:0",
  											typeDescriptions: {
  												typeIdentifier: "t_tuple$__$",
  												typeString: "tuple()"
  											}
  										},
  										id: 214,
  										nodeType: "ExpressionStatement",
  										src: "6354:53:0"
  									}
  								]
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 220,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  												],
  												expression: {
  													argumentTypes: [
  													],
  													id: 217,
  													name: "gasleft",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5161,
  													src: "6435:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  														typeString: "function () view returns (uint256)"
  													}
  												},
  												id: 218,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6435:9:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 219,
  												name: "safeTxGas",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 166,
  												src: "6448:9:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6435:22:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f7420656e6f7567682067617320746f20657865637574652073616665207472616e73616374696f6e",
  											id: 221,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6459:44:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_e7ccb05a0f2c66d12451cdfc6bbab488c38ab704d0f6af9ad18763542e9e5f18",
  												typeString: "literal_string \"Not enough gas to execute safe transaction\""
  											},
  											value: "Not enough gas to execute safe transaction"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_e7ccb05a0f2c66d12451cdfc6bbab488c38ab704d0f6af9ad18763542e9e5f18",
  												typeString: "literal_string \"Not enough gas to execute safe transaction\""
  											}
  										],
  										id: 216,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "6427:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 222,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6427:77:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 223,
  								nodeType: "ExpressionStatement",
  								src: "6427:77:0"
  							},
  							{
  								id: 288,
  								nodeType: "Block",
  								src: "6603:756:0",
  								statements: [
  									{
  										assignments: [
  											225
  										],
  										declarations: [
  											{
  												constant: false,
  												id: 225,
  												name: "gasUsed",
  												nodeType: "VariableDeclaration",
  												scope: 288,
  												src: "6617:15:0",
  												stateVariable: false,
  												storageLocation: "default",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												typeName: {
  													id: 224,
  													name: "uint256",
  													nodeType: "ElementaryTypeName",
  													src: "6617:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												value: null,
  												visibility: "internal"
  											}
  										],
  										id: 228,
  										initialValue: {
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 226,
  												name: "gasleft",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 5161,
  												src: "6635:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 227,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6635:9:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "VariableDeclarationStatement",
  										src: "6617:27:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 247,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftHandSide: {
  												argumentTypes: null,
  												id: 229,
  												name: "success",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 179,
  												src: "6769:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											nodeType: "Assignment",
  											operator: "=",
  											rightHandSide: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 231,
  														name: "to",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 158,
  														src: "6787:2:0",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 232,
  														name: "value",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 160,
  														src: "6791:5:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 233,
  														name: "data",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 162,
  														src: "6798:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 234,
  														name: "operation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 164,
  														src: "6804:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_enum$_Operation_$1993",
  															typeString: "enum Enum.Operation"
  														}
  													},
  													{
  														argumentTypes: null,
  														condition: {
  															argumentTypes: null,
  															commonType: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															id: 241,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																id: 237,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 235,
  																	name: "safeTxGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 166,
  																	src: "6815:9:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "==",
  																rightExpression: {
  																	argumentTypes: null,
  																	hexValue: "30",
  																	id: 236,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "number",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "6828:1:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_rational_0_by_1",
  																		typeString: "int_const 0"
  																	},
  																	value: "0"
  																},
  																src: "6815:14:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "&&",
  															rightExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																id: 240,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 238,
  																	name: "gasPrice",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 170,
  																	src: "6833:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "==",
  																rightExpression: {
  																	argumentTypes: null,
  																	hexValue: "30",
  																	id: 239,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "number",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "6845:1:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_rational_0_by_1",
  																		typeString: "int_const 0"
  																	},
  																	value: "0"
  																},
  																src: "6833:13:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															src: "6815:31:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														falseExpression: {
  															argumentTypes: null,
  															id: 244,
  															name: "safeTxGas",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 166,
  															src: "6861:9:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 245,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "Conditional",
  														src: "6815:55:0",
  														trueExpression: {
  															argumentTypes: null,
  															"arguments": [
  															],
  															expression: {
  																argumentTypes: [
  																],
  																id: 242,
  																name: "gasleft",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 5161,
  																src: "6849:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  																	typeString: "function () view returns (uint256)"
  																}
  															},
  															id: 243,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "6849:9:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														{
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														},
  														{
  															typeIdentifier: "t_enum$_Operation_$1993",
  															typeString: "enum Enum.Operation"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 230,
  													name: "execute",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1012,
  													src: "6779:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$returns$_t_bool_$",
  														typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256) returns (bool)"
  													}
  												},
  												id: 246,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6779:92:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											src: "6769:102:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										id: 248,
  										nodeType: "ExpressionStatement",
  										src: "6769:102:0"
  									},
  									{
  										expression: {
  											argumentTypes: null,
  											id: 255,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftHandSide: {
  												argumentTypes: null,
  												id: 249,
  												name: "gasUsed",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 225,
  												src: "6885:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "Assignment",
  											operator: "=",
  											rightHandSide: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  														],
  														expression: {
  															argumentTypes: [
  															],
  															id: 252,
  															name: "gasleft",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 5161,
  															src: "6907:7:0",
  															typeDescriptions: {
  																typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  																typeString: "function () view returns (uint256)"
  															}
  														},
  														id: 253,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6907:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 250,
  														name: "gasUsed",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 225,
  														src: "6895:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 251,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sub",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2219,
  													src: "6895:11:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 254,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6895:22:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6885:32:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 256,
  										nodeType: "ExpressionStatement",
  										src: "6885:32:0"
  									},
  									{
  										assignments: [
  											258
  										],
  										declarations: [
  											{
  												constant: false,
  												id: 258,
  												name: "payment",
  												nodeType: "VariableDeclaration",
  												scope: 288,
  												src: "7066:15:0",
  												stateVariable: false,
  												storageLocation: "default",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												typeName: {
  													id: 257,
  													name: "uint256",
  													nodeType: "ElementaryTypeName",
  													src: "7066:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												value: null,
  												visibility: "internal"
  											}
  										],
  										id: 260,
  										initialValue: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 259,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "7084:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										nodeType: "VariableDeclarationStatement",
  										src: "7066:19:0"
  									},
  									{
  										condition: {
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 263,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 261,
  												name: "gasPrice",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 170,
  												src: "7103:8:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 262,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "7114:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "7103:12:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										falseBody: null,
  										id: 275,
  										nodeType: "IfStatement",
  										src: "7099:128:0",
  										trueBody: {
  											id: 274,
  											nodeType: "Block",
  											src: "7117:110:0",
  											statements: [
  												{
  													expression: {
  														argumentTypes: null,
  														id: 272,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftHandSide: {
  															argumentTypes: null,
  															id: 264,
  															name: "payment",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 258,
  															src: "7135:7:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														nodeType: "Assignment",
  														operator: "=",
  														rightHandSide: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 266,
  																	name: "gasUsed",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 225,
  																	src: "7159:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 267,
  																	name: "baseGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 168,
  																	src: "7168:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 268,
  																	name: "gasPrice",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 170,
  																	src: "7177:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 269,
  																	name: "gasToken",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 172,
  																	src: "7187:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	id: 270,
  																	name: "refundReceiver",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 174,
  																	src: "7197:14:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	{
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	{
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																],
  																id: 265,
  																name: "handlePayment",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 370,
  																src: "7145:13:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_payable_$returns$_t_uint256_$",
  																	typeString: "function (uint256,uint256,uint256,address,address payable) returns (uint256)"
  																}
  															},
  															id: 271,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "7145:67:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														src: "7135:77:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 273,
  													nodeType: "ExpressionStatement",
  													src: "7135:77:0"
  												}
  											]
  										}
  									},
  									{
  										condition: {
  											argumentTypes: null,
  											id: 276,
  											name: "success",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 179,
  											src: "7244:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										falseBody: {
  											eventCall: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 283,
  														name: "txHash",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 182,
  														src: "7332:6:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 284,
  														name: "payment",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 258,
  														src: "7340:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 282,
  													name: "ExecutionFailure",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 57,
  													src: "7315:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$_t_uint256_$returns$__$",
  														typeString: "function (bytes32,uint256)"
  													}
  												},
  												id: 285,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7315:33:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 286,
  											nodeType: "EmitStatement",
  											src: "7310:38:0"
  										},
  										id: 287,
  										nodeType: "IfStatement",
  										src: "7240:108:0",
  										trueBody: {
  											eventCall: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 278,
  														name: "txHash",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 182,
  														src: "7275:6:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 279,
  														name: "payment",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 258,
  														src: "7283:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 277,
  													name: "ExecutionSuccess",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 63,
  													src: "7258:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$_t_uint256_$returns$__$",
  														typeString: "function (bytes32,uint256)"
  													}
  												},
  												id: 280,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7258:33:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 281,
  											nodeType: "EmitStatement",
  											src: "7253:38:0"
  										}
  									}
  								]
  							}
  						]
  					},
  					documentation: "@dev Allows to execute a Safe transaction confirmed by required number of owners and then pays the account that submitted the transaction.\n      Note: The fees are always transfered, even if the user transaction fails.\n @param to Destination address of Safe transaction.\n @param value Ether value of Safe transaction.\n @param data Data payload of Safe transaction.\n @param operation Operation type of Safe transaction.\n @param safeTxGas Gas that should be used for the Safe transaction.\n @param baseGas Gas costs for that are indipendent of the transaction execution(e.g. base transaction fee, signature check, payment of the refund)\n @param gasPrice Gas price that should be used for the payment calculation.\n @param gasToken Token address (or 0 if ETH) that is used for the payment.\n @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n @param signatures Packed signature data ({bytes32 r}{bytes32 s}{uint8 v})",
  					id: 290,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "execTransaction",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 177,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 158,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5513:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 157,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5513:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 160,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5533:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 159,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5533:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 162,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5556:19:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 161,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "5556:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 164,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5585:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 163,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "5585:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 166,
  								name: "safeTxGas",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5619:17:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 165,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5619:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 168,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5646:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 167,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5646:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 170,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5671:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 169,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "5671:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 172,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5697:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 171,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5697:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 174,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5723:30:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address_payable",
  									typeString: "address payable"
  								},
  								typeName: {
  									id: 173,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5723:15:0",
  									stateMutability: "payable",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 176,
  								name: "signatures",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5763:25:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 175,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "5763:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "5503:291:0"
  					},
  					returnParameters: {
  						id: 180,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 179,
  								name: "success",
  								nodeType: "VariableDeclaration",
  								scope: 290,
  								src: "5829:12:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 178,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "5829:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "5828:14:0"
  					},
  					scope: 903,
  					src: "5479:1886:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 369,
  						nodeType: "Block",
  						src: "7596:727:0",
  						statements: [
  							{
  								assignments: [
  									306
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 306,
  										name: "receiver",
  										nodeType: "VariableDeclaration",
  										scope: 369,
  										src: "7664:24:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										},
  										typeName: {
  											id: 305,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "7664:15:0",
  											stateMutability: "payable",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 316,
  								initialValue: {
  									argumentTypes: null,
  									condition: {
  										argumentTypes: null,
  										commonType: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										},
  										id: 311,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											argumentTypes: null,
  											id: 307,
  											name: "refundReceiver",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 300,
  											src: "7691:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													hexValue: "30",
  													id: 309,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "7717:1:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													},
  													value: "0"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													}
  												],
  												id: 308,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "7709:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 310,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "7709:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										src: "7691:28:0",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									falseExpression: {
  										argumentTypes: null,
  										id: 314,
  										name: "refundReceiver",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 300,
  										src: "7734:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									id: 315,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "Conditional",
  									src: "7691:57:0",
  									trueExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 312,
  											name: "tx",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5180,
  											src: "7722:2:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_transaction",
  												typeString: "tx"
  											}
  										},
  										id: 313,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "origin",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "7722:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7664:84:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									},
  									id: 321,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 317,
  										name: "gasToken",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 298,
  										src: "7762:8:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												hexValue: "30",
  												id: 319,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "7782:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												}
  											],
  											id: 318,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "7774:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: "address"
  										},
  										id: 320,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7774:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "7762:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: {
  									id: 367,
  									nodeType: "Block",
  									src: "8145:172:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 356,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 348,
  													name: "payment",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 303,
  													src: "8159:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 354,
  															name: "gasPrice",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 296,
  															src: "8194:8:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 351,
  																	name: "baseGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 294,
  																	src: "8181:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	id: 349,
  																	name: "gasUsed",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 292,
  																	src: "8169:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 350,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "add",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2243,
  																src: "8169:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 352,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "8169:20:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 353,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2171,
  														src: "8169:24:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 355,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "8169:34:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "8159:44:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 357,
  											nodeType: "ExpressionStatement",
  											src: "8159:44:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 360,
  																name: "gasToken",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 298,
  																src: "8239:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															{
  																argumentTypes: null,
  																id: 361,
  																name: "receiver",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 306,
  																src: "8249:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															{
  																argumentTypes: null,
  																id: 362,
  																name: "payment",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 303,
  																src: "8259:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																{
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																},
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															id: 359,
  															name: "transferToken",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2062,
  															src: "8225:13:0",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  																typeString: "function (address,address,uint256) returns (bool)"
  															}
  														},
  														id: 363,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "8225:42:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "436f756c64206e6f74207061792067617320636f737473207769746820746f6b656e",
  														id: 364,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "8269:36:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_8560a13547eca5648355c8db1a9f8653b6f657d31d476c36bca25e47b45b08f4",
  															typeString: "literal_string \"Could not pay gas costs with token\""
  														},
  														value: "Could not pay gas costs with token"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_8560a13547eca5648355c8db1a9f8653b6f657d31d476c36bca25e47b45b08f4",
  															typeString: "literal_string \"Could not pay gas costs with token\""
  														}
  													],
  													id: 358,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "8217:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 365,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "8217:89:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 366,
  											nodeType: "ExpressionStatement",
  											src: "8217:89:0"
  										}
  									]
  								},
  								id: 368,
  								nodeType: "IfStatement",
  								src: "7758:559:0",
  								trueBody: {
  									id: 347,
  									nodeType: "Block",
  									src: "7786:353:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 337,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 322,
  													name: "payment",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 303,
  													src: "7905:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															condition: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																id: 331,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 328,
  																	name: "gasPrice",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 296,
  																	src: "7940:8:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "<",
  																rightExpression: {
  																	argumentTypes: null,
  																	expression: {
  																		argumentTypes: null,
  																		id: 329,
  																		name: "tx",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 5180,
  																		src: "7951:2:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_magic_transaction",
  																			typeString: "tx"
  																		}
  																	},
  																	id: 330,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "gasprice",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: null,
  																	src: "7951:11:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																src: "7940:22:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															falseExpression: {
  																argumentTypes: null,
  																expression: {
  																	argumentTypes: null,
  																	id: 333,
  																	name: "tx",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 5180,
  																	src: "7976:2:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_magic_transaction",
  																		typeString: "tx"
  																	}
  																},
  																id: 334,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "gasprice",
  																nodeType: "MemberAccess",
  																referencedDeclaration: null,
  																src: "7976:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 335,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "Conditional",
  															src: "7940:47:0",
  															trueExpression: {
  																argumentTypes: null,
  																id: 332,
  																name: "gasPrice",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 296,
  																src: "7965:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	id: 325,
  																	name: "baseGas",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 294,
  																	src: "7927:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	argumentTypes: null,
  																	id: 323,
  																	name: "gasUsed",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 292,
  																	src: "7915:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 324,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "add",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 2243,
  																src: "7915:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 326,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "7915:20:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 327,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2171,
  														src: "7915:24:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 336,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "7915:73:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "7905:83:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 338,
  											nodeType: "ExpressionStatement",
  											src: "7905:83:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 342,
  																name: "payment",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 303,
  																src: "8081:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 340,
  																name: "receiver",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 306,
  																src: "8067:8:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															id: 341,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "send",
  															nodeType: "MemberAccess",
  															referencedDeclaration: null,
  															src: "8067:13:0",
  															typeDescriptions: {
  																typeIdentifier: "t_function_send_nonpayable$_t_uint256_$returns$_t_bool_$",
  																typeString: "function (uint256) returns (bool)"
  															}
  														},
  														id: 343,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "8067:22:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "436f756c64206e6f74207061792067617320636f7374732077697468206574686572",
  														id: 344,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "8091:36:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_e2a11e15f7be1214c1340779ad55027af8aa33aee6cb521776a28a0a44aea377",
  															typeString: "literal_string \"Could not pay gas costs with ether\""
  														},
  														value: "Could not pay gas costs with ether"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_e2a11e15f7be1214c1340779ad55027af8aa33aee6cb521776a28a0a44aea377",
  															typeString: "literal_string \"Could not pay gas costs with ether\""
  														}
  													],
  													id: 339,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "8059:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 345,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "8059:69:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 346,
  											nodeType: "ExpressionStatement",
  											src: "8059:69:0"
  										}
  									]
  								}
  							}
  						]
  					},
  					documentation: null,
  					id: 370,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "handlePayment",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 301,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 292,
  								name: "gasUsed",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7403:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 291,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7403:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 294,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7428:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 293,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7428:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 296,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7453:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 295,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7453:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 298,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7479:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 297,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7479:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 300,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7505:30:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address_payable",
  									typeString: "address payable"
  								},
  								typeName: {
  									id: 299,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7505:15:0",
  									stateMutability: "payable",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7393:148:0"
  					},
  					returnParameters: {
  						id: 304,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 303,
  								name: "payment",
  								nodeType: "VariableDeclaration",
  								scope: 370,
  								src: "7575:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 302,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7575:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7574:17:0"
  					},
  					scope: 903,
  					src: "7371:952:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "private"
  				},
  				{
  					body: {
  						id: 621,
  						nodeType: "Block",
  						src: "9004:4183:0",
  						statements: [
  							{
  								assignments: [
  									382
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 382,
  										name: "_threshold",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9072:18:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 381,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "9072:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 384,
  								initialValue: {
  									argumentTypes: null,
  									id: 383,
  									name: "threshold",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 1548,
  									src: "9093:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9072:30:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 388,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 386,
  												name: "_threshold",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 382,
  												src: "9161:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 387,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9174:1:0",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "9161:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "5468726573686f6c64206e6565647320746f20626520646566696e656421",
  											id: 389,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9177:32:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_1e23ab3cb6407b7a5fa3f757d0ea5696352121927cbe8de469caec8b2f834565",
  												typeString: "literal_string \"Threshold needs to be defined!\""
  											},
  											value: "Threshold needs to be defined!"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_1e23ab3cb6407b7a5fa3f757d0ea5696352121927cbe8de469caec8b2f834565",
  												typeString: "literal_string \"Threshold needs to be defined!\""
  											}
  										],
  										id: 385,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "9153:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 390,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9153:57:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 391,
  								nodeType: "ExpressionStatement",
  								src: "9153:57:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 399,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 393,
  													name: "signatures",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 376,
  													src: "9295:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												},
  												id: 394,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9295:17:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "3635",
  														id: 397,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "9331:2:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_65_by_1",
  															typeString: "int_const 65"
  														},
  														value: "65"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_65_by_1",
  															typeString: "int_const 65"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 395,
  														name: "_threshold",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 382,
  														src: "9316:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 396,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "mul",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2171,
  													src: "9316:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 398,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "9316:18:0",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "9295:39:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "5369676e617475726573206461746120746f6f2073686f7274",
  											id: 400,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9336:27:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_17122174e7c2d723217ce151aacf64aec6d32748978cfd1a9479e00b57ac7dd5",
  												typeString: "literal_string \"Signatures data too short\""
  											},
  											value: "Signatures data too short"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_17122174e7c2d723217ce151aacf64aec6d32748978cfd1a9479e00b57ac7dd5",
  												typeString: "literal_string \"Signatures data too short\""
  											}
  										],
  										id: 392,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "9287:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 401,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9287:77:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 402,
  								nodeType: "ExpressionStatement",
  								src: "9287:77:0"
  							},
  							{
  								assignments: [
  									404
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 404,
  										name: "lastOwner",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9426:17:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 403,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "9426:7:0",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 408,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											hexValue: "30",
  											id: 406,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9454:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											}
  										],
  										id: 405,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										lValueRequested: false,
  										nodeType: "ElementaryTypeNameExpression",
  										src: "9446:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_type$_t_address_$",
  											typeString: "type(address)"
  										},
  										typeName: "address"
  									},
  									id: 407,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "typeConversion",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9446:10:0",
  									typeDescriptions: {
  										typeIdentifier: "t_address_payable",
  										typeString: "address payable"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9426:30:0"
  							},
  							{
  								assignments: [
  									410
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 410,
  										name: "currentOwner",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9466:20:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 409,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "9466:7:0",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 411,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9466:20:0"
  							},
  							{
  								assignments: [
  									413
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 413,
  										name: "v",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9496:7:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint8",
  											typeString: "uint8"
  										},
  										typeName: {
  											id: 412,
  											name: "uint8",
  											nodeType: "ElementaryTypeName",
  											src: "9496:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint8",
  												typeString: "uint8"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 414,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9496:7:0"
  							},
  							{
  								assignments: [
  									416
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 416,
  										name: "r",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9513:9:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 415,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "9513:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 417,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9513:9:0"
  							},
  							{
  								assignments: [
  									419
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 419,
  										name: "s",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9532:9:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 418,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "9532:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 420,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9532:9:0"
  							},
  							{
  								assignments: [
  									422
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 422,
  										name: "i",
  										nodeType: "VariableDeclaration",
  										scope: 621,
  										src: "9551:9:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 421,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "9551:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 423,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9551:9:0"
  							},
  							{
  								body: {
  									id: 619,
  									nodeType: "Block",
  									src: "9603:3578:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 442,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													components: [
  														{
  															argumentTypes: null,
  															id: 434,
  															name: "v",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 413,
  															src: "9618:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint8",
  																typeString: "uint8"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 435,
  															name: "r",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 416,
  															src: "9621:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes32",
  																typeString: "bytes32"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 436,
  															name: "s",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 419,
  															src: "9624:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes32",
  																typeString: "bytes32"
  															}
  														}
  													],
  													id: 437,
  													isConstant: false,
  													isInlineArray: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													nodeType: "TupleExpression",
  													src: "9617:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_tuple$_t_uint8_$_t_bytes32_$_t_bytes32_$",
  														typeString: "tuple(uint8,bytes32,bytes32)"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 439,
  															name: "signatures",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 376,
  															src: "9644:10:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 440,
  															name: "i",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 422,
  															src: "9656:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														id: 438,
  														name: "signatureSplit",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2135,
  														src: "9629:14:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$_t_uint256_$returns$_t_uint8_$_t_bytes32_$_t_bytes32_$",
  															typeString: "function (bytes memory,uint256) pure returns (uint8,bytes32,bytes32)"
  														}
  													},
  													id: 441,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "9629:29:0",
  													typeDescriptions: {
  														typeIdentifier: "t_tuple$_t_uint8_$_t_bytes32_$_t_bytes32_$",
  														typeString: "tuple(uint8,bytes32,bytes32)"
  													}
  												},
  												src: "9617:41:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 443,
  											nodeType: "ExpressionStatement",
  											src: "9617:41:0"
  										},
  										{
  											condition: {
  												argumentTypes: null,
  												commonType: {
  													typeIdentifier: "t_uint8",
  													typeString: "uint8"
  												},
  												id: 446,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													argumentTypes: null,
  													id: 444,
  													name: "v",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 413,
  													src: "9733:1:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint8",
  														typeString: "uint8"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: "==",
  												rightExpression: {
  													argumentTypes: null,
  													hexValue: "30",
  													id: 445,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "9738:1:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													},
  													value: "0"
  												},
  												src: "9733:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											falseBody: {
  												condition: {
  													argumentTypes: null,
  													commonType: {
  														typeIdentifier: "t_uint8",
  														typeString: "uint8"
  													},
  													id: 520,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													leftExpression: {
  														argumentTypes: null,
  														id: 518,
  														name: "v",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 413,
  														src: "11783:1:0",
  														typeDescriptions: {
  															typeIdentifier: "t_uint8",
  															typeString: "uint8"
  														}
  													},
  													nodeType: "BinaryOperation",
  													operator: "==",
  													rightExpression: {
  														argumentTypes: null,
  														hexValue: "31",
  														id: 519,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "11788:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_1_by_1",
  															typeString: "int_const 1"
  														},
  														value: "1"
  													},
  													src: "11783:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													}
  												},
  												falseBody: {
  													condition: {
  														argumentTypes: null,
  														commonType: {
  															typeIdentifier: "t_uint8",
  															typeString: "uint8"
  														},
  														id: 564,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															argumentTypes: null,
  															id: 562,
  															name: "v",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 413,
  															src: "12485:1:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint8",
  																typeString: "uint8"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: ">",
  														rightExpression: {
  															argumentTypes: null,
  															hexValue: "3330",
  															id: 563,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "12489:2:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_30_by_1",
  																typeString: "int_const 30"
  															},
  															value: "30"
  														},
  														src: "12485:6:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													falseBody: {
  														id: 592,
  														nodeType: "Block",
  														src: "12791:149:0",
  														statements: [
  															{
  																expression: {
  																	argumentTypes: null,
  																	id: 590,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftHandSide: {
  																		argumentTypes: null,
  																		id: 583,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "12882:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "Assignment",
  																	operator: "=",
  																	rightHandSide: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 585,
  																				name: "dataHash",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 372,
  																				src: "12907:8:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 586,
  																				name: "v",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 413,
  																				src: "12917:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 587,
  																				name: "r",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 416,
  																				src: "12920:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 588,
  																				name: "s",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 419,
  																				src: "12923:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 584,
  																			name: "ecrecover",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 5160,
  																			src: "12897:9:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_ecrecover_pure$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_address_$",
  																				typeString: "function (bytes32,uint8,bytes32,bytes32) pure returns (address)"
  																			}
  																		},
  																		id: 589,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "12897:28:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	src: "12882:43:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																id: 591,
  																nodeType: "ExpressionStatement",
  																src: "12882:43:0"
  															}
  														]
  													},
  													id: 593,
  													nodeType: "IfStatement",
  													src: "12481:459:0",
  													trueBody: {
  														id: 582,
  														nodeType: "Block",
  														src: "12493:292:0",
  														statements: [
  															{
  																expression: {
  																	argumentTypes: null,
  																	id: 580,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftHandSide: {
  																		argumentTypes: null,
  																		id: 565,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "12658:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "Assignment",
  																	operator: "=",
  																	rightHandSide: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						"arguments": [
  																							{
  																								argumentTypes: null,
  																								hexValue: "19457468657265756d205369676e6564204d6573736167653a0a3332",
  																								id: 570,
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								kind: "string",
  																								lValueRequested: false,
  																								nodeType: "Literal",
  																								src: "12710:34:0",
  																								subdenomination: null,
  																								typeDescriptions: {
  																									typeIdentifier: "t_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73",
  																									typeString: "literal_string \"\u0019Ethereum Signed Message:\n32\""
  																								},
  																								value: "\u0019Ethereum Signed Message:\n32"
  																							},
  																							{
  																								argumentTypes: null,
  																								id: 571,
  																								name: "dataHash",
  																								nodeType: "Identifier",
  																								overloadedDeclarations: [
  																								],
  																								referencedDeclaration: 372,
  																								src: "12746:8:0",
  																								typeDescriptions: {
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							}
  																						],
  																						expression: {
  																							argumentTypes: [
  																								{
  																									typeIdentifier: "t_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73",
  																									typeString: "literal_string \"\u0019Ethereum Signed Message:\n32\""
  																								},
  																								{
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							],
  																							expression: {
  																								argumentTypes: null,
  																								id: 568,
  																								name: "abi",
  																								nodeType: "Identifier",
  																								overloadedDeclarations: [
  																								],
  																								referencedDeclaration: 5155,
  																								src: "12693:3:0",
  																								typeDescriptions: {
  																									typeIdentifier: "t_magic_abi",
  																									typeString: "abi"
  																								}
  																							},
  																							id: 569,
  																							isConstant: false,
  																							isLValue: false,
  																							isPure: true,
  																							lValueRequested: false,
  																							memberName: "encodePacked",
  																							nodeType: "MemberAccess",
  																							referencedDeclaration: null,
  																							src: "12693:16:0",
  																							typeDescriptions: {
  																								typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  																								typeString: "function () pure returns (bytes memory)"
  																							}
  																						},
  																						id: 572,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						kind: "functionCall",
  																						lValueRequested: false,
  																						names: [
  																						],
  																						nodeType: "FunctionCall",
  																						src: "12693:62:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_bytes_memory_ptr",
  																							typeString: "bytes memory"
  																						}
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_bytes_memory_ptr",
  																							typeString: "bytes memory"
  																						}
  																					],
  																					id: 567,
  																					name: "keccak256",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 5162,
  																					src: "12683:9:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  																						typeString: "function (bytes memory) pure returns (bytes32)"
  																					}
  																				},
  																				id: 573,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "functionCall",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "12683:73:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				commonType: {
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				},
  																				id: 576,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				leftExpression: {
  																					argumentTypes: null,
  																					id: 574,
  																					name: "v",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 413,
  																					src: "12758:1:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_uint8",
  																						typeString: "uint8"
  																					}
  																				},
  																				nodeType: "BinaryOperation",
  																				operator: "-",
  																				rightExpression: {
  																					argumentTypes: null,
  																					hexValue: "34",
  																					id: 575,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: true,
  																					kind: "number",
  																					lValueRequested: false,
  																					nodeType: "Literal",
  																					src: "12762:1:0",
  																					subdenomination: null,
  																					typeDescriptions: {
  																						typeIdentifier: "t_rational_4_by_1",
  																						typeString: "int_const 4"
  																					},
  																					value: "4"
  																				},
  																				src: "12758:5:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 577,
  																				name: "r",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 416,
  																				src: "12765:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 578,
  																				name: "s",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 419,
  																				src: "12768:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_uint8",
  																					typeString: "uint8"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				},
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 566,
  																			name: "ecrecover",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 5160,
  																			src: "12673:9:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_ecrecover_pure$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_address_$",
  																				typeString: "function (bytes32,uint8,bytes32,bytes32) pure returns (address)"
  																			}
  																		},
  																		id: 579,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "12673:97:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	src: "12658:112:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																id: 581,
  																nodeType: "ExpressionStatement",
  																src: "12658:112:0"
  															}
  														]
  													}
  												},
  												id: 594,
  												nodeType: "IfStatement",
  												src: "11779:1161:0",
  												trueBody: {
  													id: 561,
  													nodeType: "Block",
  													src: "11791:684:0",
  													statements: [
  														{
  															expression: {
  																argumentTypes: null,
  																id: 527,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftHandSide: {
  																	argumentTypes: null,
  																	id: 521,
  																	name: "currentOwner",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 410,
  																	src: "11904:12:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																nodeType: "Assignment",
  																operator: "=",
  																rightHandSide: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			"arguments": [
  																				{
  																					argumentTypes: null,
  																					id: 524,
  																					name: "r",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 416,
  																					src: "11935:1:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				}
  																			],
  																			expression: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				],
  																				id: 523,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				nodeType: "ElementaryTypeNameExpression",
  																				src: "11927:7:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_type$_t_uint256_$",
  																					typeString: "type(uint256)"
  																				},
  																				typeName: "uint256"
  																			},
  																			id: 525,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			kind: "typeConversion",
  																			lValueRequested: false,
  																			names: [
  																			],
  																			nodeType: "FunctionCall",
  																			src: "11927:10:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		id: 522,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		nodeType: "ElementaryTypeNameExpression",
  																		src: "11919:7:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_type$_t_address_$",
  																			typeString: "type(address)"
  																		},
  																		typeName: "address"
  																	},
  																	id: 526,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "typeConversion",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "11919:19:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																},
  																src: "11904:34:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															id: 528,
  															nodeType: "ExpressionStatement",
  															src: "11904:34:0"
  														},
  														{
  															expression: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		commonType: {
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		},
  																		id: 541,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		leftExpression: {
  																			argumentTypes: null,
  																			commonType: {
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			id: 533,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			leftExpression: {
  																				argumentTypes: null,
  																				expression: {
  																					argumentTypes: null,
  																					id: 530,
  																					name: "msg",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 5168,
  																					src: "12109:3:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_magic_message",
  																						typeString: "msg"
  																					}
  																				},
  																				id: 531,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				memberName: "sender",
  																				nodeType: "MemberAccess",
  																				referencedDeclaration: null,
  																				src: "12109:10:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_address_payable",
  																					typeString: "address payable"
  																				}
  																			},
  																			nodeType: "BinaryOperation",
  																			operator: "==",
  																			rightExpression: {
  																				argumentTypes: null,
  																				id: 532,
  																				name: "currentOwner",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 410,
  																				src: "12123:12:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_address",
  																					typeString: "address"
  																				}
  																			},
  																			src: "12109:26:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bool",
  																				typeString: "bool"
  																			}
  																		},
  																		nodeType: "BinaryOperation",
  																		operator: "||",
  																		rightExpression: {
  																			argumentTypes: null,
  																			commonType: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			},
  																			id: 540,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			leftExpression: {
  																				argumentTypes: null,
  																				baseExpression: {
  																					argumentTypes: null,
  																					baseExpression: {
  																						argumentTypes: null,
  																						id: 534,
  																						name: "approvedHashes",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 77,
  																						src: "12139:14:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  																							typeString: "mapping(address => mapping(bytes32 => uint256))"
  																						}
  																					},
  																					id: 536,
  																					indexExpression: {
  																						argumentTypes: null,
  																						id: 535,
  																						name: "currentOwner",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 410,
  																						src: "12154:12:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					},
  																					isConstant: false,
  																					isLValue: true,
  																					isPure: false,
  																					lValueRequested: false,
  																					nodeType: "IndexAccess",
  																					src: "12139:28:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  																						typeString: "mapping(bytes32 => uint256)"
  																					}
  																				},
  																				id: 538,
  																				indexExpression: {
  																					argumentTypes: null,
  																					id: 537,
  																					name: "dataHash",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 372,
  																					src: "12168:8:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				},
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				nodeType: "IndexAccess",
  																				src: "12139:38:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			nodeType: "BinaryOperation",
  																			operator: "!=",
  																			rightExpression: {
  																				argumentTypes: null,
  																				hexValue: "30",
  																				id: 539,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "12181:1:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				},
  																				value: "0"
  																			},
  																			src: "12139:43:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bool",
  																				typeString: "bool"
  																			}
  																		},
  																		src: "12109:73:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		}
  																	},
  																	{
  																		argumentTypes: null,
  																		hexValue: "4861736820686173206e6f74206265656e20617070726f766564",
  																		id: 542,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		kind: "string",
  																		lValueRequested: false,
  																		nodeType: "Literal",
  																		src: "12184:28:0",
  																		subdenomination: null,
  																		typeDescriptions: {
  																			typeIdentifier: "t_stringliteral_d7f4b4187d31f59e4128c96e91f8a3de36d0b0c16e067e93136a6935459cd4c4",
  																			typeString: "literal_string \"Hash has not been approved\""
  																		},
  																		value: "Hash has not been approved"
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		},
  																		{
  																			typeIdentifier: "t_stringliteral_d7f4b4187d31f59e4128c96e91f8a3de36d0b0c16e067e93136a6935459cd4c4",
  																			typeString: "literal_string \"Hash has not been approved\""
  																		}
  																	],
  																	id: 529,
  																	name: "require",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																		5171,
  																		5172
  																	],
  																	referencedDeclaration: 5172,
  																	src: "12101:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																		typeString: "function (bool,string memory) pure"
  																	}
  																},
  																id: 543,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "12101:112:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_tuple$__$",
  																	typeString: "tuple()"
  																}
  															},
  															id: 544,
  															nodeType: "ExpressionStatement",
  															src: "12101:112:0"
  														},
  														{
  															condition: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																},
  																id: 550,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 545,
  																	name: "consumeHash",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 378,
  																	src: "12335:11:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "&&",
  																rightExpression: {
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	id: 549,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 546,
  																			name: "msg",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 5168,
  																			src: "12350:3:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_magic_message",
  																				typeString: "msg"
  																			}
  																		},
  																		id: 547,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "sender",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: null,
  																		src: "12350:10:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address_payable",
  																			typeString: "address payable"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "!=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		id: 548,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "12364:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	src: "12350:26:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																src: "12335:41:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															falseBody: null,
  															id: 560,
  															nodeType: "IfStatement",
  															src: "12331:130:0",
  															trueBody: {
  																id: 559,
  																nodeType: "Block",
  																src: "12378:83:0",
  																statements: [
  																	{
  																		expression: {
  																			argumentTypes: null,
  																			id: 557,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			leftHandSide: {
  																				argumentTypes: null,
  																				baseExpression: {
  																					argumentTypes: null,
  																					baseExpression: {
  																						argumentTypes: null,
  																						id: 551,
  																						name: "approvedHashes",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 77,
  																						src: "12400:14:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  																							typeString: "mapping(address => mapping(bytes32 => uint256))"
  																						}
  																					},
  																					id: 554,
  																					indexExpression: {
  																						argumentTypes: null,
  																						id: 552,
  																						name: "currentOwner",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 410,
  																						src: "12415:12:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					},
  																					isConstant: false,
  																					isLValue: true,
  																					isPure: false,
  																					lValueRequested: false,
  																					nodeType: "IndexAccess",
  																					src: "12400:28:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  																						typeString: "mapping(bytes32 => uint256)"
  																					}
  																				},
  																				id: 555,
  																				indexExpression: {
  																					argumentTypes: null,
  																					id: 553,
  																					name: "dataHash",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 372,
  																					src: "12429:8:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_bytes32",
  																						typeString: "bytes32"
  																					}
  																				},
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: true,
  																				nodeType: "IndexAccess",
  																				src: "12400:38:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			nodeType: "Assignment",
  																			operator: "=",
  																			rightHandSide: {
  																				argumentTypes: null,
  																				hexValue: "30",
  																				id: 556,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "12441:1:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				},
  																				value: "0"
  																			},
  																			src: "12400:42:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		},
  																		id: 558,
  																		nodeType: "ExpressionStatement",
  																		src: "12400:42:0"
  																	}
  																]
  															}
  														}
  													]
  												}
  											},
  											id: 595,
  											nodeType: "IfStatement",
  											src: "9729:3211:0",
  											trueBody: {
  												id: 517,
  												nodeType: "Block",
  												src: "9741:2032:0",
  												statements: [
  													{
  														expression: {
  															argumentTypes: null,
  															id: 453,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																argumentTypes: null,
  																id: 447,
  																name: "currentOwner",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 410,
  																src: "9858:12:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 450,
  																				name: "r",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 416,
  																				src: "9889:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 449,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "9881:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_uint256_$",
  																				typeString: "type(uint256)"
  																			},
  																			typeName: "uint256"
  																		},
  																		id: 451,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "9881:10:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	id: 448,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	lValueRequested: false,
  																	nodeType: "ElementaryTypeNameExpression",
  																	src: "9873:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_type$_t_address_$",
  																		typeString: "type(address)"
  																	},
  																	typeName: "address"
  																},
  																id: 452,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "typeConversion",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "9873:19:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															src: "9858:34:0",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														id: 454,
  														nodeType: "ExpressionStatement",
  														src: "9858:34:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	id: 463,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 457,
  																				name: "s",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 419,
  																				src: "10287:1:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes32",
  																					typeString: "bytes32"
  																				}
  																			],
  																			id: 456,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "10279:7:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_uint256_$",
  																				typeString: "type(uint256)"
  																			},
  																			typeName: "uint256"
  																		},
  																		id: 458,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "10279:10:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: ">=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				hexValue: "3635",
  																				id: 461,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "10308:2:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_65_by_1",
  																					typeString: "int_const 65"
  																				},
  																				value: "65"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_rational_65_by_1",
  																					typeString: "int_const 65"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				id: 459,
  																				name: "_threshold",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 382,
  																				src: "10293:10:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			id: 460,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "mul",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2171,
  																			src: "10293:14:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																				typeString: "function (uint256,uint256) pure returns (uint256)"
  																			}
  																		},
  																		id: 462,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "10293:18:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	src: "10279:32:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e6174757265206c6f636174696f6e3a20696e73696465207374617469632070617274",
  																	id: 464,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "10313:57:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_bfb239616a9951d5fab065a9a51a4efbfefb4123cc2bd6ca3a42ba9495d0b860",
  																		typeString: "literal_string \"Invalid contract signature location: inside static part\""
  																	},
  																	value: "Invalid contract signature location: inside static part"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_bfb239616a9951d5fab065a9a51a4efbfefb4123cc2bd6ca3a42ba9495d0b860",
  																		typeString: "literal_string \"Invalid contract signature location: inside static part\""
  																	}
  																],
  																id: 455,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "10271:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 465,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10271:100:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 466,
  														nodeType: "ExpressionStatement",
  														src: "10271:100:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	id: 476,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				hexValue: "3332",
  																				id: 472,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "10526:2:0",
  																				subdenomination: null,
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_32_by_1",
  																					typeString: "int_const 32"
  																				},
  																				value: "32"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_rational_32_by_1",
  																					typeString: "int_const 32"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						id: 469,
  																						name: "s",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 419,
  																						src: "10519:1:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_bytes32",
  																							typeString: "bytes32"
  																						}
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_bytes32",
  																							typeString: "bytes32"
  																						}
  																					],
  																					id: 468,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: true,
  																					lValueRequested: false,
  																					nodeType: "ElementaryTypeNameExpression",
  																					src: "10511:7:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_type$_t_uint256_$",
  																						typeString: "type(uint256)"
  																					},
  																					typeName: "uint256"
  																				},
  																				id: 470,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "typeConversion",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "10511:10:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			id: 471,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "add",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2243,
  																			src: "10511:14:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																				typeString: "function (uint256,uint256) pure returns (uint256)"
  																			}
  																		},
  																		id: 473,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "10511:18:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "<=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 474,
  																			name: "signatures",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 376,
  																			src: "10533:10:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bytes_memory_ptr",
  																				typeString: "bytes memory"
  																			}
  																		},
  																		id: 475,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "length",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: null,
  																		src: "10533:17:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	src: "10511:39:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e6174757265206c6f636174696f6e3a206c656e677468206e6f742070726573656e74",
  																	id: 477,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "10552:57:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_dc0d1c56ccf75f8c8c8a674b5193ee8ed08d0760e044e48d340712e3fcc404fc",
  																		typeString: "literal_string \"Invalid contract signature location: length not present\""
  																	},
  																	value: "Invalid contract signature location: length not present"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_dc0d1c56ccf75f8c8c8a674b5193ee8ed08d0760e044e48d340712e3fcc404fc",
  																		typeString: "literal_string \"Invalid contract signature location: length not present\""
  																	}
  																],
  																id: 467,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "10503:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 478,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10503:107:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 479,
  														nodeType: "ExpressionStatement",
  														src: "10503:107:0"
  													},
  													{
  														assignments: [
  															481
  														],
  														declarations: [
  															{
  																constant: false,
  																id: 481,
  																name: "contractSignatureLen",
  																nodeType: "VariableDeclaration",
  																scope: 517,
  																src: "10754:28:0",
  																stateVariable: false,
  																storageLocation: "default",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																typeName: {
  																	id: 480,
  																	name: "uint256",
  																	nodeType: "ElementaryTypeName",
  																	src: "10754:7:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																value: null,
  																visibility: "internal"
  															}
  														],
  														id: 482,
  														initialValue: null,
  														nodeType: "VariableDeclarationStatement",
  														src: "10754:28:0"
  													},
  													{
  														externalReferences: [
  															{
  																contractSignatureLen: {
  																	declaration: 481,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "10903:20:0",
  																	valueSize: 1
  																}
  															},
  															{
  																signatures: {
  																	declaration: 376,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "10941:10:0",
  																	valueSize: 1
  																}
  															},
  															{
  																s: {
  																	declaration: 419,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "10953:1:0",
  																	valueSize: 1
  																}
  															}
  														],
  														id: 483,
  														nodeType: "InlineAssembly",
  														operations: "{\n    contractSignatureLen := mload(add(add(signatures, s), 0x20))\n}",
  														src: "10872:109:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	},
  																	id: 496,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 492,
  																				name: "contractSignatureLen",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 481,
  																				src: "11029:20:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						hexValue: "3332",
  																						id: 489,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						kind: "number",
  																						lValueRequested: false,
  																						nodeType: "Literal",
  																						src: "11021:2:0",
  																						subdenomination: null,
  																						typeDescriptions: {
  																							typeIdentifier: "t_rational_32_by_1",
  																							typeString: "int_const 32"
  																						},
  																						value: "32"
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_rational_32_by_1",
  																							typeString: "int_const 32"
  																						}
  																					],
  																					expression: {
  																						argumentTypes: null,
  																						"arguments": [
  																							{
  																								argumentTypes: null,
  																								id: 486,
  																								name: "s",
  																								nodeType: "Identifier",
  																								overloadedDeclarations: [
  																								],
  																								referencedDeclaration: 419,
  																								src: "11014:1:0",
  																								typeDescriptions: {
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							}
  																						],
  																						expression: {
  																							argumentTypes: [
  																								{
  																									typeIdentifier: "t_bytes32",
  																									typeString: "bytes32"
  																								}
  																							],
  																							id: 485,
  																							isConstant: false,
  																							isLValue: false,
  																							isPure: true,
  																							lValueRequested: false,
  																							nodeType: "ElementaryTypeNameExpression",
  																							src: "11006:7:0",
  																							typeDescriptions: {
  																								typeIdentifier: "t_type$_t_uint256_$",
  																								typeString: "type(uint256)"
  																							},
  																							typeName: "uint256"
  																						},
  																						id: 487,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						kind: "typeConversion",
  																						lValueRequested: false,
  																						names: [
  																						],
  																						nodeType: "FunctionCall",
  																						src: "11006:10:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_uint256",
  																							typeString: "uint256"
  																						}
  																					},
  																					id: 488,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: false,
  																					lValueRequested: false,
  																					memberName: "add",
  																					nodeType: "MemberAccess",
  																					referencedDeclaration: 2243,
  																					src: "11006:14:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																						typeString: "function (uint256,uint256) pure returns (uint256)"
  																					}
  																				},
  																				id: 490,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "functionCall",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "11006:18:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			},
  																			id: 491,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "add",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2243,
  																			src: "11006:22:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																				typeString: "function (uint256,uint256) pure returns (uint256)"
  																			}
  																		},
  																		id: 493,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "11006:44:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "<=",
  																	rightExpression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 494,
  																			name: "signatures",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 376,
  																			src: "11054:10:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_bytes_memory_ptr",
  																				typeString: "bytes memory"
  																			}
  																		},
  																		id: 495,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "length",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: null,
  																		src: "11054:17:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	src: "11006:65:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e6174757265206c6f636174696f6e3a2064617461206e6f7420636f6d706c657465",
  																	id: 497,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "11073:56:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_ac9b3d17bcf94bcca27fad9236a2ce28cd2180227f36ea63832457691c24a721",
  																		typeString: "literal_string \"Invalid contract signature location: data not complete\""
  																	},
  																	value: "Invalid contract signature location: data not complete"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_ac9b3d17bcf94bcca27fad9236a2ce28cd2180227f36ea63832457691c24a721",
  																		typeString: "literal_string \"Invalid contract signature location: data not complete\""
  																	}
  																],
  																id: 484,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "10998:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 498,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10998:132:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 499,
  														nodeType: "ExpressionStatement",
  														src: "10998:132:0"
  													},
  													{
  														assignments: [
  															501
  														],
  														declarations: [
  															{
  																constant: false,
  																id: 501,
  																name: "contractSignature",
  																nodeType: "VariableDeclaration",
  																scope: 517,
  																src: "11184:30:0",
  																stateVariable: false,
  																storageLocation: "memory",
  																typeDescriptions: {
  																	typeIdentifier: "t_bytes_memory_ptr",
  																	typeString: "bytes"
  																},
  																typeName: {
  																	id: 500,
  																	name: "bytes",
  																	nodeType: "ElementaryTypeName",
  																	src: "11184:5:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bytes_storage_ptr",
  																		typeString: "bytes"
  																	}
  																},
  																value: null,
  																visibility: "internal"
  															}
  														],
  														id: 502,
  														initialValue: null,
  														nodeType: "VariableDeclarationStatement",
  														src: "11184:30:0"
  													},
  													{
  														externalReferences: [
  															{
  																contractSignature: {
  																	declaration: 501,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "11474:17:0",
  																	valueSize: 1
  																}
  															},
  															{
  																signatures: {
  																	declaration: 376,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "11503:10:0",
  																	valueSize: 1
  																}
  															},
  															{
  																s: {
  																	declaration: 419,
  																	isOffset: false,
  																	isSlot: false,
  																	src: "11515:1:0",
  																	valueSize: 1
  																}
  															}
  														],
  														id: 503,
  														nodeType: "InlineAssembly",
  														operations: "{\n    contractSignature := add(add(signatures, s), 0x20)\n}",
  														src: "11304:238:0"
  													},
  													{
  														expression: {
  															argumentTypes: null,
  															"arguments": [
  																{
  																	argumentTypes: null,
  																	commonType: {
  																		typeIdentifier: "t_bytes4",
  																		typeString: "bytes4"
  																	},
  																	id: 513,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 509,
  																				name: "data",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 374,
  																				src: "11618:4:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				}
  																			},
  																			{
  																				argumentTypes: null,
  																				id: 510,
  																				name: "contractSignature",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 501,
  																				src: "11624:17:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				},
  																				{
  																					typeIdentifier: "t_bytes_memory_ptr",
  																					typeString: "bytes memory"
  																				}
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				"arguments": [
  																					{
  																						argumentTypes: null,
  																						id: 506,
  																						name: "currentOwner",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 410,
  																						src: "11587:12:0",
  																						typeDescriptions: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						}
  																					],
  																					id: 505,
  																					name: "ISignatureValidator",
  																					nodeType: "Identifier",
  																					overloadedDeclarations: [
  																					],
  																					referencedDeclaration: 2439,
  																					src: "11567:19:0",
  																					typeDescriptions: {
  																						typeIdentifier: "t_type$_t_contract$_ISignatureValidator_$2439_$",
  																						typeString: "type(contract ISignatureValidator)"
  																					}
  																				},
  																				id: 507,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "typeConversion",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "11567:33:0",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_ISignatureValidator_$2439",
  																					typeString: "contract ISignatureValidator"
  																				}
  																			},
  																			id: 508,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "isValidSignature",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 2438,
  																			src: "11567:50:0",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_external_view$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$returns$_t_bytes4_$",
  																				typeString: "function (bytes memory,bytes memory) view external returns (bytes4)"
  																			}
  																		},
  																		id: 511,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "11567:75:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_bytes4",
  																			typeString: "bytes4"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "==",
  																	rightExpression: {
  																		argumentTypes: null,
  																		id: 512,
  																		name: "EIP1271_MAGIC_VALUE",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 2426,
  																		src: "11646:19:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_bytes4",
  																			typeString: "bytes4"
  																		}
  																	},
  																	src: "11567:98:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	argumentTypes: null,
  																	hexValue: "496e76616c696420636f6e7472616374207369676e61747572652070726f7669646564",
  																	id: 514,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "11667:37:0",
  																	subdenomination: null,
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_390c7641d6d34f7efe51534140db10473a63d1356be81e211b820ef38d63c7ad",
  																		typeString: "literal_string \"Invalid contract signature provided\""
  																	},
  																	value: "Invalid contract signature provided"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_390c7641d6d34f7efe51534140db10473a63d1356be81e211b820ef38d63c7ad",
  																		typeString: "literal_string \"Invalid contract signature provided\""
  																	}
  																],
  																id: 504,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	5171,
  																	5172
  																],
  																referencedDeclaration: 5172,
  																src: "11559:7:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 515,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "11559:146:0",
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 516,
  														nodeType: "ExpressionStatement",
  														src: "11559:146:0"
  													}
  												]
  											}
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														id: 611,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															argumentTypes: null,
  															commonType: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															id: 607,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																id: 599,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	id: 597,
  																	name: "currentOwner",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 410,
  																	src: "12979:12:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: ">",
  																rightExpression: {
  																	argumentTypes: null,
  																	id: 598,
  																	name: "lastOwner",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 404,
  																	src: "12994:9:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																src: "12979:24:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "&&",
  															rightExpression: {
  																argumentTypes: null,
  																commonType: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																id: 606,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																leftExpression: {
  																	argumentTypes: null,
  																	baseExpression: {
  																		argumentTypes: null,
  																		id: 600,
  																		name: "owners",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1544,
  																		src: "13007:6:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  																			typeString: "mapping(address => address)"
  																		}
  																	},
  																	id: 602,
  																	indexExpression: {
  																		argumentTypes: null,
  																		id: 601,
  																		name: "currentOwner",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 410,
  																		src: "13014:12:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	isConstant: false,
  																	isLValue: true,
  																	isPure: false,
  																	lValueRequested: false,
  																	nodeType: "IndexAccess",
  																	src: "13007:20:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																nodeType: "BinaryOperation",
  																operator: "!=",
  																rightExpression: {
  																	argumentTypes: null,
  																	"arguments": [
  																		{
  																			argumentTypes: null,
  																			hexValue: "30",
  																			id: 604,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			kind: "number",
  																			lValueRequested: false,
  																			nodeType: "Literal",
  																			src: "13039:1:0",
  																			subdenomination: null,
  																			typeDescriptions: {
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			},
  																			value: "0"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		id: 603,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		nodeType: "ElementaryTypeNameExpression",
  																		src: "13031:7:0",
  																		typeDescriptions: {
  																			typeIdentifier: "t_type$_t_address_$",
  																			typeString: "type(address)"
  																		},
  																		typeName: "address"
  																	},
  																	id: 605,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "typeConversion",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "13031:10:0",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address_payable",
  																		typeString: "address payable"
  																	}
  																},
  																src: "13007:34:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bool",
  																	typeString: "bool"
  																}
  															},
  															src: "12979:62:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: "&&",
  														rightExpression: {
  															argumentTypes: null,
  															commonType: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															id: 610,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																argumentTypes: null,
  																id: 608,
  																name: "currentOwner",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 410,
  																src: "13045:12:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "!=",
  															rightExpression: {
  																argumentTypes: null,
  																id: 609,
  																name: "SENTINEL_OWNERS",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1540,
  																src: "13061:15:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															src: "13045:31:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														src: "12979:97:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "496e76616c6964206f776e65722070726f7669646564",
  														id: 612,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "13094:24:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_8ee2555cd581859d0f0126c1bf87e0d45ed61a2e38322e0cb3c328581d2d4b32",
  															typeString: "literal_string \"Invalid owner provided\""
  														},
  														value: "Invalid owner provided"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_8ee2555cd581859d0f0126c1bf87e0d45ed61a2e38322e0cb3c328581d2d4b32",
  															typeString: "literal_string \"Invalid owner provided\""
  														}
  													],
  													id: 596,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "12953:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 613,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "12953:179:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 614,
  											nodeType: "ExpressionStatement",
  											src: "12953:179:0"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 617,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 615,
  													name: "lastOwner",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 404,
  													src: "13146:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													id: 616,
  													name: "currentOwner",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 410,
  													src: "13158:12:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												src: "13146:24:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											id: 618,
  											nodeType: "ExpressionStatement",
  											src: "13146:24:0"
  										}
  									]
  								},
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 430,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 428,
  										name: "i",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 422,
  										src: "9582:1:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										id: 429,
  										name: "_threshold",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 382,
  										src: "9586:10:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "9582:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 620,
  								initializationExpression: {
  									expression: {
  										argumentTypes: null,
  										id: 426,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftHandSide: {
  											argumentTypes: null,
  											id: 424,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 422,
  											src: "9575:1:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										nodeType: "Assignment",
  										operator: "=",
  										rightHandSide: {
  											argumentTypes: null,
  											hexValue: "30",
  											id: 425,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "9579:1:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										},
  										src: "9575:5:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 427,
  									nodeType: "ExpressionStatement",
  									src: "9575:5:0"
  								},
  								loopExpression: {
  									expression: {
  										argumentTypes: null,
  										id: 432,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "++",
  										prefix: false,
  										src: "9598:3:0",
  										subExpression: {
  											argumentTypes: null,
  											id: 431,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 422,
  											src: "9598:1:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 433,
  									nodeType: "ExpressionStatement",
  									src: "9598:3:0"
  								},
  								nodeType: "ForStatement",
  								src: "9570:3611:0"
  							}
  						]
  					},
  					documentation: "@dev Checks whether the signature provided is valid for the provided data, hash. Will revert otherwise.\n@param dataHash Hash of the data (could be either a message hash or transaction hash)\n@param data That should be signed (this is passed to an external validator contract)\n@param signatures Signature data that should be verified. Can be ECDSA signature, contract signature (EIP-1271) or approved hash.\n@param consumeHash Indicates that in case of an approved hash the storage can be freed to save gas",
  					id: 622,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "checkSignatures",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 379,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 372,
  								name: "dataHash",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8903:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 371,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "8903:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 374,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8921:17:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 373,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "8921:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 376,
  								name: "signatures",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8940:23:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 375,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "8940:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 378,
  								name: "consumeHash",
  								nodeType: "VariableDeclaration",
  								scope: 622,
  								src: "8965:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 377,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "8965:4:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8902:80:0"
  					},
  					returnParameters: {
  						id: 380,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "9004:0:0"
  					},
  					scope: 903,
  					src: "8878:4309:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 669,
  						nodeType: "Block",
  						src: "14262:420:0",
  						statements: [
  							{
  								assignments: [
  									638
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 638,
  										name: "startGas",
  										nodeType: "VariableDeclaration",
  										scope: 669,
  										src: "14272:16:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 637,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "14272:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 641,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 639,
  										name: "gasleft",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5161,
  										src: "14291:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  											typeString: "function () view returns (uint256)"
  										}
  									},
  									id: 640,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14291:9:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "14272:28:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 644,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 624,
  													src: "14462:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 645,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 626,
  													src: "14466:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 646,
  													name: "data",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 628,
  													src: "14473:4:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 647,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 630,
  													src: "14479:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														id: 648,
  														name: "gasleft",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5161,
  														src: "14490:7:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  															typeString: "function () view returns (uint256)"
  														}
  													},
  													id: 649,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "14490:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes_calldata_ptr",
  														typeString: "bytes calldata"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												id: 643,
  												name: "execute",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1012,
  												src: "14454:7:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256) returns (bool)"
  												}
  											},
  											id: 650,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "14454:46:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 642,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5171,
  										src: "14446:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 651,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14446:55:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 652,
  								nodeType: "ExpressionStatement",
  								src: "14446:55:0"
  							},
  							{
  								assignments: [
  									654
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 654,
  										name: "requiredGas",
  										nodeType: "VariableDeclaration",
  										scope: 669,
  										src: "14511:19:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 653,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "14511:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 659,
  								initialValue: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 658,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 655,
  										name: "startGas",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 638,
  										src: "14533:8:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "-",
  									rightExpression: {
  										argumentTypes: null,
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											id: 656,
  											name: "gasleft",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5161,
  											src: "14544:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_function_gasleft_view$__$returns$_t_uint256_$",
  												typeString: "function () view returns (uint256)"
  											}
  										},
  										id: 657,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "14544:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "14533:20:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "14511:42:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 664,
  															name: "requiredGas",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 654,
  															src: "14661:11:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 662,
  															name: "abi",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 5155,
  															src: "14644:3:0",
  															typeDescriptions: {
  																typeIdentifier: "t_magic_abi",
  																typeString: "abi"
  															}
  														},
  														id: 663,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														memberName: "encodePacked",
  														nodeType: "MemberAccess",
  														referencedDeclaration: null,
  														src: "14644:16:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  															typeString: "function () pure returns (bytes memory)"
  														}
  													},
  													id: 665,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "14644:29:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												],
  												id: 661,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "14637:6:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_string_storage_ptr_$",
  													typeString: "type(string storage pointer)"
  												},
  												typeName: "string"
  											},
  											id: 666,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "14637:37:0",
  											typeDescriptions: {
  												typeIdentifier: "t_string_memory_ptr",
  												typeString: "string memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_string_memory_ptr",
  												typeString: "string memory"
  											}
  										],
  										id: 660,
  										name: "revert",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5173,
  											5174
  										],
  										referencedDeclaration: 5174,
  										src: "14630:6:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (string memory) pure"
  										}
  									},
  									id: 667,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14630:45:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 668,
  								nodeType: "ExpressionStatement",
  								src: "14630:45:0"
  							}
  						]
  					},
  					documentation: "@dev Allows to estimate a Safe transaction.\n      This method is only meant for estimation purpose, therefore two different protection mechanism against execution in a transaction have been made:\n      1.) The method can only be called from the safe itself\n      2.) The response is returned with a revert\n      When estimating set `from` to the address of the safe.\n      Since the `estimateGas` function includes refunds, call this method to get an estimated of the costs that are deducted from the safe with `execTransaction`\n @param to Destination address of Safe transaction.\n @param value Ether value of Safe transaction.\n @param data Data payload of Safe transaction.\n @param operation Operation type of Safe transaction.\n @return Estimate without refunds and overhead fees (base transaction and payload data gas costs).",
  					id: 670,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 633,
  							modifierName: {
  								argumentTypes: null,
  								id: 632,
  								name: "authorized",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 2079,
  								src: "14221:10:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "14221:10:0"
  						}
  					],
  					name: "requiredTxGas",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 631,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 624,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14122:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 623,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "14122:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 626,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14134:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 625,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "14134:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 628,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14149:19:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 627,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "14149:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 630,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14170:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 629,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "14170:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "14121:74:0"
  					},
  					returnParameters: {
  						id: 636,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 635,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 670,
  								src: "14249:7:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 634,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "14249:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "14248:9:0"
  					},
  					scope: 903,
  					src: "14099:583:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 702,
  						nodeType: "Block",
  						src: "14991:200:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 683,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												baseExpression: {
  													argumentTypes: null,
  													id: 676,
  													name: "owners",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1544,
  													src: "15009:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  														typeString: "mapping(address => address)"
  													}
  												},
  												id: 679,
  												indexExpression: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 677,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5168,
  														src: "15016:3:0",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 678,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													referencedDeclaration: null,
  													src: "15016:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "15009:18:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "30",
  														id: 681,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "15039:1:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 680,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "15031:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: "address"
  												},
  												id: 682,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "15031:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "15009:32:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4f6e6c79206f776e6572732063616e20617070726f766520612068617368",
  											id: 684,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "15043:32:0",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_60f21058f4a7689ef29853b3c9c17c9bf69856a949794649bb68878f00552475",
  												typeString: "literal_string \"Only owners can approve a hash\""
  											},
  											value: "Only owners can approve a hash"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_60f21058f4a7689ef29853b3c9c17c9bf69856a949794649bb68878f00552475",
  												typeString: "literal_string \"Only owners can approve a hash\""
  											}
  										],
  										id: 675,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											5171,
  											5172
  										],
  										referencedDeclaration: 5172,
  										src: "15001:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 685,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15001:75:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 686,
  								nodeType: "ExpressionStatement",
  								src: "15001:75:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 694,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 687,
  												name: "approvedHashes",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 77,
  												src: "15086:14:0",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_bytes32_$_t_uint256_$_$",
  													typeString: "mapping(address => mapping(bytes32 => uint256))"
  												}
  											},
  											id: 691,
  											indexExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 688,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5168,
  													src: "15101:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 689,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "15101:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "15086:26:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  												typeString: "mapping(bytes32 => uint256)"
  											}
  										},
  										id: 692,
  										indexExpression: {
  											argumentTypes: null,
  											id: 690,
  											name: "hashToApprove",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 672,
  											src: "15113:13:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "15086:41:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "31",
  										id: 693,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "15130:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "15086:45:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 695,
  								nodeType: "ExpressionStatement",
  								src: "15086:45:0"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 697,
  											name: "hashToApprove",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 672,
  											src: "15158:13:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 698,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 5168,
  												src: "15173:3:0",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 699,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "15173:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										],
  										id: 696,
  										name: "ApproveHash",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 47,
  										src: "15146:11:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$_t_address_$returns$__$",
  											typeString: "function (bytes32,address)"
  										}
  									},
  									id: 700,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15146:38:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 701,
  								nodeType: "EmitStatement",
  								src: "15141:43:0"
  							}
  						]
  					},
  					documentation: "@dev Marks a hash as approved. This can be used to validate a hash that is used by a signature.\n@param hashToApprove The hash that should be marked as approved for signatures that are verified by this contract.",
  					id: 703,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "approveHash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 673,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 672,
  								name: "hashToApprove",
  								nodeType: "VariableDeclaration",
  								scope: 703,
  								src: "14947:21:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 671,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "14947:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "14946:23:0"
  					},
  					returnParameters: {
  						id: 674,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "14991:0:0"
  					},
  					scope: 903,
  					src: "14926:265:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 726,
  						nodeType: "Block",
  						src: "15436:124:0",
  						statements: [
  							{
  								assignments: [
  									711
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 711,
  										name: "msgHash",
  										nodeType: "VariableDeclaration",
  										scope: 726,
  										src: "15446:15:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 710,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "15446:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 715,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 713,
  											name: "_data",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 705,
  											src: "15479:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										],
  										id: 712,
  										name: "getMessageHash",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 802,
  										src: "15464:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) view returns (bytes32)"
  										}
  									},
  									id: 714,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15464:21:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "15446:39:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 720,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 716,
  											name: "signedMessages",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 71,
  											src: "15495:14:0",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  												typeString: "mapping(bytes32 => uint256)"
  											}
  										},
  										id: 718,
  										indexExpression: {
  											argumentTypes: null,
  											id: 717,
  											name: "msgHash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 711,
  											src: "15510:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "15495:23:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										hexValue: "31",
  										id: 719,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "15521:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "15495:27:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 721,
  								nodeType: "ExpressionStatement",
  								src: "15495:27:0"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 723,
  											name: "msgHash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 711,
  											src: "15545:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										],
  										id: 722,
  										name: "SignMsg",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 51,
  										src: "15537:7:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_bytes32_$returns$__$",
  											typeString: "function (bytes32)"
  										}
  									},
  									id: 724,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15537:16:0",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 725,
  								nodeType: "EmitStatement",
  								src: "15532:21:0"
  							}
  						]
  					},
  					documentation: "@dev Marks a message as signed\n@param _data Arbitrary length data that should be marked as signed on the behalf of address(this)",
  					id: 727,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 708,
  							modifierName: {
  								argumentTypes: null,
  								id: 707,
  								name: "authorized",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 2079,
  								src: "15421:10:0",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "15421:10:0"
  						}
  					],
  					name: "signMessage",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 706,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 705,
  								name: "_data",
  								nodeType: "VariableDeclaration",
  								scope: 727,
  								src: "15374:20:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 704,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "15374:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "15373:22:0"
  					},
  					returnParameters: {
  						id: 709,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "15436:0:0"
  					},
  					scope: 903,
  					src: "15353:207:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 767,
  						nodeType: "Block",
  						src: "16297:386:0",
  						statements: [
  							{
  								assignments: [
  									737
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 737,
  										name: "messageHash",
  										nodeType: "VariableDeclaration",
  										scope: 767,
  										src: "16307:19:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 736,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "16307:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 741,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 739,
  											name: "_data",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 729,
  											src: "16344:5:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										],
  										id: 738,
  										name: "getMessageHash",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 802,
  										src: "16329:14:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) view returns (bytes32)"
  										}
  									},
  									id: 740,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "16329:21:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "16307:43:0"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 745,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 742,
  											name: "_signature",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 731,
  											src: "16364:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_calldata_ptr",
  												typeString: "bytes calldata"
  											}
  										},
  										id: 743,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "16364:17:0",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 744,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "16385:1:0",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "16364:22:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: {
  									id: 763,
  									nodeType: "Block",
  									src: "16481:160:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 757,
  														name: "messageHash",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 737,
  														src: "16592:11:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 758,
  														name: "_data",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 729,
  														src: "16605:5:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														}
  													},
  													{
  														argumentTypes: null,
  														id: 759,
  														name: "_signature",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 731,
  														src: "16612:10:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "66616c7365",
  														id: 760,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "bool",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "16624:5:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														value: "false"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bytes32",
  															typeString: "bytes32"
  														},
  														{
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														},
  														{
  															typeIdentifier: "t_bytes_calldata_ptr",
  															typeString: "bytes calldata"
  														},
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													],
  													id: 756,
  													name: "checkSignatures",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 622,
  													src: "16576:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_bytes32_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$_t_bool_$returns$__$",
  														typeString: "function (bytes32,bytes memory,bytes memory,bool)"
  													}
  												},
  												id: 761,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16576:54:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 762,
  											nodeType: "ExpressionStatement",
  											src: "16576:54:0"
  										}
  									]
  								},
  								id: 764,
  								nodeType: "IfStatement",
  								src: "16360:281:0",
  								trueBody: {
  									id: 755,
  									nodeType: "Block",
  									src: "16388:87:0",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														id: 751,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															argumentTypes: null,
  															baseExpression: {
  																argumentTypes: null,
  																id: 747,
  																name: "signedMessages",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 71,
  																src: "16410:14:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_mapping$_t_bytes32_$_t_uint256_$",
  																	typeString: "mapping(bytes32 => uint256)"
  																}
  															},
  															id: 749,
  															indexExpression: {
  																argumentTypes: null,
  																id: 748,
  																name: "messageHash",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 737,
  																src: "16425:11:0",
  																typeDescriptions: {
  																	typeIdentifier: "t_bytes32",
  																	typeString: "bytes32"
  																}
  															},
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "IndexAccess",
  															src: "16410:27:0",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: "!=",
  														rightExpression: {
  															argumentTypes: null,
  															hexValue: "30",
  															id: 750,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "16441:1:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_0_by_1",
  																typeString: "int_const 0"
  															},
  															value: "0"
  														},
  														src: "16410:32:0",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														argumentTypes: null,
  														hexValue: "48617368206e6f7420617070726f766564",
  														id: 752,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "16444:19:0",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_fd8211c71ab965565e8a56b84284a02d17d4d89e6f05f14b26449d5de3a8c5b6",
  															typeString: "literal_string \"Hash not approved\""
  														},
  														value: "Hash not approved"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_fd8211c71ab965565e8a56b84284a02d17d4d89e6f05f14b26449d5de3a8c5b6",
  															typeString: "literal_string \"Hash not approved\""
  														}
  													],
  													id: 746,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														5171,
  														5172
  													],
  													referencedDeclaration: 5172,
  													src: "16402:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 753,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16402:62:0",
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 754,
  											nodeType: "ExpressionStatement",
  											src: "16402:62:0"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 765,
  									name: "EIP1271_MAGIC_VALUE",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2426,
  									src: "16657:19:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes4",
  										typeString: "bytes4"
  									}
  								},
  								functionReturnParameters: 735,
  								id: 766,
  								nodeType: "Return",
  								src: "16650:26:0"
  							}
  						]
  					},
  					documentation: "Implementation of ISignatureValidator (see `interfaces/ISignatureValidator.sol`)\n@dev Should return whether the signature provided is valid for the provided data.\n      The save does not implement the interface since `checkSignatures` is not a view method.\n      The method will not perform any state changes (see parameters of `checkSignatures`)\n@param _data Arbitrary length data signed on the behalf of address(this)\n@param _signature Signature byte array associated with _data\n@return a bool upon valid or invalid signature with corresponding _data",
  					id: 768,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "isValidSignature",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 732,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 729,
  								name: "_data",
  								nodeType: "VariableDeclaration",
  								scope: 768,
  								src: "16202:20:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 728,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "16202:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 731,
  								name: "_signature",
  								nodeType: "VariableDeclaration",
  								scope: 768,
  								src: "16224:25:0",
  								stateVariable: false,
  								storageLocation: "calldata",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_calldata_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 730,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "16224:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16201:49:0"
  					},
  					returnParameters: {
  						id: 735,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 734,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 768,
  								src: "16285:6:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes4",
  									typeString: "bytes4"
  								},
  								typeName: {
  									id: 733,
  									name: "bytes4",
  									nodeType: "ElementaryTypeName",
  									src: "16285:6:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes4",
  										typeString: "bytes4"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16284:8:0"
  					},
  					scope: 903,
  					src: "16176:507:0",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "external"
  				},
  				{
  					body: {
  						id: 801,
  						nodeType: "Block",
  						src: "16959:249:0",
  						statements: [
  							{
  								assignments: [
  									776
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 776,
  										name: "safeMessageHash",
  										nodeType: "VariableDeclaration",
  										scope: 801,
  										src: "16969:23:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 775,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "16969:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 786,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 780,
  													name: "SAFE_MSG_TYPEHASH",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 41,
  													src: "17029:17:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 782,
  															name: "message",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 770,
  															src: "17058:7:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														],
  														id: 781,
  														name: "keccak256",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5162,
  														src: "17048:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  															typeString: "function (bytes memory) pure returns (bytes32)"
  														}
  													},
  													id: 783,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "17048:18:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 778,
  													name: "abi",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5155,
  													src: "17018:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_abi",
  														typeString: "abi"
  													}
  												},
  												id: 779,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												memberName: "encode",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "17018:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
  													typeString: "function () pure returns (bytes memory)"
  												}
  											},
  											id: 784,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "17018:49:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 777,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "16995:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 785,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "16995:82:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "16969:108:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															hexValue: "30783139",
  															id: 791,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "17139:4:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_25_by_1",
  																typeString: "int_const 25"
  															},
  															value: "0x19"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_25_by_1",
  																typeString: "int_const 25"
  															}
  														],
  														id: 790,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "17134:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_bytes1_$",
  															typeString: "type(bytes1)"
  														},
  														typeName: "byte"
  													},
  													id: 792,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "17134:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															hexValue: "30783031",
  															id: 794,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "17151:4:0",
  															subdenomination: null,
  															typeDescriptions: {
  																typeIdentifier: "t_rational_1_by_1",
  																typeString: "int_const 1"
  															},
  															value: "0x01"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_1_by_1",
  																typeString: "int_const 1"
  															}
  														],
  														id: 793,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "17146:4:0",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_bytes1_$",
  															typeString: "type(bytes1)"
  														},
  														typeName: "byte"
  													},
  													id: 795,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "17146:10:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 796,
  													name: "domainSeparator",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 67,
  													src: "17158:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 797,
  													name: "safeMessageHash",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 776,
  													src: "17175:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													},
  													{
  														typeIdentifier: "t_bytes1",
  														typeString: "bytes1"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 788,
  													name: "abi",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5155,
  													src: "17117:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_abi",
  														typeString: "abi"
  													}
  												},
  												id: 789,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												memberName: "encodePacked",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "17117:16:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  													typeString: "function () pure returns (bytes memory)"
  												}
  											},
  											id: 798,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "17117:74:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 787,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "17094:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 799,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "17094:107:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								functionReturnParameters: 774,
  								id: 800,
  								nodeType: "Return",
  								src: "17087:114:0"
  							}
  						]
  					},
  					documentation: "@dev Returns hash of a message that can be signed by owners.\n @param message Message that should be hashed\n @return Message hash.",
  					id: 802,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getMessageHash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 771,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 770,
  								name: "message",
  								nodeType: "VariableDeclaration",
  								scope: 802,
  								src: "16874:20:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 769,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "16874:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16864:36:0"
  					},
  					returnParameters: {
  						id: 774,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 773,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 802,
  								src: "16946:7:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 772,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "16946:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "16945:9:0"
  					},
  					scope: 903,
  					src: "16841:367:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 860,
  						nodeType: "Block",
  						src: "18285:288:0",
  						statements: [
  							{
  								assignments: [
  									828
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 828,
  										name: "safeTxHash",
  										nodeType: "VariableDeclaration",
  										scope: 860,
  										src: "18295:18:0",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_bytes32",
  											typeString: "bytes32"
  										},
  										typeName: {
  											id: 827,
  											name: "bytes32",
  											nodeType: "ElementaryTypeName",
  											src: "18295:7:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 847,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 832,
  													name: "SAFE_TX_TYPEHASH",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 38,
  													src: "18350:16:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 833,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 804,
  													src: "18368:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 834,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 806,
  													src: "18372:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 836,
  															name: "data",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 808,
  															src: "18389:4:0",
  															typeDescriptions: {
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bytes_memory_ptr",
  																typeString: "bytes memory"
  															}
  														],
  														id: 835,
  														name: "keccak256",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 5162,
  														src: "18379:9:0",
  														typeDescriptions: {
  															typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  															typeString: "function (bytes memory) pure returns (bytes32)"
  														}
  													},
  													id: 837,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "18379:15:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 838,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 810,
  													src: "18396:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 839,
  													name: "safeTxGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 812,
  													src: "18407:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 840,
  													name: "baseGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 814,
  													src: "18418:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 841,
  													name: "gasPrice",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 816,
  													src: "18427:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 842,
  													name: "gasToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 818,
  													src: "18437:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 843,
  													name: "refundReceiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 820,
  													src: "18447:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 844,
  													name: "_nonce",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 822,
  													src: "18463:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes32",
  														typeString: "bytes32"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 830,
  													name: "abi",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 5155,
  													src: "18339:3:0",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_abi",
  														typeString: "abi"
  													}
  												},
  												id: 831,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												memberName: "encode",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "18339:10:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
  													typeString: "function () pure returns (bytes memory)"
  												}
  											},
  											id: 845,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "18339:131:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 829,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "18316:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 846,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "18316:164:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "18295:185:0"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													hexValue: "30783139",
  													id: 851,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "18519:4:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_25_by_1",
  														typeString: "int_const 25"
  													},
  													value: "0x19"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_25_by_1",
  														typeString: "int_const 25"
  													}
  												],
  												id: 850,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "18514:4:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_bytes1_$",
  													typeString: "type(bytes1)"
  												},
  												typeName: "byte"
  											},
  											id: 852,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "18514:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											}
  										},
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													hexValue: "30783031",
  													id: 854,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "18531:4:0",
  													subdenomination: null,
  													typeDescriptions: {
  														typeIdentifier: "t_rational_1_by_1",
  														typeString: "int_const 1"
  													},
  													value: "0x01"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_1_by_1",
  														typeString: "int_const 1"
  													}
  												],
  												id: 853,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "18526:4:0",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_bytes1_$",
  													typeString: "type(bytes1)"
  												},
  												typeName: "byte"
  											},
  											id: 855,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "18526:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 856,
  											name: "domainSeparator",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 67,
  											src: "18538:15:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 857,
  											name: "safeTxHash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 828,
  											src: "18555:10:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											},
  											{
  												typeIdentifier: "t_bytes1",
  												typeString: "bytes1"
  											},
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											},
  											{
  												typeIdentifier: "t_bytes32",
  												typeString: "bytes32"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 848,
  											name: "abi",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 5155,
  											src: "18497:3:0",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_abi",
  												typeString: "abi"
  											}
  										},
  										id: 849,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										lValueRequested: false,
  										memberName: "encodePacked",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "18497:16:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
  											typeString: "function () pure returns (bytes memory)"
  										}
  									},
  									id: 858,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "18497:69:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_memory_ptr",
  										typeString: "bytes memory"
  									}
  								},
  								functionReturnParameters: 826,
  								id: 859,
  								nodeType: "Return",
  								src: "18490:76:0"
  							}
  						]
  					},
  					documentation: "@dev Returns the bytes that are hashed to be signed by owners.\n @param to Destination address.\n @param value Ether value.\n @param data Data payload.\n @param operation Operation type.\n @param safeTxGas Fas that should be used for the safe transaction.\n @param baseGas Gas costs for data used to trigger the safe transaction.\n @param gasPrice Maximum gas price that should be used for this transaction.\n @param gasToken Token address (or 0 if ETH) that is used for the payment.\n @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n @param _nonce Transaction nonce.\n @return Transaction hash bytes.",
  					id: 861,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "encodeTransactionData",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 823,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 804,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "17961:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 803,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "17961:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 806,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "17981:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 805,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "17981:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 808,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18004:17:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 807,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "18004:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 810,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18031:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 809,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "18031:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 812,
  								name: "safeTxGas",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18065:17:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 811,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18065:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 814,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18092:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 813,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18092:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 816,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18117:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 815,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18117:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 818,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18143:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 817,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "18143:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 820,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18169:22:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 819,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "18169:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 822,
  								name: "_nonce",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18201:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 821,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "18201:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "17951:270:0"
  					},
  					returnParameters: {
  						id: 826,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 825,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 861,
  								src: "18267:12:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 824,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "18267:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "18266:14:0"
  					},
  					scope: 903,
  					src: "17921:652:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 901,
  						nodeType: "Block",
  						src: "19615:148:0",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 888,
  													name: "to",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 863,
  													src: "19664:2:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 889,
  													name: "value",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 865,
  													src: "19668:5:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 890,
  													name: "data",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 867,
  													src: "19675:4:0",
  													typeDescriptions: {
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 891,
  													name: "operation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 869,
  													src: "19681:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 892,
  													name: "safeTxGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 871,
  													src: "19692:9:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 893,
  													name: "baseGas",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 873,
  													src: "19703:7:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 894,
  													name: "gasPrice",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 875,
  													src: "19712:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 895,
  													name: "gasToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 877,
  													src: "19722:8:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 896,
  													name: "refundReceiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 879,
  													src: "19732:14:0",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 897,
  													name: "_nonce",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 881,
  													src: "19748:6:0",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_bytes_memory_ptr",
  														typeString: "bytes memory"
  													},
  													{
  														typeIdentifier: "t_enum$_Operation_$1993",
  														typeString: "enum Enum.Operation"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												id: 887,
  												name: "encodeTransactionData",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 861,
  												src: "19642:21:0",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$_t_enum$_Operation_$1993_$_t_uint256_$_t_uint256_$_t_uint256_$_t_address_$_t_address_$_t_uint256_$returns$_t_bytes_memory_ptr_$",
  													typeString: "function (address,uint256,bytes memory,enum Enum.Operation,uint256,uint256,uint256,address,address,uint256) view returns (bytes memory)"
  												}
  											},
  											id: 898,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "19642:113:0",
  											typeDescriptions: {
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bytes_memory_ptr",
  												typeString: "bytes memory"
  											}
  										],
  										id: 886,
  										name: "keccak256",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 5162,
  										src: "19632:9:0",
  										typeDescriptions: {
  											typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
  											typeString: "function (bytes memory) pure returns (bytes32)"
  										}
  									},
  									id: 899,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "19632:124:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								functionReturnParameters: 885,
  								id: 900,
  								nodeType: "Return",
  								src: "19625:131:0"
  							}
  						]
  					},
  					documentation: "@dev Returns hash to be signed by owners.\n @param to Destination address.\n @param value Ether value.\n @param data Data payload.\n @param operation Operation type.\n @param safeTxGas Fas that should be used for the safe transaction.\n @param baseGas Gas costs for data used to trigger the safe transaction.\n @param gasPrice Maximum gas price that should be used for this transaction.\n @param gasToken Token address (or 0 if ETH) that is used for the payment.\n @param refundReceiver Address of receiver of gas payment (or 0 if tx.origin).\n @param _nonce Transaction nonce.\n @return Transaction hash.",
  					id: 902,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getTransactionHash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 882,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 863,
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19296:10:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 862,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "19296:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 865,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19316:13:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 864,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19316:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 867,
  								name: "data",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19339:17:0",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes_memory_ptr",
  									typeString: "bytes"
  								},
  								typeName: {
  									id: 866,
  									name: "bytes",
  									nodeType: "ElementaryTypeName",
  									src: "19339:5:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes_storage_ptr",
  										typeString: "bytes"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 869,
  								name: "operation",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19366:24:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_enum$_Operation_$1993",
  									typeString: "enum Enum.Operation"
  								},
  								typeName: {
  									contractScope: null,
  									id: 868,
  									name: "Enum.Operation",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1993,
  									src: "19366:14:0",
  									typeDescriptions: {
  										typeIdentifier: "t_enum$_Operation_$1993",
  										typeString: "enum Enum.Operation"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 871,
  								name: "safeTxGas",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19400:17:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 870,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19400:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 873,
  								name: "baseGas",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19427:15:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 872,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19427:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 875,
  								name: "gasPrice",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19452:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 874,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19452:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 877,
  								name: "gasToken",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19478:16:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 876,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "19478:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 879,
  								name: "refundReceiver",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19504:22:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 878,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "19504:7:0",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 881,
  								name: "_nonce",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19536:14:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 880,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "19536:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "19286:270:0"
  					},
  					returnParameters: {
  						id: 885,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 884,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 902,
  								src: "19602:7:0",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bytes32",
  									typeString: "bytes32"
  								},
  								typeName: {
  									id: 883,
  									name: "bytes32",
  									nodeType: "ElementaryTypeName",
  									src: "19602:7:0",
  									typeDescriptions: {
  										typeIdentifier: "t_bytes32",
  										typeString: "bytes32"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "19601:9:0"
  					},
  					scope: 903,
  					src: "19259:504:0",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				}
  			],
  			scope: 904,
  			src: "652:19113:0"
  		}
  	],
  	src: "0:19766:0"
  };
  var compiler$2 = {
  	name: "solc",
  	version: "0.5.14+commit.01f1aaa4.Emscripten.clang"
  };
  var networks$2 = {
  	"1": {
  		links: {
  		},
  		events: {
  		},
  		address: "0xb6029EA3B2c51D09a50B53CA8012FeEB05bDa35A",
  		updated_at: 1554371714116
  	},
  	"4": {
  		links: {
  		},
  		events: {
  		},
  		address: "0xb6029EA3B2c51D09a50B53CA8012FeEB05bDa35A",
  		updated_at: 1554371714138
  	},
  	"5": {
  		links: {
  		},
  		events: {
  		},
  		address: "0xb6029EA3B2c51D09a50B53CA8012FeEB05bDa35A",
  		updated_at: 1554371714173
  	},
  	"42": {
  		links: {
  		},
  		events: {
  		},
  		address: "0xb6029EA3B2c51D09a50B53CA8012FeEB05bDa35A",
  		updated_at: 1554371714156
  	}
  };
  var schemaVersion$2 = "2.0.3";
  var updatedAt$2 = "2020-09-18T22:50:57.798Z";
  var GnosisSafeCRCVersionContract = {
  	contractName: contractName$3,
  	abi: abi$3,
  	bytecode: bytecode$3,
  	deployedBytecode: deployedBytecode$3,
  	sourceMap: sourceMap$2,
  	deployedSourceMap: deployedSourceMap$2,
  	source: source$2,
  	sourcePath: sourcePath$2,
  	ast: ast$2,
  	legacyAST: legacyAST$2,
  	compiler: compiler$2,
  	networks: networks$2,
  	schemaVersion: schemaVersion$2,
  	updatedAt: updatedAt$2
  };

  var contractName$2 = "Hub";
  var abi$2 = [
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "_inflation",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "_period",
  				type: "uint256"
  			},
  			{
  				internalType: "string",
  				name: "_symbol",
  				type: "string"
  			},
  			{
  				internalType: "string",
  				name: "_name",
  				type: "string"
  			},
  			{
  				internalType: "uint256",
  				name: "_signupBonus",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "_initialIssuance",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "_timeout",
  				type: "uint256"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "constructor"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "from",
  				type: "address"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "HubTransfer",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "organization",
  				type: "address"
  			}
  		],
  		name: "OrganizationSignup",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "token",
  				type: "address"
  			}
  		],
  		name: "Signup",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "canSendTo",
  				type: "address"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "limit",
  				type: "uint256"
  			}
  		],
  		name: "Trust",
  		type: "event"
  	},
  	{
  		inputs: [
  		],
  		name: "deployedAt",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "divisor",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "inflation",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "initialIssuance",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "limits",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "name",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "organizations",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "period",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		name: "seen",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "signupBonus",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "symbol",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "timeout",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "tokenToUser",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "userToToken",
  		outputs: [
  			{
  				internalType: "contract Token",
  				name: "",
  				type: "address"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		name: "validation",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "seen",
  				type: "bool"
  			},
  			{
  				internalType: "uint256",
  				name: "sent",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "received",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "periods",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "issuance",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "_periods",
  				type: "uint256"
  			}
  		],
  		name: "issuanceByStep",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "_initial",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "_periods",
  				type: "uint256"
  			}
  		],
  		name: "inflate",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "signup",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "organizationSignup",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "limit",
  				type: "uint256"
  			}
  		],
  		name: "trust",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "base",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "exponent",
  				type: "uint256"
  			}
  		],
  		name: "pow",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "pure",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "tokenOwner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "src",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "dest",
  				type: "address"
  			}
  		],
  		name: "checkSendLimit",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address[]",
  				name: "tokenOwners",
  				type: "address[]"
  			},
  			{
  				internalType: "address[]",
  				name: "srcs",
  				type: "address[]"
  			},
  			{
  				internalType: "address[]",
  				name: "dests",
  				type: "address[]"
  			},
  			{
  				internalType: "uint256[]",
  				name: "wads",
  				type: "uint256[]"
  			}
  		],
  		name: "transferThrough",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	}
  ];
  var metadata$1 = "{\"compiler\":{\"version\":\"0.7.1+commit.f4a555be\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_inflation\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_period\",\"type\":\"uint256\"},{\"internalType\":\"string\",\"name\":\"_symbol\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"_name\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"_signupBonus\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_initialIssuance\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeout\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"HubTransfer\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"organization\",\"type\":\"address\"}],\"name\":\"OrganizationSignup\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"address\",\"name\":\"token\",\"type\":\"address\"}],\"name\":\"Signup\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"canSendTo\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"limit\",\"type\":\"uint256\"}],\"name\":\"Trust\",\"type\":\"event\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"tokenOwner\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"src\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"dest\",\"type\":\"address\"}],\"name\":\"checkSendLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deployedAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"divisor\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_initial\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_periods\",\"type\":\"uint256\"}],\"name\":\"inflate\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"inflation\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"initialIssuance\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"issuance\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_periods\",\"type\":\"uint256\"}],\"name\":\"issuanceByStep\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"limits\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"name\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"organizationSignup\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"organizations\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"period\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"periods\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"base\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"exponent\",\"type\":\"uint256\"}],\"name\":\"pow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"seen\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"signup\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"signupBonus\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"symbol\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeout\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"tokenToUser\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address[]\",\"name\":\"tokenOwners\",\"type\":\"address[]\"},{\"internalType\":\"address[]\",\"name\":\"srcs\",\"type\":\"address[]\"},{\"internalType\":\"address[]\",\"name\":\"dests\",\"type\":\"address[]\"},{\"internalType\":\"uint256[]\",\"name\":\"wads\",\"type\":\"uint256[]\"}],\"name\":\"transferThrough\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"limit\",\"type\":\"uint256\"}],\"name\":\"trust\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"userToToken\",\"outputs\":[{\"internalType\":\"contract Token\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"validation\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"seen\",\"type\":\"bool\"},{\"internalType\":\"uint256\",\"name\":\"sent\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"received\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"checkSendLimit(address,address,address)\":{\"details\":\"the goal of this function is to always return a sensible number, it's used to validate transfer throughs, and also heavily in the graph/pathfinding services\",\"params\":{\"dest\":\"the recipient of the tokens\",\"src\":\"the sender of the tokens\",\"tokenOwner\":\"the safe/owner that the token was minted to\"},\"returns\":{\"_0\":\"the amount of tokenowner's token src can send to dest\"}},\"inflate(uint256,uint256)\":{\"details\":\"this is basically the calculation for compound interest, with some adjustments because of integer math\",\"params\":{\"_initial\":\"the starting issuance rate\",\"_periods\":\"the step to calculate the issuance rate as of\"},\"returns\":{\"_0\":\"initial issuance rate as if interest (inflation) has been compounded period times\"}},\"issuance()\":{\"details\":\"current issuance is the initial issuance inflated by the amount of inflation periods since the hub was deployed\",\"returns\":{\"_0\":\"current issuance rate\"}},\"issuanceByStep(uint256)\":{\"params\":{\"_periods\":\"the step to calculate the issuance rate at\"},\"returns\":{\"_0\":\"inflation rate as of the given period\"}},\"organizationSignup()\":{\"details\":\"signup is permanent for organizations too, there's no way to unsignup\"},\"periods()\":{\"returns\":{\"_0\":\"the amount of periods since hub was deployed\"}},\"pow(uint256,uint256)\":{\"details\":\"this is an implementation of exponentiation by squares\",\"params\":{\"base\":\"the base to be used in the calculation\",\"exponent\":\"the exponent to be used in the calculation\"},\"returns\":{\"_0\":\"the result of the calculation\"}},\"signup()\":{\"details\":\"signup is permanent, there's no way to unsignup\"},\"transferThrough(address[],address[],address[],uint256[])\":{\"details\":\"tokenOwners[0], srcs[0], dests[0], and wads[0] constitute a transaction step\",\"params\":{\"dests\":\"the recipient of each transaction step\",\"srcs\":\"the sender of each transaction step\",\"tokenOwners\":\"the owner of the tokens being sent in each transaction step\",\"wads\":\"the amount for each transaction step\"}},\"trust(address,uint256)\":{\"details\":\"the trust graph is weighted and directed\",\"params\":{\"limit\":\"the amount this user is trusted, as a percentage of 100\",\"user\":\"the user to be trusted\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"checkSendLimit(address,address,address)\":{\"notice\":\"finds the maximum amount of a specific token that can be sent between two users\"},\"inflate(uint256,uint256)\":{\"notice\":\"find the current issuance rate for any initial issuance and amount of periods\"},\"issuance()\":{\"notice\":\"calculates the current issuance rate per second\"},\"issuanceByStep(uint256)\":{\"notice\":\"finds the inflation rate at a given inflation period\"},\"organizationSignup()\":{\"notice\":\"register an organization address with the hub and join the trust graph\"},\"periods()\":{\"notice\":\"helper function for finding the amount of inflation periods since this hub was deployed\"},\"signup()\":{\"notice\":\"signup to this circles hub - create a circles token and join the trust graph\"},\"transferThrough(address[],address[],address[],uint256[])\":{\"notice\":\"walks through tokenOwners, srcs, dests, and amounts array and executes transtive transfer\"},\"trust(address,uint256)\":{\"notice\":\"trust a user, calling this means you're able to receive tokens from this user transitively\"}},\"version\":1}},\"settings\":{\"compilationTarget\":{\"project:/contracts/Hub.sol\":\"Hub\"},\"evmVersion\":\"istanbul\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":50},\"remappings\":[]},\"sources\":{\"@openzeppelin/contracts/math/SafeMath.sol\":{\"keccak256\":\"0xcc78a17dd88fa5a2edc60c8489e2f405c0913b377216a5b26b35656b2d0dab52\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://526dc85e1f9b9b45830e202568d267d93dde7a4fcccf4ad7798dadcd92304d3c\",\"dweb:/ipfs/QmaoXMB972J3cSDLtBq3xBo4jLwqD2uzXTwujtSPqkYVhR\"]},\"@openzeppelin/contracts/utils/Address.sol\":{\"keccak256\":\"0x28911e614500ae7c607a432a709d35da25f3bc5ddc8bd12b278b66358070c0ea\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://256c8c8af5eb072bc473226ab2b2187149b8fc04f5f4a4820db22527f5ce8e3c\",\"dweb:/ipfs/QmRvi5BhnL7Rxf85KrJhwM6RRhukm4tzoctRdgQEheNyiN\"]},\"project:/contracts/ERC20.sol\":{\"keccak256\":\"0xc6dbef9412a97afb7eadffbeccb8d48eec44b2a82fca4cbf8df5bace639ba5e7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://868329d2d2a6aa37bfb1b515e4b9de144c75ac537ff3f0aebe090e34a1e2c05c\",\"dweb:/ipfs/Qmb9HooNQfXYF1GF9FK9cTFRS7CziUZdtjQ56VFVyiLqy4\"]},\"project:/contracts/Hub.sol\":{\"keccak256\":\"0x5ee732e8d2c88a8a98ce70112cd4d6e326fc58e35e9947371832d29a705f6189\",\"license\":\"AGPL\",\"urls\":[\"bzz-raw://992d302213c9345b031d0ddba1cb0493be7117552da53c3c7f807af9673aa38f\",\"dweb:/ipfs/QmYYYrEbRPs1g7RS4QbJnH24teoWc7SqSLkYPEy3HS1DHo\"]},\"project:/contracts/Token.sol\":{\"keccak256\":\"0x45bebcf11ae3349ac3f11ec3beb55450467b15c04decc38a5bfc5984361bab23\",\"license\":\"AGPL\",\"urls\":[\"bzz-raw://9607064f6816c0e0d2d3eb8c14d34ced7281cf67fd766ea351f8adc6b9cbea57\",\"dweb:/ipfs/QmQ9zLLDf8tbAMGMJs9ym8fLi7d8uMM8VSiXaSgPEUJvd5\"]},\"project:/contracts/interfaces/HubI.sol\":{\"keccak256\":\"0xe42ec83e641359f276de4f5e2dc5c6b906e18cd81b2c46e0323ac6eb81285deb\",\"license\":\"AGPL\",\"urls\":[\"bzz-raw://bfa0ba0a68e968bd0525bde11c760088ffb0f0ab30f39aa78e3ce272d1a932b3\",\"dweb:/ipfs/QmeadYT4y4mRDnadWaQaCyLrTUytmbUKyAMYQgLWMbXVHh\"]}},\"version\":1}";
  var bytecode$2 = "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";
  var deployedBytecode$2 = "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";
  var immutableReferences$1 = {
  	"1140": [
  		{
  			length: 32,
  			start: 1949
  		},
  		{
  			length: 32,
  			start: 4733
  		}
  	],
  	"1142": [
  		{
  			length: 32,
  			start: 1879
  		},
  		{
  			length: 32,
  			start: 1997
  		}
  	],
  	"1144": [
  		{
  			length: 32,
  			start: 4260
  		},
  		{
  			length: 32,
  			start: 5411
  		}
  	],
  	"1150": [
  		{
  			length: 32,
  			start: 2567
  		}
  	],
  	"1152": [
  		{
  			length: 32,
  			start: 2527
  		},
  		{
  			length: 32,
  			start: 2722
  		},
  		{
  			length: 32,
  			start: 5447
  		}
  	],
  	"1154": [
  		{
  			length: 32,
  			start: 4298
  		},
  		{
  			length: 32,
  			start: 5375
  		}
  	],
  	"1156": [
  		{
  			length: 32,
  			start: 2603
  		}
  	]
  };
  var sourceMap$1 = "133:16401:3:-:0;;;1724:523;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1724:523:3;;;;;;;;;;-1:-1:-1;1724:523:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1724:523:3;;;;;;;;;;-1:-1:-1;1724:523:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1724:523:3;;;;;;;;;;;;;;;;;;1955:22;;;1724:523;;-1:-1:-1;1724:523:3;;-1:-1:-1;1997:23:3;1967:10;1997:11;:23::i;:::-;1987:33;;2030:16;;;;2056;;;;:6;;:16;;;;;:::i;:::-;-1:-1:-1;2082:12:3;;;;:4;;:12;;;;;:::i;:::-;-1:-1:-1;2104:26:3;;;;;2140:34;;2197:15;2184:28;;2222:18;;-1:-1:-1;133:16401:3;;-1:-1:-1;;;133:16401:3;2534:209;2592:7;;2637:70;2670:1;2644:23;2653:13;2657:2;2661:4;2653:3;:13::i;:::-;2644:4;:8;;;;;;:23;;;;:::i;:::-;:27;2637:70;;;2695:1;2687:9;2637:70;;;2723:13;2727:2;2731:4;2723:3;:13::i;:::-;2716:20;2534:209;-1:-1:-1;;;2534:209:3:o;7924:637::-;7990:7;8013:9;8009:48;;-1:-1:-1;8045:1:3;8038:8;;8009:48;8070:13;8066:52;;-1:-1:-1;8106:1:3;8099:8;;8066:52;8131:8;8143:1;8131:13;8127:55;;;-1:-1:-1;8167:4:3;8160:11;;8127:55;8203:1;8214:313;8231:1;8220:8;:12;8214:313;;;8251:15;8264:1;8251:8;:12;;;;;;:15;;;;:::i;:::-;8248:269;;8298:14;8307:4;8298;:8;;;;;;:14;;;;:::i;:::-;8291:21;;8341:15;8354:1;8341:8;:12;;;;;;:15;;;;:::i;:::-;8330:26;;8248:269;;;8399:11;8408:1;8399:4;:8;;;;;;:11;;;;:::i;:::-;8395:15;;8435:14;8444:4;8435;:8;;;;;;:14;;;;:::i;:::-;8428:21;;8478:24;8500:1;8479:15;8492:1;8479:8;:12;;;;;;:15;;;;:::i;:::-;8478:21;;;;;;:24;;;;:::i;:::-;8467:35;;8248:269;8214:313;;;8543:11;8552:1;8543:4;:8;;;;;;:11;;;;:::i;:::-;8536:18;;;7924:637;;;;;:::o;4217:150:0:-;4275:7;4306:1;4302;:5;4294:44;;;;;-1:-1:-1;;;4294:44:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;4359:1;4355;:5;;;;;;;4217:150;-1:-1:-1;;;4217:150:0:o;4820:148::-;4878:7;4909:1;4905;:5;4897:42;;;;;-1:-1:-1;;;4897:42:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;4960:1;4956;:5;;;;;;;4820:148;-1:-1:-1;;;4820:148:0:o;3538:215::-;3596:7;3619:6;3615:20;;-1:-1:-1;3634:1:0;3627:8;;3615:20;3657:5;;;3661:1;3657;:5;:1;3680:5;;;;;:10;3672:56;;;;-1:-1:-1;;;3672:56:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3136:155;3194:7;3226:1;3221;:6;;3213:49;;;;;-1:-1:-1;;;3213:49:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3279:5:0;;;3136:155::o;133:16401:3:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;133:16401:3;;;-1:-1:-1;133:16401:3;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;";
  var deployedSourceMap$1 = "133:16401:3:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;525:18;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;310:32;;;:::i;:::-;;;;;;;;;;;;;;;;962:45;;;;;;;;;;;;;;;;-1:-1:-1;962:45:3;-1:-1:-1;;;;;962:45:3;;:::i;:::-;;;;-1:-1:-1;;;;;962:45:3;;;;;;;;;;;;;;4135:455;;;;;;;;;;;;;;;;-1:-1:-1;4135:455:3;;;;;;;:::i;7924:637::-;;;;;;;;;;;;;;;;-1:-1:-1;7924:637:3;;;;;;;:::i;5602:460::-;;;:::i;:::-;;1066:46;;;;;;;;;;;;;;;;-1:-1:-1;1066:46:3;-1:-1:-1;;;;;1066:46:3;;:::i;:::-;;;;;;;;;;;;;;;;;;3570:130;;;;;;;;;;;;;;;;-1:-1:-1;3570:130:3;;:::i;549:36::-;;;:::i;849:32::-;;;:::i;1634:56::-;;;;;;;;;;;;;;;;-1:-1:-1;1634:56:3;-1:-1:-1;;;;;1634:56:3;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1696:21;;;;;;;;;;;;;;;;-1:-1:-1;1696:21:3;;:::i;3265:109::-;;;:::i;9065:1691::-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;9065:1691:3;;;;;;;;;;;;;;;;;;;:::i;499:20::-;;;:::i;6349:991::-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;6349:991:3;;;;;;;;:::i;1013:47::-;;;;;;;;;;;;;;;;-1:-1:-1;1013:47:3;-1:-1:-1;;;;;1013:47:3;;:::i;1118:63::-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;1118:63:3;;;;;;;;;;:::i;2914:118::-;;;:::i;4750:676::-;;;:::i;185:34::-;;;:::i;15284:1248::-;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;15284:1248:3;;;;;;;;-1:-1:-1;15284:1248:3;;-1:-1:-1;;;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;15284:1248:3;;;;;;;;-1:-1:-1;15284:1248:3;;-1:-1:-1;;;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;15284:1248:3;;;;;;;;-1:-1:-1;15284:1248:3;;-1:-1:-1;;;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;15284:1248:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;15284:1248:3;;-1:-1:-1;15284:1248:3;;-1:-1:-1;;;;;15284:1248:3:i;761:35::-;;;:::i;412:31::-;;;:::i;639:40::-;;;:::i;525:18::-;;;;;;;;;;;;;;;-1:-1:-1;;525:18:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;310:32::-;;;:::o;962:45::-;;;;;;;;;;;;-1:-1:-1;;;;;962:45:3;;:::o;4135:455::-;4209:7;4462:9;4474:24;4478:9;4489:8;4474:3;:24::i;:::-;4462:36;;4508:9;4520:22;4524:7;4533:8;4520:3;:22::i;:::-;4508:34;-1:-1:-1;4559:24:3;4508:34;4560:15;:8;4573:1;4560:12;:15::i;:::-;4559:21;;:24::i;:::-;4552:31;;;;4135:455;;;;;:::o;7924:637::-;7990:7;8013:9;8009:48;;-1:-1:-1;8045:1:3;8038:8;;8009:48;8070:13;8066:52;;-1:-1:-1;8106:1:3;8099:8;;8066:52;8131:8;8143:1;8131:13;8127:55;;;-1:-1:-1;8167:4:3;8160:11;;8127:55;8203:1;8214:313;8231:1;8220:8;:12;8214:313;;;8251:15;:8;8264:1;8251:12;:15::i;:::-;8248:269;;8298:14;8307:4;;8298:8;:14::i;:::-;8291:21;-1:-1:-1;8341:15:3;:8;8354:1;8341:12;:15::i;:::-;8330:26;;8248:269;;;8399:11;:4;8408:1;8399:8;:11::i;:::-;8395:15;-1:-1:-1;8435:14:3;8444:4;;8435:8;:14::i;:::-;8428:21;-1:-1:-1;8478:24:3;8500:1;8479:15;:8;8492:1;8479:12;:15::i;8478:24::-;8467:35;;8248:269;8214:313;;;8543:11;:4;8552:1;8543:8;:11::i;:::-;8536:18;7924:637;-1:-1:-1;;;;7924:637:3:o;5602:460::-;5742:10;5766:1;5730:23;;;:11;:23;;;;;;-1:-1:-1;;;;;5730:23:3;5722:46;5714:102;;;;-1:-1:-1;;;5714:102:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5899:10;5885:25;;;;:13;:25;;;;;;;;:34;5877:89;;;;-1:-1:-1;;;5877:89:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5991:10;5977:25;;;;:13;:25;;;;;;:32;;-1:-1:-1;;5977:32:3;6005:4;5977:32;;;6025:30;;;5977:25;6025:30;5602:460::o;1066:46::-;;;;;;;;;;;;;;;:::o;3570:130::-;3633:7;3659:34;3667:15;3684:8;3659:7;:34::i;549:36::-;;;:::o;849:32::-;;;:::o;1634:56::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1696:21::-;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;1696:21:3;;-1:-1:-1;1696:21:3;:::o;3265:109::-;3306:7;3332:35;3340:15;3357:9;:7;:9::i;:::-;3332:7;:35::i;:::-;3325:42;;3265:109;:::o;9065:1691::-;-1:-1:-1;;;;;9210:12:3;;;9157:7;9210:12;;;:6;:12;;;;;;;;:24;;;;;;;;;;;;9206:68;;-1:-1:-1;9262:1:3;9255:8;;9206:68;-1:-1:-1;;;;;9358:17:3;;;9388:1;9358:17;;;:11;:17;;;;;;;9350:40;:64;;;;-1:-1:-1;;;;;;9395:19:3;;;;;;:13;:19;;;;;;;;9394:20;9350:64;9346:104;;;-1:-1:-1;9438:1:3;9431:8;;9346:104;-1:-1:-1;;;;;9536:23:3;;;9572:1;9536:23;;;:11;:23;;;;;;;9524:86;;-1:-1:-1;9598:1:3;9591:8;;9524:86;-1:-1:-1;;;;;9641:23:3;;;9620:18;9641:23;;;:11;:23;;;;;;;;;:38;;-1:-1:-1;;;9641:38:3;;;;;;;;;;;9620:18;;9641:23;;:33;;:38;;;;;:23;;:38;;;;;;:23;:38;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;9641:38:3;;-1:-1:-1;;;;;;9877:18:3;;;;;;;;:41;;-1:-1:-1;;;;;;9899:19:3;;;;;;:13;:19;;;;;;;;9877:41;9873:89;;;9941:10;-1:-1:-1;9934:17:3;;9873:89;-1:-1:-1;;;;;10069:23:3;;;10047:19;10069:23;;;:11;:23;;;;;;;;;:39;;-1:-1:-1;;;10069:39:3;;;;;;;;;;;10047:19;;10069:23;;:33;;:39;;;;;:23;;:39;;;;;;:23;:39;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;10069:39:3;-1:-1:-1;;;;;10302:12:3;;;10119:18;10302:12;;;:6;10069:39;10302:12;;;;;;;:24;;;;;;;;;;;10264:17;;;:11;:17;;;;;;:33;;-1:-1:-1;;;10264:33:3;;;;;;;;;;;10069:39;;-1:-1:-1;10140:3:3;;10119:18;;10263:81;;10140:3;;10264:63;;10302:24;;10264:17;;;;:27;;:33;;;;;;;;;;:17;:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;10264:33:3;;:37;:63::i;10263:81::-;10249:95;;10472:11;10466:3;:17;10462:31;;;10492:1;10485:8;;;;;;;;10462:31;-1:-1:-1;;;;;10563:12:3;;;10504:25;10563:12;;;:6;:12;;;;;;;;:24;;;;;;;;;;;;10532:73;;10594:10;;10532:57;;10548:40;;10594:10;;10548:14;:40::i;:::-;10532:11;;:15;:57::i;:73::-;10504:101;-1:-1:-1;10723:26:3;:3;10504:101;10723:7;:26::i;:::-;10716:33;;;;;;;9065:1691;;;;;;:::o;499:20::-;;;;;;;;;;;;;;;-1:-1:-1;;499:20:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6349:991;6529:10;6553:1;6517:23;;;:11;:23;;;;;;-1:-1:-1;;;;;6517:23:3;6509:46;;;:75;;-1:-1:-1;6573:10:3;6559:25;;;;:13;:25;;;;;;;;6509:75;6501:137;;;;-1:-1:-1;;;6501:137:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6708:10;-1:-1:-1;;;;;6708:18:3;;;;6700:57;;;;;-1:-1:-1;;;6700:57:3;;;;;;;;;;;;-1:-1:-1;;;6700:57:3;;;;;;;;;;;;;;;-1:-1:-1;;;;;6889:19:3;;;;;;:13;:19;;;;;;;;:28;6881:72;;;;;-1:-1:-1;;;6881:72:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;7009:3;7000:5;:12;;6992:62;;;;-1:-1:-1;;;6992:62:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7195:10;7181:25;;;;:13;:25;;;;;;;;7177:128;;;7230:10;;;:26;;;7244:5;7253:3;7244:12;7230:26;7222:72;;;;-1:-1:-1;;;7222:72:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7314:19;7321:4;7327:5;7314:6;:19::i;:::-;6349:991;;:::o;1013:47::-;;;;;;;;;;;;-1:-1:-1;;;;;1013:47:3;;:::o;1118:63::-;;;;;;;;;;;;;;;;;;;;;;;;:::o;2914:118::-;2954:7;2980:45;3018:6;2981:31;:15;3001:10;2981:19;:31::i;4750:676::-;4855:10;4879:1;4843:23;;;:11;:23;;;;;;-1:-1:-1;;;;;4843:23:3;4835:46;4827:82;;;;;-1:-1:-1;;;4827:82:3;;;;;;;;;;;;-1:-1:-1;;;4827:82:3;;;;;;;;;;;;;;;4993:10;4979:25;;;;:13;:25;;;;;;;;:34;4971:90;;;;-1:-1:-1;;;4971:90:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5072:11;5096:10;5086:21;;;;;:::i;:::-;-1:-1:-1;;;;;5086:21:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;5129:10:3;5117:23;;;;:11;:23;;;;;;;;:31;;-1:-1:-1;;;;;5117:31:3;;-1:-1:-1;;;;;;5117:31:3;;;;;;;;5158:27;;;:11;:27;;;;;;:40;;;;;;;;;5072:35;;-1:-1:-1;5346:23:3;;5365:3;5346:6;:23::i;:::-;5385:34;;;-1:-1:-1;;;;;5385:34:3;;;;;;5392:10;;5385:34;;;;;;;;;;4750:676;:::o;185:34::-;;;:::o;15284:1248::-;15535:11;:18;15519:5;:12;:34;15511:89;;;;-1:-1:-1;;;15511:89:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15633:11;:18;15618:4;:11;:33;15610:87;;;;-1:-1:-1;;;15610:87:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15730:11;:18;15715:4;:11;:33;15707:90;;;;-1:-1:-1;;;15707:90:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15812:6;15807:613;15828:4;:11;15824:1;:15;15807:613;;;15860:11;15874:4;15879:1;15874:7;;;;;;;;;;;;;;15860:21;;15895:12;15910:5;15916:1;15910:8;;;;;;;;;;;;;;15895:23;;15932:13;15948:11;15960:1;15948:14;;;;;;;;;;;;;;15932:30;;15976:11;15990:4;15995:1;15990:7;;;;;;;;;;;;;;15976:21;;16079:11;16093:32;16108:5;16115:3;16120:4;16093:14;:32::i;:::-;16079:46;;16154:3;16147;:10;;16139:43;;;;;-1:-1:-1;;;16139:43:3;;;;;;;;;;;;-1:-1:-1;;;16139:43:3;;;;;;;;;;;;;;;16197:35;16217:3;16222:4;16228:3;16197:19;:35::i;:::-;-1:-1:-1;;;;;16363:18:3;;;;;;;:11;:18;;;;;;;;;:46;;-1:-1:-1;;;16363:46:3;;;;;;;;;;;;;;;;;;;;;;;;:18;;;:30;;:46;;;;;:18;:46;;;;;;;:18;:46;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;15841:3:3;;;;;-1:-1:-1;15807:613:3;;-1:-1:-1;;;;15807:613:3;;;16489:36;16513:4;:11;16489:23;:36::i;:::-;15284:1248;;;;:::o;761:35::-;;;:::o;412:31::-;;;:::o;639:40::-;;;:::o;4217:150:0:-;4275:7;4306:1;4302;:5;4294:44;;;;;-1:-1:-1;;;4294:44:0;;;;;;;;;;;;-1:-1:-1;;;4294:44:0;;;;;;;;;;;;;;;4359:1;4355;:5;;;;;;;4217:150;-1:-1:-1;;;4217:150:0:o;4820:148::-;4878:7;4909:1;4905;:5;4897:42;;;;;-1:-1:-1;;;4897:42:0;;;;;;;;;;;;-1:-1:-1;;;4897:42:0;;;;;;;;;;;;;;;4960:1;4956;:5;;;;;;;4820:148;-1:-1:-1;;;4820:148:0:o;3538:215::-;3596:7;3619:6;3615:20;;-1:-1:-1;3634:1:0;3627:8;;3615:20;3657:5;;;3661:1;3657;:5;:1;3680:5;;;;;:10;3672:56;;;;-1:-1:-1;;;3672:56:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3136:155;3194:7;3226:1;3221;:6;;3213:49;;;;;-1:-1:-1;;;3213:49:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3279:5:0;;;3136:155::o;7533:145:3:-;7601:10;7594:18;;;;:6;:18;;;;;;;;-1:-1:-1;;;;;7594:24:3;;;;;;;;;;;;:32;;;7641:30;;;;;;;7594:24;;7601:10;7641:30;;;;;;;;;;;7533:145;;:::o;11072:1162::-;-1:-1:-1;;;;;11445:15:3;;;;;;:10;:15;;;;;:20;;;:29;11441:378;;-1:-1:-1;;;;;11588:15:3;;;;;;:10;:15;;;;;:20;;;:29;;11613:3;11588:24;:29::i;:::-;-1:-1:-1;;;;;11565:15:3;;;;;;:10;:15;;;;;:20;;:52;11441:378;;;-1:-1:-1;;;;;11713:15:3;;;;;;:10;:15;;;;;:27;;-1:-1:-1;;11713:27:3;11736:4;11713:27;;;;;11754:20;;;:26;;;11794:4;:14;;;;;;;;;;;;;;-1:-1:-1;;;;;;11794:14:3;;;;;;11441:378;-1:-1:-1;;;;;11832:16:3;;;;;;:10;:16;;;;;:21;;;:30;11828:400;;-1:-1:-1;;;;;11981:16:3;;;;;;:10;:16;;;;;:25;;;:34;;12011:3;11981:29;:34::i;:::-;-1:-1:-1;;;;;11953:16:3;;;;;;:10;:16;;;;;:25;;:62;11828:400;;;-1:-1:-1;;;;;12111:16:3;;;;;;:10;:16;;;;;:28;;-1:-1:-1;;12111:28:3;12135:4;12111:28;;;;;12153:25;;;;:31;;;12199:4;:15;;;;;;;;;;;;;;-1:-1:-1;;;;;;12199:15:3;;;;;;11828:400;11072:1162;;;:::o;12385:2437::-;12514:11;12535:12;12659:6;12654:944;12675:4;:11;12671:15;;12654:944;;;12707:29;;:::i;:::-;12739:10;:19;12750:4;12755:1;12750:7;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;12750:7:3;12739:19;;;;;;;;;;;;;;;12707:51;;;;;;;;;;;;;;;12750:7;12707:51;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;12852:403:3;;;-1:-1:-1;;;;;12984:17:3;;;12976:63;;;;-1:-1:-1;;;12976:63:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13153:10;-1:-1:-1;;;;;13142:21:3;:4;13147:1;13142:7;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13142:7:3;:21;13134:75;;;;-1:-1:-1;;;13134:75:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13233:4;13238:1;13233:7;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13233:7:3;;-1:-1:-1;12852:403:3;13371:4;:9;;;13355:4;:13;;;:25;13351:237;;;-1:-1:-1;;;;;13486:18:3;;;13478:63;;;;;-1:-1:-1;;;13478:63:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13566:4;13571:1;13566:7;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13566:7:3;;-1:-1:-1;13351:237:3;-1:-1:-1;12688:3:3;;12654:944;;;-1:-1:-1;;;;;;13673:17:3;;13665:57;;;;;-1:-1:-1;;;13665:57:3;;;;;;;;;;;;-1:-1:-1;;;13665:57:3;;;;;;;;;;;;;;;-1:-1:-1;;;;;13740:18:3;;13732:59;;;;;-1:-1:-1;;;13732:59:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13987:15:3;;;;;;:10;:15;;;;;:24;;;:29;13979:61;;;;;-1:-1:-1;;;13979:61:3;;;;;;;;;;;;-1:-1:-1;;;13979:61:3;;;;;;;;;;;;;;;-1:-1:-1;;;;;14058:16:3;;;;;;:10;:16;;;;;:21;;;:26;14050:59;;;;;-1:-1:-1;;;14050:59:3;;;;;;;;;;;;-1:-1:-1;;;14050:59:3;;;;;;;;;;;;;;;-1:-1:-1;;;;;14235:16:3;;;;;;;:10;:16;;;;;;:25;;;14211:15;;;;;;;:20;;;:49;14203:95;;;;-1:-1:-1;;;14203:95:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14408:4;:11;14431:1;14423:9;;-1:-1:-1;14408:24:3;14400:60;;;;;-1:-1:-1;;;14400:60:3;;;;;;;;;;;;-1:-1:-1;;;14400:60:3;;;;;;;;;;;;;;;-1:-1:-1;;;;;14475:44:3;;;14498:15;;;;:10;:15;;;;;;;;;:20;;;14475:44;;;;;;;;;;;;;;;;;;;;;14593:4;:11;14579:93;14611:1;14606;:6;14579:93;;14640:10;:21;14651:4;14658:1;14656;:3;14651:9;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;14651:9:3;14640:21;;;;;;;;;;;;14633:28;;-1:-1:-1;;14633:28:3;;;14651:9;14633:28;;;;;;;;-1:-1:-1;;14614:3:3;14579:93;;;-1:-1:-1;14681:11:3;14688:4;;14681:11;:::i;:::-;14774:4;:11;:16;14766:49;;;;;-1:-1:-1;;;14766:49:3;;;;;;;;;;;;-1:-1:-1;;;14766:49:3;;;;;;;;;;;;;;2690:175:0;2748:7;2779:5;;;2802:6;;;;2794:46;;;;;-1:-1:-1;;;2794:46:0;;;;;;;;;;;;-1:-1:-1;;;2794:46:0;;;;;;;;;;;;;;-1:-1:-1;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::o;:::-;;;;;;;;;;;;;;;;;;:::o";
  var source$1 = "// SPDX-License-Identifier: AGPL\npragma solidity ^0.7.0;\n\nimport \"@openzeppelin/contracts/math/SafeMath.sol\";\nimport \"./Token.sol\";\n\ncontract Hub {\n    using SafeMath for uint256;\n\n    uint256 public immutable inflation; // the inflation rate expressed as 1 + percentage inflation, aka 7% inflation is 107\n    uint256 public immutable divisor; // the largest power of 10 the inflation rate can be divided by\n    uint256 public immutable period; // the amount of sections between inflation steps\n    string public symbol;\n    string public name;\n    uint256 public immutable signupBonus; // a one-time payout made immediately on signup\n    uint256 public immutable initialIssuance; // the starting payout per second, this gets inflated by the inflation rate\n    uint256 public immutable deployedAt; // the timestamp this contract was deployed at\n    uint256 public immutable timeout; // longest a token can go without a ubi payout before it gets deactivated\n\n    mapping (address => Token) public userToToken;\n    mapping (address => address) public tokenToUser;\n    mapping (address => bool) public organizations;\n    mapping (address => mapping (address => uint256)) public limits;\n\n    event Signup(address indexed user, address token);\n    event OrganizationSignup(address indexed organization);\n    event Trust(address indexed canSendTo, address indexed user, uint256 limit);\n    event HubTransfer(address indexed from, address indexed to, uint256 amount);\n\n    // some data types used for validating transitive transfers\n    struct transferValidator {\n        bool seen;\n        uint256 sent;\n        uint256 received;\n    }\n    mapping (address => transferValidator) public validation;\n    address[] public seen;\n\n    constructor(\n        uint256 _inflation,\n        uint256 _period,\n        string memory _symbol,\n        string memory _name,\n        uint256 _signupBonus,\n        uint256 _initialIssuance,\n        uint256 _timeout\n    ) {\n        inflation = _inflation;\n        divisor = findDivisor(_inflation);\n        period = _period;\n        symbol = _symbol;\n        name = _name;\n        signupBonus = _signupBonus;\n        initialIssuance = _initialIssuance;\n        deployedAt = block.timestamp;\n        timeout = _timeout;\n    }\n\n    /// @notice calculates the correct divisor for the given inflation rate\n    /// @dev the divisor is used to maintain precision when doing math with percentages\n    /// @param _inf the inflation rate\n    /// @return the largest power of ten the inflation rate can be divided by\n    function findDivisor(uint256 _inf) internal pure returns (uint256) {\n        uint256 iter = 0;\n        while (_inf.div(pow(10, iter)) > 9) {\n            iter += 1;\n        }\n        return pow(10, iter);\n    }\n\n    /// @notice helper function for finding the amount of inflation periods since this hub was deployed\n    /// @return the amount of periods since hub was deployed\n    function periods() public view returns (uint256) {\n        return (block.timestamp.sub(deployedAt)).div(period);\n    }\n\n    /// @notice calculates the current issuance rate per second\n    /// @dev current issuance is the initial issuance inflated by the amount of inflation periods since the hub was deployed\n    /// @return current issuance rate\n    function issuance() public view returns (uint256) {\n        return inflate(initialIssuance, periods());\n    }\n\n    /// @notice finds the inflation rate at a given inflation period\n    /// @param _periods the step to calculate the issuance rate at\n    /// @return inflation rate as of the given period\n    function issuanceByStep(uint256 _periods) public view returns (uint256) {\n        return inflate(initialIssuance, _periods);\n    }\n\n    /// @notice find the current issuance rate for any initial issuance and amount of periods\n    /// @dev this is basically the calculation for compound interest, with some adjustments because of integer math\n    /// @param _initial the starting issuance rate\n    /// @param _periods the step to calculate the issuance rate as of\n    /// @return initial issuance rate as if interest (inflation) has been compounded period times\n    function inflate(uint256 _initial, uint256 _periods) public view returns (uint256) {\n        // this returns P * (1 + r) ** t - which is a the formula for compound interest if \n        // interest is compounded only once per period\n        // in our case, currentIssuanceRate = initialIssuance * (inflation) ** periods\n        uint256 q = pow(inflation, _periods);\n        uint256 d = pow(divisor, _periods);\n        return (_initial.mul(q)).div(d);\n    }\n\n    /// @notice signup to this circles hub - create a circles token and join the trust graph\n    /// @dev signup is permanent, there's no way to unsignup\n    function signup() public {\n        // signup can only be called once\n        require(address(userToToken[msg.sender]) == address(0), \"You can't sign up twice\");\n        // organizations cannot sign up for a token\n        require(organizations[msg.sender] == false, \"Organizations cannot signup as normal users\");\n\n        Token token = new Token(msg.sender);\n        userToToken[msg.sender] = token;\n        tokenToUser[address(token)] = msg.sender;\n        // every user must trust themselves with a weight of 100\n        // this is so that all users accept their own token at all times\n        _trust(msg.sender, 100);\n\n        emit Signup(msg.sender, address(token));\n    }\n\n    /// @notice register an organization address with the hub and join the trust graph\n    /// @dev signup is permanent for organizations too, there's no way to unsignup\n    function organizationSignup() public {\n        // can't register as an organization if you have a token\n        require(address(userToToken[msg.sender]) == address(0), \"Normal users cannot signup as organizations\");\n        // can't register as an organization twice\n        require(organizations[msg.sender] == false, \"You can't sign up as an organization twice\");\n\n        organizations[msg.sender] = true;\n\n        emit OrganizationSignup(msg.sender);\n    }\n\n    /// @notice trust a user, calling this means you're able to receive tokens from this user transitively\n    /// @dev the trust graph is weighted and directed\n    /// @param user the user to be trusted\n    /// @param limit the amount this user is trusted, as a percentage of 100\n    function trust(address user, uint limit) public {\n        // only users who have signed up as tokens or organizations can enter the trust graph\n        require(address(userToToken[msg.sender]) != address(0) || organizations[msg.sender], \"You can only trust people after you've signed up!\");\n        // you must continue to trust yourself 100%\n        require(msg.sender != user, \"You can't untrust yourself\");\n        // organizations can't receive trust since they don't have their own token (ie. there's nothing to trust)\n        require(organizations[user] == false, \"You can't trust an organization\");\n        // must a percentage\n        require(limit <= 100, \"Limit must be a percentage out of 100\");\n        // organizations don't have a token to base send limits off of, so they can only trust at rates 0 or 100\n        if (organizations[msg.sender]) {\n            require(limit == 0 || limit == 100, \"Trust is binary for organizations\");\n        }\n        _trust(user, limit);\n    }\n\n    /// @dev used internally in both the trust function and signup\n    /// @param user the user to be trusted\n    /// @param limit the amount this user is trusted, as a percentage of 100\n    function _trust(address user, uint limit) internal {\n        limits[msg.sender][user] = limit;\n        emit Trust(msg.sender, user, limit);\n    }\n\n    /// @dev this is an implementation of exponentiation by squares\n    /// @param base the base to be used in the calculation\n    /// @param exponent the exponent to be used in the calculation\n    /// @return the result of the calculation\n    function pow(uint256 base, uint256 exponent) public pure returns (uint256) {\n        if (base == 0) {\n            return 0;\n        }\n        if (exponent == 0) {\n            return 1;\n        }\n        if (exponent == 1) {\n            return base;\n        }\n        uint256 y = 1;\n        while(exponent > 1) {\n            if(exponent.mod(2) == 0) {\n                base = base.mul(base);\n                exponent = exponent.div(2);\n            } else {\n                y = base.mul(y);\n                base = base.mul(base);\n                exponent = (exponent.sub(1)).div(2);\n            }\n        }\n        return base.mul(y);\n    }\n\n    /// @notice finds the maximum amount of a specific token that can be sent between two users\n    /// @dev the goal of this function is to always return a sensible number, it's used to validate transfer throughs, and also heavily in the graph/pathfinding services\n    /// @param tokenOwner the safe/owner that the token was minted to\n    /// @param src the sender of the tokens\n    /// @param dest the recipient of the tokens\n    /// @return the amount of tokenowner's token src can send to dest\n    function checkSendLimit(address tokenOwner, address src, address dest) public view returns (uint256) {\n\n        // there is no trust\n        if (limits[dest][tokenOwner] == 0) {\n            return 0;\n        }\n\n        // if dest hasn't signed up, they cannot trust anyone\n        if (address(userToToken[dest]) == address(0) && !organizations[dest] ) {\n            return 0;\n        }\n\n        //if the token doesn't exist, it can't be sent/accepted\n        if (address(userToToken[tokenOwner]) == address(0)) {\n             return 0;\n        }\n\n        uint256 srcBalance = userToToken[tokenOwner].balanceOf(src);\n\n        // if sending dest's token to dest, src can send 100% of their holdings\n        // for organizations, trust is binary - if trust is not 0, src can send 100% of their holdings\n        if (tokenOwner == dest || organizations[dest]) {\n            return srcBalance;\n        }\n\n        // find the amount dest already has of the token that's being sent\n        uint256 destBalance = userToToken[tokenOwner].balanceOf(dest);\n\n        uint256 oneHundred = 100;\n        \n        // find the maximum possible amount based on dest's trust limit for this token\n        uint256 max = (userToToken[dest].balanceOf(dest).mul(limits[dest][tokenOwner])).div(oneHundred);\n        \n        // if trustLimit has already been overriden by a direct transfer, nothing more can be sent\n        if (max < destBalance) return 0;\n\n        uint256 destBalanceScaled = destBalance.mul(oneHundred.sub(limits[dest][tokenOwner])).div(oneHundred);\n        \n        // return the max amount dest is willing to hold minus the amount they already have\n        return max.sub(destBalanceScaled);\n    }\n\n    /// @dev builds the validation data structures, called for each transaction step of a transtive transactions\n    /// @param src the sender of a single transaction step\n    /// @param dest the recipient of a single transaction step\n    /// @param wad the amount being passed along a single transaction step\n    function buildValidationData(address src, address dest, uint wad) internal {\n        // the validation mapping has this format\n        // { address: {\n        //     seen: whether this user is part of the transaction,\n        //     sent: total amount sent by this user,\n        //     received: total amount received by this user,\n        //    }\n        // }\n        if (validation[src].seen != false) {\n            // if we have seen the addresses, increment their sent amounts\n            validation[src].sent = validation[src].sent.add(wad);\n        } else {\n            // if we haven't, add them to the validation mapping\n            validation[src].seen = true;\n            validation[src].sent = wad;\n            seen.push(src);\n        }\n        if (validation[dest].seen != false) {\n            // if we have seen the addresses, increment their sent amounts\n            validation[dest].received = validation[dest].received.add(wad);\n        } else {\n            // if we haven't, add them to the validation mapping\n            validation[dest].seen = true;\n            validation[dest].received = wad; \n            seen.push(dest);   \n        }\n    }\n\n    /// @dev performs the validation for an attempted transitive transfer\n    /// @param steps the number of steps in the transitive transaction\n    function validateTransferThrough(uint256 steps) internal {\n        // a valid path has only one real sender and receiver\n        address src;\n        address dest;\n        // iterate through the array of all the addresses that were part of the transaction data\n        for (uint i = 0; i < seen.length; i++) {\n            transferValidator memory curr = validation[seen[i]];\n            // if the address sent more than they received, they are the sender\n            if (curr.sent > curr.received) {\n                // if we've already found a sender, transaction is invalid\n                require(src == address(0), \"Path sends from more than one src\");\n                // the real token sender must also be the transaction sender\n                require(seen[i] == msg.sender, \"Path doesn't send from transaction sender\");\n                src = seen[i];\n            }\n            // if the address received more than they sent, they are the recipient\n            if (curr.received > curr.sent) {\n                // if we've already found a recipient, transaction is invalid\n                require(dest == address(0), \"Path sends to more than one dest\");\n                dest = seen[i];\n            }\n        }\n        // a valid path has both a sender and a recipient\n        require(src != address(0), \"Transaction must have a src\");\n        require(dest != address(0), \"Transaction must have a dest\");\n        // sender should not recieve, recipient should not send\n        // by this point in the code, we should have one src and one dest and no one else's balance should change\n        require(validation[src].received == 0, \"Sender is receiving\");\n        require(validation[dest].sent == 0, \"Recipient is sending\");\n        // the total amounts sent and received by sender and recipient should match\n        require(validation[src].sent == validation[dest].received, \"Unequal sent and received amounts\");\n        // the maximum amount of addresses we should see is one more than steps in the path\n        require(seen.length <= steps + 1, \"Seen too many addresses\");\n        emit HubTransfer(src, dest, validation[src].sent);\n        // clean up the validation datastructures\n        for (uint i = seen.length; i >= 1; i--) {\n            delete validation[seen[i-1]];\n        }\n        delete seen;\n        // sanity check that we cleaned everything up correctly\n        require(seen.length == 0, \"Seen should be empty\");\n    }\n\n    /// @notice walks through tokenOwners, srcs, dests, and amounts array and executes transtive transfer\n    /// @dev tokenOwners[0], srcs[0], dests[0], and wads[0] constitute a transaction step\n    /// @param tokenOwners the owner of the tokens being sent in each transaction step\n    /// @param srcs the sender of each transaction step\n    /// @param dests the recipient of each transaction step\n    /// @param wads the amount for each transaction step\n    function transferThrough(\n        address[] memory tokenOwners,\n        address[] memory srcs,\n        address[] memory dests,\n        uint[] memory wads\n    ) public {\n        // all the arrays must be the same length\n        require(dests.length == tokenOwners.length, \"Tokens array length must equal dests array\");\n        require(srcs.length == tokenOwners.length, \"Tokens array length must equal srcs array\");\n        require(wads.length == tokenOwners.length, \"Tokens array length must equal amounts array\");\n        for (uint i = 0; i < srcs.length; i++) {\n            address src = srcs[i];\n            address dest = dests[i];\n            address token = tokenOwners[i];\n            uint256 wad = wads[i];\n            \n            // check that no trust limits are violated\n            uint256 max = checkSendLimit(token, src, dest);\n            require(wad <= max, \"Trust limit exceeded\");\n\n            buildValidationData(src, dest, wad);\n            \n            // go ahead and do the transfers now so that we don't have to walk through this array again\n            userToToken[token].hubTransfer(src, dest, wad);\n        }\n        // this will revert if there are any problems found\n        validateTransferThrough(srcs.length);\n    }\n}\n\n";
  var sourcePath$1 = "/home/ele/Documents/Berlin-Coop/CirclesUBI/circles-contracts/contracts/Hub.sol";
  var ast$1 = {
  	absolutePath: "project:/contracts/Hub.sol",
  	exportedSymbols: {
  		Hub: [
  			2238
  		]
  	},
  	id: 2239,
  	license: "AGPL",
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1133,
  			literals: [
  				"solidity",
  				"^",
  				"0.7",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "33:23:3"
  		},
  		{
  			absolutePath: "@openzeppelin/contracts/math/SafeMath.sol",
  			file: "@openzeppelin/contracts/math/SafeMath.sol",
  			id: 1134,
  			nodeType: "ImportDirective",
  			scope: 2239,
  			sourceUnit: 355,
  			src: "58:51:3",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "project:/contracts/Token.sol",
  			file: "./Token.sol",
  			id: 1135,
  			nodeType: "ImportDirective",
  			scope: 2239,
  			sourceUnit: 2751,
  			src: "110:21:3",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			abstract: false,
  			baseContracts: [
  			],
  			contractDependencies: [
  				2750
  			],
  			contractKind: "contract",
  			fullyImplemented: true,
  			id: 2238,
  			linearizedBaseContracts: [
  				2238
  			],
  			name: "Hub",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 1138,
  					libraryName: {
  						id: 1136,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 354,
  						src: "158:8:3",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$354",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "152:27:3",
  					typeName: {
  						id: 1137,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "171:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: false,
  					functionSelector: "be0522e0",
  					id: 1140,
  					mutability: "immutable",
  					name: "inflation",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "185:34:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1139,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "185:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "1f2dc5ef",
  					id: 1142,
  					mutability: "immutable",
  					name: "divisor",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "310:32:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1141,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "310:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "ef78d4fd",
  					id: 1144,
  					mutability: "immutable",
  					name: "period",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "412:31:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1143,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "412:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "95d89b41",
  					id: 1146,
  					mutability: "mutable",
  					name: "symbol",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "499:20:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_storage",
  						typeString: "string"
  					},
  					typeName: {
  						id: 1145,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "499:6:3",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "06fdde03",
  					id: 1148,
  					mutability: "mutable",
  					name: "name",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "525:18:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_storage",
  						typeString: "string"
  					},
  					typeName: {
  						id: 1147,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "525:6:3",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "67cb52d8",
  					id: 1150,
  					mutability: "immutable",
  					name: "signupBonus",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "549:36:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1149,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "549:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "fc22a9f8",
  					id: 1152,
  					mutability: "immutable",
  					name: "initialIssuance",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "639:40:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1151,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "639:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "eae4c19f",
  					id: 1154,
  					mutability: "immutable",
  					name: "deployedAt",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "761:35:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1153,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "761:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "70dea79a",
  					id: 1156,
  					mutability: "immutable",
  					name: "timeout",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "849:32:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 1155,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "849:7:3",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "28d249fe",
  					id: 1160,
  					mutability: "mutable",
  					name: "userToToken",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "962:45:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  						typeString: "mapping(address => contract Token)"
  					},
  					typeName: {
  						id: 1159,
  						keyType: {
  							id: 1157,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "971:7:3",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "962:26:3",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  							typeString: "mapping(address => contract Token)"
  						},
  						valueType: {
  							id: 1158,
  							name: "Token",
  							nodeType: "UserDefinedTypeName",
  							referencedDeclaration: 2750,
  							src: "982:5:3",
  							typeDescriptions: {
  								typeIdentifier: "t_contract$_Token_$2750",
  								typeString: "contract Token"
  							}
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "a18b506b",
  					id: 1164,
  					mutability: "mutable",
  					name: "tokenToUser",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "1013:47:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  						typeString: "mapping(address => address)"
  					},
  					typeName: {
  						id: 1163,
  						keyType: {
  							id: 1161,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "1022:7:3",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "1013:28:3",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  							typeString: "mapping(address => address)"
  						},
  						valueType: {
  							id: 1162,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "1033:7:3",
  							stateMutability: "nonpayable",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "5a1f7406",
  					id: 1168,
  					mutability: "mutable",
  					name: "organizations",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "1066:46:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  						typeString: "mapping(address => bool)"
  					},
  					typeName: {
  						id: 1167,
  						keyType: {
  							id: 1165,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "1075:7:3",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "1066:25:3",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  							typeString: "mapping(address => bool)"
  						},
  						valueType: {
  							id: 1166,
  							name: "bool",
  							nodeType: "ElementaryTypeName",
  							src: "1086:4:3",
  							typeDescriptions: {
  								typeIdentifier: "t_bool",
  								typeString: "bool"
  							}
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "a3eb2b4a",
  					id: 1174,
  					mutability: "mutable",
  					name: "limits",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "1118:63:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
  						typeString: "mapping(address => mapping(address => uint256))"
  					},
  					typeName: {
  						id: 1173,
  						keyType: {
  							id: 1169,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "1127:7:3",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "1118:49:3",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
  							typeString: "mapping(address => mapping(address => uint256))"
  						},
  						valueType: {
  							id: 1172,
  							keyType: {
  								id: 1170,
  								name: "address",
  								nodeType: "ElementaryTypeName",
  								src: "1147:7:3",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								}
  							},
  							nodeType: "Mapping",
  							src: "1138:28:3",
  							typeDescriptions: {
  								typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  								typeString: "mapping(address => uint256)"
  							},
  							valueType: {
  								id: 1171,
  								name: "uint256",
  								nodeType: "ElementaryTypeName",
  								src: "1158:7:3",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							}
  						}
  					},
  					visibility: "public"
  				},
  				{
  					anonymous: false,
  					id: 1180,
  					name: "Signup",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 1179,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1176,
  								indexed: true,
  								mutability: "mutable",
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 1180,
  								src: "1201:20:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1175,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1201:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1178,
  								indexed: false,
  								mutability: "mutable",
  								name: "token",
  								nodeType: "VariableDeclaration",
  								scope: 1180,
  								src: "1223:13:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1177,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1223:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1200:37:3"
  					},
  					src: "1188:50:3"
  				},
  				{
  					anonymous: false,
  					id: 1184,
  					name: "OrganizationSignup",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 1183,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1182,
  								indexed: true,
  								mutability: "mutable",
  								name: "organization",
  								nodeType: "VariableDeclaration",
  								scope: 1184,
  								src: "1268:28:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1181,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1268:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1267:30:3"
  					},
  					src: "1243:55:3"
  				},
  				{
  					anonymous: false,
  					id: 1192,
  					name: "Trust",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 1191,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1186,
  								indexed: true,
  								mutability: "mutable",
  								name: "canSendTo",
  								nodeType: "VariableDeclaration",
  								scope: 1192,
  								src: "1315:25:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1185,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1315:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1188,
  								indexed: true,
  								mutability: "mutable",
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 1192,
  								src: "1342:20:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1187,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1342:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1190,
  								indexed: false,
  								mutability: "mutable",
  								name: "limit",
  								nodeType: "VariableDeclaration",
  								scope: 1192,
  								src: "1364:13:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1189,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1364:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1314:64:3"
  					},
  					src: "1303:76:3"
  				},
  				{
  					anonymous: false,
  					id: 1200,
  					name: "HubTransfer",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 1199,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1194,
  								indexed: true,
  								mutability: "mutable",
  								name: "from",
  								nodeType: "VariableDeclaration",
  								scope: 1200,
  								src: "1402:20:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1193,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1402:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1196,
  								indexed: true,
  								mutability: "mutable",
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 1200,
  								src: "1424:18:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1195,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1424:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1198,
  								indexed: false,
  								mutability: "mutable",
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1200,
  								src: "1444:14:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1197,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1444:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1401:58:3"
  					},
  					src: "1384:76:3"
  				},
  				{
  					canonicalName: "Hub.transferValidator",
  					id: 1207,
  					members: [
  						{
  							constant: false,
  							id: 1202,
  							mutability: "mutable",
  							name: "seen",
  							nodeType: "VariableDeclaration",
  							scope: 1207,
  							src: "1565:9:3",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_bool",
  								typeString: "bool"
  							},
  							typeName: {
  								id: 1201,
  								name: "bool",
  								nodeType: "ElementaryTypeName",
  								src: "1565:4:3",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								}
  							},
  							visibility: "internal"
  						},
  						{
  							constant: false,
  							id: 1204,
  							mutability: "mutable",
  							name: "sent",
  							nodeType: "VariableDeclaration",
  							scope: 1207,
  							src: "1584:12:3",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 1203,
  								name: "uint256",
  								nodeType: "ElementaryTypeName",
  								src: "1584:7:3",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							visibility: "internal"
  						},
  						{
  							constant: false,
  							id: 1206,
  							mutability: "mutable",
  							name: "received",
  							nodeType: "VariableDeclaration",
  							scope: 1207,
  							src: "1606:16:3",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 1205,
  								name: "uint256",
  								nodeType: "ElementaryTypeName",
  								src: "1606:7:3",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							visibility: "internal"
  						}
  					],
  					name: "transferValidator",
  					nodeType: "StructDefinition",
  					scope: 2238,
  					src: "1530:99:3",
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "77ed63c2",
  					id: 1211,
  					mutability: "mutable",
  					name: "validation",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "1634:56:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  						typeString: "mapping(address => struct Hub.transferValidator)"
  					},
  					typeName: {
  						id: 1210,
  						keyType: {
  							id: 1208,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "1643:7:3",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "1634:38:3",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  							typeString: "mapping(address => struct Hub.transferValidator)"
  						},
  						valueType: {
  							id: 1209,
  							name: "transferValidator",
  							nodeType: "UserDefinedTypeName",
  							referencedDeclaration: 1207,
  							src: "1654:17:3",
  							typeDescriptions: {
  								typeIdentifier: "t_struct$_transferValidator_$1207_storage_ptr",
  								typeString: "struct Hub.transferValidator"
  							}
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "7f501d04",
  					id: 1214,
  					mutability: "mutable",
  					name: "seen",
  					nodeType: "VariableDeclaration",
  					scope: 2238,
  					src: "1696:21:3",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_array$_t_address_$dyn_storage",
  						typeString: "address[]"
  					},
  					typeName: {
  						baseType: {
  							id: 1212,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "1696:7:3",
  							stateMutability: "nonpayable",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						id: 1213,
  						nodeType: "ArrayTypeName",
  						src: "1696:9:3",
  						typeDescriptions: {
  							typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  							typeString: "address[]"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1270,
  						nodeType: "Block",
  						src: "1945:302:3",
  						statements: [
  							{
  								expression: {
  									id: 1233,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1231,
  										name: "inflation",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1140,
  										src: "1955:9:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1232,
  										name: "_inflation",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1216,
  										src: "1967:10:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1955:22:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1234,
  								nodeType: "ExpressionStatement",
  								src: "1955:22:3"
  							},
  							{
  								expression: {
  									id: 1239,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1235,
  										name: "divisor",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1142,
  										src: "1987:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										"arguments": [
  											{
  												id: 1237,
  												name: "_inflation",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1216,
  												src: "2009:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1236,
  											name: "findDivisor",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1304,
  											src: "1997:11:3",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$returns$_t_uint256_$",
  												typeString: "function (uint256) pure returns (uint256)"
  											}
  										},
  										id: 1238,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1997:23:3",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1987:33:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1240,
  								nodeType: "ExpressionStatement",
  								src: "1987:33:3"
  							},
  							{
  								expression: {
  									id: 1243,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1241,
  										name: "period",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1144,
  										src: "2030:6:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1242,
  										name: "_period",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1218,
  										src: "2039:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2030:16:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1244,
  								nodeType: "ExpressionStatement",
  								src: "2030:16:3"
  							},
  							{
  								expression: {
  									id: 1247,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1245,
  										name: "symbol",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1146,
  										src: "2056:6:3",
  										typeDescriptions: {
  											typeIdentifier: "t_string_storage",
  											typeString: "string storage ref"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1246,
  										name: "_symbol",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1220,
  										src: "2065:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_string_memory_ptr",
  											typeString: "string memory"
  										}
  									},
  									src: "2056:16:3",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage",
  										typeString: "string storage ref"
  									}
  								},
  								id: 1248,
  								nodeType: "ExpressionStatement",
  								src: "2056:16:3"
  							},
  							{
  								expression: {
  									id: 1251,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1249,
  										name: "name",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1148,
  										src: "2082:4:3",
  										typeDescriptions: {
  											typeIdentifier: "t_string_storage",
  											typeString: "string storage ref"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1250,
  										name: "_name",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1222,
  										src: "2089:5:3",
  										typeDescriptions: {
  											typeIdentifier: "t_string_memory_ptr",
  											typeString: "string memory"
  										}
  									},
  									src: "2082:12:3",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage",
  										typeString: "string storage ref"
  									}
  								},
  								id: 1252,
  								nodeType: "ExpressionStatement",
  								src: "2082:12:3"
  							},
  							{
  								expression: {
  									id: 1255,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1253,
  										name: "signupBonus",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1150,
  										src: "2104:11:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1254,
  										name: "_signupBonus",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1224,
  										src: "2118:12:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2104:26:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1256,
  								nodeType: "ExpressionStatement",
  								src: "2104:26:3"
  							},
  							{
  								expression: {
  									id: 1259,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1257,
  										name: "initialIssuance",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1152,
  										src: "2140:15:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1258,
  										name: "_initialIssuance",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1226,
  										src: "2158:16:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2140:34:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1260,
  								nodeType: "ExpressionStatement",
  								src: "2140:34:3"
  							},
  							{
  								expression: {
  									id: 1264,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1261,
  										name: "deployedAt",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1154,
  										src: "2184:10:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										expression: {
  											id: 1262,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: -4,
  											src: "2197:5:3",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 1263,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "timestamp",
  										nodeType: "MemberAccess",
  										src: "2197:15:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2184:28:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1265,
  								nodeType: "ExpressionStatement",
  								src: "2184:28:3"
  							},
  							{
  								expression: {
  									id: 1268,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 1266,
  										name: "timeout",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1156,
  										src: "2222:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1267,
  										name: "_timeout",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1228,
  										src: "2232:8:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "2222:18:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1269,
  								nodeType: "ExpressionStatement",
  								src: "2222:18:3"
  							}
  						]
  					},
  					id: 1271,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1229,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1216,
  								mutability: "mutable",
  								name: "_inflation",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1745:18:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1215,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1745:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1218,
  								mutability: "mutable",
  								name: "_period",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1773:15:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1217,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1773:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1220,
  								mutability: "mutable",
  								name: "_symbol",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1798:21:3",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 1219,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "1798:6:3",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1222,
  								mutability: "mutable",
  								name: "_name",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1829:19:3",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 1221,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "1829:6:3",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1224,
  								mutability: "mutable",
  								name: "_signupBonus",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1858:20:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1223,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1858:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1226,
  								mutability: "mutable",
  								name: "_initialIssuance",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1888:24:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1225,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1888:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1228,
  								mutability: "mutable",
  								name: "_timeout",
  								nodeType: "VariableDeclaration",
  								scope: 1271,
  								src: "1922:16:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1227,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1922:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1735:209:3"
  					},
  					returnParameters: {
  						id: 1230,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1945:0:3"
  					},
  					scope: 2238,
  					src: "1724:523:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1303,
  						nodeType: "Block",
  						src: "2601:142:3",
  						statements: [
  							{
  								assignments: [
  									1280
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1280,
  										mutability: "mutable",
  										name: "iter",
  										nodeType: "VariableDeclaration",
  										scope: 1303,
  										src: "2611:12:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1279,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "2611:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1282,
  								initialValue: {
  									hexValue: "30",
  									id: 1281,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "number",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "2626:1:3",
  									typeDescriptions: {
  										typeIdentifier: "t_rational_0_by_1",
  										typeString: "int_const 0"
  									},
  									value: "0"
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "2611:16:3"
  							},
  							{
  								body: {
  									id: 1296,
  									nodeType: "Block",
  									src: "2673:34:3",
  									statements: [
  										{
  											expression: {
  												id: 1294,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 1292,
  													name: "iter",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1280,
  													src: "2687:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "+=",
  												rightHandSide: {
  													hexValue: "31",
  													id: 1293,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "2695:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_rational_1_by_1",
  														typeString: "int_const 1"
  													},
  													value: "1"
  												},
  												src: "2687:9:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1295,
  											nodeType: "ExpressionStatement",
  											src: "2687:9:3"
  										}
  									]
  								},
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1291,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										"arguments": [
  											{
  												"arguments": [
  													{
  														hexValue: "3130",
  														id: 1286,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "2657:2:3",
  														typeDescriptions: {
  															typeIdentifier: "t_rational_10_by_1",
  															typeString: "int_const 10"
  														},
  														value: "10"
  													},
  													{
  														id: 1287,
  														name: "iter",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1280,
  														src: "2661:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_10_by_1",
  															typeString: "int_const 10"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 1285,
  													name: "pow",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1691,
  													src: "2653:3:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1288,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "2653:13:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												id: 1283,
  												name: "_inf",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1274,
  												src: "2644:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1284,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 259,
  											src: "2644:8:3",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1289,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "2644:23:3",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										hexValue: "39",
  										id: 1290,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2670:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_9_by_1",
  											typeString: "int_const 9"
  										},
  										value: "9"
  									},
  									src: "2644:27:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1297,
  								nodeType: "WhileStatement",
  								src: "2637:70:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											hexValue: "3130",
  											id: 1299,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2727:2:3",
  											typeDescriptions: {
  												typeIdentifier: "t_rational_10_by_1",
  												typeString: "int_const 10"
  											},
  											value: "10"
  										},
  										{
  											id: 1300,
  											name: "iter",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1280,
  											src: "2731:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_rational_10_by_1",
  												typeString: "int_const 10"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1298,
  										name: "pow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1691,
  										src: "2723:3:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1301,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2723:13:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1278,
  								id: 1302,
  								nodeType: "Return",
  								src: "2716:20:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1272,
  						nodeType: "StructuredDocumentation",
  						src: "2253:276:3",
  						text: "@notice calculates the correct divisor for the given inflation rate\n @dev the divisor is used to maintain precision when doing math with percentages\n @param _inf the inflation rate\n @return the largest power of ten the inflation rate can be divided by"
  					},
  					id: 1304,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "findDivisor",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1275,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1274,
  								mutability: "mutable",
  								name: "_inf",
  								nodeType: "VariableDeclaration",
  								scope: 1304,
  								src: "2555:12:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1273,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "2555:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2554:14:3"
  					},
  					returnParameters: {
  						id: 1278,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1277,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1304,
  								src: "2592:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1276,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "2592:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2591:9:3"
  					},
  					scope: 2238,
  					src: "2534:209:3",
  					stateMutability: "pure",
  					virtual: false,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1320,
  						nodeType: "Block",
  						src: "2963:69:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1317,
  											name: "period",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1144,
  											src: "3018:6:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											components: [
  												{
  													"arguments": [
  														{
  															id: 1313,
  															name: "deployedAt",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1154,
  															src: "3001:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															expression: {
  																id: 1310,
  																name: "block",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: -4,
  																src: "2981:5:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_magic_block",
  																	typeString: "block"
  																}
  															},
  															id: 1311,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "timestamp",
  															nodeType: "MemberAccess",
  															src: "2981:15:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1312,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sub",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 203,
  														src: "2981:19:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1314,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2981:31:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											id: 1315,
  											isConstant: false,
  											isInlineArray: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "TupleExpression",
  											src: "2980:33:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1316,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 259,
  										src: "2980:37:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1318,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2980:45:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1309,
  								id: 1319,
  								nodeType: "Return",
  								src: "2973:52:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1305,
  						nodeType: "StructuredDocumentation",
  						src: "2749:160:3",
  						text: "@notice helper function for finding the amount of inflation periods since this hub was deployed\n @return the amount of periods since hub was deployed"
  					},
  					functionSelector: "a4caeb42",
  					id: 1321,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "periods",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1306,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2930:2:3"
  					},
  					returnParameters: {
  						id: 1309,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1308,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1321,
  								src: "2954:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1307,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "2954:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2953:9:3"
  					},
  					scope: 2238,
  					src: "2914:118:3",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1333,
  						nodeType: "Block",
  						src: "3315:59:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1328,
  											name: "initialIssuance",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1152,
  											src: "3340:15:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 1329,
  												name: "periods",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1321,
  												src: "3357:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 1330,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3357:9:3",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1327,
  										name: "inflate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1382,
  										src: "3332:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 1331,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3332:35:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1326,
  								id: 1332,
  								nodeType: "Return",
  								src: "3325:42:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1322,
  						nodeType: "StructuredDocumentation",
  						src: "3038:222:3",
  						text: "@notice calculates the current issuance rate per second\n @dev current issuance is the initial issuance inflated by the amount of inflation periods since the hub was deployed\n @return current issuance rate"
  					},
  					functionSelector: "863623bb",
  					id: 1334,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "issuance",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1323,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3282:2:3"
  					},
  					returnParameters: {
  						id: 1326,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1325,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1334,
  								src: "3306:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1324,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3306:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "3305:9:3"
  					},
  					scope: 2238,
  					src: "3265:109:3",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1347,
  						nodeType: "Block",
  						src: "3642:58:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1343,
  											name: "initialIssuance",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1152,
  											src: "3667:15:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											id: 1344,
  											name: "_periods",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1337,
  											src: "3684:8:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1342,
  										name: "inflate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1382,
  										src: "3659:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 1345,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3659:34:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1341,
  								id: 1346,
  								nodeType: "Return",
  								src: "3652:41:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1335,
  						nodeType: "StructuredDocumentation",
  						src: "3380:185:3",
  						text: "@notice finds the inflation rate at a given inflation period\n @param _periods the step to calculate the issuance rate at\n @return inflation rate as of the given period"
  					},
  					functionSelector: "61c4b421",
  					id: 1348,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "issuanceByStep",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1338,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1337,
  								mutability: "mutable",
  								name: "_periods",
  								nodeType: "VariableDeclaration",
  								scope: 1348,
  								src: "3594:16:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1336,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3594:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "3593:18:3"
  					},
  					returnParameters: {
  						id: 1341,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1340,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1348,
  								src: "3633:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1339,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3633:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "3632:9:3"
  					},
  					scope: 2238,
  					src: "3570:130:3",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1381,
  						nodeType: "Block",
  						src: "4218:372:3",
  						statements: [
  							{
  								assignments: [
  									1359
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1359,
  										mutability: "mutable",
  										name: "q",
  										nodeType: "VariableDeclaration",
  										scope: 1381,
  										src: "4462:9:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1358,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "4462:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1364,
  								initialValue: {
  									"arguments": [
  										{
  											id: 1361,
  											name: "inflation",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1140,
  											src: "4478:9:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											id: 1362,
  											name: "_periods",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1353,
  											src: "4489:8:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1360,
  										name: "pow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1691,
  										src: "4474:3:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1363,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4474:24:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "4462:36:3"
  							},
  							{
  								assignments: [
  									1366
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1366,
  										mutability: "mutable",
  										name: "d",
  										nodeType: "VariableDeclaration",
  										scope: 1381,
  										src: "4508:9:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1365,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "4508:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1371,
  								initialValue: {
  									"arguments": [
  										{
  											id: 1368,
  											name: "divisor",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1142,
  											src: "4524:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											id: 1369,
  											name: "_periods",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1353,
  											src: "4533:8:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1367,
  										name: "pow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1691,
  										src: "4520:3:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1370,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4520:22:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "4508:34:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1378,
  											name: "d",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1366,
  											src: "4581:1:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											components: [
  												{
  													"arguments": [
  														{
  															id: 1374,
  															name: "q",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1359,
  															src: "4573:1:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															id: 1372,
  															name: "_initial",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1351,
  															src: "4560:8:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1373,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 237,
  														src: "4560:12:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1375,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "4560:15:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											id: 1376,
  											isConstant: false,
  											isInlineArray: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "TupleExpression",
  											src: "4559:17:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1377,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 259,
  										src: "4559:21:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1379,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4559:24:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1357,
  								id: 1380,
  								nodeType: "Return",
  								src: "4552:31:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1349,
  						nodeType: "StructuredDocumentation",
  						src: "3706:424:3",
  						text: "@notice find the current issuance rate for any initial issuance and amount of periods\n @dev this is basically the calculation for compound interest, with some adjustments because of integer math\n @param _initial the starting issuance rate\n @param _periods the step to calculate the issuance rate as of\n @return initial issuance rate as if interest (inflation) has been compounded period times"
  					},
  					functionSelector: "2a938342",
  					id: 1382,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "inflate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1354,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1351,
  								mutability: "mutable",
  								name: "_initial",
  								nodeType: "VariableDeclaration",
  								scope: 1382,
  								src: "4152:16:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1350,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "4152:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1353,
  								mutability: "mutable",
  								name: "_periods",
  								nodeType: "VariableDeclaration",
  								scope: 1382,
  								src: "4170:16:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1352,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "4170:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "4151:36:3"
  					},
  					returnParameters: {
  						id: 1357,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1356,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1382,
  								src: "4209:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1355,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "4209:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "4208:9:3"
  					},
  					scope: 2238,
  					src: "4135:455:3",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1452,
  						nodeType: "Block",
  						src: "4775:651:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 1398,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												"arguments": [
  													{
  														baseExpression: {
  															id: 1389,
  															name: "userToToken",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1160,
  															src: "4843:11:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  																typeString: "mapping(address => contract Token)"
  															}
  														},
  														id: 1392,
  														indexExpression: {
  															expression: {
  																id: 1390,
  																name: "msg",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: -15,
  																src: "4855:3:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_magic_message",
  																	typeString: "msg"
  																}
  															},
  															id: 1391,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "sender",
  															nodeType: "MemberAccess",
  															src: "4855:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "4843:23:3",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Token_$2750",
  															typeString: "contract Token"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_contract$_Token_$2750",
  															typeString: "contract Token"
  														}
  													],
  													id: 1388,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "4835:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 1387,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "4835:7:3",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 1393,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "4835:32:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												"arguments": [
  													{
  														hexValue: "30",
  														id: 1396,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "4879:1:3",
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 1395,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "4871:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 1394,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "4871:7:3",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 1397,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "4871:10:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "4835:46:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "596f752063616e2774207369676e207570207477696365",
  											id: 1399,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "4883:25:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_1efbb6dec79d778e8f8d82c0704a10c59142e478257a2be868ea7a54f0cd499e",
  												typeString: "literal_string \"You can't sign up twice\""
  											},
  											value: "You can't sign up twice"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_1efbb6dec79d778e8f8d82c0704a10c59142e478257a2be868ea7a54f0cd499e",
  												typeString: "literal_string \"You can't sign up twice\""
  											}
  										],
  										id: 1386,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "4827:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1400,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4827:82:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1401,
  								nodeType: "ExpressionStatement",
  								src: "4827:82:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											id: 1408,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												baseExpression: {
  													id: 1403,
  													name: "organizations",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1168,
  													src: "4979:13:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  														typeString: "mapping(address => bool)"
  													}
  												},
  												id: 1406,
  												indexExpression: {
  													expression: {
  														id: 1404,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: -15,
  														src: "4993:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 1405,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													src: "4993:10:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "4979:25:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												hexValue: "66616c7365",
  												id: 1407,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "bool",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "5008:5:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												value: "false"
  											},
  											src: "4979:34:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "4f7267616e697a6174696f6e732063616e6e6f74207369676e7570206173206e6f726d616c207573657273",
  											id: 1409,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "5015:45:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_e66a76efd18f0e15d3291829f7718ae21f2dc384f194b6932c25b14c8f5a8cef",
  												typeString: "literal_string \"Organizations cannot signup as normal users\""
  											},
  											value: "Organizations cannot signup as normal users"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_e66a76efd18f0e15d3291829f7718ae21f2dc384f194b6932c25b14c8f5a8cef",
  												typeString: "literal_string \"Organizations cannot signup as normal users\""
  											}
  										],
  										id: 1402,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "4971:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1410,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4971:90:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1411,
  								nodeType: "ExpressionStatement",
  								src: "4971:90:3"
  							},
  							{
  								assignments: [
  									1413
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1413,
  										mutability: "mutable",
  										name: "token",
  										nodeType: "VariableDeclaration",
  										scope: 1452,
  										src: "5072:11:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Token_$2750",
  											typeString: "contract Token"
  										},
  										typeName: {
  											id: 1412,
  											name: "Token",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 2750,
  											src: "5072:5:3",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_Token_$2750",
  												typeString: "contract Token"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1419,
  								initialValue: {
  									"arguments": [
  										{
  											expression: {
  												id: 1416,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "5096:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1417,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "5096:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										],
  										id: 1415,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "NewExpression",
  										src: "5086:9:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_creation_nonpayable$_t_address_$returns$_t_contract$_Token_$2750_$",
  											typeString: "function (address) returns (contract Token)"
  										},
  										typeName: {
  											id: 1414,
  											name: "Token",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 2750,
  											src: "5090:5:3",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_Token_$2750",
  												typeString: "contract Token"
  											}
  										}
  									},
  									id: 1418,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5086:21:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_Token_$2750",
  										typeString: "contract Token"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5072:35:3"
  							},
  							{
  								expression: {
  									id: 1425,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										baseExpression: {
  											id: 1420,
  											name: "userToToken",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1160,
  											src: "5117:11:3",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  												typeString: "mapping(address => contract Token)"
  											}
  										},
  										id: 1423,
  										indexExpression: {
  											expression: {
  												id: 1421,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "5129:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1422,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "5129:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "5117:23:3",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Token_$2750",
  											typeString: "contract Token"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1424,
  										name: "token",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1413,
  										src: "5143:5:3",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Token_$2750",
  											typeString: "contract Token"
  										}
  									},
  									src: "5117:31:3",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_Token_$2750",
  										typeString: "contract Token"
  									}
  								},
  								id: 1426,
  								nodeType: "ExpressionStatement",
  								src: "5117:31:3"
  							},
  							{
  								expression: {
  									id: 1435,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										baseExpression: {
  											id: 1427,
  											name: "tokenToUser",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1164,
  											src: "5158:11:3",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_address_$",
  												typeString: "mapping(address => address)"
  											}
  										},
  										id: 1432,
  										indexExpression: {
  											"arguments": [
  												{
  													id: 1430,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1413,
  													src: "5178:5:3",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_Token_$2750",
  														typeString: "contract Token"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_Token_$2750",
  														typeString: "contract Token"
  													}
  												],
  												id: 1429,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "5170:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: {
  													id: 1428,
  													name: "address",
  													nodeType: "ElementaryTypeName",
  													src: "5170:7:3",
  													typeDescriptions: {
  													}
  												}
  											},
  											id: 1431,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "5170:14:3",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "5158:27:3",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										expression: {
  											id: 1433,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: -15,
  											src: "5188:3:3",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 1434,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										src: "5188:10:3",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "5158:40:3",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 1436,
  								nodeType: "ExpressionStatement",
  								src: "5158:40:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											expression: {
  												id: 1438,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "5353:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1439,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "5353:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											hexValue: "313030",
  											id: 1440,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "5365:3:3",
  											typeDescriptions: {
  												typeIdentifier: "t_rational_100_by_1",
  												typeString: "int_const 100"
  											},
  											value: "100"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_rational_100_by_1",
  												typeString: "int_const 100"
  											}
  										],
  										id: 1437,
  										name: "_trust",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1597,
  										src: "5346:6:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1441,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5346:23:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1442,
  								nodeType: "ExpressionStatement",
  								src: "5346:23:3"
  							},
  							{
  								eventCall: {
  									"arguments": [
  										{
  											expression: {
  												id: 1444,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "5392:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1445,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "5392:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											"arguments": [
  												{
  													id: 1448,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1413,
  													src: "5412:5:3",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_Token_$2750",
  														typeString: "contract Token"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_Token_$2750",
  														typeString: "contract Token"
  													}
  												],
  												id: 1447,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "5404:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: {
  													id: 1446,
  													name: "address",
  													nodeType: "ElementaryTypeName",
  													src: "5404:7:3",
  													typeDescriptions: {
  													}
  												}
  											},
  											id: 1449,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "5404:14:3",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										id: 1443,
  										name: "Signup",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1180,
  										src: "5385:6:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_address_$returns$__$",
  											typeString: "function (address,address)"
  										}
  									},
  									id: 1450,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5385:34:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1451,
  								nodeType: "EmitStatement",
  								src: "5380:39:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1383,
  						nodeType: "StructuredDocumentation",
  						src: "4596:149:3",
  						text: "@notice signup to this circles hub - create a circles token and join the trust graph\n @dev signup is permanent, there's no way to unsignup"
  					},
  					functionSelector: "b7bc0f73",
  					id: 1453,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "signup",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1384,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4765:2:3"
  					},
  					returnParameters: {
  						id: 1385,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4775:0:3"
  					},
  					scope: 2238,
  					src: "4750:676:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1495,
  						nodeType: "Block",
  						src: "5639:423:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 1469,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												"arguments": [
  													{
  														baseExpression: {
  															id: 1460,
  															name: "userToToken",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1160,
  															src: "5730:11:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  																typeString: "mapping(address => contract Token)"
  															}
  														},
  														id: 1463,
  														indexExpression: {
  															expression: {
  																id: 1461,
  																name: "msg",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: -15,
  																src: "5742:3:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_magic_message",
  																	typeString: "msg"
  																}
  															},
  															id: 1462,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "sender",
  															nodeType: "MemberAccess",
  															src: "5742:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "5730:23:3",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Token_$2750",
  															typeString: "contract Token"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_contract$_Token_$2750",
  															typeString: "contract Token"
  														}
  													],
  													id: 1459,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "5722:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 1458,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "5722:7:3",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 1464,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "5722:32:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												"arguments": [
  													{
  														hexValue: "30",
  														id: 1467,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "5766:1:3",
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 1466,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "5758:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 1465,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "5758:7:3",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 1468,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "5758:10:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "5722:46:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "4e6f726d616c2075736572732063616e6e6f74207369676e7570206173206f7267616e697a6174696f6e73",
  											id: 1470,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "5770:45:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_dcda9714bf80fa26761f02031c7d61716ef2295595bb451377f4e99d1f3f9712",
  												typeString: "literal_string \"Normal users cannot signup as organizations\""
  											},
  											value: "Normal users cannot signup as organizations"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_dcda9714bf80fa26761f02031c7d61716ef2295595bb451377f4e99d1f3f9712",
  												typeString: "literal_string \"Normal users cannot signup as organizations\""
  											}
  										],
  										id: 1457,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "5714:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1471,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5714:102:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1472,
  								nodeType: "ExpressionStatement",
  								src: "5714:102:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											id: 1479,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												baseExpression: {
  													id: 1474,
  													name: "organizations",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1168,
  													src: "5885:13:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  														typeString: "mapping(address => bool)"
  													}
  												},
  												id: 1477,
  												indexExpression: {
  													expression: {
  														id: 1475,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: -15,
  														src: "5899:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 1476,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													src: "5899:10:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "5885:25:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												hexValue: "66616c7365",
  												id: 1478,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "bool",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "5914:5:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												value: "false"
  											},
  											src: "5885:34:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "596f752063616e2774207369676e20757020617320616e206f7267616e697a6174696f6e207477696365",
  											id: 1480,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "5921:44:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_3aaf2463823841555c6497222979b880a5da2317c047671fdd5741e2741495c8",
  												typeString: "literal_string \"You can't sign up as an organization twice\""
  											},
  											value: "You can't sign up as an organization twice"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_3aaf2463823841555c6497222979b880a5da2317c047671fdd5741e2741495c8",
  												typeString: "literal_string \"You can't sign up as an organization twice\""
  											}
  										],
  										id: 1473,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "5877:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1481,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5877:89:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1482,
  								nodeType: "ExpressionStatement",
  								src: "5877:89:3"
  							},
  							{
  								expression: {
  									id: 1488,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										baseExpression: {
  											id: 1483,
  											name: "organizations",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1168,
  											src: "5977:13:3",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  												typeString: "mapping(address => bool)"
  											}
  										},
  										id: 1486,
  										indexExpression: {
  											expression: {
  												id: 1484,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "5991:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1485,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "5991:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "5977:25:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										hexValue: "74727565",
  										id: 1487,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "6005:4:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "true"
  									},
  									src: "5977:32:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1489,
  								nodeType: "ExpressionStatement",
  								src: "5977:32:3"
  							},
  							{
  								eventCall: {
  									"arguments": [
  										{
  											expression: {
  												id: 1491,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "6044:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1492,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "6044:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										],
  										id: 1490,
  										name: "OrganizationSignup",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1184,
  										src: "6025:18:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$returns$__$",
  											typeString: "function (address)"
  										}
  									},
  									id: 1493,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6025:30:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1494,
  								nodeType: "EmitStatement",
  								src: "6020:35:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1454,
  						nodeType: "StructuredDocumentation",
  						src: "5432:165:3",
  						text: "@notice register an organization address with the hub and join the trust graph\n @dev signup is permanent for organizations too, there's no way to unsignup"
  					},
  					functionSelector: "3fbd653c",
  					id: 1496,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "organizationSignup",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1455,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "5629:2:3"
  					},
  					returnParameters: {
  						id: 1456,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "5639:0:3"
  					},
  					scope: 2238,
  					src: "5602:460:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1571,
  						nodeType: "Block",
  						src: "6397:943:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											id: 1521,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												commonType: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												},
  												id: 1516,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													"arguments": [
  														{
  															baseExpression: {
  																id: 1507,
  																name: "userToToken",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1160,
  																src: "6517:11:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  																	typeString: "mapping(address => contract Token)"
  																}
  															},
  															id: 1510,
  															indexExpression: {
  																expression: {
  																	id: 1508,
  																	name: "msg",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: -15,
  																	src: "6529:3:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_magic_message",
  																		typeString: "msg"
  																	}
  																},
  																id: 1509,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "sender",
  																nodeType: "MemberAccess",
  																src: "6529:10:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address_payable",
  																	typeString: "address payable"
  																}
  															},
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "IndexAccess",
  															src: "6517:23:3",
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_Token_$2750",
  																typeString: "contract Token"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_contract$_Token_$2750",
  																typeString: "contract Token"
  															}
  														],
  														id: 1506,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "6509:7:3",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_address_$",
  															typeString: "type(address)"
  														},
  														typeName: {
  															id: 1505,
  															name: "address",
  															nodeType: "ElementaryTypeName",
  															src: "6509:7:3",
  															typeDescriptions: {
  															}
  														}
  													},
  													id: 1511,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6509:32:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: "!=",
  												rightExpression: {
  													"arguments": [
  														{
  															hexValue: "30",
  															id: 1514,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "6553:1:3",
  															typeDescriptions: {
  																typeIdentifier: "t_rational_0_by_1",
  																typeString: "int_const 0"
  															},
  															value: "0"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_0_by_1",
  																typeString: "int_const 0"
  															}
  														],
  														id: 1513,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "6545:7:3",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_address_$",
  															typeString: "type(address)"
  														},
  														typeName: {
  															id: 1512,
  															name: "address",
  															nodeType: "ElementaryTypeName",
  															src: "6545:7:3",
  															typeDescriptions: {
  															}
  														}
  													},
  													id: 1515,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6545:10:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												src: "6509:46:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "||",
  											rightExpression: {
  												baseExpression: {
  													id: 1517,
  													name: "organizations",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1168,
  													src: "6559:13:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  														typeString: "mapping(address => bool)"
  													}
  												},
  												id: 1520,
  												indexExpression: {
  													expression: {
  														id: 1518,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: -15,
  														src: "6573:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 1519,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													src: "6573:10:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "6559:25:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											src: "6509:75:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "596f752063616e206f6e6c792074727573742070656f706c6520616674657220796f75277665207369676e656420757021",
  											id: 1522,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6586:51:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_3e66ed50af6033d6f4e06cd174b05824d1f63800848df8453bc4f755ffc7e341",
  												typeString: "literal_string \"You can only trust people after you've signed up!\""
  											},
  											value: "You can only trust people after you've signed up!"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_3e66ed50af6033d6f4e06cd174b05824d1f63800848df8453bc4f755ffc7e341",
  												typeString: "literal_string \"You can only trust people after you've signed up!\""
  											}
  										],
  										id: 1504,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "6501:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1523,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6501:137:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1524,
  								nodeType: "ExpressionStatement",
  								src: "6501:137:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 1529,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 1526,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: -15,
  													src: "6708:3:3",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1527,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												src: "6708:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												id: 1528,
  												name: "user",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1499,
  												src: "6722:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "6708:18:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "596f752063616e277420756e747275737420796f757273656c66",
  											id: 1530,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6728:28:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_32ba97078af3ad838cf1976313c6eb1ef5cc94e93c4abd539534632651d8a311",
  												typeString: "literal_string \"You can't untrust yourself\""
  											},
  											value: "You can't untrust yourself"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_32ba97078af3ad838cf1976313c6eb1ef5cc94e93c4abd539534632651d8a311",
  												typeString: "literal_string \"You can't untrust yourself\""
  											}
  										],
  										id: 1525,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "6700:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1531,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6700:57:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1532,
  								nodeType: "ExpressionStatement",
  								src: "6700:57:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											id: 1538,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												baseExpression: {
  													id: 1534,
  													name: "organizations",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1168,
  													src: "6889:13:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  														typeString: "mapping(address => bool)"
  													}
  												},
  												id: 1536,
  												indexExpression: {
  													id: 1535,
  													name: "user",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1499,
  													src: "6903:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "6889:19:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												hexValue: "66616c7365",
  												id: 1537,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "bool",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "6912:5:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												value: "false"
  											},
  											src: "6889:28:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "596f752063616e277420747275737420616e206f7267616e697a6174696f6e",
  											id: 1539,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6919:33:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_f5dc7911fb94e33dd24ff5c64bcd96b1c45b9eba60163ee03e1c1e86d67d0a1e",
  												typeString: "literal_string \"You can't trust an organization\""
  											},
  											value: "You can't trust an organization"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_f5dc7911fb94e33dd24ff5c64bcd96b1c45b9eba60163ee03e1c1e86d67d0a1e",
  												typeString: "literal_string \"You can't trust an organization\""
  											}
  										],
  										id: 1533,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "6881:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1540,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6881:72:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1541,
  								nodeType: "ExpressionStatement",
  								src: "6881:72:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1545,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												id: 1543,
  												name: "limit",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1501,
  												src: "7000:5:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "<=",
  											rightExpression: {
  												hexValue: "313030",
  												id: 1544,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "7009:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_100_by_1",
  													typeString: "int_const 100"
  												},
  												value: "100"
  											},
  											src: "7000:12:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "4c696d6974206d75737420626520612070657263656e74616765206f7574206f6620313030",
  											id: 1546,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "7014:39:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_cc96caa47b7b76d39ad05960c449d4effd0cf497d3c0424d5256b2e65346fce7",
  												typeString: "literal_string \"Limit must be a percentage out of 100\""
  											},
  											value: "Limit must be a percentage out of 100"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_cc96caa47b7b76d39ad05960c449d4effd0cf497d3c0424d5256b2e65346fce7",
  												typeString: "literal_string \"Limit must be a percentage out of 100\""
  											}
  										],
  										id: 1542,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "6992:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1547,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6992:62:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1548,
  								nodeType: "ExpressionStatement",
  								src: "6992:62:3"
  							},
  							{
  								condition: {
  									baseExpression: {
  										id: 1549,
  										name: "organizations",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1168,
  										src: "7181:13:3",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  											typeString: "mapping(address => bool)"
  										}
  									},
  									id: 1552,
  									indexExpression: {
  										expression: {
  											id: 1550,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: -15,
  											src: "7195:3:3",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 1551,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										src: "7195:10:3",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "7181:25:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1565,
  								nodeType: "IfStatement",
  								src: "7177:128:3",
  								trueBody: {
  									id: 1564,
  									nodeType: "Block",
  									src: "7208:97:3",
  									statements: [
  										{
  											expression: {
  												"arguments": [
  													{
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														id: 1560,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															commonType: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															id: 1556,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																id: 1554,
  																name: "limit",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1501,
  																src: "7230:5:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "==",
  															rightExpression: {
  																hexValue: "30",
  																id: 1555,
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																kind: "number",
  																lValueRequested: false,
  																nodeType: "Literal",
  																src: "7239:1:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_rational_0_by_1",
  																	typeString: "int_const 0"
  																},
  																value: "0"
  															},
  															src: "7230:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: "||",
  														rightExpression: {
  															commonType: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															id: 1559,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																id: 1557,
  																name: "limit",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1501,
  																src: "7244:5:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "==",
  															rightExpression: {
  																hexValue: "313030",
  																id: 1558,
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																kind: "number",
  																lValueRequested: false,
  																nodeType: "Literal",
  																src: "7253:3:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_rational_100_by_1",
  																	typeString: "int_const 100"
  																},
  																value: "100"
  															},
  															src: "7244:12:3",
  															typeDescriptions: {
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														},
  														src: "7230:26:3",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														hexValue: "54727573742069732062696e61727920666f72206f7267616e697a6174696f6e73",
  														id: 1561,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "7258:35:3",
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_a7724e49aea8f173a138a507f23a17836a1dde8b7ada5042d739df2910c1b762",
  															typeString: "literal_string \"Trust is binary for organizations\""
  														},
  														value: "Trust is binary for organizations"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_a7724e49aea8f173a138a507f23a17836a1dde8b7ada5042d739df2910c1b762",
  															typeString: "literal_string \"Trust is binary for organizations\""
  														}
  													],
  													id: 1553,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														-18,
  														-18
  													],
  													referencedDeclaration: -18,
  													src: "7222:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 1562,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7222:72:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 1563,
  											nodeType: "ExpressionStatement",
  											src: "7222:72:3"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1567,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1499,
  											src: "7321:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											id: 1568,
  											name: "limit",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1501,
  											src: "7327:5:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1566,
  										name: "_trust",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1597,
  										src: "7314:6:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1569,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7314:19:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1570,
  								nodeType: "ExpressionStatement",
  								src: "7314:19:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1497,
  						nodeType: "StructuredDocumentation",
  						src: "6068:276:3",
  						text: "@notice trust a user, calling this means you're able to receive tokens from this user transitively\n @dev the trust graph is weighted and directed\n @param user the user to be trusted\n @param limit the amount this user is trusted, as a percentage of 100"
  					},
  					functionSelector: "9951d62f",
  					id: 1572,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "trust",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1502,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1499,
  								mutability: "mutable",
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 1572,
  								src: "6364:12:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1498,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "6364:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1501,
  								mutability: "mutable",
  								name: "limit",
  								nodeType: "VariableDeclaration",
  								scope: 1572,
  								src: "6378:10:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1500,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "6378:4:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "6363:26:3"
  					},
  					returnParameters: {
  						id: 1503,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "6397:0:3"
  					},
  					scope: 2238,
  					src: "6349:991:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1596,
  						nodeType: "Block",
  						src: "7584:94:3",
  						statements: [
  							{
  								expression: {
  									id: 1587,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										baseExpression: {
  											baseExpression: {
  												id: 1580,
  												name: "limits",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1174,
  												src: "7594:6:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
  													typeString: "mapping(address => mapping(address => uint256))"
  												}
  											},
  											id: 1584,
  											indexExpression: {
  												expression: {
  													id: 1581,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: -15,
  													src: "7601:3:3",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1582,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												src: "7601:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "7594:18:3",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 1585,
  										indexExpression: {
  											id: 1583,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1575,
  											src: "7613:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "7594:24:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 1586,
  										name: "limit",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1577,
  										src: "7621:5:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7594:32:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1588,
  								nodeType: "ExpressionStatement",
  								src: "7594:32:3"
  							},
  							{
  								eventCall: {
  									"arguments": [
  										{
  											expression: {
  												id: 1590,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: -15,
  												src: "7647:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1591,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											src: "7647:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											id: 1592,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1575,
  											src: "7659:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											id: 1593,
  											name: "limit",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1577,
  											src: "7665:5:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1589,
  										name: "Trust",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1192,
  										src: "7641:5:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 1594,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7641:30:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1595,
  								nodeType: "EmitStatement",
  								src: "7636:35:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1573,
  						nodeType: "StructuredDocumentation",
  						src: "7346:182:3",
  						text: "@dev used internally in both the trust function and signup\n @param user the user to be trusted\n @param limit the amount this user is trusted, as a percentage of 100"
  					},
  					id: 1597,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "_trust",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1578,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1575,
  								mutability: "mutable",
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 1597,
  								src: "7549:12:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1574,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7549:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1577,
  								mutability: "mutable",
  								name: "limit",
  								nodeType: "VariableDeclaration",
  								scope: 1597,
  								src: "7563:10:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1576,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7563:4:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7548:26:3"
  					},
  					returnParameters: {
  						id: 1579,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "7584:0:3"
  					},
  					scope: 2238,
  					src: "7533:145:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1690,
  						nodeType: "Block",
  						src: "7999:562:3",
  						statements: [
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1609,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 1607,
  										name: "base",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1600,
  										src: "8013:4:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										hexValue: "30",
  										id: 1608,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "8021:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "8013:9:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1613,
  								nodeType: "IfStatement",
  								src: "8009:48:3",
  								trueBody: {
  									id: 1612,
  									nodeType: "Block",
  									src: "8024:33:3",
  									statements: [
  										{
  											expression: {
  												hexValue: "30",
  												id: 1610,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "8045:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											functionReturnParameters: 1606,
  											id: 1611,
  											nodeType: "Return",
  											src: "8038:8:3"
  										}
  									]
  								}
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1616,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 1614,
  										name: "exponent",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1602,
  										src: "8070:8:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										hexValue: "30",
  										id: 1615,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "8082:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "8070:13:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1620,
  								nodeType: "IfStatement",
  								src: "8066:52:3",
  								trueBody: {
  									id: 1619,
  									nodeType: "Block",
  									src: "8085:33:3",
  									statements: [
  										{
  											expression: {
  												hexValue: "31",
  												id: 1617,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "8106:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_1_by_1",
  													typeString: "int_const 1"
  												},
  												value: "1"
  											},
  											functionReturnParameters: 1606,
  											id: 1618,
  											nodeType: "Return",
  											src: "8099:8:3"
  										}
  									]
  								}
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1623,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 1621,
  										name: "exponent",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1602,
  										src: "8131:8:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										hexValue: "31",
  										id: 1622,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "8143:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "8131:13:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1627,
  								nodeType: "IfStatement",
  								src: "8127:55:3",
  								trueBody: {
  									id: 1626,
  									nodeType: "Block",
  									src: "8146:36:3",
  									statements: [
  										{
  											expression: {
  												id: 1624,
  												name: "base",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1600,
  												src: "8167:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											functionReturnParameters: 1606,
  											id: 1625,
  											nodeType: "Return",
  											src: "8160:11:3"
  										}
  									]
  								}
  							},
  							{
  								assignments: [
  									1629
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1629,
  										mutability: "mutable",
  										name: "y",
  										nodeType: "VariableDeclaration",
  										scope: 1690,
  										src: "8191:9:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1628,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "8191:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1631,
  								initialValue: {
  									hexValue: "31",
  									id: 1630,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "number",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "8203:1:3",
  									typeDescriptions: {
  										typeIdentifier: "t_rational_1_by_1",
  										typeString: "int_const 1"
  									},
  									value: "1"
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8191:13:3"
  							},
  							{
  								body: {
  									id: 1683,
  									nodeType: "Block",
  									src: "8234:293:3",
  									statements: [
  										{
  											condition: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												id: 1640,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													"arguments": [
  														{
  															hexValue: "32",
  															id: 1637,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "8264:1:3",
  															typeDescriptions: {
  																typeIdentifier: "t_rational_2_by_1",
  																typeString: "int_const 2"
  															},
  															value: "2"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_2_by_1",
  																typeString: "int_const 2"
  															}
  														],
  														expression: {
  															id: 1635,
  															name: "exponent",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1602,
  															src: "8251:8:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1636,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mod",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 281,
  														src: "8251:12:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1638,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "8251:15:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: "==",
  												rightExpression: {
  													hexValue: "30",
  													id: 1639,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "8270:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													},
  													value: "0"
  												},
  												src: "8251:20:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											falseBody: {
  												id: 1681,
  												nodeType: "Block",
  												src: "8377:140:3",
  												statements: [
  													{
  														expression: {
  															id: 1661,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 1656,
  																name: "y",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1629,
  																src: "8395:1:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																"arguments": [
  																	{
  																		id: 1659,
  																		name: "y",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1629,
  																		src: "8408:1:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		id: 1657,
  																		name: "base",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1600,
  																		src: "8399:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1658,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "mul",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 237,
  																	src: "8399:8:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1660,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "8399:11:3",
  																tryCall: false,
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															src: "8395:15:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1662,
  														nodeType: "ExpressionStatement",
  														src: "8395:15:3"
  													},
  													{
  														expression: {
  															id: 1668,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 1663,
  																name: "base",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1600,
  																src: "8428:4:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																"arguments": [
  																	{
  																		id: 1666,
  																		name: "base",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1600,
  																		src: "8444:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		id: 1664,
  																		name: "base",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1600,
  																		src: "8435:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1665,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "mul",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 237,
  																	src: "8435:8:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1667,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "8435:14:3",
  																tryCall: false,
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															src: "8428:21:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1669,
  														nodeType: "ExpressionStatement",
  														src: "8428:21:3"
  													},
  													{
  														expression: {
  															id: 1679,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 1670,
  																name: "exponent",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1602,
  																src: "8467:8:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																"arguments": [
  																	{
  																		hexValue: "32",
  																		id: 1677,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		kind: "number",
  																		lValueRequested: false,
  																		nodeType: "Literal",
  																		src: "8500:1:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_rational_2_by_1",
  																			typeString: "int_const 2"
  																		},
  																		value: "2"
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_rational_2_by_1",
  																			typeString: "int_const 2"
  																		}
  																	],
  																	expression: {
  																		components: [
  																			{
  																				"arguments": [
  																					{
  																						hexValue: "31",
  																						id: 1673,
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						kind: "number",
  																						lValueRequested: false,
  																						nodeType: "Literal",
  																						src: "8492:1:3",
  																						typeDescriptions: {
  																							typeIdentifier: "t_rational_1_by_1",
  																							typeString: "int_const 1"
  																						},
  																						value: "1"
  																					}
  																				],
  																				expression: {
  																					argumentTypes: [
  																						{
  																							typeIdentifier: "t_rational_1_by_1",
  																							typeString: "int_const 1"
  																						}
  																					],
  																					expression: {
  																						id: 1671,
  																						name: "exponent",
  																						nodeType: "Identifier",
  																						overloadedDeclarations: [
  																						],
  																						referencedDeclaration: 1602,
  																						src: "8479:8:3",
  																						typeDescriptions: {
  																							typeIdentifier: "t_uint256",
  																							typeString: "uint256"
  																						}
  																					},
  																					id: 1672,
  																					isConstant: false,
  																					isLValue: false,
  																					isPure: false,
  																					lValueRequested: false,
  																					memberName: "sub",
  																					nodeType: "MemberAccess",
  																					referencedDeclaration: 203,
  																					src: "8479:12:3",
  																					typeDescriptions: {
  																						typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																						typeString: "function (uint256,uint256) pure returns (uint256)"
  																					}
  																				},
  																				id: 1674,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				kind: "functionCall",
  																				lValueRequested: false,
  																				names: [
  																				],
  																				nodeType: "FunctionCall",
  																				src: "8479:15:3",
  																				tryCall: false,
  																				typeDescriptions: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				}
  																			}
  																		],
  																		id: 1675,
  																		isConstant: false,
  																		isInlineArray: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		nodeType: "TupleExpression",
  																		src: "8478:17:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1676,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "div",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 259,
  																	src: "8478:21:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1678,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "8478:24:3",
  																tryCall: false,
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															src: "8467:35:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1680,
  														nodeType: "ExpressionStatement",
  														src: "8467:35:3"
  													}
  												]
  											},
  											id: 1682,
  											nodeType: "IfStatement",
  											src: "8248:269:3",
  											trueBody: {
  												id: 1655,
  												nodeType: "Block",
  												src: "8273:98:3",
  												statements: [
  													{
  														expression: {
  															id: 1646,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 1641,
  																name: "base",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1600,
  																src: "8291:4:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																"arguments": [
  																	{
  																		id: 1644,
  																		name: "base",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1600,
  																		src: "8307:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		id: 1642,
  																		name: "base",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1600,
  																		src: "8298:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1643,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "mul",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 237,
  																	src: "8298:8:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1645,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "8298:14:3",
  																tryCall: false,
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															src: "8291:21:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1647,
  														nodeType: "ExpressionStatement",
  														src: "8291:21:3"
  													},
  													{
  														expression: {
  															id: 1653,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 1648,
  																name: "exponent",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1602,
  																src: "8330:8:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																"arguments": [
  																	{
  																		hexValue: "32",
  																		id: 1651,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		kind: "number",
  																		lValueRequested: false,
  																		nodeType: "Literal",
  																		src: "8354:1:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_rational_2_by_1",
  																			typeString: "int_const 2"
  																		},
  																		value: "2"
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_rational_2_by_1",
  																			typeString: "int_const 2"
  																		}
  																	],
  																	expression: {
  																		id: 1649,
  																		name: "exponent",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1602,
  																		src: "8341:8:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1650,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "div",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 259,
  																	src: "8341:12:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1652,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "8341:15:3",
  																tryCall: false,
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															src: "8330:26:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1654,
  														nodeType: "ExpressionStatement",
  														src: "8330:26:3"
  													}
  												]
  											}
  										}
  									]
  								},
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1634,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 1632,
  										name: "exponent",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1602,
  										src: "8220:8:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										hexValue: "31",
  										id: 1633,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "8231:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "8220:12:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1684,
  								nodeType: "WhileStatement",
  								src: "8214:313:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1687,
  											name: "y",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1629,
  											src: "8552:1:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											id: 1685,
  											name: "base",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1600,
  											src: "8543:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1686,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 237,
  										src: "8543:8:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1688,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "8543:11:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1606,
  								id: 1689,
  								nodeType: "Return",
  								src: "8536:18:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1598,
  						nodeType: "StructuredDocumentation",
  						src: "7684:235:3",
  						text: "@dev this is an implementation of exponentiation by squares\n @param base the base to be used in the calculation\n @param exponent the exponent to be used in the calculation\n @return the result of the calculation"
  					},
  					functionSelector: "2e4c697f",
  					id: 1691,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "pow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1603,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1600,
  								mutability: "mutable",
  								name: "base",
  								nodeType: "VariableDeclaration",
  								scope: 1691,
  								src: "7937:12:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1599,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7937:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1602,
  								mutability: "mutable",
  								name: "exponent",
  								nodeType: "VariableDeclaration",
  								scope: 1691,
  								src: "7951:16:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1601,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7951:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7936:32:3"
  					},
  					returnParameters: {
  						id: 1606,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1605,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1691,
  								src: "7990:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1604,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7990:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7989:9:3"
  					},
  					scope: 2238,
  					src: "7924:637:3",
  					stateMutability: "pure",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1830,
  						nodeType: "Block",
  						src: "9166:1590:3",
  						statements: [
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1709,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										baseExpression: {
  											baseExpression: {
  												id: 1703,
  												name: "limits",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1174,
  												src: "9210:6:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
  													typeString: "mapping(address => mapping(address => uint256))"
  												}
  											},
  											id: 1705,
  											indexExpression: {
  												id: 1704,
  												name: "dest",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1698,
  												src: "9217:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "9210:12:3",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 1707,
  										indexExpression: {
  											id: 1706,
  											name: "tokenOwner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1694,
  											src: "9223:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "IndexAccess",
  										src: "9210:24:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										hexValue: "30",
  										id: 1708,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "9238:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "9210:29:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1713,
  								nodeType: "IfStatement",
  								src: "9206:68:3",
  								trueBody: {
  									id: 1712,
  									nodeType: "Block",
  									src: "9241:33:3",
  									statements: [
  										{
  											expression: {
  												hexValue: "30",
  												id: 1710,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9262:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											functionReturnParameters: 1702,
  											id: 1711,
  											nodeType: "Return",
  											src: "9255:8:3"
  										}
  									]
  								}
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									id: 1729,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										commonType: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										id: 1724,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											"arguments": [
  												{
  													baseExpression: {
  														id: 1716,
  														name: "userToToken",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1160,
  														src: "9358:11:3",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  															typeString: "mapping(address => contract Token)"
  														}
  													},
  													id: 1718,
  													indexExpression: {
  														id: 1717,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1698,
  														src: "9370:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "9358:17:3",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_Token_$2750",
  														typeString: "contract Token"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_Token_$2750",
  														typeString: "contract Token"
  													}
  												],
  												id: 1715,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "9350:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: {
  													id: 1714,
  													name: "address",
  													nodeType: "ElementaryTypeName",
  													src: "9350:7:3",
  													typeDescriptions: {
  													}
  												}
  											},
  											id: 1719,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "9350:26:3",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											"arguments": [
  												{
  													hexValue: "30",
  													id: 1722,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "9388:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													},
  													value: "0"
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_rational_0_by_1",
  														typeString: "int_const 0"
  													}
  												],
  												id: 1721,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "9380:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: {
  													id: 1720,
  													name: "address",
  													nodeType: "ElementaryTypeName",
  													src: "9380:7:3",
  													typeDescriptions: {
  													}
  												}
  											},
  											id: 1723,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "9380:10:3",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										src: "9350:40:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "&&",
  									rightExpression: {
  										id: 1728,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "!",
  										prefix: true,
  										src: "9394:20:3",
  										subExpression: {
  											baseExpression: {
  												id: 1725,
  												name: "organizations",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1168,
  												src: "9395:13:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  													typeString: "mapping(address => bool)"
  												}
  											},
  											id: 1727,
  											indexExpression: {
  												id: 1726,
  												name: "dest",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1698,
  												src: "9409:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "9395:19:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									src: "9350:64:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1733,
  								nodeType: "IfStatement",
  								src: "9346:104:3",
  								trueBody: {
  									id: 1732,
  									nodeType: "Block",
  									src: "9417:33:3",
  									statements: [
  										{
  											expression: {
  												hexValue: "30",
  												id: 1730,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9438:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											functionReturnParameters: 1702,
  											id: 1731,
  											nodeType: "Return",
  											src: "9431:8:3"
  										}
  									]
  								}
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									},
  									id: 1744,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										"arguments": [
  											{
  												baseExpression: {
  													id: 1736,
  													name: "userToToken",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1160,
  													src: "9536:11:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  														typeString: "mapping(address => contract Token)"
  													}
  												},
  												id: 1738,
  												indexExpression: {
  													id: 1737,
  													name: "tokenOwner",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1694,
  													src: "9548:10:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "9536:23:3",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_Token_$2750",
  													typeString: "contract Token"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_contract$_Token_$2750",
  													typeString: "contract Token"
  												}
  											],
  											id: 1735,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "9528:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: {
  												id: 1734,
  												name: "address",
  												nodeType: "ElementaryTypeName",
  												src: "9528:7:3",
  												typeDescriptions: {
  												}
  											}
  										},
  										id: 1739,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9528:32:3",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										"arguments": [
  											{
  												hexValue: "30",
  												id: 1742,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9572:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												}
  											],
  											id: 1741,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											lValueRequested: false,
  											nodeType: "ElementaryTypeNameExpression",
  											src: "9564:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_type$_t_address_$",
  												typeString: "type(address)"
  											},
  											typeName: {
  												id: 1740,
  												name: "address",
  												nodeType: "ElementaryTypeName",
  												src: "9564:7:3",
  												typeDescriptions: {
  												}
  											}
  										},
  										id: 1743,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "typeConversion",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9564:10:3",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "9528:46:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1748,
  								nodeType: "IfStatement",
  								src: "9524:86:3",
  								trueBody: {
  									id: 1747,
  									nodeType: "Block",
  									src: "9576:34:3",
  									statements: [
  										{
  											expression: {
  												hexValue: "30",
  												id: 1745,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9598:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											functionReturnParameters: 1702,
  											id: 1746,
  											nodeType: "Return",
  											src: "9591:8:3"
  										}
  									]
  								}
  							},
  							{
  								assignments: [
  									1750
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1750,
  										mutability: "mutable",
  										name: "srcBalance",
  										nodeType: "VariableDeclaration",
  										scope: 1830,
  										src: "9620:18:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1749,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "9620:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1757,
  								initialValue: {
  									"arguments": [
  										{
  											id: 1755,
  											name: "src",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1696,
  											src: "9675:3:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										expression: {
  											baseExpression: {
  												id: 1751,
  												name: "userToToken",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1160,
  												src: "9641:11:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  													typeString: "mapping(address => contract Token)"
  												}
  											},
  											id: 1753,
  											indexExpression: {
  												id: 1752,
  												name: "tokenOwner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1694,
  												src: "9653:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "9641:23:3",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_Token_$2750",
  												typeString: "contract Token"
  											}
  										},
  										id: 1754,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "balanceOf",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 735,
  										src: "9641:33:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) view external returns (uint256)"
  										}
  									},
  									id: 1756,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9641:38:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9620:59:3"
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									id: 1764,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										commonType: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										id: 1760,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										leftExpression: {
  											id: 1758,
  											name: "tokenOwner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1694,
  											src: "9877:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										nodeType: "BinaryOperation",
  										operator: "==",
  										rightExpression: {
  											id: 1759,
  											name: "dest",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1698,
  											src: "9891:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										src: "9877:18:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "||",
  									rightExpression: {
  										baseExpression: {
  											id: 1761,
  											name: "organizations",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1168,
  											src: "9899:13:3",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_bool_$",
  												typeString: "mapping(address => bool)"
  											}
  										},
  										id: 1763,
  										indexExpression: {
  											id: 1762,
  											name: "dest",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1698,
  											src: "9913:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "IndexAccess",
  										src: "9899:19:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									src: "9877:41:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1768,
  								nodeType: "IfStatement",
  								src: "9873:89:3",
  								trueBody: {
  									id: 1767,
  									nodeType: "Block",
  									src: "9920:42:3",
  									statements: [
  										{
  											expression: {
  												id: 1765,
  												name: "srcBalance",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1750,
  												src: "9941:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											functionReturnParameters: 1702,
  											id: 1766,
  											nodeType: "Return",
  											src: "9934:17:3"
  										}
  									]
  								}
  							},
  							{
  								assignments: [
  									1770
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1770,
  										mutability: "mutable",
  										name: "destBalance",
  										nodeType: "VariableDeclaration",
  										scope: 1830,
  										src: "10047:19:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1769,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "10047:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1777,
  								initialValue: {
  									"arguments": [
  										{
  											id: 1775,
  											name: "dest",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1698,
  											src: "10103:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										expression: {
  											baseExpression: {
  												id: 1771,
  												name: "userToToken",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1160,
  												src: "10069:11:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  													typeString: "mapping(address => contract Token)"
  												}
  											},
  											id: 1773,
  											indexExpression: {
  												id: 1772,
  												name: "tokenOwner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1694,
  												src: "10081:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "10069:23:3",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_Token_$2750",
  												typeString: "contract Token"
  											}
  										},
  										id: 1774,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "balanceOf",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 735,
  										src: "10069:33:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) view external returns (uint256)"
  										}
  									},
  									id: 1776,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10069:39:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10047:61:3"
  							},
  							{
  								assignments: [
  									1779
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1779,
  										mutability: "mutable",
  										name: "oneHundred",
  										nodeType: "VariableDeclaration",
  										scope: 1830,
  										src: "10119:18:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1778,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "10119:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1781,
  								initialValue: {
  									hexValue: "313030",
  									id: 1780,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "number",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "10140:3:3",
  									typeDescriptions: {
  										typeIdentifier: "t_rational_100_by_1",
  										typeString: "int_const 100"
  									},
  									value: "100"
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10119:24:3"
  							},
  							{
  								assignments: [
  									1783
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1783,
  										mutability: "mutable",
  										name: "max",
  										nodeType: "VariableDeclaration",
  										scope: 1830,
  										src: "10249:11:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1782,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "10249:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1801,
  								initialValue: {
  									"arguments": [
  										{
  											id: 1799,
  											name: "oneHundred",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1779,
  											src: "10333:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											components: [
  												{
  													"arguments": [
  														{
  															baseExpression: {
  																baseExpression: {
  																	id: 1791,
  																	name: "limits",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1174,
  																	src: "10302:6:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
  																		typeString: "mapping(address => mapping(address => uint256))"
  																	}
  																},
  																id: 1793,
  																indexExpression: {
  																	id: 1792,
  																	name: "dest",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1698,
  																	src: "10309:4:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																nodeType: "IndexAccess",
  																src: "10302:12:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  																	typeString: "mapping(address => uint256)"
  																}
  															},
  															id: 1795,
  															indexExpression: {
  																id: 1794,
  																name: "tokenOwner",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1694,
  																src: "10315:10:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "IndexAccess",
  															src: "10302:24:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															"arguments": [
  																{
  																	id: 1788,
  																	name: "dest",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1698,
  																	src: "10292:4:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																],
  																expression: {
  																	baseExpression: {
  																		id: 1784,
  																		name: "userToToken",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1160,
  																		src: "10264:11:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  																			typeString: "mapping(address => contract Token)"
  																		}
  																	},
  																	id: 1786,
  																	indexExpression: {
  																		id: 1785,
  																		name: "dest",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1698,
  																		src: "10276:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	isConstant: false,
  																	isLValue: true,
  																	isPure: false,
  																	lValueRequested: false,
  																	nodeType: "IndexAccess",
  																	src: "10264:17:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_contract$_Token_$2750",
  																		typeString: "contract Token"
  																	}
  																},
  																id: 1787,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "balanceOf",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 735,
  																src: "10264:27:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																	typeString: "function (address) view external returns (uint256)"
  																}
  															},
  															id: 1789,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "10264:33:3",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1790,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 237,
  														src: "10264:37:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1796,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "10264:63:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											id: 1797,
  											isConstant: false,
  											isInlineArray: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "TupleExpression",
  											src: "10263:65:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1798,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 259,
  										src: "10263:69:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1800,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10263:81:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10249:95:3"
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1804,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 1802,
  										name: "max",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1783,
  										src: "10466:3:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										id: 1803,
  										name: "destBalance",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1770,
  										src: "10472:11:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10466:17:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 1807,
  								nodeType: "IfStatement",
  								src: "10462:31:3",
  								trueBody: {
  									expression: {
  										hexValue: "30",
  										id: 1805,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "10492:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 1702,
  									id: 1806,
  									nodeType: "Return",
  									src: "10485:8:3"
  								}
  							},
  							{
  								assignments: [
  									1809
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1809,
  										mutability: "mutable",
  										name: "destBalanceScaled",
  										nodeType: "VariableDeclaration",
  										scope: 1830,
  										src: "10504:25:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1808,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "10504:7:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1824,
  								initialValue: {
  									"arguments": [
  										{
  											id: 1822,
  											name: "oneHundred",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1779,
  											src: "10594:10:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											"arguments": [
  												{
  													"arguments": [
  														{
  															baseExpression: {
  																baseExpression: {
  																	id: 1814,
  																	name: "limits",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1174,
  																	src: "10563:6:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
  																		typeString: "mapping(address => mapping(address => uint256))"
  																	}
  																},
  																id: 1816,
  																indexExpression: {
  																	id: 1815,
  																	name: "dest",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1698,
  																	src: "10570:4:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																nodeType: "IndexAccess",
  																src: "10563:12:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  																	typeString: "mapping(address => uint256)"
  																}
  															},
  															id: 1818,
  															indexExpression: {
  																id: 1817,
  																name: "tokenOwner",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1694,
  																src: "10576:10:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															nodeType: "IndexAccess",
  															src: "10563:24:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															id: 1812,
  															name: "oneHundred",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1779,
  															src: "10548:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1813,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sub",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 203,
  														src: "10548:14:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1819,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "10548:40:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													id: 1810,
  													name: "destBalance",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1770,
  													src: "10532:11:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1811,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 237,
  												src: "10532:15:3",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1820,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "10532:57:3",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1821,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 259,
  										src: "10532:61:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1823,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10532:73:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10504:101:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 1827,
  											name: "destBalanceScaled",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1809,
  											src: "10731:17:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											id: 1825,
  											name: "max",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1783,
  											src: "10723:3:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1826,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sub",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 203,
  										src: "10723:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1828,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10723:26:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1702,
  								id: 1829,
  								nodeType: "Return",
  								src: "10716:33:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1692,
  						nodeType: "StructuredDocumentation",
  						src: "8567:493:3",
  						text: "@notice finds the maximum amount of a specific token that can be sent between two users\n @dev the goal of this function is to always return a sensible number, it's used to validate transfer throughs, and also heavily in the graph/pathfinding services\n @param tokenOwner the safe/owner that the token was minted to\n @param src the sender of the tokens\n @param dest the recipient of the tokens\n @return the amount of tokenowner's token src can send to dest"
  					},
  					functionSelector: "8a0ef184",
  					id: 1831,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "checkSendLimit",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1699,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1694,
  								mutability: "mutable",
  								name: "tokenOwner",
  								nodeType: "VariableDeclaration",
  								scope: 1831,
  								src: "9089:18:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1693,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9089:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1696,
  								mutability: "mutable",
  								name: "src",
  								nodeType: "VariableDeclaration",
  								scope: 1831,
  								src: "9109:11:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1695,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9109:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1698,
  								mutability: "mutable",
  								name: "dest",
  								nodeType: "VariableDeclaration",
  								scope: 1831,
  								src: "9122:12:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1697,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9122:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "9088:47:3"
  					},
  					returnParameters: {
  						id: 1702,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1701,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1831,
  								src: "9157:7:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1700,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "9157:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "9156:9:3"
  					},
  					scope: 2238,
  					src: "9065:1691:3",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1925,
  						nodeType: "Block",
  						src: "11147:1087:3",
  						statements: [
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									id: 1846,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										expression: {
  											baseExpression: {
  												id: 1841,
  												name: "validation",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1211,
  												src: "11445:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  													typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  												}
  											},
  											id: 1843,
  											indexExpression: {
  												id: 1842,
  												name: "src",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1834,
  												src: "11456:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "11445:15:3",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  												typeString: "struct Hub.transferValidator storage ref"
  											}
  										},
  										id: 1844,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "seen",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1202,
  										src: "11445:20:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "!=",
  									rightExpression: {
  										hexValue: "66616c7365",
  										id: 1845,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "11469:5:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "false"
  									},
  									src: "11445:29:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: {
  									id: 1881,
  									nodeType: "Block",
  									src: "11634:185:3",
  									statements: [
  										{
  											expression: {
  												id: 1866,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													expression: {
  														baseExpression: {
  															id: 1861,
  															name: "validation",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1211,
  															src: "11713:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  															}
  														},
  														id: 1863,
  														indexExpression: {
  															id: 1862,
  															name: "src",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1834,
  															src: "11724:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "11713:15:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  															typeString: "struct Hub.transferValidator storage ref"
  														}
  													},
  													id: 1864,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "seen",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1202,
  													src: "11713:20:3",
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													hexValue: "74727565",
  													id: 1865,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "bool",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "11736:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													},
  													value: "true"
  												},
  												src: "11713:27:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											id: 1867,
  											nodeType: "ExpressionStatement",
  											src: "11713:27:3"
  										},
  										{
  											expression: {
  												id: 1873,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													expression: {
  														baseExpression: {
  															id: 1868,
  															name: "validation",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1211,
  															src: "11754:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  															}
  														},
  														id: 1870,
  														indexExpression: {
  															id: 1869,
  															name: "src",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1834,
  															src: "11765:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "11754:15:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  															typeString: "struct Hub.transferValidator storage ref"
  														}
  													},
  													id: 1871,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "sent",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1204,
  													src: "11754:20:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													id: 1872,
  													name: "wad",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1838,
  													src: "11777:3:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "11754:26:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1874,
  											nodeType: "ExpressionStatement",
  											src: "11754:26:3"
  										},
  										{
  											expression: {
  												"arguments": [
  													{
  														id: 1878,
  														name: "src",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1834,
  														src: "11804:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													expression: {
  														id: 1875,
  														name: "seen",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1214,
  														src: "11794:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_array$_t_address_$dyn_storage",
  															typeString: "address[] storage ref"
  														}
  													},
  													id: 1877,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "push",
  													nodeType: "MemberAccess",
  													src: "11794:9:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_arraypush_nonpayable$_t_address_$returns$__$",
  														typeString: "function (address)"
  													}
  												},
  												id: 1879,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "11794:14:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 1880,
  											nodeType: "ExpressionStatement",
  											src: "11794:14:3"
  										}
  									]
  								},
  								id: 1882,
  								nodeType: "IfStatement",
  								src: "11441:378:3",
  								trueBody: {
  									id: 1860,
  									nodeType: "Block",
  									src: "11476:152:3",
  									statements: [
  										{
  											expression: {
  												id: 1858,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													expression: {
  														baseExpression: {
  															id: 1847,
  															name: "validation",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1211,
  															src: "11565:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  															}
  														},
  														id: 1849,
  														indexExpression: {
  															id: 1848,
  															name: "src",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1834,
  															src: "11576:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "11565:15:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  															typeString: "struct Hub.transferValidator storage ref"
  														}
  													},
  													id: 1850,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "sent",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1204,
  													src: "11565:20:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  														{
  															id: 1856,
  															name: "wad",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1838,
  															src: "11613:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															expression: {
  																baseExpression: {
  																	id: 1851,
  																	name: "validation",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1211,
  																	src: "11588:10:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																		typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  																	}
  																},
  																id: 1853,
  																indexExpression: {
  																	id: 1852,
  																	name: "src",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1834,
  																	src: "11599:3:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																nodeType: "IndexAccess",
  																src: "11588:15:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  																	typeString: "struct Hub.transferValidator storage ref"
  																}
  															},
  															id: 1854,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "sent",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 1204,
  															src: "11588:20:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1855,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 181,
  														src: "11588:24:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1857,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "11588:29:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "11565:52:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1859,
  											nodeType: "ExpressionStatement",
  											src: "11565:52:3"
  										}
  									]
  								}
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									id: 1888,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										expression: {
  											baseExpression: {
  												id: 1883,
  												name: "validation",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1211,
  												src: "11832:10:3",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  													typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  												}
  											},
  											id: 1885,
  											indexExpression: {
  												id: 1884,
  												name: "dest",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1836,
  												src: "11843:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "11832:16:3",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  												typeString: "struct Hub.transferValidator storage ref"
  											}
  										},
  										id: 1886,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "seen",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1202,
  										src: "11832:21:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "!=",
  									rightExpression: {
  										hexValue: "66616c7365",
  										id: 1887,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "11857:5:3",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "false"
  									},
  									src: "11832:30:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: {
  									id: 1923,
  									nodeType: "Block",
  									src: "12032:196:3",
  									statements: [
  										{
  											expression: {
  												id: 1908,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													expression: {
  														baseExpression: {
  															id: 1903,
  															name: "validation",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1211,
  															src: "12111:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  															}
  														},
  														id: 1905,
  														indexExpression: {
  															id: 1904,
  															name: "dest",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1836,
  															src: "12122:4:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "12111:16:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  															typeString: "struct Hub.transferValidator storage ref"
  														}
  													},
  													id: 1906,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "seen",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1202,
  													src: "12111:21:3",
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													hexValue: "74727565",
  													id: 1907,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "bool",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "12135:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_bool",
  														typeString: "bool"
  													},
  													value: "true"
  												},
  												src: "12111:28:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											id: 1909,
  											nodeType: "ExpressionStatement",
  											src: "12111:28:3"
  										},
  										{
  											expression: {
  												id: 1915,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													expression: {
  														baseExpression: {
  															id: 1910,
  															name: "validation",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1211,
  															src: "12153:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  															}
  														},
  														id: 1912,
  														indexExpression: {
  															id: 1911,
  															name: "dest",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1836,
  															src: "12164:4:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "12153:16:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  															typeString: "struct Hub.transferValidator storage ref"
  														}
  													},
  													id: 1913,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "received",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1206,
  													src: "12153:25:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													id: 1914,
  													name: "wad",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1838,
  													src: "12181:3:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "12153:31:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1916,
  											nodeType: "ExpressionStatement",
  											src: "12153:31:3"
  										},
  										{
  											expression: {
  												"arguments": [
  													{
  														id: 1920,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1836,
  														src: "12209:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													expression: {
  														id: 1917,
  														name: "seen",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1214,
  														src: "12199:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_array$_t_address_$dyn_storage",
  															typeString: "address[] storage ref"
  														}
  													},
  													id: 1919,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "push",
  													nodeType: "MemberAccess",
  													src: "12199:9:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_arraypush_nonpayable$_t_address_$returns$__$",
  														typeString: "function (address)"
  													}
  												},
  												id: 1921,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "12199:15:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 1922,
  											nodeType: "ExpressionStatement",
  											src: "12199:15:3"
  										}
  									]
  								},
  								id: 1924,
  								nodeType: "IfStatement",
  								src: "11828:400:3",
  								trueBody: {
  									id: 1902,
  									nodeType: "Block",
  									src: "11864:162:3",
  									statements: [
  										{
  											expression: {
  												id: 1900,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													expression: {
  														baseExpression: {
  															id: 1889,
  															name: "validation",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1211,
  															src: "11953:10:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  															}
  														},
  														id: 1891,
  														indexExpression: {
  															id: 1890,
  															name: "dest",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1836,
  															src: "11964:4:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "11953:16:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  															typeString: "struct Hub.transferValidator storage ref"
  														}
  													},
  													id: 1892,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "received",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1206,
  													src: "11953:25:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  														{
  															id: 1898,
  															name: "wad",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1838,
  															src: "12011:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															expression: {
  																baseExpression: {
  																	id: 1893,
  																	name: "validation",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1211,
  																	src: "11981:10:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  																		typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  																	}
  																},
  																id: 1895,
  																indexExpression: {
  																	id: 1894,
  																	name: "dest",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1836,
  																	src: "11992:4:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																},
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																nodeType: "IndexAccess",
  																src: "11981:16:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  																	typeString: "struct Hub.transferValidator storage ref"
  																}
  															},
  															id: 1896,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "received",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 1206,
  															src: "11981:25:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1897,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 181,
  														src: "11981:29:3",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1899,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "11981:34:3",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "11953:62:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1901,
  											nodeType: "ExpressionStatement",
  											src: "11953:62:3"
  										}
  									]
  								}
  							}
  						]
  					},
  					documentation: {
  						id: 1832,
  						nodeType: "StructuredDocumentation",
  						src: "10762:305:3",
  						text: "@dev builds the validation data structures, called for each transaction step of a transtive transactions\n @param src the sender of a single transaction step\n @param dest the recipient of a single transaction step\n @param wad the amount being passed along a single transaction step"
  					},
  					id: 1926,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "buildValidationData",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1839,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1834,
  								mutability: "mutable",
  								name: "src",
  								nodeType: "VariableDeclaration",
  								scope: 1926,
  								src: "11101:11:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1833,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "11101:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1836,
  								mutability: "mutable",
  								name: "dest",
  								nodeType: "VariableDeclaration",
  								scope: 1926,
  								src: "11114:12:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1835,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "11114:7:3",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1838,
  								mutability: "mutable",
  								name: "wad",
  								nodeType: "VariableDeclaration",
  								scope: 1926,
  								src: "11128:8:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1837,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "11128:4:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "11100:37:3"
  					},
  					returnParameters: {
  						id: 1840,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "11147:0:3"
  					},
  					scope: 2238,
  					src: "11072:1162:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 2120,
  						nodeType: "Block",
  						src: "12442:2380:3",
  						statements: [
  							{
  								assignments: [
  									1933
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1933,
  										mutability: "mutable",
  										name: "src",
  										nodeType: "VariableDeclaration",
  										scope: 2120,
  										src: "12514:11:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 1932,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "12514:7:3",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1934,
  								nodeType: "VariableDeclarationStatement",
  								src: "12514:11:3"
  							},
  							{
  								assignments: [
  									1936
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1936,
  										mutability: "mutable",
  										name: "dest",
  										nodeType: "VariableDeclaration",
  										scope: 2120,
  										src: "12535:12:3",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										},
  										typeName: {
  											id: 1935,
  											name: "address",
  											nodeType: "ElementaryTypeName",
  											src: "12535:7:3",
  											stateMutability: "nonpayable",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 1937,
  								nodeType: "VariableDeclarationStatement",
  								src: "12535:12:3"
  							},
  							{
  								body: {
  									id: 2013,
  									nodeType: "Block",
  									src: "12693:905:3",
  									statements: [
  										{
  											assignments: [
  												1950
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 1950,
  													mutability: "mutable",
  													name: "curr",
  													nodeType: "VariableDeclaration",
  													scope: 2013,
  													src: "12707:29:3",
  													stateVariable: false,
  													storageLocation: "memory",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_transferValidator_$1207_memory_ptr",
  														typeString: "struct Hub.transferValidator"
  													},
  													typeName: {
  														id: 1949,
  														name: "transferValidator",
  														nodeType: "UserDefinedTypeName",
  														referencedDeclaration: 1207,
  														src: "12707:17:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_storage_ptr",
  															typeString: "struct Hub.transferValidator"
  														}
  													},
  													visibility: "internal"
  												}
  											],
  											id: 1956,
  											initialValue: {
  												baseExpression: {
  													id: 1951,
  													name: "validation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1211,
  													src: "12739:10:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  														typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  													}
  												},
  												id: 1955,
  												indexExpression: {
  													baseExpression: {
  														id: 1952,
  														name: "seen",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1214,
  														src: "12750:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_array$_t_address_$dyn_storage",
  															typeString: "address[] storage ref"
  														}
  													},
  													id: 1954,
  													indexExpression: {
  														id: 1953,
  														name: "i",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1939,
  														src: "12755:1:3",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "12750:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "12739:19:3",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  													typeString: "struct Hub.transferValidator storage ref"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "12707:51:3"
  										},
  										{
  											condition: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												id: 1961,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													expression: {
  														id: 1957,
  														name: "curr",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1950,
  														src: "12856:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_memory_ptr",
  															typeString: "struct Hub.transferValidator memory"
  														}
  													},
  													id: 1958,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sent",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1204,
  													src: "12856:9:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: ">",
  												rightExpression: {
  													expression: {
  														id: 1959,
  														name: "curr",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1950,
  														src: "12868:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_memory_ptr",
  															typeString: "struct Hub.transferValidator memory"
  														}
  													},
  													id: 1960,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "received",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1206,
  													src: "12868:13:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "12856:25:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											id: 1989,
  											nodeType: "IfStatement",
  											src: "12852:403:3",
  											trueBody: {
  												id: 1988,
  												nodeType: "Block",
  												src: "12883:372:3",
  												statements: [
  													{
  														expression: {
  															"arguments": [
  																{
  																	commonType: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	id: 1968,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		id: 1963,
  																		name: "src",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1933,
  																		src: "12984:3:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "==",
  																	rightExpression: {
  																		"arguments": [
  																			{
  																				hexValue: "30",
  																				id: 1966,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "12999:1:3",
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				},
  																				value: "0"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				}
  																			],
  																			id: 1965,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "12991:7:3",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_address_$",
  																				typeString: "type(address)"
  																			},
  																			typeName: {
  																				id: 1964,
  																				name: "address",
  																				nodeType: "ElementaryTypeName",
  																				src: "12991:7:3",
  																				typeDescriptions: {
  																				}
  																			}
  																		},
  																		id: 1967,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "12991:10:3",
  																		tryCall: false,
  																		typeDescriptions: {
  																			typeIdentifier: "t_address_payable",
  																			typeString: "address payable"
  																		}
  																	},
  																	src: "12984:17:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	hexValue: "506174682073656e64732066726f6d206d6f7265207468616e206f6e6520737263",
  																	id: 1969,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "13003:35:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_bd5ad249a9664f143a0488240f4d415946e88e6be137102a9ebc93e8312ca47d",
  																		typeString: "literal_string \"Path sends from more than one src\""
  																	},
  																	value: "Path sends from more than one src"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_bd5ad249a9664f143a0488240f4d415946e88e6be137102a9ebc93e8312ca47d",
  																		typeString: "literal_string \"Path sends from more than one src\""
  																	}
  																],
  																id: 1962,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	-18,
  																	-18
  																],
  																referencedDeclaration: -18,
  																src: "12976:7:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 1970,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "12976:63:3",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 1971,
  														nodeType: "ExpressionStatement",
  														src: "12976:63:3"
  													},
  													{
  														expression: {
  															"arguments": [
  																{
  																	commonType: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	id: 1978,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		baseExpression: {
  																			id: 1973,
  																			name: "seen",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 1214,
  																			src: "13142:4:3",
  																			typeDescriptions: {
  																				typeIdentifier: "t_array$_t_address_$dyn_storage",
  																				typeString: "address[] storage ref"
  																			}
  																		},
  																		id: 1975,
  																		indexExpression: {
  																			id: 1974,
  																			name: "i",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 1939,
  																			src: "13147:1:3",
  																			typeDescriptions: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		},
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		nodeType: "IndexAccess",
  																		src: "13142:7:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "==",
  																	rightExpression: {
  																		expression: {
  																			id: 1976,
  																			name: "msg",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: -15,
  																			src: "13153:3:3",
  																			typeDescriptions: {
  																				typeIdentifier: "t_magic_message",
  																				typeString: "msg"
  																			}
  																		},
  																		id: 1977,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "sender",
  																		nodeType: "MemberAccess",
  																		src: "13153:10:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address_payable",
  																			typeString: "address payable"
  																		}
  																	},
  																	src: "13142:21:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	hexValue: "5061746820646f65736e27742073656e642066726f6d207472616e73616374696f6e2073656e646572",
  																	id: 1979,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "13165:43:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_d9e6394d4dbbea9b9a8aaf6490cf335c359714fd39b81ef3bbaa04a6167eaa70",
  																		typeString: "literal_string \"Path doesn't send from transaction sender\""
  																	},
  																	value: "Path doesn't send from transaction sender"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_d9e6394d4dbbea9b9a8aaf6490cf335c359714fd39b81ef3bbaa04a6167eaa70",
  																		typeString: "literal_string \"Path doesn't send from transaction sender\""
  																	}
  																],
  																id: 1972,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	-18,
  																	-18
  																],
  																referencedDeclaration: -18,
  																src: "13134:7:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 1980,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "13134:75:3",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 1981,
  														nodeType: "ExpressionStatement",
  														src: "13134:75:3"
  													},
  													{
  														expression: {
  															id: 1986,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 1982,
  																name: "src",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1933,
  																src: "13227:3:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																baseExpression: {
  																	id: 1983,
  																	name: "seen",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1214,
  																	src: "13233:4:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_array$_t_address_$dyn_storage",
  																		typeString: "address[] storage ref"
  																	}
  																},
  																id: 1985,
  																indexExpression: {
  																	id: 1984,
  																	name: "i",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1939,
  																	src: "13238:1:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																nodeType: "IndexAccess",
  																src: "13233:7:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															src: "13227:13:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														id: 1987,
  														nodeType: "ExpressionStatement",
  														src: "13227:13:3"
  													}
  												]
  											}
  										},
  										{
  											condition: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												id: 1994,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													expression: {
  														id: 1990,
  														name: "curr",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1950,
  														src: "13355:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_memory_ptr",
  															typeString: "struct Hub.transferValidator memory"
  														}
  													},
  													id: 1991,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "received",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1206,
  													src: "13355:13:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: ">",
  												rightExpression: {
  													expression: {
  														id: 1992,
  														name: "curr",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1950,
  														src: "13371:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_transferValidator_$1207_memory_ptr",
  															typeString: "struct Hub.transferValidator memory"
  														}
  													},
  													id: 1993,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sent",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1204,
  													src: "13371:9:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "13355:25:3",
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											id: 2012,
  											nodeType: "IfStatement",
  											src: "13351:237:3",
  											trueBody: {
  												id: 2011,
  												nodeType: "Block",
  												src: "13382:206:3",
  												statements: [
  													{
  														expression: {
  															"arguments": [
  																{
  																	commonType: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	},
  																	id: 2001,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	leftExpression: {
  																		id: 1996,
  																		name: "dest",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 1936,
  																		src: "13486:4:3",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	},
  																	nodeType: "BinaryOperation",
  																	operator: "==",
  																	rightExpression: {
  																		"arguments": [
  																			{
  																				hexValue: "30",
  																				id: 1999,
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				kind: "number",
  																				lValueRequested: false,
  																				nodeType: "Literal",
  																				src: "13502:1:3",
  																				typeDescriptions: {
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				},
  																				value: "0"
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_rational_0_by_1",
  																					typeString: "int_const 0"
  																				}
  																			],
  																			id: 1998,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "13494:7:3",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_address_$",
  																				typeString: "type(address)"
  																			},
  																			typeName: {
  																				id: 1997,
  																				name: "address",
  																				nodeType: "ElementaryTypeName",
  																				src: "13494:7:3",
  																				typeDescriptions: {
  																				}
  																			}
  																		},
  																		id: 2000,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "13494:10:3",
  																		tryCall: false,
  																		typeDescriptions: {
  																			typeIdentifier: "t_address_payable",
  																			typeString: "address payable"
  																		}
  																	},
  																	src: "13486:18:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	}
  																},
  																{
  																	hexValue: "506174682073656e647320746f206d6f7265207468616e206f6e652064657374",
  																	id: 2002,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: true,
  																	kind: "string",
  																	lValueRequested: false,
  																	nodeType: "Literal",
  																	src: "13506:34:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_stringliteral_636ae00d32879d12302d10bdd0b90698f43cf16407a22a354e188979ec5b7df3",
  																		typeString: "literal_string \"Path sends to more than one dest\""
  																	},
  																	value: "Path sends to more than one dest"
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_bool",
  																		typeString: "bool"
  																	},
  																	{
  																		typeIdentifier: "t_stringliteral_636ae00d32879d12302d10bdd0b90698f43cf16407a22a354e188979ec5b7df3",
  																		typeString: "literal_string \"Path sends to more than one dest\""
  																	}
  																],
  																id: 1995,
  																name: "require",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																	-18,
  																	-18
  																],
  																referencedDeclaration: -18,
  																src: "13478:7:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  																	typeString: "function (bool,string memory) pure"
  																}
  															},
  															id: 2003,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "13478:63:3",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_tuple$__$",
  																typeString: "tuple()"
  															}
  														},
  														id: 2004,
  														nodeType: "ExpressionStatement",
  														src: "13478:63:3"
  													},
  													{
  														expression: {
  															id: 2009,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftHandSide: {
  																id: 2005,
  																name: "dest",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1936,
  																src: "13559:4:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															nodeType: "Assignment",
  															operator: "=",
  															rightHandSide: {
  																baseExpression: {
  																	id: 2006,
  																	name: "seen",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1214,
  																	src: "13566:4:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_array$_t_address_$dyn_storage",
  																		typeString: "address[] storage ref"
  																	}
  																},
  																id: 2008,
  																indexExpression: {
  																	id: 2007,
  																	name: "i",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1939,
  																	src: "13571:1:3",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																nodeType: "IndexAccess",
  																src: "13566:7:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																}
  															},
  															src: "13559:14:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														id: 2010,
  														nodeType: "ExpressionStatement",
  														src: "13559:14:3"
  													}
  												]
  											}
  										}
  									]
  								},
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1945,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 1942,
  										name: "i",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1939,
  										src: "12671:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										expression: {
  											id: 1943,
  											name: "seen",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1214,
  											src: "12675:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_storage",
  												typeString: "address[] storage ref"
  											}
  										},
  										id: 1944,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										src: "12675:11:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "12671:15:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2014,
  								initializationExpression: {
  									assignments: [
  										1939
  									],
  									declarations: [
  										{
  											constant: false,
  											id: 1939,
  											mutability: "mutable",
  											name: "i",
  											nodeType: "VariableDeclaration",
  											scope: 2014,
  											src: "12659:6:3",
  											stateVariable: false,
  											storageLocation: "default",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											typeName: {
  												id: 1938,
  												name: "uint",
  												nodeType: "ElementaryTypeName",
  												src: "12659:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											visibility: "internal"
  										}
  									],
  									id: 1941,
  									initialValue: {
  										hexValue: "30",
  										id: 1940,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "12668:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									nodeType: "VariableDeclarationStatement",
  									src: "12659:10:3"
  								},
  								loopExpression: {
  									expression: {
  										id: 1947,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "++",
  										prefix: false,
  										src: "12688:3:3",
  										subExpression: {
  											id: 1946,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1939,
  											src: "12688:1:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 1948,
  									nodeType: "ExpressionStatement",
  									src: "12688:3:3"
  								},
  								nodeType: "ForStatement",
  								src: "12654:944:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 2021,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												id: 2016,
  												name: "src",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1933,
  												src: "13673:3:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												"arguments": [
  													{
  														hexValue: "30",
  														id: 2019,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "13688:1:3",
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 2018,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "13680:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 2017,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "13680:7:3",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 2020,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "13680:10:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "13673:17:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "5472616e73616374696f6e206d7573742068617665206120737263",
  											id: 2022,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "13692:29:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_6ded99c44d58ae990e48a4fa06b4daac2277f2603cae3502a4dbd932987e5f7f",
  												typeString: "literal_string \"Transaction must have a src\""
  											},
  											value: "Transaction must have a src"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_6ded99c44d58ae990e48a4fa06b4daac2277f2603cae3502a4dbd932987e5f7f",
  												typeString: "literal_string \"Transaction must have a src\""
  											}
  										],
  										id: 2015,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "13665:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2023,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "13665:57:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2024,
  								nodeType: "ExpressionStatement",
  								src: "13665:57:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 2031,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												id: 2026,
  												name: "dest",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1936,
  												src: "13740:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												"arguments": [
  													{
  														hexValue: "30",
  														id: 2029,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "13756:1:3",
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 2028,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "13748:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 2027,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "13748:7:3",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 2030,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "13748:10:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "13740:18:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "5472616e73616374696f6e206d757374206861766520612064657374",
  											id: 2032,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "13760:30:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_41d6d26c8e90b951d2aec8b2d38d1057d948500e39d06b0e7fbdaeb0bc360992",
  												typeString: "literal_string \"Transaction must have a dest\""
  											},
  											value: "Transaction must have a dest"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_41d6d26c8e90b951d2aec8b2d38d1057d948500e39d06b0e7fbdaeb0bc360992",
  												typeString: "literal_string \"Transaction must have a dest\""
  											}
  										],
  										id: 2025,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "13732:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2033,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "13732:59:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2034,
  								nodeType: "ExpressionStatement",
  								src: "13732:59:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2041,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													baseExpression: {
  														id: 2036,
  														name: "validation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1211,
  														src: "13987:10:3",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  															typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  														}
  													},
  													id: 2038,
  													indexExpression: {
  														id: 2037,
  														name: "src",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1933,
  														src: "13998:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "13987:15:3",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  														typeString: "struct Hub.transferValidator storage ref"
  													}
  												},
  												id: 2039,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "received",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1206,
  												src: "13987:24:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												hexValue: "30",
  												id: 2040,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "14015:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "13987:29:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "53656e64657220697320726563656976696e67",
  											id: 2042,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "14018:21:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_89f5905e57e8dce0a828148fcfff03bb5a643f9180447bef665b1d7134d626ef",
  												typeString: "literal_string \"Sender is receiving\""
  											},
  											value: "Sender is receiving"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_89f5905e57e8dce0a828148fcfff03bb5a643f9180447bef665b1d7134d626ef",
  												typeString: "literal_string \"Sender is receiving\""
  											}
  										],
  										id: 2035,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "13979:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2043,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "13979:61:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2044,
  								nodeType: "ExpressionStatement",
  								src: "13979:61:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2051,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													baseExpression: {
  														id: 2046,
  														name: "validation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1211,
  														src: "14058:10:3",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  															typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  														}
  													},
  													id: 2048,
  													indexExpression: {
  														id: 2047,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1936,
  														src: "14069:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "14058:16:3",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  														typeString: "struct Hub.transferValidator storage ref"
  													}
  												},
  												id: 2049,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sent",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1204,
  												src: "14058:21:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												hexValue: "30",
  												id: 2050,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "14083:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "14058:26:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "526563697069656e742069732073656e64696e67",
  											id: 2052,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "14086:22:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_18747d2531191c2698bbaf45882679d66443118c356c2287d6d9e9a5c7fcf973",
  												typeString: "literal_string \"Recipient is sending\""
  											},
  											value: "Recipient is sending"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_18747d2531191c2698bbaf45882679d66443118c356c2287d6d9e9a5c7fcf973",
  												typeString: "literal_string \"Recipient is sending\""
  											}
  										],
  										id: 2045,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "14050:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2053,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14050:59:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2054,
  								nodeType: "ExpressionStatement",
  								src: "14050:59:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2064,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													baseExpression: {
  														id: 2056,
  														name: "validation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1211,
  														src: "14211:10:3",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  															typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  														}
  													},
  													id: 2058,
  													indexExpression: {
  														id: 2057,
  														name: "src",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1933,
  														src: "14222:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "14211:15:3",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  														typeString: "struct Hub.transferValidator storage ref"
  													}
  												},
  												id: 2059,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sent",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1204,
  												src: "14211:20:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												expression: {
  													baseExpression: {
  														id: 2060,
  														name: "validation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1211,
  														src: "14235:10:3",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  															typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  														}
  													},
  													id: 2062,
  													indexExpression: {
  														id: 2061,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1936,
  														src: "14246:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "14235:16:3",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  														typeString: "struct Hub.transferValidator storage ref"
  													}
  												},
  												id: 2063,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "received",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1206,
  												src: "14235:25:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "14211:49:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "556e657175616c2073656e7420616e6420726563656976656420616d6f756e7473",
  											id: 2065,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "14262:35:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_f5c3e52d85771c19e73499345987bbb17e32ec59d7cb8ef334626a423fb94cfb",
  												typeString: "literal_string \"Unequal sent and received amounts\""
  											},
  											value: "Unequal sent and received amounts"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_f5c3e52d85771c19e73499345987bbb17e32ec59d7cb8ef334626a423fb94cfb",
  												typeString: "literal_string \"Unequal sent and received amounts\""
  											}
  										],
  										id: 2055,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "14203:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2066,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14203:95:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2067,
  								nodeType: "ExpressionStatement",
  								src: "14203:95:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2074,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2069,
  													name: "seen",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1214,
  													src: "14408:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_storage",
  														typeString: "address[] storage ref"
  													}
  												},
  												id: 2070,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "14408:11:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "<=",
  											rightExpression: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												id: 2073,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftExpression: {
  													id: 2071,
  													name: "steps",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1929,
  													src: "14423:5:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "BinaryOperation",
  												operator: "+",
  												rightExpression: {
  													hexValue: "31",
  													id: 2072,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													kind: "number",
  													lValueRequested: false,
  													nodeType: "Literal",
  													src: "14431:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_rational_1_by_1",
  														typeString: "int_const 1"
  													},
  													value: "1"
  												},
  												src: "14423:9:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "14408:24:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "5365656e20746f6f206d616e7920616464726573736573",
  											id: 2075,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "14434:25:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_9c7094d6ce7f5df448f76d8136b15f6c81c4846433c1fec602370bb5e0be3b5f",
  												typeString: "literal_string \"Seen too many addresses\""
  											},
  											value: "Seen too many addresses"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_9c7094d6ce7f5df448f76d8136b15f6c81c4846433c1fec602370bb5e0be3b5f",
  												typeString: "literal_string \"Seen too many addresses\""
  											}
  										],
  										id: 2068,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "14400:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2076,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14400:60:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2077,
  								nodeType: "ExpressionStatement",
  								src: "14400:60:3"
  							},
  							{
  								eventCall: {
  									"arguments": [
  										{
  											id: 2079,
  											name: "src",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1933,
  											src: "14487:3:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											id: 2080,
  											name: "dest",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1936,
  											src: "14492:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											expression: {
  												baseExpression: {
  													id: 2081,
  													name: "validation",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1211,
  													src: "14498:10:3",
  													typeDescriptions: {
  														typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  														typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  													}
  												},
  												id: 2083,
  												indexExpression: {
  													id: 2082,
  													name: "src",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1933,
  													src: "14509:3:3",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "14498:15:3",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  													typeString: "struct Hub.transferValidator storage ref"
  												}
  											},
  											id: 2084,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sent",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 1204,
  											src: "14498:20:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 2078,
  										name: "HubTransfer",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1200,
  										src: "14475:11:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 2085,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14475:44:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2086,
  								nodeType: "EmitStatement",
  								src: "14470:49:3"
  							},
  							{
  								body: {
  									id: 2107,
  									nodeType: "Block",
  									src: "14619:53:3",
  									statements: [
  										{
  											expression: {
  												id: 2105,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "UnaryOperation",
  												operator: "delete",
  												prefix: true,
  												src: "14633:28:3",
  												subExpression: {
  													baseExpression: {
  														id: 2098,
  														name: "validation",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1211,
  														src: "14640:10:3",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_transferValidator_$1207_storage_$",
  															typeString: "mapping(address => struct Hub.transferValidator storage ref)"
  														}
  													},
  													id: 2104,
  													indexExpression: {
  														baseExpression: {
  															id: 2099,
  															name: "seen",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1214,
  															src: "14651:4:3",
  															typeDescriptions: {
  																typeIdentifier: "t_array$_t_address_$dyn_storage",
  																typeString: "address[] storage ref"
  															}
  														},
  														id: 2103,
  														indexExpression: {
  															commonType: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															id: 2102,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															leftExpression: {
  																id: 2100,
  																name: "i",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2088,
  																src: "14656:1:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															nodeType: "BinaryOperation",
  															operator: "-",
  															rightExpression: {
  																hexValue: "31",
  																id: 2101,
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																kind: "number",
  																lValueRequested: false,
  																nodeType: "Literal",
  																src: "14658:1:3",
  																typeDescriptions: {
  																	typeIdentifier: "t_rational_1_by_1",
  																	typeString: "int_const 1"
  																},
  																value: "1"
  															},
  															src: "14656:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "14651:9:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													nodeType: "IndexAccess",
  													src: "14640:21:3",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_transferValidator_$1207_storage",
  														typeString: "struct Hub.transferValidator storage ref"
  													}
  												},
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 2106,
  											nodeType: "ExpressionStatement",
  											src: "14633:28:3"
  										}
  									]
  								},
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 2094,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 2092,
  										name: "i",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2088,
  										src: "14606:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">=",
  									rightExpression: {
  										hexValue: "31",
  										id: 2093,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "14611:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_1_by_1",
  											typeString: "int_const 1"
  										},
  										value: "1"
  									},
  									src: "14606:6:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2108,
  								initializationExpression: {
  									assignments: [
  										2088
  									],
  									declarations: [
  										{
  											constant: false,
  											id: 2088,
  											mutability: "mutable",
  											name: "i",
  											nodeType: "VariableDeclaration",
  											scope: 2108,
  											src: "14584:6:3",
  											stateVariable: false,
  											storageLocation: "default",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											typeName: {
  												id: 2087,
  												name: "uint",
  												nodeType: "ElementaryTypeName",
  												src: "14584:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											visibility: "internal"
  										}
  									],
  									id: 2091,
  									initialValue: {
  										expression: {
  											id: 2089,
  											name: "seen",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1214,
  											src: "14593:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_storage",
  												typeString: "address[] storage ref"
  											}
  										},
  										id: 2090,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										src: "14593:11:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "VariableDeclarationStatement",
  									src: "14584:20:3"
  								},
  								loopExpression: {
  									expression: {
  										id: 2096,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "--",
  										prefix: false,
  										src: "14614:3:3",
  										subExpression: {
  											id: 2095,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2088,
  											src: "14614:1:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 2097,
  									nodeType: "ExpressionStatement",
  									src: "14614:3:3"
  								},
  								nodeType: "ForStatement",
  								src: "14579:93:3"
  							},
  							{
  								expression: {
  									id: 2110,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "UnaryOperation",
  									operator: "delete",
  									prefix: true,
  									src: "14681:11:3",
  									subExpression: {
  										id: 2109,
  										name: "seen",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1214,
  										src: "14688:4:3",
  										typeDescriptions: {
  											typeIdentifier: "t_array$_t_address_$dyn_storage",
  											typeString: "address[] storage ref"
  										}
  									},
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2111,
  								nodeType: "ExpressionStatement",
  								src: "14681:11:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2116,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2113,
  													name: "seen",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1214,
  													src: "14774:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_storage",
  														typeString: "address[] storage ref"
  													}
  												},
  												id: 2114,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "14774:11:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												hexValue: "30",
  												id: 2115,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "14789:1:3",
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "14774:16:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "5365656e2073686f756c6420626520656d707479",
  											id: 2117,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "14792:22:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_df31f4cd56ee9d90a8a753c8f534dd8dec3b906d4966bf0461a5aea6d1e8b098",
  												typeString: "literal_string \"Seen should be empty\""
  											},
  											value: "Seen should be empty"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_df31f4cd56ee9d90a8a753c8f534dd8dec3b906d4966bf0461a5aea6d1e8b098",
  												typeString: "literal_string \"Seen should be empty\""
  											}
  										],
  										id: 2112,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "14766:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2118,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "14766:49:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2119,
  								nodeType: "ExpressionStatement",
  								src: "14766:49:3"
  							}
  						]
  					},
  					documentation: {
  						id: 1927,
  						nodeType: "StructuredDocumentation",
  						src: "12240:140:3",
  						text: "@dev performs the validation for an attempted transitive transfer\n @param steps the number of steps in the transitive transaction"
  					},
  					id: 2121,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "validateTransferThrough",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1930,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1929,
  								mutability: "mutable",
  								name: "steps",
  								nodeType: "VariableDeclaration",
  								scope: 2121,
  								src: "12418:13:3",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1928,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "12418:7:3",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "12417:15:3"
  					},
  					returnParameters: {
  						id: 1931,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "12442:0:3"
  					},
  					scope: 2238,
  					src: "12385:2437:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 2236,
  						nodeType: "Block",
  						src: "15451:1081:3",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2142,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2138,
  													name: "dests",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2131,
  													src: "15519:5:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2139,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "15519:12:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												expression: {
  													id: 2140,
  													name: "tokenOwners",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2125,
  													src: "15535:11:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2141,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "15535:18:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "15519:34:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "546f6b656e73206172726179206c656e677468206d75737420657175616c206465737473206172726179",
  											id: 2143,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "15555:44:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_59ad779d34add4559c288c6282fd203bb30023e760668fd175322e96d95f2b2d",
  												typeString: "literal_string \"Tokens array length must equal dests array\""
  											},
  											value: "Tokens array length must equal dests array"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_59ad779d34add4559c288c6282fd203bb30023e760668fd175322e96d95f2b2d",
  												typeString: "literal_string \"Tokens array length must equal dests array\""
  											}
  										],
  										id: 2137,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "15511:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2144,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15511:89:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2145,
  								nodeType: "ExpressionStatement",
  								src: "15511:89:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2151,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2147,
  													name: "srcs",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2128,
  													src: "15618:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2148,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "15618:11:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												expression: {
  													id: 2149,
  													name: "tokenOwners",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2125,
  													src: "15633:11:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2150,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "15633:18:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "15618:33:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "546f6b656e73206172726179206c656e677468206d75737420657175616c2073726373206172726179",
  											id: 2152,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "15653:43:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_350a87b7a24261b7126182087ee093f882e791fb9f86d5409c3f4134f397e659",
  												typeString: "literal_string \"Tokens array length must equal srcs array\""
  											},
  											value: "Tokens array length must equal srcs array"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_350a87b7a24261b7126182087ee093f882e791fb9f86d5409c3f4134f397e659",
  												typeString: "literal_string \"Tokens array length must equal srcs array\""
  											}
  										],
  										id: 2146,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "15610:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2153,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15610:87:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2154,
  								nodeType: "ExpressionStatement",
  								src: "15610:87:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 2160,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2156,
  													name: "wads",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2134,
  													src: "15715:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_uint256_$dyn_memory_ptr",
  														typeString: "uint256[] memory"
  													}
  												},
  												id: 2157,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "15715:11:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												expression: {
  													id: 2158,
  													name: "tokenOwners",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2125,
  													src: "15730:11:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2159,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "length",
  												nodeType: "MemberAccess",
  												src: "15730:18:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "15715:33:3",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											hexValue: "546f6b656e73206172726179206c656e677468206d75737420657175616c20616d6f756e7473206172726179",
  											id: 2161,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "15750:46:3",
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_6b9adb5f6ee0763717d7c928a999cc9d2c329729480d2b7fe0e4a678da677bfc",
  												typeString: "literal_string \"Tokens array length must equal amounts array\""
  											},
  											value: "Tokens array length must equal amounts array"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_6b9adb5f6ee0763717d7c928a999cc9d2c329729480d2b7fe0e4a678da677bfc",
  												typeString: "literal_string \"Tokens array length must equal amounts array\""
  											}
  										],
  										id: 2155,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "15707:7:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 2162,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "15707:90:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2163,
  								nodeType: "ExpressionStatement",
  								src: "15707:90:3"
  							},
  							{
  								body: {
  									id: 2229,
  									nodeType: "Block",
  									src: "15846:574:3",
  									statements: [
  										{
  											assignments: [
  												2176
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 2176,
  													mutability: "mutable",
  													name: "src",
  													nodeType: "VariableDeclaration",
  													scope: 2229,
  													src: "15860:11:3",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													typeName: {
  														id: 2175,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "15860:7:3",
  														stateMutability: "nonpayable",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													visibility: "internal"
  												}
  											],
  											id: 2180,
  											initialValue: {
  												baseExpression: {
  													id: 2177,
  													name: "srcs",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2128,
  													src: "15874:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2179,
  												indexExpression: {
  													id: 2178,
  													name: "i",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2165,
  													src: "15879:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "15874:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "15860:21:3"
  										},
  										{
  											assignments: [
  												2182
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 2182,
  													mutability: "mutable",
  													name: "dest",
  													nodeType: "VariableDeclaration",
  													scope: 2229,
  													src: "15895:12:3",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													typeName: {
  														id: 2181,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "15895:7:3",
  														stateMutability: "nonpayable",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													visibility: "internal"
  												}
  											],
  											id: 2186,
  											initialValue: {
  												baseExpression: {
  													id: 2183,
  													name: "dests",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2131,
  													src: "15910:5:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2185,
  												indexExpression: {
  													id: 2184,
  													name: "i",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2165,
  													src: "15916:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "15910:8:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "15895:23:3"
  										},
  										{
  											assignments: [
  												2188
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 2188,
  													mutability: "mutable",
  													name: "token",
  													nodeType: "VariableDeclaration",
  													scope: 2229,
  													src: "15932:13:3",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													typeName: {
  														id: 2187,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "15932:7:3",
  														stateMutability: "nonpayable",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													visibility: "internal"
  												}
  											],
  											id: 2192,
  											initialValue: {
  												baseExpression: {
  													id: 2189,
  													name: "tokenOwners",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2125,
  													src: "15948:11:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  														typeString: "address[] memory"
  													}
  												},
  												id: 2191,
  												indexExpression: {
  													id: 2190,
  													name: "i",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2165,
  													src: "15960:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "15948:14:3",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "15932:30:3"
  										},
  										{
  											assignments: [
  												2194
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 2194,
  													mutability: "mutable",
  													name: "wad",
  													nodeType: "VariableDeclaration",
  													scope: 2229,
  													src: "15976:11:3",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													typeName: {
  														id: 2193,
  														name: "uint256",
  														nodeType: "ElementaryTypeName",
  														src: "15976:7:3",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													visibility: "internal"
  												}
  											],
  											id: 2198,
  											initialValue: {
  												baseExpression: {
  													id: 2195,
  													name: "wads",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2134,
  													src: "15990:4:3",
  													typeDescriptions: {
  														typeIdentifier: "t_array$_t_uint256_$dyn_memory_ptr",
  														typeString: "uint256[] memory"
  													}
  												},
  												id: 2197,
  												indexExpression: {
  													id: 2196,
  													name: "i",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2165,
  													src: "15995:1:3",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												nodeType: "IndexAccess",
  												src: "15990:7:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "15976:21:3"
  										},
  										{
  											assignments: [
  												2200
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 2200,
  													mutability: "mutable",
  													name: "max",
  													nodeType: "VariableDeclaration",
  													scope: 2229,
  													src: "16079:11:3",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													typeName: {
  														id: 2199,
  														name: "uint256",
  														nodeType: "ElementaryTypeName",
  														src: "16079:7:3",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													visibility: "internal"
  												}
  											],
  											id: 2206,
  											initialValue: {
  												"arguments": [
  													{
  														id: 2202,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2188,
  														src: "16108:5:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2203,
  														name: "src",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2176,
  														src: "16115:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2204,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2182,
  														src: "16120:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													id: 2201,
  													name: "checkSendLimit",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1831,
  													src: "16093:14:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_view$_t_address_$_t_address_$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address,address,address) view returns (uint256)"
  													}
  												},
  												id: 2205,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16093:32:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "16079:46:3"
  										},
  										{
  											expression: {
  												"arguments": [
  													{
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														id: 2210,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														leftExpression: {
  															id: 2208,
  															name: "wad",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2194,
  															src: "16147:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														nodeType: "BinaryOperation",
  														operator: "<=",
  														rightExpression: {
  															id: 2209,
  															name: "max",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2200,
  															src: "16154:3:3",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														src: "16147:10:3",
  														typeDescriptions: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														}
  													},
  													{
  														hexValue: "5472757374206c696d6974206578636565646564",
  														id: 2211,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "string",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "16159:22:3",
  														typeDescriptions: {
  															typeIdentifier: "t_stringliteral_bfd65915118c90a8f528a4497fd37b2c98d1b399053d7d29cf1cda0cd1d9b348",
  															typeString: "literal_string \"Trust limit exceeded\""
  														},
  														value: "Trust limit exceeded"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														{
  															typeIdentifier: "t_stringliteral_bfd65915118c90a8f528a4497fd37b2c98d1b399053d7d29cf1cda0cd1d9b348",
  															typeString: "literal_string \"Trust limit exceeded\""
  														}
  													],
  													id: 2207,
  													name: "require",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  														-18,
  														-18
  													],
  													referencedDeclaration: -18,
  													src: "16139:7:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  														typeString: "function (bool,string memory) pure"
  													}
  												},
  												id: 2212,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16139:43:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 2213,
  											nodeType: "ExpressionStatement",
  											src: "16139:43:3"
  										},
  										{
  											expression: {
  												"arguments": [
  													{
  														id: 2215,
  														name: "src",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2176,
  														src: "16217:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2216,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2182,
  														src: "16222:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2217,
  														name: "wad",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2194,
  														src: "16228:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 2214,
  													name: "buildValidationData",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1926,
  													src: "16197:19:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  														typeString: "function (address,address,uint256)"
  													}
  												},
  												id: 2218,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16197:35:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 2219,
  											nodeType: "ExpressionStatement",
  											src: "16197:35:3"
  										},
  										{
  											expression: {
  												"arguments": [
  													{
  														id: 2224,
  														name: "src",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2176,
  														src: "16394:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2225,
  														name: "dest",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2182,
  														src: "16399:4:3",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2226,
  														name: "wad",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2194,
  														src: "16405:3:3",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														baseExpression: {
  															id: 2220,
  															name: "userToToken",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1160,
  															src: "16363:11:3",
  															typeDescriptions: {
  																typeIdentifier: "t_mapping$_t_address_$_t_contract$_Token_$2750_$",
  																typeString: "mapping(address => contract Token)"
  															}
  														},
  														id: 2222,
  														indexExpression: {
  															id: 2221,
  															name: "token",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2188,
  															src: "16375:5:3",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														},
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														nodeType: "IndexAccess",
  														src: "16363:18:3",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Token_$2750",
  															typeString: "contract Token"
  														}
  													},
  													id: 2223,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "hubTransfer",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2732,
  													src: "16363:30:3",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  														typeString: "function (address,address,uint256) external returns (bool)"
  													}
  												},
  												id: 2227,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "16363:46:3",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												}
  											},
  											id: 2228,
  											nodeType: "ExpressionStatement",
  											src: "16363:46:3"
  										}
  									]
  								},
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 2171,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 2168,
  										name: "i",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2165,
  										src: "15824:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										expression: {
  											id: 2169,
  											name: "srcs",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2128,
  											src: "15828:4:3",
  											typeDescriptions: {
  												typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  												typeString: "address[] memory"
  											}
  										},
  										id: 2170,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "length",
  										nodeType: "MemberAccess",
  										src: "15828:11:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "15824:15:3",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2230,
  								initializationExpression: {
  									assignments: [
  										2165
  									],
  									declarations: [
  										{
  											constant: false,
  											id: 2165,
  											mutability: "mutable",
  											name: "i",
  											nodeType: "VariableDeclaration",
  											scope: 2230,
  											src: "15812:6:3",
  											stateVariable: false,
  											storageLocation: "default",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											typeName: {
  												id: 2164,
  												name: "uint",
  												nodeType: "ElementaryTypeName",
  												src: "15812:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											visibility: "internal"
  										}
  									],
  									id: 2167,
  									initialValue: {
  										hexValue: "30",
  										id: 2166,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "15821:1:3",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									nodeType: "VariableDeclarationStatement",
  									src: "15812:10:3"
  								},
  								loopExpression: {
  									expression: {
  										id: 2173,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "UnaryOperation",
  										operator: "++",
  										prefix: false,
  										src: "15841:3:3",
  										subExpression: {
  											id: 2172,
  											name: "i",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2165,
  											src: "15841:1:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 2174,
  									nodeType: "ExpressionStatement",
  									src: "15841:3:3"
  								},
  								nodeType: "ForStatement",
  								src: "15807:613:3"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											expression: {
  												id: 2232,
  												name: "srcs",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2128,
  												src: "16513:4:3",
  												typeDescriptions: {
  													typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  													typeString: "address[] memory"
  												}
  											},
  											id: 2233,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "length",
  											nodeType: "MemberAccess",
  											src: "16513:11:3",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 2231,
  										name: "validateTransferThrough",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2121,
  										src: "16489:23:3",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$returns$__$",
  											typeString: "function (uint256)"
  										}
  									},
  									id: 2234,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "16489:36:3",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2235,
  								nodeType: "ExpressionStatement",
  								src: "16489:36:3"
  							}
  						]
  					},
  					documentation: {
  						id: 2122,
  						nodeType: "StructuredDocumentation",
  						src: "14828:451:3",
  						text: "@notice walks through tokenOwners, srcs, dests, and amounts array and executes transtive transfer\n @dev tokenOwners[0], srcs[0], dests[0], and wads[0] constitute a transaction step\n @param tokenOwners the owner of the tokens being sent in each transaction step\n @param srcs the sender of each transaction step\n @param dests the recipient of each transaction step\n @param wads the amount for each transaction step"
  					},
  					functionSelector: "d62fd9a2",
  					id: 2237,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "transferThrough",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2135,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2125,
  								mutability: "mutable",
  								name: "tokenOwners",
  								nodeType: "VariableDeclaration",
  								scope: 2237,
  								src: "15318:28:3",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  									typeString: "address[]"
  								},
  								typeName: {
  									baseType: {
  										id: 2123,
  										name: "address",
  										nodeType: "ElementaryTypeName",
  										src: "15318:7:3",
  										stateMutability: "nonpayable",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									id: 2124,
  									nodeType: "ArrayTypeName",
  									src: "15318:9:3",
  									typeDescriptions: {
  										typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  										typeString: "address[]"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2128,
  								mutability: "mutable",
  								name: "srcs",
  								nodeType: "VariableDeclaration",
  								scope: 2237,
  								src: "15356:21:3",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  									typeString: "address[]"
  								},
  								typeName: {
  									baseType: {
  										id: 2126,
  										name: "address",
  										nodeType: "ElementaryTypeName",
  										src: "15356:7:3",
  										stateMutability: "nonpayable",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									id: 2127,
  									nodeType: "ArrayTypeName",
  									src: "15356:9:3",
  									typeDescriptions: {
  										typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  										typeString: "address[]"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2131,
  								mutability: "mutable",
  								name: "dests",
  								nodeType: "VariableDeclaration",
  								scope: 2237,
  								src: "15387:22:3",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_array$_t_address_$dyn_memory_ptr",
  									typeString: "address[]"
  								},
  								typeName: {
  									baseType: {
  										id: 2129,
  										name: "address",
  										nodeType: "ElementaryTypeName",
  										src: "15387:7:3",
  										stateMutability: "nonpayable",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									id: 2130,
  									nodeType: "ArrayTypeName",
  									src: "15387:9:3",
  									typeDescriptions: {
  										typeIdentifier: "t_array$_t_address_$dyn_storage_ptr",
  										typeString: "address[]"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2134,
  								mutability: "mutable",
  								name: "wads",
  								nodeType: "VariableDeclaration",
  								scope: 2237,
  								src: "15419:18:3",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_array$_t_uint256_$dyn_memory_ptr",
  									typeString: "uint256[]"
  								},
  								typeName: {
  									baseType: {
  										id: 2132,
  										name: "uint",
  										nodeType: "ElementaryTypeName",
  										src: "15419:4:3",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									id: 2133,
  									nodeType: "ArrayTypeName",
  									src: "15419:6:3",
  									typeDescriptions: {
  										typeIdentifier: "t_array$_t_uint256_$dyn_storage_ptr",
  										typeString: "uint256[]"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "15308:135:3"
  					},
  					returnParameters: {
  						id: 2136,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "15451:0:3"
  					},
  					scope: 2238,
  					src: "15284:1248:3",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				}
  			],
  			scope: 2239,
  			src: "133:16401:3"
  		}
  	],
  	src: "33:16503:3"
  };
  var legacyAST$1 = {
  	attributes: {
  		absolutePath: "project:/contracts/Hub.sol",
  		exportedSymbols: {
  			Hub: [
  				2238
  			]
  		},
  		license: "AGPL"
  	},
  	children: [
  		{
  			attributes: {
  				literals: [
  					"solidity",
  					"^",
  					"0.7",
  					".0"
  				]
  			},
  			id: 1133,
  			name: "PragmaDirective",
  			src: "33:23:3"
  		},
  		{
  			attributes: {
  				SourceUnit: 355,
  				absolutePath: "@openzeppelin/contracts/math/SafeMath.sol",
  				file: "@openzeppelin/contracts/math/SafeMath.sol",
  				scope: 2239,
  				symbolAliases: [
  					null
  				],
  				unitAlias: ""
  			},
  			id: 1134,
  			name: "ImportDirective",
  			src: "58:51:3"
  		},
  		{
  			attributes: {
  				SourceUnit: 2751,
  				absolutePath: "project:/contracts/Token.sol",
  				file: "./Token.sol",
  				scope: 2239,
  				symbolAliases: [
  					null
  				],
  				unitAlias: ""
  			},
  			id: 1135,
  			name: "ImportDirective",
  			src: "110:21:3"
  		},
  		{
  			attributes: {
  				abstract: false,
  				baseContracts: [
  					null
  				],
  				contractDependencies: [
  					2750
  				],
  				contractKind: "contract",
  				fullyImplemented: true,
  				linearizedBaseContracts: [
  					2238
  				],
  				name: "Hub",
  				scope: 2239
  			},
  			children: [
  				{
  					children: [
  						{
  							attributes: {
  								name: "SafeMath",
  								referencedDeclaration: 354,
  								type: "library SafeMath"
  							},
  							id: 1136,
  							name: "UserDefinedTypeName",
  							src: "158:8:3"
  						},
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1137,
  							name: "ElementaryTypeName",
  							src: "171:7:3"
  						}
  					],
  					id: 1138,
  					name: "UsingForDirective",
  					src: "152:27:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "be0522e0",
  						mutability: "immutable",
  						name: "inflation",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1139,
  							name: "ElementaryTypeName",
  							src: "185:7:3"
  						}
  					],
  					id: 1140,
  					name: "VariableDeclaration",
  					src: "185:34:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "1f2dc5ef",
  						mutability: "immutable",
  						name: "divisor",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1141,
  							name: "ElementaryTypeName",
  							src: "310:7:3"
  						}
  					],
  					id: 1142,
  					name: "VariableDeclaration",
  					src: "310:32:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "ef78d4fd",
  						mutability: "immutable",
  						name: "period",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1143,
  							name: "ElementaryTypeName",
  							src: "412:7:3"
  						}
  					],
  					id: 1144,
  					name: "VariableDeclaration",
  					src: "412:31:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "95d89b41",
  						mutability: "mutable",
  						name: "symbol",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "string",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "string",
  								type: "string"
  							},
  							id: 1145,
  							name: "ElementaryTypeName",
  							src: "499:6:3"
  						}
  					],
  					id: 1146,
  					name: "VariableDeclaration",
  					src: "499:20:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "06fdde03",
  						mutability: "mutable",
  						name: "name",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "string",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "string",
  								type: "string"
  							},
  							id: 1147,
  							name: "ElementaryTypeName",
  							src: "525:6:3"
  						}
  					],
  					id: 1148,
  					name: "VariableDeclaration",
  					src: "525:18:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "67cb52d8",
  						mutability: "immutable",
  						name: "signupBonus",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1149,
  							name: "ElementaryTypeName",
  							src: "549:7:3"
  						}
  					],
  					id: 1150,
  					name: "VariableDeclaration",
  					src: "549:36:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "fc22a9f8",
  						mutability: "immutable",
  						name: "initialIssuance",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1151,
  							name: "ElementaryTypeName",
  							src: "639:7:3"
  						}
  					],
  					id: 1152,
  					name: "VariableDeclaration",
  					src: "639:40:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "eae4c19f",
  						mutability: "immutable",
  						name: "deployedAt",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1153,
  							name: "ElementaryTypeName",
  							src: "761:7:3"
  						}
  					],
  					id: 1154,
  					name: "VariableDeclaration",
  					src: "761:35:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "70dea79a",
  						mutability: "immutable",
  						name: "timeout",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 1155,
  							name: "ElementaryTypeName",
  							src: "849:7:3"
  						}
  					],
  					id: 1156,
  					name: "VariableDeclaration",
  					src: "849:32:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "28d249fe",
  						mutability: "mutable",
  						name: "userToToken",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "mapping(address => contract Token)",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								type: "mapping(address => contract Token)"
  							},
  							children: [
  								{
  									attributes: {
  										name: "address",
  										type: "address"
  									},
  									id: 1157,
  									name: "ElementaryTypeName",
  									src: "971:7:3"
  								},
  								{
  									attributes: {
  										name: "Token",
  										referencedDeclaration: 2750,
  										type: "contract Token"
  									},
  									id: 1158,
  									name: "UserDefinedTypeName",
  									src: "982:5:3"
  								}
  							],
  							id: 1159,
  							name: "Mapping",
  							src: "962:26:3"
  						}
  					],
  					id: 1160,
  					name: "VariableDeclaration",
  					src: "962:45:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "a18b506b",
  						mutability: "mutable",
  						name: "tokenToUser",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "mapping(address => address)",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								type: "mapping(address => address)"
  							},
  							children: [
  								{
  									attributes: {
  										name: "address",
  										type: "address"
  									},
  									id: 1161,
  									name: "ElementaryTypeName",
  									src: "1022:7:3"
  								},
  								{
  									attributes: {
  										name: "address",
  										stateMutability: "nonpayable",
  										type: "address"
  									},
  									id: 1162,
  									name: "ElementaryTypeName",
  									src: "1033:7:3"
  								}
  							],
  							id: 1163,
  							name: "Mapping",
  							src: "1013:28:3"
  						}
  					],
  					id: 1164,
  					name: "VariableDeclaration",
  					src: "1013:47:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "5a1f7406",
  						mutability: "mutable",
  						name: "organizations",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "mapping(address => bool)",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								type: "mapping(address => bool)"
  							},
  							children: [
  								{
  									attributes: {
  										name: "address",
  										type: "address"
  									},
  									id: 1165,
  									name: "ElementaryTypeName",
  									src: "1075:7:3"
  								},
  								{
  									attributes: {
  										name: "bool",
  										type: "bool"
  									},
  									id: 1166,
  									name: "ElementaryTypeName",
  									src: "1086:4:3"
  								}
  							],
  							id: 1167,
  							name: "Mapping",
  							src: "1066:25:3"
  						}
  					],
  					id: 1168,
  					name: "VariableDeclaration",
  					src: "1066:46:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "a3eb2b4a",
  						mutability: "mutable",
  						name: "limits",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "mapping(address => mapping(address => uint256))",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								type: "mapping(address => mapping(address => uint256))"
  							},
  							children: [
  								{
  									attributes: {
  										name: "address",
  										type: "address"
  									},
  									id: 1169,
  									name: "ElementaryTypeName",
  									src: "1127:7:3"
  								},
  								{
  									attributes: {
  										type: "mapping(address => uint256)"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												type: "address"
  											},
  											id: 1170,
  											name: "ElementaryTypeName",
  											src: "1147:7:3"
  										},
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1171,
  											name: "ElementaryTypeName",
  											src: "1158:7:3"
  										}
  									],
  									id: 1172,
  									name: "Mapping",
  									src: "1138:28:3"
  								}
  							],
  							id: 1173,
  							name: "Mapping",
  							src: "1118:49:3"
  						}
  					],
  					id: 1174,
  					name: "VariableDeclaration",
  					src: "1118:63:3"
  				},
  				{
  					attributes: {
  						anonymous: false,
  						name: "Signup"
  					},
  					children: [
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										indexed: true,
  										mutability: "mutable",
  										name: "user",
  										scope: 1180,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1175,
  											name: "ElementaryTypeName",
  											src: "1201:7:3"
  										}
  									],
  									id: 1176,
  									name: "VariableDeclaration",
  									src: "1201:20:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										indexed: false,
  										mutability: "mutable",
  										name: "token",
  										scope: 1180,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1177,
  											name: "ElementaryTypeName",
  											src: "1223:7:3"
  										}
  									],
  									id: 1178,
  									name: "VariableDeclaration",
  									src: "1223:13:3"
  								}
  							],
  							id: 1179,
  							name: "ParameterList",
  							src: "1200:37:3"
  						}
  					],
  					id: 1180,
  					name: "EventDefinition",
  					src: "1188:50:3"
  				},
  				{
  					attributes: {
  						anonymous: false,
  						name: "OrganizationSignup"
  					},
  					children: [
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										indexed: true,
  										mutability: "mutable",
  										name: "organization",
  										scope: 1184,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1181,
  											name: "ElementaryTypeName",
  											src: "1268:7:3"
  										}
  									],
  									id: 1182,
  									name: "VariableDeclaration",
  									src: "1268:28:3"
  								}
  							],
  							id: 1183,
  							name: "ParameterList",
  							src: "1267:30:3"
  						}
  					],
  					id: 1184,
  					name: "EventDefinition",
  					src: "1243:55:3"
  				},
  				{
  					attributes: {
  						anonymous: false,
  						name: "Trust"
  					},
  					children: [
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										indexed: true,
  										mutability: "mutable",
  										name: "canSendTo",
  										scope: 1192,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1185,
  											name: "ElementaryTypeName",
  											src: "1315:7:3"
  										}
  									],
  									id: 1186,
  									name: "VariableDeclaration",
  									src: "1315:25:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										indexed: true,
  										mutability: "mutable",
  										name: "user",
  										scope: 1192,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1187,
  											name: "ElementaryTypeName",
  											src: "1342:7:3"
  										}
  									],
  									id: 1188,
  									name: "VariableDeclaration",
  									src: "1342:20:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										indexed: false,
  										mutability: "mutable",
  										name: "limit",
  										scope: 1192,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1189,
  											name: "ElementaryTypeName",
  											src: "1364:7:3"
  										}
  									],
  									id: 1190,
  									name: "VariableDeclaration",
  									src: "1364:13:3"
  								}
  							],
  							id: 1191,
  							name: "ParameterList",
  							src: "1314:64:3"
  						}
  					],
  					id: 1192,
  					name: "EventDefinition",
  					src: "1303:76:3"
  				},
  				{
  					attributes: {
  						anonymous: false,
  						name: "HubTransfer"
  					},
  					children: [
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										indexed: true,
  										mutability: "mutable",
  										name: "from",
  										scope: 1200,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1193,
  											name: "ElementaryTypeName",
  											src: "1402:7:3"
  										}
  									],
  									id: 1194,
  									name: "VariableDeclaration",
  									src: "1402:20:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										indexed: true,
  										mutability: "mutable",
  										name: "to",
  										scope: 1200,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1195,
  											name: "ElementaryTypeName",
  											src: "1424:7:3"
  										}
  									],
  									id: 1196,
  									name: "VariableDeclaration",
  									src: "1424:18:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										indexed: false,
  										mutability: "mutable",
  										name: "amount",
  										scope: 1200,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1197,
  											name: "ElementaryTypeName",
  											src: "1444:7:3"
  										}
  									],
  									id: 1198,
  									name: "VariableDeclaration",
  									src: "1444:14:3"
  								}
  							],
  							id: 1199,
  							name: "ParameterList",
  							src: "1401:58:3"
  						}
  					],
  					id: 1200,
  					name: "EventDefinition",
  					src: "1384:76:3"
  				},
  				{
  					attributes: {
  						canonicalName: "Hub.transferValidator",
  						name: "transferValidator",
  						scope: 2238,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								constant: false,
  								mutability: "mutable",
  								name: "seen",
  								scope: 1207,
  								stateVariable: false,
  								storageLocation: "default",
  								type: "bool",
  								visibility: "internal"
  							},
  							children: [
  								{
  									attributes: {
  										name: "bool",
  										type: "bool"
  									},
  									id: 1201,
  									name: "ElementaryTypeName",
  									src: "1565:4:3"
  								}
  							],
  							id: 1202,
  							name: "VariableDeclaration",
  							src: "1565:9:3"
  						},
  						{
  							attributes: {
  								constant: false,
  								mutability: "mutable",
  								name: "sent",
  								scope: 1207,
  								stateVariable: false,
  								storageLocation: "default",
  								type: "uint256",
  								visibility: "internal"
  							},
  							children: [
  								{
  									attributes: {
  										name: "uint256",
  										type: "uint256"
  									},
  									id: 1203,
  									name: "ElementaryTypeName",
  									src: "1584:7:3"
  								}
  							],
  							id: 1204,
  							name: "VariableDeclaration",
  							src: "1584:12:3"
  						},
  						{
  							attributes: {
  								constant: false,
  								mutability: "mutable",
  								name: "received",
  								scope: 1207,
  								stateVariable: false,
  								storageLocation: "default",
  								type: "uint256",
  								visibility: "internal"
  							},
  							children: [
  								{
  									attributes: {
  										name: "uint256",
  										type: "uint256"
  									},
  									id: 1205,
  									name: "ElementaryTypeName",
  									src: "1606:7:3"
  								}
  							],
  							id: 1206,
  							name: "VariableDeclaration",
  							src: "1606:16:3"
  						}
  					],
  					id: 1207,
  					name: "StructDefinition",
  					src: "1530:99:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "77ed63c2",
  						mutability: "mutable",
  						name: "validation",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "mapping(address => struct Hub.transferValidator)",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								type: "mapping(address => struct Hub.transferValidator)"
  							},
  							children: [
  								{
  									attributes: {
  										name: "address",
  										type: "address"
  									},
  									id: 1208,
  									name: "ElementaryTypeName",
  									src: "1643:7:3"
  								},
  								{
  									attributes: {
  										name: "transferValidator",
  										referencedDeclaration: 1207,
  										type: "struct Hub.transferValidator"
  									},
  									id: 1209,
  									name: "UserDefinedTypeName",
  									src: "1654:17:3"
  								}
  							],
  							id: 1210,
  							name: "Mapping",
  							src: "1634:38:3"
  						}
  					],
  					id: 1211,
  					name: "VariableDeclaration",
  					src: "1634:56:3"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "7f501d04",
  						mutability: "mutable",
  						name: "seen",
  						scope: 2238,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "address[]",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								type: "address[]"
  							},
  							children: [
  								{
  									attributes: {
  										name: "address",
  										stateMutability: "nonpayable",
  										type: "address"
  									},
  									id: 1212,
  									name: "ElementaryTypeName",
  									src: "1696:7:3"
  								}
  							],
  							id: 1213,
  							name: "ArrayTypeName",
  							src: "1696:9:3"
  						}
  					],
  					id: 1214,
  					name: "VariableDeclaration",
  					src: "1696:21:3"
  				},
  				{
  					attributes: {
  						implemented: true,
  						isConstructor: true,
  						kind: "constructor",
  						modifiers: [
  							null
  						],
  						name: "",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_inflation",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1215,
  											name: "ElementaryTypeName",
  											src: "1745:7:3"
  										}
  									],
  									id: 1216,
  									name: "VariableDeclaration",
  									src: "1745:18:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_period",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1217,
  											name: "ElementaryTypeName",
  											src: "1773:7:3"
  										}
  									],
  									id: 1218,
  									name: "VariableDeclaration",
  									src: "1773:15:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_symbol",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "string",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "string",
  												type: "string"
  											},
  											id: 1219,
  											name: "ElementaryTypeName",
  											src: "1798:6:3"
  										}
  									],
  									id: 1220,
  									name: "VariableDeclaration",
  									src: "1798:21:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_name",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "string",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "string",
  												type: "string"
  											},
  											id: 1221,
  											name: "ElementaryTypeName",
  											src: "1829:6:3"
  										}
  									],
  									id: 1222,
  									name: "VariableDeclaration",
  									src: "1829:19:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_signupBonus",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1223,
  											name: "ElementaryTypeName",
  											src: "1858:7:3"
  										}
  									],
  									id: 1224,
  									name: "VariableDeclaration",
  									src: "1858:20:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_initialIssuance",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1225,
  											name: "ElementaryTypeName",
  											src: "1888:7:3"
  										}
  									],
  									id: 1226,
  									name: "VariableDeclaration",
  									src: "1888:24:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_timeout",
  										scope: 1271,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1227,
  											name: "ElementaryTypeName",
  											src: "1922:7:3"
  										}
  									],
  									id: 1228,
  									name: "VariableDeclaration",
  									src: "1922:16:3"
  								}
  							],
  							id: 1229,
  							name: "ParameterList",
  							src: "1735:209:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1230,
  							name: "ParameterList",
  							src: "1945:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1140,
  														type: "uint256",
  														value: "inflation"
  													},
  													id: 1231,
  													name: "Identifier",
  													src: "1955:9:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1216,
  														type: "uint256",
  														value: "_inflation"
  													},
  													id: 1232,
  													name: "Identifier",
  													src: "1967:10:3"
  												}
  											],
  											id: 1233,
  											name: "Assignment",
  											src: "1955:22:3"
  										}
  									],
  									id: 1234,
  									name: "ExpressionStatement",
  									src: "1955:22:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1142,
  														type: "uint256",
  														value: "divisor"
  													},
  													id: 1235,
  													name: "Identifier",
  													src: "1987:7:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1304,
  																type: "function (uint256) pure returns (uint256)",
  																value: "findDivisor"
  															},
  															id: 1236,
  															name: "Identifier",
  															src: "1997:11:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1216,
  																type: "uint256",
  																value: "_inflation"
  															},
  															id: 1237,
  															name: "Identifier",
  															src: "2009:10:3"
  														}
  													],
  													id: 1238,
  													name: "FunctionCall",
  													src: "1997:23:3"
  												}
  											],
  											id: 1239,
  											name: "Assignment",
  											src: "1987:33:3"
  										}
  									],
  									id: 1240,
  									name: "ExpressionStatement",
  									src: "1987:33:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1144,
  														type: "uint256",
  														value: "period"
  													},
  													id: 1241,
  													name: "Identifier",
  													src: "2030:6:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1218,
  														type: "uint256",
  														value: "_period"
  													},
  													id: 1242,
  													name: "Identifier",
  													src: "2039:7:3"
  												}
  											],
  											id: 1243,
  											name: "Assignment",
  											src: "2030:16:3"
  										}
  									],
  									id: 1244,
  									name: "ExpressionStatement",
  									src: "2030:16:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "string storage ref"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1146,
  														type: "string storage ref",
  														value: "symbol"
  													},
  													id: 1245,
  													name: "Identifier",
  													src: "2056:6:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1220,
  														type: "string memory",
  														value: "_symbol"
  													},
  													id: 1246,
  													name: "Identifier",
  													src: "2065:7:3"
  												}
  											],
  											id: 1247,
  											name: "Assignment",
  											src: "2056:16:3"
  										}
  									],
  									id: 1248,
  									name: "ExpressionStatement",
  									src: "2056:16:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "string storage ref"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1148,
  														type: "string storage ref",
  														value: "name"
  													},
  													id: 1249,
  													name: "Identifier",
  													src: "2082:4:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1222,
  														type: "string memory",
  														value: "_name"
  													},
  													id: 1250,
  													name: "Identifier",
  													src: "2089:5:3"
  												}
  											],
  											id: 1251,
  											name: "Assignment",
  											src: "2082:12:3"
  										}
  									],
  									id: 1252,
  									name: "ExpressionStatement",
  									src: "2082:12:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1150,
  														type: "uint256",
  														value: "signupBonus"
  													},
  													id: 1253,
  													name: "Identifier",
  													src: "2104:11:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1224,
  														type: "uint256",
  														value: "_signupBonus"
  													},
  													id: 1254,
  													name: "Identifier",
  													src: "2118:12:3"
  												}
  											],
  											id: 1255,
  											name: "Assignment",
  											src: "2104:26:3"
  										}
  									],
  									id: 1256,
  									name: "ExpressionStatement",
  									src: "2104:26:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1152,
  														type: "uint256",
  														value: "initialIssuance"
  													},
  													id: 1257,
  													name: "Identifier",
  													src: "2140:15:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1226,
  														type: "uint256",
  														value: "_initialIssuance"
  													},
  													id: 1258,
  													name: "Identifier",
  													src: "2158:16:3"
  												}
  											],
  											id: 1259,
  											name: "Assignment",
  											src: "2140:34:3"
  										}
  									],
  									id: 1260,
  									name: "ExpressionStatement",
  									src: "2140:34:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1154,
  														type: "uint256",
  														value: "deployedAt"
  													},
  													id: 1261,
  													name: "Identifier",
  													src: "2184:10:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "timestamp",
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -4,
  																type: "block",
  																value: "block"
  															},
  															id: 1262,
  															name: "Identifier",
  															src: "2197:5:3"
  														}
  													],
  													id: 1263,
  													name: "MemberAccess",
  													src: "2197:15:3"
  												}
  											],
  											id: 1264,
  											name: "Assignment",
  											src: "2184:28:3"
  										}
  									],
  									id: 1265,
  									name: "ExpressionStatement",
  									src: "2184:28:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1156,
  														type: "uint256",
  														value: "timeout"
  													},
  													id: 1266,
  													name: "Identifier",
  													src: "2222:7:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1228,
  														type: "uint256",
  														value: "_timeout"
  													},
  													id: 1267,
  													name: "Identifier",
  													src: "2232:8:3"
  												}
  											],
  											id: 1268,
  											name: "Assignment",
  											src: "2222:18:3"
  										}
  									],
  									id: 1269,
  									name: "ExpressionStatement",
  									src: "2222:18:3"
  								}
  							],
  							id: 1270,
  							name: "Block",
  							src: "1945:302:3"
  						}
  					],
  					id: 1271,
  					name: "FunctionDefinition",
  					src: "1724:523:3"
  				},
  				{
  					attributes: {
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "findDivisor",
  						scope: 2238,
  						stateMutability: "pure",
  						virtual: false,
  						visibility: "internal"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice calculates the correct divisor for the given inflation rate\n @dev the divisor is used to maintain precision when doing math with percentages\n @param _inf the inflation rate\n @return the largest power of ten the inflation rate can be divided by"
  							},
  							id: 1272,
  							name: "StructuredDocumentation",
  							src: "2253:276:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_inf",
  										scope: 1304,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1273,
  											name: "ElementaryTypeName",
  											src: "2555:7:3"
  										}
  									],
  									id: 1274,
  									name: "VariableDeclaration",
  									src: "2555:12:3"
  								}
  							],
  							id: 1275,
  							name: "ParameterList",
  							src: "2554:14:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1304,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1276,
  											name: "ElementaryTypeName",
  											src: "2592:7:3"
  										}
  									],
  									id: 1277,
  									name: "VariableDeclaration",
  									src: "2592:7:3"
  								}
  							],
  							id: 1278,
  							name: "ParameterList",
  							src: "2591:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										assignments: [
  											1280
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "iter",
  												scope: 1303,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1279,
  													name: "ElementaryTypeName",
  													src: "2611:7:3"
  												}
  											],
  											id: 1280,
  											name: "VariableDeclaration",
  											src: "2611:12:3"
  										},
  										{
  											attributes: {
  												hexvalue: "30",
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												token: "number",
  												type: "int_const 0",
  												value: "0"
  											},
  											id: 1281,
  											name: "Literal",
  											src: "2626:1:3"
  										}
  									],
  									id: 1282,
  									name: "VariableDeclarationStatement",
  									src: "2611:16:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: ">",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "div",
  																referencedDeclaration: 259,
  																type: "function (uint256,uint256) pure returns (uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1274,
  																		type: "uint256",
  																		value: "_inf"
  																	},
  																	id: 1283,
  																	name: "Identifier",
  																	src: "2644:4:3"
  																}
  															],
  															id: 1284,
  															name: "MemberAccess",
  															src: "2644:8:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_10_by_1",
  																				typeString: "int_const 10"
  																			},
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1691,
  																		type: "function (uint256,uint256) pure returns (uint256)",
  																		value: "pow"
  																	},
  																	id: 1285,
  																	name: "Identifier",
  																	src: "2653:3:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "3130",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 10",
  																		value: "10"
  																	},
  																	id: 1286,
  																	name: "Literal",
  																	src: "2657:2:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1280,
  																		type: "uint256",
  																		value: "iter"
  																	},
  																	id: 1287,
  																	name: "Identifier",
  																	src: "2661:4:3"
  																}
  															],
  															id: 1288,
  															name: "FunctionCall",
  															src: "2653:13:3"
  														}
  													],
  													id: 1289,
  													name: "FunctionCall",
  													src: "2644:23:3"
  												},
  												{
  													attributes: {
  														hexvalue: "39",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 9",
  														value: "9"
  													},
  													id: 1290,
  													name: "Literal",
  													src: "2670:1:3"
  												}
  											],
  											id: 1291,
  											name: "BinaryOperation",
  											src: "2644:27:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "+=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1280,
  																		type: "uint256",
  																		value: "iter"
  																	},
  																	id: 1292,
  																	name: "Identifier",
  																	src: "2687:4:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "31",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 1",
  																		value: "1"
  																	},
  																	id: 1293,
  																	name: "Literal",
  																	src: "2695:1:3"
  																}
  															],
  															id: 1294,
  															name: "Assignment",
  															src: "2687:9:3"
  														}
  													],
  													id: 1295,
  													name: "ExpressionStatement",
  													src: "2687:9:3"
  												}
  											],
  											id: 1296,
  											name: "Block",
  											src: "2673:34:3"
  										}
  									],
  									id: 1297,
  									name: "WhileStatement",
  									src: "2637:70:3"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 1278
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_10_by_1",
  																typeString: "int_const 10"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1691,
  														type: "function (uint256,uint256) pure returns (uint256)",
  														value: "pow"
  													},
  													id: 1298,
  													name: "Identifier",
  													src: "2723:3:3"
  												},
  												{
  													attributes: {
  														hexvalue: "3130",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 10",
  														value: "10"
  													},
  													id: 1299,
  													name: "Literal",
  													src: "2727:2:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1280,
  														type: "uint256",
  														value: "iter"
  													},
  													id: 1300,
  													name: "Identifier",
  													src: "2731:4:3"
  												}
  											],
  											id: 1301,
  											name: "FunctionCall",
  											src: "2723:13:3"
  										}
  									],
  									id: 1302,
  									name: "Return",
  									src: "2716:20:3"
  								}
  							],
  							id: 1303,
  							name: "Block",
  							src: "2601:142:3"
  						}
  					],
  					id: 1304,
  					name: "FunctionDefinition",
  					src: "2534:209:3"
  				},
  				{
  					attributes: {
  						functionSelector: "a4caeb42",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "periods",
  						scope: 2238,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for finding the amount of inflation periods since this hub was deployed\n @return the amount of periods since hub was deployed"
  							},
  							id: 1305,
  							name: "StructuredDocumentation",
  							src: "2749:160:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1306,
  							name: "ParameterList",
  							src: "2930:2:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1321,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1307,
  											name: "ElementaryTypeName",
  											src: "2954:7:3"
  										}
  									],
  									id: 1308,
  									name: "VariableDeclaration",
  									src: "2954:7:3"
  								}
  							],
  							id: 1309,
  							name: "ParameterList",
  							src: "2953:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 1309
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "div",
  														referencedDeclaration: 259,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isInlineArray: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "sub",
  																				referencedDeclaration: 203,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						member_name: "timestamp",
  																						type: "uint256"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: -4,
  																								type: "block",
  																								value: "block"
  																							},
  																							id: 1310,
  																							name: "Identifier",
  																							src: "2981:5:3"
  																						}
  																					],
  																					id: 1311,
  																					name: "MemberAccess",
  																					src: "2981:15:3"
  																				}
  																			],
  																			id: 1312,
  																			name: "MemberAccess",
  																			src: "2981:19:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1154,
  																				type: "uint256",
  																				value: "deployedAt"
  																			},
  																			id: 1313,
  																			name: "Identifier",
  																			src: "3001:10:3"
  																		}
  																	],
  																	id: 1314,
  																	name: "FunctionCall",
  																	src: "2981:31:3"
  																}
  															],
  															id: 1315,
  															name: "TupleExpression",
  															src: "2980:33:3"
  														}
  													],
  													id: 1316,
  													name: "MemberAccess",
  													src: "2980:37:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1144,
  														type: "uint256",
  														value: "period"
  													},
  													id: 1317,
  													name: "Identifier",
  													src: "3018:6:3"
  												}
  											],
  											id: 1318,
  											name: "FunctionCall",
  											src: "2980:45:3"
  										}
  									],
  									id: 1319,
  									name: "Return",
  									src: "2973:52:3"
  								}
  							],
  							id: 1320,
  							name: "Block",
  							src: "2963:69:3"
  						}
  					],
  					id: 1321,
  					name: "FunctionDefinition",
  					src: "2914:118:3"
  				},
  				{
  					attributes: {
  						functionSelector: "863623bb",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "issuance",
  						scope: 2238,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice calculates the current issuance rate per second\n @dev current issuance is the initial issuance inflated by the amount of inflation periods since the hub was deployed\n @return current issuance rate"
  							},
  							id: 1322,
  							name: "StructuredDocumentation",
  							src: "3038:222:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1323,
  							name: "ParameterList",
  							src: "3282:2:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1334,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1324,
  											name: "ElementaryTypeName",
  											src: "3306:7:3"
  										}
  									],
  									id: 1325,
  									name: "VariableDeclaration",
  									src: "3306:7:3"
  								}
  							],
  							id: 1326,
  							name: "ParameterList",
  							src: "3305:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 1326
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1382,
  														type: "function (uint256,uint256) view returns (uint256)",
  														value: "inflate"
  													},
  													id: 1327,
  													name: "Identifier",
  													src: "3332:7:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1152,
  														type: "uint256",
  														value: "initialIssuance"
  													},
  													id: 1328,
  													name: "Identifier",
  													src: "3340:15:3"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1321,
  																type: "function () view returns (uint256)",
  																value: "periods"
  															},
  															id: 1329,
  															name: "Identifier",
  															src: "3357:7:3"
  														}
  													],
  													id: 1330,
  													name: "FunctionCall",
  													src: "3357:9:3"
  												}
  											],
  											id: 1331,
  											name: "FunctionCall",
  											src: "3332:35:3"
  										}
  									],
  									id: 1332,
  									name: "Return",
  									src: "3325:42:3"
  								}
  							],
  							id: 1333,
  							name: "Block",
  							src: "3315:59:3"
  						}
  					],
  					id: 1334,
  					name: "FunctionDefinition",
  					src: "3265:109:3"
  				},
  				{
  					attributes: {
  						functionSelector: "61c4b421",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "issuanceByStep",
  						scope: 2238,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice finds the inflation rate at a given inflation period\n @param _periods the step to calculate the issuance rate at\n @return inflation rate as of the given period"
  							},
  							id: 1335,
  							name: "StructuredDocumentation",
  							src: "3380:185:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_periods",
  										scope: 1348,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1336,
  											name: "ElementaryTypeName",
  											src: "3594:7:3"
  										}
  									],
  									id: 1337,
  									name: "VariableDeclaration",
  									src: "3594:16:3"
  								}
  							],
  							id: 1338,
  							name: "ParameterList",
  							src: "3593:18:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1348,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1339,
  											name: "ElementaryTypeName",
  											src: "3633:7:3"
  										}
  									],
  									id: 1340,
  									name: "VariableDeclaration",
  									src: "3633:7:3"
  								}
  							],
  							id: 1341,
  							name: "ParameterList",
  							src: "3632:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 1341
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1382,
  														type: "function (uint256,uint256) view returns (uint256)",
  														value: "inflate"
  													},
  													id: 1342,
  													name: "Identifier",
  													src: "3659:7:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1152,
  														type: "uint256",
  														value: "initialIssuance"
  													},
  													id: 1343,
  													name: "Identifier",
  													src: "3667:15:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1337,
  														type: "uint256",
  														value: "_periods"
  													},
  													id: 1344,
  													name: "Identifier",
  													src: "3684:8:3"
  												}
  											],
  											id: 1345,
  											name: "FunctionCall",
  											src: "3659:34:3"
  										}
  									],
  									id: 1346,
  									name: "Return",
  									src: "3652:41:3"
  								}
  							],
  							id: 1347,
  							name: "Block",
  							src: "3642:58:3"
  						}
  					],
  					id: 1348,
  					name: "FunctionDefinition",
  					src: "3570:130:3"
  				},
  				{
  					attributes: {
  						functionSelector: "2a938342",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "inflate",
  						scope: 2238,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice find the current issuance rate for any initial issuance and amount of periods\n @dev this is basically the calculation for compound interest, with some adjustments because of integer math\n @param _initial the starting issuance rate\n @param _periods the step to calculate the issuance rate as of\n @return initial issuance rate as if interest (inflation) has been compounded period times"
  							},
  							id: 1349,
  							name: "StructuredDocumentation",
  							src: "3706:424:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_initial",
  										scope: 1382,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1350,
  											name: "ElementaryTypeName",
  											src: "4152:7:3"
  										}
  									],
  									id: 1351,
  									name: "VariableDeclaration",
  									src: "4152:16:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_periods",
  										scope: 1382,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1352,
  											name: "ElementaryTypeName",
  											src: "4170:7:3"
  										}
  									],
  									id: 1353,
  									name: "VariableDeclaration",
  									src: "4170:16:3"
  								}
  							],
  							id: 1354,
  							name: "ParameterList",
  							src: "4151:36:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1382,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1355,
  											name: "ElementaryTypeName",
  											src: "4209:7:3"
  										}
  									],
  									id: 1356,
  									name: "VariableDeclaration",
  									src: "4209:7:3"
  								}
  							],
  							id: 1357,
  							name: "ParameterList",
  							src: "4208:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										assignments: [
  											1359
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "q",
  												scope: 1381,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1358,
  													name: "ElementaryTypeName",
  													src: "4462:7:3"
  												}
  											],
  											id: 1359,
  											name: "VariableDeclaration",
  											src: "4462:9:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1691,
  														type: "function (uint256,uint256) pure returns (uint256)",
  														value: "pow"
  													},
  													id: 1360,
  													name: "Identifier",
  													src: "4474:3:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1140,
  														type: "uint256",
  														value: "inflation"
  													},
  													id: 1361,
  													name: "Identifier",
  													src: "4478:9:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1353,
  														type: "uint256",
  														value: "_periods"
  													},
  													id: 1362,
  													name: "Identifier",
  													src: "4489:8:3"
  												}
  											],
  											id: 1363,
  											name: "FunctionCall",
  											src: "4474:24:3"
  										}
  									],
  									id: 1364,
  									name: "VariableDeclarationStatement",
  									src: "4462:36:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1366
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "d",
  												scope: 1381,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1365,
  													name: "ElementaryTypeName",
  													src: "4508:7:3"
  												}
  											],
  											id: 1366,
  											name: "VariableDeclaration",
  											src: "4508:9:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1691,
  														type: "function (uint256,uint256) pure returns (uint256)",
  														value: "pow"
  													},
  													id: 1367,
  													name: "Identifier",
  													src: "4520:3:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1142,
  														type: "uint256",
  														value: "divisor"
  													},
  													id: 1368,
  													name: "Identifier",
  													src: "4524:7:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1353,
  														type: "uint256",
  														value: "_periods"
  													},
  													id: 1369,
  													name: "Identifier",
  													src: "4533:8:3"
  												}
  											],
  											id: 1370,
  											name: "FunctionCall",
  											src: "4520:22:3"
  										}
  									],
  									id: 1371,
  									name: "VariableDeclarationStatement",
  									src: "4508:34:3"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 1357
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "div",
  														referencedDeclaration: 259,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isInlineArray: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "mul",
  																				referencedDeclaration: 237,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1351,
  																						type: "uint256",
  																						value: "_initial"
  																					},
  																					id: 1372,
  																					name: "Identifier",
  																					src: "4560:8:3"
  																				}
  																			],
  																			id: 1373,
  																			name: "MemberAccess",
  																			src: "4560:12:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1359,
  																				type: "uint256",
  																				value: "q"
  																			},
  																			id: 1374,
  																			name: "Identifier",
  																			src: "4573:1:3"
  																		}
  																	],
  																	id: 1375,
  																	name: "FunctionCall",
  																	src: "4560:15:3"
  																}
  															],
  															id: 1376,
  															name: "TupleExpression",
  															src: "4559:17:3"
  														}
  													],
  													id: 1377,
  													name: "MemberAccess",
  													src: "4559:21:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1366,
  														type: "uint256",
  														value: "d"
  													},
  													id: 1378,
  													name: "Identifier",
  													src: "4581:1:3"
  												}
  											],
  											id: 1379,
  											name: "FunctionCall",
  											src: "4559:24:3"
  										}
  									],
  									id: 1380,
  									name: "Return",
  									src: "4552:31:3"
  								}
  							],
  							id: 1381,
  							name: "Block",
  							src: "4218:372:3"
  						}
  					],
  					id: 1382,
  					name: "FunctionDefinition",
  					src: "4135:455:3"
  				},
  				{
  					attributes: {
  						functionSelector: "b7bc0f73",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "signup",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice signup to this circles hub - create a circles token and join the trust graph\n @dev signup is permanent, there's no way to unsignup"
  							},
  							id: 1383,
  							name: "StructuredDocumentation",
  							src: "4596:149:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1384,
  							name: "ParameterList",
  							src: "4765:2:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1385,
  							name: "ParameterList",
  							src: "4775:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_1efbb6dec79d778e8f8d82c0704a10c59142e478257a2be868ea7a54f0cd499e",
  																typeString: "literal_string \"You can't sign up twice\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1386,
  													name: "Identifier",
  													src: "4827:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_contract$_Token_$2750",
  																				typeString: "contract Token"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1387,
  																			name: "ElementaryTypeName",
  																			src: "4835:7:3"
  																		}
  																	],
  																	id: 1388,
  																	name: "ElementaryTypeNameExpression",
  																	src: "4835:7:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "contract Token"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1160,
  																				type: "mapping(address => contract Token)",
  																				value: "userToToken"
  																			},
  																			id: 1389,
  																			name: "Identifier",
  																			src: "4843:11:3"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "sender",
  																				type: "address payable"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: -15,
  																						type: "msg",
  																						value: "msg"
  																					},
  																					id: 1390,
  																					name: "Identifier",
  																					src: "4855:3:3"
  																				}
  																			],
  																			id: 1391,
  																			name: "MemberAccess",
  																			src: "4855:10:3"
  																		}
  																	],
  																	id: 1392,
  																	name: "IndexAccess",
  																	src: "4843:23:3"
  																}
  															],
  															id: 1393,
  															name: "FunctionCall",
  															src: "4835:32:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address payable",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1394,
  																			name: "ElementaryTypeName",
  																			src: "4871:7:3"
  																		}
  																	],
  																	id: 1395,
  																	name: "ElementaryTypeNameExpression",
  																	src: "4871:7:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 1396,
  																	name: "Literal",
  																	src: "4879:1:3"
  																}
  															],
  															id: 1397,
  															name: "FunctionCall",
  															src: "4871:10:3"
  														}
  													],
  													id: 1398,
  													name: "BinaryOperation",
  													src: "4835:46:3"
  												},
  												{
  													attributes: {
  														hexvalue: "596f752063616e2774207369676e207570207477696365",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"You can't sign up twice\"",
  														value: "You can't sign up twice"
  													},
  													id: 1399,
  													name: "Literal",
  													src: "4883:25:3"
  												}
  											],
  											id: 1400,
  											name: "FunctionCall",
  											src: "4827:82:3"
  										}
  									],
  									id: 1401,
  									name: "ExpressionStatement",
  									src: "4827:82:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_e66a76efd18f0e15d3291829f7718ae21f2dc384f194b6932c25b14c8f5a8cef",
  																typeString: "literal_string \"Organizations cannot signup as normal users\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1402,
  													name: "Identifier",
  													src: "4971:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1168,
  																		type: "mapping(address => bool)",
  																		value: "organizations"
  																	},
  																	id: 1403,
  																	name: "Identifier",
  																	src: "4979:13:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "sender",
  																		type: "address payable"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: -15,
  																				type: "msg",
  																				value: "msg"
  																			},
  																			id: 1404,
  																			name: "Identifier",
  																			src: "4993:3:3"
  																		}
  																	],
  																	id: 1405,
  																	name: "MemberAccess",
  																	src: "4993:10:3"
  																}
  															],
  															id: 1406,
  															name: "IndexAccess",
  															src: "4979:25:3"
  														},
  														{
  															attributes: {
  																hexvalue: "66616c7365",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "bool",
  																type: "bool",
  																value: "false"
  															},
  															id: 1407,
  															name: "Literal",
  															src: "5008:5:3"
  														}
  													],
  													id: 1408,
  													name: "BinaryOperation",
  													src: "4979:34:3"
  												},
  												{
  													attributes: {
  														hexvalue: "4f7267616e697a6174696f6e732063616e6e6f74207369676e7570206173206e6f726d616c207573657273",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Organizations cannot signup as normal users\"",
  														value: "Organizations cannot signup as normal users"
  													},
  													id: 1409,
  													name: "Literal",
  													src: "5015:45:3"
  												}
  											],
  											id: 1410,
  											name: "FunctionCall",
  											src: "4971:90:3"
  										}
  									],
  									id: 1411,
  									name: "ExpressionStatement",
  									src: "4971:90:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1413
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "token",
  												scope: 1452,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "contract Token",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "Token",
  														referencedDeclaration: 2750,
  														type: "contract Token"
  													},
  													id: 1412,
  													name: "UserDefinedTypeName",
  													src: "5072:5:3"
  												}
  											],
  											id: 1413,
  											name: "VariableDeclaration",
  											src: "5072:11:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "contract Token",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														type: "function (address) returns (contract Token)"
  													},
  													children: [
  														{
  															attributes: {
  																name: "Token",
  																referencedDeclaration: 2750,
  																type: "contract Token"
  															},
  															id: 1414,
  															name: "UserDefinedTypeName",
  															src: "5090:5:3"
  														}
  													],
  													id: 1415,
  													name: "NewExpression",
  													src: "5086:9:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1416,
  															name: "Identifier",
  															src: "5096:3:3"
  														}
  													],
  													id: 1417,
  													name: "MemberAccess",
  													src: "5096:10:3"
  												}
  											],
  											id: 1418,
  											name: "FunctionCall",
  											src: "5086:21:3"
  										}
  									],
  									id: 1419,
  									name: "VariableDeclarationStatement",
  									src: "5072:35:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "contract Token"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: true,
  														type: "contract Token"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1160,
  																type: "mapping(address => contract Token)",
  																value: "userToToken"
  															},
  															id: 1420,
  															name: "Identifier",
  															src: "5117:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sender",
  																type: "address payable"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: -15,
  																		type: "msg",
  																		value: "msg"
  																	},
  																	id: 1421,
  																	name: "Identifier",
  																	src: "5129:3:3"
  																}
  															],
  															id: 1422,
  															name: "MemberAccess",
  															src: "5129:10:3"
  														}
  													],
  													id: 1423,
  													name: "IndexAccess",
  													src: "5117:23:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1413,
  														type: "contract Token",
  														value: "token"
  													},
  													id: 1424,
  													name: "Identifier",
  													src: "5143:5:3"
  												}
  											],
  											id: 1425,
  											name: "Assignment",
  											src: "5117:31:3"
  										}
  									],
  									id: 1426,
  									name: "ExpressionStatement",
  									src: "5117:31:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "address"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: true,
  														type: "address"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1164,
  																type: "mapping(address => address)",
  																value: "tokenToUser"
  															},
  															id: 1427,
  															name: "Identifier",
  															src: "5158:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_contract$_Token_$2750",
  																				typeString: "contract Token"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1428,
  																			name: "ElementaryTypeName",
  																			src: "5170:7:3"
  																		}
  																	],
  																	id: 1429,
  																	name: "ElementaryTypeNameExpression",
  																	src: "5170:7:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1413,
  																		type: "contract Token",
  																		value: "token"
  																	},
  																	id: 1430,
  																	name: "Identifier",
  																	src: "5178:5:3"
  																}
  															],
  															id: 1431,
  															name: "FunctionCall",
  															src: "5170:14:3"
  														}
  													],
  													id: 1432,
  													name: "IndexAccess",
  													src: "5158:27:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1433,
  															name: "Identifier",
  															src: "5188:3:3"
  														}
  													],
  													id: 1434,
  													name: "MemberAccess",
  													src: "5188:10:3"
  												}
  											],
  											id: 1435,
  											name: "Assignment",
  											src: "5158:40:3"
  										}
  									],
  									id: 1436,
  									name: "ExpressionStatement",
  									src: "5158:40:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															},
  															{
  																typeIdentifier: "t_rational_100_by_1",
  																typeString: "int_const 100"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1597,
  														type: "function (address,uint256)",
  														value: "_trust"
  													},
  													id: 1437,
  													name: "Identifier",
  													src: "5346:6:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1438,
  															name: "Identifier",
  															src: "5353:3:3"
  														}
  													],
  													id: 1439,
  													name: "MemberAccess",
  													src: "5353:10:3"
  												},
  												{
  													attributes: {
  														hexvalue: "313030",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 100",
  														value: "100"
  													},
  													id: 1440,
  													name: "Literal",
  													src: "5365:3:3"
  												}
  											],
  											id: 1441,
  											name: "FunctionCall",
  											src: "5346:23:3"
  										}
  									],
  									id: 1442,
  									name: "ExpressionStatement",
  									src: "5346:23:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															},
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1180,
  														type: "function (address,address)",
  														value: "Signup"
  													},
  													id: 1443,
  													name: "Identifier",
  													src: "5385:6:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1444,
  															name: "Identifier",
  															src: "5392:3:3"
  														}
  													],
  													id: 1445,
  													name: "MemberAccess",
  													src: "5392:10:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "address",
  														type_conversion: true
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_contract$_Token_$2750",
  																		typeString: "contract Token"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																type: "type(address)"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "address"
  																	},
  																	id: 1446,
  																	name: "ElementaryTypeName",
  																	src: "5404:7:3"
  																}
  															],
  															id: 1447,
  															name: "ElementaryTypeNameExpression",
  															src: "5404:7:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1413,
  																type: "contract Token",
  																value: "token"
  															},
  															id: 1448,
  															name: "Identifier",
  															src: "5412:5:3"
  														}
  													],
  													id: 1449,
  													name: "FunctionCall",
  													src: "5404:14:3"
  												}
  											],
  											id: 1450,
  											name: "FunctionCall",
  											src: "5385:34:3"
  										}
  									],
  									id: 1451,
  									name: "EmitStatement",
  									src: "5380:39:3"
  								}
  							],
  							id: 1452,
  							name: "Block",
  							src: "4775:651:3"
  						}
  					],
  					id: 1453,
  					name: "FunctionDefinition",
  					src: "4750:676:3"
  				},
  				{
  					attributes: {
  						functionSelector: "3fbd653c",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "organizationSignup",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice register an organization address with the hub and join the trust graph\n @dev signup is permanent for organizations too, there's no way to unsignup"
  							},
  							id: 1454,
  							name: "StructuredDocumentation",
  							src: "5432:165:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1455,
  							name: "ParameterList",
  							src: "5629:2:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1456,
  							name: "ParameterList",
  							src: "5639:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_dcda9714bf80fa26761f02031c7d61716ef2295595bb451377f4e99d1f3f9712",
  																typeString: "literal_string \"Normal users cannot signup as organizations\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1457,
  													name: "Identifier",
  													src: "5714:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_contract$_Token_$2750",
  																				typeString: "contract Token"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1458,
  																			name: "ElementaryTypeName",
  																			src: "5722:7:3"
  																		}
  																	],
  																	id: 1459,
  																	name: "ElementaryTypeNameExpression",
  																	src: "5722:7:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "contract Token"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1160,
  																				type: "mapping(address => contract Token)",
  																				value: "userToToken"
  																			},
  																			id: 1460,
  																			name: "Identifier",
  																			src: "5730:11:3"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "sender",
  																				type: "address payable"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: -15,
  																						type: "msg",
  																						value: "msg"
  																					},
  																					id: 1461,
  																					name: "Identifier",
  																					src: "5742:3:3"
  																				}
  																			],
  																			id: 1462,
  																			name: "MemberAccess",
  																			src: "5742:10:3"
  																		}
  																	],
  																	id: 1463,
  																	name: "IndexAccess",
  																	src: "5730:23:3"
  																}
  															],
  															id: 1464,
  															name: "FunctionCall",
  															src: "5722:32:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address payable",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1465,
  																			name: "ElementaryTypeName",
  																			src: "5758:7:3"
  																		}
  																	],
  																	id: 1466,
  																	name: "ElementaryTypeNameExpression",
  																	src: "5758:7:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 1467,
  																	name: "Literal",
  																	src: "5766:1:3"
  																}
  															],
  															id: 1468,
  															name: "FunctionCall",
  															src: "5758:10:3"
  														}
  													],
  													id: 1469,
  													name: "BinaryOperation",
  													src: "5722:46:3"
  												},
  												{
  													attributes: {
  														hexvalue: "4e6f726d616c2075736572732063616e6e6f74207369676e7570206173206f7267616e697a6174696f6e73",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Normal users cannot signup as organizations\"",
  														value: "Normal users cannot signup as organizations"
  													},
  													id: 1470,
  													name: "Literal",
  													src: "5770:45:3"
  												}
  											],
  											id: 1471,
  											name: "FunctionCall",
  											src: "5714:102:3"
  										}
  									],
  									id: 1472,
  									name: "ExpressionStatement",
  									src: "5714:102:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_3aaf2463823841555c6497222979b880a5da2317c047671fdd5741e2741495c8",
  																typeString: "literal_string \"You can't sign up as an organization twice\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1473,
  													name: "Identifier",
  													src: "5877:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1168,
  																		type: "mapping(address => bool)",
  																		value: "organizations"
  																	},
  																	id: 1474,
  																	name: "Identifier",
  																	src: "5885:13:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "sender",
  																		type: "address payable"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: -15,
  																				type: "msg",
  																				value: "msg"
  																			},
  																			id: 1475,
  																			name: "Identifier",
  																			src: "5899:3:3"
  																		}
  																	],
  																	id: 1476,
  																	name: "MemberAccess",
  																	src: "5899:10:3"
  																}
  															],
  															id: 1477,
  															name: "IndexAccess",
  															src: "5885:25:3"
  														},
  														{
  															attributes: {
  																hexvalue: "66616c7365",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "bool",
  																type: "bool",
  																value: "false"
  															},
  															id: 1478,
  															name: "Literal",
  															src: "5914:5:3"
  														}
  													],
  													id: 1479,
  													name: "BinaryOperation",
  													src: "5885:34:3"
  												},
  												{
  													attributes: {
  														hexvalue: "596f752063616e2774207369676e20757020617320616e206f7267616e697a6174696f6e207477696365",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"You can't sign up as an organization twice\"",
  														value: "You can't sign up as an organization twice"
  													},
  													id: 1480,
  													name: "Literal",
  													src: "5921:44:3"
  												}
  											],
  											id: 1481,
  											name: "FunctionCall",
  											src: "5877:89:3"
  										}
  									],
  									id: 1482,
  									name: "ExpressionStatement",
  									src: "5877:89:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: true,
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1168,
  																type: "mapping(address => bool)",
  																value: "organizations"
  															},
  															id: 1483,
  															name: "Identifier",
  															src: "5977:13:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sender",
  																type: "address payable"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: -15,
  																		type: "msg",
  																		value: "msg"
  																	},
  																	id: 1484,
  																	name: "Identifier",
  																	src: "5991:3:3"
  																}
  															],
  															id: 1485,
  															name: "MemberAccess",
  															src: "5991:10:3"
  														}
  													],
  													id: 1486,
  													name: "IndexAccess",
  													src: "5977:25:3"
  												},
  												{
  													attributes: {
  														hexvalue: "74727565",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "bool",
  														type: "bool",
  														value: "true"
  													},
  													id: 1487,
  													name: "Literal",
  													src: "6005:4:3"
  												}
  											],
  											id: 1488,
  											name: "Assignment",
  											src: "5977:32:3"
  										}
  									],
  									id: 1489,
  									name: "ExpressionStatement",
  									src: "5977:32:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1184,
  														type: "function (address)",
  														value: "OrganizationSignup"
  													},
  													id: 1490,
  													name: "Identifier",
  													src: "6025:18:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1491,
  															name: "Identifier",
  															src: "6044:3:3"
  														}
  													],
  													id: 1492,
  													name: "MemberAccess",
  													src: "6044:10:3"
  												}
  											],
  											id: 1493,
  											name: "FunctionCall",
  											src: "6025:30:3"
  										}
  									],
  									id: 1494,
  									name: "EmitStatement",
  									src: "6020:35:3"
  								}
  							],
  							id: 1495,
  							name: "Block",
  							src: "5639:423:3"
  						}
  					],
  					id: 1496,
  					name: "FunctionDefinition",
  					src: "5602:460:3"
  				},
  				{
  					attributes: {
  						functionSelector: "9951d62f",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "trust",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice trust a user, calling this means you're able to receive tokens from this user transitively\n @dev the trust graph is weighted and directed\n @param user the user to be trusted\n @param limit the amount this user is trusted, as a percentage of 100"
  							},
  							id: 1497,
  							name: "StructuredDocumentation",
  							src: "6068:276:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "user",
  										scope: 1572,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1498,
  											name: "ElementaryTypeName",
  											src: "6364:7:3"
  										}
  									],
  									id: 1499,
  									name: "VariableDeclaration",
  									src: "6364:12:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "limit",
  										scope: 1572,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint",
  												type: "uint256"
  											},
  											id: 1500,
  											name: "ElementaryTypeName",
  											src: "6378:4:3"
  										}
  									],
  									id: 1501,
  									name: "VariableDeclaration",
  									src: "6378:10:3"
  								}
  							],
  							id: 1502,
  							name: "ParameterList",
  							src: "6363:26:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1503,
  							name: "ParameterList",
  							src: "6397:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_3e66ed50af6033d6f4e06cd174b05824d1f63800848df8453bc4f755ffc7e341",
  																typeString: "literal_string \"You can only trust people after you've signed up!\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1504,
  													name: "Identifier",
  													src: "6501:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "||",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																commonType: {
  																	typeIdentifier: "t_address",
  																	typeString: "address"
  																},
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "!=",
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "address",
  																		type_conversion: true
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_contract$_Token_$2750",
  																						typeString: "contract Token"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				type: "type(address)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						name: "address"
  																					},
  																					id: 1505,
  																					name: "ElementaryTypeName",
  																					src: "6509:7:3"
  																				}
  																			],
  																			id: 1506,
  																			name: "ElementaryTypeNameExpression",
  																			src: "6509:7:3"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "contract Token"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1160,
  																						type: "mapping(address => contract Token)",
  																						value: "userToToken"
  																					},
  																					id: 1507,
  																					name: "Identifier",
  																					src: "6517:11:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						member_name: "sender",
  																						type: "address payable"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: -15,
  																								type: "msg",
  																								value: "msg"
  																							},
  																							id: 1508,
  																							name: "Identifier",
  																							src: "6529:3:3"
  																						}
  																					],
  																					id: 1509,
  																					name: "MemberAccess",
  																					src: "6529:10:3"
  																				}
  																			],
  																			id: 1510,
  																			name: "IndexAccess",
  																			src: "6517:23:3"
  																		}
  																	],
  																	id: 1511,
  																	name: "FunctionCall",
  																	src: "6509:32:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "address payable",
  																		type_conversion: true
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_rational_0_by_1",
  																						typeString: "int_const 0"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				type: "type(address)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						name: "address"
  																					},
  																					id: 1512,
  																					name: "ElementaryTypeName",
  																					src: "6545:7:3"
  																				}
  																			],
  																			id: 1513,
  																			name: "ElementaryTypeNameExpression",
  																			src: "6545:7:3"
  																		},
  																		{
  																			attributes: {
  																				hexvalue: "30",
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				token: "number",
  																				type: "int_const 0",
  																				value: "0"
  																			},
  																			id: 1514,
  																			name: "Literal",
  																			src: "6553:1:3"
  																		}
  																	],
  																	id: 1515,
  																	name: "FunctionCall",
  																	src: "6545:10:3"
  																}
  															],
  															id: 1516,
  															name: "BinaryOperation",
  															src: "6509:46:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1168,
  																		type: "mapping(address => bool)",
  																		value: "organizations"
  																	},
  																	id: 1517,
  																	name: "Identifier",
  																	src: "6559:13:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "sender",
  																		type: "address payable"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: -15,
  																				type: "msg",
  																				value: "msg"
  																			},
  																			id: 1518,
  																			name: "Identifier",
  																			src: "6573:3:3"
  																		}
  																	],
  																	id: 1519,
  																	name: "MemberAccess",
  																	src: "6573:10:3"
  																}
  															],
  															id: 1520,
  															name: "IndexAccess",
  															src: "6559:25:3"
  														}
  													],
  													id: 1521,
  													name: "BinaryOperation",
  													src: "6509:75:3"
  												},
  												{
  													attributes: {
  														hexvalue: "596f752063616e206f6e6c792074727573742070656f706c6520616674657220796f75277665207369676e656420757021",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"You can only trust people after you've signed up!\"",
  														value: "You can only trust people after you've signed up!"
  													},
  													id: 1522,
  													name: "Literal",
  													src: "6586:51:3"
  												}
  											],
  											id: 1523,
  											name: "FunctionCall",
  											src: "6501:137:3"
  										}
  									],
  									id: 1524,
  									name: "ExpressionStatement",
  									src: "6501:137:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_32ba97078af3ad838cf1976313c6eb1ef5cc94e93c4abd539534632651d8a311",
  																typeString: "literal_string \"You can't untrust yourself\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1525,
  													name: "Identifier",
  													src: "6700:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "!=",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sender",
  																type: "address payable"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: -15,
  																		type: "msg",
  																		value: "msg"
  																	},
  																	id: 1526,
  																	name: "Identifier",
  																	src: "6708:3:3"
  																}
  															],
  															id: 1527,
  															name: "MemberAccess",
  															src: "6708:10:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1499,
  																type: "address",
  																value: "user"
  															},
  															id: 1528,
  															name: "Identifier",
  															src: "6722:4:3"
  														}
  													],
  													id: 1529,
  													name: "BinaryOperation",
  													src: "6708:18:3"
  												},
  												{
  													attributes: {
  														hexvalue: "596f752063616e277420756e747275737420796f757273656c66",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"You can't untrust yourself\"",
  														value: "You can't untrust yourself"
  													},
  													id: 1530,
  													name: "Literal",
  													src: "6728:28:3"
  												}
  											],
  											id: 1531,
  											name: "FunctionCall",
  											src: "6700:57:3"
  										}
  									],
  									id: 1532,
  									name: "ExpressionStatement",
  									src: "6700:57:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_f5dc7911fb94e33dd24ff5c64bcd96b1c45b9eba60163ee03e1c1e86d67d0a1e",
  																typeString: "literal_string \"You can't trust an organization\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1533,
  													name: "Identifier",
  													src: "6881:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_bool",
  															typeString: "bool"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1168,
  																		type: "mapping(address => bool)",
  																		value: "organizations"
  																	},
  																	id: 1534,
  																	name: "Identifier",
  																	src: "6889:13:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1499,
  																		type: "address",
  																		value: "user"
  																	},
  																	id: 1535,
  																	name: "Identifier",
  																	src: "6903:4:3"
  																}
  															],
  															id: 1536,
  															name: "IndexAccess",
  															src: "6889:19:3"
  														},
  														{
  															attributes: {
  																hexvalue: "66616c7365",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "bool",
  																type: "bool",
  																value: "false"
  															},
  															id: 1537,
  															name: "Literal",
  															src: "6912:5:3"
  														}
  													],
  													id: 1538,
  													name: "BinaryOperation",
  													src: "6889:28:3"
  												},
  												{
  													attributes: {
  														hexvalue: "596f752063616e277420747275737420616e206f7267616e697a6174696f6e",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"You can't trust an organization\"",
  														value: "You can't trust an organization"
  													},
  													id: 1539,
  													name: "Literal",
  													src: "6919:33:3"
  												}
  											],
  											id: 1540,
  											name: "FunctionCall",
  											src: "6881:72:3"
  										}
  									],
  									id: 1541,
  									name: "ExpressionStatement",
  									src: "6881:72:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_cc96caa47b7b76d39ad05960c449d4effd0cf497d3c0424d5256b2e65346fce7",
  																typeString: "literal_string \"Limit must be a percentage out of 100\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 1542,
  													name: "Identifier",
  													src: "6992:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "<=",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1501,
  																type: "uint256",
  																value: "limit"
  															},
  															id: 1543,
  															name: "Identifier",
  															src: "7000:5:3"
  														},
  														{
  															attributes: {
  																hexvalue: "313030",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 100",
  																value: "100"
  															},
  															id: 1544,
  															name: "Literal",
  															src: "7009:3:3"
  														}
  													],
  													id: 1545,
  													name: "BinaryOperation",
  													src: "7000:12:3"
  												},
  												{
  													attributes: {
  														hexvalue: "4c696d6974206d75737420626520612070657263656e74616765206f7574206f6620313030",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Limit must be a percentage out of 100\"",
  														value: "Limit must be a percentage out of 100"
  													},
  													id: 1546,
  													name: "Literal",
  													src: "7014:39:3"
  												}
  											],
  											id: 1547,
  											name: "FunctionCall",
  											src: "6992:62:3"
  										}
  									],
  									id: 1548,
  									name: "ExpressionStatement",
  									src: "6992:62:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1168,
  														type: "mapping(address => bool)",
  														value: "organizations"
  													},
  													id: 1549,
  													name: "Identifier",
  													src: "7181:13:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1550,
  															name: "Identifier",
  															src: "7195:3:3"
  														}
  													],
  													id: 1551,
  													name: "MemberAccess",
  													src: "7195:10:3"
  												}
  											],
  											id: 1552,
  											name: "IndexAccess",
  											src: "7181:25:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "tuple()",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_bool",
  																				typeString: "bool"
  																			},
  																			{
  																				typeIdentifier: "t_stringliteral_a7724e49aea8f173a138a507f23a17836a1dde8b7ada5042d739df2910c1b762",
  																				typeString: "literal_string \"Trust is binary for organizations\""
  																			}
  																		],
  																		overloadedDeclarations: [
  																			-18,
  																			-18
  																		],
  																		referencedDeclaration: -18,
  																		type: "function (bool,string memory) pure",
  																		value: "require"
  																	},
  																	id: 1553,
  																	name: "Identifier",
  																	src: "7222:7:3"
  																},
  																{
  																	attributes: {
  																		commonType: {
  																			typeIdentifier: "t_bool",
  																			typeString: "bool"
  																		},
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		operator: "||",
  																		type: "bool"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				commonType: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				},
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "==",
  																				type: "bool"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1501,
  																						type: "uint256",
  																						value: "limit"
  																					},
  																					id: 1554,
  																					name: "Identifier",
  																					src: "7230:5:3"
  																				},
  																				{
  																					attributes: {
  																						hexvalue: "30",
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						lValueRequested: false,
  																						token: "number",
  																						type: "int_const 0",
  																						value: "0"
  																					},
  																					id: 1555,
  																					name: "Literal",
  																					src: "7239:1:3"
  																				}
  																			],
  																			id: 1556,
  																			name: "BinaryOperation",
  																			src: "7230:10:3"
  																		},
  																		{
  																			attributes: {
  																				commonType: {
  																					typeIdentifier: "t_uint256",
  																					typeString: "uint256"
  																				},
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "==",
  																				type: "bool"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1501,
  																						type: "uint256",
  																						value: "limit"
  																					},
  																					id: 1557,
  																					name: "Identifier",
  																					src: "7244:5:3"
  																				},
  																				{
  																					attributes: {
  																						hexvalue: "313030",
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						lValueRequested: false,
  																						token: "number",
  																						type: "int_const 100",
  																						value: "100"
  																					},
  																					id: 1558,
  																					name: "Literal",
  																					src: "7253:3:3"
  																				}
  																			],
  																			id: 1559,
  																			name: "BinaryOperation",
  																			src: "7244:12:3"
  																		}
  																	],
  																	id: 1560,
  																	name: "BinaryOperation",
  																	src: "7230:26:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "54727573742069732062696e61727920666f72206f7267616e697a6174696f6e73",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "string",
  																		type: "literal_string \"Trust is binary for organizations\"",
  																		value: "Trust is binary for organizations"
  																	},
  																	id: 1561,
  																	name: "Literal",
  																	src: "7258:35:3"
  																}
  															],
  															id: 1562,
  															name: "FunctionCall",
  															src: "7222:72:3"
  														}
  													],
  													id: 1563,
  													name: "ExpressionStatement",
  													src: "7222:72:3"
  												}
  											],
  											id: 1564,
  											name: "Block",
  											src: "7208:97:3"
  										}
  									],
  									id: 1565,
  									name: "IfStatement",
  									src: "7177:128:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1597,
  														type: "function (address,uint256)",
  														value: "_trust"
  													},
  													id: 1566,
  													name: "Identifier",
  													src: "7314:6:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1499,
  														type: "address",
  														value: "user"
  													},
  													id: 1567,
  													name: "Identifier",
  													src: "7321:4:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1501,
  														type: "uint256",
  														value: "limit"
  													},
  													id: 1568,
  													name: "Identifier",
  													src: "7327:5:3"
  												}
  											],
  											id: 1569,
  											name: "FunctionCall",
  											src: "7314:19:3"
  										}
  									],
  									id: 1570,
  									name: "ExpressionStatement",
  									src: "7314:19:3"
  								}
  							],
  							id: 1571,
  							name: "Block",
  							src: "6397:943:3"
  						}
  					],
  					id: 1572,
  					name: "FunctionDefinition",
  					src: "6349:991:3"
  				},
  				{
  					attributes: {
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "_trust",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "internal"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@dev used internally in both the trust function and signup\n @param user the user to be trusted\n @param limit the amount this user is trusted, as a percentage of 100"
  							},
  							id: 1573,
  							name: "StructuredDocumentation",
  							src: "7346:182:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "user",
  										scope: 1597,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1574,
  											name: "ElementaryTypeName",
  											src: "7549:7:3"
  										}
  									],
  									id: 1575,
  									name: "VariableDeclaration",
  									src: "7549:12:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "limit",
  										scope: 1597,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint",
  												type: "uint256"
  											},
  											id: 1576,
  											name: "ElementaryTypeName",
  											src: "7563:4:3"
  										}
  									],
  									id: 1577,
  									name: "VariableDeclaration",
  									src: "7563:10:3"
  								}
  							],
  							id: 1578,
  							name: "ParameterList",
  							src: "7548:26:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1579,
  							name: "ParameterList",
  							src: "7584:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: true,
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "mapping(address => uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1174,
  																		type: "mapping(address => mapping(address => uint256))",
  																		value: "limits"
  																	},
  																	id: 1580,
  																	name: "Identifier",
  																	src: "7594:6:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "sender",
  																		type: "address payable"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: -15,
  																				type: "msg",
  																				value: "msg"
  																			},
  																			id: 1581,
  																			name: "Identifier",
  																			src: "7601:3:3"
  																		}
  																	],
  																	id: 1582,
  																	name: "MemberAccess",
  																	src: "7601:10:3"
  																}
  															],
  															id: 1584,
  															name: "IndexAccess",
  															src: "7594:18:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1575,
  																type: "address",
  																value: "user"
  															},
  															id: 1583,
  															name: "Identifier",
  															src: "7613:4:3"
  														}
  													],
  													id: 1585,
  													name: "IndexAccess",
  													src: "7594:24:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1577,
  														type: "uint256",
  														value: "limit"
  													},
  													id: 1586,
  													name: "Identifier",
  													src: "7621:5:3"
  												}
  											],
  											id: 1587,
  											name: "Assignment",
  											src: "7594:32:3"
  										}
  									],
  									id: 1588,
  									name: "ExpressionStatement",
  									src: "7594:32:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address_payable",
  																typeString: "address payable"
  															},
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1192,
  														type: "function (address,address,uint256)",
  														value: "Trust"
  													},
  													id: 1589,
  													name: "Identifier",
  													src: "7641:5:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 1590,
  															name: "Identifier",
  															src: "7647:3:3"
  														}
  													],
  													id: 1591,
  													name: "MemberAccess",
  													src: "7647:10:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1575,
  														type: "address",
  														value: "user"
  													},
  													id: 1592,
  													name: "Identifier",
  													src: "7659:4:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1577,
  														type: "uint256",
  														value: "limit"
  													},
  													id: 1593,
  													name: "Identifier",
  													src: "7665:5:3"
  												}
  											],
  											id: 1594,
  											name: "FunctionCall",
  											src: "7641:30:3"
  										}
  									],
  									id: 1595,
  									name: "EmitStatement",
  									src: "7636:35:3"
  								}
  							],
  							id: 1596,
  							name: "Block",
  							src: "7584:94:3"
  						}
  					],
  					id: 1597,
  					name: "FunctionDefinition",
  					src: "7533:145:3"
  				},
  				{
  					attributes: {
  						functionSelector: "2e4c697f",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "pow",
  						scope: 2238,
  						stateMutability: "pure",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@dev this is an implementation of exponentiation by squares\n @param base the base to be used in the calculation\n @param exponent the exponent to be used in the calculation\n @return the result of the calculation"
  							},
  							id: 1598,
  							name: "StructuredDocumentation",
  							src: "7684:235:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "base",
  										scope: 1691,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1599,
  											name: "ElementaryTypeName",
  											src: "7937:7:3"
  										}
  									],
  									id: 1600,
  									name: "VariableDeclaration",
  									src: "7937:12:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "exponent",
  										scope: 1691,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1601,
  											name: "ElementaryTypeName",
  											src: "7951:7:3"
  										}
  									],
  									id: 1602,
  									name: "VariableDeclaration",
  									src: "7951:16:3"
  								}
  							],
  							id: 1603,
  							name: "ParameterList",
  							src: "7936:32:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1691,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1604,
  											name: "ElementaryTypeName",
  											src: "7990:7:3"
  										}
  									],
  									id: 1605,
  									name: "VariableDeclaration",
  									src: "7990:7:3"
  								}
  							],
  							id: 1606,
  							name: "ParameterList",
  							src: "7989:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "==",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1600,
  														type: "uint256",
  														value: "base"
  													},
  													id: 1607,
  													name: "Identifier",
  													src: "8013:4:3"
  												},
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 1608,
  													name: "Literal",
  													src: "8021:1:3"
  												}
  											],
  											id: 1609,
  											name: "BinaryOperation",
  											src: "8013:9:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1606
  													},
  													children: [
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 1610,
  															name: "Literal",
  															src: "8045:1:3"
  														}
  													],
  													id: 1611,
  													name: "Return",
  													src: "8038:8:3"
  												}
  											],
  											id: 1612,
  											name: "Block",
  											src: "8024:33:3"
  										}
  									],
  									id: 1613,
  									name: "IfStatement",
  									src: "8009:48:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "==",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1602,
  														type: "uint256",
  														value: "exponent"
  													},
  													id: 1614,
  													name: "Identifier",
  													src: "8070:8:3"
  												},
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 1615,
  													name: "Literal",
  													src: "8082:1:3"
  												}
  											],
  											id: 1616,
  											name: "BinaryOperation",
  											src: "8070:13:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1606
  													},
  													children: [
  														{
  															attributes: {
  																hexvalue: "31",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 1",
  																value: "1"
  															},
  															id: 1617,
  															name: "Literal",
  															src: "8106:1:3"
  														}
  													],
  													id: 1618,
  													name: "Return",
  													src: "8099:8:3"
  												}
  											],
  											id: 1619,
  											name: "Block",
  											src: "8085:33:3"
  										}
  									],
  									id: 1620,
  									name: "IfStatement",
  									src: "8066:52:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "==",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1602,
  														type: "uint256",
  														value: "exponent"
  													},
  													id: 1621,
  													name: "Identifier",
  													src: "8131:8:3"
  												},
  												{
  													attributes: {
  														hexvalue: "31",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 1",
  														value: "1"
  													},
  													id: 1622,
  													name: "Literal",
  													src: "8143:1:3"
  												}
  											],
  											id: 1623,
  											name: "BinaryOperation",
  											src: "8131:13:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1606
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1600,
  																type: "uint256",
  																value: "base"
  															},
  															id: 1624,
  															name: "Identifier",
  															src: "8167:4:3"
  														}
  													],
  													id: 1625,
  													name: "Return",
  													src: "8160:11:3"
  												}
  											],
  											id: 1626,
  											name: "Block",
  											src: "8146:36:3"
  										}
  									],
  									id: 1627,
  									name: "IfStatement",
  									src: "8127:55:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1629
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "y",
  												scope: 1690,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1628,
  													name: "ElementaryTypeName",
  													src: "8191:7:3"
  												}
  											],
  											id: 1629,
  											name: "VariableDeclaration",
  											src: "8191:9:3"
  										},
  										{
  											attributes: {
  												hexvalue: "31",
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												token: "number",
  												type: "int_const 1",
  												value: "1"
  											},
  											id: 1630,
  											name: "Literal",
  											src: "8203:1:3"
  										}
  									],
  									id: 1631,
  									name: "VariableDeclarationStatement",
  									src: "8191:13:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: ">",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1602,
  														type: "uint256",
  														value: "exponent"
  													},
  													id: 1632,
  													name: "Identifier",
  													src: "8220:8:3"
  												},
  												{
  													attributes: {
  														hexvalue: "31",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 1",
  														value: "1"
  													},
  													id: 1633,
  													name: "Literal",
  													src: "8231:1:3"
  												}
  											],
  											id: 1634,
  											name: "BinaryOperation",
  											src: "8220:12:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "==",
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_rational_2_by_1",
  																						typeString: "int_const 2"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "mod",
  																				referencedDeclaration: 281,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1602,
  																						type: "uint256",
  																						value: "exponent"
  																					},
  																					id: 1635,
  																					name: "Identifier",
  																					src: "8251:8:3"
  																				}
  																			],
  																			id: 1636,
  																			name: "MemberAccess",
  																			src: "8251:12:3"
  																		},
  																		{
  																			attributes: {
  																				hexvalue: "32",
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				token: "number",
  																				type: "int_const 2",
  																				value: "2"
  																			},
  																			id: 1637,
  																			name: "Literal",
  																			src: "8264:1:3"
  																		}
  																	],
  																	id: 1638,
  																	name: "FunctionCall",
  																	src: "8251:15:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 1639,
  																	name: "Literal",
  																	src: "8270:1:3"
  																}
  															],
  															id: 1640,
  															name: "BinaryOperation",
  															src: "8251:20:3"
  														},
  														{
  															children: [
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1600,
  																						type: "uint256",
  																						value: "base"
  																					},
  																					id: 1641,
  																					name: "Identifier",
  																					src: "8291:4:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_uint256",
  																										typeString: "uint256"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "mul",
  																								referencedDeclaration: 237,
  																								type: "function (uint256,uint256) pure returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1600,
  																										type: "uint256",
  																										value: "base"
  																									},
  																									id: 1642,
  																									name: "Identifier",
  																									src: "8298:4:3"
  																								}
  																							],
  																							id: 1643,
  																							name: "MemberAccess",
  																							src: "8298:8:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1600,
  																								type: "uint256",
  																								value: "base"
  																							},
  																							id: 1644,
  																							name: "Identifier",
  																							src: "8307:4:3"
  																						}
  																					],
  																					id: 1645,
  																					name: "FunctionCall",
  																					src: "8298:14:3"
  																				}
  																			],
  																			id: 1646,
  																			name: "Assignment",
  																			src: "8291:21:3"
  																		}
  																	],
  																	id: 1647,
  																	name: "ExpressionStatement",
  																	src: "8291:21:3"
  																},
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1602,
  																						type: "uint256",
  																						value: "exponent"
  																					},
  																					id: 1648,
  																					name: "Identifier",
  																					src: "8330:8:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_rational_2_by_1",
  																										typeString: "int_const 2"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "div",
  																								referencedDeclaration: 259,
  																								type: "function (uint256,uint256) pure returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1602,
  																										type: "uint256",
  																										value: "exponent"
  																									},
  																									id: 1649,
  																									name: "Identifier",
  																									src: "8341:8:3"
  																								}
  																							],
  																							id: 1650,
  																							name: "MemberAccess",
  																							src: "8341:12:3"
  																						},
  																						{
  																							attributes: {
  																								hexvalue: "32",
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								lValueRequested: false,
  																								token: "number",
  																								type: "int_const 2",
  																								value: "2"
  																							},
  																							id: 1651,
  																							name: "Literal",
  																							src: "8354:1:3"
  																						}
  																					],
  																					id: 1652,
  																					name: "FunctionCall",
  																					src: "8341:15:3"
  																				}
  																			],
  																			id: 1653,
  																			name: "Assignment",
  																			src: "8330:26:3"
  																		}
  																	],
  																	id: 1654,
  																	name: "ExpressionStatement",
  																	src: "8330:26:3"
  																}
  															],
  															id: 1655,
  															name: "Block",
  															src: "8273:98:3"
  														},
  														{
  															children: [
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1629,
  																						type: "uint256",
  																						value: "y"
  																					},
  																					id: 1656,
  																					name: "Identifier",
  																					src: "8395:1:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_uint256",
  																										typeString: "uint256"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "mul",
  																								referencedDeclaration: 237,
  																								type: "function (uint256,uint256) pure returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1600,
  																										type: "uint256",
  																										value: "base"
  																									},
  																									id: 1657,
  																									name: "Identifier",
  																									src: "8399:4:3"
  																								}
  																							],
  																							id: 1658,
  																							name: "MemberAccess",
  																							src: "8399:8:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1629,
  																								type: "uint256",
  																								value: "y"
  																							},
  																							id: 1659,
  																							name: "Identifier",
  																							src: "8408:1:3"
  																						}
  																					],
  																					id: 1660,
  																					name: "FunctionCall",
  																					src: "8399:11:3"
  																				}
  																			],
  																			id: 1661,
  																			name: "Assignment",
  																			src: "8395:15:3"
  																		}
  																	],
  																	id: 1662,
  																	name: "ExpressionStatement",
  																	src: "8395:15:3"
  																},
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1600,
  																						type: "uint256",
  																						value: "base"
  																					},
  																					id: 1663,
  																					name: "Identifier",
  																					src: "8428:4:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_uint256",
  																										typeString: "uint256"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "mul",
  																								referencedDeclaration: 237,
  																								type: "function (uint256,uint256) pure returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1600,
  																										type: "uint256",
  																										value: "base"
  																									},
  																									id: 1664,
  																									name: "Identifier",
  																									src: "8435:4:3"
  																								}
  																							],
  																							id: 1665,
  																							name: "MemberAccess",
  																							src: "8435:8:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1600,
  																								type: "uint256",
  																								value: "base"
  																							},
  																							id: 1666,
  																							name: "Identifier",
  																							src: "8444:4:3"
  																						}
  																					],
  																					id: 1667,
  																					name: "FunctionCall",
  																					src: "8435:14:3"
  																				}
  																			],
  																			id: 1668,
  																			name: "Assignment",
  																			src: "8428:21:3"
  																		}
  																	],
  																	id: 1669,
  																	name: "ExpressionStatement",
  																	src: "8428:21:3"
  																},
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1602,
  																						type: "uint256",
  																						value: "exponent"
  																					},
  																					id: 1670,
  																					name: "Identifier",
  																					src: "8467:8:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_rational_2_by_1",
  																										typeString: "int_const 2"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "div",
  																								referencedDeclaration: 259,
  																								type: "function (uint256,uint256) pure returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										isConstant: false,
  																										isInlineArray: false,
  																										isLValue: false,
  																										isPure: false,
  																										lValueRequested: false,
  																										type: "uint256"
  																									},
  																									children: [
  																										{
  																											attributes: {
  																												isConstant: false,
  																												isLValue: false,
  																												isPure: false,
  																												isStructConstructorCall: false,
  																												lValueRequested: false,
  																												names: [
  																													null
  																												],
  																												tryCall: false,
  																												type: "uint256",
  																												type_conversion: false
  																											},
  																											children: [
  																												{
  																													attributes: {
  																														argumentTypes: [
  																															{
  																																typeIdentifier: "t_rational_1_by_1",
  																																typeString: "int_const 1"
  																															}
  																														],
  																														isConstant: false,
  																														isLValue: false,
  																														isPure: false,
  																														lValueRequested: false,
  																														member_name: "sub",
  																														referencedDeclaration: 203,
  																														type: "function (uint256,uint256) pure returns (uint256)"
  																													},
  																													children: [
  																														{
  																															attributes: {
  																																overloadedDeclarations: [
  																																	null
  																																],
  																																referencedDeclaration: 1602,
  																																type: "uint256",
  																																value: "exponent"
  																															},
  																															id: 1671,
  																															name: "Identifier",
  																															src: "8479:8:3"
  																														}
  																													],
  																													id: 1672,
  																													name: "MemberAccess",
  																													src: "8479:12:3"
  																												},
  																												{
  																													attributes: {
  																														hexvalue: "31",
  																														isConstant: false,
  																														isLValue: false,
  																														isPure: true,
  																														lValueRequested: false,
  																														token: "number",
  																														type: "int_const 1",
  																														value: "1"
  																													},
  																													id: 1673,
  																													name: "Literal",
  																													src: "8492:1:3"
  																												}
  																											],
  																											id: 1674,
  																											name: "FunctionCall",
  																											src: "8479:15:3"
  																										}
  																									],
  																									id: 1675,
  																									name: "TupleExpression",
  																									src: "8478:17:3"
  																								}
  																							],
  																							id: 1676,
  																							name: "MemberAccess",
  																							src: "8478:21:3"
  																						},
  																						{
  																							attributes: {
  																								hexvalue: "32",
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								lValueRequested: false,
  																								token: "number",
  																								type: "int_const 2",
  																								value: "2"
  																							},
  																							id: 1677,
  																							name: "Literal",
  																							src: "8500:1:3"
  																						}
  																					],
  																					id: 1678,
  																					name: "FunctionCall",
  																					src: "8478:24:3"
  																				}
  																			],
  																			id: 1679,
  																			name: "Assignment",
  																			src: "8467:35:3"
  																		}
  																	],
  																	id: 1680,
  																	name: "ExpressionStatement",
  																	src: "8467:35:3"
  																}
  															],
  															id: 1681,
  															name: "Block",
  															src: "8377:140:3"
  														}
  													],
  													id: 1682,
  													name: "IfStatement",
  													src: "8248:269:3"
  												}
  											],
  											id: 1683,
  											name: "Block",
  											src: "8234:293:3"
  										}
  									],
  									id: 1684,
  									name: "WhileStatement",
  									src: "8214:313:3"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 1606
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "mul",
  														referencedDeclaration: 237,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1600,
  																type: "uint256",
  																value: "base"
  															},
  															id: 1685,
  															name: "Identifier",
  															src: "8543:4:3"
  														}
  													],
  													id: 1686,
  													name: "MemberAccess",
  													src: "8543:8:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1629,
  														type: "uint256",
  														value: "y"
  													},
  													id: 1687,
  													name: "Identifier",
  													src: "8552:1:3"
  												}
  											],
  											id: 1688,
  											name: "FunctionCall",
  											src: "8543:11:3"
  										}
  									],
  									id: 1689,
  									name: "Return",
  									src: "8536:18:3"
  								}
  							],
  							id: 1690,
  							name: "Block",
  							src: "7999:562:3"
  						}
  					],
  					id: 1691,
  					name: "FunctionDefinition",
  					src: "7924:637:3"
  				},
  				{
  					attributes: {
  						functionSelector: "8a0ef184",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "checkSendLimit",
  						scope: 2238,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice finds the maximum amount of a specific token that can be sent between two users\n @dev the goal of this function is to always return a sensible number, it's used to validate transfer throughs, and also heavily in the graph/pathfinding services\n @param tokenOwner the safe/owner that the token was minted to\n @param src the sender of the tokens\n @param dest the recipient of the tokens\n @return the amount of tokenowner's token src can send to dest"
  							},
  							id: 1692,
  							name: "StructuredDocumentation",
  							src: "8567:493:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "tokenOwner",
  										scope: 1831,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1693,
  											name: "ElementaryTypeName",
  											src: "9089:7:3"
  										}
  									],
  									id: 1694,
  									name: "VariableDeclaration",
  									src: "9089:18:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "src",
  										scope: 1831,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1695,
  											name: "ElementaryTypeName",
  											src: "9109:7:3"
  										}
  									],
  									id: 1696,
  									name: "VariableDeclaration",
  									src: "9109:11:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "dest",
  										scope: 1831,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1697,
  											name: "ElementaryTypeName",
  											src: "9122:7:3"
  										}
  									],
  									id: 1698,
  									name: "VariableDeclaration",
  									src: "9122:12:3"
  								}
  							],
  							id: 1699,
  							name: "ParameterList",
  							src: "9088:47:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 1831,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1700,
  											name: "ElementaryTypeName",
  											src: "9157:7:3"
  										}
  									],
  									id: 1701,
  									name: "VariableDeclaration",
  									src: "9157:7:3"
  								}
  							],
  							id: 1702,
  							name: "ParameterList",
  							src: "9156:9:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "==",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "mapping(address => uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1174,
  																		type: "mapping(address => mapping(address => uint256))",
  																		value: "limits"
  																	},
  																	id: 1703,
  																	name: "Identifier",
  																	src: "9210:6:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1698,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 1704,
  																	name: "Identifier",
  																	src: "9217:4:3"
  																}
  															],
  															id: 1705,
  															name: "IndexAccess",
  															src: "9210:12:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1694,
  																type: "address",
  																value: "tokenOwner"
  															},
  															id: 1706,
  															name: "Identifier",
  															src: "9223:10:3"
  														}
  													],
  													id: 1707,
  													name: "IndexAccess",
  													src: "9210:24:3"
  												},
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 1708,
  													name: "Literal",
  													src: "9238:1:3"
  												}
  											],
  											id: 1709,
  											name: "BinaryOperation",
  											src: "9210:29:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1702
  													},
  													children: [
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 1710,
  															name: "Literal",
  															src: "9262:1:3"
  														}
  													],
  													id: 1711,
  													name: "Return",
  													src: "9255:8:3"
  												}
  											],
  											id: 1712,
  											name: "Block",
  											src: "9241:33:3"
  										}
  									],
  									id: 1713,
  									name: "IfStatement",
  									src: "9206:68:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "&&",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_contract$_Token_$2750",
  																				typeString: "contract Token"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1714,
  																			name: "ElementaryTypeName",
  																			src: "9350:7:3"
  																		}
  																	],
  																	id: 1715,
  																	name: "ElementaryTypeNameExpression",
  																	src: "9350:7:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "contract Token"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1160,
  																				type: "mapping(address => contract Token)",
  																				value: "userToToken"
  																			},
  																			id: 1716,
  																			name: "Identifier",
  																			src: "9358:11:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1698,
  																				type: "address",
  																				value: "dest"
  																			},
  																			id: 1717,
  																			name: "Identifier",
  																			src: "9370:4:3"
  																		}
  																	],
  																	id: 1718,
  																	name: "IndexAccess",
  																	src: "9358:17:3"
  																}
  															],
  															id: 1719,
  															name: "FunctionCall",
  															src: "9350:26:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address payable",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 1720,
  																			name: "ElementaryTypeName",
  																			src: "9380:7:3"
  																		}
  																	],
  																	id: 1721,
  																	name: "ElementaryTypeNameExpression",
  																	src: "9380:7:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 1722,
  																	name: "Literal",
  																	src: "9388:1:3"
  																}
  															],
  															id: 1723,
  															name: "FunctionCall",
  															src: "9380:10:3"
  														}
  													],
  													id: 1724,
  													name: "BinaryOperation",
  													src: "9350:40:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "!",
  														prefix: true,
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1168,
  																		type: "mapping(address => bool)",
  																		value: "organizations"
  																	},
  																	id: 1725,
  																	name: "Identifier",
  																	src: "9395:13:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1698,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 1726,
  																	name: "Identifier",
  																	src: "9409:4:3"
  																}
  															],
  															id: 1727,
  															name: "IndexAccess",
  															src: "9395:19:3"
  														}
  													],
  													id: 1728,
  													name: "UnaryOperation",
  													src: "9394:20:3"
  												}
  											],
  											id: 1729,
  											name: "BinaryOperation",
  											src: "9350:64:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1702
  													},
  													children: [
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 1730,
  															name: "Literal",
  															src: "9438:1:3"
  														}
  													],
  													id: 1731,
  													name: "Return",
  													src: "9431:8:3"
  												}
  											],
  											id: 1732,
  											name: "Block",
  											src: "9417:33:3"
  										}
  									],
  									id: 1733,
  									name: "IfStatement",
  									src: "9346:104:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "==",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "address",
  														type_conversion: true
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_contract$_Token_$2750",
  																		typeString: "contract Token"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																type: "type(address)"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "address"
  																	},
  																	id: 1734,
  																	name: "ElementaryTypeName",
  																	src: "9528:7:3"
  																}
  															],
  															id: 1735,
  															name: "ElementaryTypeNameExpression",
  															src: "9528:7:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "contract Token"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1160,
  																		type: "mapping(address => contract Token)",
  																		value: "userToToken"
  																	},
  																	id: 1736,
  																	name: "Identifier",
  																	src: "9536:11:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1694,
  																		type: "address",
  																		value: "tokenOwner"
  																	},
  																	id: 1737,
  																	name: "Identifier",
  																	src: "9548:10:3"
  																}
  															],
  															id: 1738,
  															name: "IndexAccess",
  															src: "9536:23:3"
  														}
  													],
  													id: 1739,
  													name: "FunctionCall",
  													src: "9528:32:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "address payable",
  														type_conversion: true
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_rational_0_by_1",
  																		typeString: "int_const 0"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																type: "type(address)"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "address"
  																	},
  																	id: 1740,
  																	name: "ElementaryTypeName",
  																	src: "9564:7:3"
  																}
  															],
  															id: 1741,
  															name: "ElementaryTypeNameExpression",
  															src: "9564:7:3"
  														},
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 1742,
  															name: "Literal",
  															src: "9572:1:3"
  														}
  													],
  													id: 1743,
  													name: "FunctionCall",
  													src: "9564:10:3"
  												}
  											],
  											id: 1744,
  											name: "BinaryOperation",
  											src: "9528:46:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1702
  													},
  													children: [
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 1745,
  															name: "Literal",
  															src: "9598:1:3"
  														}
  													],
  													id: 1746,
  													name: "Return",
  													src: "9591:8:3"
  												}
  											],
  											id: 1747,
  											name: "Block",
  											src: "9576:34:3"
  										}
  									],
  									id: 1748,
  									name: "IfStatement",
  									src: "9524:86:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1750
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "srcBalance",
  												scope: 1830,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1749,
  													name: "ElementaryTypeName",
  													src: "9620:7:3"
  												}
  											],
  											id: 1750,
  											name: "VariableDeclaration",
  											src: "9620:18:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "balanceOf",
  														referencedDeclaration: 735,
  														type: "function (address) view external returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "contract Token"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1160,
  																		type: "mapping(address => contract Token)",
  																		value: "userToToken"
  																	},
  																	id: 1751,
  																	name: "Identifier",
  																	src: "9641:11:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1694,
  																		type: "address",
  																		value: "tokenOwner"
  																	},
  																	id: 1752,
  																	name: "Identifier",
  																	src: "9653:10:3"
  																}
  															],
  															id: 1753,
  															name: "IndexAccess",
  															src: "9641:23:3"
  														}
  													],
  													id: 1754,
  													name: "MemberAccess",
  													src: "9641:33:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1696,
  														type: "address",
  														value: "src"
  													},
  													id: 1755,
  													name: "Identifier",
  													src: "9675:3:3"
  												}
  											],
  											id: 1756,
  											name: "FunctionCall",
  											src: "9641:38:3"
  										}
  									],
  									id: 1757,
  									name: "VariableDeclarationStatement",
  									src: "9620:59:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "||",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1694,
  																type: "address",
  																value: "tokenOwner"
  															},
  															id: 1758,
  															name: "Identifier",
  															src: "9877:10:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1698,
  																type: "address",
  																value: "dest"
  															},
  															id: 1759,
  															name: "Identifier",
  															src: "9891:4:3"
  														}
  													],
  													id: 1760,
  													name: "BinaryOperation",
  													src: "9877:18:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1168,
  																type: "mapping(address => bool)",
  																value: "organizations"
  															},
  															id: 1761,
  															name: "Identifier",
  															src: "9899:13:3"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1698,
  																type: "address",
  																value: "dest"
  															},
  															id: 1762,
  															name: "Identifier",
  															src: "9913:4:3"
  														}
  													],
  													id: 1763,
  													name: "IndexAccess",
  													src: "9899:19:3"
  												}
  											],
  											id: 1764,
  											name: "BinaryOperation",
  											src: "9877:41:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														functionReturnParameters: 1702
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1750,
  																type: "uint256",
  																value: "srcBalance"
  															},
  															id: 1765,
  															name: "Identifier",
  															src: "9941:10:3"
  														}
  													],
  													id: 1766,
  													name: "Return",
  													src: "9934:17:3"
  												}
  											],
  											id: 1767,
  											name: "Block",
  											src: "9920:42:3"
  										}
  									],
  									id: 1768,
  									name: "IfStatement",
  									src: "9873:89:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1770
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "destBalance",
  												scope: 1830,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1769,
  													name: "ElementaryTypeName",
  													src: "10047:7:3"
  												}
  											],
  											id: 1770,
  											name: "VariableDeclaration",
  											src: "10047:19:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "balanceOf",
  														referencedDeclaration: 735,
  														type: "function (address) view external returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "contract Token"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1160,
  																		type: "mapping(address => contract Token)",
  																		value: "userToToken"
  																	},
  																	id: 1771,
  																	name: "Identifier",
  																	src: "10069:11:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1694,
  																		type: "address",
  																		value: "tokenOwner"
  																	},
  																	id: 1772,
  																	name: "Identifier",
  																	src: "10081:10:3"
  																}
  															],
  															id: 1773,
  															name: "IndexAccess",
  															src: "10069:23:3"
  														}
  													],
  													id: 1774,
  													name: "MemberAccess",
  													src: "10069:33:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1698,
  														type: "address",
  														value: "dest"
  													},
  													id: 1775,
  													name: "Identifier",
  													src: "10103:4:3"
  												}
  											],
  											id: 1776,
  											name: "FunctionCall",
  											src: "10069:39:3"
  										}
  									],
  									id: 1777,
  									name: "VariableDeclarationStatement",
  									src: "10047:61:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1779
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "oneHundred",
  												scope: 1830,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1778,
  													name: "ElementaryTypeName",
  													src: "10119:7:3"
  												}
  											],
  											id: 1779,
  											name: "VariableDeclaration",
  											src: "10119:18:3"
  										},
  										{
  											attributes: {
  												hexvalue: "313030",
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												token: "number",
  												type: "int_const 100",
  												value: "100"
  											},
  											id: 1780,
  											name: "Literal",
  											src: "10140:3:3"
  										}
  									],
  									id: 1781,
  									name: "VariableDeclarationStatement",
  									src: "10119:24:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1783
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "max",
  												scope: 1830,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1782,
  													name: "ElementaryTypeName",
  													src: "10249:7:3"
  												}
  											],
  											id: 1783,
  											name: "VariableDeclaration",
  											src: "10249:11:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "div",
  														referencedDeclaration: 259,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isInlineArray: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "mul",
  																				referencedDeclaration: 237,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_address",
  																										typeString: "address"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "balanceOf",
  																								referencedDeclaration: 735,
  																								type: "function (address) view external returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										isConstant: false,
  																										isLValue: true,
  																										isPure: false,
  																										lValueRequested: false,
  																										type: "contract Token"
  																									},
  																									children: [
  																										{
  																											attributes: {
  																												overloadedDeclarations: [
  																													null
  																												],
  																												referencedDeclaration: 1160,
  																												type: "mapping(address => contract Token)",
  																												value: "userToToken"
  																											},
  																											id: 1784,
  																											name: "Identifier",
  																											src: "10264:11:3"
  																										},
  																										{
  																											attributes: {
  																												overloadedDeclarations: [
  																													null
  																												],
  																												referencedDeclaration: 1698,
  																												type: "address",
  																												value: "dest"
  																											},
  																											id: 1785,
  																											name: "Identifier",
  																											src: "10276:4:3"
  																										}
  																									],
  																									id: 1786,
  																									name: "IndexAccess",
  																									src: "10264:17:3"
  																								}
  																							],
  																							id: 1787,
  																							name: "MemberAccess",
  																							src: "10264:27:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1698,
  																								type: "address",
  																								value: "dest"
  																							},
  																							id: 1788,
  																							name: "Identifier",
  																							src: "10292:4:3"
  																						}
  																					],
  																					id: 1789,
  																					name: "FunctionCall",
  																					src: "10264:33:3"
  																				}
  																			],
  																			id: 1790,
  																			name: "MemberAccess",
  																			src: "10264:37:3"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: true,
  																						isPure: false,
  																						lValueRequested: false,
  																						type: "mapping(address => uint256)"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1174,
  																								type: "mapping(address => mapping(address => uint256))",
  																								value: "limits"
  																							},
  																							id: 1791,
  																							name: "Identifier",
  																							src: "10302:6:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1698,
  																								type: "address",
  																								value: "dest"
  																							},
  																							id: 1792,
  																							name: "Identifier",
  																							src: "10309:4:3"
  																						}
  																					],
  																					id: 1793,
  																					name: "IndexAccess",
  																					src: "10302:12:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1694,
  																						type: "address",
  																						value: "tokenOwner"
  																					},
  																					id: 1794,
  																					name: "Identifier",
  																					src: "10315:10:3"
  																				}
  																			],
  																			id: 1795,
  																			name: "IndexAccess",
  																			src: "10302:24:3"
  																		}
  																	],
  																	id: 1796,
  																	name: "FunctionCall",
  																	src: "10264:63:3"
  																}
  															],
  															id: 1797,
  															name: "TupleExpression",
  															src: "10263:65:3"
  														}
  													],
  													id: 1798,
  													name: "MemberAccess",
  													src: "10263:69:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1779,
  														type: "uint256",
  														value: "oneHundred"
  													},
  													id: 1799,
  													name: "Identifier",
  													src: "10333:10:3"
  												}
  											],
  											id: 1800,
  											name: "FunctionCall",
  											src: "10263:81:3"
  										}
  									],
  									id: 1801,
  									name: "VariableDeclarationStatement",
  									src: "10249:95:3"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "<",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1783,
  														type: "uint256",
  														value: "max"
  													},
  													id: 1802,
  													name: "Identifier",
  													src: "10466:3:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1770,
  														type: "uint256",
  														value: "destBalance"
  													},
  													id: 1803,
  													name: "Identifier",
  													src: "10472:11:3"
  												}
  											],
  											id: 1804,
  											name: "BinaryOperation",
  											src: "10466:17:3"
  										},
  										{
  											attributes: {
  												functionReturnParameters: 1702
  											},
  											children: [
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 1805,
  													name: "Literal",
  													src: "10492:1:3"
  												}
  											],
  											id: 1806,
  											name: "Return",
  											src: "10485:8:3"
  										}
  									],
  									id: 1807,
  									name: "IfStatement",
  									src: "10462:31:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1809
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "destBalanceScaled",
  												scope: 1830,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 1808,
  													name: "ElementaryTypeName",
  													src: "10504:7:3"
  												}
  											],
  											id: 1809,
  											name: "VariableDeclaration",
  											src: "10504:25:3"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "div",
  														referencedDeclaration: 259,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "mul",
  																		referencedDeclaration: 237,
  																		type: "function (uint256,uint256) pure returns (uint256)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1770,
  																				type: "uint256",
  																				value: "destBalance"
  																			},
  																			id: 1810,
  																			name: "Identifier",
  																			src: "10532:11:3"
  																		}
  																	],
  																	id: 1811,
  																	name: "MemberAccess",
  																	src: "10532:15:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "sub",
  																				referencedDeclaration: 203,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1779,
  																						type: "uint256",
  																						value: "oneHundred"
  																					},
  																					id: 1812,
  																					name: "Identifier",
  																					src: "10548:10:3"
  																				}
  																			],
  																			id: 1813,
  																			name: "MemberAccess",
  																			src: "10548:14:3"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "uint256"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: true,
  																						isPure: false,
  																						lValueRequested: false,
  																						type: "mapping(address => uint256)"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1174,
  																								type: "mapping(address => mapping(address => uint256))",
  																								value: "limits"
  																							},
  																							id: 1814,
  																							name: "Identifier",
  																							src: "10563:6:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1698,
  																								type: "address",
  																								value: "dest"
  																							},
  																							id: 1815,
  																							name: "Identifier",
  																							src: "10570:4:3"
  																						}
  																					],
  																					id: 1816,
  																					name: "IndexAccess",
  																					src: "10563:12:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1694,
  																						type: "address",
  																						value: "tokenOwner"
  																					},
  																					id: 1817,
  																					name: "Identifier",
  																					src: "10576:10:3"
  																				}
  																			],
  																			id: 1818,
  																			name: "IndexAccess",
  																			src: "10563:24:3"
  																		}
  																	],
  																	id: 1819,
  																	name: "FunctionCall",
  																	src: "10548:40:3"
  																}
  															],
  															id: 1820,
  															name: "FunctionCall",
  															src: "10532:57:3"
  														}
  													],
  													id: 1821,
  													name: "MemberAccess",
  													src: "10532:61:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1779,
  														type: "uint256",
  														value: "oneHundred"
  													},
  													id: 1822,
  													name: "Identifier",
  													src: "10594:10:3"
  												}
  											],
  											id: 1823,
  											name: "FunctionCall",
  											src: "10532:73:3"
  										}
  									],
  									id: 1824,
  									name: "VariableDeclarationStatement",
  									src: "10504:101:3"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 1702
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sub",
  														referencedDeclaration: 203,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1783,
  																type: "uint256",
  																value: "max"
  															},
  															id: 1825,
  															name: "Identifier",
  															src: "10723:3:3"
  														}
  													],
  													id: 1826,
  													name: "MemberAccess",
  													src: "10723:7:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1809,
  														type: "uint256",
  														value: "destBalanceScaled"
  													},
  													id: 1827,
  													name: "Identifier",
  													src: "10731:17:3"
  												}
  											],
  											id: 1828,
  											name: "FunctionCall",
  											src: "10723:26:3"
  										}
  									],
  									id: 1829,
  									name: "Return",
  									src: "10716:33:3"
  								}
  							],
  							id: 1830,
  							name: "Block",
  							src: "9166:1590:3"
  						}
  					],
  					id: 1831,
  					name: "FunctionDefinition",
  					src: "9065:1691:3"
  				},
  				{
  					attributes: {
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "buildValidationData",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "internal"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@dev builds the validation data structures, called for each transaction step of a transtive transactions\n @param src the sender of a single transaction step\n @param dest the recipient of a single transaction step\n @param wad the amount being passed along a single transaction step"
  							},
  							id: 1832,
  							name: "StructuredDocumentation",
  							src: "10762:305:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "src",
  										scope: 1926,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1833,
  											name: "ElementaryTypeName",
  											src: "11101:7:3"
  										}
  									],
  									id: 1834,
  									name: "VariableDeclaration",
  									src: "11101:11:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "dest",
  										scope: 1926,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 1835,
  											name: "ElementaryTypeName",
  											src: "11114:7:3"
  										}
  									],
  									id: 1836,
  									name: "VariableDeclaration",
  									src: "11114:12:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "wad",
  										scope: 1926,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint",
  												type: "uint256"
  											},
  											id: 1837,
  											name: "ElementaryTypeName",
  											src: "11128:4:3"
  										}
  									],
  									id: 1838,
  									name: "VariableDeclaration",
  									src: "11128:8:3"
  								}
  							],
  							id: 1839,
  							name: "ParameterList",
  							src: "11100:37:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1840,
  							name: "ParameterList",
  							src: "11147:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "!=",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "seen",
  														referencedDeclaration: 1202,
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "struct Hub.transferValidator storage ref"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1211,
  																		type: "mapping(address => struct Hub.transferValidator storage ref)",
  																		value: "validation"
  																	},
  																	id: 1841,
  																	name: "Identifier",
  																	src: "11445:10:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1834,
  																		type: "address",
  																		value: "src"
  																	},
  																	id: 1842,
  																	name: "Identifier",
  																	src: "11456:3:3"
  																}
  															],
  															id: 1843,
  															name: "IndexAccess",
  															src: "11445:15:3"
  														}
  													],
  													id: 1844,
  													name: "MemberAccess",
  													src: "11445:20:3"
  												},
  												{
  													attributes: {
  														hexvalue: "66616c7365",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "bool",
  														type: "bool",
  														value: "false"
  													},
  													id: 1845,
  													name: "Literal",
  													src: "11469:5:3"
  												}
  											],
  											id: 1846,
  											name: "BinaryOperation",
  											src: "11445:29:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		member_name: "sent",
  																		referencedDeclaration: 1204,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "struct Hub.transferValidator storage ref"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1211,
  																						type: "mapping(address => struct Hub.transferValidator storage ref)",
  																						value: "validation"
  																					},
  																					id: 1847,
  																					name: "Identifier",
  																					src: "11565:10:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1834,
  																						type: "address",
  																						value: "src"
  																					},
  																					id: 1848,
  																					name: "Identifier",
  																					src: "11576:3:3"
  																				}
  																			],
  																			id: 1849,
  																			name: "IndexAccess",
  																			src: "11565:15:3"
  																		}
  																	],
  																	id: 1850,
  																	name: "MemberAccess",
  																	src: "11565:20:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "add",
  																				referencedDeclaration: 181,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: true,
  																						isPure: false,
  																						lValueRequested: false,
  																						member_name: "sent",
  																						referencedDeclaration: 1204,
  																						type: "uint256"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								isConstant: false,
  																								isLValue: true,
  																								isPure: false,
  																								lValueRequested: false,
  																								type: "struct Hub.transferValidator storage ref"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1211,
  																										type: "mapping(address => struct Hub.transferValidator storage ref)",
  																										value: "validation"
  																									},
  																									id: 1851,
  																									name: "Identifier",
  																									src: "11588:10:3"
  																								},
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1834,
  																										type: "address",
  																										value: "src"
  																									},
  																									id: 1852,
  																									name: "Identifier",
  																									src: "11599:3:3"
  																								}
  																							],
  																							id: 1853,
  																							name: "IndexAccess",
  																							src: "11588:15:3"
  																						}
  																					],
  																					id: 1854,
  																					name: "MemberAccess",
  																					src: "11588:20:3"
  																				}
  																			],
  																			id: 1855,
  																			name: "MemberAccess",
  																			src: "11588:24:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1838,
  																				type: "uint256",
  																				value: "wad"
  																			},
  																			id: 1856,
  																			name: "Identifier",
  																			src: "11613:3:3"
  																		}
  																	],
  																	id: 1857,
  																	name: "FunctionCall",
  																	src: "11588:29:3"
  																}
  															],
  															id: 1858,
  															name: "Assignment",
  															src: "11565:52:3"
  														}
  													],
  													id: 1859,
  													name: "ExpressionStatement",
  													src: "11565:52:3"
  												}
  											],
  											id: 1860,
  											name: "Block",
  											src: "11476:152:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		member_name: "seen",
  																		referencedDeclaration: 1202,
  																		type: "bool"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "struct Hub.transferValidator storage ref"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1211,
  																						type: "mapping(address => struct Hub.transferValidator storage ref)",
  																						value: "validation"
  																					},
  																					id: 1861,
  																					name: "Identifier",
  																					src: "11713:10:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1834,
  																						type: "address",
  																						value: "src"
  																					},
  																					id: 1862,
  																					name: "Identifier",
  																					src: "11724:3:3"
  																				}
  																			],
  																			id: 1863,
  																			name: "IndexAccess",
  																			src: "11713:15:3"
  																		}
  																	],
  																	id: 1864,
  																	name: "MemberAccess",
  																	src: "11713:20:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "74727565",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "bool",
  																		type: "bool",
  																		value: "true"
  																	},
  																	id: 1865,
  																	name: "Literal",
  																	src: "11736:4:3"
  																}
  															],
  															id: 1866,
  															name: "Assignment",
  															src: "11713:27:3"
  														}
  													],
  													id: 1867,
  													name: "ExpressionStatement",
  													src: "11713:27:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		member_name: "sent",
  																		referencedDeclaration: 1204,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "struct Hub.transferValidator storage ref"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1211,
  																						type: "mapping(address => struct Hub.transferValidator storage ref)",
  																						value: "validation"
  																					},
  																					id: 1868,
  																					name: "Identifier",
  																					src: "11754:10:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1834,
  																						type: "address",
  																						value: "src"
  																					},
  																					id: 1869,
  																					name: "Identifier",
  																					src: "11765:3:3"
  																				}
  																			],
  																			id: 1870,
  																			name: "IndexAccess",
  																			src: "11754:15:3"
  																		}
  																	],
  																	id: 1871,
  																	name: "MemberAccess",
  																	src: "11754:20:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1838,
  																		type: "uint256",
  																		value: "wad"
  																	},
  																	id: 1872,
  																	name: "Identifier",
  																	src: "11777:3:3"
  																}
  															],
  															id: 1873,
  															name: "Assignment",
  															src: "11754:26:3"
  														}
  													],
  													id: 1874,
  													name: "ExpressionStatement",
  													src: "11754:26:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "tuple()",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "push",
  																		type: "function (address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1214,
  																				type: "address[] storage ref",
  																				value: "seen"
  																			},
  																			id: 1875,
  																			name: "Identifier",
  																			src: "11794:4:3"
  																		}
  																	],
  																	id: 1877,
  																	name: "MemberAccess",
  																	src: "11794:9:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1834,
  																		type: "address",
  																		value: "src"
  																	},
  																	id: 1878,
  																	name: "Identifier",
  																	src: "11804:3:3"
  																}
  															],
  															id: 1879,
  															name: "FunctionCall",
  															src: "11794:14:3"
  														}
  													],
  													id: 1880,
  													name: "ExpressionStatement",
  													src: "11794:14:3"
  												}
  											],
  											id: 1881,
  											name: "Block",
  											src: "11634:185:3"
  										}
  									],
  									id: 1882,
  									name: "IfStatement",
  									src: "11441:378:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_bool",
  													typeString: "bool"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "!=",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "seen",
  														referencedDeclaration: 1202,
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "struct Hub.transferValidator storage ref"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1211,
  																		type: "mapping(address => struct Hub.transferValidator storage ref)",
  																		value: "validation"
  																	},
  																	id: 1883,
  																	name: "Identifier",
  																	src: "11832:10:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1836,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 1884,
  																	name: "Identifier",
  																	src: "11843:4:3"
  																}
  															],
  															id: 1885,
  															name: "IndexAccess",
  															src: "11832:16:3"
  														}
  													],
  													id: 1886,
  													name: "MemberAccess",
  													src: "11832:21:3"
  												},
  												{
  													attributes: {
  														hexvalue: "66616c7365",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "bool",
  														type: "bool",
  														value: "false"
  													},
  													id: 1887,
  													name: "Literal",
  													src: "11857:5:3"
  												}
  											],
  											id: 1888,
  											name: "BinaryOperation",
  											src: "11832:30:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		member_name: "received",
  																		referencedDeclaration: 1206,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "struct Hub.transferValidator storage ref"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1211,
  																						type: "mapping(address => struct Hub.transferValidator storage ref)",
  																						value: "validation"
  																					},
  																					id: 1889,
  																					name: "Identifier",
  																					src: "11953:10:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1836,
  																						type: "address",
  																						value: "dest"
  																					},
  																					id: 1890,
  																					name: "Identifier",
  																					src: "11964:4:3"
  																				}
  																			],
  																			id: 1891,
  																			name: "IndexAccess",
  																			src: "11953:16:3"
  																		}
  																	],
  																	id: 1892,
  																	name: "MemberAccess",
  																	src: "11953:25:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "add",
  																				referencedDeclaration: 181,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: true,
  																						isPure: false,
  																						lValueRequested: false,
  																						member_name: "received",
  																						referencedDeclaration: 1206,
  																						type: "uint256"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								isConstant: false,
  																								isLValue: true,
  																								isPure: false,
  																								lValueRequested: false,
  																								type: "struct Hub.transferValidator storage ref"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1211,
  																										type: "mapping(address => struct Hub.transferValidator storage ref)",
  																										value: "validation"
  																									},
  																									id: 1893,
  																									name: "Identifier",
  																									src: "11981:10:3"
  																								},
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1836,
  																										type: "address",
  																										value: "dest"
  																									},
  																									id: 1894,
  																									name: "Identifier",
  																									src: "11992:4:3"
  																								}
  																							],
  																							id: 1895,
  																							name: "IndexAccess",
  																							src: "11981:16:3"
  																						}
  																					],
  																					id: 1896,
  																					name: "MemberAccess",
  																					src: "11981:25:3"
  																				}
  																			],
  																			id: 1897,
  																			name: "MemberAccess",
  																			src: "11981:29:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1838,
  																				type: "uint256",
  																				value: "wad"
  																			},
  																			id: 1898,
  																			name: "Identifier",
  																			src: "12011:3:3"
  																		}
  																	],
  																	id: 1899,
  																	name: "FunctionCall",
  																	src: "11981:34:3"
  																}
  															],
  															id: 1900,
  															name: "Assignment",
  															src: "11953:62:3"
  														}
  													],
  													id: 1901,
  													name: "ExpressionStatement",
  													src: "11953:62:3"
  												}
  											],
  											id: 1902,
  											name: "Block",
  											src: "11864:162:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		member_name: "seen",
  																		referencedDeclaration: 1202,
  																		type: "bool"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "struct Hub.transferValidator storage ref"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1211,
  																						type: "mapping(address => struct Hub.transferValidator storage ref)",
  																						value: "validation"
  																					},
  																					id: 1903,
  																					name: "Identifier",
  																					src: "12111:10:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1836,
  																						type: "address",
  																						value: "dest"
  																					},
  																					id: 1904,
  																					name: "Identifier",
  																					src: "12122:4:3"
  																				}
  																			],
  																			id: 1905,
  																			name: "IndexAccess",
  																			src: "12111:16:3"
  																		}
  																	],
  																	id: 1906,
  																	name: "MemberAccess",
  																	src: "12111:21:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "74727565",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "bool",
  																		type: "bool",
  																		value: "true"
  																	},
  																	id: 1907,
  																	name: "Literal",
  																	src: "12135:4:3"
  																}
  															],
  															id: 1908,
  															name: "Assignment",
  															src: "12111:28:3"
  														}
  													],
  													id: 1909,
  													name: "ExpressionStatement",
  													src: "12111:28:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		member_name: "received",
  																		referencedDeclaration: 1206,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "struct Hub.transferValidator storage ref"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1211,
  																						type: "mapping(address => struct Hub.transferValidator storage ref)",
  																						value: "validation"
  																					},
  																					id: 1910,
  																					name: "Identifier",
  																					src: "12153:10:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1836,
  																						type: "address",
  																						value: "dest"
  																					},
  																					id: 1911,
  																					name: "Identifier",
  																					src: "12164:4:3"
  																				}
  																			],
  																			id: 1912,
  																			name: "IndexAccess",
  																			src: "12153:16:3"
  																		}
  																	],
  																	id: 1913,
  																	name: "MemberAccess",
  																	src: "12153:25:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1838,
  																		type: "uint256",
  																		value: "wad"
  																	},
  																	id: 1914,
  																	name: "Identifier",
  																	src: "12181:3:3"
  																}
  															],
  															id: 1915,
  															name: "Assignment",
  															src: "12153:31:3"
  														}
  													],
  													id: 1916,
  													name: "ExpressionStatement",
  													src: "12153:31:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "tuple()",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "push",
  																		type: "function (address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1214,
  																				type: "address[] storage ref",
  																				value: "seen"
  																			},
  																			id: 1917,
  																			name: "Identifier",
  																			src: "12199:4:3"
  																		}
  																	],
  																	id: 1919,
  																	name: "MemberAccess",
  																	src: "12199:9:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1836,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 1920,
  																	name: "Identifier",
  																	src: "12209:4:3"
  																}
  															],
  															id: 1921,
  															name: "FunctionCall",
  															src: "12199:15:3"
  														}
  													],
  													id: 1922,
  													name: "ExpressionStatement",
  													src: "12199:15:3"
  												}
  											],
  											id: 1923,
  											name: "Block",
  											src: "12032:196:3"
  										}
  									],
  									id: 1924,
  									name: "IfStatement",
  									src: "11828:400:3"
  								}
  							],
  							id: 1925,
  							name: "Block",
  							src: "11147:1087:3"
  						}
  					],
  					id: 1926,
  					name: "FunctionDefinition",
  					src: "11072:1162:3"
  				},
  				{
  					attributes: {
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "validateTransferThrough",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "internal"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@dev performs the validation for an attempted transitive transfer\n @param steps the number of steps in the transitive transaction"
  							},
  							id: 1927,
  							name: "StructuredDocumentation",
  							src: "12240:140:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "steps",
  										scope: 2121,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 1928,
  											name: "ElementaryTypeName",
  											src: "12418:7:3"
  										}
  									],
  									id: 1929,
  									name: "VariableDeclaration",
  									src: "12418:13:3"
  								}
  							],
  							id: 1930,
  							name: "ParameterList",
  							src: "12417:15:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 1931,
  							name: "ParameterList",
  							src: "12442:0:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										assignments: [
  											1933
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "src",
  												scope: 2120,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "address",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "address",
  														stateMutability: "nonpayable",
  														type: "address"
  													},
  													id: 1932,
  													name: "ElementaryTypeName",
  													src: "12514:7:3"
  												}
  											],
  											id: 1933,
  											name: "VariableDeclaration",
  											src: "12514:11:3"
  										}
  									],
  									id: 1934,
  									name: "VariableDeclarationStatement",
  									src: "12514:11:3"
  								},
  								{
  									attributes: {
  										assignments: [
  											1936
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "dest",
  												scope: 2120,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "address",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "address",
  														stateMutability: "nonpayable",
  														type: "address"
  													},
  													id: 1935,
  													name: "ElementaryTypeName",
  													src: "12535:7:3"
  												}
  											],
  											id: 1936,
  											name: "VariableDeclaration",
  											src: "12535:12:3"
  										}
  									],
  									id: 1937,
  									name: "VariableDeclarationStatement",
  									src: "12535:12:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												assignments: [
  													1939
  												]
  											},
  											children: [
  												{
  													attributes: {
  														constant: false,
  														mutability: "mutable",
  														name: "i",
  														scope: 2014,
  														stateVariable: false,
  														storageLocation: "default",
  														type: "uint256",
  														visibility: "internal"
  													},
  													children: [
  														{
  															attributes: {
  																name: "uint",
  																type: "uint256"
  															},
  															id: 1938,
  															name: "ElementaryTypeName",
  															src: "12659:4:3"
  														}
  													],
  													id: 1939,
  													name: "VariableDeclaration",
  													src: "12659:6:3"
  												},
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 1940,
  													name: "Literal",
  													src: "12668:1:3"
  												}
  											],
  											id: 1941,
  											name: "VariableDeclarationStatement",
  											src: "12659:10:3"
  										},
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "<",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1939,
  														type: "uint256",
  														value: "i"
  													},
  													id: 1942,
  													name: "Identifier",
  													src: "12671:1:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "length",
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1214,
  																type: "address[] storage ref",
  																value: "seen"
  															},
  															id: 1943,
  															name: "Identifier",
  															src: "12675:4:3"
  														}
  													],
  													id: 1944,
  													name: "MemberAccess",
  													src: "12675:11:3"
  												}
  											],
  											id: 1945,
  											name: "BinaryOperation",
  											src: "12671:15:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "++",
  														prefix: false,
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1939,
  																type: "uint256",
  																value: "i"
  															},
  															id: 1946,
  															name: "Identifier",
  															src: "12688:1:3"
  														}
  													],
  													id: 1947,
  													name: "UnaryOperation",
  													src: "12688:3:3"
  												}
  											],
  											id: 1948,
  											name: "ExpressionStatement",
  											src: "12688:3:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														assignments: [
  															1950
  														]
  													},
  													children: [
  														{
  															attributes: {
  																constant: false,
  																mutability: "mutable",
  																name: "curr",
  																scope: 2013,
  																stateVariable: false,
  																storageLocation: "memory",
  																type: "struct Hub.transferValidator",
  																visibility: "internal"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "transferValidator",
  																		referencedDeclaration: 1207,
  																		type: "struct Hub.transferValidator"
  																	},
  																	id: 1949,
  																	name: "UserDefinedTypeName",
  																	src: "12707:17:3"
  																}
  															],
  															id: 1950,
  															name: "VariableDeclaration",
  															src: "12707:29:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "struct Hub.transferValidator storage ref"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1211,
  																		type: "mapping(address => struct Hub.transferValidator storage ref)",
  																		value: "validation"
  																	},
  																	id: 1951,
  																	name: "Identifier",
  																	src: "12739:10:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "address"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1214,
  																				type: "address[] storage ref",
  																				value: "seen"
  																			},
  																			id: 1952,
  																			name: "Identifier",
  																			src: "12750:4:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1939,
  																				type: "uint256",
  																				value: "i"
  																			},
  																			id: 1953,
  																			name: "Identifier",
  																			src: "12755:1:3"
  																		}
  																	],
  																	id: 1954,
  																	name: "IndexAccess",
  																	src: "12750:7:3"
  																}
  															],
  															id: 1955,
  															name: "IndexAccess",
  															src: "12739:19:3"
  														}
  													],
  													id: 1956,
  													name: "VariableDeclarationStatement",
  													src: "12707:51:3"
  												},
  												{
  													attributes: {
  													},
  													children: [
  														{
  															attributes: {
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: ">",
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "sent",
  																		referencedDeclaration: 1204,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1950,
  																				type: "struct Hub.transferValidator memory",
  																				value: "curr"
  																			},
  																			id: 1957,
  																			name: "Identifier",
  																			src: "12856:4:3"
  																		}
  																	],
  																	id: 1958,
  																	name: "MemberAccess",
  																	src: "12856:9:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "received",
  																		referencedDeclaration: 1206,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1950,
  																				type: "struct Hub.transferValidator memory",
  																				value: "curr"
  																			},
  																			id: 1959,
  																			name: "Identifier",
  																			src: "12868:4:3"
  																		}
  																	],
  																	id: 1960,
  																	name: "MemberAccess",
  																	src: "12868:13:3"
  																}
  															],
  															id: 1961,
  															name: "BinaryOperation",
  															src: "12856:25:3"
  														},
  														{
  															children: [
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				isStructConstructorCall: false,
  																				lValueRequested: false,
  																				names: [
  																					null
  																				],
  																				tryCall: false,
  																				type: "tuple()",
  																				type_conversion: false
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						argumentTypes: [
  																							{
  																								typeIdentifier: "t_bool",
  																								typeString: "bool"
  																							},
  																							{
  																								typeIdentifier: "t_stringliteral_bd5ad249a9664f143a0488240f4d415946e88e6be137102a9ebc93e8312ca47d",
  																								typeString: "literal_string \"Path sends from more than one src\""
  																							}
  																						],
  																						overloadedDeclarations: [
  																							-18,
  																							-18
  																						],
  																						referencedDeclaration: -18,
  																						type: "function (bool,string memory) pure",
  																						value: "require"
  																					},
  																					id: 1962,
  																					name: "Identifier",
  																					src: "12976:7:3"
  																				},
  																				{
  																					attributes: {
  																						commonType: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						},
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						operator: "==",
  																						type: "bool"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1933,
  																								type: "address",
  																								value: "src"
  																							},
  																							id: 1963,
  																							name: "Identifier",
  																							src: "12984:3:3"
  																						},
  																						{
  																							attributes: {
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								isStructConstructorCall: false,
  																								lValueRequested: false,
  																								names: [
  																									null
  																								],
  																								tryCall: false,
  																								type: "address payable",
  																								type_conversion: true
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										argumentTypes: [
  																											{
  																												typeIdentifier: "t_rational_0_by_1",
  																												typeString: "int_const 0"
  																											}
  																										],
  																										isConstant: false,
  																										isLValue: false,
  																										isPure: true,
  																										lValueRequested: false,
  																										type: "type(address)"
  																									},
  																									children: [
  																										{
  																											attributes: {
  																												name: "address"
  																											},
  																											id: 1964,
  																											name: "ElementaryTypeName",
  																											src: "12991:7:3"
  																										}
  																									],
  																									id: 1965,
  																									name: "ElementaryTypeNameExpression",
  																									src: "12991:7:3"
  																								},
  																								{
  																									attributes: {
  																										hexvalue: "30",
  																										isConstant: false,
  																										isLValue: false,
  																										isPure: true,
  																										lValueRequested: false,
  																										token: "number",
  																										type: "int_const 0",
  																										value: "0"
  																									},
  																									id: 1966,
  																									name: "Literal",
  																									src: "12999:1:3"
  																								}
  																							],
  																							id: 1967,
  																							name: "FunctionCall",
  																							src: "12991:10:3"
  																						}
  																					],
  																					id: 1968,
  																					name: "BinaryOperation",
  																					src: "12984:17:3"
  																				},
  																				{
  																					attributes: {
  																						hexvalue: "506174682073656e64732066726f6d206d6f7265207468616e206f6e6520737263",
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						lValueRequested: false,
  																						token: "string",
  																						type: "literal_string \"Path sends from more than one src\"",
  																						value: "Path sends from more than one src"
  																					},
  																					id: 1969,
  																					name: "Literal",
  																					src: "13003:35:3"
  																				}
  																			],
  																			id: 1970,
  																			name: "FunctionCall",
  																			src: "12976:63:3"
  																		}
  																	],
  																	id: 1971,
  																	name: "ExpressionStatement",
  																	src: "12976:63:3"
  																},
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				isStructConstructorCall: false,
  																				lValueRequested: false,
  																				names: [
  																					null
  																				],
  																				tryCall: false,
  																				type: "tuple()",
  																				type_conversion: false
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						argumentTypes: [
  																							{
  																								typeIdentifier: "t_bool",
  																								typeString: "bool"
  																							},
  																							{
  																								typeIdentifier: "t_stringliteral_d9e6394d4dbbea9b9a8aaf6490cf335c359714fd39b81ef3bbaa04a6167eaa70",
  																								typeString: "literal_string \"Path doesn't send from transaction sender\""
  																							}
  																						],
  																						overloadedDeclarations: [
  																							-18,
  																							-18
  																						],
  																						referencedDeclaration: -18,
  																						type: "function (bool,string memory) pure",
  																						value: "require"
  																					},
  																					id: 1972,
  																					name: "Identifier",
  																					src: "13134:7:3"
  																				},
  																				{
  																					attributes: {
  																						commonType: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						},
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						operator: "==",
  																						type: "bool"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								isConstant: false,
  																								isLValue: true,
  																								isPure: false,
  																								lValueRequested: false,
  																								type: "address"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1214,
  																										type: "address[] storage ref",
  																										value: "seen"
  																									},
  																									id: 1973,
  																									name: "Identifier",
  																									src: "13142:4:3"
  																								},
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 1939,
  																										type: "uint256",
  																										value: "i"
  																									},
  																									id: 1974,
  																									name: "Identifier",
  																									src: "13147:1:3"
  																								}
  																							],
  																							id: 1975,
  																							name: "IndexAccess",
  																							src: "13142:7:3"
  																						},
  																						{
  																							attributes: {
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "sender",
  																								type: "address payable"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: -15,
  																										type: "msg",
  																										value: "msg"
  																									},
  																									id: 1976,
  																									name: "Identifier",
  																									src: "13153:3:3"
  																								}
  																							],
  																							id: 1977,
  																							name: "MemberAccess",
  																							src: "13153:10:3"
  																						}
  																					],
  																					id: 1978,
  																					name: "BinaryOperation",
  																					src: "13142:21:3"
  																				},
  																				{
  																					attributes: {
  																						hexvalue: "5061746820646f65736e27742073656e642066726f6d207472616e73616374696f6e2073656e646572",
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						lValueRequested: false,
  																						token: "string",
  																						type: "literal_string \"Path doesn't send from transaction sender\"",
  																						value: "Path doesn't send from transaction sender"
  																					},
  																					id: 1979,
  																					name: "Literal",
  																					src: "13165:43:3"
  																				}
  																			],
  																			id: 1980,
  																			name: "FunctionCall",
  																			src: "13134:75:3"
  																		}
  																	],
  																	id: 1981,
  																	name: "ExpressionStatement",
  																	src: "13134:75:3"
  																},
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "address"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1933,
  																						type: "address",
  																						value: "src"
  																					},
  																					id: 1982,
  																					name: "Identifier",
  																					src: "13227:3:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: true,
  																						isPure: false,
  																						lValueRequested: false,
  																						type: "address"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1214,
  																								type: "address[] storage ref",
  																								value: "seen"
  																							},
  																							id: 1983,
  																							name: "Identifier",
  																							src: "13233:4:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1939,
  																								type: "uint256",
  																								value: "i"
  																							},
  																							id: 1984,
  																							name: "Identifier",
  																							src: "13238:1:3"
  																						}
  																					],
  																					id: 1985,
  																					name: "IndexAccess",
  																					src: "13233:7:3"
  																				}
  																			],
  																			id: 1986,
  																			name: "Assignment",
  																			src: "13227:13:3"
  																		}
  																	],
  																	id: 1987,
  																	name: "ExpressionStatement",
  																	src: "13227:13:3"
  																}
  															],
  															id: 1988,
  															name: "Block",
  															src: "12883:372:3"
  														}
  													],
  													id: 1989,
  													name: "IfStatement",
  													src: "12852:403:3"
  												},
  												{
  													attributes: {
  													},
  													children: [
  														{
  															attributes: {
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: ">",
  																type: "bool"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "received",
  																		referencedDeclaration: 1206,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1950,
  																				type: "struct Hub.transferValidator memory",
  																				value: "curr"
  																			},
  																			id: 1990,
  																			name: "Identifier",
  																			src: "13355:4:3"
  																		}
  																	],
  																	id: 1991,
  																	name: "MemberAccess",
  																	src: "13355:13:3"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "sent",
  																		referencedDeclaration: 1204,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1950,
  																				type: "struct Hub.transferValidator memory",
  																				value: "curr"
  																			},
  																			id: 1992,
  																			name: "Identifier",
  																			src: "13371:4:3"
  																		}
  																	],
  																	id: 1993,
  																	name: "MemberAccess",
  																	src: "13371:9:3"
  																}
  															],
  															id: 1994,
  															name: "BinaryOperation",
  															src: "13355:25:3"
  														},
  														{
  															children: [
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				isStructConstructorCall: false,
  																				lValueRequested: false,
  																				names: [
  																					null
  																				],
  																				tryCall: false,
  																				type: "tuple()",
  																				type_conversion: false
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						argumentTypes: [
  																							{
  																								typeIdentifier: "t_bool",
  																								typeString: "bool"
  																							},
  																							{
  																								typeIdentifier: "t_stringliteral_636ae00d32879d12302d10bdd0b90698f43cf16407a22a354e188979ec5b7df3",
  																								typeString: "literal_string \"Path sends to more than one dest\""
  																							}
  																						],
  																						overloadedDeclarations: [
  																							-18,
  																							-18
  																						],
  																						referencedDeclaration: -18,
  																						type: "function (bool,string memory) pure",
  																						value: "require"
  																					},
  																					id: 1995,
  																					name: "Identifier",
  																					src: "13478:7:3"
  																				},
  																				{
  																					attributes: {
  																						commonType: {
  																							typeIdentifier: "t_address",
  																							typeString: "address"
  																						},
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						operator: "==",
  																						type: "bool"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1936,
  																								type: "address",
  																								value: "dest"
  																							},
  																							id: 1996,
  																							name: "Identifier",
  																							src: "13486:4:3"
  																						},
  																						{
  																							attributes: {
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								isStructConstructorCall: false,
  																								lValueRequested: false,
  																								names: [
  																									null
  																								],
  																								tryCall: false,
  																								type: "address payable",
  																								type_conversion: true
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										argumentTypes: [
  																											{
  																												typeIdentifier: "t_rational_0_by_1",
  																												typeString: "int_const 0"
  																											}
  																										],
  																										isConstant: false,
  																										isLValue: false,
  																										isPure: true,
  																										lValueRequested: false,
  																										type: "type(address)"
  																									},
  																									children: [
  																										{
  																											attributes: {
  																												name: "address"
  																											},
  																											id: 1997,
  																											name: "ElementaryTypeName",
  																											src: "13494:7:3"
  																										}
  																									],
  																									id: 1998,
  																									name: "ElementaryTypeNameExpression",
  																									src: "13494:7:3"
  																								},
  																								{
  																									attributes: {
  																										hexvalue: "30",
  																										isConstant: false,
  																										isLValue: false,
  																										isPure: true,
  																										lValueRequested: false,
  																										token: "number",
  																										type: "int_const 0",
  																										value: "0"
  																									},
  																									id: 1999,
  																									name: "Literal",
  																									src: "13502:1:3"
  																								}
  																							],
  																							id: 2000,
  																							name: "FunctionCall",
  																							src: "13494:10:3"
  																						}
  																					],
  																					id: 2001,
  																					name: "BinaryOperation",
  																					src: "13486:18:3"
  																				},
  																				{
  																					attributes: {
  																						hexvalue: "506174682073656e647320746f206d6f7265207468616e206f6e652064657374",
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: true,
  																						lValueRequested: false,
  																						token: "string",
  																						type: "literal_string \"Path sends to more than one dest\"",
  																						value: "Path sends to more than one dest"
  																					},
  																					id: 2002,
  																					name: "Literal",
  																					src: "13506:34:3"
  																				}
  																			],
  																			id: 2003,
  																			name: "FunctionCall",
  																			src: "13478:63:3"
  																		}
  																	],
  																	id: 2004,
  																	name: "ExpressionStatement",
  																	src: "13478:63:3"
  																},
  																{
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				operator: "=",
  																				type: "address"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1936,
  																						type: "address",
  																						value: "dest"
  																					},
  																					id: 2005,
  																					name: "Identifier",
  																					src: "13559:4:3"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: true,
  																						isPure: false,
  																						lValueRequested: false,
  																						type: "address"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1214,
  																								type: "address[] storage ref",
  																								value: "seen"
  																							},
  																							id: 2006,
  																							name: "Identifier",
  																							src: "13566:4:3"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 1939,
  																								type: "uint256",
  																								value: "i"
  																							},
  																							id: 2007,
  																							name: "Identifier",
  																							src: "13571:1:3"
  																						}
  																					],
  																					id: 2008,
  																					name: "IndexAccess",
  																					src: "13566:7:3"
  																				}
  																			],
  																			id: 2009,
  																			name: "Assignment",
  																			src: "13559:14:3"
  																		}
  																	],
  																	id: 2010,
  																	name: "ExpressionStatement",
  																	src: "13559:14:3"
  																}
  															],
  															id: 2011,
  															name: "Block",
  															src: "13382:206:3"
  														}
  													],
  													id: 2012,
  													name: "IfStatement",
  													src: "13351:237:3"
  												}
  											],
  											id: 2013,
  											name: "Block",
  											src: "12693:905:3"
  										}
  									],
  									id: 2014,
  									name: "ForStatement",
  									src: "12654:944:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_6ded99c44d58ae990e48a4fa06b4daac2277f2603cae3502a4dbd932987e5f7f",
  																typeString: "literal_string \"Transaction must have a src\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2015,
  													name: "Identifier",
  													src: "13665:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "!=",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1933,
  																type: "address",
  																value: "src"
  															},
  															id: 2016,
  															name: "Identifier",
  															src: "13673:3:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address payable",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 2017,
  																			name: "ElementaryTypeName",
  																			src: "13680:7:3"
  																		}
  																	],
  																	id: 2018,
  																	name: "ElementaryTypeNameExpression",
  																	src: "13680:7:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 2019,
  																	name: "Literal",
  																	src: "13688:1:3"
  																}
  															],
  															id: 2020,
  															name: "FunctionCall",
  															src: "13680:10:3"
  														}
  													],
  													id: 2021,
  													name: "BinaryOperation",
  													src: "13673:17:3"
  												},
  												{
  													attributes: {
  														hexvalue: "5472616e73616374696f6e206d7573742068617665206120737263",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Transaction must have a src\"",
  														value: "Transaction must have a src"
  													},
  													id: 2022,
  													name: "Literal",
  													src: "13692:29:3"
  												}
  											],
  											id: 2023,
  											name: "FunctionCall",
  											src: "13665:57:3"
  										}
  									],
  									id: 2024,
  									name: "ExpressionStatement",
  									src: "13665:57:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_41d6d26c8e90b951d2aec8b2d38d1057d948500e39d06b0e7fbdaeb0bc360992",
  																typeString: "literal_string \"Transaction must have a dest\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2025,
  													name: "Identifier",
  													src: "13732:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "!=",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1936,
  																type: "address",
  																value: "dest"
  															},
  															id: 2026,
  															name: "Identifier",
  															src: "13740:4:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address payable",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 2027,
  																			name: "ElementaryTypeName",
  																			src: "13748:7:3"
  																		}
  																	],
  																	id: 2028,
  																	name: "ElementaryTypeNameExpression",
  																	src: "13748:7:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 2029,
  																	name: "Literal",
  																	src: "13756:1:3"
  																}
  															],
  															id: 2030,
  															name: "FunctionCall",
  															src: "13748:10:3"
  														}
  													],
  													id: 2031,
  													name: "BinaryOperation",
  													src: "13740:18:3"
  												},
  												{
  													attributes: {
  														hexvalue: "5472616e73616374696f6e206d757374206861766520612064657374",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Transaction must have a dest\"",
  														value: "Transaction must have a dest"
  													},
  													id: 2032,
  													name: "Literal",
  													src: "13760:30:3"
  												}
  											],
  											id: 2033,
  											name: "FunctionCall",
  											src: "13732:59:3"
  										}
  									],
  									id: 2034,
  									name: "ExpressionStatement",
  									src: "13732:59:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_89f5905e57e8dce0a828148fcfff03bb5a643f9180447bef665b1d7134d626ef",
  																typeString: "literal_string \"Sender is receiving\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2035,
  													name: "Identifier",
  													src: "13979:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "received",
  																referencedDeclaration: 1206,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "struct Hub.transferValidator storage ref"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1211,
  																				type: "mapping(address => struct Hub.transferValidator storage ref)",
  																				value: "validation"
  																			},
  																			id: 2036,
  																			name: "Identifier",
  																			src: "13987:10:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1933,
  																				type: "address",
  																				value: "src"
  																			},
  																			id: 2037,
  																			name: "Identifier",
  																			src: "13998:3:3"
  																		}
  																	],
  																	id: 2038,
  																	name: "IndexAccess",
  																	src: "13987:15:3"
  																}
  															],
  															id: 2039,
  															name: "MemberAccess",
  															src: "13987:24:3"
  														},
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 2040,
  															name: "Literal",
  															src: "14015:1:3"
  														}
  													],
  													id: 2041,
  													name: "BinaryOperation",
  													src: "13987:29:3"
  												},
  												{
  													attributes: {
  														hexvalue: "53656e64657220697320726563656976696e67",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Sender is receiving\"",
  														value: "Sender is receiving"
  													},
  													id: 2042,
  													name: "Literal",
  													src: "14018:21:3"
  												}
  											],
  											id: 2043,
  											name: "FunctionCall",
  											src: "13979:61:3"
  										}
  									],
  									id: 2044,
  									name: "ExpressionStatement",
  									src: "13979:61:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_18747d2531191c2698bbaf45882679d66443118c356c2287d6d9e9a5c7fcf973",
  																typeString: "literal_string \"Recipient is sending\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2045,
  													name: "Identifier",
  													src: "14050:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sent",
  																referencedDeclaration: 1204,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "struct Hub.transferValidator storage ref"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1211,
  																				type: "mapping(address => struct Hub.transferValidator storage ref)",
  																				value: "validation"
  																			},
  																			id: 2046,
  																			name: "Identifier",
  																			src: "14058:10:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1936,
  																				type: "address",
  																				value: "dest"
  																			},
  																			id: 2047,
  																			name: "Identifier",
  																			src: "14069:4:3"
  																		}
  																	],
  																	id: 2048,
  																	name: "IndexAccess",
  																	src: "14058:16:3"
  																}
  															],
  															id: 2049,
  															name: "MemberAccess",
  															src: "14058:21:3"
  														},
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 2050,
  															name: "Literal",
  															src: "14083:1:3"
  														}
  													],
  													id: 2051,
  													name: "BinaryOperation",
  													src: "14058:26:3"
  												},
  												{
  													attributes: {
  														hexvalue: "526563697069656e742069732073656e64696e67",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Recipient is sending\"",
  														value: "Recipient is sending"
  													},
  													id: 2052,
  													name: "Literal",
  													src: "14086:22:3"
  												}
  											],
  											id: 2053,
  											name: "FunctionCall",
  											src: "14050:59:3"
  										}
  									],
  									id: 2054,
  									name: "ExpressionStatement",
  									src: "14050:59:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_f5c3e52d85771c19e73499345987bbb17e32ec59d7cb8ef334626a423fb94cfb",
  																typeString: "literal_string \"Unequal sent and received amounts\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2055,
  													name: "Identifier",
  													src: "14203:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sent",
  																referencedDeclaration: 1204,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "struct Hub.transferValidator storage ref"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1211,
  																				type: "mapping(address => struct Hub.transferValidator storage ref)",
  																				value: "validation"
  																			},
  																			id: 2056,
  																			name: "Identifier",
  																			src: "14211:10:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1933,
  																				type: "address",
  																				value: "src"
  																			},
  																			id: 2057,
  																			name: "Identifier",
  																			src: "14222:3:3"
  																		}
  																	],
  																	id: 2058,
  																	name: "IndexAccess",
  																	src: "14211:15:3"
  																}
  															],
  															id: 2059,
  															name: "MemberAccess",
  															src: "14211:20:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "received",
  																referencedDeclaration: 1206,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "struct Hub.transferValidator storage ref"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1211,
  																				type: "mapping(address => struct Hub.transferValidator storage ref)",
  																				value: "validation"
  																			},
  																			id: 2060,
  																			name: "Identifier",
  																			src: "14235:10:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1936,
  																				type: "address",
  																				value: "dest"
  																			},
  																			id: 2061,
  																			name: "Identifier",
  																			src: "14246:4:3"
  																		}
  																	],
  																	id: 2062,
  																	name: "IndexAccess",
  																	src: "14235:16:3"
  																}
  															],
  															id: 2063,
  															name: "MemberAccess",
  															src: "14235:25:3"
  														}
  													],
  													id: 2064,
  													name: "BinaryOperation",
  													src: "14211:49:3"
  												},
  												{
  													attributes: {
  														hexvalue: "556e657175616c2073656e7420616e6420726563656976656420616d6f756e7473",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Unequal sent and received amounts\"",
  														value: "Unequal sent and received amounts"
  													},
  													id: 2065,
  													name: "Literal",
  													src: "14262:35:3"
  												}
  											],
  											id: 2066,
  											name: "FunctionCall",
  											src: "14203:95:3"
  										}
  									],
  									id: 2067,
  									name: "ExpressionStatement",
  									src: "14203:95:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_9c7094d6ce7f5df448f76d8136b15f6c81c4846433c1fec602370bb5e0be3b5f",
  																typeString: "literal_string \"Seen too many addresses\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2068,
  													name: "Identifier",
  													src: "14400:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "<=",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1214,
  																		type: "address[] storage ref",
  																		value: "seen"
  																	},
  																	id: 2069,
  																	name: "Identifier",
  																	src: "14408:4:3"
  																}
  															],
  															id: 2070,
  															name: "MemberAccess",
  															src: "14408:11:3"
  														},
  														{
  															attributes: {
  																commonType: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																},
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "+",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1929,
  																		type: "uint256",
  																		value: "steps"
  																	},
  																	id: 2071,
  																	name: "Identifier",
  																	src: "14423:5:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "31",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 1",
  																		value: "1"
  																	},
  																	id: 2072,
  																	name: "Literal",
  																	src: "14431:1:3"
  																}
  															],
  															id: 2073,
  															name: "BinaryOperation",
  															src: "14423:9:3"
  														}
  													],
  													id: 2074,
  													name: "BinaryOperation",
  													src: "14408:24:3"
  												},
  												{
  													attributes: {
  														hexvalue: "5365656e20746f6f206d616e7920616464726573736573",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Seen too many addresses\"",
  														value: "Seen too many addresses"
  													},
  													id: 2075,
  													name: "Literal",
  													src: "14434:25:3"
  												}
  											],
  											id: 2076,
  											name: "FunctionCall",
  											src: "14400:60:3"
  										}
  									],
  									id: 2077,
  									name: "ExpressionStatement",
  									src: "14400:60:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1200,
  														type: "function (address,address,uint256)",
  														value: "HubTransfer"
  													},
  													id: 2078,
  													name: "Identifier",
  													src: "14475:11:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1933,
  														type: "address",
  														value: "src"
  													},
  													id: 2079,
  													name: "Identifier",
  													src: "14487:3:3"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1936,
  														type: "address",
  														value: "dest"
  													},
  													id: 2080,
  													name: "Identifier",
  													src: "14492:4:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sent",
  														referencedDeclaration: 1204,
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "struct Hub.transferValidator storage ref"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1211,
  																		type: "mapping(address => struct Hub.transferValidator storage ref)",
  																		value: "validation"
  																	},
  																	id: 2081,
  																	name: "Identifier",
  																	src: "14498:10:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1933,
  																		type: "address",
  																		value: "src"
  																	},
  																	id: 2082,
  																	name: "Identifier",
  																	src: "14509:3:3"
  																}
  															],
  															id: 2083,
  															name: "IndexAccess",
  															src: "14498:15:3"
  														}
  													],
  													id: 2084,
  													name: "MemberAccess",
  													src: "14498:20:3"
  												}
  											],
  											id: 2085,
  											name: "FunctionCall",
  											src: "14475:44:3"
  										}
  									],
  									id: 2086,
  									name: "EmitStatement",
  									src: "14470:49:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												assignments: [
  													2088
  												]
  											},
  											children: [
  												{
  													attributes: {
  														constant: false,
  														mutability: "mutable",
  														name: "i",
  														scope: 2108,
  														stateVariable: false,
  														storageLocation: "default",
  														type: "uint256",
  														visibility: "internal"
  													},
  													children: [
  														{
  															attributes: {
  																name: "uint",
  																type: "uint256"
  															},
  															id: 2087,
  															name: "ElementaryTypeName",
  															src: "14584:4:3"
  														}
  													],
  													id: 2088,
  													name: "VariableDeclaration",
  													src: "14584:6:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "length",
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 1214,
  																type: "address[] storage ref",
  																value: "seen"
  															},
  															id: 2089,
  															name: "Identifier",
  															src: "14593:4:3"
  														}
  													],
  													id: 2090,
  													name: "MemberAccess",
  													src: "14593:11:3"
  												}
  											],
  											id: 2091,
  											name: "VariableDeclarationStatement",
  											src: "14584:20:3"
  										},
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: ">=",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2088,
  														type: "uint256",
  														value: "i"
  													},
  													id: 2092,
  													name: "Identifier",
  													src: "14606:1:3"
  												},
  												{
  													attributes: {
  														hexvalue: "31",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 1",
  														value: "1"
  													},
  													id: 2093,
  													name: "Literal",
  													src: "14611:1:3"
  												}
  											],
  											id: 2094,
  											name: "BinaryOperation",
  											src: "14606:6:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "--",
  														prefix: false,
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2088,
  																type: "uint256",
  																value: "i"
  															},
  															id: 2095,
  															name: "Identifier",
  															src: "14614:1:3"
  														}
  													],
  													id: 2096,
  													name: "UnaryOperation",
  													src: "14614:3:3"
  												}
  											],
  											id: 2097,
  											name: "ExpressionStatement",
  											src: "14614:3:3"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "delete",
  																prefix: true,
  																type: "tuple()"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: true,
  																		type: "struct Hub.transferValidator storage ref"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 1211,
  																				type: "mapping(address => struct Hub.transferValidator storage ref)",
  																				value: "validation"
  																			},
  																			id: 2098,
  																			name: "Identifier",
  																			src: "14640:10:3"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "address"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1214,
  																						type: "address[] storage ref",
  																						value: "seen"
  																					},
  																					id: 2099,
  																					name: "Identifier",
  																					src: "14651:4:3"
  																				},
  																				{
  																					attributes: {
  																						commonType: {
  																							typeIdentifier: "t_uint256",
  																							typeString: "uint256"
  																						},
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						operator: "-",
  																						type: "uint256"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 2088,
  																								type: "uint256",
  																								value: "i"
  																							},
  																							id: 2100,
  																							name: "Identifier",
  																							src: "14656:1:3"
  																						},
  																						{
  																							attributes: {
  																								hexvalue: "31",
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								lValueRequested: false,
  																								token: "number",
  																								type: "int_const 1",
  																								value: "1"
  																							},
  																							id: 2101,
  																							name: "Literal",
  																							src: "14658:1:3"
  																						}
  																					],
  																					id: 2102,
  																					name: "BinaryOperation",
  																					src: "14656:3:3"
  																				}
  																			],
  																			id: 2103,
  																			name: "IndexAccess",
  																			src: "14651:9:3"
  																		}
  																	],
  																	id: 2104,
  																	name: "IndexAccess",
  																	src: "14640:21:3"
  																}
  															],
  															id: 2105,
  															name: "UnaryOperation",
  															src: "14633:28:3"
  														}
  													],
  													id: 2106,
  													name: "ExpressionStatement",
  													src: "14633:28:3"
  												}
  											],
  											id: 2107,
  											name: "Block",
  											src: "14619:53:3"
  										}
  									],
  									id: 2108,
  									name: "ForStatement",
  									src: "14579:93:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "delete",
  												prefix: true,
  												type: "tuple()"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1214,
  														type: "address[] storage ref",
  														value: "seen"
  													},
  													id: 2109,
  													name: "Identifier",
  													src: "14688:4:3"
  												}
  											],
  											id: 2110,
  											name: "UnaryOperation",
  											src: "14681:11:3"
  										}
  									],
  									id: 2111,
  									name: "ExpressionStatement",
  									src: "14681:11:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_df31f4cd56ee9d90a8a753c8f534dd8dec3b906d4966bf0461a5aea6d1e8b098",
  																typeString: "literal_string \"Seen should be empty\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2112,
  													name: "Identifier",
  													src: "14766:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1214,
  																		type: "address[] storage ref",
  																		value: "seen"
  																	},
  																	id: 2113,
  																	name: "Identifier",
  																	src: "14774:4:3"
  																}
  															],
  															id: 2114,
  															name: "MemberAccess",
  															src: "14774:11:3"
  														},
  														{
  															attributes: {
  																hexvalue: "30",
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																lValueRequested: false,
  																token: "number",
  																type: "int_const 0",
  																value: "0"
  															},
  															id: 2115,
  															name: "Literal",
  															src: "14789:1:3"
  														}
  													],
  													id: 2116,
  													name: "BinaryOperation",
  													src: "14774:16:3"
  												},
  												{
  													attributes: {
  														hexvalue: "5365656e2073686f756c6420626520656d707479",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Seen should be empty\"",
  														value: "Seen should be empty"
  													},
  													id: 2117,
  													name: "Literal",
  													src: "14792:22:3"
  												}
  											],
  											id: 2118,
  											name: "FunctionCall",
  											src: "14766:49:3"
  										}
  									],
  									id: 2119,
  									name: "ExpressionStatement",
  									src: "14766:49:3"
  								}
  							],
  							id: 2120,
  							name: "Block",
  							src: "12442:2380:3"
  						}
  					],
  					id: 2121,
  					name: "FunctionDefinition",
  					src: "12385:2437:3"
  				},
  				{
  					attributes: {
  						functionSelector: "d62fd9a2",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "transferThrough",
  						scope: 2238,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice walks through tokenOwners, srcs, dests, and amounts array and executes transtive transfer\n @dev tokenOwners[0], srcs[0], dests[0], and wads[0] constitute a transaction step\n @param tokenOwners the owner of the tokens being sent in each transaction step\n @param srcs the sender of each transaction step\n @param dests the recipient of each transaction step\n @param wads the amount for each transaction step"
  							},
  							id: 2122,
  							name: "StructuredDocumentation",
  							src: "14828:451:3"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "tokenOwners",
  										scope: 2237,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "address[]",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												type: "address[]"
  											},
  											children: [
  												{
  													attributes: {
  														name: "address",
  														stateMutability: "nonpayable",
  														type: "address"
  													},
  													id: 2123,
  													name: "ElementaryTypeName",
  													src: "15318:7:3"
  												}
  											],
  											id: 2124,
  											name: "ArrayTypeName",
  											src: "15318:9:3"
  										}
  									],
  									id: 2125,
  									name: "VariableDeclaration",
  									src: "15318:28:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "srcs",
  										scope: 2237,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "address[]",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												type: "address[]"
  											},
  											children: [
  												{
  													attributes: {
  														name: "address",
  														stateMutability: "nonpayable",
  														type: "address"
  													},
  													id: 2126,
  													name: "ElementaryTypeName",
  													src: "15356:7:3"
  												}
  											],
  											id: 2127,
  											name: "ArrayTypeName",
  											src: "15356:9:3"
  										}
  									],
  									id: 2128,
  									name: "VariableDeclaration",
  									src: "15356:21:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "dests",
  										scope: 2237,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "address[]",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												type: "address[]"
  											},
  											children: [
  												{
  													attributes: {
  														name: "address",
  														stateMutability: "nonpayable",
  														type: "address"
  													},
  													id: 2129,
  													name: "ElementaryTypeName",
  													src: "15387:7:3"
  												}
  											],
  											id: 2130,
  											name: "ArrayTypeName",
  											src: "15387:9:3"
  										}
  									],
  									id: 2131,
  									name: "VariableDeclaration",
  									src: "15387:22:3"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "wads",
  										scope: 2237,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "uint256[]",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												type: "uint256[]"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint",
  														type: "uint256"
  													},
  													id: 2132,
  													name: "ElementaryTypeName",
  													src: "15419:4:3"
  												}
  											],
  											id: 2133,
  											name: "ArrayTypeName",
  											src: "15419:6:3"
  										}
  									],
  									id: 2134,
  									name: "VariableDeclaration",
  									src: "15419:18:3"
  								}
  							],
  							id: 2135,
  							name: "ParameterList",
  							src: "15308:135:3"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2136,
  							name: "ParameterList",
  							src: "15451:0:3"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_59ad779d34add4559c288c6282fd203bb30023e760668fd175322e96d95f2b2d",
  																typeString: "literal_string \"Tokens array length must equal dests array\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2137,
  													name: "Identifier",
  													src: "15511:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2131,
  																		type: "address[] memory",
  																		value: "dests"
  																	},
  																	id: 2138,
  																	name: "Identifier",
  																	src: "15519:5:3"
  																}
  															],
  															id: 2139,
  															name: "MemberAccess",
  															src: "15519:12:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2125,
  																		type: "address[] memory",
  																		value: "tokenOwners"
  																	},
  																	id: 2140,
  																	name: "Identifier",
  																	src: "15535:11:3"
  																}
  															],
  															id: 2141,
  															name: "MemberAccess",
  															src: "15535:18:3"
  														}
  													],
  													id: 2142,
  													name: "BinaryOperation",
  													src: "15519:34:3"
  												},
  												{
  													attributes: {
  														hexvalue: "546f6b656e73206172726179206c656e677468206d75737420657175616c206465737473206172726179",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Tokens array length must equal dests array\"",
  														value: "Tokens array length must equal dests array"
  													},
  													id: 2143,
  													name: "Literal",
  													src: "15555:44:3"
  												}
  											],
  											id: 2144,
  											name: "FunctionCall",
  											src: "15511:89:3"
  										}
  									],
  									id: 2145,
  									name: "ExpressionStatement",
  									src: "15511:89:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_350a87b7a24261b7126182087ee093f882e791fb9f86d5409c3f4134f397e659",
  																typeString: "literal_string \"Tokens array length must equal srcs array\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2146,
  													name: "Identifier",
  													src: "15610:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2128,
  																		type: "address[] memory",
  																		value: "srcs"
  																	},
  																	id: 2147,
  																	name: "Identifier",
  																	src: "15618:4:3"
  																}
  															],
  															id: 2148,
  															name: "MemberAccess",
  															src: "15618:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2125,
  																		type: "address[] memory",
  																		value: "tokenOwners"
  																	},
  																	id: 2149,
  																	name: "Identifier",
  																	src: "15633:11:3"
  																}
  															],
  															id: 2150,
  															name: "MemberAccess",
  															src: "15633:18:3"
  														}
  													],
  													id: 2151,
  													name: "BinaryOperation",
  													src: "15618:33:3"
  												},
  												{
  													attributes: {
  														hexvalue: "546f6b656e73206172726179206c656e677468206d75737420657175616c2073726373206172726179",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Tokens array length must equal srcs array\"",
  														value: "Tokens array length must equal srcs array"
  													},
  													id: 2152,
  													name: "Literal",
  													src: "15653:43:3"
  												}
  											],
  											id: 2153,
  											name: "FunctionCall",
  											src: "15610:87:3"
  										}
  									],
  									id: 2154,
  									name: "ExpressionStatement",
  									src: "15610:87:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															},
  															{
  																typeIdentifier: "t_stringliteral_6b9adb5f6ee0763717d7c928a999cc9d2c329729480d2b7fe0e4a678da677bfc",
  																typeString: "literal_string \"Tokens array length must equal amounts array\""
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool,string memory) pure",
  														value: "require"
  													},
  													id: 2155,
  													name: "Identifier",
  													src: "15707:7:3"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2134,
  																		type: "uint256[] memory",
  																		value: "wads"
  																	},
  																	id: 2156,
  																	name: "Identifier",
  																	src: "15715:4:3"
  																}
  															],
  															id: 2157,
  															name: "MemberAccess",
  															src: "15715:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "length",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2125,
  																		type: "address[] memory",
  																		value: "tokenOwners"
  																	},
  																	id: 2158,
  																	name: "Identifier",
  																	src: "15730:11:3"
  																}
  															],
  															id: 2159,
  															name: "MemberAccess",
  															src: "15730:18:3"
  														}
  													],
  													id: 2160,
  													name: "BinaryOperation",
  													src: "15715:33:3"
  												},
  												{
  													attributes: {
  														hexvalue: "546f6b656e73206172726179206c656e677468206d75737420657175616c20616d6f756e7473206172726179",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "string",
  														type: "literal_string \"Tokens array length must equal amounts array\"",
  														value: "Tokens array length must equal amounts array"
  													},
  													id: 2161,
  													name: "Literal",
  													src: "15750:46:3"
  												}
  											],
  											id: 2162,
  											name: "FunctionCall",
  											src: "15707:90:3"
  										}
  									],
  									id: 2163,
  									name: "ExpressionStatement",
  									src: "15707:90:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												assignments: [
  													2165
  												]
  											},
  											children: [
  												{
  													attributes: {
  														constant: false,
  														mutability: "mutable",
  														name: "i",
  														scope: 2230,
  														stateVariable: false,
  														storageLocation: "default",
  														type: "uint256",
  														visibility: "internal"
  													},
  													children: [
  														{
  															attributes: {
  																name: "uint",
  																type: "uint256"
  															},
  															id: 2164,
  															name: "ElementaryTypeName",
  															src: "15812:4:3"
  														}
  													],
  													id: 2165,
  													name: "VariableDeclaration",
  													src: "15812:6:3"
  												},
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 2166,
  													name: "Literal",
  													src: "15821:1:3"
  												}
  											],
  											id: 2167,
  											name: "VariableDeclarationStatement",
  											src: "15812:10:3"
  										},
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "<",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2165,
  														type: "uint256",
  														value: "i"
  													},
  													id: 2168,
  													name: "Identifier",
  													src: "15824:1:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "length",
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2128,
  																type: "address[] memory",
  																value: "srcs"
  															},
  															id: 2169,
  															name: "Identifier",
  															src: "15828:4:3"
  														}
  													],
  													id: 2170,
  													name: "MemberAccess",
  													src: "15828:11:3"
  												}
  											],
  											id: 2171,
  											name: "BinaryOperation",
  											src: "15824:15:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "++",
  														prefix: false,
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2165,
  																type: "uint256",
  																value: "i"
  															},
  															id: 2172,
  															name: "Identifier",
  															src: "15841:1:3"
  														}
  													],
  													id: 2173,
  													name: "UnaryOperation",
  													src: "15841:3:3"
  												}
  											],
  											id: 2174,
  											name: "ExpressionStatement",
  											src: "15841:3:3"
  										},
  										{
  											children: [
  												{
  													attributes: {
  														assignments: [
  															2176
  														]
  													},
  													children: [
  														{
  															attributes: {
  																constant: false,
  																mutability: "mutable",
  																name: "src",
  																scope: 2229,
  																stateVariable: false,
  																storageLocation: "default",
  																type: "address",
  																visibility: "internal"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "address",
  																		stateMutability: "nonpayable",
  																		type: "address"
  																	},
  																	id: 2175,
  																	name: "ElementaryTypeName",
  																	src: "15860:7:3"
  																}
  															],
  															id: 2176,
  															name: "VariableDeclaration",
  															src: "15860:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "address"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2128,
  																		type: "address[] memory",
  																		value: "srcs"
  																	},
  																	id: 2177,
  																	name: "Identifier",
  																	src: "15874:4:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2165,
  																		type: "uint256",
  																		value: "i"
  																	},
  																	id: 2178,
  																	name: "Identifier",
  																	src: "15879:1:3"
  																}
  															],
  															id: 2179,
  															name: "IndexAccess",
  															src: "15874:7:3"
  														}
  													],
  													id: 2180,
  													name: "VariableDeclarationStatement",
  													src: "15860:21:3"
  												},
  												{
  													attributes: {
  														assignments: [
  															2182
  														]
  													},
  													children: [
  														{
  															attributes: {
  																constant: false,
  																mutability: "mutable",
  																name: "dest",
  																scope: 2229,
  																stateVariable: false,
  																storageLocation: "default",
  																type: "address",
  																visibility: "internal"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "address",
  																		stateMutability: "nonpayable",
  																		type: "address"
  																	},
  																	id: 2181,
  																	name: "ElementaryTypeName",
  																	src: "15895:7:3"
  																}
  															],
  															id: 2182,
  															name: "VariableDeclaration",
  															src: "15895:12:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "address"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2131,
  																		type: "address[] memory",
  																		value: "dests"
  																	},
  																	id: 2183,
  																	name: "Identifier",
  																	src: "15910:5:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2165,
  																		type: "uint256",
  																		value: "i"
  																	},
  																	id: 2184,
  																	name: "Identifier",
  																	src: "15916:1:3"
  																}
  															],
  															id: 2185,
  															name: "IndexAccess",
  															src: "15910:8:3"
  														}
  													],
  													id: 2186,
  													name: "VariableDeclarationStatement",
  													src: "15895:23:3"
  												},
  												{
  													attributes: {
  														assignments: [
  															2188
  														]
  													},
  													children: [
  														{
  															attributes: {
  																constant: false,
  																mutability: "mutable",
  																name: "token",
  																scope: 2229,
  																stateVariable: false,
  																storageLocation: "default",
  																type: "address",
  																visibility: "internal"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "address",
  																		stateMutability: "nonpayable",
  																		type: "address"
  																	},
  																	id: 2187,
  																	name: "ElementaryTypeName",
  																	src: "15932:7:3"
  																}
  															],
  															id: 2188,
  															name: "VariableDeclaration",
  															src: "15932:13:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "address"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2125,
  																		type: "address[] memory",
  																		value: "tokenOwners"
  																	},
  																	id: 2189,
  																	name: "Identifier",
  																	src: "15948:11:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2165,
  																		type: "uint256",
  																		value: "i"
  																	},
  																	id: 2190,
  																	name: "Identifier",
  																	src: "15960:1:3"
  																}
  															],
  															id: 2191,
  															name: "IndexAccess",
  															src: "15948:14:3"
  														}
  													],
  													id: 2192,
  													name: "VariableDeclarationStatement",
  													src: "15932:30:3"
  												},
  												{
  													attributes: {
  														assignments: [
  															2194
  														]
  													},
  													children: [
  														{
  															attributes: {
  																constant: false,
  																mutability: "mutable",
  																name: "wad",
  																scope: 2229,
  																stateVariable: false,
  																storageLocation: "default",
  																type: "uint256",
  																visibility: "internal"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "uint256",
  																		type: "uint256"
  																	},
  																	id: 2193,
  																	name: "ElementaryTypeName",
  																	src: "15976:7:3"
  																}
  															],
  															id: 2194,
  															name: "VariableDeclaration",
  															src: "15976:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2134,
  																		type: "uint256[] memory",
  																		value: "wads"
  																	},
  																	id: 2195,
  																	name: "Identifier",
  																	src: "15990:4:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2165,
  																		type: "uint256",
  																		value: "i"
  																	},
  																	id: 2196,
  																	name: "Identifier",
  																	src: "15995:1:3"
  																}
  															],
  															id: 2197,
  															name: "IndexAccess",
  															src: "15990:7:3"
  														}
  													],
  													id: 2198,
  													name: "VariableDeclarationStatement",
  													src: "15976:21:3"
  												},
  												{
  													attributes: {
  														assignments: [
  															2200
  														]
  													},
  													children: [
  														{
  															attributes: {
  																constant: false,
  																mutability: "mutable",
  																name: "max",
  																scope: 2229,
  																stateVariable: false,
  																storageLocation: "default",
  																type: "uint256",
  																visibility: "internal"
  															},
  															children: [
  																{
  																	attributes: {
  																		name: "uint256",
  																		type: "uint256"
  																	},
  																	id: 2199,
  																	name: "ElementaryTypeName",
  																	src: "16079:7:3"
  																}
  															],
  															id: 2200,
  															name: "VariableDeclaration",
  															src: "16079:11:3"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1831,
  																		type: "function (address,address,address) view returns (uint256)",
  																		value: "checkSendLimit"
  																	},
  																	id: 2201,
  																	name: "Identifier",
  																	src: "16093:14:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2188,
  																		type: "address",
  																		value: "token"
  																	},
  																	id: 2202,
  																	name: "Identifier",
  																	src: "16108:5:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2176,
  																		type: "address",
  																		value: "src"
  																	},
  																	id: 2203,
  																	name: "Identifier",
  																	src: "16115:3:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2182,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 2204,
  																	name: "Identifier",
  																	src: "16120:4:3"
  																}
  															],
  															id: 2205,
  															name: "FunctionCall",
  															src: "16093:32:3"
  														}
  													],
  													id: 2206,
  													name: "VariableDeclarationStatement",
  													src: "16079:46:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "tuple()",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_bool",
  																				typeString: "bool"
  																			},
  																			{
  																				typeIdentifier: "t_stringliteral_bfd65915118c90a8f528a4497fd37b2c98d1b399053d7d29cf1cda0cd1d9b348",
  																				typeString: "literal_string \"Trust limit exceeded\""
  																			}
  																		],
  																		overloadedDeclarations: [
  																			-18,
  																			-18
  																		],
  																		referencedDeclaration: -18,
  																		type: "function (bool,string memory) pure",
  																		value: "require"
  																	},
  																	id: 2207,
  																	name: "Identifier",
  																	src: "16139:7:3"
  																},
  																{
  																	attributes: {
  																		commonType: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		},
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		operator: "<=",
  																		type: "bool"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2194,
  																				type: "uint256",
  																				value: "wad"
  																			},
  																			id: 2208,
  																			name: "Identifier",
  																			src: "16147:3:3"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2200,
  																				type: "uint256",
  																				value: "max"
  																			},
  																			id: 2209,
  																			name: "Identifier",
  																			src: "16154:3:3"
  																		}
  																	],
  																	id: 2210,
  																	name: "BinaryOperation",
  																	src: "16147:10:3"
  																},
  																{
  																	attributes: {
  																		hexvalue: "5472757374206c696d6974206578636565646564",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "string",
  																		type: "literal_string \"Trust limit exceeded\"",
  																		value: "Trust limit exceeded"
  																	},
  																	id: 2211,
  																	name: "Literal",
  																	src: "16159:22:3"
  																}
  															],
  															id: 2212,
  															name: "FunctionCall",
  															src: "16139:43:3"
  														}
  													],
  													id: 2213,
  													name: "ExpressionStatement",
  													src: "16139:43:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "tuple()",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1926,
  																		type: "function (address,address,uint256)",
  																		value: "buildValidationData"
  																	},
  																	id: 2214,
  																	name: "Identifier",
  																	src: "16197:19:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2176,
  																		type: "address",
  																		value: "src"
  																	},
  																	id: 2215,
  																	name: "Identifier",
  																	src: "16217:3:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2182,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 2216,
  																	name: "Identifier",
  																	src: "16222:4:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2194,
  																		type: "uint256",
  																		value: "wad"
  																	},
  																	id: 2217,
  																	name: "Identifier",
  																	src: "16228:3:3"
  																}
  															],
  															id: 2218,
  															name: "FunctionCall",
  															src: "16197:35:3"
  														}
  													],
  													id: 2219,
  													name: "ExpressionStatement",
  													src: "16197:35:3"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "bool",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "hubTransfer",
  																		referencedDeclaration: 2732,
  																		type: "function (address,address,uint256) external returns (bool)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: true,
  																				isPure: false,
  																				lValueRequested: false,
  																				type: "contract Token"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 1160,
  																						type: "mapping(address => contract Token)",
  																						value: "userToToken"
  																					},
  																					id: 2220,
  																					name: "Identifier",
  																					src: "16363:11:3"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2188,
  																						type: "address",
  																						value: "token"
  																					},
  																					id: 2221,
  																					name: "Identifier",
  																					src: "16375:5:3"
  																				}
  																			],
  																			id: 2222,
  																			name: "IndexAccess",
  																			src: "16363:18:3"
  																		}
  																	],
  																	id: 2223,
  																	name: "MemberAccess",
  																	src: "16363:30:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2176,
  																		type: "address",
  																		value: "src"
  																	},
  																	id: 2224,
  																	name: "Identifier",
  																	src: "16394:3:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2182,
  																		type: "address",
  																		value: "dest"
  																	},
  																	id: 2225,
  																	name: "Identifier",
  																	src: "16399:4:3"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2194,
  																		type: "uint256",
  																		value: "wad"
  																	},
  																	id: 2226,
  																	name: "Identifier",
  																	src: "16405:3:3"
  																}
  															],
  															id: 2227,
  															name: "FunctionCall",
  															src: "16363:46:3"
  														}
  													],
  													id: 2228,
  													name: "ExpressionStatement",
  													src: "16363:46:3"
  												}
  											],
  											id: 2229,
  											name: "Block",
  											src: "15846:574:3"
  										}
  									],
  									id: 2230,
  									name: "ForStatement",
  									src: "15807:613:3"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2121,
  														type: "function (uint256)",
  														value: "validateTransferThrough"
  													},
  													id: 2231,
  													name: "Identifier",
  													src: "16489:23:3"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "length",
  														type: "uint256"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2128,
  																type: "address[] memory",
  																value: "srcs"
  															},
  															id: 2232,
  															name: "Identifier",
  															src: "16513:4:3"
  														}
  													],
  													id: 2233,
  													name: "MemberAccess",
  													src: "16513:11:3"
  												}
  											],
  											id: 2234,
  											name: "FunctionCall",
  											src: "16489:36:3"
  										}
  									],
  									id: 2235,
  									name: "ExpressionStatement",
  									src: "16489:36:3"
  								}
  							],
  							id: 2236,
  							name: "Block",
  							src: "15451:1081:3"
  						}
  					],
  					id: 2237,
  					name: "FunctionDefinition",
  					src: "15284:1248:3"
  				}
  			],
  			id: 2238,
  			name: "ContractDefinition",
  			src: "133:16401:3"
  		}
  	],
  	id: 2239,
  	name: "SourceUnit",
  	src: "33:16503:3"
  };
  var compiler$1 = {
  	name: "solc",
  	version: "0.7.1+commit.f4a555be.Emscripten.clang"
  };
  var networks$1 = {
  };
  var schemaVersion$1 = "3.4.10";
  var updatedAt$1 = "2022-11-29T09:43:24.104Z";
  var devdoc$1 = {
  	kind: "dev",
  	methods: {
  		"checkSendLimit(address,address,address)": {
  			details: "the goal of this function is to always return a sensible number, it's used to validate transfer throughs, and also heavily in the graph/pathfinding services",
  			params: {
  				dest: "the recipient of the tokens",
  				src: "the sender of the tokens",
  				tokenOwner: "the safe/owner that the token was minted to"
  			},
  			returns: {
  				_0: "the amount of tokenowner's token src can send to dest"
  			}
  		},
  		"inflate(uint256,uint256)": {
  			details: "this is basically the calculation for compound interest, with some adjustments because of integer math",
  			params: {
  				_initial: "the starting issuance rate",
  				_periods: "the step to calculate the issuance rate as of"
  			},
  			returns: {
  				_0: "initial issuance rate as if interest (inflation) has been compounded period times"
  			}
  		},
  		"issuance()": {
  			details: "current issuance is the initial issuance inflated by the amount of inflation periods since the hub was deployed",
  			returns: {
  				_0: "current issuance rate"
  			}
  		},
  		"issuanceByStep(uint256)": {
  			params: {
  				_periods: "the step to calculate the issuance rate at"
  			},
  			returns: {
  				_0: "inflation rate as of the given period"
  			}
  		},
  		"organizationSignup()": {
  			details: "signup is permanent for organizations too, there's no way to unsignup"
  		},
  		"periods()": {
  			returns: {
  				_0: "the amount of periods since hub was deployed"
  			}
  		},
  		"pow(uint256,uint256)": {
  			details: "this is an implementation of exponentiation by squares",
  			params: {
  				base: "the base to be used in the calculation",
  				exponent: "the exponent to be used in the calculation"
  			},
  			returns: {
  				_0: "the result of the calculation"
  			}
  		},
  		"signup()": {
  			details: "signup is permanent, there's no way to unsignup"
  		},
  		"transferThrough(address[],address[],address[],uint256[])": {
  			details: "tokenOwners[0], srcs[0], dests[0], and wads[0] constitute a transaction step",
  			params: {
  				dests: "the recipient of each transaction step",
  				srcs: "the sender of each transaction step",
  				tokenOwners: "the owner of the tokens being sent in each transaction step",
  				wads: "the amount for each transaction step"
  			}
  		},
  		"trust(address,uint256)": {
  			details: "the trust graph is weighted and directed",
  			params: {
  				limit: "the amount this user is trusted, as a percentage of 100",
  				user: "the user to be trusted"
  			}
  		}
  	},
  	version: 1
  };
  var userdoc$1 = {
  	kind: "user",
  	methods: {
  		"checkSendLimit(address,address,address)": {
  			notice: "finds the maximum amount of a specific token that can be sent between two users"
  		},
  		"inflate(uint256,uint256)": {
  			notice: "find the current issuance rate for any initial issuance and amount of periods"
  		},
  		"issuance()": {
  			notice: "calculates the current issuance rate per second"
  		},
  		"issuanceByStep(uint256)": {
  			notice: "finds the inflation rate at a given inflation period"
  		},
  		"organizationSignup()": {
  			notice: "register an organization address with the hub and join the trust graph"
  		},
  		"periods()": {
  			notice: "helper function for finding the amount of inflation periods since this hub was deployed"
  		},
  		"signup()": {
  			notice: "signup to this circles hub - create a circles token and join the trust graph"
  		},
  		"transferThrough(address[],address[],address[],uint256[])": {
  			notice: "walks through tokenOwners, srcs, dests, and amounts array and executes transtive transfer"
  		},
  		"trust(address,uint256)": {
  			notice: "trust a user, calling this means you're able to receive tokens from this user transitively"
  		}
  	},
  	version: 1
  };
  var HubContract = {
  	contractName: contractName$2,
  	abi: abi$2,
  	metadata: metadata$1,
  	bytecode: bytecode$2,
  	deployedBytecode: deployedBytecode$2,
  	immutableReferences: immutableReferences$1,
  	sourceMap: sourceMap$1,
  	deployedSourceMap: deployedSourceMap$1,
  	source: source$1,
  	sourcePath: sourcePath$1,
  	ast: ast$1,
  	legacyAST: legacyAST$1,
  	compiler: compiler$1,
  	networks: networks$1,
  	schemaVersion: schemaVersion$1,
  	updatedAt: updatedAt$1,
  	devdoc: devdoc$1,
  	userdoc: userdoc$1
  };

  var _format = "hh-sol-artifact-1";
  var contractName$1 = "GnosisSafeProxyFactory";
  var sourceName = "contracts/proxies/GnosisSafeProxyFactory.sol";
  var abi$1 = [
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: false,
  				internalType: "contract GnosisSafeProxy",
  				name: "proxy",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "singleton",
  				type: "address"
  			}
  		],
  		name: "ProxyCreation",
  		type: "event"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "_singleton",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "initializer",
  				type: "bytes"
  			},
  			{
  				internalType: "uint256",
  				name: "saltNonce",
  				type: "uint256"
  			}
  		],
  		name: "calculateCreateProxyWithNonceAddress",
  		outputs: [
  			{
  				internalType: "contract GnosisSafeProxy",
  				name: "proxy",
  				type: "address"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "singleton",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "data",
  				type: "bytes"
  			}
  		],
  		name: "createProxy",
  		outputs: [
  			{
  				internalType: "contract GnosisSafeProxy",
  				name: "proxy",
  				type: "address"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "_singleton",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "initializer",
  				type: "bytes"
  			},
  			{
  				internalType: "uint256",
  				name: "saltNonce",
  				type: "uint256"
  			},
  			{
  				internalType: "contract IProxyCreationCallback",
  				name: "callback",
  				type: "address"
  			}
  		],
  		name: "createProxyWithCallback",
  		outputs: [
  			{
  				internalType: "contract GnosisSafeProxy",
  				name: "proxy",
  				type: "address"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "_singleton",
  				type: "address"
  			},
  			{
  				internalType: "bytes",
  				name: "initializer",
  				type: "bytes"
  			},
  			{
  				internalType: "uint256",
  				name: "saltNonce",
  				type: "uint256"
  			}
  		],
  		name: "createProxyWithNonce",
  		outputs: [
  			{
  				internalType: "contract GnosisSafeProxy",
  				name: "proxy",
  				type: "address"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "proxyCreationCode",
  		outputs: [
  			{
  				internalType: "bytes",
  				name: "",
  				type: "bytes"
  			}
  		],
  		stateMutability: "pure",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "proxyRuntimeCode",
  		outputs: [
  			{
  				internalType: "bytes",
  				name: "",
  				type: "bytes"
  			}
  		],
  		stateMutability: "pure",
  		type: "function"
  	}
  ];
  var bytecode$1 = "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";
  var deployedBytecode$1 = "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";
  var linkReferences = {
  };
  var deployedLinkReferences = {
  };
  var ProxyFactoryContract = {
  	_format: _format,
  	contractName: contractName$1,
  	sourceName: sourceName,
  	abi: abi$1,
  	bytecode: bytecode$1,
  	deployedBytecode: deployedBytecode$1,
  	linkReferences: linkReferences,
  	deployedLinkReferences: deployedLinkReferences
  };

  var contractName = "Token";
  var abi = [
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "_owner",
  				type: "address"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "constructor"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "spender",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			}
  		],
  		name: "Approval",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "from",
  				type: "address"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			}
  		],
  		name: "Transfer",
  		type: "event"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "spender",
  				type: "address"
  			}
  		],
  		name: "allowance",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "spender",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "approve",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "account",
  				type: "address"
  			}
  		],
  		name: "balanceOf",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "currentIssuance",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "decimals",
  		outputs: [
  			{
  				internalType: "uint8",
  				name: "",
  				type: "uint8"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "spender",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "subtractedValue",
  				type: "uint256"
  			}
  		],
  		name: "decreaseAllowance",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "hub",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "spender",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "addedValue",
  				type: "uint256"
  			}
  		],
  		name: "increaseAllowance",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "inflationOffset",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "lastTouched",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "owner",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "totalSupply",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "sender",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "recipient",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "transferFrom",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "time",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "symbol",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "name",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "period",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "periods",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "timeout",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "periodsWhenLastTouched",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "hubDeployedAt",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "stop",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "stopped",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "findInflationOffset",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "look",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		inputs: [
  		],
  		name: "update",
  		outputs: [
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "from",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "hubTransfer",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		inputs: [
  			{
  				internalType: "address",
  				name: "dst",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "wad",
  				type: "uint256"
  			}
  		],
  		name: "transfer",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		stateMutability: "nonpayable",
  		type: "function"
  	}
  ];
  var metadata = "{\"compiler\":{\"version\":\"0.7.1+commit.f4a555be\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_owner\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"spender\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"value\",\"type\":\"uint256\"}],\"name\":\"Approval\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"value\",\"type\":\"uint256\"}],\"name\":\"Transfer\",\"type\":\"event\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"spender\",\"type\":\"address\"}],\"name\":\"allowance\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"spender\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"approve\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"account\",\"type\":\"address\"}],\"name\":\"balanceOf\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"currentIssuance\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"decimals\",\"outputs\":[{\"internalType\":\"uint8\",\"name\":\"\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"spender\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"subtractedValue\",\"type\":\"uint256\"}],\"name\":\"decreaseAllowance\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"findInflationOffset\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"hub\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"hubDeployedAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"hubTransfer\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"spender\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"addedValue\",\"type\":\"uint256\"}],\"name\":\"increaseAllowance\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"inflationOffset\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"lastTouched\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"look\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"name\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"period\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"periods\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"periodsWhenLastTouched\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stop\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stopped\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"symbol\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"time\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeout\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"totalSupply\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"dst\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"wad\",\"type\":\"uint256\"}],\"name\":\"transfer\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"sender\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"recipient\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"transferFrom\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"update\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"allowance(address,address)\":{\"details\":\"See {IERC20-allowance}.\"},\"approve(address,uint256)\":{\"details\":\"See {IERC20-approve}. Requirements: - `spender` cannot be the zero address.\"},\"balanceOf(address)\":{\"details\":\"See {IERC20-balanceOf}.\"},\"decreaseAllowance(address,uint256)\":{\"details\":\"Atomically decreases the allowance granted to `spender` by the caller. This is an alternative to {approve} that can be used as a mitigation for problems described in {IERC20-approve}. Emits an {Approval} event indicating the updated allowance. Requirements: - `spender` cannot be the zero address. - `spender` must have allowance for the caller of at least `subtractedValue`.\"},\"findInflationOffset()\":{\"details\":\"ubi is payed out continuously between inflation steps\",\"returns\":{\"_0\":\"the amount of seconds until the next inflation step\"}},\"hubDeployedAt()\":{\"returns\":{\"_0\":\"the timestamp the hub was deployed at\"}},\"hubTransfer(address,address,uint256)\":{\"params\":{\"amount\":\"the amount of tokens to transfer\",\"from\":\"the address the tokens are being transfered from\",\"to\":\"the address the tokens are being transferred to\"}},\"increaseAllowance(address,uint256)\":{\"details\":\"Atomically increases the allowance granted to `spender` by the caller. This is an alternative to {approve} that can be used as a mitigation for problems described in {IERC20-approve}. Emits an {Approval} event indicating the updated allowance. Requirements: - `spender` cannot be the zero address.\"},\"look()\":{\"details\":\"is called in the update method to write the new balance to state, but also useful in wallets\",\"returns\":{\"_0\":\"how much ubi this token holder is owed\"}},\"name()\":{\"details\":\"all circles tokens should have the same name\",\"returns\":{\"_0\":\"the token name\"}},\"period()\":{\"returns\":{\"_0\":\"period length in seconds\"}},\"periods()\":{\"returns\":{\"_0\":\"the number of periods since the hub was deployed\"}},\"periodsWhenLastTouched()\":{\"details\":\"ie. if ubi was last payed out during the second inflation step, returns two\",\"returns\":{\"_0\":\"the inflation step by count\"}},\"stop()\":{\"details\":\"intended for use in case of key loss, system failure, or migration to new contracts\"},\"stopped()\":{\"details\":\"combines the manual stop variable with a dead man's switch\",\"returns\":{\"_0\":\"false is the token is still paying out ubi, otherwise true\"}},\"symbol()\":{\"details\":\"all circles tokens should have the same symbol\",\"returns\":{\"_0\":\"the token symbol\"}},\"time()\":{\"returns\":{\"_0\":\"the block timestamp\"}},\"timeout()\":{\"returns\":{\"_0\":\"the number of seconds the token can go without being updated before it's deactivated\"}},\"totalSupply()\":{\"details\":\"See {IERC20-totalSupply}.\"},\"transferFrom(address,address,uint256)\":{\"details\":\"See {IERC20-transferFrom}. Emits an {Approval} event indicating the updated allowance. This is not required by the EIP. See the note at the beginning of {ERC20}; Requirements: - `sender` and `recipient` cannot be the zero address. - `sender` must have a balance of at least `amount`. - the caller must have allowance for ``sender``'s tokens of at least `amount`.\"},\"update()\":{\"details\":\"this is the method to actually update storage with new token balance\"}},\"stateVariables\":{\"decimals\":{\"details\":\"Returns the number of decimals used to get its user representation. For example, if `decimals` equals `2`, a balance of `505` tokens should be displayed to a user as `5,05` (`505 / 10 ** 2`). Tokens usually opt for a value of 18, imitating the relationship between Ether and Wei. This is the value {ERC20} uses, unless {_setupDecimals} is called. NOTE: This information is only used for _display_ purposes: it in no way affects any of the arithmetic of the contract, including {IERC20-balanceOf} and {IERC20-transfer}.\"}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"findInflationOffset()\":{\"notice\":\"the amount of seconds until the ubi payout is next inflated\"},\"hubDeployedAt()\":{\"notice\":\"helper functio for getting the hub deployment time\"},\"hubTransfer(address,address,uint256)\":{\"notice\":\"special method called by the hub to execute a transitive transaction\"},\"look()\":{\"notice\":\"checks how much ubi this token holder is owed, but doesn't update their balance\"},\"name()\":{\"notice\":\"helper function for the token name\"},\"period()\":{\"notice\":\"helper function for fetching the period length from the hub\"},\"periods()\":{\"notice\":\"helper function for fetching the number of periods from the hub\"},\"periodsWhenLastTouched()\":{\"notice\":\"find the inflation step when ubi was last payed out\"},\"stop()\":{\"notice\":\"Caution! manually deactivates or stops this token, no ubi will be payed out after this is called\"},\"stopped()\":{\"notice\":\"checks whether this token has been either stopped manually, or whether it has timed out\"},\"symbol()\":{\"notice\":\"helper function for the token symbol\"},\"time()\":{\"notice\":\"helper function for block timestamp\"},\"timeout()\":{\"notice\":\"helper function for fetching the timeout from the hub\"},\"update()\":{\"notice\":\"receive a ubi payout\"}},\"version\":1}},\"settings\":{\"compilationTarget\":{\"project:/contracts/Token.sol\":\"Token\"},\"evmVersion\":\"istanbul\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":50},\"remappings\":[]},\"sources\":{\"@openzeppelin/contracts/math/SafeMath.sol\":{\"keccak256\":\"0xcc78a17dd88fa5a2edc60c8489e2f405c0913b377216a5b26b35656b2d0dab52\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://526dc85e1f9b9b45830e202568d267d93dde7a4fcccf4ad7798dadcd92304d3c\",\"dweb:/ipfs/QmaoXMB972J3cSDLtBq3xBo4jLwqD2uzXTwujtSPqkYVhR\"]},\"@openzeppelin/contracts/utils/Address.sol\":{\"keccak256\":\"0x28911e614500ae7c607a432a709d35da25f3bc5ddc8bd12b278b66358070c0ea\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://256c8c8af5eb072bc473226ab2b2187149b8fc04f5f4a4820db22527f5ce8e3c\",\"dweb:/ipfs/QmRvi5BhnL7Rxf85KrJhwM6RRhukm4tzoctRdgQEheNyiN\"]},\"project:/contracts/ERC20.sol\":{\"keccak256\":\"0xc6dbef9412a97afb7eadffbeccb8d48eec44b2a82fca4cbf8df5bace639ba5e7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://868329d2d2a6aa37bfb1b515e4b9de144c75ac537ff3f0aebe090e34a1e2c05c\",\"dweb:/ipfs/Qmb9HooNQfXYF1GF9FK9cTFRS7CziUZdtjQ56VFVyiLqy4\"]},\"project:/contracts/Token.sol\":{\"keccak256\":\"0x45bebcf11ae3349ac3f11ec3beb55450467b15c04decc38a5bfc5984361bab23\",\"license\":\"AGPL\",\"urls\":[\"bzz-raw://9607064f6816c0e0d2d3eb8c14d34ced7281cf67fd766ea351f8adc6b9cbea57\",\"dweb:/ipfs/QmQ9zLLDf8tbAMGMJs9ym8fLi7d8uMM8VSiXaSgPEUJvd5\"]},\"project:/contracts/interfaces/HubI.sol\":{\"keccak256\":\"0xe42ec83e641359f276de4f5e2dc5c6b906e18cd81b2c46e0323ac6eb81285deb\",\"license\":\"AGPL\",\"urls\":[\"bzz-raw://bfa0ba0a68e968bd0525bde11c760088ffb0f0ab30f39aa78e3ce272d1a932b3\",\"dweb:/ipfs/QmeadYT4y4mRDnadWaQaCyLrTUytmbUKyAMYQgLWMbXVHh\"]}},\"version\":1}";
  var bytecode = "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";
  var deployedBytecode = "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";
  var immutableReferences = {
  	"2309": [
  		{
  			length: 32,
  			start: 1708
  		}
  	],
  	"2315": [
  		{
  			length: 32,
  			start: 1417
  		},
  		{
  			length: 32,
  			start: 2492
  		},
  		{
  			length: 32,
  			start: 2756
  		}
  	]
  };
  var sourceMap = "165:7412:5:-:0;;;-1:-1:-1;;;228:45:5;;1086:299;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1086:299:5;-1:-1:-1;;;;;1132:20:5;;1124:29;;;;;;-1:-1:-1;;;;;;;1163:14:5;;;;;;1187:3;:16;;-1:-1:-1;;;;;;1187:16:5;1193:10;1187:16;;;1227:6;:4;:6::i;:::-;1213:11;:20;1261:21;:19;:21::i;:::-;1243:15;:39;1315:3;;1310:20;;;-1:-1:-1;;;1310:20:5;;;;-1:-1:-1;;;;;1315:3:5;;;;-1:-1:-1;;1310:20:5;;;;;;;;;;;;;;;1315:3;1310:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1310:20:5;1292:15;:38;1359:3;;1354:23;;;-1:-1:-1;;;1354:23:5;;;;1340:38;;1346:6;;-1:-1:-1;;;;;1359:3:5;;;;1354:21;;:23;;;;;1310:20;;1354:23;;;;;;;;1359:3;1354:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1354:23:5;1340:5;:38::i;:::-;1086:299;165:7412;;1479:85;1542:15;1479:85;:::o;4363:306::-;4415:7;;4566:53;4603:15;:13;:15::i;:::-;4567:30;4580:16;4594:1;4567:30;4580:7;:9::i;:::-;:13;;;;;;:16;;;;:::i;:::-;4567:8;:6;:8::i;:::-;:12;;;;;;:30;;;;:::i;4566:53::-;4529:91;-1:-1:-1;4637:25:5;4655:6;:4;:6::i;:::-;4637:13;:17;;;;;;:25;;;;:::i;:::-;4630:32;;;4363:306;:::o;7649:370:2:-;-1:-1:-1;;;;;7732:21:2;;7724:65;;;;;-1:-1:-1;;;7724:65:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;7800:49;7829:1;7833:7;7842:6;7800:20;:49::i;:::-;7875:24;7892:6;7875:12;;:16;;;;;;:24;;;;:::i;:::-;7860:12;:39;-1:-1:-1;;;;;7930:18:2;;:9;:18;;;;;;;;;;;;:30;;7953:6;;7930:22;;;;;:30;;:::i;:::-;-1:-1:-1;;;;;7909:18:2;;:9;:18;;;;;;;;;;;:51;;;;7975:37;;;;;;;7909:18;;:9;;7975:37;;;;;;;;;;7649:370;;:::o;3254:101:5:-;3331:3;;3326:22;;;-1:-1:-1;;;3326:22:5;;;;3300:7;;-1:-1:-1;;;;;3331:3:5;;-1:-1:-1;;3326:22:5;;;;;;;;;;;;;;3331:3;3326:22;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3326:22:5;;-1:-1:-1;3254:101:5;:::o;2423:92::-;2494:3;;2489:19;;;-1:-1:-1;;;2489:19:5;;;;2463:7;;-1:-1:-1;;;;;2494:3:5;;2489:17;;:19;;;;;;;;;;;;;;2494:3;2489:19;;;;;;;;;;2690:175:0;2748:7;2779:5;;;2802:6;;;;2794:46;;;;;-1:-1:-1;;;2794:46:0;;;;;;;;;;;;-1:-1:-1;;;2794:46:0;;;;;;;;;;;;;;;2857:1;-1:-1:-1;2690:175:0;;;;;:::o;2182:90:5:-;2252:3;;2247:18;;;-1:-1:-1;;;2247:18:5;;;;2221:7;;-1:-1:-1;;;;;2252:3:5;;-1:-1:-1;;2247:18:5;;;;;;;;;;;;;;2252:3;2247:18;;;;;;;;;;3538:215:0;3596:7;3619:6;3615:20;;-1:-1:-1;3634:1:0;3627:8;;3615:20;3657:5;;;3661:1;3657;:5;:1;3680:5;;;;;:10;3672:56;;;;-1:-1:-1;;;3672:56:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3136:155;3194:7;3226:1;3221;:6;;3213:49;;;;;-1:-1:-1;;;3213:49:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3279:5:0;;;3136:155::o;10511:92:2:-;;;;:::o;165:7412:5:-;;;;;;;;;;;;;;;;;";
  var deployedSourceMap = "165:7412:5:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1967:92;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3571:72;;;:::i;:::-;;4101:155:2;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;4101:155:2;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;2991:136:5;;;:::i;:::-;;;;;;;;;;;;;;;;507:30;;;:::i;1479:85::-;;;:::i;3146:89:2:-;;;:::i;7109:167:5:-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;7109:167:5;;;;;;;;;;;;;;;;;:::i;4716:304:2:-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;4716:304:2;;;;;;;;;;;;;;;;;:::i;228:45:5:-;;;:::i;:::-;;;;;;;;;;;;;;;;;;;352:18;;;:::i;:::-;;;;-1:-1:-1;;;;;352:18:5;;;;;;;;;;;;;;5415:211:2;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;5415:211:2;;;;;;;;:::i;3254:101:5:-;;;:::i;4363:306::-;;;:::i;4932:1370::-;;;:::i;3293:108:2:-;;;;;;;;;;;;;;;;-1:-1:-1;3293:108:2;-1:-1:-1;;;;;3293:108:2;;:::i;2692:92:5:-;;;:::i;3900:246::-;;;:::i;280:26::-;;;:::i;434:30::-;;;:::i;1716:105::-;;;:::i;6427:401::-;;;:::i;6113:262:2:-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;6113:262:2;;;;;;;;:::i;2423:92:5:-;;;:::i;7282:293::-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;7282:293:5;;;;;;;;:::i;598:30::-;;;:::i;3823:140:2:-;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;3823:140:2;;;;;;;;;;:::i;2182:90:5:-;;;:::i;1967:92::-;2041:3;;2036:16;;;-1:-1:-1;;;2036:16:5;;;;2004:13;;-1:-1:-1;;;;;2041:3:5;;-1:-1:-1;;2036:16:5;;;;;2041:3;;2036:16;;;;;;;2041:3;2036:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;2036:16:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;2036:16:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;2036:16:5;;;;;-1:-1:-1;;2036:16:5;;;;;;;;;;-1:-1:-1;2036:16:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2029:23;;1967:92;;:::o;3571:72::-;1042:10;-1:-1:-1;;;;;1056:5:5;1042:19;;1034:28;;;;;;3614:15:::1;:22:::0;;-1:-1:-1;;3614:22:5::1;3632:4;3614:22;::::0;;3571:72::o;4101:155:2:-;4175:4;4191:37;4200:10;4212:7;4221:6;4191:8;:37::i;:::-;-1:-1:-1;4245:4:2;4101:155;;;;;:::o;2991:136:5:-;3046:7;3072:48;3111:8;:6;:8::i;:::-;3073:32;3089:15;:13;:15::i;:::-;3073:11;;;:15;:32::i;:::-;3072:38;;:48::i;:::-;3065:55;;2991:136;:::o;507:30::-;;;;:::o;1479:85::-;1542:15;1479:85;:::o;3146:89:2:-;3216:12;;3146:89;:::o;7109:167:5:-;898:3;;7226:4;;-1:-1:-1;;;;;898:3:5;884:10;:17;876:26;;;;;;7242:27:::1;7252:4;7258:2;7262:6;7242:9;:27::i;:::-;7109:167:::0;;;;;:::o;4716:304:2:-;4813:4;4829:36;4839:6;4847:9;4858:6;4829:9;:36::i;:::-;4875:117;4884:6;4892:10;4904:87;4940:6;4904:87;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;4904:19:2;;;;;;-1:-1:-1;4904:19:2;;;;;;;;4924:10;4904:31;;;;;;;;;;:35;:87::i;:::-;4875:8;:117::i;:::-;-1:-1:-1;5009:4:2;4716:304;;;;;:::o;228:45:5:-;;;:::o;352:18::-;;;-1:-1:-1;;;;;352:18:5;;:::o;5415:211:2:-;5528:10;5503:4;5549:23;;;:11;:23;;;;;;;;-1:-1:-1;;;;;5549:32:2;;;;;;;;;;5503:4;;5519:79;;5549:32;;:48;;5586:10;5549:36;:48::i;3254:101:5:-;3331:3;;3326:22;;;-1:-1:-1;;;3326:22:5;;;;3300:7;;-1:-1:-1;;;;;3331:3:5;;-1:-1:-1;;3326:22:5;;;;;;;;;;;;;;3331:3;3326:22;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3326:22:5;;-1:-1:-1;3254:101:5;:::o;4363:306::-;4415:7;4529:21;4566:53;4603:15;:13;:15::i;:::-;4567:30;4580:16;4594:1;4580:9;:7;:9::i;:::-;:13;;:16::i;:::-;4567:8;:6;:8::i;:::-;:12;;:30::i;4566:53::-;4529:91;;4637:25;4655:6;:4;:6::i;:::-;4637:13;;:17;:25::i;:::-;4630:32;;;4363:306;:::o;4932:1370::-;4969:7;5062:9;:7;:9::i;:::-;5058:23;;;-1:-1:-1;5080:1:5;5073:8;;5058:23;5135:11;;5173:15;;5213;;5091:14;;5135:11;5173:15;5091:14;5250:24;:22;:24::i;:::-;5238:36;;5506:573;5534:6;:4;:6::i;:::-;5513:17;:5;5523:6;5513:9;:17::i;:::-;:27;5506:573;;5650:28;5661:16;:6;5672:4;5661:10;:16::i;:::-;5650:6;;:10;:28::i;:::-;5641:37;-1:-1:-1;5772:17:5;:5;5782:6;5772:9;:17::i;:::-;5764:25;;5868:8;:6;:8::i;:::-;5859:17;-1:-1:-1;5952:8:5;:1;5958;5952:5;:8::i;:::-;6046:3;;6041:27;;;-1:-1:-1;;;6041:27:5;;;;;;;;;;;;-1:-1:-1;;;;;;6046:3:5;;;;-1:-1:-1;;6041:27:5;;;;;;;;;;;;;;;6046:3;6041:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;6041:27:5;;-1:-1:-1;5506:573:5;;;6165:27;6195:17;6206:5;6195:6;:4;:6::i;:::-;:10;;:17::i;:::-;6165:47;-1:-1:-1;6231:41:5;6242:29;6165:47;6266:4;6242:23;:29::i;:::-;6231:6;;:10;:41::i;:::-;6222:50;-1:-1:-1;;;;;;;4932:1370:5;:::o;3293:108:2:-;-1:-1:-1;;;;;3376:18:2;3350:7;3376:18;;;;;;;;;;;;3293:108::o;2692:92:5:-;2763:3;;2758:19;;;-1:-1:-1;;;2758:19:5;;;;2732:7;;-1:-1:-1;;;;;2763:3:5;;2758:17;;:19;;;;;;;;;;;;;;2763:3;2758:19;;;;;;;;;;3900:246;3960:15;;3940:4;;3960:15;;3956:32;;;-1:-1:-1;3984:4:5;3977:11;;3956:32;3998:31;4032:23;4043:11;;4032:6;:4;:6::i;:23::-;3998:57;;4095:9;:7;:9::i;:::-;4069:23;:35;4065:52;;;4113:4;4106:11;;;;;4065:52;4134:5;4127:12;;;3900:246;:::o;280:26::-;;;;:::o;434:30::-;;;:::o;1716:105::-;1801:3;;1796:18;;;-1:-1:-1;;;1796:18:5;;;;1764:13;;-1:-1:-1;;;;;1801:3:5;;-1:-1:-1;;1796:18:5;;;;;1801:3;;1796:18;;;;;;;1801:3;1796:18;;;;;;;;;;6427:401;6462:12;6477:6;:4;:6::i;:::-;6462:21;-1:-1:-1;6555:8:5;;6551:271;;6672:21;:19;:21::i;:::-;6654:15;:39;6721:6;:4;:6::i;:::-;6707:11;:20;6764:3;;6759:20;;;-1:-1:-1;;;6759:20:5;;;;-1:-1:-1;;;;;6764:3:5;;;;-1:-1:-1;;6759:20:5;;;;;;;;;;;;;;;6764:3;6759:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;6759:20:5;6741:15;:38;6793:18;6799:5;6806:4;6793:5;:18::i;:::-;6427:401;:::o;6113:262:2:-;6206:4;6222:125;6231:10;6243:7;6252:94;6289:15;6252:94;;;;;;;;;;;;;;;;;6264:10;6252:23;;;;:11;:23;;;;;;;;-1:-1:-1;;;;;6252:32:2;;;;;;;;;;;;:36;:94::i;2423:92:5:-;2494:3;;2489:19;;;-1:-1:-1;;;2489:19:5;;;;2463:7;;-1:-1:-1;;;;;2494:3:5;;2489:17;;:19;;;;;;;;;;;;;;2494:3;2489:19;;;;;;;;;;7282:293;7351:4;7544:24;7559:3;7564;7544:14;:24::i;598:30::-;;;;:::o;3823:140:2:-;-1:-1:-1;;;;;3929:18:2;;;3903:7;3929:18;;;-1:-1:-1;3929:18:2;;;;;;;;:27;;;;;;;;;;;;;3823:140::o;2182:90:5:-;2252:3;;2247:18;;;-1:-1:-1;;;2247:18:5;;;;2221:7;;-1:-1:-1;;;;;2252:3:5;;-1:-1:-1;;2247:18:5;;;;;;;;;;;;;;2252:3;2247:18;;;;;;;;;;2690:175:0;2748:7;2779:5;;;2802:6;;;;2794:46;;;;;-1:-1:-1;;;2794:46:0;;;;;;;;;;;;-1:-1:-1;;;2794:46:0;;;;;;;;;;;;;;3538:215;3596:7;3619:6;3615:20;;-1:-1:-1;3634:1:0;3627:8;;3615:20;3657:5;;;3661:1;3657;:5;:1;3680:5;;;;;:10;3672:56;;;;-1:-1:-1;;;3672:56:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3136:155;3194:7;3226:1;3221;:6;;3213:49;;;;;-1:-1:-1;;;3213:49:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3279:5:0;;;3136:155::o;9173:340:2:-;-1:-1:-1;;;;;9274:19:2;;9266:68;;;;-1:-1:-1;;;9266:68:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;9352:21:2;;9344:68;;;;-1:-1:-1;;;9344:68:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;9423:18:2;;;;;;;-1:-1:-1;9423:18:2;;;;;;;;:27;;;;;;;;;;;;;:36;;;9474:32;;;;;;;;;;;;;;;;;9173:340;;;:::o;4217:150:0:-;4275:7;4306:1;4302;:5;4294:44;;;;;-1:-1:-1;;;4294:44:0;;;;;;;;;;;;-1:-1:-1;;;4294:44:0;;;;;;;;;;;;;;;4359:1;4355;:5;;;;;;;4217:150;-1:-1:-1;;;4217:150:0:o;6849:530:2:-;-1:-1:-1;;;;;6954:20:2;;6946:70;;;;-1:-1:-1;;;6946:70:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;7034:23:2;;7026:71;;;;-1:-1:-1;;;7026:71:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7108:47;7129:6;7137:9;7148:6;7108:20;:47::i;:::-;7186:71;7208:6;7186:71;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;7186:17:2;;:9;:17;;;;;;;;;;;;;:21;:71::i;:::-;-1:-1:-1;;;;;7166:17:2;;;:9;:17;;;;;;;;;;;:91;;;;7290:20;;;;;;;:32;;7315:6;7290:24;:32::i;:::-;-1:-1:-1;;;;;7267:20:2;;;:9;:20;;;;;;;;;;;;:55;;;;7337:35;;;;;;;7267:20;;7337:35;;;;;;;;;;;;;6849:530;;;:::o;5432:163:0:-;5518:7;5553:12;5545:6;;;;5537:29;;;;-1:-1:-1;;;5537:29:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;5537:29:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;5583:5:0;;;5432:163::o;7649:370:2:-;-1:-1:-1;;;;;7732:21:2;;7724:65;;;;;-1:-1:-1;;;7724:65:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;7800:49;7829:1;7833:7;7842:6;7800:20;:49::i;:::-;7875:12;;:24;;7892:6;7875:16;:24::i;:::-;7860:12;:39;-1:-1:-1;;;;;7930:18:2;;:9;:18;;;;;;;;;;;:30;;7953:6;7930:22;:30::i;:::-;-1:-1:-1;;;;;7909:18:2;;:9;:18;;;;;;;;;;;:51;;;;7975:37;;;;;;;7909:18;;:9;;7975:37;;;;;;;;;;7649:370;;:::o;3604:161::-;3681:4;3697:40;3707:10;3719:9;3730:6;3697:9;:40::i;10511:92::-;;;;:::o";
  var source = "// SPDX-License-Identifier: AGPL\npragma solidity ^0.7.0;\n\nimport \"@openzeppelin/contracts/math/SafeMath.sol\";\nimport \"./ERC20.sol\";\nimport \"./interfaces/HubI.sol\";\n\ncontract Token is ERC20 {\n    using SafeMath for uint256;\n\n    uint8 public immutable override decimals = 18;\n\n    uint256 public lastTouched; // the timestamp of the last ubi payout\n    address public hub; // the address of the hub this token was deployed through\n    address public immutable owner; // the safe that deployed this token\n    uint256 public inflationOffset; // the amount of seconds until the next inflation step\n    uint256 public currentIssuance; // issanceRate at the time this token was deployed\n    bool private manuallyStopped; // true if this token has been stopped by it's owner\n\n    /// @dev modifier allowing function to be only called through the hub\n    modifier onlyHub() {\n        require(msg.sender == hub);\n        _;\n    }\n\n    /// @dev modifier allowing function to be only called by the token owner\n    modifier onlyOwner() {\n        require(msg.sender == owner);\n        _;\n    }\n\n    constructor(address _owner) {\n        require(_owner != address(0));\n        owner = _owner;\n        hub = msg.sender;\n        lastTouched = time();\n        inflationOffset = findInflationOffset();\n        currentIssuance = HubI(hub).issuance();\n        _mint(_owner, HubI(hub).signupBonus());\n    }\n\n    /// @notice helper function for block timestamp\n    /// @return the block timestamp\n    function time() public view returns (uint256) {\n        return block.timestamp;\n    }\n\n    /// @notice helper function for the token symbol\n    /// @dev all circles tokens should have the same symbol\n    /// @return the token symbol\n    function symbol() public view override returns (string memory) {\n        return HubI(hub).symbol();\n    }\n\n    /// @notice helper function for the token name\n    /// @dev all circles tokens should have the same name\n    /// @return the token name\n    function name() public view returns (string memory) {\n        return HubI(hub).name();\n    }\n\n    /// @notice helper function for fetching the period length from the hub\n    /// @return period length in seconds\n    function period() public view returns (uint256) {\n        return HubI(hub).period();\n    }\n\n    /// @notice helper function for fetching the number of periods from the hub\n    /// @return the number of periods since the hub was deployed\n    function periods() public view returns (uint256) {\n        return HubI(hub).periods();\n    }\n\n    /// @notice helper function for fetching the timeout from the hub\n    /// @return the number of seconds the token can go without being updated before it's deactivated\n    function timeout() public view returns (uint256) {\n        return HubI(hub).timeout();\n    }\n\n    /// @notice find the inflation step when ubi was last payed out\n    /// @dev ie. if ubi was last payed out during the second inflation step, returns two\n    /// @return the inflation step by count\n    function periodsWhenLastTouched() public view returns (uint256) {\n        return (lastTouched.sub(hubDeployedAt())).div(period());\n    }\n\n    /// @notice helper functio for getting the hub deployment time\n    /// @return the timestamp the hub was deployed at\n    function hubDeployedAt() public view returns (uint256) {\n        return HubI(hub).deployedAt();\n    }\n\n    /// @notice Caution! manually deactivates or stops this token, no ubi will be payed out after this is called\n    /// @dev intended for use in case of key loss, system failure, or migration to new contracts\n    function stop() public onlyOwner {\n        manuallyStopped = true;\n    }\n\n    /// @notice checks whether this token has been either stopped manually, or whether it has timed out\n    /// @dev combines the manual stop variable with a dead man's switch\n    /// @return false is the token is still paying out ubi, otherwise true\n    function stopped() public view returns (bool) {\n        if (manuallyStopped) return true;\n        uint256 secondsSinceLastTouched = time().sub(lastTouched);\n        if (secondsSinceLastTouched > timeout()) return true;\n        return false;\n    }\n\n    /// @notice the amount of seconds until the ubi payout is next inflated\n    /// @dev ubi is payed out continuously between inflation steps\n    /// @return the amount of seconds until the next inflation step\n    function findInflationOffset() public view returns (uint256) {\n        // finds the timestamp of the next inflation step, and subtracts the current timestamp\n        uint256 nextInflation =\n            ((period().mul(periods().add(1))).add(hubDeployedAt()));\n        return nextInflation.sub(time());\n    }\n\n    /// @notice checks how much ubi this token holder is owed, but doesn't update their balance\n    /// @dev is called in the update method to write the new balance to state, but also useful in wallets\n    /// @return how much ubi this token holder is owed\n    function look() public view returns (uint256) {\n        // don't payout ubi if the token has been deactivated/stopped\n        if (stopped()) return 0;\n        uint256 payout = 0;\n        uint256 clock = lastTouched;\n        uint256 offset = inflationOffset;\n        uint256 rate = currentIssuance;\n        uint256 p = periodsWhenLastTouched();\n        // this while loop gets executed only when we're rolling over an inflation step\n        // in the course of a ubi payout aka while we have to pay out ubi for more time\n        // than lastTouched + inflationOffset\n        while (clock.add(offset) <= time()) {\n            // add the remaining offset time to the payout total at the current rate\n            payout = payout.add(offset.mul(rate));\n            // adjust clock to the timestamp of the next inflation step\n            clock = clock.add(offset);\n            // the offset is now the length of 1 period\n            offset = period();\n            // increment the period we are paying out for\n            p = p.add(1);\n            // find the issuance rate as of the next period\n            rate = HubI(hub).issuanceByStep(p);\n        }\n        // at this point, time() - clock should always be less than 1 period\n        uint256 timeSinceLastPayout = time().sub(clock);\n        payout = payout.add(timeSinceLastPayout.mul(rate));\n        return payout;\n    }\n\n    /// @notice receive a ubi payout\n    /// @dev this is the method to actually update storage with new token balance\n    function update() public {\n        uint256 gift = look();\n        // does nothing if there's no ubi to be payed out\n        if (gift > 0) {\n            // update the state variables used to calculate ubi, then mint\n            inflationOffset = findInflationOffset();\n            lastTouched = time();\n            currentIssuance = HubI(hub).issuance();\n            _mint(owner, gift);\n        }\n    }\n\n    /// @notice special method called by the hub to execute a transitive transaction\n    /// @param from the address the tokens are being transfered from\n    /// @param to the address the tokens are being transferred to\n    /// @param amount the amount of tokens to transfer\n    function hubTransfer(\n        address from,\n        address to,\n        uint256 amount\n    ) public onlyHub returns (bool) {\n        _transfer(from, to, amount);\n    }\n\n    function transfer(address dst, uint256 wad) public override returns (bool) {\n        // this code shouldn't be necessary, but when it's removed the gas estimation methods\n        // in the gnosis safe no longer work, still true as of solidity 7.1\n        return super.transfer(dst, wad);\n    }\n}\n";
  var sourcePath = "/home/ele/Documents/Berlin-Coop/CirclesUBI/circles-contracts/contracts/Token.sol";
  var ast = {
  	absolutePath: "project:/contracts/Token.sol",
  	exportedSymbols: {
  		Token: [
  			2750
  		]
  	},
  	id: 2751,
  	license: "AGPL",
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 2297,
  			literals: [
  				"solidity",
  				"^",
  				"0.7",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "33:23:5"
  		},
  		{
  			absolutePath: "@openzeppelin/contracts/math/SafeMath.sol",
  			file: "@openzeppelin/contracts/math/SafeMath.sol",
  			id: 2298,
  			nodeType: "ImportDirective",
  			scope: 2751,
  			sourceUnit: 355,
  			src: "58:51:5",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "project:/contracts/ERC20.sol",
  			file: "./ERC20.sol",
  			id: 2299,
  			nodeType: "ImportDirective",
  			scope: 2751,
  			sourceUnit: 1132,
  			src: "110:21:5",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "project:/contracts/interfaces/HubI.sol",
  			file: "./interfaces/HubI.sol",
  			id: 2300,
  			nodeType: "ImportDirective",
  			scope: 2751,
  			sourceUnit: 2918,
  			src: "132:31:5",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			abstract: false,
  			baseContracts: [
  				{
  					baseName: {
  						id: 2301,
  						name: "ERC20",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1131,
  						src: "183:5:5",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ERC20_$1131",
  							typeString: "contract ERC20"
  						}
  					},
  					id: 2302,
  					nodeType: "InheritanceSpecifier",
  					src: "183:5:5"
  				}
  			],
  			contractDependencies: [
  				1131
  			],
  			contractKind: "contract",
  			fullyImplemented: true,
  			id: 2750,
  			linearizedBaseContracts: [
  				2750,
  				1131
  			],
  			name: "Token",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 2305,
  					libraryName: {
  						id: 2303,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 354,
  						src: "201:8:5",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$354",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "195:27:5",
  					typeName: {
  						id: 2304,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "214:7:5",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					baseFunctions: [
  						713
  					],
  					constant: false,
  					functionSelector: "313ce567",
  					id: 2309,
  					mutability: "immutable",
  					name: "decimals",
  					nodeType: "VariableDeclaration",
  					overrides: {
  						id: 2307,
  						nodeType: "OverrideSpecifier",
  						overrides: [
  						],
  						src: "251:8:5"
  					},
  					scope: 2750,
  					src: "228:45:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint8",
  						typeString: "uint8"
  					},
  					typeName: {
  						id: 2306,
  						name: "uint8",
  						nodeType: "ElementaryTypeName",
  						src: "228:5:5",
  						typeDescriptions: {
  							typeIdentifier: "t_uint8",
  							typeString: "uint8"
  						}
  					},
  					value: {
  						hexValue: "3138",
  						id: 2308,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "271:2:5",
  						typeDescriptions: {
  							typeIdentifier: "t_rational_18_by_1",
  							typeString: "int_const 18"
  						},
  						value: "18"
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "8b4eed81",
  					id: 2311,
  					mutability: "mutable",
  					name: "lastTouched",
  					nodeType: "VariableDeclaration",
  					scope: 2750,
  					src: "280:26:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 2310,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "280:7:5",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "365a86fc",
  					id: 2313,
  					mutability: "mutable",
  					name: "hub",
  					nodeType: "VariableDeclaration",
  					scope: 2750,
  					src: "352:18:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_address",
  						typeString: "address"
  					},
  					typeName: {
  						id: 2312,
  						name: "address",
  						nodeType: "ElementaryTypeName",
  						src: "352:7:5",
  						stateMutability: "nonpayable",
  						typeDescriptions: {
  							typeIdentifier: "t_address",
  							typeString: "address"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "8da5cb5b",
  					id: 2315,
  					mutability: "immutable",
  					name: "owner",
  					nodeType: "VariableDeclaration",
  					scope: 2750,
  					src: "434:30:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_address",
  						typeString: "address"
  					},
  					typeName: {
  						id: 2314,
  						name: "address",
  						nodeType: "ElementaryTypeName",
  						src: "434:7:5",
  						stateMutability: "nonpayable",
  						typeDescriptions: {
  							typeIdentifier: "t_address",
  							typeString: "address"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "107129dd",
  					id: 2317,
  					mutability: "mutable",
  					name: "inflationOffset",
  					nodeType: "VariableDeclaration",
  					scope: 2750,
  					src: "507:30:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 2316,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "507:7:5",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					functionSelector: "d4048089",
  					id: 2319,
  					mutability: "mutable",
  					name: "currentIssuance",
  					nodeType: "VariableDeclaration",
  					scope: 2750,
  					src: "598:30:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 2318,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "598:7:5",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 2321,
  					mutability: "mutable",
  					name: "manuallyStopped",
  					nodeType: "VariableDeclaration",
  					scope: 2750,
  					src: "685:28:5",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_bool",
  						typeString: "bool"
  					},
  					typeName: {
  						id: 2320,
  						name: "bool",
  						nodeType: "ElementaryTypeName",
  						src: "685:4:5",
  						typeDescriptions: {
  							typeIdentifier: "t_bool",
  							typeString: "bool"
  						}
  					},
  					visibility: "private"
  				},
  				{
  					body: {
  						id: 2332,
  						nodeType: "Block",
  						src: "866:54:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 2328,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2325,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: -15,
  													src: "884:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 2326,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												src: "884:10:5",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												id: 2327,
  												name: "hub",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2313,
  												src: "898:3:5",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "884:17:5",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 2324,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "876:7:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 2329,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "876:26:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2330,
  								nodeType: "ExpressionStatement",
  								src: "876:26:5"
  							},
  							{
  								id: 2331,
  								nodeType: "PlaceholderStatement",
  								src: "912:1:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2322,
  						nodeType: "StructuredDocumentation",
  						src: "773:69:5",
  						text: "@dev modifier allowing function to be only called through the hub"
  					},
  					id: 2333,
  					name: "onlyHub",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 2323,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "863:2:5"
  					},
  					src: "847:73:5",
  					virtual: false,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 2344,
  						nodeType: "Block",
  						src: "1024:56:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 2340,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												expression: {
  													id: 2337,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: -15,
  													src: "1042:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 2338,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												src: "1042:10:5",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												id: 2339,
  												name: "owner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2315,
  												src: "1056:5:5",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "1042:19:5",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 2336,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "1034:7:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 2341,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1034:28:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2342,
  								nodeType: "ExpressionStatement",
  								src: "1034:28:5"
  							},
  							{
  								id: 2343,
  								nodeType: "PlaceholderStatement",
  								src: "1072:1:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2334,
  						nodeType: "StructuredDocumentation",
  						src: "926:72:5",
  						text: "@dev modifier allowing function to be only called by the token owner"
  					},
  					id: 2345,
  					name: "onlyOwner",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 2335,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1021:2:5"
  					},
  					src: "1003:77:5",
  					virtual: false,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 2395,
  						nodeType: "Block",
  						src: "1114:271:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 2356,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												id: 2351,
  												name: "_owner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2347,
  												src: "1132:6:5",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												"arguments": [
  													{
  														hexValue: "30",
  														id: 2354,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "1150:1:5",
  														typeDescriptions: {
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														},
  														value: "0"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_0_by_1",
  															typeString: "int_const 0"
  														}
  													],
  													id: 2353,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "1142:7:5",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: {
  														id: 2352,
  														name: "address",
  														nodeType: "ElementaryTypeName",
  														src: "1142:7:5",
  														typeDescriptions: {
  														}
  													}
  												},
  												id: 2355,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1142:10:5",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "1132:20:5",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 2350,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											-18,
  											-18
  										],
  										referencedDeclaration: -18,
  										src: "1124:7:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 2357,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1124:29:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2358,
  								nodeType: "ExpressionStatement",
  								src: "1124:29:5"
  							},
  							{
  								expression: {
  									id: 2361,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2359,
  										name: "owner",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2315,
  										src: "1163:5:5",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										id: 2360,
  										name: "_owner",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2347,
  										src: "1171:6:5",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									src: "1163:14:5",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 2362,
  								nodeType: "ExpressionStatement",
  								src: "1163:14:5"
  							},
  							{
  								expression: {
  									id: 2366,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2363,
  										name: "hub",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2313,
  										src: "1187:3:5",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										expression: {
  											id: 2364,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: -15,
  											src: "1193:3:5",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 2365,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										src: "1193:10:5",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "1187:16:5",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 2367,
  								nodeType: "ExpressionStatement",
  								src: "1187:16:5"
  							},
  							{
  								expression: {
  									id: 2371,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2368,
  										name: "lastTouched",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2311,
  										src: "1213:11:5",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											id: 2369,
  											name: "time",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2406,
  											src: "1227:4:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  												typeString: "function () view returns (uint256)"
  											}
  										},
  										id: 2370,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1227:6:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1213:20:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2372,
  								nodeType: "ExpressionStatement",
  								src: "1213:20:5"
  							},
  							{
  								expression: {
  									id: 2376,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2373,
  										name: "inflationOffset",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2317,
  										src: "1243:15:5",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											id: 2374,
  											name: "findInflationOffset",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2573,
  											src: "1261:19:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  												typeString: "function () view returns (uint256)"
  											}
  										},
  										id: 2375,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1261:21:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1243:39:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2377,
  								nodeType: "ExpressionStatement",
  								src: "1243:39:5"
  							},
  							{
  								expression: {
  									id: 2384,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2378,
  										name: "currentIssuance",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2319,
  										src: "1292:15:5",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											expression: {
  												"arguments": [
  													{
  														id: 2380,
  														name: "hub",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2313,
  														src: "1315:3:5",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													id: 2379,
  													name: "HubI",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2917,
  													src: "1310:4:5",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  														typeString: "type(contract HubI)"
  													}
  												},
  												id: 2381,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1310:9:5",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_HubI_$2917",
  													typeString: "contract HubI"
  												}
  											},
  											id: 2382,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "issuance",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2841,
  											src: "1310:18:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  												typeString: "function () view external returns (uint256)"
  											}
  										},
  										id: 2383,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1310:20:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1292:38:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2385,
  								nodeType: "ExpressionStatement",
  								src: "1292:38:5"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 2387,
  											name: "_owner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2347,
  											src: "1346:6:5",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												expression: {
  													"arguments": [
  														{
  															id: 2389,
  															name: "hub",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2313,
  															src: "1359:3:5",
  															typeDescriptions: {
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															}
  														],
  														id: 2388,
  														name: "HubI",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2917,
  														src: "1354:4:5",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  															typeString: "type(contract HubI)"
  														}
  													},
  													id: 2390,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "1354:9:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_HubI_$2917",
  														typeString: "contract HubI"
  													}
  												},
  												id: 2391,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "signupBonus",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2873,
  												src: "1354:21:5",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  													typeString: "function () view external returns (uint256)"
  												}
  											},
  											id: 2392,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "1354:23:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 2386,
  										name: "_mint",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1007,
  										src: "1340:5:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 2393,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1340:38:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2394,
  								nodeType: "ExpressionStatement",
  								src: "1340:38:5"
  							}
  						]
  					},
  					id: 2396,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2348,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2347,
  								mutability: "mutable",
  								name: "_owner",
  								nodeType: "VariableDeclaration",
  								scope: 2396,
  								src: "1098:14:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 2346,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1098:7:5",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1097:16:5"
  					},
  					returnParameters: {
  						id: 2349,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1114:0:5"
  					},
  					scope: 2750,
  					src: "1086:299:5",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2405,
  						nodeType: "Block",
  						src: "1525:39:5",
  						statements: [
  							{
  								expression: {
  									expression: {
  										id: 2402,
  										name: "block",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: -4,
  										src: "1542:5:5",
  										typeDescriptions: {
  											typeIdentifier: "t_magic_block",
  											typeString: "block"
  										}
  									},
  									id: 2403,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "timestamp",
  									nodeType: "MemberAccess",
  									src: "1542:15:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2401,
  								id: 2404,
  								nodeType: "Return",
  								src: "1535:22:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2397,
  						nodeType: "StructuredDocumentation",
  						src: "1391:83:5",
  						text: "@notice helper function for block timestamp\n @return the block timestamp"
  					},
  					functionSelector: "16ada547",
  					id: 2406,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "time",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2398,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1492:2:5"
  					},
  					returnParameters: {
  						id: 2401,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2400,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2406,
  								src: "1516:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2399,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "1516:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1515:9:5"
  					},
  					scope: 2750,
  					src: "1479:85:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					baseFunctions: [
  						704
  					],
  					body: {
  						id: 2419,
  						nodeType: "Block",
  						src: "1779:42:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											"arguments": [
  												{
  													id: 2414,
  													name: "hub",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2313,
  													src: "1801:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 2413,
  												name: "HubI",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2917,
  												src: "1796:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  													typeString: "type(contract HubI)"
  												}
  											},
  											id: 2415,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "1796:9:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_HubI_$2917",
  												typeString: "contract HubI"
  											}
  										},
  										id: 2416,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "symbol",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2892,
  										src: "1796:16:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_string_memory_ptr_$",
  											typeString: "function () view external returns (string memory)"
  										}
  									},
  									id: 2417,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1796:18:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_string_memory_ptr",
  										typeString: "string memory"
  									}
  								},
  								functionReturnParameters: 2412,
  								id: 2418,
  								nodeType: "Return",
  								src: "1789:25:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2407,
  						nodeType: "StructuredDocumentation",
  						src: "1570:141:5",
  						text: "@notice helper function for the token symbol\n @dev all circles tokens should have the same symbol\n @return the token symbol"
  					},
  					functionSelector: "95d89b41",
  					id: 2420,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "symbol",
  					nodeType: "FunctionDefinition",
  					overrides: {
  						id: 2409,
  						nodeType: "OverrideSpecifier",
  						overrides: [
  						],
  						src: "1746:8:5"
  					},
  					parameters: {
  						id: 2408,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1731:2:5"
  					},
  					returnParameters: {
  						id: 2412,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2411,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2420,
  								src: "1764:13:5",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 2410,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "1764:6:5",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "1763:15:5"
  					},
  					scope: 2750,
  					src: "1716:105:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2432,
  						nodeType: "Block",
  						src: "2019:40:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											"arguments": [
  												{
  													id: 2427,
  													name: "hub",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2313,
  													src: "2041:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 2426,
  												name: "HubI",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2917,
  												src: "2036:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  													typeString: "type(contract HubI)"
  												}
  											},
  											id: 2428,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2036:9:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_HubI_$2917",
  												typeString: "contract HubI"
  											}
  										},
  										id: 2429,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "name",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2897,
  										src: "2036:14:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_string_memory_ptr_$",
  											typeString: "function () view external returns (string memory)"
  										}
  									},
  									id: 2430,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2036:16:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_string_memory_ptr",
  										typeString: "string memory"
  									}
  								},
  								functionReturnParameters: 2425,
  								id: 2431,
  								nodeType: "Return",
  								src: "2029:23:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2421,
  						nodeType: "StructuredDocumentation",
  						src: "1827:135:5",
  						text: "@notice helper function for the token name\n @dev all circles tokens should have the same name\n @return the token name"
  					},
  					functionSelector: "06fdde03",
  					id: 2433,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "name",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2422,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1980:2:5"
  					},
  					returnParameters: {
  						id: 2425,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2424,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2433,
  								src: "2004:13:5",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 2423,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "2004:6:5",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2003:15:5"
  					},
  					scope: 2750,
  					src: "1967:92:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2445,
  						nodeType: "Block",
  						src: "2230:42:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											"arguments": [
  												{
  													id: 2440,
  													name: "hub",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2313,
  													src: "2252:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 2439,
  												name: "HubI",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2917,
  												src: "2247:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  													typeString: "type(contract HubI)"
  												}
  											},
  											id: 2441,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2247:9:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_HubI_$2917",
  												typeString: "contract HubI"
  											}
  										},
  										id: 2442,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "period",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2863,
  										src: "2247:16:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  											typeString: "function () view external returns (uint256)"
  										}
  									},
  									id: 2443,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2247:18:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2438,
  								id: 2444,
  								nodeType: "Return",
  								src: "2240:25:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2434,
  						nodeType: "StructuredDocumentation",
  						src: "2065:112:5",
  						text: "@notice helper function for fetching the period length from the hub\n @return period length in seconds"
  					},
  					functionSelector: "ef78d4fd",
  					id: 2446,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "period",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2435,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2197:2:5"
  					},
  					returnParameters: {
  						id: 2438,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2437,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2446,
  								src: "2221:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2436,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "2221:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2220:9:5"
  					},
  					scope: 2750,
  					src: "2182:90:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2458,
  						nodeType: "Block",
  						src: "2472:43:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											"arguments": [
  												{
  													id: 2453,
  													name: "hub",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2313,
  													src: "2494:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 2452,
  												name: "HubI",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2917,
  												src: "2489:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  													typeString: "type(contract HubI)"
  												}
  											},
  											id: 2454,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2489:9:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_HubI_$2917",
  												typeString: "contract HubI"
  											}
  										},
  										id: 2455,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "periods",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2868,
  										src: "2489:17:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  											typeString: "function () view external returns (uint256)"
  										}
  									},
  									id: 2456,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2489:19:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2451,
  								id: 2457,
  								nodeType: "Return",
  								src: "2482:26:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2447,
  						nodeType: "StructuredDocumentation",
  						src: "2278:140:5",
  						text: "@notice helper function for fetching the number of periods from the hub\n @return the number of periods since the hub was deployed"
  					},
  					functionSelector: "a4caeb42",
  					id: 2459,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "periods",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2448,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2439:2:5"
  					},
  					returnParameters: {
  						id: 2451,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2450,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2459,
  								src: "2463:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2449,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "2463:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2462:9:5"
  					},
  					scope: 2750,
  					src: "2423:92:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2471,
  						nodeType: "Block",
  						src: "2741:43:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											"arguments": [
  												{
  													id: 2466,
  													name: "hub",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2313,
  													src: "2763:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 2465,
  												name: "HubI",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2917,
  												src: "2758:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  													typeString: "type(contract HubI)"
  												}
  											},
  											id: 2467,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2758:9:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_HubI_$2917",
  												typeString: "contract HubI"
  											}
  										},
  										id: 2468,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "timeout",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2916,
  										src: "2758:17:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  											typeString: "function () view external returns (uint256)"
  										}
  									},
  									id: 2469,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2758:19:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2464,
  								id: 2470,
  								nodeType: "Return",
  								src: "2751:26:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2460,
  						nodeType: "StructuredDocumentation",
  						src: "2521:166:5",
  						text: "@notice helper function for fetching the timeout from the hub\n @return the number of seconds the token can go without being updated before it's deactivated"
  					},
  					functionSelector: "70dea79a",
  					id: 2472,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "timeout",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2461,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2708:2:5"
  					},
  					returnParameters: {
  						id: 2464,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2463,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2472,
  								src: "2732:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2462,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "2732:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "2731:9:5"
  					},
  					scope: 2750,
  					src: "2692:92:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2489,
  						nodeType: "Block",
  						src: "3055:72:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 2485,
  												name: "period",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2446,
  												src: "3111:6:5",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 2486,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3111:8:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											components: [
  												{
  													"arguments": [
  														{
  															"arguments": [
  															],
  															expression: {
  																argumentTypes: [
  																],
  																id: 2480,
  																name: "hubDeployedAt",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2503,
  																src: "3089:13:5",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  																	typeString: "function () view returns (uint256)"
  																}
  															},
  															id: 2481,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "3089:15:5",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															id: 2478,
  															name: "lastTouched",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2311,
  															src: "3073:11:5",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 2479,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sub",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 203,
  														src: "3073:15:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 2482,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "3073:32:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											id: 2483,
  											isConstant: false,
  											isInlineArray: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "TupleExpression",
  											src: "3072:34:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 2484,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 259,
  										src: "3072:38:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 2487,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3072:48:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2477,
  								id: 2488,
  								nodeType: "Return",
  								src: "3065:55:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2473,
  						nodeType: "StructuredDocumentation",
  						src: "2790:196:5",
  						text: "@notice find the inflation step when ubi was last payed out\n @dev ie. if ubi was last payed out during the second inflation step, returns two\n @return the inflation step by count"
  					},
  					functionSelector: "0b0aaf27",
  					id: 2490,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "periodsWhenLastTouched",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2474,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3022:2:5"
  					},
  					returnParameters: {
  						id: 2477,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2476,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2490,
  								src: "3046:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2475,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3046:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "3045:9:5"
  					},
  					scope: 2750,
  					src: "2991:136:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2502,
  						nodeType: "Block",
  						src: "3309:46:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											"arguments": [
  												{
  													id: 2497,
  													name: "hub",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2313,
  													src: "3331:3:5",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												],
  												id: 2496,
  												name: "HubI",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2917,
  												src: "3326:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  													typeString: "type(contract HubI)"
  												}
  											},
  											id: 2498,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3326:9:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_HubI_$2917",
  												typeString: "contract HubI"
  											}
  										},
  										id: 2499,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "deployedAt",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2902,
  										src: "3326:20:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  											typeString: "function () view external returns (uint256)"
  										}
  									},
  									id: 2500,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3326:22:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2495,
  								id: 2501,
  								nodeType: "Return",
  								src: "3319:29:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2491,
  						nodeType: "StructuredDocumentation",
  						src: "3133:116:5",
  						text: "@notice helper functio for getting the hub deployment time\n @return the timestamp the hub was deployed at"
  					},
  					functionSelector: "3b6fe91f",
  					id: 2503,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "hubDeployedAt",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2492,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3276:2:5"
  					},
  					returnParameters: {
  						id: 2495,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2494,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2503,
  								src: "3300:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2493,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "3300:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "3299:9:5"
  					},
  					scope: 2750,
  					src: "3254:101:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2513,
  						nodeType: "Block",
  						src: "3604:39:5",
  						statements: [
  							{
  								expression: {
  									id: 2511,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2509,
  										name: "manuallyStopped",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2321,
  										src: "3614:15:5",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										hexValue: "74727565",
  										id: 2510,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3632:4:5",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "true"
  									},
  									src: "3614:22:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2512,
  								nodeType: "ExpressionStatement",
  								src: "3614:22:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2504,
  						nodeType: "StructuredDocumentation",
  						src: "3361:205:5",
  						text: "@notice Caution! manually deactivates or stops this token, no ubi will be payed out after this is called\n @dev intended for use in case of key loss, system failure, or migration to new contracts"
  					},
  					functionSelector: "07da68f5",
  					id: 2514,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							id: 2507,
  							modifierName: {
  								id: 2506,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 2345,
  								src: "3594:9:5",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "3594:9:5"
  						}
  					],
  					name: "stop",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2505,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3584:2:5"
  					},
  					returnParameters: {
  						id: 2508,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3604:0:5"
  					},
  					scope: 2750,
  					src: "3571:72:5",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2541,
  						nodeType: "Block",
  						src: "3946:200:5",
  						statements: [
  							{
  								condition: {
  									id: 2520,
  									name: "manuallyStopped",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2321,
  									src: "3960:15:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2523,
  								nodeType: "IfStatement",
  								src: "3956:32:5",
  								trueBody: {
  									expression: {
  										hexValue: "74727565",
  										id: 2521,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3984:4:5",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "true"
  									},
  									functionReturnParameters: 2519,
  									id: 2522,
  									nodeType: "Return",
  									src: "3977:11:5"
  								}
  							},
  							{
  								assignments: [
  									2525
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2525,
  										mutability: "mutable",
  										name: "secondsSinceLastTouched",
  										nodeType: "VariableDeclaration",
  										scope: 2541,
  										src: "3998:31:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2524,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "3998:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2531,
  								initialValue: {
  									"arguments": [
  										{
  											id: 2529,
  											name: "lastTouched",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2311,
  											src: "4043:11:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 2526,
  												name: "time",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2406,
  												src: "4032:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 2527,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4032:6:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 2528,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sub",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 203,
  										src: "4032:10:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 2530,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4032:23:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3998:57:5"
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 2535,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 2532,
  										name: "secondsSinceLastTouched",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2525,
  										src: "4069:23:5",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											id: 2533,
  											name: "timeout",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2472,
  											src: "4095:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  												typeString: "function () view returns (uint256)"
  											}
  										},
  										id: 2534,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4095:9:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4069:35:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2538,
  								nodeType: "IfStatement",
  								src: "4065:52:5",
  								trueBody: {
  									expression: {
  										hexValue: "74727565",
  										id: 2536,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "bool",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "4113:4:5",
  										typeDescriptions: {
  											typeIdentifier: "t_bool",
  											typeString: "bool"
  										},
  										value: "true"
  									},
  									functionReturnParameters: 2519,
  									id: 2537,
  									nodeType: "Return",
  									src: "4106:11:5"
  								}
  							},
  							{
  								expression: {
  									hexValue: "66616c7365",
  									id: 2539,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "bool",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "4134:5:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									},
  									value: "false"
  								},
  								functionReturnParameters: 2519,
  								id: 2540,
  								nodeType: "Return",
  								src: "4127:12:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2515,
  						nodeType: "StructuredDocumentation",
  						src: "3649:246:5",
  						text: "@notice checks whether this token has been either stopped manually, or whether it has timed out\n @dev combines the manual stop variable with a dead man's switch\n @return false is the token is still paying out ubi, otherwise true"
  					},
  					functionSelector: "75f12b21",
  					id: 2542,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "stopped",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2516,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "3916:2:5"
  					},
  					returnParameters: {
  						id: 2519,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2518,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2542,
  								src: "3940:4:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 2517,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "3940:4:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "3939:6:5"
  					},
  					scope: 2750,
  					src: "3900:246:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2572,
  						nodeType: "Block",
  						src: "4424:245:5",
  						statements: [
  							{
  								assignments: [
  									2549
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2549,
  										mutability: "mutable",
  										name: "nextInflation",
  										nodeType: "VariableDeclaration",
  										scope: 2572,
  										src: "4529:21:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2548,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "4529:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2565,
  								initialValue: {
  									components: [
  										{
  											"arguments": [
  												{
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														id: 2561,
  														name: "hubDeployedAt",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2503,
  														src: "4603:13:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  															typeString: "function () view returns (uint256)"
  														}
  													},
  													id: 2562,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "4603:15:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													components: [
  														{
  															"arguments": [
  																{
  																	"arguments": [
  																		{
  																			hexValue: "31",
  																			id: 2556,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			kind: "number",
  																			lValueRequested: false,
  																			nodeType: "Literal",
  																			src: "4594:1:5",
  																			typeDescriptions: {
  																				typeIdentifier: "t_rational_1_by_1",
  																				typeString: "int_const 1"
  																			},
  																			value: "1"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_1_by_1",
  																				typeString: "int_const 1"
  																			}
  																		],
  																		expression: {
  																			"arguments": [
  																			],
  																			expression: {
  																				argumentTypes: [
  																				],
  																				id: 2553,
  																				name: "periods",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 2459,
  																				src: "4580:7:5",
  																				typeDescriptions: {
  																					typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  																					typeString: "function () view returns (uint256)"
  																				}
  																			},
  																			id: 2554,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			kind: "functionCall",
  																			lValueRequested: false,
  																			names: [
  																			],
  																			nodeType: "FunctionCall",
  																			src: "4580:9:5",
  																			tryCall: false,
  																			typeDescriptions: {
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		},
  																		id: 2555,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "add",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 181,
  																		src: "4580:13:5",
  																		typeDescriptions: {
  																			typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																			typeString: "function (uint256,uint256) pure returns (uint256)"
  																		}
  																	},
  																	id: 2557,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "functionCall",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "4580:16:5",
  																	tryCall: false,
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	"arguments": [
  																	],
  																	expression: {
  																		argumentTypes: [
  																		],
  																		id: 2550,
  																		name: "period",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 2446,
  																		src: "4567:6:5",
  																		typeDescriptions: {
  																			typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  																			typeString: "function () view returns (uint256)"
  																		}
  																	},
  																	id: 2551,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	kind: "functionCall",
  																	lValueRequested: false,
  																	names: [
  																	],
  																	nodeType: "FunctionCall",
  																	src: "4567:8:5",
  																	tryCall: false,
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 2552,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "mul",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 237,
  																src: "4567:12:5",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 2558,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "4567:30:5",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													id: 2559,
  													isConstant: false,
  													isInlineArray: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "TupleExpression",
  													src: "4566:32:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 2560,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "add",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 181,
  												src: "4566:36:5",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 2563,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4566:53:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									id: 2564,
  									isConstant: false,
  									isInlineArray: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "TupleExpression",
  									src: "4565:55:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "4529:91:5"
  							},
  							{
  								expression: {
  									"arguments": [
  										{
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 2568,
  												name: "time",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2406,
  												src: "4655:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 2569,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4655:6:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											id: 2566,
  											name: "nextInflation",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2549,
  											src: "4637:13:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 2567,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sub",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 203,
  										src: "4637:17:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 2570,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4637:25:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2547,
  								id: 2571,
  								nodeType: "Return",
  								src: "4630:32:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2543,
  						nodeType: "StructuredDocumentation",
  						src: "4152:206:5",
  						text: "@notice the amount of seconds until the ubi payout is next inflated\n @dev ubi is payed out continuously between inflation steps\n @return the amount of seconds until the next inflation step"
  					},
  					functionSelector: "41c30546",
  					id: 2573,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "findInflationOffset",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2544,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4391:2:5"
  					},
  					returnParameters: {
  						id: 2547,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2546,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2573,
  								src: "4415:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2545,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "4415:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "4414:9:5"
  					},
  					scope: 2750,
  					src: "4363:306:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2672,
  						nodeType: "Block",
  						src: "4978:1324:5",
  						statements: [
  							{
  								condition: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 2579,
  										name: "stopped",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2542,
  										src: "5062:7:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$__$returns$_t_bool_$",
  											typeString: "function () view returns (bool)"
  										}
  									},
  									id: 2580,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5062:9:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2583,
  								nodeType: "IfStatement",
  								src: "5058:23:5",
  								trueBody: {
  									expression: {
  										hexValue: "30",
  										id: 2581,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "5080:1:5",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 2578,
  									id: 2582,
  									nodeType: "Return",
  									src: "5073:8:5"
  								}
  							},
  							{
  								assignments: [
  									2585
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2585,
  										mutability: "mutable",
  										name: "payout",
  										nodeType: "VariableDeclaration",
  										scope: 2672,
  										src: "5091:14:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2584,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "5091:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2587,
  								initialValue: {
  									hexValue: "30",
  									id: 2586,
  									isConstant: false,
  									isLValue: false,
  									isPure: true,
  									kind: "number",
  									lValueRequested: false,
  									nodeType: "Literal",
  									src: "5108:1:5",
  									typeDescriptions: {
  										typeIdentifier: "t_rational_0_by_1",
  										typeString: "int_const 0"
  									},
  									value: "0"
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5091:18:5"
  							},
  							{
  								assignments: [
  									2589
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2589,
  										mutability: "mutable",
  										name: "clock",
  										nodeType: "VariableDeclaration",
  										scope: 2672,
  										src: "5119:13:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2588,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "5119:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2591,
  								initialValue: {
  									id: 2590,
  									name: "lastTouched",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2311,
  									src: "5135:11:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5119:27:5"
  							},
  							{
  								assignments: [
  									2593
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2593,
  										mutability: "mutable",
  										name: "offset",
  										nodeType: "VariableDeclaration",
  										scope: 2672,
  										src: "5156:14:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2592,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "5156:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2595,
  								initialValue: {
  									id: 2594,
  									name: "inflationOffset",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2317,
  									src: "5173:15:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5156:32:5"
  							},
  							{
  								assignments: [
  									2597
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2597,
  										mutability: "mutable",
  										name: "rate",
  										nodeType: "VariableDeclaration",
  										scope: 2672,
  										src: "5198:12:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2596,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "5198:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2599,
  								initialValue: {
  									id: 2598,
  									name: "currentIssuance",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2319,
  									src: "5213:15:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5198:30:5"
  							},
  							{
  								assignments: [
  									2601
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2601,
  										mutability: "mutable",
  										name: "p",
  										nodeType: "VariableDeclaration",
  										scope: 2672,
  										src: "5238:9:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2600,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "5238:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2604,
  								initialValue: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 2602,
  										name: "periodsWhenLastTouched",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2490,
  										src: "5250:22:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  											typeString: "function () view returns (uint256)"
  										}
  									},
  									id: 2603,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5250:24:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5238:36:5"
  							},
  							{
  								body: {
  									id: 2650,
  									nodeType: "Block",
  									src: "5542:537:5",
  									statements: [
  										{
  											expression: {
  												id: 2620,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2612,
  													name: "payout",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2585,
  													src: "5641:6:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  														{
  															"arguments": [
  																{
  																	id: 2617,
  																	name: "rate",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 2597,
  																	src: "5672:4:5",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																expression: {
  																	id: 2615,
  																	name: "offset",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 2593,
  																	src: "5661:6:5",
  																	typeDescriptions: {
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																},
  																id: 2616,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "mul",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 237,
  																src: "5661:10:5",
  																typeDescriptions: {
  																	typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																	typeString: "function (uint256,uint256) pure returns (uint256)"
  																}
  															},
  															id: 2618,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "functionCall",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "5661:16:5",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															id: 2613,
  															name: "payout",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2585,
  															src: "5650:6:5",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 2614,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 181,
  														src: "5650:10:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 2619,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "5650:28:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "5641:37:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2621,
  											nodeType: "ExpressionStatement",
  											src: "5641:37:5"
  										},
  										{
  											expression: {
  												id: 2627,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2622,
  													name: "clock",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2589,
  													src: "5764:5:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  														{
  															id: 2625,
  															name: "offset",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2593,
  															src: "5782:6:5",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															id: 2623,
  															name: "clock",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2589,
  															src: "5772:5:5",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 2624,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 181,
  														src: "5772:9:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 2626,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "5772:17:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "5764:25:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2628,
  											nodeType: "ExpressionStatement",
  											src: "5764:25:5"
  										},
  										{
  											expression: {
  												id: 2632,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2629,
  													name: "offset",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2593,
  													src: "5859:6:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														id: 2630,
  														name: "period",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2446,
  														src: "5868:6:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  															typeString: "function () view returns (uint256)"
  														}
  													},
  													id: 2631,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "5868:8:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "5859:17:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2633,
  											nodeType: "ExpressionStatement",
  											src: "5859:17:5"
  										},
  										{
  											expression: {
  												id: 2639,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2634,
  													name: "p",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2601,
  													src: "5948:1:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  														{
  															hexValue: "31",
  															id: 2637,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															kind: "number",
  															lValueRequested: false,
  															nodeType: "Literal",
  															src: "5958:1:5",
  															typeDescriptions: {
  																typeIdentifier: "t_rational_1_by_1",
  																typeString: "int_const 1"
  															},
  															value: "1"
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_rational_1_by_1",
  																typeString: "int_const 1"
  															}
  														],
  														expression: {
  															id: 2635,
  															name: "p",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2601,
  															src: "5952:1:5",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 2636,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 181,
  														src: "5952:5:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 2638,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "5952:8:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "5948:12:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2640,
  											nodeType: "ExpressionStatement",
  											src: "5948:12:5"
  										},
  										{
  											expression: {
  												id: 2648,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2641,
  													name: "rate",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2597,
  													src: "6034:4:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  														{
  															id: 2646,
  															name: "p",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2601,
  															src: "6066:1:5",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															"arguments": [
  																{
  																	id: 2643,
  																	name: "hub",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 2313,
  																	src: "6046:3:5",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																],
  																id: 2642,
  																name: "HubI",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2917,
  																src: "6041:4:5",
  																typeDescriptions: {
  																	typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  																	typeString: "type(contract HubI)"
  																}
  															},
  															id: 2644,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "typeConversion",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "6041:9:5",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_HubI_$2917",
  																typeString: "contract HubI"
  															}
  														},
  														id: 2645,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "issuanceByStep",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2848,
  														src: "6041:24:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_external_view$_t_uint256_$returns$_t_uint256_$",
  															typeString: "function (uint256) view external returns (uint256)"
  														}
  													},
  													id: 2647,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6041:27:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6034:34:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2649,
  											nodeType: "ExpressionStatement",
  											src: "6034:34:5"
  										}
  									]
  								},
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 2611,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										"arguments": [
  											{
  												id: 2607,
  												name: "offset",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2593,
  												src: "5523:6:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												id: 2605,
  												name: "clock",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2589,
  												src: "5513:5:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2606,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 181,
  											src: "5513:9:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 2608,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5513:17:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<=",
  									rightExpression: {
  										"arguments": [
  										],
  										expression: {
  											argumentTypes: [
  											],
  											id: 2609,
  											name: "time",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2406,
  											src: "5534:4:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  												typeString: "function () view returns (uint256)"
  											}
  										},
  										id: 2610,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5534:6:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5513:27:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2651,
  								nodeType: "WhileStatement",
  								src: "5506:573:5"
  							},
  							{
  								assignments: [
  									2653
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2653,
  										mutability: "mutable",
  										name: "timeSinceLastPayout",
  										nodeType: "VariableDeclaration",
  										scope: 2672,
  										src: "6165:27:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2652,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "6165:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2659,
  								initialValue: {
  									"arguments": [
  										{
  											id: 2657,
  											name: "clock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2589,
  											src: "6206:5:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 2654,
  												name: "time",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2406,
  												src: "6195:4:5",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 2655,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6195:6:5",
  											tryCall: false,
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 2656,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sub",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 203,
  										src: "6195:10:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 2658,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6195:17:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "6165:47:5"
  							},
  							{
  								expression: {
  									id: 2668,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										id: 2660,
  										name: "payout",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2585,
  										src: "6222:6:5",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										"arguments": [
  											{
  												"arguments": [
  													{
  														id: 2665,
  														name: "rate",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2597,
  														src: "6266:4:5",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														id: 2663,
  														name: "timeSinceLastPayout",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2653,
  														src: "6242:19:5",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 2664,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "mul",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 237,
  													src: "6242:23:5",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 2666,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6242:29:5",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												id: 2661,
  												name: "payout",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2585,
  												src: "6231:6:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2662,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 181,
  											src: "6231:10:5",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 2667,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "6231:41:5",
  										tryCall: false,
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6222:50:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2669,
  								nodeType: "ExpressionStatement",
  								src: "6222:50:5"
  							},
  							{
  								expression: {
  									id: 2670,
  									name: "payout",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 2585,
  									src: "6289:6:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 2578,
  								id: 2671,
  								nodeType: "Return",
  								src: "6282:13:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2574,
  						nodeType: "StructuredDocumentation",
  						src: "4675:252:5",
  						text: "@notice checks how much ubi this token holder is owed, but doesn't update their balance\n @dev is called in the update method to write the new balance to state, but also useful in wallets\n @return how much ubi this token holder is owed"
  					},
  					functionSelector: "6c050eae",
  					id: 2673,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "look",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2575,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4945:2:5"
  					},
  					returnParameters: {
  						id: 2578,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2577,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2673,
  								src: "4969:7:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2576,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "4969:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "4968:9:5"
  					},
  					scope: 2750,
  					src: "4932:1370:5",
  					stateMutability: "view",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2710,
  						nodeType: "Block",
  						src: "6452:376:5",
  						statements: [
  							{
  								assignments: [
  									2678
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 2678,
  										mutability: "mutable",
  										name: "gift",
  										nodeType: "VariableDeclaration",
  										scope: 2710,
  										src: "6462:12:5",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 2677,
  											name: "uint256",
  											nodeType: "ElementaryTypeName",
  											src: "6462:7:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										visibility: "internal"
  									}
  								],
  								id: 2681,
  								initialValue: {
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 2679,
  										name: "look",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2673,
  										src: "6477:4:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  											typeString: "function () view returns (uint256)"
  										}
  									},
  									id: 2680,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6477:6:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "6462:21:5"
  							},
  							{
  								condition: {
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 2684,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										id: 2682,
  										name: "gift",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2678,
  										src: "6555:4:5",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										hexValue: "30",
  										id: 2683,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "6562:1:5",
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "6555:8:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								id: 2709,
  								nodeType: "IfStatement",
  								src: "6551:271:5",
  								trueBody: {
  									id: 2708,
  									nodeType: "Block",
  									src: "6565:257:5",
  									statements: [
  										{
  											expression: {
  												id: 2688,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2685,
  													name: "inflationOffset",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2317,
  													src: "6654:15:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														id: 2686,
  														name: "findInflationOffset",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2573,
  														src: "6672:19:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  															typeString: "function () view returns (uint256)"
  														}
  													},
  													id: 2687,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6672:21:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6654:39:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2689,
  											nodeType: "ExpressionStatement",
  											src: "6654:39:5"
  										},
  										{
  											expression: {
  												id: 2693,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2690,
  													name: "lastTouched",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2311,
  													src: "6707:11:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														id: 2691,
  														name: "time",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2406,
  														src: "6721:4:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  															typeString: "function () view returns (uint256)"
  														}
  													},
  													id: 2692,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6721:6:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6707:20:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2694,
  											nodeType: "ExpressionStatement",
  											src: "6707:20:5"
  										},
  										{
  											expression: {
  												id: 2701,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													id: 2695,
  													name: "currentIssuance",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2319,
  													src: "6741:15:5",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													"arguments": [
  													],
  													expression: {
  														argumentTypes: [
  														],
  														expression: {
  															"arguments": [
  																{
  																	id: 2697,
  																	name: "hub",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 2313,
  																	src: "6764:3:5",
  																	typeDescriptions: {
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																}
  															],
  															expression: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_address",
  																		typeString: "address"
  																	}
  																],
  																id: 2696,
  																name: "HubI",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2917,
  																src: "6759:4:5",
  																typeDescriptions: {
  																	typeIdentifier: "t_type$_t_contract$_HubI_$2917_$",
  																	typeString: "type(contract HubI)"
  																}
  															},
  															id: 2698,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															kind: "typeConversion",
  															lValueRequested: false,
  															names: [
  															],
  															nodeType: "FunctionCall",
  															src: "6759:9:5",
  															tryCall: false,
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_HubI_$2917",
  																typeString: "contract HubI"
  															}
  														},
  														id: 2699,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "issuance",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2841,
  														src: "6759:18:5",
  														typeDescriptions: {
  															typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  															typeString: "function () view external returns (uint256)"
  														}
  													},
  													id: 2700,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6759:20:5",
  													tryCall: false,
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6741:38:5",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 2702,
  											nodeType: "ExpressionStatement",
  											src: "6741:38:5"
  										},
  										{
  											expression: {
  												"arguments": [
  													{
  														id: 2704,
  														name: "owner",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2315,
  														src: "6799:5:5",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													{
  														id: 2705,
  														name: "gift",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2678,
  														src: "6806:4:5",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													id: 2703,
  													name: "_mint",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1007,
  													src: "6793:5:5",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  														typeString: "function (address,uint256)"
  													}
  												},
  												id: 2706,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6793:18:5",
  												tryCall: false,
  												typeDescriptions: {
  													typeIdentifier: "t_tuple$__$",
  													typeString: "tuple()"
  												}
  											},
  											id: 2707,
  											nodeType: "ExpressionStatement",
  											src: "6793:18:5"
  										}
  									]
  								}
  							}
  						]
  					},
  					documentation: {
  						id: 2674,
  						nodeType: "StructuredDocumentation",
  						src: "6308:114:5",
  						text: "@notice receive a ubi payout\n @dev this is the method to actually update storage with new token balance"
  					},
  					functionSelector: "a2e62045",
  					id: 2711,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "update",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2675,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "6442:2:5"
  					},
  					returnParameters: {
  						id: 2676,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "6452:0:5"
  					},
  					scope: 2750,
  					src: "6427:401:5",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2731,
  						nodeType: "Block",
  						src: "7232:44:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 2726,
  											name: "from",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2714,
  											src: "7252:4:5",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											id: 2727,
  											name: "to",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2716,
  											src: "7258:2:5",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											id: 2728,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2718,
  											src: "7262:6:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 2725,
  										name: "_transfer",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 952,
  										src: "7242:9:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 2729,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7242:27:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2730,
  								nodeType: "ExpressionStatement",
  								src: "7242:27:5"
  							}
  						]
  					},
  					documentation: {
  						id: 2712,
  						nodeType: "StructuredDocumentation",
  						src: "6834:270:5",
  						text: "@notice special method called by the hub to execute a transitive transaction\n @param from the address the tokens are being transfered from\n @param to the address the tokens are being transferred to\n @param amount the amount of tokens to transfer"
  					},
  					functionSelector: "20a6703c",
  					id: 2732,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							id: 2721,
  							modifierName: {
  								id: 2720,
  								name: "onlyHub",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 2333,
  								src: "7209:7:5",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "7209:7:5"
  						}
  					],
  					name: "hubTransfer",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2719,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2714,
  								mutability: "mutable",
  								name: "from",
  								nodeType: "VariableDeclaration",
  								scope: 2732,
  								src: "7139:12:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 2713,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7139:7:5",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2716,
  								mutability: "mutable",
  								name: "to",
  								nodeType: "VariableDeclaration",
  								scope: 2732,
  								src: "7161:10:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 2715,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7161:7:5",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2718,
  								mutability: "mutable",
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 2732,
  								src: "7181:14:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2717,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7181:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7129:72:5"
  					},
  					returnParameters: {
  						id: 2724,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2723,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2732,
  								src: "7226:4:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 2722,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "7226:4:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7225:6:5"
  					},
  					scope: 2750,
  					src: "7109:167:5",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				},
  				{
  					baseFunctions: [
  						755
  					],
  					body: {
  						id: 2748,
  						nodeType: "Block",
  						src: "7357:218:5",
  						statements: [
  							{
  								expression: {
  									"arguments": [
  										{
  											id: 2744,
  											name: "dst",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2734,
  											src: "7559:3:5",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											id: 2745,
  											name: "wad",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2736,
  											src: "7564:3:5",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											id: 2742,
  											name: "super",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: -25,
  											src: "7544:5:5",
  											typeDescriptions: {
  												typeIdentifier: "t_super$_Token_$2750",
  												typeString: "contract super Token"
  											}
  										},
  										id: 2743,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "transfer",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 755,
  										src: "7544:14:5",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
  											typeString: "function (address,uint256) returns (bool)"
  										}
  									},
  									id: 2746,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7544:24:5",
  									tryCall: false,
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								functionReturnParameters: 2741,
  								id: 2747,
  								nodeType: "Return",
  								src: "7537:31:5"
  							}
  						]
  					},
  					functionSelector: "a9059cbb",
  					id: 2749,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "transfer",
  					nodeType: "FunctionDefinition",
  					overrides: {
  						id: 2738,
  						nodeType: "OverrideSpecifier",
  						overrides: [
  						],
  						src: "7333:8:5"
  					},
  					parameters: {
  						id: 2737,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2734,
  								mutability: "mutable",
  								name: "dst",
  								nodeType: "VariableDeclaration",
  								scope: 2749,
  								src: "7300:11:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 2733,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "7300:7:5",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2736,
  								mutability: "mutable",
  								name: "wad",
  								nodeType: "VariableDeclaration",
  								scope: 2749,
  								src: "7313:11:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2735,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "7313:7:5",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7299:26:5"
  					},
  					returnParameters: {
  						id: 2741,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2740,
  								mutability: "mutable",
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 2749,
  								src: "7351:4:5",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_bool",
  									typeString: "bool"
  								},
  								typeName: {
  									id: 2739,
  									name: "bool",
  									nodeType: "ElementaryTypeName",
  									src: "7351:4:5",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								visibility: "internal"
  							}
  						],
  						src: "7350:6:5"
  					},
  					scope: 2750,
  					src: "7282:293:5",
  					stateMutability: "nonpayable",
  					virtual: false,
  					visibility: "public"
  				}
  			],
  			scope: 2751,
  			src: "165:7412:5"
  		}
  	],
  	src: "33:7545:5"
  };
  var legacyAST = {
  	attributes: {
  		absolutePath: "project:/contracts/Token.sol",
  		exportedSymbols: {
  			Token: [
  				2750
  			]
  		},
  		license: "AGPL"
  	},
  	children: [
  		{
  			attributes: {
  				literals: [
  					"solidity",
  					"^",
  					"0.7",
  					".0"
  				]
  			},
  			id: 2297,
  			name: "PragmaDirective",
  			src: "33:23:5"
  		},
  		{
  			attributes: {
  				SourceUnit: 355,
  				absolutePath: "@openzeppelin/contracts/math/SafeMath.sol",
  				file: "@openzeppelin/contracts/math/SafeMath.sol",
  				scope: 2751,
  				symbolAliases: [
  					null
  				],
  				unitAlias: ""
  			},
  			id: 2298,
  			name: "ImportDirective",
  			src: "58:51:5"
  		},
  		{
  			attributes: {
  				SourceUnit: 1132,
  				absolutePath: "project:/contracts/ERC20.sol",
  				file: "./ERC20.sol",
  				scope: 2751,
  				symbolAliases: [
  					null
  				],
  				unitAlias: ""
  			},
  			id: 2299,
  			name: "ImportDirective",
  			src: "110:21:5"
  		},
  		{
  			attributes: {
  				SourceUnit: 2918,
  				absolutePath: "project:/contracts/interfaces/HubI.sol",
  				file: "./interfaces/HubI.sol",
  				scope: 2751,
  				symbolAliases: [
  					null
  				],
  				unitAlias: ""
  			},
  			id: 2300,
  			name: "ImportDirective",
  			src: "132:31:5"
  		},
  		{
  			attributes: {
  				abstract: false,
  				contractDependencies: [
  					1131
  				],
  				contractKind: "contract",
  				fullyImplemented: true,
  				linearizedBaseContracts: [
  					2750,
  					1131
  				],
  				name: "Token",
  				scope: 2751
  			},
  			children: [
  				{
  					attributes: {
  					},
  					children: [
  						{
  							attributes: {
  								name: "ERC20",
  								referencedDeclaration: 1131,
  								type: "contract ERC20"
  							},
  							id: 2301,
  							name: "UserDefinedTypeName",
  							src: "183:5:5"
  						}
  					],
  					id: 2302,
  					name: "InheritanceSpecifier",
  					src: "183:5:5"
  				},
  				{
  					children: [
  						{
  							attributes: {
  								name: "SafeMath",
  								referencedDeclaration: 354,
  								type: "library SafeMath"
  							},
  							id: 2303,
  							name: "UserDefinedTypeName",
  							src: "201:8:5"
  						},
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 2304,
  							name: "ElementaryTypeName",
  							src: "214:7:5"
  						}
  					],
  					id: 2305,
  					name: "UsingForDirective",
  					src: "195:27:5"
  				},
  				{
  					attributes: {
  						baseFunctions: [
  							713
  						],
  						constant: false,
  						functionSelector: "313ce567",
  						mutability: "immutable",
  						name: "decimals",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint8",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint8",
  								type: "uint8"
  							},
  							id: 2306,
  							name: "ElementaryTypeName",
  							src: "228:5:5"
  						},
  						{
  							attributes: {
  								overrides: [
  									null
  								]
  							},
  							id: 2307,
  							name: "OverrideSpecifier",
  							src: "251:8:5"
  						},
  						{
  							attributes: {
  								hexvalue: "3138",
  								isConstant: false,
  								isLValue: false,
  								isPure: true,
  								lValueRequested: false,
  								token: "number",
  								type: "int_const 18",
  								value: "18"
  							},
  							id: 2308,
  							name: "Literal",
  							src: "271:2:5"
  						}
  					],
  					id: 2309,
  					name: "VariableDeclaration",
  					src: "228:45:5"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "8b4eed81",
  						mutability: "mutable",
  						name: "lastTouched",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 2310,
  							name: "ElementaryTypeName",
  							src: "280:7:5"
  						}
  					],
  					id: 2311,
  					name: "VariableDeclaration",
  					src: "280:26:5"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "365a86fc",
  						mutability: "mutable",
  						name: "hub",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "address",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "address",
  								stateMutability: "nonpayable",
  								type: "address"
  							},
  							id: 2312,
  							name: "ElementaryTypeName",
  							src: "352:7:5"
  						}
  					],
  					id: 2313,
  					name: "VariableDeclaration",
  					src: "352:18:5"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "8da5cb5b",
  						mutability: "immutable",
  						name: "owner",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "address",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "address",
  								stateMutability: "nonpayable",
  								type: "address"
  							},
  							id: 2314,
  							name: "ElementaryTypeName",
  							src: "434:7:5"
  						}
  					],
  					id: 2315,
  					name: "VariableDeclaration",
  					src: "434:30:5"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "107129dd",
  						mutability: "mutable",
  						name: "inflationOffset",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 2316,
  							name: "ElementaryTypeName",
  							src: "507:7:5"
  						}
  					],
  					id: 2317,
  					name: "VariableDeclaration",
  					src: "507:30:5"
  				},
  				{
  					attributes: {
  						constant: false,
  						functionSelector: "d4048089",
  						mutability: "mutable",
  						name: "currentIssuance",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "uint256",
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								name: "uint256",
  								type: "uint256"
  							},
  							id: 2318,
  							name: "ElementaryTypeName",
  							src: "598:7:5"
  						}
  					],
  					id: 2319,
  					name: "VariableDeclaration",
  					src: "598:30:5"
  				},
  				{
  					attributes: {
  						constant: false,
  						mutability: "mutable",
  						name: "manuallyStopped",
  						scope: 2750,
  						stateVariable: true,
  						storageLocation: "default",
  						type: "bool",
  						visibility: "private"
  					},
  					children: [
  						{
  							attributes: {
  								name: "bool",
  								type: "bool"
  							},
  							id: 2320,
  							name: "ElementaryTypeName",
  							src: "685:4:5"
  						}
  					],
  					id: 2321,
  					name: "VariableDeclaration",
  					src: "685:28:5"
  				},
  				{
  					attributes: {
  						name: "onlyHub",
  						virtual: false,
  						visibility: "internal"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@dev modifier allowing function to be only called through the hub"
  							},
  							id: 2322,
  							name: "StructuredDocumentation",
  							src: "773:69:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2323,
  							name: "ParameterList",
  							src: "863:2:5"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool) pure",
  														value: "require"
  													},
  													id: 2324,
  													name: "Identifier",
  													src: "876:7:5"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sender",
  																type: "address payable"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: -15,
  																		type: "msg",
  																		value: "msg"
  																	},
  																	id: 2325,
  																	name: "Identifier",
  																	src: "884:3:5"
  																}
  															],
  															id: 2326,
  															name: "MemberAccess",
  															src: "884:10:5"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2313,
  																type: "address",
  																value: "hub"
  															},
  															id: 2327,
  															name: "Identifier",
  															src: "898:3:5"
  														}
  													],
  													id: 2328,
  													name: "BinaryOperation",
  													src: "884:17:5"
  												}
  											],
  											id: 2329,
  											name: "FunctionCall",
  											src: "876:26:5"
  										}
  									],
  									id: 2330,
  									name: "ExpressionStatement",
  									src: "876:26:5"
  								},
  								{
  									id: 2331,
  									name: "PlaceholderStatement",
  									src: "912:1:5"
  								}
  							],
  							id: 2332,
  							name: "Block",
  							src: "866:54:5"
  						}
  					],
  					id: 2333,
  					name: "ModifierDefinition",
  					src: "847:73:5"
  				},
  				{
  					attributes: {
  						name: "onlyOwner",
  						virtual: false,
  						visibility: "internal"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@dev modifier allowing function to be only called by the token owner"
  							},
  							id: 2334,
  							name: "StructuredDocumentation",
  							src: "926:72:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2335,
  							name: "ParameterList",
  							src: "1021:2:5"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool) pure",
  														value: "require"
  													},
  													id: 2336,
  													name: "Identifier",
  													src: "1034:7:5"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "==",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "sender",
  																type: "address payable"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: -15,
  																		type: "msg",
  																		value: "msg"
  																	},
  																	id: 2337,
  																	name: "Identifier",
  																	src: "1042:3:5"
  																}
  															],
  															id: 2338,
  															name: "MemberAccess",
  															src: "1042:10:5"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2315,
  																type: "address",
  																value: "owner"
  															},
  															id: 2339,
  															name: "Identifier",
  															src: "1056:5:5"
  														}
  													],
  													id: 2340,
  													name: "BinaryOperation",
  													src: "1042:19:5"
  												}
  											],
  											id: 2341,
  											name: "FunctionCall",
  											src: "1034:28:5"
  										}
  									],
  									id: 2342,
  									name: "ExpressionStatement",
  									src: "1034:28:5"
  								},
  								{
  									id: 2343,
  									name: "PlaceholderStatement",
  									src: "1072:1:5"
  								}
  							],
  							id: 2344,
  							name: "Block",
  							src: "1024:56:5"
  						}
  					],
  					id: 2345,
  					name: "ModifierDefinition",
  					src: "1003:77:5"
  				},
  				{
  					attributes: {
  						implemented: true,
  						isConstructor: true,
  						kind: "constructor",
  						modifiers: [
  							null
  						],
  						name: "",
  						scope: 2750,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "_owner",
  										scope: 2396,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 2346,
  											name: "ElementaryTypeName",
  											src: "1098:7:5"
  										}
  									],
  									id: 2347,
  									name: "VariableDeclaration",
  									src: "1098:14:5"
  								}
  							],
  							id: 2348,
  							name: "ParameterList",
  							src: "1097:16:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2349,
  							name: "ParameterList",
  							src: "1114:0:5"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_bool",
  																typeString: "bool"
  															}
  														],
  														overloadedDeclarations: [
  															-18,
  															-18
  														],
  														referencedDeclaration: -18,
  														type: "function (bool) pure",
  														value: "require"
  													},
  													id: 2350,
  													name: "Identifier",
  													src: "1124:7:5"
  												},
  												{
  													attributes: {
  														commonType: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														},
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														operator: "!=",
  														type: "bool"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2347,
  																type: "address",
  																value: "_owner"
  															},
  															id: 2351,
  															name: "Identifier",
  															src: "1132:6:5"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: true,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "address payable",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_rational_0_by_1",
  																				typeString: "int_const 0"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		type: "type(address)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				name: "address"
  																			},
  																			id: 2352,
  																			name: "ElementaryTypeName",
  																			src: "1142:7:5"
  																		}
  																	],
  																	id: 2353,
  																	name: "ElementaryTypeNameExpression",
  																	src: "1142:7:5"
  																},
  																{
  																	attributes: {
  																		hexvalue: "30",
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: true,
  																		lValueRequested: false,
  																		token: "number",
  																		type: "int_const 0",
  																		value: "0"
  																	},
  																	id: 2354,
  																	name: "Literal",
  																	src: "1150:1:5"
  																}
  															],
  															id: 2355,
  															name: "FunctionCall",
  															src: "1142:10:5"
  														}
  													],
  													id: 2356,
  													name: "BinaryOperation",
  													src: "1132:20:5"
  												}
  											],
  											id: 2357,
  											name: "FunctionCall",
  											src: "1124:29:5"
  										}
  									],
  									id: 2358,
  									name: "ExpressionStatement",
  									src: "1124:29:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "address"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2315,
  														type: "address",
  														value: "owner"
  													},
  													id: 2359,
  													name: "Identifier",
  													src: "1163:5:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2347,
  														type: "address",
  														value: "_owner"
  													},
  													id: 2360,
  													name: "Identifier",
  													src: "1171:6:5"
  												}
  											],
  											id: 2361,
  											name: "Assignment",
  											src: "1163:14:5"
  										}
  									],
  									id: 2362,
  									name: "ExpressionStatement",
  									src: "1163:14:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "address"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2313,
  														type: "address",
  														value: "hub"
  													},
  													id: 2363,
  													name: "Identifier",
  													src: "1187:3:5"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sender",
  														type: "address payable"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -15,
  																type: "msg",
  																value: "msg"
  															},
  															id: 2364,
  															name: "Identifier",
  															src: "1193:3:5"
  														}
  													],
  													id: 2365,
  													name: "MemberAccess",
  													src: "1193:10:5"
  												}
  											],
  											id: 2366,
  											name: "Assignment",
  											src: "1187:16:5"
  										}
  									],
  									id: 2367,
  									name: "ExpressionStatement",
  									src: "1187:16:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2311,
  														type: "uint256",
  														value: "lastTouched"
  													},
  													id: 2368,
  													name: "Identifier",
  													src: "1213:11:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2406,
  																type: "function () view returns (uint256)",
  																value: "time"
  															},
  															id: 2369,
  															name: "Identifier",
  															src: "1227:4:5"
  														}
  													],
  													id: 2370,
  													name: "FunctionCall",
  													src: "1227:6:5"
  												}
  											],
  											id: 2371,
  											name: "Assignment",
  											src: "1213:20:5"
  										}
  									],
  									id: 2372,
  									name: "ExpressionStatement",
  									src: "1213:20:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2317,
  														type: "uint256",
  														value: "inflationOffset"
  													},
  													id: 2373,
  													name: "Identifier",
  													src: "1243:15:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2573,
  																type: "function () view returns (uint256)",
  																value: "findInflationOffset"
  															},
  															id: 2374,
  															name: "Identifier",
  															src: "1261:19:5"
  														}
  													],
  													id: 2375,
  													name: "FunctionCall",
  													src: "1261:21:5"
  												}
  											],
  											id: 2376,
  											name: "Assignment",
  											src: "1243:39:5"
  										}
  									],
  									id: 2377,
  									name: "ExpressionStatement",
  									src: "1243:39:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2319,
  														type: "uint256",
  														value: "currentIssuance"
  													},
  													id: 2378,
  													name: "Identifier",
  													src: "1292:15:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "issuance",
  																referencedDeclaration: 2841,
  																type: "function () view external returns (uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "contract HubI",
  																		type_conversion: true
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_address",
  																						typeString: "address"
  																					}
  																				],
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2917,
  																				type: "type(contract HubI)",
  																				value: "HubI"
  																			},
  																			id: 2379,
  																			name: "Identifier",
  																			src: "1310:4:5"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2313,
  																				type: "address",
  																				value: "hub"
  																			},
  																			id: 2380,
  																			name: "Identifier",
  																			src: "1315:3:5"
  																		}
  																	],
  																	id: 2381,
  																	name: "FunctionCall",
  																	src: "1310:9:5"
  																}
  															],
  															id: 2382,
  															name: "MemberAccess",
  															src: "1310:18:5"
  														}
  													],
  													id: 2383,
  													name: "FunctionCall",
  													src: "1310:20:5"
  												}
  											],
  											id: 2384,
  											name: "Assignment",
  											src: "1292:38:5"
  										}
  									],
  									id: 2385,
  									name: "ExpressionStatement",
  									src: "1292:38:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 1007,
  														type: "function (address,uint256)",
  														value: "_mint"
  													},
  													id: 2386,
  													name: "Identifier",
  													src: "1340:5:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2347,
  														type: "address",
  														value: "_owner"
  													},
  													id: 2387,
  													name: "Identifier",
  													src: "1346:6:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "signupBonus",
  																referencedDeclaration: 2873,
  																type: "function () view external returns (uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "contract HubI",
  																		type_conversion: true
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_address",
  																						typeString: "address"
  																					}
  																				],
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2917,
  																				type: "type(contract HubI)",
  																				value: "HubI"
  																			},
  																			id: 2388,
  																			name: "Identifier",
  																			src: "1354:4:5"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2313,
  																				type: "address",
  																				value: "hub"
  																			},
  																			id: 2389,
  																			name: "Identifier",
  																			src: "1359:3:5"
  																		}
  																	],
  																	id: 2390,
  																	name: "FunctionCall",
  																	src: "1354:9:5"
  																}
  															],
  															id: 2391,
  															name: "MemberAccess",
  															src: "1354:21:5"
  														}
  													],
  													id: 2392,
  													name: "FunctionCall",
  													src: "1354:23:5"
  												}
  											],
  											id: 2393,
  											name: "FunctionCall",
  											src: "1340:38:5"
  										}
  									],
  									id: 2394,
  									name: "ExpressionStatement",
  									src: "1340:38:5"
  								}
  							],
  							id: 2395,
  							name: "Block",
  							src: "1114:271:5"
  						}
  					],
  					id: 2396,
  					name: "FunctionDefinition",
  					src: "1086:299:5"
  				},
  				{
  					attributes: {
  						functionSelector: "16ada547",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "time",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for block timestamp\n @return the block timestamp"
  							},
  							id: 2397,
  							name: "StructuredDocumentation",
  							src: "1391:83:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2398,
  							name: "ParameterList",
  							src: "1492:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2406,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2399,
  											name: "ElementaryTypeName",
  											src: "1516:7:5"
  										}
  									],
  									id: 2400,
  									name: "VariableDeclaration",
  									src: "1516:7:5"
  								}
  							],
  							id: 2401,
  							name: "ParameterList",
  							src: "1515:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2401
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												member_name: "timestamp",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: -4,
  														type: "block",
  														value: "block"
  													},
  													id: 2402,
  													name: "Identifier",
  													src: "1542:5:5"
  												}
  											],
  											id: 2403,
  											name: "MemberAccess",
  											src: "1542:15:5"
  										}
  									],
  									id: 2404,
  									name: "Return",
  									src: "1535:22:5"
  								}
  							],
  							id: 2405,
  							name: "Block",
  							src: "1525:39:5"
  						}
  					],
  					id: 2406,
  					name: "FunctionDefinition",
  					src: "1479:85:5"
  				},
  				{
  					attributes: {
  						baseFunctions: [
  							704
  						],
  						functionSelector: "95d89b41",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "symbol",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for the token symbol\n @dev all circles tokens should have the same symbol\n @return the token symbol"
  							},
  							id: 2407,
  							name: "StructuredDocumentation",
  							src: "1570:141:5"
  						},
  						{
  							attributes: {
  								overrides: [
  									null
  								]
  							},
  							id: 2409,
  							name: "OverrideSpecifier",
  							src: "1746:8:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2408,
  							name: "ParameterList",
  							src: "1731:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2420,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "string",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "string",
  												type: "string"
  											},
  											id: 2410,
  											name: "ElementaryTypeName",
  											src: "1764:6:5"
  										}
  									],
  									id: 2411,
  									name: "VariableDeclaration",
  									src: "1764:13:5"
  								}
  							],
  							id: 2412,
  							name: "ParameterList",
  							src: "1763:15:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2412
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "string memory",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "symbol",
  														referencedDeclaration: 2892,
  														type: "function () view external returns (string memory)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "contract HubI",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2917,
  																		type: "type(contract HubI)",
  																		value: "HubI"
  																	},
  																	id: 2413,
  																	name: "Identifier",
  																	src: "1796:4:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2313,
  																		type: "address",
  																		value: "hub"
  																	},
  																	id: 2414,
  																	name: "Identifier",
  																	src: "1801:3:5"
  																}
  															],
  															id: 2415,
  															name: "FunctionCall",
  															src: "1796:9:5"
  														}
  													],
  													id: 2416,
  													name: "MemberAccess",
  													src: "1796:16:5"
  												}
  											],
  											id: 2417,
  											name: "FunctionCall",
  											src: "1796:18:5"
  										}
  									],
  									id: 2418,
  									name: "Return",
  									src: "1789:25:5"
  								}
  							],
  							id: 2419,
  							name: "Block",
  							src: "1779:42:5"
  						}
  					],
  					id: 2420,
  					name: "FunctionDefinition",
  					src: "1716:105:5"
  				},
  				{
  					attributes: {
  						functionSelector: "06fdde03",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "name",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for the token name\n @dev all circles tokens should have the same name\n @return the token name"
  							},
  							id: 2421,
  							name: "StructuredDocumentation",
  							src: "1827:135:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2422,
  							name: "ParameterList",
  							src: "1980:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2433,
  										stateVariable: false,
  										storageLocation: "memory",
  										type: "string",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "string",
  												type: "string"
  											},
  											id: 2423,
  											name: "ElementaryTypeName",
  											src: "2004:6:5"
  										}
  									],
  									id: 2424,
  									name: "VariableDeclaration",
  									src: "2004:13:5"
  								}
  							],
  							id: 2425,
  							name: "ParameterList",
  							src: "2003:15:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2425
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "string memory",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "name",
  														referencedDeclaration: 2897,
  														type: "function () view external returns (string memory)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "contract HubI",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2917,
  																		type: "type(contract HubI)",
  																		value: "HubI"
  																	},
  																	id: 2426,
  																	name: "Identifier",
  																	src: "2036:4:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2313,
  																		type: "address",
  																		value: "hub"
  																	},
  																	id: 2427,
  																	name: "Identifier",
  																	src: "2041:3:5"
  																}
  															],
  															id: 2428,
  															name: "FunctionCall",
  															src: "2036:9:5"
  														}
  													],
  													id: 2429,
  													name: "MemberAccess",
  													src: "2036:14:5"
  												}
  											],
  											id: 2430,
  											name: "FunctionCall",
  											src: "2036:16:5"
  										}
  									],
  									id: 2431,
  									name: "Return",
  									src: "2029:23:5"
  								}
  							],
  							id: 2432,
  							name: "Block",
  							src: "2019:40:5"
  						}
  					],
  					id: 2433,
  					name: "FunctionDefinition",
  					src: "1967:92:5"
  				},
  				{
  					attributes: {
  						functionSelector: "ef78d4fd",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "period",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for fetching the period length from the hub\n @return period length in seconds"
  							},
  							id: 2434,
  							name: "StructuredDocumentation",
  							src: "2065:112:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2435,
  							name: "ParameterList",
  							src: "2197:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2446,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2436,
  											name: "ElementaryTypeName",
  											src: "2221:7:5"
  										}
  									],
  									id: 2437,
  									name: "VariableDeclaration",
  									src: "2221:7:5"
  								}
  							],
  							id: 2438,
  							name: "ParameterList",
  							src: "2220:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2438
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "period",
  														referencedDeclaration: 2863,
  														type: "function () view external returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "contract HubI",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2917,
  																		type: "type(contract HubI)",
  																		value: "HubI"
  																	},
  																	id: 2439,
  																	name: "Identifier",
  																	src: "2247:4:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2313,
  																		type: "address",
  																		value: "hub"
  																	},
  																	id: 2440,
  																	name: "Identifier",
  																	src: "2252:3:5"
  																}
  															],
  															id: 2441,
  															name: "FunctionCall",
  															src: "2247:9:5"
  														}
  													],
  													id: 2442,
  													name: "MemberAccess",
  													src: "2247:16:5"
  												}
  											],
  											id: 2443,
  											name: "FunctionCall",
  											src: "2247:18:5"
  										}
  									],
  									id: 2444,
  									name: "Return",
  									src: "2240:25:5"
  								}
  							],
  							id: 2445,
  							name: "Block",
  							src: "2230:42:5"
  						}
  					],
  					id: 2446,
  					name: "FunctionDefinition",
  					src: "2182:90:5"
  				},
  				{
  					attributes: {
  						functionSelector: "a4caeb42",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "periods",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for fetching the number of periods from the hub\n @return the number of periods since the hub was deployed"
  							},
  							id: 2447,
  							name: "StructuredDocumentation",
  							src: "2278:140:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2448,
  							name: "ParameterList",
  							src: "2439:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2459,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2449,
  											name: "ElementaryTypeName",
  											src: "2463:7:5"
  										}
  									],
  									id: 2450,
  									name: "VariableDeclaration",
  									src: "2463:7:5"
  								}
  							],
  							id: 2451,
  							name: "ParameterList",
  							src: "2462:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2451
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "periods",
  														referencedDeclaration: 2868,
  														type: "function () view external returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "contract HubI",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2917,
  																		type: "type(contract HubI)",
  																		value: "HubI"
  																	},
  																	id: 2452,
  																	name: "Identifier",
  																	src: "2489:4:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2313,
  																		type: "address",
  																		value: "hub"
  																	},
  																	id: 2453,
  																	name: "Identifier",
  																	src: "2494:3:5"
  																}
  															],
  															id: 2454,
  															name: "FunctionCall",
  															src: "2489:9:5"
  														}
  													],
  													id: 2455,
  													name: "MemberAccess",
  													src: "2489:17:5"
  												}
  											],
  											id: 2456,
  											name: "FunctionCall",
  											src: "2489:19:5"
  										}
  									],
  									id: 2457,
  									name: "Return",
  									src: "2482:26:5"
  								}
  							],
  							id: 2458,
  							name: "Block",
  							src: "2472:43:5"
  						}
  					],
  					id: 2459,
  					name: "FunctionDefinition",
  					src: "2423:92:5"
  				},
  				{
  					attributes: {
  						functionSelector: "70dea79a",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "timeout",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper function for fetching the timeout from the hub\n @return the number of seconds the token can go without being updated before it's deactivated"
  							},
  							id: 2460,
  							name: "StructuredDocumentation",
  							src: "2521:166:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2461,
  							name: "ParameterList",
  							src: "2708:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2472,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2462,
  											name: "ElementaryTypeName",
  											src: "2732:7:5"
  										}
  									],
  									id: 2463,
  									name: "VariableDeclaration",
  									src: "2732:7:5"
  								}
  							],
  							id: 2464,
  							name: "ParameterList",
  							src: "2731:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2464
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "timeout",
  														referencedDeclaration: 2916,
  														type: "function () view external returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "contract HubI",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2917,
  																		type: "type(contract HubI)",
  																		value: "HubI"
  																	},
  																	id: 2465,
  																	name: "Identifier",
  																	src: "2758:4:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2313,
  																		type: "address",
  																		value: "hub"
  																	},
  																	id: 2466,
  																	name: "Identifier",
  																	src: "2763:3:5"
  																}
  															],
  															id: 2467,
  															name: "FunctionCall",
  															src: "2758:9:5"
  														}
  													],
  													id: 2468,
  													name: "MemberAccess",
  													src: "2758:17:5"
  												}
  											],
  											id: 2469,
  											name: "FunctionCall",
  											src: "2758:19:5"
  										}
  									],
  									id: 2470,
  									name: "Return",
  									src: "2751:26:5"
  								}
  							],
  							id: 2471,
  							name: "Block",
  							src: "2741:43:5"
  						}
  					],
  					id: 2472,
  					name: "FunctionDefinition",
  					src: "2692:92:5"
  				},
  				{
  					attributes: {
  						functionSelector: "0b0aaf27",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "periodsWhenLastTouched",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice find the inflation step when ubi was last payed out\n @dev ie. if ubi was last payed out during the second inflation step, returns two\n @return the inflation step by count"
  							},
  							id: 2473,
  							name: "StructuredDocumentation",
  							src: "2790:196:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2474,
  							name: "ParameterList",
  							src: "3022:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2490,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2475,
  											name: "ElementaryTypeName",
  											src: "3046:7:5"
  										}
  									],
  									id: 2476,
  									name: "VariableDeclaration",
  									src: "3046:7:5"
  								}
  							],
  							id: 2477,
  							name: "ParameterList",
  							src: "3045:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2477
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "div",
  														referencedDeclaration: 259,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isInlineArray: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "sub",
  																				referencedDeclaration: 203,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2311,
  																						type: "uint256",
  																						value: "lastTouched"
  																					},
  																					id: 2478,
  																					name: "Identifier",
  																					src: "3073:11:5"
  																				}
  																			],
  																			id: 2479,
  																			name: "MemberAccess",
  																			src: "3073:15:5"
  																		},
  																		{
  																			attributes: {
  																				"arguments": [
  																					null
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				isStructConstructorCall: false,
  																				lValueRequested: false,
  																				names: [
  																					null
  																				],
  																				tryCall: false,
  																				type: "uint256",
  																				type_conversion: false
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						argumentTypes: [
  																							null
  																						],
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2503,
  																						type: "function () view returns (uint256)",
  																						value: "hubDeployedAt"
  																					},
  																					id: 2480,
  																					name: "Identifier",
  																					src: "3089:13:5"
  																				}
  																			],
  																			id: 2481,
  																			name: "FunctionCall",
  																			src: "3089:15:5"
  																		}
  																	],
  																	id: 2482,
  																	name: "FunctionCall",
  																	src: "3073:32:5"
  																}
  															],
  															id: 2483,
  															name: "TupleExpression",
  															src: "3072:34:5"
  														}
  													],
  													id: 2484,
  													name: "MemberAccess",
  													src: "3072:38:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2446,
  																type: "function () view returns (uint256)",
  																value: "period"
  															},
  															id: 2485,
  															name: "Identifier",
  															src: "3111:6:5"
  														}
  													],
  													id: 2486,
  													name: "FunctionCall",
  													src: "3111:8:5"
  												}
  											],
  											id: 2487,
  											name: "FunctionCall",
  											src: "3072:48:5"
  										}
  									],
  									id: 2488,
  									name: "Return",
  									src: "3065:55:5"
  								}
  							],
  							id: 2489,
  							name: "Block",
  							src: "3055:72:5"
  						}
  					],
  					id: 2490,
  					name: "FunctionDefinition",
  					src: "2991:136:5"
  				},
  				{
  					attributes: {
  						functionSelector: "3b6fe91f",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "hubDeployedAt",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice helper functio for getting the hub deployment time\n @return the timestamp the hub was deployed at"
  							},
  							id: 2491,
  							name: "StructuredDocumentation",
  							src: "3133:116:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2492,
  							name: "ParameterList",
  							src: "3276:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2503,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2493,
  											name: "ElementaryTypeName",
  											src: "3300:7:5"
  										}
  									],
  									id: 2494,
  									name: "VariableDeclaration",
  									src: "3300:7:5"
  								}
  							],
  							id: 2495,
  							name: "ParameterList",
  							src: "3299:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2495
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "deployedAt",
  														referencedDeclaration: 2902,
  														type: "function () view external returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "contract HubI",
  																type_conversion: true
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2917,
  																		type: "type(contract HubI)",
  																		value: "HubI"
  																	},
  																	id: 2496,
  																	name: "Identifier",
  																	src: "3326:4:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2313,
  																		type: "address",
  																		value: "hub"
  																	},
  																	id: 2497,
  																	name: "Identifier",
  																	src: "3331:3:5"
  																}
  															],
  															id: 2498,
  															name: "FunctionCall",
  															src: "3326:9:5"
  														}
  													],
  													id: 2499,
  													name: "MemberAccess",
  													src: "3326:20:5"
  												}
  											],
  											id: 2500,
  											name: "FunctionCall",
  											src: "3326:22:5"
  										}
  									],
  									id: 2501,
  									name: "Return",
  									src: "3319:29:5"
  								}
  							],
  							id: 2502,
  							name: "Block",
  							src: "3309:46:5"
  						}
  					],
  					id: 2503,
  					name: "FunctionDefinition",
  					src: "3254:101:5"
  				},
  				{
  					attributes: {
  						functionSelector: "07da68f5",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						name: "stop",
  						scope: 2750,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice Caution! manually deactivates or stops this token, no ubi will be payed out after this is called\n @dev intended for use in case of key loss, system failure, or migration to new contracts"
  							},
  							id: 2504,
  							name: "StructuredDocumentation",
  							src: "3361:205:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2505,
  							name: "ParameterList",
  							src: "3584:2:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2508,
  							name: "ParameterList",
  							src: "3604:0:5"
  						},
  						{
  							attributes: {
  							},
  							children: [
  								{
  									attributes: {
  										overloadedDeclarations: [
  											null
  										],
  										referencedDeclaration: 2345,
  										type: "modifier ()",
  										value: "onlyOwner"
  									},
  									id: 2506,
  									name: "Identifier",
  									src: "3594:9:5"
  								}
  							],
  							id: 2507,
  							name: "ModifierInvocation",
  							src: "3594:9:5"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2321,
  														type: "bool",
  														value: "manuallyStopped"
  													},
  													id: 2509,
  													name: "Identifier",
  													src: "3614:15:5"
  												},
  												{
  													attributes: {
  														hexvalue: "74727565",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "bool",
  														type: "bool",
  														value: "true"
  													},
  													id: 2510,
  													name: "Literal",
  													src: "3632:4:5"
  												}
  											],
  											id: 2511,
  											name: "Assignment",
  											src: "3614:22:5"
  										}
  									],
  									id: 2512,
  									name: "ExpressionStatement",
  									src: "3614:22:5"
  								}
  							],
  							id: 2513,
  							name: "Block",
  							src: "3604:39:5"
  						}
  					],
  					id: 2514,
  					name: "FunctionDefinition",
  					src: "3571:72:5"
  				},
  				{
  					attributes: {
  						functionSelector: "75f12b21",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "stopped",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice checks whether this token has been either stopped manually, or whether it has timed out\n @dev combines the manual stop variable with a dead man's switch\n @return false is the token is still paying out ubi, otherwise true"
  							},
  							id: 2515,
  							name: "StructuredDocumentation",
  							src: "3649:246:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2516,
  							name: "ParameterList",
  							src: "3916:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2542,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "bool",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "bool",
  												type: "bool"
  											},
  											id: 2517,
  											name: "ElementaryTypeName",
  											src: "3940:4:5"
  										}
  									],
  									id: 2518,
  									name: "VariableDeclaration",
  									src: "3940:4:5"
  								}
  							],
  							id: 2519,
  							name: "ParameterList",
  							src: "3939:6:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												overloadedDeclarations: [
  													null
  												],
  												referencedDeclaration: 2321,
  												type: "bool",
  												value: "manuallyStopped"
  											},
  											id: 2520,
  											name: "Identifier",
  											src: "3960:15:5"
  										},
  										{
  											attributes: {
  												functionReturnParameters: 2519
  											},
  											children: [
  												{
  													attributes: {
  														hexvalue: "74727565",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "bool",
  														type: "bool",
  														value: "true"
  													},
  													id: 2521,
  													name: "Literal",
  													src: "3984:4:5"
  												}
  											],
  											id: 2522,
  											name: "Return",
  											src: "3977:11:5"
  										}
  									],
  									id: 2523,
  									name: "IfStatement",
  									src: "3956:32:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2525
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "secondsSinceLastTouched",
  												scope: 2541,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2524,
  													name: "ElementaryTypeName",
  													src: "3998:7:5"
  												}
  											],
  											id: 2525,
  											name: "VariableDeclaration",
  											src: "3998:31:5"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sub",
  														referencedDeclaration: 203,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																"arguments": [
  																	null
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			null
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2406,
  																		type: "function () view returns (uint256)",
  																		value: "time"
  																	},
  																	id: 2526,
  																	name: "Identifier",
  																	src: "4032:4:5"
  																}
  															],
  															id: 2527,
  															name: "FunctionCall",
  															src: "4032:6:5"
  														}
  													],
  													id: 2528,
  													name: "MemberAccess",
  													src: "4032:10:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2311,
  														type: "uint256",
  														value: "lastTouched"
  													},
  													id: 2529,
  													name: "Identifier",
  													src: "4043:11:5"
  												}
  											],
  											id: 2530,
  											name: "FunctionCall",
  											src: "4032:23:5"
  										}
  									],
  									id: 2531,
  									name: "VariableDeclarationStatement",
  									src: "3998:57:5"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: ">",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2525,
  														type: "uint256",
  														value: "secondsSinceLastTouched"
  													},
  													id: 2532,
  													name: "Identifier",
  													src: "4069:23:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2472,
  																type: "function () view returns (uint256)",
  																value: "timeout"
  															},
  															id: 2533,
  															name: "Identifier",
  															src: "4095:7:5"
  														}
  													],
  													id: 2534,
  													name: "FunctionCall",
  													src: "4095:9:5"
  												}
  											],
  											id: 2535,
  											name: "BinaryOperation",
  											src: "4069:35:5"
  										},
  										{
  											attributes: {
  												functionReturnParameters: 2519
  											},
  											children: [
  												{
  													attributes: {
  														hexvalue: "74727565",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "bool",
  														type: "bool",
  														value: "true"
  													},
  													id: 2536,
  													name: "Literal",
  													src: "4113:4:5"
  												}
  											],
  											id: 2537,
  											name: "Return",
  											src: "4106:11:5"
  										}
  									],
  									id: 2538,
  									name: "IfStatement",
  									src: "4065:52:5"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 2519
  									},
  									children: [
  										{
  											attributes: {
  												hexvalue: "66616c7365",
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												token: "bool",
  												type: "bool",
  												value: "false"
  											},
  											id: 2539,
  											name: "Literal",
  											src: "4134:5:5"
  										}
  									],
  									id: 2540,
  									name: "Return",
  									src: "4127:12:5"
  								}
  							],
  							id: 2541,
  							name: "Block",
  							src: "3946:200:5"
  						}
  					],
  					id: 2542,
  					name: "FunctionDefinition",
  					src: "3900:246:5"
  				},
  				{
  					attributes: {
  						functionSelector: "41c30546",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "findInflationOffset",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice the amount of seconds until the ubi payout is next inflated\n @dev ubi is payed out continuously between inflation steps\n @return the amount of seconds until the next inflation step"
  							},
  							id: 2543,
  							name: "StructuredDocumentation",
  							src: "4152:206:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2544,
  							name: "ParameterList",
  							src: "4391:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2573,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2545,
  											name: "ElementaryTypeName",
  											src: "4415:7:5"
  										}
  									],
  									id: 2546,
  									name: "VariableDeclaration",
  									src: "4415:7:5"
  								}
  							],
  							id: 2547,
  							name: "ParameterList",
  							src: "4414:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										assignments: [
  											2549
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "nextInflation",
  												scope: 2572,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2548,
  													name: "ElementaryTypeName",
  													src: "4529:7:5"
  												}
  											],
  											id: 2549,
  											name: "VariableDeclaration",
  											src: "4529:21:5"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isInlineArray: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "add",
  																referencedDeclaration: 181,
  																type: "function (uint256,uint256) pure returns (uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		isConstant: false,
  																		isInlineArray: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		type: "uint256"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				isStructConstructorCall: false,
  																				lValueRequested: false,
  																				names: [
  																					null
  																				],
  																				tryCall: false,
  																				type: "uint256",
  																				type_conversion: false
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						argumentTypes: [
  																							{
  																								typeIdentifier: "t_uint256",
  																								typeString: "uint256"
  																							}
  																						],
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						member_name: "mul",
  																						referencedDeclaration: 237,
  																						type: "function (uint256,uint256) pure returns (uint256)"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								"arguments": [
  																									null
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								isStructConstructorCall: false,
  																								lValueRequested: false,
  																								names: [
  																									null
  																								],
  																								tryCall: false,
  																								type: "uint256",
  																								type_conversion: false
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										argumentTypes: [
  																											null
  																										],
  																										overloadedDeclarations: [
  																											null
  																										],
  																										referencedDeclaration: 2446,
  																										type: "function () view returns (uint256)",
  																										value: "period"
  																									},
  																									id: 2550,
  																									name: "Identifier",
  																									src: "4567:6:5"
  																								}
  																							],
  																							id: 2551,
  																							name: "FunctionCall",
  																							src: "4567:8:5"
  																						}
  																					],
  																					id: 2552,
  																					name: "MemberAccess",
  																					src: "4567:12:5"
  																				},
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "uint256",
  																						type_conversion: false
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_rational_1_by_1",
  																										typeString: "int_const 1"
  																									}
  																								],
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: false,
  																								lValueRequested: false,
  																								member_name: "add",
  																								referencedDeclaration: 181,
  																								type: "function (uint256,uint256) pure returns (uint256)"
  																							},
  																							children: [
  																								{
  																									attributes: {
  																										"arguments": [
  																											null
  																										],
  																										isConstant: false,
  																										isLValue: false,
  																										isPure: false,
  																										isStructConstructorCall: false,
  																										lValueRequested: false,
  																										names: [
  																											null
  																										],
  																										tryCall: false,
  																										type: "uint256",
  																										type_conversion: false
  																									},
  																									children: [
  																										{
  																											attributes: {
  																												argumentTypes: [
  																													null
  																												],
  																												overloadedDeclarations: [
  																													null
  																												],
  																												referencedDeclaration: 2459,
  																												type: "function () view returns (uint256)",
  																												value: "periods"
  																											},
  																											id: 2553,
  																											name: "Identifier",
  																											src: "4580:7:5"
  																										}
  																									],
  																									id: 2554,
  																									name: "FunctionCall",
  																									src: "4580:9:5"
  																								}
  																							],
  																							id: 2555,
  																							name: "MemberAccess",
  																							src: "4580:13:5"
  																						},
  																						{
  																							attributes: {
  																								hexvalue: "31",
  																								isConstant: false,
  																								isLValue: false,
  																								isPure: true,
  																								lValueRequested: false,
  																								token: "number",
  																								type: "int_const 1",
  																								value: "1"
  																							},
  																							id: 2556,
  																							name: "Literal",
  																							src: "4594:1:5"
  																						}
  																					],
  																					id: 2557,
  																					name: "FunctionCall",
  																					src: "4580:16:5"
  																				}
  																			],
  																			id: 2558,
  																			name: "FunctionCall",
  																			src: "4567:30:5"
  																		}
  																	],
  																	id: 2559,
  																	name: "TupleExpression",
  																	src: "4566:32:5"
  																}
  															],
  															id: 2560,
  															name: "MemberAccess",
  															src: "4566:36:5"
  														},
  														{
  															attributes: {
  																"arguments": [
  																	null
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			null
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2503,
  																		type: "function () view returns (uint256)",
  																		value: "hubDeployedAt"
  																	},
  																	id: 2561,
  																	name: "Identifier",
  																	src: "4603:13:5"
  																}
  															],
  															id: 2562,
  															name: "FunctionCall",
  															src: "4603:15:5"
  														}
  													],
  													id: 2563,
  													name: "FunctionCall",
  													src: "4566:53:5"
  												}
  											],
  											id: 2564,
  											name: "TupleExpression",
  											src: "4565:55:5"
  										}
  									],
  									id: 2565,
  									name: "VariableDeclarationStatement",
  									src: "4529:91:5"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 2547
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sub",
  														referencedDeclaration: 203,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2549,
  																type: "uint256",
  																value: "nextInflation"
  															},
  															id: 2566,
  															name: "Identifier",
  															src: "4637:13:5"
  														}
  													],
  													id: 2567,
  													name: "MemberAccess",
  													src: "4637:17:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2406,
  																type: "function () view returns (uint256)",
  																value: "time"
  															},
  															id: 2568,
  															name: "Identifier",
  															src: "4655:4:5"
  														}
  													],
  													id: 2569,
  													name: "FunctionCall",
  													src: "4655:6:5"
  												}
  											],
  											id: 2570,
  											name: "FunctionCall",
  											src: "4637:25:5"
  										}
  									],
  									id: 2571,
  									name: "Return",
  									src: "4630:32:5"
  								}
  							],
  							id: 2572,
  							name: "Block",
  							src: "4424:245:5"
  						}
  					],
  					id: 2573,
  					name: "FunctionDefinition",
  					src: "4363:306:5"
  				},
  				{
  					attributes: {
  						functionSelector: "6c050eae",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "look",
  						scope: 2750,
  						stateMutability: "view",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice checks how much ubi this token holder is owed, but doesn't update their balance\n @dev is called in the update method to write the new balance to state, but also useful in wallets\n @return how much ubi this token holder is owed"
  							},
  							id: 2574,
  							name: "StructuredDocumentation",
  							src: "4675:252:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2575,
  							name: "ParameterList",
  							src: "4945:2:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2673,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2576,
  											name: "ElementaryTypeName",
  											src: "4969:7:5"
  										}
  									],
  									id: 2577,
  									name: "VariableDeclaration",
  									src: "4969:7:5"
  								}
  							],
  							id: 2578,
  							name: "ParameterList",
  							src: "4968:9:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "bool",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2542,
  														type: "function () view returns (bool)",
  														value: "stopped"
  													},
  													id: 2579,
  													name: "Identifier",
  													src: "5062:7:5"
  												}
  											],
  											id: 2580,
  											name: "FunctionCall",
  											src: "5062:9:5"
  										},
  										{
  											attributes: {
  												functionReturnParameters: 2578
  											},
  											children: [
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 2581,
  													name: "Literal",
  													src: "5080:1:5"
  												}
  											],
  											id: 2582,
  											name: "Return",
  											src: "5073:8:5"
  										}
  									],
  									id: 2583,
  									name: "IfStatement",
  									src: "5058:23:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2585
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "payout",
  												scope: 2672,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2584,
  													name: "ElementaryTypeName",
  													src: "5091:7:5"
  												}
  											],
  											id: 2585,
  											name: "VariableDeclaration",
  											src: "5091:14:5"
  										},
  										{
  											attributes: {
  												hexvalue: "30",
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												token: "number",
  												type: "int_const 0",
  												value: "0"
  											},
  											id: 2586,
  											name: "Literal",
  											src: "5108:1:5"
  										}
  									],
  									id: 2587,
  									name: "VariableDeclarationStatement",
  									src: "5091:18:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2589
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "clock",
  												scope: 2672,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2588,
  													name: "ElementaryTypeName",
  													src: "5119:7:5"
  												}
  											],
  											id: 2589,
  											name: "VariableDeclaration",
  											src: "5119:13:5"
  										},
  										{
  											attributes: {
  												overloadedDeclarations: [
  													null
  												],
  												referencedDeclaration: 2311,
  												type: "uint256",
  												value: "lastTouched"
  											},
  											id: 2590,
  											name: "Identifier",
  											src: "5135:11:5"
  										}
  									],
  									id: 2591,
  									name: "VariableDeclarationStatement",
  									src: "5119:27:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2593
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "offset",
  												scope: 2672,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2592,
  													name: "ElementaryTypeName",
  													src: "5156:7:5"
  												}
  											],
  											id: 2593,
  											name: "VariableDeclaration",
  											src: "5156:14:5"
  										},
  										{
  											attributes: {
  												overloadedDeclarations: [
  													null
  												],
  												referencedDeclaration: 2317,
  												type: "uint256",
  												value: "inflationOffset"
  											},
  											id: 2594,
  											name: "Identifier",
  											src: "5173:15:5"
  										}
  									],
  									id: 2595,
  									name: "VariableDeclarationStatement",
  									src: "5156:32:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2597
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "rate",
  												scope: 2672,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2596,
  													name: "ElementaryTypeName",
  													src: "5198:7:5"
  												}
  											],
  											id: 2597,
  											name: "VariableDeclaration",
  											src: "5198:12:5"
  										},
  										{
  											attributes: {
  												overloadedDeclarations: [
  													null
  												],
  												referencedDeclaration: 2319,
  												type: "uint256",
  												value: "currentIssuance"
  											},
  											id: 2598,
  											name: "Identifier",
  											src: "5213:15:5"
  										}
  									],
  									id: 2599,
  									name: "VariableDeclarationStatement",
  									src: "5198:30:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2601
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "p",
  												scope: 2672,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2600,
  													name: "ElementaryTypeName",
  													src: "5238:7:5"
  												}
  											],
  											id: 2601,
  											name: "VariableDeclaration",
  											src: "5238:9:5"
  										},
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2490,
  														type: "function () view returns (uint256)",
  														value: "periodsWhenLastTouched"
  													},
  													id: 2602,
  													name: "Identifier",
  													src: "5250:22:5"
  												}
  											],
  											id: 2603,
  											name: "FunctionCall",
  											src: "5250:24:5"
  										}
  									],
  									id: 2604,
  									name: "VariableDeclarationStatement",
  									src: "5238:36:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "<=",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "add",
  																referencedDeclaration: 181,
  																type: "function (uint256,uint256) pure returns (uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2589,
  																		type: "uint256",
  																		value: "clock"
  																	},
  																	id: 2605,
  																	name: "Identifier",
  																	src: "5513:5:5"
  																}
  															],
  															id: 2606,
  															name: "MemberAccess",
  															src: "5513:9:5"
  														},
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2593,
  																type: "uint256",
  																value: "offset"
  															},
  															id: 2607,
  															name: "Identifier",
  															src: "5523:6:5"
  														}
  													],
  													id: 2608,
  													name: "FunctionCall",
  													src: "5513:17:5"
  												},
  												{
  													attributes: {
  														"arguments": [
  															null
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	null
  																],
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: 2406,
  																type: "function () view returns (uint256)",
  																value: "time"
  															},
  															id: 2609,
  															name: "Identifier",
  															src: "5534:4:5"
  														}
  													],
  													id: 2610,
  													name: "FunctionCall",
  													src: "5534:6:5"
  												}
  											],
  											id: 2611,
  											name: "BinaryOperation",
  											src: "5513:27:5"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2585,
  																		type: "uint256",
  																		value: "payout"
  																	},
  																	id: 2612,
  																	name: "Identifier",
  																	src: "5641:6:5"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "add",
  																				referencedDeclaration: 181,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2585,
  																						type: "uint256",
  																						value: "payout"
  																					},
  																					id: 2613,
  																					name: "Identifier",
  																					src: "5650:6:5"
  																				}
  																			],
  																			id: 2614,
  																			name: "MemberAccess",
  																			src: "5650:10:5"
  																		},
  																		{
  																			attributes: {
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				isStructConstructorCall: false,
  																				lValueRequested: false,
  																				names: [
  																					null
  																				],
  																				tryCall: false,
  																				type: "uint256",
  																				type_conversion: false
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						argumentTypes: [
  																							{
  																								typeIdentifier: "t_uint256",
  																								typeString: "uint256"
  																							}
  																						],
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						lValueRequested: false,
  																						member_name: "mul",
  																						referencedDeclaration: 237,
  																						type: "function (uint256,uint256) pure returns (uint256)"
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 2593,
  																								type: "uint256",
  																								value: "offset"
  																							},
  																							id: 2615,
  																							name: "Identifier",
  																							src: "5661:6:5"
  																						}
  																					],
  																					id: 2616,
  																					name: "MemberAccess",
  																					src: "5661:10:5"
  																				},
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2597,
  																						type: "uint256",
  																						value: "rate"
  																					},
  																					id: 2617,
  																					name: "Identifier",
  																					src: "5672:4:5"
  																				}
  																			],
  																			id: 2618,
  																			name: "FunctionCall",
  																			src: "5661:16:5"
  																		}
  																	],
  																	id: 2619,
  																	name: "FunctionCall",
  																	src: "5650:28:5"
  																}
  															],
  															id: 2620,
  															name: "Assignment",
  															src: "5641:37:5"
  														}
  													],
  													id: 2621,
  													name: "ExpressionStatement",
  													src: "5641:37:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2589,
  																		type: "uint256",
  																		value: "clock"
  																	},
  																	id: 2622,
  																	name: "Identifier",
  																	src: "5764:5:5"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "add",
  																				referencedDeclaration: 181,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2589,
  																						type: "uint256",
  																						value: "clock"
  																					},
  																					id: 2623,
  																					name: "Identifier",
  																					src: "5772:5:5"
  																				}
  																			],
  																			id: 2624,
  																			name: "MemberAccess",
  																			src: "5772:9:5"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2593,
  																				type: "uint256",
  																				value: "offset"
  																			},
  																			id: 2625,
  																			name: "Identifier",
  																			src: "5782:6:5"
  																		}
  																	],
  																	id: 2626,
  																	name: "FunctionCall",
  																	src: "5772:17:5"
  																}
  															],
  															id: 2627,
  															name: "Assignment",
  															src: "5764:25:5"
  														}
  													],
  													id: 2628,
  													name: "ExpressionStatement",
  													src: "5764:25:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2593,
  																		type: "uint256",
  																		value: "offset"
  																	},
  																	id: 2629,
  																	name: "Identifier",
  																	src: "5859:6:5"
  																},
  																{
  																	attributes: {
  																		"arguments": [
  																			null
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					null
  																				],
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2446,
  																				type: "function () view returns (uint256)",
  																				value: "period"
  																			},
  																			id: 2630,
  																			name: "Identifier",
  																			src: "5868:6:5"
  																		}
  																	],
  																	id: 2631,
  																	name: "FunctionCall",
  																	src: "5868:8:5"
  																}
  															],
  															id: 2632,
  															name: "Assignment",
  															src: "5859:17:5"
  														}
  													],
  													id: 2633,
  													name: "ExpressionStatement",
  													src: "5859:17:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2601,
  																		type: "uint256",
  																		value: "p"
  																	},
  																	id: 2634,
  																	name: "Identifier",
  																	src: "5948:1:5"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_rational_1_by_1",
  																						typeString: "int_const 1"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "add",
  																				referencedDeclaration: 181,
  																				type: "function (uint256,uint256) pure returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						overloadedDeclarations: [
  																							null
  																						],
  																						referencedDeclaration: 2601,
  																						type: "uint256",
  																						value: "p"
  																					},
  																					id: 2635,
  																					name: "Identifier",
  																					src: "5952:1:5"
  																				}
  																			],
  																			id: 2636,
  																			name: "MemberAccess",
  																			src: "5952:5:5"
  																		},
  																		{
  																			attributes: {
  																				hexvalue: "31",
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: true,
  																				lValueRequested: false,
  																				token: "number",
  																				type: "int_const 1",
  																				value: "1"
  																			},
  																			id: 2637,
  																			name: "Literal",
  																			src: "5958:1:5"
  																		}
  																	],
  																	id: 2638,
  																	name: "FunctionCall",
  																	src: "5952:8:5"
  																}
  															],
  															id: 2639,
  															name: "Assignment",
  															src: "5948:12:5"
  														}
  													],
  													id: 2640,
  													name: "ExpressionStatement",
  													src: "5948:12:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2597,
  																		type: "uint256",
  																		value: "rate"
  																	},
  																	id: 2641,
  																	name: "Identifier",
  																	src: "6034:4:5"
  																},
  																{
  																	attributes: {
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					{
  																						typeIdentifier: "t_uint256",
  																						typeString: "uint256"
  																					}
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "issuanceByStep",
  																				referencedDeclaration: 2848,
  																				type: "function (uint256) view external returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "contract HubI",
  																						type_conversion: true
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_address",
  																										typeString: "address"
  																									}
  																								],
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 2917,
  																								type: "type(contract HubI)",
  																								value: "HubI"
  																							},
  																							id: 2642,
  																							name: "Identifier",
  																							src: "6041:4:5"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 2313,
  																								type: "address",
  																								value: "hub"
  																							},
  																							id: 2643,
  																							name: "Identifier",
  																							src: "6046:3:5"
  																						}
  																					],
  																					id: 2644,
  																					name: "FunctionCall",
  																					src: "6041:9:5"
  																				}
  																			],
  																			id: 2645,
  																			name: "MemberAccess",
  																			src: "6041:24:5"
  																		},
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2601,
  																				type: "uint256",
  																				value: "p"
  																			},
  																			id: 2646,
  																			name: "Identifier",
  																			src: "6066:1:5"
  																		}
  																	],
  																	id: 2647,
  																	name: "FunctionCall",
  																	src: "6041:27:5"
  																}
  															],
  															id: 2648,
  															name: "Assignment",
  															src: "6034:34:5"
  														}
  													],
  													id: 2649,
  													name: "ExpressionStatement",
  													src: "6034:34:5"
  												}
  											],
  											id: 2650,
  											name: "Block",
  											src: "5542:537:5"
  										}
  									],
  									id: 2651,
  									name: "WhileStatement",
  									src: "5506:573:5"
  								},
  								{
  									attributes: {
  										assignments: [
  											2653
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "timeSinceLastPayout",
  												scope: 2672,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2652,
  													name: "ElementaryTypeName",
  													src: "6165:7:5"
  												}
  											],
  											id: 2653,
  											name: "VariableDeclaration",
  											src: "6165:27:5"
  										},
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "sub",
  														referencedDeclaration: 203,
  														type: "function (uint256,uint256) pure returns (uint256)"
  													},
  													children: [
  														{
  															attributes: {
  																"arguments": [
  																	null
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			null
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2406,
  																		type: "function () view returns (uint256)",
  																		value: "time"
  																	},
  																	id: 2654,
  																	name: "Identifier",
  																	src: "6195:4:5"
  																}
  															],
  															id: 2655,
  															name: "FunctionCall",
  															src: "6195:6:5"
  														}
  													],
  													id: 2656,
  													name: "MemberAccess",
  													src: "6195:10:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2589,
  														type: "uint256",
  														value: "clock"
  													},
  													id: 2657,
  													name: "Identifier",
  													src: "6206:5:5"
  												}
  											],
  											id: 2658,
  											name: "FunctionCall",
  											src: "6195:17:5"
  										}
  									],
  									id: 2659,
  									name: "VariableDeclarationStatement",
  									src: "6165:47:5"
  								},
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: "=",
  												type: "uint256"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2585,
  														type: "uint256",
  														value: "payout"
  													},
  													id: 2660,
  													name: "Identifier",
  													src: "6222:6:5"
  												},
  												{
  													attributes: {
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														isStructConstructorCall: false,
  														lValueRequested: false,
  														names: [
  															null
  														],
  														tryCall: false,
  														type: "uint256",
  														type_conversion: false
  													},
  													children: [
  														{
  															attributes: {
  																argumentTypes: [
  																	{
  																		typeIdentifier: "t_uint256",
  																		typeString: "uint256"
  																	}
  																],
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																member_name: "add",
  																referencedDeclaration: 181,
  																type: "function (uint256,uint256) pure returns (uint256)"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2585,
  																		type: "uint256",
  																		value: "payout"
  																	},
  																	id: 2661,
  																	name: "Identifier",
  																	src: "6231:6:5"
  																}
  															],
  															id: 2662,
  															name: "MemberAccess",
  															src: "6231:10:5"
  														},
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "uint256",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		lValueRequested: false,
  																		member_name: "mul",
  																		referencedDeclaration: 237,
  																		type: "function (uint256,uint256) pure returns (uint256)"
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2653,
  																				type: "uint256",
  																				value: "timeSinceLastPayout"
  																			},
  																			id: 2663,
  																			name: "Identifier",
  																			src: "6242:19:5"
  																		}
  																	],
  																	id: 2664,
  																	name: "MemberAccess",
  																	src: "6242:23:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2597,
  																		type: "uint256",
  																		value: "rate"
  																	},
  																	id: 2665,
  																	name: "Identifier",
  																	src: "6266:4:5"
  																}
  															],
  															id: 2666,
  															name: "FunctionCall",
  															src: "6242:29:5"
  														}
  													],
  													id: 2667,
  													name: "FunctionCall",
  													src: "6231:41:5"
  												}
  											],
  											id: 2668,
  											name: "Assignment",
  											src: "6222:50:5"
  										}
  									],
  									id: 2669,
  									name: "ExpressionStatement",
  									src: "6222:50:5"
  								},
  								{
  									attributes: {
  										functionReturnParameters: 2578
  									},
  									children: [
  										{
  											attributes: {
  												overloadedDeclarations: [
  													null
  												],
  												referencedDeclaration: 2585,
  												type: "uint256",
  												value: "payout"
  											},
  											id: 2670,
  											name: "Identifier",
  											src: "6289:6:5"
  										}
  									],
  									id: 2671,
  									name: "Return",
  									src: "6282:13:5"
  								}
  							],
  							id: 2672,
  							name: "Block",
  							src: "4978:1324:5"
  						}
  					],
  					id: 2673,
  					name: "FunctionDefinition",
  					src: "4932:1370:5"
  				},
  				{
  					attributes: {
  						functionSelector: "a2e62045",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "update",
  						scope: 2750,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice receive a ubi payout\n @dev this is the method to actually update storage with new token balance"
  							},
  							id: 2674,
  							name: "StructuredDocumentation",
  							src: "6308:114:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2675,
  							name: "ParameterList",
  							src: "6442:2:5"
  						},
  						{
  							attributes: {
  								parameters: [
  									null
  								]
  							},
  							children: [
  							],
  							id: 2676,
  							name: "ParameterList",
  							src: "6452:0:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										assignments: [
  											2678
  										]
  									},
  									children: [
  										{
  											attributes: {
  												constant: false,
  												mutability: "mutable",
  												name: "gift",
  												scope: 2710,
  												stateVariable: false,
  												storageLocation: "default",
  												type: "uint256",
  												visibility: "internal"
  											},
  											children: [
  												{
  													attributes: {
  														name: "uint256",
  														type: "uint256"
  													},
  													id: 2677,
  													name: "ElementaryTypeName",
  													src: "6462:7:5"
  												}
  											],
  											id: 2678,
  											name: "VariableDeclaration",
  											src: "6462:12:5"
  										},
  										{
  											attributes: {
  												"arguments": [
  													null
  												],
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "uint256",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															null
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2673,
  														type: "function () view returns (uint256)",
  														value: "look"
  													},
  													id: 2679,
  													name: "Identifier",
  													src: "6477:4:5"
  												}
  											],
  											id: 2680,
  											name: "FunctionCall",
  											src: "6477:6:5"
  										}
  									],
  									id: 2681,
  									name: "VariableDeclarationStatement",
  									src: "6462:21:5"
  								},
  								{
  									attributes: {
  									},
  									children: [
  										{
  											attributes: {
  												commonType: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												},
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												operator: ">",
  												type: "bool"
  											},
  											children: [
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2678,
  														type: "uint256",
  														value: "gift"
  													},
  													id: 2682,
  													name: "Identifier",
  													src: "6555:4:5"
  												},
  												{
  													attributes: {
  														hexvalue: "30",
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														token: "number",
  														type: "int_const 0",
  														value: "0"
  													},
  													id: 2683,
  													name: "Literal",
  													src: "6562:1:5"
  												}
  											],
  											id: 2684,
  											name: "BinaryOperation",
  											src: "6555:8:5"
  										},
  										{
  											children: [
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2317,
  																		type: "uint256",
  																		value: "inflationOffset"
  																	},
  																	id: 2685,
  																	name: "Identifier",
  																	src: "6654:15:5"
  																},
  																{
  																	attributes: {
  																		"arguments": [
  																			null
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					null
  																				],
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2573,
  																				type: "function () view returns (uint256)",
  																				value: "findInflationOffset"
  																			},
  																			id: 2686,
  																			name: "Identifier",
  																			src: "6672:19:5"
  																		}
  																	],
  																	id: 2687,
  																	name: "FunctionCall",
  																	src: "6672:21:5"
  																}
  															],
  															id: 2688,
  															name: "Assignment",
  															src: "6654:39:5"
  														}
  													],
  													id: 2689,
  													name: "ExpressionStatement",
  													src: "6654:39:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2311,
  																		type: "uint256",
  																		value: "lastTouched"
  																	},
  																	id: 2690,
  																	name: "Identifier",
  																	src: "6707:11:5"
  																},
  																{
  																	attributes: {
  																		"arguments": [
  																			null
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					null
  																				],
  																				overloadedDeclarations: [
  																					null
  																				],
  																				referencedDeclaration: 2406,
  																				type: "function () view returns (uint256)",
  																				value: "time"
  																			},
  																			id: 2691,
  																			name: "Identifier",
  																			src: "6721:4:5"
  																		}
  																	],
  																	id: 2692,
  																	name: "FunctionCall",
  																	src: "6721:6:5"
  																}
  															],
  															id: 2693,
  															name: "Assignment",
  															src: "6707:20:5"
  														}
  													],
  													id: 2694,
  													name: "ExpressionStatement",
  													src: "6707:20:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																lValueRequested: false,
  																operator: "=",
  																type: "uint256"
  															},
  															children: [
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2319,
  																		type: "uint256",
  																		value: "currentIssuance"
  																	},
  																	id: 2695,
  																	name: "Identifier",
  																	src: "6741:15:5"
  																},
  																{
  																	attributes: {
  																		"arguments": [
  																			null
  																		],
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		isStructConstructorCall: false,
  																		lValueRequested: false,
  																		names: [
  																			null
  																		],
  																		tryCall: false,
  																		type: "uint256",
  																		type_conversion: false
  																	},
  																	children: [
  																		{
  																			attributes: {
  																				argumentTypes: [
  																					null
  																				],
  																				isConstant: false,
  																				isLValue: false,
  																				isPure: false,
  																				lValueRequested: false,
  																				member_name: "issuance",
  																				referencedDeclaration: 2841,
  																				type: "function () view external returns (uint256)"
  																			},
  																			children: [
  																				{
  																					attributes: {
  																						isConstant: false,
  																						isLValue: false,
  																						isPure: false,
  																						isStructConstructorCall: false,
  																						lValueRequested: false,
  																						names: [
  																							null
  																						],
  																						tryCall: false,
  																						type: "contract HubI",
  																						type_conversion: true
  																					},
  																					children: [
  																						{
  																							attributes: {
  																								argumentTypes: [
  																									{
  																										typeIdentifier: "t_address",
  																										typeString: "address"
  																									}
  																								],
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 2917,
  																								type: "type(contract HubI)",
  																								value: "HubI"
  																							},
  																							id: 2696,
  																							name: "Identifier",
  																							src: "6759:4:5"
  																						},
  																						{
  																							attributes: {
  																								overloadedDeclarations: [
  																									null
  																								],
  																								referencedDeclaration: 2313,
  																								type: "address",
  																								value: "hub"
  																							},
  																							id: 2697,
  																							name: "Identifier",
  																							src: "6764:3:5"
  																						}
  																					],
  																					id: 2698,
  																					name: "FunctionCall",
  																					src: "6759:9:5"
  																				}
  																			],
  																			id: 2699,
  																			name: "MemberAccess",
  																			src: "6759:18:5"
  																		}
  																	],
  																	id: 2700,
  																	name: "FunctionCall",
  																	src: "6759:20:5"
  																}
  															],
  															id: 2701,
  															name: "Assignment",
  															src: "6741:38:5"
  														}
  													],
  													id: 2702,
  													name: "ExpressionStatement",
  													src: "6741:38:5"
  												},
  												{
  													children: [
  														{
  															attributes: {
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																isStructConstructorCall: false,
  																lValueRequested: false,
  																names: [
  																	null
  																],
  																tryCall: false,
  																type: "tuple()",
  																type_conversion: false
  															},
  															children: [
  																{
  																	attributes: {
  																		argumentTypes: [
  																			{
  																				typeIdentifier: "t_address",
  																				typeString: "address"
  																			},
  																			{
  																				typeIdentifier: "t_uint256",
  																				typeString: "uint256"
  																			}
  																		],
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 1007,
  																		type: "function (address,uint256)",
  																		value: "_mint"
  																	},
  																	id: 2703,
  																	name: "Identifier",
  																	src: "6793:5:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2315,
  																		type: "address",
  																		value: "owner"
  																	},
  																	id: 2704,
  																	name: "Identifier",
  																	src: "6799:5:5"
  																},
  																{
  																	attributes: {
  																		overloadedDeclarations: [
  																			null
  																		],
  																		referencedDeclaration: 2678,
  																		type: "uint256",
  																		value: "gift"
  																	},
  																	id: 2705,
  																	name: "Identifier",
  																	src: "6806:4:5"
  																}
  															],
  															id: 2706,
  															name: "FunctionCall",
  															src: "6793:18:5"
  														}
  													],
  													id: 2707,
  													name: "ExpressionStatement",
  													src: "6793:18:5"
  												}
  											],
  											id: 2708,
  											name: "Block",
  											src: "6565:257:5"
  										}
  									],
  									id: 2709,
  									name: "IfStatement",
  									src: "6551:271:5"
  								}
  							],
  							id: 2710,
  							name: "Block",
  							src: "6452:376:5"
  						}
  					],
  					id: 2711,
  					name: "FunctionDefinition",
  					src: "6427:401:5"
  				},
  				{
  					attributes: {
  						functionSelector: "20a6703c",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						name: "hubTransfer",
  						scope: 2750,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								text: "@notice special method called by the hub to execute a transitive transaction\n @param from the address the tokens are being transfered from\n @param to the address the tokens are being transferred to\n @param amount the amount of tokens to transfer"
  							},
  							id: 2712,
  							name: "StructuredDocumentation",
  							src: "6834:270:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "from",
  										scope: 2732,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 2713,
  											name: "ElementaryTypeName",
  											src: "7139:7:5"
  										}
  									],
  									id: 2714,
  									name: "VariableDeclaration",
  									src: "7139:12:5"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "to",
  										scope: 2732,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 2715,
  											name: "ElementaryTypeName",
  											src: "7161:7:5"
  										}
  									],
  									id: 2716,
  									name: "VariableDeclaration",
  									src: "7161:10:5"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "amount",
  										scope: 2732,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2717,
  											name: "ElementaryTypeName",
  											src: "7181:7:5"
  										}
  									],
  									id: 2718,
  									name: "VariableDeclaration",
  									src: "7181:14:5"
  								}
  							],
  							id: 2719,
  							name: "ParameterList",
  							src: "7129:72:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2732,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "bool",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "bool",
  												type: "bool"
  											},
  											id: 2722,
  											name: "ElementaryTypeName",
  											src: "7226:4:5"
  										}
  									],
  									id: 2723,
  									name: "VariableDeclaration",
  									src: "7226:4:5"
  								}
  							],
  							id: 2724,
  							name: "ParameterList",
  							src: "7225:6:5"
  						},
  						{
  							attributes: {
  							},
  							children: [
  								{
  									attributes: {
  										overloadedDeclarations: [
  											null
  										],
  										referencedDeclaration: 2333,
  										type: "modifier ()",
  										value: "onlyHub"
  									},
  									id: 2720,
  									name: "Identifier",
  									src: "7209:7:5"
  								}
  							],
  							id: 2721,
  							name: "ModifierInvocation",
  							src: "7209:7:5"
  						},
  						{
  							children: [
  								{
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "tuple()",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 952,
  														type: "function (address,address,uint256)",
  														value: "_transfer"
  													},
  													id: 2725,
  													name: "Identifier",
  													src: "7242:9:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2714,
  														type: "address",
  														value: "from"
  													},
  													id: 2726,
  													name: "Identifier",
  													src: "7252:4:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2716,
  														type: "address",
  														value: "to"
  													},
  													id: 2727,
  													name: "Identifier",
  													src: "7258:2:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2718,
  														type: "uint256",
  														value: "amount"
  													},
  													id: 2728,
  													name: "Identifier",
  													src: "7262:6:5"
  												}
  											],
  											id: 2729,
  											name: "FunctionCall",
  											src: "7242:27:5"
  										}
  									],
  									id: 2730,
  									name: "ExpressionStatement",
  									src: "7242:27:5"
  								}
  							],
  							id: 2731,
  							name: "Block",
  							src: "7232:44:5"
  						}
  					],
  					id: 2732,
  					name: "FunctionDefinition",
  					src: "7109:167:5"
  				},
  				{
  					attributes: {
  						baseFunctions: [
  							755
  						],
  						functionSelector: "a9059cbb",
  						implemented: true,
  						isConstructor: false,
  						kind: "function",
  						modifiers: [
  							null
  						],
  						name: "transfer",
  						scope: 2750,
  						stateMutability: "nonpayable",
  						virtual: false,
  						visibility: "public"
  					},
  					children: [
  						{
  							attributes: {
  								overrides: [
  									null
  								]
  							},
  							id: 2738,
  							name: "OverrideSpecifier",
  							src: "7333:8:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "dst",
  										scope: 2749,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "address",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "address",
  												stateMutability: "nonpayable",
  												type: "address"
  											},
  											id: 2733,
  											name: "ElementaryTypeName",
  											src: "7300:7:5"
  										}
  									],
  									id: 2734,
  									name: "VariableDeclaration",
  									src: "7300:11:5"
  								},
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "wad",
  										scope: 2749,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "uint256",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "uint256",
  												type: "uint256"
  											},
  											id: 2735,
  											name: "ElementaryTypeName",
  											src: "7313:7:5"
  										}
  									],
  									id: 2736,
  									name: "VariableDeclaration",
  									src: "7313:11:5"
  								}
  							],
  							id: 2737,
  							name: "ParameterList",
  							src: "7299:26:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										constant: false,
  										mutability: "mutable",
  										name: "",
  										scope: 2749,
  										stateVariable: false,
  										storageLocation: "default",
  										type: "bool",
  										visibility: "internal"
  									},
  									children: [
  										{
  											attributes: {
  												name: "bool",
  												type: "bool"
  											},
  											id: 2739,
  											name: "ElementaryTypeName",
  											src: "7351:4:5"
  										}
  									],
  									id: 2740,
  									name: "VariableDeclaration",
  									src: "7351:4:5"
  								}
  							],
  							id: 2741,
  							name: "ParameterList",
  							src: "7350:6:5"
  						},
  						{
  							children: [
  								{
  									attributes: {
  										functionReturnParameters: 2741
  									},
  									children: [
  										{
  											attributes: {
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												isStructConstructorCall: false,
  												lValueRequested: false,
  												names: [
  													null
  												],
  												tryCall: false,
  												type: "bool",
  												type_conversion: false
  											},
  											children: [
  												{
  													attributes: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_address",
  																typeString: "address"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														member_name: "transfer",
  														referencedDeclaration: 755,
  														type: "function (address,uint256) returns (bool)"
  													},
  													children: [
  														{
  															attributes: {
  																overloadedDeclarations: [
  																	null
  																],
  																referencedDeclaration: -25,
  																type: "contract super Token",
  																value: "super"
  															},
  															id: 2742,
  															name: "Identifier",
  															src: "7544:5:5"
  														}
  													],
  													id: 2743,
  													name: "MemberAccess",
  													src: "7544:14:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2734,
  														type: "address",
  														value: "dst"
  													},
  													id: 2744,
  													name: "Identifier",
  													src: "7559:3:5"
  												},
  												{
  													attributes: {
  														overloadedDeclarations: [
  															null
  														],
  														referencedDeclaration: 2736,
  														type: "uint256",
  														value: "wad"
  													},
  													id: 2745,
  													name: "Identifier",
  													src: "7564:3:5"
  												}
  											],
  											id: 2746,
  											name: "FunctionCall",
  											src: "7544:24:5"
  										}
  									],
  									id: 2747,
  									name: "Return",
  									src: "7537:31:5"
  								}
  							],
  							id: 2748,
  							name: "Block",
  							src: "7357:218:5"
  						}
  					],
  					id: 2749,
  					name: "FunctionDefinition",
  					src: "7282:293:5"
  				}
  			],
  			id: 2750,
  			name: "ContractDefinition",
  			src: "165:7412:5"
  		}
  	],
  	id: 2751,
  	name: "SourceUnit",
  	src: "33:7545:5"
  };
  var compiler = {
  	name: "solc",
  	version: "0.7.1+commit.f4a555be.Emscripten.clang"
  };
  var networks = {
  };
  var schemaVersion = "3.4.10";
  var updatedAt = "2022-11-29T09:43:24.129Z";
  var devdoc = {
  	kind: "dev",
  	methods: {
  		"allowance(address,address)": {
  			details: "See {IERC20-allowance}."
  		},
  		"approve(address,uint256)": {
  			details: "See {IERC20-approve}. Requirements: - `spender` cannot be the zero address."
  		},
  		"balanceOf(address)": {
  			details: "See {IERC20-balanceOf}."
  		},
  		"decreaseAllowance(address,uint256)": {
  			details: "Atomically decreases the allowance granted to `spender` by the caller. This is an alternative to {approve} that can be used as a mitigation for problems described in {IERC20-approve}. Emits an {Approval} event indicating the updated allowance. Requirements: - `spender` cannot be the zero address. - `spender` must have allowance for the caller of at least `subtractedValue`."
  		},
  		"findInflationOffset()": {
  			details: "ubi is payed out continuously between inflation steps",
  			returns: {
  				_0: "the amount of seconds until the next inflation step"
  			}
  		},
  		"hubDeployedAt()": {
  			returns: {
  				_0: "the timestamp the hub was deployed at"
  			}
  		},
  		"hubTransfer(address,address,uint256)": {
  			params: {
  				amount: "the amount of tokens to transfer",
  				from: "the address the tokens are being transfered from",
  				to: "the address the tokens are being transferred to"
  			}
  		},
  		"increaseAllowance(address,uint256)": {
  			details: "Atomically increases the allowance granted to `spender` by the caller. This is an alternative to {approve} that can be used as a mitigation for problems described in {IERC20-approve}. Emits an {Approval} event indicating the updated allowance. Requirements: - `spender` cannot be the zero address."
  		},
  		"look()": {
  			details: "is called in the update method to write the new balance to state, but also useful in wallets",
  			returns: {
  				_0: "how much ubi this token holder is owed"
  			}
  		},
  		"name()": {
  			details: "all circles tokens should have the same name",
  			returns: {
  				_0: "the token name"
  			}
  		},
  		"period()": {
  			returns: {
  				_0: "period length in seconds"
  			}
  		},
  		"periods()": {
  			returns: {
  				_0: "the number of periods since the hub was deployed"
  			}
  		},
  		"periodsWhenLastTouched()": {
  			details: "ie. if ubi was last payed out during the second inflation step, returns two",
  			returns: {
  				_0: "the inflation step by count"
  			}
  		},
  		"stop()": {
  			details: "intended for use in case of key loss, system failure, or migration to new contracts"
  		},
  		"stopped()": {
  			details: "combines the manual stop variable with a dead man's switch",
  			returns: {
  				_0: "false is the token is still paying out ubi, otherwise true"
  			}
  		},
  		"symbol()": {
  			details: "all circles tokens should have the same symbol",
  			returns: {
  				_0: "the token symbol"
  			}
  		},
  		"time()": {
  			returns: {
  				_0: "the block timestamp"
  			}
  		},
  		"timeout()": {
  			returns: {
  				_0: "the number of seconds the token can go without being updated before it's deactivated"
  			}
  		},
  		"totalSupply()": {
  			details: "See {IERC20-totalSupply}."
  		},
  		"transferFrom(address,address,uint256)": {
  			details: "See {IERC20-transferFrom}. Emits an {Approval} event indicating the updated allowance. This is not required by the EIP. See the note at the beginning of {ERC20}; Requirements: - `sender` and `recipient` cannot be the zero address. - `sender` must have a balance of at least `amount`. - the caller must have allowance for ``sender``'s tokens of at least `amount`."
  		},
  		"update()": {
  			details: "this is the method to actually update storage with new token balance"
  		}
  	},
  	stateVariables: {
  		decimals: {
  			details: "Returns the number of decimals used to get its user representation. For example, if `decimals` equals `2`, a balance of `505` tokens should be displayed to a user as `5,05` (`505 / 10 ** 2`). Tokens usually opt for a value of 18, imitating the relationship between Ether and Wei. This is the value {ERC20} uses, unless {_setupDecimals} is called. NOTE: This information is only used for _display_ purposes: it in no way affects any of the arithmetic of the contract, including {IERC20-balanceOf} and {IERC20-transfer}."
  		}
  	},
  	version: 1
  };
  var userdoc = {
  	kind: "user",
  	methods: {
  		"findInflationOffset()": {
  			notice: "the amount of seconds until the ubi payout is next inflated"
  		},
  		"hubDeployedAt()": {
  			notice: "helper functio for getting the hub deployment time"
  		},
  		"hubTransfer(address,address,uint256)": {
  			notice: "special method called by the hub to execute a transitive transaction"
  		},
  		"look()": {
  			notice: "checks how much ubi this token holder is owed, but doesn't update their balance"
  		},
  		"name()": {
  			notice: "helper function for the token name"
  		},
  		"period()": {
  			notice: "helper function for fetching the period length from the hub"
  		},
  		"periods()": {
  			notice: "helper function for fetching the number of periods from the hub"
  		},
  		"periodsWhenLastTouched()": {
  			notice: "find the inflation step when ubi was last payed out"
  		},
  		"stop()": {
  			notice: "Caution! manually deactivates or stops this token, no ubi will be payed out after this is called"
  		},
  		"stopped()": {
  			notice: "checks whether this token has been either stopped manually, or whether it has timed out"
  		},
  		"symbol()": {
  			notice: "helper function for the token symbol"
  		},
  		"time()": {
  			notice: "helper function for block timestamp"
  		},
  		"timeout()": {
  			notice: "helper function for fetching the timeout from the hub"
  		},
  		"update()": {
  			notice: "receive a ubi payout"
  		}
  	},
  	version: 1
  };
  var TokenContract = {
  	contractName: contractName,
  	abi: abi,
  	metadata: metadata,
  	bytecode: bytecode,
  	deployedBytecode: deployedBytecode,
  	immutableReferences: immutableReferences,
  	sourceMap: sourceMap,
  	deployedSourceMap: deployedSourceMap,
  	source: source,
  	sourcePath: sourcePath,
  	ast: ast,
  	legacyAST: legacyAST,
  	compiler: compiler,
  	networks: networks,
  	schemaVersion: schemaVersion,
  	updatedAt: updatedAt,
  	devdoc: devdoc,
  	userdoc: userdoc
  };

  function getContract(web3, abi, address) {
    return new web3.eth.Contract(abi, address);
  }
  function getSafeContract(web3, address) {
    return getContract(web3, GnosisSafeContract.abi, address);
  }
  function getSafeCRCVersionContract(web3, address) {
    return getContract(web3, GnosisSafeCRCVersionContract.abi, address);
  }
  function getTokenContract(web3, address) {
    return getContract(web3, TokenContract.abi, address);
  }
  function getContracts(web3, options) {
    var safeMasterAddress = options.safeMasterAddress,
      proxyFactoryAddress = options.proxyFactoryAddress,
      hubAddress = options.hubAddress;
    var safeMaster = getSafeContract(web3, safeMasterAddress);
    var proxyFactory = getContract(web3, ProxyFactoryContract.abi, proxyFactoryAddress);
    var hub = getContract(web3, HubContract.abi, hubAddress);
    return {
      hub: hub,
      proxyFactory: proxyFactory,
      safeMaster: safeMaster
    };
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(undefined);
      });
    };
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
  	if (typeof f == "function") {
  		var a = function a () {
  			if (this instanceof a) {
          return Reflect.construct(f, arguments, this.constructor);
  			}
  			return f.apply(this, arguments);
  		};
  		a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, '__esModule', {value: true});
  	Object.keys(n).forEach(function (k) {
  		var d = Object.getOwnPropertyDescriptor(n, k);
  		Object.defineProperty(a, k, d.get ? d : {
  			enumerable: true,
  			get: function () {
  				return n[k];
  			}
  		});
  	});
  	return a;
  }

  var regeneratorRuntime$1 = {exports: {}};

  var _typeof = {exports: {}};

  (function (module) {
    function _typeof(obj) {
      "@babel/helpers - typeof";
      return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
    }
    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(_typeof);
  var _typeofExports = _typeof.exports;
  getDefaultExportFromCjs(_typeofExports);

  (function (module) {
    var _typeof = _typeofExports["default"];
    function _regeneratorRuntime() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports;
      var exports = {},
        Op = Object.prototype,
        hasOwn = Op.hasOwnProperty,
        defineProperty = Object.defineProperty || function (obj, key, desc) {
          obj[key] = desc.value;
        },
        $Symbol = "function" == typeof Symbol ? Symbol : {},
        iteratorSymbol = $Symbol.iterator || "@@iterator",
        asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
        toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
      function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
          value: value,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), obj[key];
      }
      try {
        define({}, "");
      } catch (err) {
        define = function define(obj, key, value) {
          return obj[key] = value;
        };
      }
      function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
          generator = Object.create(protoGenerator.prototype),
          context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
          value: makeInvokeMethod(innerFn, self, context)
        }), generator;
      }
      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }
      exports.wrap = wrap;
      var ContinueSentinel = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var IteratorPrototype = {};
      define(IteratorPrototype, iteratorSymbol, function () {
        return this;
      });
      var getProto = Object.getPrototypeOf,
        NativeIteratorPrototype = getProto && getProto(getProto(values([])));
      NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          define(prototype, method, function (arg) {
            return this._invoke(method, arg);
          });
        });
      }
      function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);
          if ("throw" !== record.type) {
            var result = record.arg,
              value = result.value;
            return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            }) : PromiseImpl.resolve(value).then(function (unwrapped) {
              result.value = unwrapped, resolve(result);
            }, function (error) {
              return invoke("throw", error, resolve, reject);
            });
          }
          reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
          value: function value(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new PromiseImpl(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          }
        });
      }
      function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function (method, arg) {
          if ("executing" === state) throw new Error("Generator is already running");
          if ("completed" === state) {
            if ("throw" === method) throw arg;
            return doneResult();
          }
          for (context.method = method, context.arg = arg;;) {
            var delegate = context.delegate;
            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);
              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }
            if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
              if ("suspendedStart" === state) throw state = "completed", context.arg;
              context.dispatchException(context.arg);
            } else "return" === context.method && context.abrupt("return", context.arg);
            state = "executing";
            var record = tryCatch(innerFn, self, context);
            if ("normal" === record.type) {
              if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
              return {
                value: record.arg,
                done: context.done
              };
            }
            "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
          }
        };
      }
      function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method,
          method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
      }
      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
      }
      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
      }
      function Context(tryLocsList) {
        this.tryEntries = [{
          tryLoc: "root"
        }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];
          if (iteratorMethod) return iteratorMethod.call(iterable);
          if ("function" == typeof iterable.next) return iterable;
          if (!isNaN(iterable.length)) {
            var i = -1,
              next = function next() {
                for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                return next.value = undefined, next.done = !0, next;
              };
            return next.next = next;
          }
        }
        return {
          next: doneResult
        };
      }
      function doneResult() {
        return {
          value: undefined,
          done: !0
        };
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
      }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
      }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
      }, exports.mark = function (genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
      }, exports.awrap = function (arg) {
        return {
          __await: arg
        };
      }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
        return this;
      }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
        return this;
      }), define(Gp, "toString", function () {
        return "[object Generator]";
      }), exports.keys = function (val) {
        var object = Object(val),
          keys = [];
        for (var key in object) keys.push(key);
        return keys.reverse(), function next() {
          for (; keys.length;) {
            var key = keys.pop();
            if (key in object) return next.value = key, next.done = !1, next;
          }
          return next.done = !0, next;
        };
      }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
          this.done = !0;
          var rootRecord = this.tryEntries[0].completion;
          if ("throw" === rootRecord.type) throw rootRecord.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) throw exception;
          var context = this;
          function handle(loc, caught) {
            return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i],
              record = entry.completion;
            if ("root" === entry.tryLoc) return handle("end");
            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc"),
                hasFinally = hasOwn.call(entry, "finallyLoc");
              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
              } else {
                if (!hasFinally) throw new Error("try statement without catch or finally");
                if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }
          finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
          var record = finallyEntry ? finallyEntry.completion : {};
          return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
          if ("throw" === record.type) throw record.arg;
          return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;
              if ("throw" === record.type) {
                var thrown = record.arg;
                resetTryEntry(entry);
              }
              return thrown;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          return this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
      }, exports;
    }
    module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(regeneratorRuntime$1);
  var regeneratorRuntimeExports = regeneratorRuntime$1.exports;
  getDefaultExportFromCjs(regeneratorRuntimeExports);

  var runtime = regeneratorRuntimeExports();
  var regenerator = runtime;
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
  var _regeneratorRuntime = getDefaultExportFromCjs(regenerator);

  var CALL_OP = 0;
  var SAFE_THRESHOLD = 1;
  var SENTINEL_ADDRESS = '0x0000000000000000000000000000000000000001';
  var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
  var SAFE_LAST_VERSION = '1.3.0';
  var CIRCLES_INCEPTION_TIMESTAMP = new Date('2020-10-15T00:00:00.000Z');
  var NO_LIMIT_PERCENTAGE = 0;
  var DEFAULT_TRUST_LIMIT = 1;
  var DEFAULT_USER_LIMIT_PERCENTAGE = 100;
  var DEFAULT_ORG_LIMIT_PERCENTAGE = 100;

  function checkAccount(web3, account) {
    return checkOptions(account, {
      address: web3.utils.checkAddressChecksum,
      privateKey: web3.utils.isHexStrict
    });
  }

  var DEFAULT_LIMIT = 20;
  var DEFAULT_TIMESTAMP = 0;
  var ActivityTypes = createSymbolObject(['ADD_CONNECTION', 'ADD_OWNER', 'HUB_TRANSFER', 'REMOVE_CONNECTION', 'REMOVE_OWNER', 'TRANSFER']);
  var ActivityFilterTypes = createSymbolObject(['DISABLED', 'CONNECTIONS', 'OWNERS', 'TRANSFERS']);
  var TYPE_HUB_TRANSFER = 'HUB_TRANSFER';
  var TYPE_OWNERSHIP = 'OWNERSHIP';
  var TYPE_TRANSFER = 'TRANSFER';
  var TYPE_TRUST = 'TRUST';
  function createActivityModule(web3, contracts, utils) {
    return {
      ActivityTypes: ActivityTypes,
      ActivityFilterTypes: ActivityFilterTypes,
      getLatest: function () {
        var _getLatest = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(account, userOptions) {
          var options, getNotifications, activities, filterString;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  limit: {
                    type: 'number',
                    "default": DEFAULT_LIMIT
                  },
                  offset: {
                    type: 'number',
                    "default": 0
                  },
                  timestamp: {
                    type: 'number',
                    "default": DEFAULT_TIMESTAMP
                  },
                  filter: {
                    type: function type(value) {
                      return !!Object.keys(ActivityFilterTypes).find(function (key) {
                        return ActivityFilterTypes[key] === value;
                      });
                    },
                    "default": ActivityFilterTypes.DISABLED
                  },
                  otherSafeAddress: {
                    type: web3.utils.checkAddressChecksum,
                    "default": ZERO_ADDRESS
                  }
                });
                getNotifications = function () {
                  var _ref = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(filterString) {
                    var parameters, mutualTrustParams, mutualTransferParams, response;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (options.otherSafeAddress != ZERO_ADDRESS) {
                            mutualTrustParams = "\n            {\n              time_gt: ".concat(options.timestamp, ",\n              safeAddress: \"").concat(options.safeAddress.toLowerCase(), "\",\n              type: TRUST,\n              trust_: {\n                user: \"").concat(options.otherSafeAddress.toLowerCase(), "\",\n              }\n            },\n            {\n              time_gt: ").concat(options.timestamp, ",\n              safeAddress: \"").concat(options.safeAddress.toLowerCase(), "\",\n              type: TRUST,\n              trust_: {\n                canSendTo: \"").concat(options.otherSafeAddress.toLowerCase(), "\",\n              }\n            },\n          ");
                            mutualTransferParams = "\n\n            {\n              time_gt: ".concat(options.timestamp, ",\n              safeAddress: \"").concat(options.safeAddress.toLowerCase(), "\",\n              type: HUB_TRANSFER,\n              hubTransfer_: {\n                to: \"").concat(options.otherSafeAddress.toLowerCase(), "\",\n              }\n            },\n            {\n              time_gt: ").concat(options.timestamp, ",\n              safeAddress: \"").concat(options.safeAddress.toLowerCase(), "\",\n              type: HUB_TRANSFER,\n              hubTransfer_: {\n                from: \"").concat(options.otherSafeAddress.toLowerCase(), "\",\n              }\n            },\n          ");
                            parameters = "\n            orderBy: \"time\",\n            orderDirection: \"desc\",\n            first: ".concat(options.limit, ",\n            skip: ").concat(options.offset, ",\n            where: {\n              or: [\n                ").concat(filterString === TYPE_TRANSFER || !filterString ? mutualTransferParams : '', ",\n                ").concat(filterString === TYPE_TRUST || !filterString ? mutualTrustParams : '', "\n              ]\n            }\n          ");
                          } else {
                            parameters = "\n            orderBy: \"time\",\n            orderDirection: \"desc\",\n            first: ".concat(options.limit, ",\n            skip: ").concat(options.offset, ",\n            where: {\n              time_gt: ").concat(options.timestamp, ",\n              safeAddress: \"").concat(options.safeAddress.toLowerCase(), "\",\n              ").concat(filterString ? "type: ".concat(filterString) : '', "\n            }\n          ");
                          }
                          _context.next = 3;
                          return utils.requestIndexedDB('activity_stream', parameters);
                        case 3:
                          response = _context.sent;
                          if (!(!response || !response.notifications || response.notifications.length === 0)) {
                            _context.next = 6;
                            break;
                          }
                          return _context.abrupt("return", []);
                        case 6:
                          return _context.abrupt("return", response.notifications.reduce(function (acc, notification) {
                            var timestamp = parseInt(notification.time, 10);
                            var data;
                            var type;
                            if (notification.type === TYPE_OWNERSHIP) {
                              var _notification$ownersh = notification.ownership,
                                adds = _notification$ownersh.adds,
                                removes = _notification$ownersh.removes;
                              type = adds ? ActivityTypes.ADD_OWNER : ActivityTypes.REMOVE_OWNER;
                              data = {
                                ownerAddress: adds ? adds : removes,
                                safeAddress: options.safeAddress
                              };
                              data.ownerAddress = web3.utils.toChecksumAddress(data.ownerAddress);
                            } else if (notification.type === TYPE_TRANSFER) {
                              var _notification$transfe = notification.transfer,
                                from = _notification$transfe.from,
                                to = _notification$transfe.to,
                                amount = _notification$transfe.amount;
                              type = ActivityTypes.TRANSFER;
                              data = {
                                from: web3.utils.toChecksumAddress(from),
                                to: web3.utils.toChecksumAddress(to),
                                value: new web3.utils.BN(amount)
                              };
                            } else if (notification.type === TYPE_HUB_TRANSFER) {
                              var _notification$hubTran = notification.hubTransfer,
                                _from = _notification$hubTran.from,
                                _to = _notification$hubTran.to,
                                _amount = _notification$hubTran.amount;
                              type = ActivityTypes.HUB_TRANSFER;
                              data = {
                                from: web3.utils.toChecksumAddress(_from),
                                to: web3.utils.toChecksumAddress(_to),
                                value: new web3.utils.BN(_amount)
                              };
                            } else if (notification.type === TYPE_TRUST) {
                              var _notification$trust = notification.trust,
                                user = _notification$trust.user,
                                canSendTo = _notification$trust.canSendTo,
                                limitPercentage = _notification$trust.limitPercentage;
                              if (limitPercentage === '0') {
                                type = ActivityTypes.REMOVE_CONNECTION;
                              } else {
                                type = ActivityTypes.ADD_CONNECTION;
                              }
                              data = {
                                user: web3.utils.toChecksumAddress(user),
                                canSendTo: web3.utils.toChecksumAddress(canSendTo),
                                limitPercentage: parseInt(limitPercentage, 10)
                              };
                            } else {
                              return acc;
                            }
                            if (type === ActivityTypes.ADD_CONNECTION && data.canSendTo === data.user) {
                              return acc;
                            }
                            if (type === ActivityTypes.TRANSFER && data.from !== ZERO_ADDRESS && options.otherSafeAddress === ZERO_ADDRESS) {
                              return acc;
                            }
                            var transactionHash = notification.transactionHash;
                            acc.push({
                              data: data,
                              timestamp: timestamp,
                              transactionHash: transactionHash,
                              type: type
                            });
                            return acc;
                          }, []));
                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function getNotifications(_x3) {
                    return _ref.apply(this, arguments);
                  };
                }();
                activities = [];
                if (!(options.filter === ActivityFilterTypes.TRANSFERS)) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 7;
                return Promise.all([getNotifications(TYPE_TRANSFER), getNotifications(TYPE_HUB_TRANSFER)]);
              case 7:
                activities = _context2.sent.flat().sort(function (_ref2, _ref3) {
                  var itemA = _ref2.timestamp;
                  var itemB = _ref3.timestamp;
                  return itemA - itemB;
                });
                _context2.next = 14;
                break;
              case 10:
                if (options.filter === ActivityFilterTypes.CONNECTIONS) {
                  filterString = TYPE_TRUST;
                } else if (options.filter === ActivityFilterTypes.OWNERS) {
                  filterString = TYPE_TRANSFER;
                }
                _context2.next = 13;
                return getNotifications(filterString);
              case 13:
                activities = _context2.sent;
              case 14:
                if (!(activities.length === 0)) {
                  _context2.next = 16;
                  break;
                }
                return _context2.abrupt("return", {
                  activities: [],
                  lastTimestamp: 0
                });
              case 16:
                return _context2.abrupt("return", {
                  activities: activities,
                  lastTimestamp: activities[0].timestamp
                });
              case 17:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function getLatest(_x, _x2) {
          return _getLatest.apply(this, arguments);
        }
        return getLatest;
      }()
    };
  }

  function createAvatarModule(web3, utils) {
    return {
      upload: function upload(account, data) {
        checkAccount(web3, account);
        return utils.requestAPI({
          path: ['uploads', 'avatar'],
          method: 'POST',
          data: data
        });
      },
      "delete": function () {
        var _delete2 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(account, userOptions) {
          var options, url;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  url: {
                    type: 'string'
                  }
                });
                url = options.url;
                _context.next = 5;
                return utils.requestAPI({
                  path: ['uploads', 'avatar'],
                  method: 'DELETE',
                  data: {
                    url: url
                  }
                });
              case 5:
                return _context.abrupt("return", true);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function _delete(_x, _x2) {
          return _delete2.apply(this, arguments);
        }
        return _delete;
      }()
    };
  }

  function createNewsModule(utils) {
    return {
      getLatestNews: function () {
        var _getLatestNews = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(userOptions) {
          var options, afterDate, isActive, limit, offset, response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                options = checkOptions(userOptions, {
                  afterDate: {
                    type: 'string',
                    "default": CIRCLES_INCEPTION_TIMESTAMP.toString()
                  },
                  isActive: {
                    type: 'boolean',
                    "default": true
                  },
                  limit: {
                    type: 'number',
                    "default": 10
                  },
                  offset: {
                    type: 'number',
                    "default": 0
                  }
                });
                afterDate = options.afterDate, isActive = options.isActive, limit = options.limit, offset = options.offset;
                _context.next = 4;
                return utils.requestAPI({
                  path: ['news'],
                  method: 'GET',
                  data: {
                    afterDate: afterDate,
                    isActive: isActive,
                    limit: limit,
                    offset: offset
                  }
                });
              case 4:
                response = _context.sent;
                return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getLatestNews(_x) {
          return _getLatestNews.apply(this, arguments);
        }
        return getLatestNews;
      }()
    };
  }

  function loop(_x, _x2) {
    return _loop.apply(this, arguments);
  }
  function _loop() {
    _loop = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(request, condition) {
      var _ref,
        label,
        _ref$maxAttempts,
        maxAttempts,
        _ref$retryDelay,
        retryDelay,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, label = _ref.label, _ref$maxAttempts = _ref.maxAttempts, maxAttempts = _ref$maxAttempts === void 0 ? 30 : _ref$maxAttempts, _ref$retryDelay = _ref.retryDelay, retryDelay = _ref$retryDelay === void 0 ? 6000 : _ref$retryDelay;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var attempt = 0;
              var run = function run() {
                if (attempt > maxAttempts) {
                  throw new CoreError("Tried too many times waiting for condition".concat(label && ": \"".concat(label, "\"")), ErrorCodes.TOO_MANY_ATTEMPTS);
                }
                return request().then(function (data) {
                  if (condition(data)) {
                    return data;
                  } else {
                    attempt += 1;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, retryDelay);
                    }).then(run);
                  }
                });
              };
              run().then(resolve)["catch"](reject);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _loop.apply(this, arguments);
  }

  function _getOwners2(_x, _x2) {
    return _getOwners.apply(this, arguments);
  }
  function _getOwners() {
    _getOwners = _asyncToGenerator( _regeneratorRuntime.mark(function _callee13(web3, safeAddress) {
      var safe;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            safe = getSafeContract(web3, safeAddress);
            _context13.next = 3;
            return safe.methods.getOwners().call();
          case 3:
            return _context13.abrupt("return", _context13.sent);
          case 4:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return _getOwners.apply(this, arguments);
  }
  function _getVersion2(_x3, _x4) {
    return _getVersion.apply(this, arguments);
  }
  function _getVersion() {
    _getVersion = _asyncToGenerator( _regeneratorRuntime.mark(function _callee14(web3, safeAddress) {
      var safe;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            safe = getSafeContract(web3, safeAddress);
            _context14.next = 3;
            return safe.methods.VERSION().call();
          case 3:
            return _context14.abrupt("return", _context14.sent);
          case 4:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return _getVersion.apply(this, arguments);
  }
  function _predictAddress2(_x5, _x6, _x7, _x8) {
    return _predictAddress.apply(this, arguments);
  }
  function _predictAddress() {
    _predictAddress = _asyncToGenerator( _regeneratorRuntime.mark(function _callee15(web3, utils, nonce, address) {
      var _yield$utils$requestR2, safe;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return utils.requestRelayer({
              path: ['safes', 'predict'],
              version: 3,
              method: 'POST',
              data: {
                saltNonce: nonce,
                owners: [address],
                threshold: SAFE_THRESHOLD
              }
            });
          case 2:
            _yield$utils$requestR2 = _context15.sent;
            safe = _yield$utils$requestR2.safe;
            return _context15.abrupt("return", web3.utils.toChecksumAddress(safe));
          case 5:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _predictAddress.apply(this, arguments);
  }
  function _getSafeStatus2(_x9, _x10) {
    return _getSafeStatus.apply(this, arguments);
  }
  function _getSafeStatus() {
    _getSafeStatus = _asyncToGenerator( _regeneratorRuntime.mark(function _callee16(utils, safeAddress) {
      var isCreated, isDeployed, _yield$utils$requestR3, txHash;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            isCreated = false;
            isDeployed = false;
            _context16.prev = 2;
            _context16.next = 5;
            return utils.requestRelayer({
              path: ['safes', safeAddress, 'funded'],
              version: 2
            });
          case 5:
            _yield$utils$requestR3 = _context16.sent;
            txHash = _yield$utils$requestR3.txHash;
            isCreated = true;
            isDeployed = txHash !== null;
            _context16.next = 15;
            break;
          case 11:
            _context16.prev = 11;
            _context16.t0 = _context16["catch"](2);
            if (!(!_context16.t0.request || _context16.t0.request.status !== 404)) {
              _context16.next = 15;
              break;
            }
            throw _context16.t0;
          case 15:
            return _context16.abrupt("return", {
              isCreated: isCreated,
              isDeployed: isDeployed
            });
          case 16:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[2, 11]]);
    }));
    return _getSafeStatus.apply(this, arguments);
  }
  function createSafeModule(web3, contracts, utils, globalOptions) {
    var fallbackHandlerAddress = globalOptions.fallbackHandlerAddress;
    var safeMaster = contracts.safeMaster;
    return {
      predictAddress: function () {
        var _predictAddress3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  nonce: {
                    type: 'number'
                  }
                });
                _context.next = 4;
                return _predictAddress2(web3, utils, options.nonce, account.address);
              case 4:
                return _context.abrupt("return", _context.sent);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function predictAddress(_x11, _x12) {
          return _predictAddress3.apply(this, arguments);
        }
        return predictAddress;
      }(),
      getSafeStatus: function () {
        var _getSafeStatus3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context2.next = 4;
                return _getSafeStatus2(utils, options.safeAddress);
              case 4:
                return _context2.abrupt("return", _context2.sent);
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function getSafeStatus(_x13, _x14) {
          return _getSafeStatus3.apply(this, arguments);
        }
        return getSafeStatus;
      }(),
      prepareDeploy: function () {
        var _prepareDeploy = _asyncToGenerator( _regeneratorRuntime.mark(function _callee3(account, userOptions) {
          var options, predictedSafeAddress, status, _yield$utils$requestR, safe;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  nonce: {
                    type: 'number'
                  }
                });
                _context3.next = 4;
                return _predictAddress2(web3, utils, options.nonce, account.address);
              case 4:
                predictedSafeAddress = _context3.sent;
                _context3.next = 7;
                return _getSafeStatus2(utils, predictedSafeAddress);
              case 7:
                status = _context3.sent;
                if (!status.isCreated) {
                  _context3.next = 10;
                  break;
                }
                return _context3.abrupt("return", predictedSafeAddress);
              case 10:
                _context3.next = 12;
                return utils.requestRelayer({
                  path: ['safes'],
                  version: 3,
                  method: 'POST',
                  data: {
                    saltNonce: options.nonce,
                    owners: [account.address],
                    threshold: SAFE_THRESHOLD
                  }
                });
              case 12:
                _yield$utils$requestR = _context3.sent;
                safe = _yield$utils$requestR.safe;
                return _context3.abrupt("return", web3.utils.toChecksumAddress(safe));
              case 15:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function prepareDeploy(_x15, _x16) {
          return _prepareDeploy.apply(this, arguments);
        }
        return prepareDeploy;
      }(),
      isFunded: function () {
        var _isFunded = _asyncToGenerator( _regeneratorRuntime.mark(function _callee4(account, userOptions) {
          var options, result, balance;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context4.prev = 2;
                _context4.next = 5;
                return utils.requestRelayer({
                  path: ['safes', 'estimates'],
                  data: {
                    numberOwners: 1
                  },
                  version: 3,
                  method: 'POST'
                });
              case 5:
                result = _context4.sent;
                _context4.next = 8;
                return web3.eth.getBalance(options.safeAddress);
              case 8:
                balance = _context4.sent;
                return _context4.abrupt("return", web3.utils.toBN(balance).gte(web3.utils.toBN(result[0].payment)));
              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);
                return _context4.abrupt("return", false);
              case 15:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[2, 12]]);
        }));
        function isFunded(_x17, _x18) {
          return _isFunded.apply(this, arguments);
        }
        return isFunded;
      }(),
      deploy: function () {
        var _deploy = _asyncToGenerator( _regeneratorRuntime.mark(function _callee5(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context5.next = 4;
                return utils.requestRelayer({
                  path: ['safes', options.safeAddress, 'funded'],
                  version: 2,
                  method: 'PUT'
                });
              case 4:
                return _context5.abrupt("return", true);
              case 5:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function deploy(_x19, _x20) {
          return _deploy.apply(this, arguments);
        }
        return deploy;
      }(),
      deployForOrganization: function () {
        var _deployForOrganization = _asyncToGenerator( _regeneratorRuntime.mark(function _callee6(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context6.next = 4;
                return utils.requestRelayer({
                  path: ['safes', options.safeAddress, 'organization'],
                  version: 2,
                  method: 'PUT'
                });
              case 4:
                return _context6.abrupt("return", true);
              case 5:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        function deployForOrganization(_x21, _x22) {
          return _deployForOrganization.apply(this, arguments);
        }
        return deployForOrganization;
      }(),
      getAddresses: function () {
        var _getAddresses = _asyncToGenerator( _regeneratorRuntime.mark(function _callee7(account, userOptions) {
          var options, response;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  ownerAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context7.next = 4;
                return utils.requestIndexedDB('safe_addresses', options);
              case 4:
                response = _context7.sent;
                if (!(!response || !response.user)) {
                  _context7.next = 7;
                  break;
                }
                return _context7.abrupt("return", []);
              case 7:
                return _context7.abrupt("return", response.user.safeAddresses.map(function (address) {
                  return web3.utils.toChecksumAddress(address);
                }));
              case 8:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        function getAddresses(_x23, _x24) {
          return _getAddresses.apply(this, arguments);
        }
        return getAddresses;
      }(),
      getOwners: function () {
        var _getOwners3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee8(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context8.next = 4;
                return _getOwners2(web3, options.safeAddress);
              case 4:
                return _context8.abrupt("return", _context8.sent);
              case 5:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        function getOwners(_x25, _x26) {
          return _getOwners3.apply(this, arguments);
        }
        return getOwners;
      }(),
      addOwner: function () {
        var _addOwner = _asyncToGenerator( _regeneratorRuntime.mark(function _callee9(account, userOptions) {
          var options, safe, txData;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  ownerAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                safe = getSafeContract(web3, options.safeAddress);
                txData = safe.methods.addOwnerWithThreshold(options.ownerAddress, SAFE_THRESHOLD).encodeABI();
                _context9.next = 6;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: options.safeAddress,
                  txData: txData
                });
              case 6:
                return _context9.abrupt("return", _context9.sent);
              case 7:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        function addOwner(_x27, _x28) {
          return _addOwner.apply(this, arguments);
        }
        return addOwner;
      }(),
      removeOwner: function () {
        var _removeOwner = _asyncToGenerator( _regeneratorRuntime.mark(function _callee10(account, userOptions) {
          var options, safe, owners, ownerIndex, prevOwner, txData;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  ownerAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                safe = getSafeContract(web3, options.safeAddress);
                _context10.next = 5;
                return _getOwners2(web3, options.safeAddress);
              case 5:
                owners = _context10.sent;
                ownerIndex = owners.findIndex(function (owner) {
                  return owner === options.ownerAddress;
                });
                prevOwner = ownerIndex > 0 ? owners[ownerIndex - 1] : SENTINEL_ADDRESS;
                _context10.next = 10;
                return safe.methods.removeOwner(prevOwner, options.ownerAddress, SAFE_THRESHOLD).encodeABI();
              case 10:
                txData = _context10.sent;
                _context10.next = 13;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: options.safeAddress,
                  txData: txData
                });
              case 13:
                return _context10.abrupt("return", _context10.sent);
              case 14:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        function removeOwner(_x29, _x30) {
          return _removeOwner.apply(this, arguments);
        }
        return removeOwner;
      }(),
      getVersion: function () {
        var _getVersion3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee11(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context11.next = 4;
                return _getVersion2(web3, options.safeAddress);
              case 4:
                return _context11.abrupt("return", _context11.sent);
              case 5:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }));
        function getVersion(_x31, _x32) {
          return _getVersion3.apply(this, arguments);
        }
        return getVersion;
      }(),
      updateToLastVersion: function () {
        var _updateToLastVersion = _asyncToGenerator( _regeneratorRuntime.mark(function _callee12(account, userOptions) {
          var options, safeVersion, txHashChangeMasterCopy, txHashFallbackHandler, safeInstance, updateSafeTxData, fallbackHandlerTxData;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context12.next = 4;
                return _getVersion2(web3, options.safeAddress);
              case 4:
                safeVersion = _context12.sent;
                if (!(safeVersion != SAFE_LAST_VERSION)) {
                  _context12.next = 19;
                  break;
                }
                safeInstance = getSafeCRCVersionContract(web3, options.safeAddress);
                updateSafeTxData = safeInstance.methods.changeMasterCopy(safeMaster.options.address).encodeABI();
                _context12.next = 10;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: options.safeAddress,
                  txData: updateSafeTxData,
                  isCRCVersion: true
                });
              case 10:
                txHashChangeMasterCopy = _context12.sent;
                if (txHashChangeMasterCopy) {
                  _context12.next = 13;
                  break;
                }
                throw new CoreError("Safe with version ".concat(safeVersion, " failed to change the Master Copy"));
              case 13:
                _context12.next = 15;
                return loop(function () {
                  return _getVersion2(web3, options.safeAddress);
                }, function (version) {
                  return version == SAFE_LAST_VERSION;
                });
              case 15:
                fallbackHandlerTxData = safeInstance.methods.setFallbackHandler(fallbackHandlerAddress).encodeABI();
                _context12.next = 18;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: options.safeAddress,
                  txData: fallbackHandlerTxData
                });
              case 18:
                txHashFallbackHandler = _context12.sent;
              case 19:
                return _context12.abrupt("return", {
                  txHashChangeMasterCopy: txHashChangeMasterCopy,
                  txHashFallbackHandler: txHashFallbackHandler
                });
              case 20:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        function updateToLastVersion(_x33, _x34) {
          return _updateToLastVersion.apply(this, arguments);
        }
        return updateToLastVersion;
      }()
    };
  }

  function createOrganizationModule(web3, contracts, utils) {
    var hub = contracts.hub;
    return {
      isFunded: function () {
        var _isFunded = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(account, userOptions) {
          var options, txData, signupCosts, balance;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context.next = 4;
                return web3.eth.getCode(options.safeAddress);
              case 4:
                _context.t0 = _context.sent;
                if (!(_context.t0 === '0x')) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", false);
              case 7:
                _context.next = 9;
                return hub.methods.organizationSignup().encodeABI();
              case 9:
                txData = _context.sent;
                _context.prev = 10;
                _context.next = 13;
                return utils.estimateTransactionCosts(account, {
                  safeAddress: options.safeAddress,
                  to: hub.options.address,
                  txData: txData
                });
              case 13:
                signupCosts = _context.sent;
                _context.next = 16;
                return web3.eth.getBalance(options.safeAddress);
              case 16:
                balance = _context.sent;
                return _context.abrupt("return", web3.utils.toBN(balance).gte(signupCosts));
              case 20:
                _context.prev = 20;
                _context.t1 = _context["catch"](10);
                return _context.abrupt("return", false);
              case 23:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[10, 20]]);
        }));
        function isFunded(_x, _x2) {
          return _isFunded.apply(this, arguments);
        }
        return isFunded;
      }(),
      deploy: function () {
        var _deploy = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(account, userOptions) {
          var options, txData;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context2.next = 4;
                return hub.methods.organizationSignup().encodeABI();
              case 4:
                txData = _context2.sent;
                _context2.next = 7;
                return utils.executeSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: hub.options.address,
                  txData: txData
                });
              case 7:
                return _context2.abrupt("return", _context2.sent);
              case 8:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function deploy(_x3, _x4) {
          return _deploy.apply(this, arguments);
        }
        return deploy;
      }(),
      isOrganization: function () {
        var _isOrganization = _asyncToGenerator( _regeneratorRuntime.mark(function _callee3(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context3.next = 4;
                return hub.methods.organizations(options.safeAddress).call();
              case 4:
                return _context3.abrupt("return", _context3.sent);
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function isOrganization(_x5, _x6) {
          return _isOrganization.apply(this, arguments);
        }
        return isOrganization;
      }(),
      prefund: function () {
        var _prefund = _asyncToGenerator( _regeneratorRuntime.mark(function _callee4(account, userOptions) {
          var options, isOrganization, tokenAddress, tokenContract, balance, value, txDataAddConnection, txHashAddConnection, transfer, txData, txHash;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  from: {
                    type: web3.utils.checkAddressChecksum
                  },
                  to: {
                    type: web3.utils.checkAddressChecksum
                  },
                  value: {
                    type: web3.utils.isBN
                  }
                });
                _context4.next = 4;
                return hub.methods.organizations(options.to).call();
              case 4:
                isOrganization = _context4.sent;
                if (isOrganization) {
                  _context4.next = 7;
                  break;
                }
                throw new CoreError('Given address is not an organization');
              case 7:
                _context4.next = 9;
                return hub.methods.userToToken(options.from).call();
              case 9:
                tokenAddress = _context4.sent;
                if (!(tokenAddress === ZERO_ADDRESS)) {
                  _context4.next = 12;
                  break;
                }
                throw new CoreError('No token given to pay transaction', ErrorCodes.INSUFFICIENT_FUNDS);
              case 12:
                tokenContract = getTokenContract(web3, tokenAddress);
                _context4.next = 15;
                return tokenContract.methods.balanceOf(options.from).call();
              case 15:
                balance = _context4.sent;
                value = options.value.toString();
                if (web3.utils.toBN(balance).gte(web3.utils.toBN(value))) {
                  _context4.next = 19;
                  break;
                }
                throw new CoreError('No sufficient funds to pay transaction', ErrorCodes.INSUFFICIENT_FUNDS);
              case 19:
                _context4.next = 21;
                return hub.methods.trust(options.from, 100).encodeABI();
              case 21:
                txDataAddConnection = _context4.sent;
                _context4.next = 24;
                return utils.executeSafeTx(account, {
                  safeAddress: options.to,
                  to: hub.options.address,
                  txData: txDataAddConnection
                });
              case 24:
                txHashAddConnection = _context4.sent;
                if (txHashAddConnection) {
                  _context4.next = 27;
                  break;
                }
                throw new CoreError('Organization failed to trust safe');
              case 27:
                _context4.next = 29;
                return loop(function () {
                  return hub.methods.limits(options.to, options.from).call();
                }, function (trustLimit) {
                  return trustLimit === '100';
                });
              case 29:
                transfer = {
                  tokenOwners: [options.from],
                  sources: [options.from],
                  destinations: [options.to],
                  values: [value]
                };
                _context4.next = 32;
                return hub.methods.transferThrough(transfer.tokenOwners, transfer.sources, transfer.destinations, transfer.values).encodeABI();
              case 32:
                txData = _context4.sent;
                _context4.next = 35;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.from,
                  to: hub.options.address,
                  txData: txData
                });
              case 35:
                txHash = _context4.sent;
                if (txHash) {
                  _context4.next = 38;
                  break;
                }
                throw new CoreError('Failed transfer to fund organization');
              case 38:
                return _context4.abrupt("return", txHash);
              case 39:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function prefund(_x7, _x8) {
          return _prefund.apply(this, arguments);
        }
        return prefund;
      }(),
      getMembers: function () {
        var _getMembers = _asyncToGenerator( _regeneratorRuntime.mark(function _callee5(account, userOptions) {
          var options, owners, promises, results;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context5.next = 4;
                return _getOwners2(web3, options.safeAddress);
              case 4:
                owners = _context5.sent;
                promises = owners.map(function (ownerAddress) {
                  return utils.requestIndexedDB('organization_status', ownerAddress);
                });
                _context5.next = 8;
                return Promise.all(promises);
              case 8:
                results = _context5.sent;
                return _context5.abrupt("return", results.reduce(function (acc, result) {
                  if (!result || !result.user) {
                    return;
                  }
                  acc.push({
                    ownerAddress: web3.utils.toChecksumAddress(result.user.id),
                    safeAddresses: result.user.safes.reduce(function (acc, safe) {
                      if (!safe.organization) {
                        acc.push(web3.utils.toChecksumAddress(safe.id));
                      }
                      return acc;
                    }, [])
                  });
                  return acc;
                }, []));
              case 10:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function getMembers(_x9, _x10) {
          return _getMembers.apply(this, arguments);
        }
        return getMembers;
      }()
    };
  }

  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }

  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _findTransitiveTransfer2(_x, _x2, _x3, _x4, _x5) {
    return _findTransitiveTransfer.apply(this, arguments);
  }
  function _findTransitiveTransfer() {
    _findTransitiveTransfer = _asyncToGenerator( _regeneratorRuntime.mark(function _callee13(web3, utils, userOptions, pathfinderType, pathfinderMaxTransferSteps) {
      var result;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!(pathfinderType == 'cli')) {
              _context13.next = 6;
              break;
            }
            _context13.next = 3;
            return findTransitiveTransferCli(web3, utils, userOptions);
          case 3:
            result = _context13.sent;
            _context13.next = 10;
            break;
          case 6:
            if (!(pathfinderType == 'server')) {
              _context13.next = 10;
              break;
            }
            _context13.next = 9;
            return findTransitiveTransferServer(web3, utils, userOptions, pathfinderMaxTransferSteps);
          case 9:
            result = _context13.sent;
          case 10:
            return _context13.abrupt("return", result);
          case 11:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return _findTransitiveTransfer.apply(this, arguments);
  }
  function findTransitiveTransferCli(_x6, _x7, _x8) {
    return _findTransitiveTransferCli.apply(this, arguments);
  }
  function _findTransitiveTransferCli() {
    _findTransitiveTransferCli = _asyncToGenerator( _regeneratorRuntime.mark(function _callee14(web3, utils, userOptions) {
      var options, response;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            options = checkOptions(userOptions, {
              from: {
                type: web3.utils.checkAddressChecksum
              },
              to: {
                type: web3.utils.checkAddressChecksum
              },
              value: {
                type: web3.utils.isBN
              },
              hops: {
                type: 'number',
                "default": 3
              }
            });
            _context14.prev = 1;
            _context14.next = 4;
            return utils.requestAPI({
              path: ['transfers'],
              method: 'POST',
              data: {
                from: options.from,
                to: options.to,
                value: options.value.toString(),
                hops: options.hops.toString()
              }
            });
          case 4:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);
          case 8:
            _context14.prev = 8;
            _context14.t0 = _context14["catch"](1);
            throw new TransferError(_context14.t0.message, ErrorCodes.UNKNOWN_ERROR);
          case 11:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[1, 8]]);
    }));
    return _findTransitiveTransferCli.apply(this, arguments);
  }
  function findTransitiveTransferServer(_x9, _x10, _x11, _x12) {
    return _findTransitiveTransferServer.apply(this, arguments);
  }
  function _findTransitiveTransferServer() {
    _findTransitiveTransferServer = _asyncToGenerator( _regeneratorRuntime.mark(function _callee15(web3, utils, userOptions, pathfinderMaxTransferSteps) {
      var options, response;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            options = checkOptions(userOptions, {
              from: {
                type: web3.utils.checkAddressChecksum
              },
              to: {
                type: web3.utils.checkAddressChecksum
              },
              value: {
                type: web3.utils.isBN
              },
              maxTransfers: {
                type: 'number',
                "default": pathfinderMaxTransferSteps
              }
            });
            _context15.prev = 1;
            _context15.next = 4;
            return utils.requestPathfinderAPI({
              method: 'POST',
              data: {
                id: crypto.randomUUID(),
                method: 'compute_transfer',
                params: {
                  from: options.from,
                  to: options.to,
                  value: options.value.toString(),
                  max_transfers: options.maxTransfers
                }
              },
              isTrailingSlash: false
            });
          case 4:
            response = _context15.sent;
            return _context15.abrupt("return", response.result);
          case 8:
            _context15.prev = 8;
            _context15.t0 = _context15["catch"](1);
            throw new TransferError(_context15.t0.message, ErrorCodes.UNKNOWN_ERROR);
          case 11:
          case "end":
            return _context15.stop();
        }
      }, _callee15, null, [[1, 8]]);
    }));
    return _findTransitiveTransferServer.apply(this, arguments);
  }
  function updateTransitiveTransfer(_x13, _x14, _x15) {
    return _updateTransitiveTransfer.apply(this, arguments);
  }
  function _updateTransitiveTransfer() {
    _updateTransitiveTransfer = _asyncToGenerator( _regeneratorRuntime.mark(function _callee16(web3, utils, userOptions) {
      var options, response;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            options = checkOptions(userOptions, {
              from: {
                type: web3.utils.checkAddressChecksum
              },
              to: {
                type: web3.utils.checkAddressChecksum
              },
              value: {
                type: web3.utils.isBN
              },
              hops: {
                type: 'number',
                "default": 3
              }
            });
            _context16.prev = 1;
            _context16.next = 4;
            return utils.requestAPI({
              path: ['transfers', 'update'],
              method: 'POST',
              data: {
                from: options.from,
                to: options.to,
                value: options.value.toString(),
                hops: options.hops.toString()
              }
            });
          case 4:
            response = _context16.sent;
            return _context16.abrupt("return", response.data);
          case 8:
            _context16.prev = 8;
            _context16.t0 = _context16["catch"](1);
            throw new TransferError(_context16.t0.message, ErrorCodes.UNKNOWN_ERROR);
          case 11:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[1, 8]]);
    }));
    return _updateTransitiveTransfer.apply(this, arguments);
  }
  function createTokenModule(web3, contracts, utils, globalOptions) {
    var hub = contracts.hub;
    var pathfinderType = globalOptions.pathfinderType,
      pathfinderMaxTransferSteps = globalOptions.pathfinderMaxTransferSteps;
    return {
      isFunded: function () {
        var _isFunded = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(account, userOptions) {
          var options, txData, costs, balance;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context.next = 4;
                return web3.eth.getCode(options.safeAddress);
              case 4:
                _context.t0 = _context.sent;
                if (!(_context.t0 === '0x')) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", false);
              case 7:
                _context.next = 9;
                return hub.methods.signup().encodeABI();
              case 9:
                txData = _context.sent;
                _context.prev = 10;
                _context.next = 13;
                return utils.estimateTransactionCosts(account, {
                  safeAddress: options.safeAddress,
                  to: hub.options.address,
                  txData: txData
                });
              case 13:
                costs = _context.sent;
                _context.next = 16;
                return web3.eth.getBalance(options.safeAddress);
              case 16:
                balance = _context.sent;
                return _context.abrupt("return", web3.utils.toBN(balance).gte(costs));
              case 20:
                _context.prev = 20;
                _context.t1 = _context["catch"](10);
                return _context.abrupt("return", false);
              case 23:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[10, 20]]);
        }));
        function isFunded(_x16, _x17) {
          return _isFunded.apply(this, arguments);
        }
        return isFunded;
      }(),
      checkSendLimit: function () {
        var _checkSendLimit = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(account, userOptions) {
          var options, sendLimit;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  from: {
                    type: web3.utils.checkAddressChecksum
                  },
                  to: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context2.next = 4;
                return hub.methods.checkSendLimit(options.from, options.from, options.to).call();
              case 4:
                sendLimit = _context2.sent;
                return _context2.abrupt("return", web3.utils.toBN(sendLimit));
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function checkSendLimit(_x18, _x19) {
          return _checkSendLimit.apply(this, arguments);
        }
        return checkSendLimit;
      }(),
      deploy: function () {
        var _deploy = _asyncToGenerator( _regeneratorRuntime.mark(function _callee3(account, userOptions) {
          var options, txData, safeVersion;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context3.next = 4;
                return hub.methods.signup().encodeABI();
              case 4:
                txData = _context3.sent;
                _context3.next = 7;
                return _getVersion2(web3, options.safeAddress);
              case 7:
                safeVersion = _context3.sent;
                _context3.next = 10;
                return utils.executeSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: hub.options.address,
                  txData: txData,
                  isCRCVersion: safeVersion != SAFE_LAST_VERSION
                });
              case 10:
                return _context3.abrupt("return", _context3.sent);
              case 11:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function deploy(_x20, _x21) {
          return _deploy.apply(this, arguments);
        }
        return deploy;
      }(),
      getAddress: function () {
        var _getAddress = _asyncToGenerator( _regeneratorRuntime.mark(function _callee4(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context4.next = 4;
                return hub.methods.userToToken(options.safeAddress).call();
              case 4:
                return _context4.abrupt("return", _context4.sent);
              case 5:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function getAddress(_x22, _x23) {
          return _getAddress.apply(this, arguments);
        }
        return getAddress;
      }(),
      listAllTokens: function () {
        var _listAllTokens = _asyncToGenerator( _regeneratorRuntime.mark(function _callee5(account, userOptions) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                checkAccount(web3, account);
                _context5.next = 3;
                return utils.listAllTokens(userOptions);
              case 3:
                return _context5.abrupt("return", _context5.sent);
              case 4:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function listAllTokens(_x24, _x25) {
          return _listAllTokens.apply(this, arguments);
        }
        return listAllTokens;
      }(),
      getBalance: function () {
        var _getBalance = _asyncToGenerator( _regeneratorRuntime.mark(function _callee6(account, userOptions) {
          var options, safeAddress, tokenAddress, response, token;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  tokenAddress: {
                    type: web3.utils.checkAddressChecksum,
                    "default": ZERO_ADDRESS
                  }
                });
                safeAddress = options.safeAddress, tokenAddress = options.tokenAddress;
                _context6.next = 5;
                return utils.requestIndexedDB('balances', safeAddress);
              case 5:
                response = _context6.sent;
                if (!(!response || !response.safe)) {
                  _context6.next = 8;
                  break;
                }
                throw new CoreError("Could not find Safe with address ".concat(safeAddress), ErrorCodes.SAFE_NOT_FOUND);
              case 8:
                if (!(tokenAddress !== ZERO_ADDRESS)) {
                  _context6.next = 13;
                  break;
                }
                token = response.safe.balances.find(function (item) {
                  return item.token.id === tokenAddress;
                });
                if (token) {
                  _context6.next = 12;
                  break;
                }
                return _context6.abrupt("return", web3.utils.toBN('0'));
              case 12:
                return _context6.abrupt("return", web3.utils.toBN(token.amount));
              case 13:
                return _context6.abrupt("return", response.safe.balances.reduce(function (acc, _ref) {
                  var amount = _ref.amount;
                  return acc.iadd(web3.utils.toBN(amount));
                }, web3.utils.toBN('0')));
              case 14:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        function getBalance(_x26, _x27) {
          return _getBalance.apply(this, arguments);
        }
        return getBalance;
      }(),
      findTransitiveTransfer: function () {
        var _findTransitiveTransfer3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee7(account, userOptions) {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                checkAccount(web3, account);
                _context7.next = 3;
                return _findTransitiveTransfer2(web3, utils, userOptions, pathfinderType, pathfinderMaxTransferSteps);
              case 3:
                return _context7.abrupt("return", _context7.sent);
              case 4:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        function findTransitiveTransfer(_x28, _x29) {
          return _findTransitiveTransfer3.apply(this, arguments);
        }
        return findTransitiveTransfer;
      }(),
      updateTransferSteps: function () {
        var _updateTransferSteps = _asyncToGenerator( _regeneratorRuntime.mark(function _callee8(account, userOptions) {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                checkAccount(web3, account);
                _context8.next = 3;
                return updateTransitiveTransfer(web3, utils, userOptions);
              case 3:
                return _context8.abrupt("return", _context8.sent);
              case 4:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        function updateTransferSteps(_x30, _x31) {
          return _updateTransferSteps.apply(this, arguments);
        }
        return updateTransferSteps;
      }(),
      transfer: function () {
        var _transfer = _asyncToGenerator( _regeneratorRuntime.mark(function _callee9(account, userOptions) {
          var fieldObject, options, transfer, sendLimitTo, response, txData, txHash, _web3$eth$accounts$si, signature;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                checkAccount(web3, account);
                if (pathfinderType == 'cli') {
                  fieldObject = {
                    from: {
                      type: web3.utils.checkAddressChecksum
                    },
                    to: {
                      type: web3.utils.checkAddressChecksum
                    },
                    value: {
                      type: web3.utils.isBN
                    },
                    paymentNote: {
                      type: 'string',
                      "default": ''
                    },
                    hops: {
                      type: 'number',
                      "default": 3
                    }
                  };
                } else {
                  fieldObject = {
                    from: {
                      type: web3.utils.checkAddressChecksum
                    },
                    to: {
                      type: web3.utils.checkAddressChecksum
                    },
                    value: {
                      type: web3.utils.isBN
                    },
                    paymentNote: {
                      type: 'string',
                      "default": ''
                    },
                    maxTransfers: {
                      type: 'number',
                      "default": pathfinderMaxTransferSteps
                    }
                  };
                }
                options = checkOptions(userOptions, fieldObject);
                transfer = {
                  tokenOwners: [],
                  sources: [],
                  destinations: [],
                  values: []
                };
                _context9.next = 6;
                return hub.methods.checkSendLimit(options.to, options.from, options.to).call();
              case 6:
                sendLimitTo = _context9.sent;
                if (!web3.utils.toBN(sendLimitTo).gte(options.value)) {
                  _context9.next = 14;
                  break;
                }
                transfer.tokenOwners.push(options.to);
                transfer.sources.push(options.from);
                transfer.destinations.push(options.to);
                transfer.values.push(options.value.toString());
                _context9.next = 32;
                break;
              case 14:
                _context9.prev = 14;
                _context9.next = 17;
                return _findTransitiveTransfer2(web3, utils, options, pathfinderType, pathfinderMaxTransferSteps);
              case 17:
                response = _context9.sent;
                if (!web3.utils.toBN(response.maxFlowValue).lt(options.value)) {
                  _context9.next = 20;
                  break;
                }
                throw new TransferError('No possible transfer found', ErrorCodes.TRANSFER_NOT_FOUND, _objectSpread(_objectSpread({}, options), {}, {
                  response: response
                }));
              case 20:
                if (!(response.transferSteps.length > pathfinderMaxTransferSteps)) {
                  _context9.next = 22;
                  break;
                }
                throw new TransferError('Too many transfer steps', ErrorCodes.TOO_COMPLEX_TRANSFER, _objectSpread(_objectSpread({}, options), {}, {
                  response: response
                }));
              case 22:
                if (pathfinderType == 'cli') {
                  response.transferSteps.forEach(function (transaction) {
                    transfer.tokenOwners.push(transaction.tokenOwnerAddress);
                    transfer.sources.push(transaction.from);
                    transfer.destinations.push(transaction.to);
                    transfer.values.push(transaction.value);
                  });
                } else if (pathfinderType == 'server') {
                  response.transferSteps.forEach(function (transaction) {
                    transfer.tokenOwners.push(transaction.token_owner);
                    transfer.sources.push(transaction.from);
                    transfer.destinations.push(transaction.to);
                    transfer.values.push(transaction.value);
                  });
                }
                _context9.next = 32;
                break;
              case 25:
                _context9.prev = 25;
                _context9.t0 = _context9["catch"](14);
                if (_context9.t0.code) {
                  _context9.next = 31;
                  break;
                }
                throw new TransferError(_context9.t0.message, ErrorCodes.INVALID_TRANSFER, _objectSpread(_objectSpread({}, options), {}, {
                  response: response
                }));
              case 31:
                throw _context9.t0;
              case 32:
                _context9.next = 34;
                return hub.methods.transferThrough(transfer.tokenOwners, transfer.sources, transfer.destinations, transfer.values).encodeABI();
              case 34:
                txData = _context9.sent;
                _context9.next = 37;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.from,
                  to: hub.options.address,
                  txData: txData,
                  transferData: transfer
                });
              case 37:
                txHash = _context9.sent;
                if (!(options.paymentNote.length === 0)) {
                  _context9.next = 40;
                  break;
                }
                return _context9.abrupt("return", txHash);
              case 40:
                if (txHash) {
                  _context9.next = 42;
                  break;
                }
                return _context9.abrupt("return", null);
              case 42:
                _web3$eth$accounts$si = web3.eth.accounts.sign([options.from, options.to, txHash].join(''), account.privateKey), signature = _web3$eth$accounts$si.signature;
                _context9.next = 45;
                return utils.requestAPI({
                  path: ['transfers'],
                  method: 'PUT',
                  data: {
                    address: account.address,
                    signature: signature,
                    data: {
                      from: options.from,
                      to: options.to,
                      transactionHash: txHash,
                      paymentNote: options.paymentNote
                    }
                  }
                });
              case 45:
                return _context9.abrupt("return", txHash);
              case 46:
              case "end":
                return _context9.stop();
            }
          }, _callee9, null, [[14, 25]]);
        }));
        function transfer(_x32, _x33) {
          return _transfer.apply(this, arguments);
        }
        return transfer;
      }(),
      getPaymentNote: function () {
        var _getPaymentNote = _asyncToGenerator( _regeneratorRuntime.mark(function _callee10(account, userOptions) {
          var options, _web3$eth$accounts$si2, signature, response;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  transactionHash: {
                    type: function type(value) {
                      return /^0x([A-Fa-f0-9]{64})$/.test(value);
                    }
                  }
                });
                _web3$eth$accounts$si2 = web3.eth.accounts.sign([options.transactionHash].join(''), account.privateKey), signature = _web3$eth$accounts$si2.signature;
                _context10.prev = 3;
                _context10.next = 6;
                return utils.requestAPI({
                  path: ['transfers', options.transactionHash],
                  method: 'POST',
                  data: {
                    address: account.address,
                    signature: signature
                  }
                });
              case 6:
                response = _context10.sent;
                if (!(response && response.data && response.data.paymentNote)) {
                  _context10.next = 9;
                  break;
                }
                return _context10.abrupt("return", response.data.paymentNote);
              case 9:
                _context10.next = 15;
                break;
              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10["catch"](3);
                if (!(!_context10.t0.request || _context10.t0.request.status !== 404 && _context10.t0.request.status !== 403)) {
                  _context10.next = 15;
                  break;
                }
                throw _context10.t0;
              case 15:
                return _context10.abrupt("return", null);
              case 16:
              case "end":
                return _context10.stop();
            }
          }, _callee10, null, [[3, 11]]);
        }));
        function getPaymentNote(_x34, _x35) {
          return _getPaymentNote.apply(this, arguments);
        }
        return getPaymentNote;
      }(),
      checkUBIPayout: function () {
        var _checkUBIPayout = _asyncToGenerator( _regeneratorRuntime.mark(function _callee11(account, userOptions) {
          var options, tokenAddress, token, payout;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context11.next = 4;
                return hub.methods.userToToken(options.safeAddress).call();
              case 4:
                tokenAddress = _context11.sent;
                if (!(tokenAddress === ZERO_ADDRESS)) {
                  _context11.next = 7;
                  break;
                }
                throw new CoreError('Invalid Token address. Did you forget to deploy the Token?', ErrorCodes.TOKEN_NOT_FOUND);
              case 7:
                _context11.next = 9;
                return getTokenContract(web3, tokenAddress);
              case 9:
                token = _context11.sent;
                _context11.next = 12;
                return token.methods.look().call();
              case 12:
                payout = _context11.sent;
                return _context11.abrupt("return", web3.utils.toBN(payout));
              case 14:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }));
        function checkUBIPayout(_x36, _x37) {
          return _checkUBIPayout.apply(this, arguments);
        }
        return checkUBIPayout;
      }(),
      requestUBIPayout: function () {
        var _requestUBIPayout = _asyncToGenerator( _regeneratorRuntime.mark(function _callee12(account, userOptions) {
          var options, safeAddress, tokenAddress, token, ubiTxData;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                safeAddress = options.safeAddress;
                _context12.next = 5;
                return hub.methods.userToToken(safeAddress).call();
              case 5:
                tokenAddress = _context12.sent;
                if (!(tokenAddress === ZERO_ADDRESS)) {
                  _context12.next = 8;
                  break;
                }
                throw new CoreError('Invalid Token address. Did you forget to deploy the Token?', ErrorCodes.TOKEN_NOT_FOUND);
              case 8:
                _context12.next = 10;
                return getTokenContract(web3, tokenAddress);
              case 10:
                token = _context12.sent;
                _context12.next = 13;
                return token.methods.update().encodeABI();
              case 13:
                ubiTxData = _context12.sent;
                _context12.next = 16;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.safeAddress,
                  to: token.options.address,
                  txData: ubiTxData
                });
              case 16:
                return _context12.abrupt("return", _context12.sent);
              case 17:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        function requestUBIPayout(_x38, _x39) {
          return _requestUBIPayout.apply(this, arguments);
        }
        return requestUBIPayout;
      }()
    };
  }

  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
  }

  function createTrustModule(web3, contracts, utils) {
    var hub = contracts.hub;
    return {
      isTrusted: function () {
        var _isTrusted = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(account, userOptions) {
          var options, safeAddress, response, trustConnections;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  limit: {
                    type: 'number',
                    "default": DEFAULT_TRUST_LIMIT
                  }
                });
                safeAddress = options.safeAddress.toLowerCase();
                _context.next = 5;
                return utils.requestIndexedDB('trust_network', safeAddress);
              case 5:
                response = _context.sent;
                if (response) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", {
                  trustConnections: 0,
                  isTrusted: false
                });
              case 8:
                trustConnections = response.trusts.filter(function (connection) {
                  return parseInt(connection.limitPercentage, 10) !== NO_LIMIT_PERCENTAGE;
                });
                return _context.abrupt("return", {
                  trustConnections: trustConnections.length,
                  isTrusted: trustConnections.length >= options.limit
                });
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function isTrusted(_x, _x2) {
          return _isTrusted.apply(this, arguments);
        }
        return isTrusted;
      }(),
      getNetwork: function getNetwork(account, userOptions) {
        checkAccount(web3, account);
        var _checkOptions = checkOptions(userOptions, {
            safeAddress: {
              type: web3.utils.checkAddressChecksum
            }
          }),
          safeAddress = _checkOptions.safeAddress;
        return utils.requestIndexedDB('trust_status', safeAddress.toLowerCase()).then(function () {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            safe = _ref.safe;
          var network = {};
          if (safe) {
            var trusters = safe.outgoing;
            var trustees = safe.incoming;
            trusters && trusters.forEach(function (truster) {
              var trusterAddress = web3.utils.toChecksumAddress(truster.canSendToAddress);
              var newConnection = {
                safeAddress: trusterAddress,
                isIncoming: false,
                isOutgoing: true,
                mutualConnections: []
              };
              network[trusterAddress] = newConnection;
            });
            trustees && trustees.forEach(function (trustee) {
              var trusteeAddress = web3.utils.toChecksumAddress(trustee.userAddress);
              var existingConnection = network[trusteeAddress];
              if (existingConnection) {
                existingConnection.isIncoming = true;
              } else {
                var newConnection = {
                  safeAddress: trusteeAddress,
                  isIncoming: true,
                  isOutgoing: false,
                  mutualConnections: []
                };
                network[trusteeAddress] = newConnection;
              }
              var trustersOfTrustee = trustee.user.outgoing;
              trustersOfTrustee && trustersOfTrustee.forEach(function (trusterOfTrustee) {
                var ttAddress = web3.utils.toChecksumAddress(trusterOfTrustee.canSendToAddress);
                if (ttAddress !== trusteeAddress) {
                  var _existingConnection = network[ttAddress];
                  if (_existingConnection) {
                    var previousMutualConnections = _existingConnection.mutualConnections;
                    _existingConnection.mutualConnections = [].concat(_toConsumableArray(previousMutualConnections), [trusteeAddress]);
                  } else {
                    var _newConnection = {
                      safeAddress: ttAddress,
                      isIncoming: false,
                      isOutgoing: false,
                      mutualConnections: [trusteeAddress]
                    };
                    network[ttAddress] = _newConnection;
                  }
                }
              });
            });
          }
          return Object.values(network);
        });
      },
      addConnection: function () {
        var _addConnection = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(account, userOptions) {
          var options, isOrgSignedup, txData;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  user: {
                    type: web3.utils.checkAddressChecksum
                  },
                  canSendTo: {
                    type: web3.utils.checkAddressChecksum
                  },
                  limitPercentage: {
                    type: 'number',
                    "default": DEFAULT_USER_LIMIT_PERCENTAGE
                  }
                });
                _context2.next = 4;
                return hub.methods.organizations(options.canSendTo).call();
              case 4:
                isOrgSignedup = _context2.sent;
                if (isOrgSignedup) {
                  options.limitPercentage = DEFAULT_ORG_LIMIT_PERCENTAGE;
                }
                _context2.next = 8;
                return hub.methods.trust(options.user, options.limitPercentage).encodeABI();
              case 8:
                txData = _context2.sent;
                _context2.next = 11;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.canSendTo,
                  to: hub.options.address,
                  txData: txData
                });
              case 11:
                return _context2.abrupt("return", _context2.sent);
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function addConnection(_x3, _x4) {
          return _addConnection.apply(this, arguments);
        }
        return addConnection;
      }(),
      removeConnection: function () {
        var _removeConnection = _asyncToGenerator( _regeneratorRuntime.mark(function _callee3(account, userOptions) {
          var options, txData;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  user: {
                    type: web3.utils.checkAddressChecksum
                  },
                  canSendTo: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context3.next = 4;
                return hub.methods.trust(options.user, NO_LIMIT_PERCENTAGE).encodeABI();
              case 4:
                txData = _context3.sent;
                _context3.next = 7;
                return utils.executeTokenSafeTx(account, {
                  safeAddress: options.canSendTo,
                  to: hub.options.address,
                  txData: txData
                });
              case 7:
                return _context3.abrupt("return", _context3.sent);
              case 8:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function removeConnection(_x5, _x6) {
          return _removeConnection.apply(this, arguments);
        }
        return removeConnection;
      }()
    };
  }

  function checkArrayEntries(arr, validatorFn) {
    if (!Array.isArray(arr)) {
      return false;
    }
    return arr.find(function (entry) {
      return !validatorFn(entry);
    }) === undefined;
  }

  function createUserModule(web3, contracts, utils) {
    return {
      dryRegister: function () {
        var _dryRegister = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(account, userOptions) {
          var options, avatarUrl, username, email;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  username: {
                    type: 'string',
                    "default": ''
                  },
                  email: {
                    type: 'string',
                    "default": ''
                  },
                  avatarUrl: {
                    type: 'string',
                    "default": ''
                  }
                });
                avatarUrl = options.avatarUrl, username = options.username, email = options.email;
                _context.next = 5;
                return utils.requestAPI({
                  path: ['users'],
                  method: 'POST',
                  data: {
                    email: email,
                    username: username,
                    avatarUrl: avatarUrl
                  }
                });
              case 5:
                return _context.abrupt("return", true);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function dryRegister(_x, _x2) {
          return _dryRegister.apply(this, arguments);
        }
        return dryRegister;
      }(),
      register: function () {
        var _register = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(account, userOptions) {
          var options, address, nonce, avatarUrl, safeAddress, username, email, _web3$eth$accounts$si, signature;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  nonce: {
                    type: 'number',
                    "default": 0
                  },
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  username: {
                    type: 'string',
                    "default": ''
                  },
                  email: {
                    type: 'string',
                    "default": ''
                  },
                  avatarUrl: {
                    type: 'string',
                    "default": ''
                  }
                });
                address = account.address;
                nonce = options.nonce, avatarUrl = options.avatarUrl, safeAddress = options.safeAddress, username = options.username, email = options.email;
                _web3$eth$accounts$si = web3.eth.accounts.sign([address, nonce, safeAddress, username].join(''), account.privateKey), signature = _web3$eth$accounts$si.signature;
                _context2.next = 7;
                return utils.requestAPI({
                  path: ['users'],
                  method: 'PUT',
                  data: {
                    address: account.address,
                    nonce: nonce > 0 ? nonce : null,
                    signature: signature,
                    data: {
                      email: email,
                      safeAddress: safeAddress,
                      username: username,
                      avatarUrl: avatarUrl
                    }
                  }
                });
              case 7:
                return _context2.abrupt("return", true);
              case 8:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function register(_x3, _x4) {
          return _register.apply(this, arguments);
        }
        return register;
      }(),
      update: function () {
        var _update = _asyncToGenerator( _regeneratorRuntime.mark(function _callee3(account, userOptions) {
          var options, address, safeAddress, username, email, avatarUrl, _web3$eth$accounts$si2, signature;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  username: {
                    type: 'string',
                    "default": ''
                  },
                  email: {
                    type: 'string',
                    "default": ''
                  },
                  avatarUrl: {
                    type: 'string',
                    "default": ''
                  }
                });
                address = account.address;
                safeAddress = options.safeAddress, username = options.username, email = options.email, avatarUrl = options.avatarUrl;
                _web3$eth$accounts$si2 = web3.eth.accounts.sign([address, safeAddress, username].join(''), account.privateKey), signature = _web3$eth$accounts$si2.signature;
                _context3.next = 7;
                return utils.requestAPI({
                  path: ['users', safeAddress],
                  method: 'POST',
                  data: {
                    address: account.address,
                    signature: signature,
                    data: {
                      safeAddress: safeAddress,
                      username: username,
                      email: email,
                      avatarUrl: avatarUrl
                    }
                  }
                });
              case 7:
                return _context3.abrupt("return", true);
              case 8:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function update(_x5, _x6) {
          return _update.apply(this, arguments);
        }
        return update;
      }(),
      "delete": function () {
        var _delete2 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee4(account, userOptions) {
          var options, address, safeAddress, _web3$eth$accounts$si3, signature;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                address = account.address;
                safeAddress = options.safeAddress;
                _web3$eth$accounts$si3 = web3.eth.accounts.sign([address, safeAddress].join(''), account.privateKey), signature = _web3$eth$accounts$si3.signature;
                _context4.next = 7;
                return utils.requestAPI({
                  path: ['users', safeAddress],
                  method: 'DELETE',
                  data: {
                    address: account.address,
                    signature: signature
                  }
                });
              case 7:
                return _context4.abrupt("return", true);
              case 8:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function _delete(_x7, _x8) {
          return _delete2.apply(this, arguments);
        }
        return _delete;
      }(),
      resolve: function () {
        var _resolve = _asyncToGenerator( _regeneratorRuntime.mark(function _callee5(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  addresses: {
                    type: function type(arr) {
                      return checkArrayEntries(arr, web3.utils.checkAddressChecksum);
                    },
                    "default": []
                  },
                  usernames: {
                    type: function type(arr) {
                      return checkArrayEntries(arr, function (entry) {
                        return /^[a-zA-Z0-9]+$/.test(entry);
                      });
                    },
                    "default": []
                  }
                });
                _context5.next = 4;
                return utils.requestAPI({
                  path: ['users'],
                  data: {
                    address: options.addresses,
                    username: options.usernames
                  }
                });
              case 4:
                return _context5.abrupt("return", _context5.sent);
              case 5:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function resolve(_x9, _x10) {
          return _resolve.apply(this, arguments);
        }
        return resolve;
      }(),
      search: function () {
        var _search = _asyncToGenerator( _regeneratorRuntime.mark(function _callee6(account, userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  query: {
                    type: 'string'
                  }
                });
                _context6.next = 4;
                return utils.requestAPI({
                  path: ['users'],
                  data: {
                    query: options.query
                  }
                });
              case 4:
                return _context6.abrupt("return", _context6.sent);
              case 5:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        function search(_x11, _x12) {
          return _search.apply(this, arguments);
        }
        return search;
      }(),
      getEmail: function () {
        var _getEmail = _asyncToGenerator( _regeneratorRuntime.mark(function _callee7(account, userOptions) {
          var options, address, safeAddress, _web3$eth$accounts$si4, signature, response;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                address = account.address;
                safeAddress = options.safeAddress;
                _web3$eth$accounts$si4 = web3.eth.accounts.sign([address, safeAddress].join(''), account.privateKey), signature = _web3$eth$accounts$si4.signature;
                _context7.prev = 5;
                _context7.next = 8;
                return utils.requestAPI({
                  path: ['users', safeAddress, 'email'],
                  method: 'POST',
                  data: {
                    address: account.address,
                    signature: signature
                  }
                });
              case 8:
                response = _context7.sent;
                if (!(response && response.data && response.data.email)) {
                  _context7.next = 11;
                  break;
                }
                return _context7.abrupt("return", response.data.email);
              case 11:
                _context7.next = 17;
                break;
              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](5);
                if (!(!_context7.t0.request || _context7.t0.request.status !== 404 && _context7.t0.request.status !== 403)) {
                  _context7.next = 17;
                  break;
                }
                throw _context7.t0;
              case 17:
                return _context7.abrupt("return", null);
              case 18:
              case "end":
                return _context7.stop();
            }
          }, _callee7, null, [[5, 13]]);
        }));
        function getEmail(_x13, _x14) {
          return _getEmail.apply(this, arguments);
        }
        return getEmail;
      }(),
      updateProfileMigrationConsent: function () {
        var _updateProfileMigrationConsent = _asyncToGenerator( _regeneratorRuntime.mark(function _callee8(account, userOptions) {
          var options, address, safeAddress, profileMigrationConsent, _web3$eth$accounts$si5, signature;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  profileMigrationConsent: {
                    type: 'boolean'
                  }
                });
                address = account.address;
                safeAddress = options.safeAddress, profileMigrationConsent = options.profileMigrationConsent;
                _web3$eth$accounts$si5 = web3.eth.accounts.sign([address, safeAddress, profileMigrationConsent].join(''), account.privateKey), signature = _web3$eth$accounts$si5.signature;
                _context8.next = 7;
                return utils.requestAPI({
                  path: ['users', safeAddress, 'update-profile-migration-consent'],
                  method: 'POST',
                  data: {
                    address: account.address,
                    signature: signature,
                    data: {
                      safeAddress: safeAddress,
                      profileMigrationConsent: profileMigrationConsent
                    }
                  }
                });
              case 7:
                return _context8.abrupt("return", true);
              case 8:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        function updateProfileMigrationConsent(_x15, _x16) {
          return _updateProfileMigrationConsent.apply(this, arguments);
        }
        return updateProfileMigrationConsent;
      }(),
      getProfileMigrationConsent: function () {
        var _getProfileMigrationConsent = _asyncToGenerator( _regeneratorRuntime.mark(function _callee9(account, userOptions) {
          var options, address, safeAddress, _web3$eth$accounts$si6, signature, response;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                address = account.address;
                safeAddress = options.safeAddress;
                _web3$eth$accounts$si6 = web3.eth.accounts.sign([address, safeAddress].join(''), account.privateKey), signature = _web3$eth$accounts$si6.signature;
                _context9.prev = 5;
                _context9.next = 8;
                return utils.requestAPI({
                  path: ['users', safeAddress, 'get-profile-migration-consent'],
                  method: 'POST',
                  data: {
                    address: account.address,
                    signature: signature
                  }
                });
              case 8:
                response = _context9.sent;
                if (!(response && 'data' in response && 'profileMigrationConsent' in response.data)) {
                  _context9.next = 11;
                  break;
                }
                return _context9.abrupt("return", response.data.profileMigrationConsent);
              case 11:
                _context9.next = 17;
                break;
              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9["catch"](5);
                if (!(!_context9.t0.request || _context9.t0.request.status !== 404 && _context9.t0.request.status !== 403)) {
                  _context9.next = 17;
                  break;
                }
                throw _context9.t0;
              case 17:
                return _context9.abrupt("return", null);
              case 18:
              case "end":
                return _context9.stop();
            }
          }, _callee9, null, [[5, 13]]);
        }));
        function getProfileMigrationConsent(_x17, _x18) {
          return _getProfileMigrationConsent.apply(this, arguments);
        }
        return getProfileMigrationConsent;
      }()
    };
  }

  var TransactionQueue = function () {
    function TransactionQueue() {
      _classCallCheck(this, TransactionQueue);
      this.nextTicketId = 0;
      this.pending = {};
      this.current = {};
    }
    _createClass(TransactionQueue, [{
      key: "queue",
      value: function queue(key) {
        if (!(key in this.pending)) {
          this.pending[key] = [];
        }
        var ticketId = this.nextTicketId;
        this.pending[key].push(ticketId);
        this.nextTicketId += 1;
        return ticketId;
      }
    }, {
      key: "unqueue",
      value: function unqueue(key, ticketId) {
        var index = this.pending[key].findIndex(function (id) {
          return id === ticketId;
        });
        if (index > 0) {
          throw new Error("Can only unqueue oldest transaction (LIFO logic)");
        } else if (index === 0) {
          this.pending[key].shift();
        } else ;
      }
    }, {
      key: "isNextInQueue",
      value: function isNextInQueue(key, ticketId) {
        return this.pending[key].findIndex(function (id) {
          return id === ticketId;
        }) === 0;
      }
    }, {
      key: "lockTransaction",
      value: function lockTransaction(key, transactionData) {
        if (key in this.current) {
          throw new Error("Can't lock already locked transaction with key ".concat(key));
        }
        this.current[key] = transactionData;
      }
    }, {
      key: "unlockTransaction",
      value: function unlockTransaction(key, ticketId) {
        if (key in this.current && this.current[key].ticketId === ticketId) {
          delete this.current[key];
        }
      }
    }, {
      key: "isLocked",
      value: function isLocked(key) {
        return key in this.current;
      }
    }, {
      key: "getCurrentTransaction",
      value: function getCurrentTransaction(key) {
        return this.current[key];
      }
    }]);
    return TransactionQueue;
  }();

  function encode$1(str) {
    return encodeURIComponent(str);
  }
  function parameterize(obj) {
    if (Object.keys(obj).length === 0) {
      return '';
    }
    return '?' + Object.keys(obj).reduce(function (acc, key) {
      if (Array.isArray(obj[key])) {
        if (obj[key].length === 0) {
          return acc;
        }
        var merged = obj[key].map(function (item) {
          return "".concat(encode$1(key), "[]=").concat(encode$1(item));
        }).join('&');
        acc.push(merged);
        return acc;
      }
      acc.push("".concat(encode$1(key), "=").concat(encode$1(obj[key])));
      return acc;
    }, []).join('&');
  }

  function commonjsRequire(path) {
  	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
  }

  const generate = (num, fn) => {
    let a = [];
    for (var i = 0; i < num; ++i) a.push(fn(i));
    return a;
  };
  const replicate = (num, val) => generate(num, () => val);
  const concat$1 = (a, b) => a.concat(b);
  const flatten$1 = a => {
    let r = [];
    for (let j = 0, J = a.length; j < J; ++j) for (let i = 0, I = a[j].length; i < I; ++i) r.push(a[j][i]);
    return r;
  };
  const chunksOf = (n, a) => {
    let b = [];
    for (let i = 0, l = a.length; i < l; i += n) b.push(a.slice(i, i + n));
    return b;
  };
  var array = {
    generate,
    replicate,
    concat: concat$1,
    flatten: flatten$1,
    chunksOf
  };
  getDefaultExportFromCjs(array);

  const at = (bytes, index) => parseInt(bytes.slice(index * 2 + 2, index * 2 + 4), 16);
  const random = bytes => {
    let rnd;
    if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) rnd = window.crypto.getRandomValues(new Uint8Array(bytes));else if (typeof commonjsRequire !== "undefined") rnd = commonjsRequire("c" + "rypto").randomBytes(bytes);else throw "Safe random numbers not available.";
    let hex = "0x";
    for (let i = 0; i < bytes; ++i) hex += ("00" + rnd[i].toString(16)).slice(-2);
    return hex;
  };
  const length = a => (a.length - 2) / 2;
  const flatten = a => "0x" + a.reduce((r, s) => r + s.slice(2), "");
  const slice = (i, j, bs) => "0x" + bs.slice(i * 2 + 2, j * 2 + 2);
  const reverse = hex => {
    let rev = "0x";
    for (let i = 0, l = length(hex); i < l; ++i) {
      rev += hex.slice((l - i) * 2, (l - i + 1) * 2);
    }
    return rev;
  };
  const pad$1 = (l, hex) => hex.length === l * 2 + 2 ? hex : pad$1(l, "0x" + "0" + hex.slice(2));
  const padRight = (l, hex) => hex.length === l * 2 + 2 ? hex : padRight(l, hex + "0");
  const toArray$1 = hex => {
    let arr = [];
    for (let i = 2, l = hex.length; i < l; i += 2) arr.push(parseInt(hex.slice(i, i + 2), 16));
    return arr;
  };
  const fromArray = arr => {
    let hex = "0x";
    for (let i = 0, l = arr.length; i < l; ++i) {
      let b = arr[i];
      hex += (b < 16 ? "0" : "") + b.toString(16);
    }
    return hex;
  };
  const toUint8Array = hex => new Uint8Array(toArray$1(hex));
  const fromUint8Array = arr => fromArray([].slice.call(arr, 0));
  const fromNumber$1 = num => {
    let hex = num.toString(16);
    return hex.length % 2 === 0 ? "0x" + hex : "0x0" + hex;
  };
  const toNumber$1 = hex => parseInt(hex.slice(2), 16);
  const concat = (a, b) => a.concat(b.slice(2));
  const fromNat = bn => bn === "0x0" ? "0x" : bn.length % 2 === 0 ? bn : "0x0" + bn.slice(2);
  const toNat = bn => bn[2] === "0" ? "0x" + bn.slice(3) : bn;
  const fromAscii = ascii => {
    let hex = "0x";
    for (let i = 0; i < ascii.length; ++i) hex += ("00" + ascii.charCodeAt(i).toString(16)).slice(-2);
    return hex;
  };
  const toAscii = hex => {
    let ascii = "";
    for (let i = 2; i < hex.length; i += 2) ascii += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
    return ascii;
  };
  const fromString$2 = s => {
    const makeByte = uint8 => {
      const b = uint8.toString(16);
      return b.length < 2 ? "0" + b : b;
    };
    let bytes = "0x";
    for (let ci = 0; ci != s.length; ci++) {
      let c = s.charCodeAt(ci);
      if (c < 128) {
        bytes += makeByte(c);
        continue;
      }
      if (c < 2048) {
        bytes += makeByte(c >> 6 | 192);
      } else {
        if (c > 0xd7ff && c < 0xdc00) {
          if (++ci == s.length) return null;
          let c2 = s.charCodeAt(ci);
          if (c2 < 0xdc00 || c2 > 0xdfff) return null;
          c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
          bytes += makeByte(c >> 18 | 240);
          bytes += makeByte(c >> 12 & 63 | 128);
        } else {
          bytes += makeByte(c >> 12 | 224);
        }
        bytes += makeByte(c >> 6 & 63 | 128);
      }
      bytes += makeByte(c & 63 | 128);
    }
    return bytes;
  };
  const toString$2 = bytes => {
    let s = '';
    let i = 0;
    let l = length(bytes);
    while (i < l) {
      let c = at(bytes, i++);
      if (c > 127) {
        if (c > 191 && c < 224) {
          if (i >= l) return null;
          c = (c & 31) << 6 | at(bytes, i) & 63;
        } else if (c > 223 && c < 240) {
          if (i + 1 >= l) return null;
          c = (c & 15) << 12 | (at(bytes, i) & 63) << 6 | at(bytes, ++i) & 63;
        } else if (c > 239 && c < 248) {
          if (i + 2 >= l) return null;
          c = (c & 7) << 18 | (at(bytes, i) & 63) << 12 | (at(bytes, ++i) & 63) << 6 | at(bytes, ++i) & 63;
        } else return null;
        ++i;
      }
      if (c <= 0xffff) s += String.fromCharCode(c);else if (c <= 0x10ffff) {
        c -= 0x10000;
        s += String.fromCharCode(c >> 10 | 0xd800);
        s += String.fromCharCode(c & 0x3FF | 0xdc00);
      } else return null;
    }
    return s;
  };
  var bytes = {
    random,
    length,
    concat,
    flatten,
    slice,
    reverse,
    pad: pad$1,
    padRight,
    fromAscii,
    toAscii,
    fromString: fromString$2,
    toString: toString$2,
    fromNumber: fromNumber$1,
    toNumber: toNumber$1,
    fromNat,
    toNat,
    fromArray,
    toArray: toArray$1,
    fromUint8Array,
    toUint8Array
  };
  getDefaultExportFromCjs(bytes);

  var bn = {exports: {}};

  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var inited = false;
  function init() {
    inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }
    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
  }
  function toByteArray(b64) {
    if (!inited) {
      init();
    }
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4');
    }
    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
    arr = new Arr(len * 3 / 4 - placeHolders);
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for (i = 0, j = 0; i < l; i += 4, j += 3) {
      tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
      arr[L++] = tmp >> 16 & 0xFF;
      arr[L++] = tmp >> 8 & 0xFF;
      arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
      tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
      arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
      tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
      arr[L++] = tmp >> 8 & 0xFF;
      arr[L++] = tmp & 0xFF;
    }
    return arr;
  }
  function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
  }
  function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
      output.push(tripletToBase64(tmp));
    }
    return output.join('');
  }
  function fromByteArray(uint8) {
    if (!inited) {
      init();
    }
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3;
    var output = '';
    var parts = [];
    var maxChunkLength = 16383;
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    }
    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      output += lookup[tmp >> 2];
      output += lookup[tmp << 4 & 0x3F];
      output += '==';
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + uint8[len - 1];
      output += lookup[tmp >> 10];
      output += lookup[tmp >> 4 & 0x3F];
      output += lookup[tmp << 2 & 0x3F];
      output += '=';
    }
    parts.push(output);
    return parts.join('');
  }

  function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
  }
  function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }
      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }
    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
    e = e << mLen | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
    buffer[offset + i - d] |= s * 128;
  }

  var toString$1 = {}.toString;
  var isArray$1 = Array.isArray || function (arr) {
    return toString$1.call(arr) == '[object Array]';
  };

  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  var INSPECT_MAX_BYTES = 50;
  Buffer$1.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : true;
  var _kMaxLength = kMaxLength();
  function kMaxLength() {
    return Buffer$1.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
  }
  function createBuffer(that, length) {
    if (kMaxLength() < length) {
      throw new RangeError('Invalid typed array length');
    }
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      that = new Uint8Array(length);
      that.__proto__ = Buffer$1.prototype;
    } else {
      if (that === null) {
        that = new Buffer$1(length);
      }
      that.length = length;
    }
    return that;
  }
  function Buffer$1(arg, encodingOrOffset, length) {
    if (!Buffer$1.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$1)) {
      return new Buffer$1(arg, encodingOrOffset, length);
    }
    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new Error('If encoding is specified then the first argument must be a string');
      }
      return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
  }
  Buffer$1.poolSize = 8192;
  Buffer$1._augment = function (arr) {
    arr.__proto__ = Buffer$1.prototype;
    return arr;
  };
  function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('"value" argument must not be a number');
    }
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
      return fromArrayBuffer(that, value, encodingOrOffset, length);
    }
    if (typeof value === 'string') {
      return fromString$1(that, value, encodingOrOffset);
    }
    return fromObject(that, value);
  }
  Buffer$1.from = function (value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
  };
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    Buffer$1.prototype.__proto__ = Uint8Array.prototype;
    Buffer$1.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && Buffer$1[Symbol.species] === Buffer$1) ;
  }
  function assertSize(size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be a number');
    } else if (size < 0) {
      throw new RangeError('"size" argument must not be negative');
    }
  }
  function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(that, size);
    }
    if (fill !== undefined) {
      return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    }
    return createBuffer(that, size);
  }
  Buffer$1.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding);
  };
  function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) {
      for (var i = 0; i < size; ++i) {
        that[i] = 0;
      }
    }
    return that;
  }
  Buffer$1.allocUnsafe = function (size) {
    return allocUnsafe(null, size);
  };
  Buffer$1.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size);
  };
  function fromString$1(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8';
    }
    if (!Buffer$1.isEncoding(encoding)) {
      throw new TypeError('"encoding" must be a valid string encoding');
    }
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) {
      that = that.slice(0, actual);
    }
    return that;
  }
  function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for (var i = 0; i < length; i += 1) {
      that[i] = array[i] & 255;
    }
    return that;
  }
  function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength;
    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('\'offset\' is out of bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('\'length\' is out of bounds');
    }
    if (byteOffset === undefined && length === undefined) {
      array = new Uint8Array(array);
    } else if (length === undefined) {
      array = new Uint8Array(array, byteOffset);
    } else {
      array = new Uint8Array(array, byteOffset, length);
    }
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      that = array;
      that.__proto__ = Buffer$1.prototype;
    } else {
      that = fromArrayLike(that, array);
    }
    return that;
  }
  function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
      var len = checked(obj.length) | 0;
      that = createBuffer(that, len);
      if (that.length === 0) {
        return that;
      }
      obj.copy(that, 0, 0, len);
      return that;
    }
    if (obj) {
      if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
        if (typeof obj.length !== 'number' || isnan(obj.length)) {
          return createBuffer(that, 0);
        }
        return fromArrayLike(that, obj);
      }
      if (obj.type === 'Buffer' && isArray$1(obj.data)) {
        return fromArrayLike(that, obj.data);
      }
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
  }
  function checked(length) {
    if (length >= kMaxLength()) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
    }
    return length | 0;
  }
  function SlowBuffer(length) {
    if (+length != length) {
      length = 0;
    }
    return Buffer$1.alloc(+length);
  }
  Buffer$1.isBuffer = isBuffer$1;
  function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
  }
  Buffer$1.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
      throw new TypeError('Arguments must be Buffers');
    }
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
      }
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
  };
  Buffer$1.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true;
      default:
        return false;
    }
  };
  Buffer$1.concat = function concat(list, length) {
    if (!isArray$1(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
      return Buffer$1.alloc(0);
    }
    var i;
    if (length === undefined) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }
    var buffer = Buffer$1.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
      var buf = list[i];
      if (!internalIsBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      buf.copy(buffer, pos);
      pos += buf.length;
    }
    return buffer;
  };
  function byteLength(string, encoding) {
    if (internalIsBuffer(string)) {
      return string.length;
    }
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== 'string') {
      string = '' + string;
    }
    var len = string.length;
    if (len === 0) return 0;
    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
          return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2;
        case 'hex':
          return len >>> 1;
        case 'base64':
          return base64ToBytes(string).length;
        default:
          if (loweredCase) return utf8ToBytes(string).length;
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer$1.byteLength = byteLength;
  function slowToString(encoding, start, end) {
    var loweredCase = false;
    if (start === undefined || start < 0) {
      start = 0;
    }
    if (start > this.length) {
      return '';
    }
    if (end === undefined || end > this.length) {
      end = this.length;
    }
    if (end <= 0) {
      return '';
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
      return '';
    }
    if (!encoding) encoding = 'utf8';
    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end);
        case 'ascii':
          return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end);
        case 'base64':
          return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end);
        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
          encoding = (encoding + '').toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer$1.prototype._isBuffer = true;
  function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
  }
  Buffer$1.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits');
    }
    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }
    return this;
  };
  Buffer$1.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits');
    }
    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }
    return this;
  };
  Buffer$1.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits');
    }
    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }
    return this;
  };
  Buffer$1.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
  };
  Buffer$1.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer$1.compare(this, b) === 0;
  };
  Buffer$1.prototype.inspect = function inspect() {
    var str = '';
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
      if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
  };
  Buffer$1.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) {
      throw new TypeError('Argument must be a Buffer');
    }
    if (start === undefined) {
      start = 0;
    }
    if (end === undefined) {
      end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
      thisStart = 0;
    }
    if (thisEnd === undefined) {
      thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index');
    }
    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start >= end) {
      return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
      }
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
  };
  function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    if (buffer.length === 0) return -1;
    if (typeof byteOffset === 'string') {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff;
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000;
    }
    byteOffset = +byteOffset;
    if (isNaN(byteOffset)) {
      byteOffset = dir ? 0 : buffer.length - 1;
    }
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
      if (dir) return -1;else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0;else return -1;
    }
    if (typeof val === 'string') {
      val = Buffer$1.from(val, encoding);
    }
    if (internalIsBuffer(val)) {
      if (val.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
      val = val & 0xFF;
      if (Buffer$1.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
      }
      return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
  }
  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase();
      if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }
    function read(buf, i) {
      if (indexSize === 1) {
        return buf[i];
      } else {
        return buf.readUInt16BE(i * indexSize);
      }
    }
    var i;
    if (dir) {
      var foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i;
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1) i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        var found = true;
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break;
          }
        }
        if (found) return i;
      }
    }
    return -1;
  }
  Buffer$1.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };
  Buffer$1.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };
  Buffer$1.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };
  function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) {
      length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (isNaN(parsed)) return i;
      buf[offset + i] = parsed;
    }
    return i;
  }
  function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
  }
  function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
  }
  function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
  }
  function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
  }
  function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
  }
  Buffer$1.prototype.write = function write(string, offset, length, encoding) {
    if (offset === undefined) {
      encoding = 'utf8';
      length = this.length;
      offset = 0;
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset;
      length = this.length;
      offset = 0;
    } else if (isFinite(offset)) {
      offset = offset | 0;
      if (isFinite(length)) {
        length = length | 0;
        if (encoding === undefined) encoding = 'utf8';
      } else {
        encoding = length;
        length = undefined;
      }
    } else {
      throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    }
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds');
    }
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length);
        case 'ascii':
          return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length);
        case 'base64':
          return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length);
        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };
  Buffer$1.prototype.toJSON = function toJSON() {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return fromByteArray(buf);
    } else {
      return fromByteArray(buf.slice(start, end));
    }
  }
  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint;
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint;
              }
            }
        }
      }
      if (codePoint === null) {
        codePoint = 0xFFFD;
        bytesPerSequence = 1;
      } else if (codePoint > 0xFFFF) {
        codePoint -= 0x10000;
        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }
      res.push(codePoint);
      i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
  }
  var MAX_ARGUMENTS_LENGTH = 0x1000;
  function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints);
    }
    var res = '';
    var i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
  }
  function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F);
    }
    return ret;
  }
  function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret;
  }
  function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for (var i = start; i < end; ++i) {
      out += toHex$1(buf[i]);
    }
    return out;
  }
  function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
  }
  Buffer$1.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
      start += len;
      if (start < 0) start = 0;
    } else if (start > len) {
      start = len;
    }
    if (end < 0) {
      end += len;
      if (end < 0) end = 0;
    } else if (end > len) {
      end = len;
    }
    if (end < start) end = start;
    var newBuf;
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      newBuf = this.subarray(start, end);
      newBuf.__proto__ = Buffer$1.prototype;
    } else {
      var sliceLen = end - start;
      newBuf = new Buffer$1(sliceLen, undefined);
      for (var i = 0; i < sliceLen; ++i) {
        newBuf[i] = this[i + start];
      }
    }
    return newBuf;
  };
  function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
  }
  Buffer$1.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }
    return val;
  };
  Buffer$1.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      checkOffset(offset, byteLength, this.length);
    }
    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul;
    }
    return val;
  };
  Buffer$1.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
  };
  Buffer$1.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };
  Buffer$1.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };
  Buffer$1.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
  };
  Buffer$1.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };
  Buffer$1.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
  };
  Buffer$1.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul;
    }
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
  };
  Buffer$1.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
  };
  Buffer$1.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
  };
  Buffer$1.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
  };
  Buffer$1.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };
  Buffer$1.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };
  Buffer$1.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
  };
  Buffer$1.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
  };
  Buffer$1.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
  };
  Buffer$1.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
  };
  function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
  }
  Buffer$1.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = value / mul & 0xFF;
    }
    return offset + byteLength;
  };
  Buffer$1.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = value / mul & 0xFF;
    }
    return offset + byteLength;
  };
  Buffer$1.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
  };
  function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
      buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
    }
  }
  Buffer$1.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value & 0xff;
      this[offset + 1] = value >>> 8;
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2;
  };
  Buffer$1.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 8;
      this[offset + 1] = value & 0xff;
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2;
  };
  function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
      buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
    }
  }
  Buffer$1.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 0xff;
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4;
  };
  Buffer$1.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 0xff;
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4;
  };
  Buffer$1.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);
      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
  };
  Buffer$1.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);
      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
  };
  Buffer$1.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
  };
  Buffer$1.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value & 0xff;
      this[offset + 1] = value >>> 8;
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2;
  };
  Buffer$1.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 8;
      this[offset + 1] = value & 0xff;
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2;
  };
  Buffer$1.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value & 0xff;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4;
  };
  Buffer$1.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 0xff;
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4;
  };
  function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
  }
  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }
  Buffer$1.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };
  Buffer$1.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };
  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }
  Buffer$1.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };
  Buffer$1.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  };
  Buffer$1.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds');
    }
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) {
      for (i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start];
      }
    } else if (len < 1000 || !Buffer$1.TYPED_ARRAY_SUPPORT) {
      for (i = 0; i < len; ++i) {
        target[i + targetStart] = this[i + start];
      }
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    }
    return len;
  };
  Buffer$1.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === 'string') {
        encoding = end;
        end = this.length;
      }
      if (val.length === 1) {
        var code = val.charCodeAt(0);
        if (code < 256) {
          val = code;
        }
      }
      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string');
      }
      if (typeof encoding === 'string' && !Buffer$1.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding);
      }
    } else if (typeof val === 'number') {
      val = val & 255;
    }
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index');
    }
    if (end <= start) {
      return this;
    }
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer$1(val, encoding).toString());
      var len = bytes.length;
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }
    return this;
  };
  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
  function base64clean(str) {
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    if (str.length < 2) return '';
    while (str.length % 4 !== 0) {
      str = str + '=';
    }
    return str;
  }
  function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
  }
  function toHex$1(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
  }
  function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i);
      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        if (!leadSurrogate) {
          if (codePoint > 0xDBFF) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue;
          } else if (i + 1 === length) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue;
          }
          leadSurrogate = codePoint;
          continue;
        }
        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          leadSurrogate = codePoint;
          continue;
        }
        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
      } else if (leadSurrogate) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
      }
      leadSurrogate = null;
      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break;
        bytes.push(codePoint);
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break;
        bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break;
        bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break;
        bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
      } else {
        throw new Error('Invalid code point');
      }
    }
    return bytes;
  }
  function asciiToBytes(str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      byteArray.push(str.charCodeAt(i) & 0xFF);
    }
    return byteArray;
  }
  function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break;
      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }
    return byteArray;
  }
  function base64ToBytes(str) {
    return toByteArray(base64clean(str));
  }
  function blitBuffer(src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if (i + offset >= dst.length || i >= src.length) break;
      dst[i + offset] = src[i];
    }
    return i;
  }
  function isnan(val) {
    return val !== val;
  }
  function isBuffer$1(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
  }
  function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
  }
  function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0));
  }

  var bufferEs6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Buffer: Buffer$1,
    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    SlowBuffer: SlowBuffer,
    isBuffer: isBuffer$1,
    kMaxLength: _kMaxLength
  });

  var require$$0$3 = /*@__PURE__*/getAugmentedNamespace(bufferEs6);

  bn.exports;
  (function (module) {
    (function (module, exports) {
      function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
      }
      function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function () {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      }
      function BN(number, base, endian) {
        if (BN.isBN(number)) {
          return number;
        }
        this.negative = 0;
        this.words = null;
        this.length = 0;
        this.red = null;
        if (number !== null) {
          if (base === 'le' || base === 'be') {
            endian = base;
            base = 10;
          }
          this._init(number || 0, base || 10, endian || 'be');
        }
      }
      if (typeof module === 'object') {
        module.exports = BN;
      } else {
        exports.BN = BN;
      }
      BN.BN = BN;
      BN.wordSize = 26;
      var Buffer;
      try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
          Buffer = window.Buffer;
        } else {
          Buffer = require$$0$3.Buffer;
        }
      } catch (e) {}
      BN.isBN = function isBN(num) {
        if (num instanceof BN) {
          return true;
        }
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
      };
      BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
      };
      BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
      };
      BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') {
          return this._initNumber(number, base, endian);
        }
        if (typeof number === 'object') {
          return this._initArray(number, base, endian);
        }
        if (base === 'hex') {
          base = 16;
        }
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
          start++;
          this.negative = 1;
        }
        if (start < number.length) {
          if (base === 16) {
            this._parseHex(number, start, endian);
          } else {
            this._parseBase(number, base, start);
            if (endian === 'le') {
              this._initArray(this.toArray(), base, endian);
            }
          }
        }
      };
      BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
          this.negative = 1;
          number = -number;
        }
        if (number < 0x4000000) {
          this.words = [number & 0x3ffffff];
          this.length = 1;
        } else if (number < 0x10000000000000) {
          this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff];
          this.length = 2;
        } else {
          assert(number < 0x20000000000000);
          this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff, 1];
          this.length = 3;
        }
        if (endian !== 'le') return;
        this._initArray(this.toArray(), base, endian);
      };
      BN.prototype._initArray = function _initArray(number, base, endian) {
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
          this.words = [0];
          this.length = 1;
          return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }
        var j, w;
        var off = 0;
        if (endian === 'be') {
          for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
              off -= 26;
              j++;
            }
          }
        } else if (endian === 'le') {
          for (i = 0, j = 0; i < number.length; i += 3) {
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
              off -= 26;
              j++;
            }
          }
        }
        return this.strip();
      };
      function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        if (c >= 65 && c <= 70) {
          return c - 55;
        } else if (c >= 97 && c <= 102) {
          return c - 87;
        } else {
          return c - 48 & 0xf;
        }
      }
      function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) {
          r |= parseHex4Bits(string, index - 1) << 4;
        }
        return r;
      }
      BN.prototype._parseHex = function _parseHex(number, start, endian) {
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') {
          for (i = number.length - 1; i >= start; i -= 2) {
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
              off -= 18;
              j += 1;
              this.words[j] |= w >>> 26;
            } else {
              off += 8;
            }
          }
        } else {
          var parseLength = number.length - start;
          for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
              off -= 18;
              j += 1;
              this.words[j] |= w >>> 26;
            } else {
              off += 8;
            }
          }
        }
        this.strip();
      };
      function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for (var i = start; i < len; i++) {
          var c = str.charCodeAt(i) - 48;
          r *= mul;
          if (c >= 49) {
            r += c - 49 + 0xa;
          } else if (c >= 17) {
            r += c - 17 + 0xa;
          } else {
            r += c;
          }
        }
        return r;
      }
      BN.prototype._parseBase = function _parseBase(number, base, start) {
        this.words = [0];
        this.length = 1;
        for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
          limbLen++;
        }
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for (var i = start; i < end; i += limbLen) {
          word = parseBase(number, i, i + limbLen, base);
          this.imuln(limbPow);
          if (this.words[0] + word < 0x4000000) {
            this.words[0] += word;
          } else {
            this._iaddn(word);
          }
        }
        if (mod !== 0) {
          var pow = 1;
          word = parseBase(number, i, number.length, base);
          for (i = 0; i < mod; i++) {
            pow *= base;
          }
          this.imuln(pow);
          if (this.words[0] + word < 0x4000000) {
            this.words[0] += word;
          } else {
            this._iaddn(word);
          }
        }
        this.strip();
      };
      BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          dest.words[i] = this.words[i];
        }
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
      };
      BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
      };
      BN.prototype._expand = function _expand(size) {
        while (this.length < size) {
          this.words[this.length++] = 0;
        }
        return this;
      };
      BN.prototype.strip = function strip() {
        while (this.length > 1 && this.words[this.length - 1] === 0) {
          this.length--;
        }
        return this._normSign();
      };
      BN.prototype._normSign = function _normSign() {
        if (this.length === 1 && this.words[0] === 0) {
          this.negative = 0;
        }
        return this;
      };
      BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
      };
      var zeros = ['', '0', '00', '000', '0000', '00000', '000000', '0000000', '00000000', '000000000', '0000000000', '00000000000', '000000000000', '0000000000000', '00000000000000', '000000000000000', '0000000000000000', '00000000000000000', '000000000000000000', '0000000000000000000', '00000000000000000000', '000000000000000000000', '0000000000000000000000', '00000000000000000000000', '000000000000000000000000', '0000000000000000000000000'];
      var groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
      var groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
      BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
          out = '';
          var off = 0;
          var carry = 0;
          for (var i = 0; i < this.length; i++) {
            var w = this.words[i];
            var word = ((w << off | carry) & 0xffffff).toString(16);
            carry = w >>> 24 - off & 0xffffff;
            if (carry !== 0 || i !== this.length - 1) {
              out = zeros[6 - word.length] + word + out;
            } else {
              out = word + out;
            }
            off += 2;
            if (off >= 26) {
              off -= 26;
              i--;
            }
          }
          if (carry !== 0) {
            out = carry.toString(16) + out;
          }
          while (out.length % padding !== 0) {
            out = '0' + out;
          }
          if (this.negative !== 0) {
            out = '-' + out;
          }
          return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
          var groupSize = groupSizes[base];
          var groupBase = groupBases[base];
          out = '';
          var c = this.clone();
          c.negative = 0;
          while (!c.isZero()) {
            var r = c.modn(groupBase).toString(base);
            c = c.idivn(groupBase);
            if (!c.isZero()) {
              out = zeros[groupSize - r.length] + r + out;
            } else {
              out = r + out;
            }
          }
          if (this.isZero()) {
            out = '0' + out;
          }
          while (out.length % padding !== 0) {
            out = '0' + out;
          }
          if (this.negative !== 0) {
            out = '-' + out;
          }
          return out;
        }
        assert(false, 'Base should be between 2 and 36');
      };
      BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) {
          ret += this.words[1] * 0x4000000;
        } else if (this.length === 3 && this.words[2] === 0x01) {
          ret += 0x10000000000000 + this.words[1] * 0x4000000;
        } else if (this.length > 2) {
          assert(false, 'Number can only safely store up to 53 bits');
        }
        return this.negative !== 0 ? -ret : ret;
      };
      BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
      };
      BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
      };
      BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
      };
      BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
          for (i = 0; i < reqLength - byteLength; i++) {
            res[i] = 0;
          }
          for (i = 0; !q.isZero(); i++) {
            b = q.andln(0xff);
            q.iushrn(8);
            res[reqLength - i - 1] = b;
          }
        } else {
          for (i = 0; !q.isZero(); i++) {
            b = q.andln(0xff);
            q.iushrn(8);
            res[i] = b;
          }
          for (; i < reqLength; i++) {
            res[i] = 0;
          }
        }
        return res;
      };
      if (Math.clz32) {
        BN.prototype._countBits = function _countBits(w) {
          return 32 - Math.clz32(w);
        };
      } else {
        BN.prototype._countBits = function _countBits(w) {
          var t = w;
          var r = 0;
          if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
          }
          if (t >= 0x40) {
            r += 7;
            t >>>= 7;
          }
          if (t >= 0x8) {
            r += 4;
            t >>>= 4;
          }
          if (t >= 0x02) {
            r += 2;
            t >>>= 2;
          }
          return r + t;
        };
      }
      BN.prototype._zeroBits = function _zeroBits(w) {
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
          r += 13;
          t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
          r += 7;
          t >>>= 7;
        }
        if ((t & 0xf) === 0) {
          r += 4;
          t >>>= 4;
        }
        if ((t & 0x3) === 0) {
          r += 2;
          t >>>= 2;
        }
        if ((t & 0x1) === 0) {
          r++;
        }
        return r;
      };
      BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
      };
      function toBitArray(num) {
        var w = new Array(num.bitLength());
        for (var bit = 0; bit < w.length; bit++) {
          var off = bit / 26 | 0;
          var wbit = bit % 26;
          w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
      }
      BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for (var i = 0; i < this.length; i++) {
          var b = this._zeroBits(this.words[i]);
          r += b;
          if (b !== 26) break;
        }
        return r;
      };
      BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
      };
      BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) {
          return this.abs().inotn(width).iaddn(1);
        }
        return this.clone();
      };
      BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) {
          return this.notn(width).iaddn(1).ineg();
        }
        return this.clone();
      };
      BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
      };
      BN.prototype.neg = function neg() {
        return this.clone().ineg();
      };
      BN.prototype.ineg = function ineg() {
        if (!this.isZero()) {
          this.negative ^= 1;
        }
        return this;
      };
      BN.prototype.iuor = function iuor(num) {
        while (this.length < num.length) {
          this.words[this.length++] = 0;
        }
        for (var i = 0; i < num.length; i++) {
          this.words[i] = this.words[i] | num.words[i];
        }
        return this.strip();
      };
      BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
      };
      BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
      };
      BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
      };
      BN.prototype.iuand = function iuand(num) {
        var b;
        if (this.length > num.length) {
          b = num;
        } else {
          b = this;
        }
        for (var i = 0; i < b.length; i++) {
          this.words[i] = this.words[i] & num.words[i];
        }
        this.length = b.length;
        return this.strip();
      };
      BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
      };
      BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
      };
      BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
      };
      BN.prototype.iuxor = function iuxor(num) {
        var a;
        var b;
        if (this.length > num.length) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        for (var i = 0; i < b.length; i++) {
          this.words[i] = a.words[i] ^ b.words[i];
        }
        if (this !== a) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        this.length = a.length;
        return this.strip();
      };
      BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
      };
      BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
      };
      BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
      };
      BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        this._expand(bytesNeeded);
        if (bitsLeft > 0) {
          bytesNeeded--;
        }
        for (var i = 0; i < bytesNeeded; i++) {
          this.words[i] = ~this.words[i] & 0x3ffffff;
        }
        if (bitsLeft > 0) {
          this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        }
        return this.strip();
      };
      BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
      };
      BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) {
          this.words[off] = this.words[off] | 1 << wbit;
        } else {
          this.words[off] = this.words[off] & ~(1 << wbit);
        }
        return this.strip();
      };
      BN.prototype.iadd = function iadd(num) {
        var r;
        if (this.negative !== 0 && num.negative === 0) {
          this.negative = 0;
          r = this.isub(num);
          this.negative ^= 1;
          return this._normSign();
        } else if (this.negative === 0 && num.negative !== 0) {
          num.negative = 0;
          r = this.isub(num);
          num.negative = 1;
          return r._normSign();
        }
        var a, b;
        if (this.length > num.length) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        var carry = 0;
        for (var i = 0; i < b.length; i++) {
          r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
          this.words[i] = r & 0x3ffffff;
          carry = r >>> 26;
        }
        for (; carry !== 0 && i < a.length; i++) {
          r = (a.words[i] | 0) + carry;
          this.words[i] = r & 0x3ffffff;
          carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
          this.words[this.length] = carry;
          this.length++;
        } else if (a !== this) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        return this;
      };
      BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
          num.negative = 0;
          res = this.sub(num);
          num.negative ^= 1;
          return res;
        } else if (num.negative === 0 && this.negative !== 0) {
          this.negative = 0;
          res = num.sub(this);
          this.negative = 1;
          return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
      };
      BN.prototype.isub = function isub(num) {
        if (num.negative !== 0) {
          num.negative = 0;
          var r = this.iadd(num);
          num.negative = 1;
          return r._normSign();
        } else if (this.negative !== 0) {
          this.negative = 0;
          this.iadd(num);
          this.negative = 1;
          return this._normSign();
        }
        var cmp = this.cmp(num);
        if (cmp === 0) {
          this.negative = 0;
          this.length = 1;
          this.words[0] = 0;
          return this;
        }
        var a, b;
        if (cmp > 0) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        var carry = 0;
        for (var i = 0; i < b.length; i++) {
          r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
          carry = r >> 26;
          this.words[i] = r & 0x3ffffff;
        }
        for (; carry !== 0 && i < a.length; i++) {
          r = (a.words[i] | 0) + carry;
          carry = r >> 26;
          this.words[i] = r & 0x3ffffff;
        }
        if (carry === 0 && i < a.length && a !== this) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        this.length = Math.max(this.length, i);
        if (a !== this) {
          this.negative = 1;
        }
        return this.strip();
      };
      BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
      };
      function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for (var k = 1; k < len; k++) {
          var ncarry = carry >>> 26;
          var rword = carry & 0x3ffffff;
          var maxJ = Math.min(k, num.length - 1);
          for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
            var i = k - j | 0;
            a = self.words[i] | 0;
            b = num.words[j] | 0;
            r = a * b + rword;
            ncarry += r / 0x4000000 | 0;
            rword = r & 0x3ffffff;
          }
          out.words[k] = rword | 0;
          carry = ncarry | 0;
        }
        if (carry !== 0) {
          out.words[k] = carry | 0;
        } else {
          out.length--;
        }
        return out.strip();
      }
      var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
          o[19] = c;
          out.length++;
        }
        return out;
      };
      if (!Math.imul) {
        comb10MulTo = smallMulTo;
      }
      function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for (var k = 0; k < out.length - 1; k++) {
          var ncarry = hncarry;
          hncarry = 0;
          var rword = carry & 0x3ffffff;
          var maxJ = Math.min(k, num.length - 1);
          for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
            var i = k - j;
            var a = self.words[i] | 0;
            var b = num.words[j] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            ncarry = ncarry + (r / 0x4000000 | 0) | 0;
            lo = lo + rword | 0;
            rword = lo & 0x3ffffff;
            ncarry = ncarry + (lo >>> 26) | 0;
            hncarry += ncarry >>> 26;
            ncarry &= 0x3ffffff;
          }
          out.words[k] = rword;
          carry = ncarry;
          ncarry = hncarry;
        }
        if (carry !== 0) {
          out.words[k] = carry;
        } else {
          out.length--;
        }
        return out.strip();
      }
      function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
      }
      BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) {
          res = comb10MulTo(this, num, out);
        } else if (len < 63) {
          res = smallMulTo(this, num, out);
        } else if (len < 1024) {
          res = bigMulTo(this, num, out);
        } else {
          res = jumboMulTo(this, num, out);
        }
        return res;
      };
      function FFTM(x, y) {
        this.x = x;
        this.y = y;
      }
      FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for (var i = 0; i < N; i++) {
          t[i] = this.revBin(i, l, N);
        }
        return t;
      };
      FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for (var i = 0; i < l; i++) {
          rb |= (x & 1) << l - i - 1;
          x >>= 1;
        }
        return rb;
      };
      FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for (var i = 0; i < N; i++) {
          rtws[i] = rws[rbt[i]];
          itws[i] = iws[rbt[i]];
        }
      };
      FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for (var s = 1; s < N; s <<= 1) {
          var l = s << 1;
          var rtwdf = Math.cos(2 * Math.PI / l);
          var itwdf = Math.sin(2 * Math.PI / l);
          for (var p = 0; p < N; p += l) {
            var rtwdf_ = rtwdf;
            var itwdf_ = itwdf;
            for (var j = 0; j < s; j++) {
              var re = rtws[p + j];
              var ie = itws[p + j];
              var ro = rtws[p + j + s];
              var io = itws[p + j + s];
              var rx = rtwdf_ * ro - itwdf_ * io;
              io = rtwdf_ * io + itwdf_ * ro;
              ro = rx;
              rtws[p + j] = re + ro;
              itws[p + j] = ie + io;
              rtws[p + j + s] = re - ro;
              itws[p + j + s] = ie - io;
              if (j !== l) {
                rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                rtwdf_ = rx;
              }
            }
          }
        }
      };
      FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for (N = N / 2 | 0; N; N = N >>> 1) {
          i++;
        }
        return 1 << i + 1 + odd;
      };
      FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for (var i = 0; i < N / 2; i++) {
          var t = rws[i];
          rws[i] = rws[N - i - 1];
          rws[N - i - 1] = t;
          t = iws[i];
          iws[i] = -iws[N - i - 1];
          iws[N - i - 1] = -t;
        }
      };
      FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for (var i = 0; i < N / 2; i++) {
          var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
          ws[i] = w & 0x3ffffff;
          if (w < 0x4000000) {
            carry = 0;
          } else {
            carry = w / 0x4000000 | 0;
          }
        }
        return ws;
      };
      FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for (var i = 0; i < len; i++) {
          carry = carry + (ws[i] | 0);
          rws[2 * i] = carry & 0x1fff;
          carry = carry >>> 13;
          rws[2 * i + 1] = carry & 0x1fff;
          carry = carry >>> 13;
        }
        for (i = 2 * len; i < N; ++i) {
          rws[i] = 0;
        }
        assert(carry === 0);
        assert((carry & ~0x1fff) === 0);
      };
      FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for (var i = 0; i < N; i++) {
          ph[i] = 0;
        }
        return ph;
      };
      FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for (var i = 0; i < N; i++) {
          var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
          iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
          rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
      };
      BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
      };
      BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
      };
      BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
      };
      BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        var carry = 0;
        for (var i = 0; i < this.length; i++) {
          var w = (this.words[i] | 0) * num;
          var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
          carry >>= 26;
          carry += w / 0x4000000 | 0;
          carry += lo >>> 26;
          this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
          this.words[i] = carry;
          this.length++;
        }
        return this;
      };
      BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
      };
      BN.prototype.sqr = function sqr() {
        return this.mul(this);
      };
      BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
      };
      BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        var res = this;
        for (var i = 0; i < w.length; i++, res = res.sqr()) {
          if (w[i] !== 0) break;
        }
        if (++i < w.length) {
          for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
            if (w[i] === 0) continue;
            res = res.mul(q);
          }
        }
        return res;
      };
      BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
          var carry = 0;
          for (i = 0; i < this.length; i++) {
            var newCarry = this.words[i] & carryMask;
            var c = (this.words[i] | 0) - newCarry << r;
            this.words[i] = c | carry;
            carry = newCarry >>> 26 - r;
          }
          if (carry) {
            this.words[i] = carry;
            this.length++;
          }
        }
        if (s !== 0) {
          for (i = this.length - 1; i >= 0; i--) {
            this.words[i + s] = this.words[i];
          }
          for (i = 0; i < s; i++) {
            this.words[i] = 0;
          }
          this.length += s;
        }
        return this.strip();
      };
      BN.prototype.ishln = function ishln(bits) {
        assert(this.negative === 0);
        return this.iushln(bits);
      };
      BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) {
          h = (hint - hint % 26) / 26;
        } else {
          h = 0;
        }
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        if (maskedWords) {
          for (var i = 0; i < s; i++) {
            maskedWords.words[i] = this.words[i];
          }
          maskedWords.length = s;
        }
        if (s === 0) ; else if (this.length > s) {
          this.length -= s;
          for (i = 0; i < this.length; i++) {
            this.words[i] = this.words[i + s];
          }
        } else {
          this.words[0] = 0;
          this.length = 1;
        }
        var carry = 0;
        for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
          var word = this.words[i] | 0;
          this.words[i] = carry << 26 - r | word >>> r;
          carry = word & mask;
        }
        if (maskedWords && carry !== 0) {
          maskedWords.words[maskedWords.length++] = carry;
        }
        if (this.length === 0) {
          this.words[0] = 0;
          this.length = 1;
        }
        return this.strip();
      };
      BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
      };
      BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
      };
      BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
      };
      BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
      };
      BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
      };
      BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        if (this.length <= s) return false;
        var w = this.words[s];
        return !!(w & q);
      };
      BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) {
          return this;
        }
        if (r !== 0) {
          s++;
        }
        this.length = Math.min(s, this.length);
        if (r !== 0) {
          var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
          this.words[this.length - 1] &= mask;
        }
        return this.strip();
      };
      BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
      };
      BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        if (this.negative !== 0) {
          if (this.length === 1 && (this.words[0] | 0) < num) {
            this.words[0] = num - (this.words[0] | 0);
            this.negative = 0;
            return this;
          }
          this.negative = 0;
          this.isubn(num);
          this.negative = 1;
          return this;
        }
        return this._iaddn(num);
      };
      BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
          this.words[i] -= 0x4000000;
          if (i === this.length - 1) {
            this.words[i + 1] = 1;
          } else {
            this.words[i + 1]++;
          }
        }
        this.length = Math.max(this.length, i + 1);
        return this;
      };
      BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
          this.negative = 0;
          this.iaddn(num);
          this.negative = 1;
          return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
          this.words[0] = -this.words[0];
          this.negative = 1;
        } else {
          for (var i = 0; i < this.length && this.words[i] < 0; i++) {
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
          }
        }
        return this.strip();
      };
      BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
      };
      BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
      };
      BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
      };
      BN.prototype.abs = function abs() {
        return this.clone().iabs();
      };
      BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for (i = 0; i < num.length; i++) {
          w = (this.words[i + shift] | 0) + carry;
          var right = (num.words[i] | 0) * mul;
          w -= right & 0x3ffffff;
          carry = (w >> 26) - (right / 0x4000000 | 0);
          this.words[i + shift] = w & 0x3ffffff;
        }
        for (; i < this.length - shift; i++) {
          w = (this.words[i + shift] | 0) + carry;
          carry = w >> 26;
          this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        assert(carry === -1);
        carry = 0;
        for (i = 0; i < this.length; i++) {
          w = -(this.words[i] | 0) + carry;
          carry = w >> 26;
          this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
      };
      BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
          b = b.ushln(shift);
          a.iushln(shift);
          bhi = b.words[b.length - 1] | 0;
        }
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
          q = new BN(null);
          q.length = m + 1;
          q.words = new Array(q.length);
          for (var i = 0; i < q.length; i++) {
            q.words[i] = 0;
          }
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
          a = diff;
          if (q) {
            q.words[m] = 1;
          }
        }
        for (var j = m - 1; j >= 0; j--) {
          var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
          qj = Math.min(qj / bhi | 0, 0x3ffffff);
          a._ishlnsubmul(b, qj, j);
          while (a.negative !== 0) {
            qj--;
            a.negative = 0;
            a._ishlnsubmul(b, 1, j);
            if (!a.isZero()) {
              a.negative ^= 1;
            }
          }
          if (q) {
            q.words[j] = qj;
          }
        }
        if (q) {
          q.strip();
        }
        a.strip();
        if (mode !== 'div' && shift !== 0) {
          a.iushrn(shift);
        }
        return {
          div: q || null,
          mod: a
        };
      };
      BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) {
          return {
            div: new BN(0),
            mod: new BN(0)
          };
        }
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
          res = this.neg().divmod(num, mode);
          if (mode !== 'mod') {
            div = res.div.neg();
          }
          if (mode !== 'div') {
            mod = res.mod.neg();
            if (positive && mod.negative !== 0) {
              mod.iadd(num);
            }
          }
          return {
            div: div,
            mod: mod
          };
        }
        if (this.negative === 0 && num.negative !== 0) {
          res = this.divmod(num.neg(), mode);
          if (mode !== 'mod') {
            div = res.div.neg();
          }
          return {
            div: div,
            mod: res.mod
          };
        }
        if ((this.negative & num.negative) !== 0) {
          res = this.neg().divmod(num.neg(), mode);
          if (mode !== 'div') {
            mod = res.mod.neg();
            if (positive && mod.negative !== 0) {
              mod.isub(num);
            }
          }
          return {
            div: res.div,
            mod: mod
          };
        }
        if (num.length > this.length || this.cmp(num) < 0) {
          return {
            div: new BN(0),
            mod: this
          };
        }
        if (num.length === 1) {
          if (mode === 'div') {
            return {
              div: this.divn(num.words[0]),
              mod: null
            };
          }
          if (mode === 'mod') {
            return {
              div: null,
              mod: new BN(this.modn(num.words[0]))
            };
          }
          return {
            div: this.divn(num.words[0]),
            mod: new BN(this.modn(num.words[0]))
          };
        }
        return this._wordDiv(num, mode);
      };
      BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
      };
      BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
      };
      BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
      };
      BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
      };
      BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = (1 << 26) % num;
        var acc = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          acc = (p * acc + (this.words[i] | 0)) % num;
        }
        return acc;
      };
      BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          var w = (this.words[i] | 0) + carry * 0x4000000;
          this.words[i] = w / num | 0;
          carry = w % num;
        }
        return this.strip();
      };
      BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
      };
      BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) {
          x = x.umod(p);
        } else {
          x = x.clone();
        }
        var A = new BN(1);
        var B = new BN(0);
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while (x.isEven() && y.isEven()) {
          x.iushrn(1);
          y.iushrn(1);
          ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while (!x.isZero()) {
          for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
          if (i > 0) {
            x.iushrn(i);
            while (i-- > 0) {
              if (A.isOdd() || B.isOdd()) {
                A.iadd(yp);
                B.isub(xp);
              }
              A.iushrn(1);
              B.iushrn(1);
            }
          }
          for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
          if (j > 0) {
            y.iushrn(j);
            while (j-- > 0) {
              if (C.isOdd() || D.isOdd()) {
                C.iadd(yp);
                D.isub(xp);
              }
              C.iushrn(1);
              D.iushrn(1);
            }
          }
          if (x.cmp(y) >= 0) {
            x.isub(y);
            A.isub(C);
            B.isub(D);
          } else {
            y.isub(x);
            C.isub(A);
            D.isub(B);
          }
        }
        return {
          a: C,
          b: D,
          gcd: y.iushln(g)
        };
      };
      BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) {
          a = a.umod(p);
        } else {
          a = a.clone();
        }
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
          for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
          if (i > 0) {
            a.iushrn(i);
            while (i-- > 0) {
              if (x1.isOdd()) {
                x1.iadd(delta);
              }
              x1.iushrn(1);
            }
          }
          for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
          if (j > 0) {
            b.iushrn(j);
            while (j-- > 0) {
              if (x2.isOdd()) {
                x2.iadd(delta);
              }
              x2.iushrn(1);
            }
          }
          if (a.cmp(b) >= 0) {
            a.isub(b);
            x1.isub(x2);
          } else {
            b.isub(a);
            x2.isub(x1);
          }
        }
        var res;
        if (a.cmpn(1) === 0) {
          res = x1;
        } else {
          res = x2;
        }
        if (res.cmpn(0) < 0) {
          res.iadd(p);
        }
        return res;
      };
      BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        for (var shift = 0; a.isEven() && b.isEven(); shift++) {
          a.iushrn(1);
          b.iushrn(1);
        }
        do {
          while (a.isEven()) {
            a.iushrn(1);
          }
          while (b.isEven()) {
            b.iushrn(1);
          }
          var r = a.cmp(b);
          if (r < 0) {
            var t = a;
            a = b;
            b = t;
          } else if (r === 0 || b.cmpn(1) === 0) {
            break;
          }
          a.isub(b);
        } while (true);
        return b.iushln(shift);
      };
      BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
      };
      BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
      };
      BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
      };
      BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
      };
      BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        if (this.length <= s) {
          this._expand(s + 1);
          this.words[s] |= q;
          return this;
        }
        var carry = q;
        for (var i = s; carry !== 0 && i < this.length; i++) {
          var w = this.words[i] | 0;
          w += carry;
          carry = w >>> 26;
          w &= 0x3ffffff;
          this.words[i] = w;
        }
        if (carry !== 0) {
          this.words[i] = carry;
          this.length++;
        }
        return this;
      };
      BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
      };
      BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) {
          res = 1;
        } else {
          if (negative) {
            num = -num;
          }
          assert(num <= 0x3ffffff, 'Number is too big');
          var w = this.words[0] | 0;
          res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
      };
      BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
      };
      BN.prototype.ucmp = function ucmp(num) {
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          var a = this.words[i] | 0;
          var b = num.words[i] | 0;
          if (a === b) continue;
          if (a < b) {
            res = -1;
          } else if (a > b) {
            res = 1;
          }
          break;
        }
        return res;
      };
      BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
      };
      BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
      };
      BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
      };
      BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
      };
      BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
      };
      BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
      };
      BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
      };
      BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
      };
      BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
      };
      BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
      };
      BN.red = function red(num) {
        return new Red(num);
      };
      BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
      };
      BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
      };
      BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
      };
      BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
      };
      BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
      };
      BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
      };
      BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
      };
      BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
      };
      BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
      };
      BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
      };
      BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
      };
      BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
      };
      BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
      };
      BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
      };
      BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
      };
      BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
      };
      BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
      };
      var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function MPrime(name, p) {
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
      }
      MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
      };
      MPrime.prototype.ireduce = function ireduce(num) {
        var r = num;
        var rlen;
        do {
          this.split(r, this.tmp);
          r = this.imulK(r);
          r = r.iadd(this.tmp);
          rlen = r.bitLength();
        } while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
          r.words[0] = 0;
          r.length = 1;
        } else if (cmp > 0) {
          r.isub(this.p);
        } else {
          if (r.strip !== undefined) {
            r.strip();
          } else {
            r._strip();
          }
        }
        return r;
      };
      MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
      };
      MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
      };
      function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
      }
      inherits(K256, MPrime);
      K256.prototype.split = function split(input, output) {
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for (var i = 0; i < outLen; i++) {
          output.words[i] = input.words[i];
        }
        output.length = outLen;
        if (input.length <= 9) {
          input.words[0] = 0;
          input.length = 1;
          return;
        }
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for (i = 10; i < input.length; i++) {
          var next = input.words[i] | 0;
          input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
          prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) {
          input.length -= 10;
        } else {
          input.length -= 9;
        }
      };
      K256.prototype.imulK = function imulK(num) {
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        var lo = 0;
        for (var i = 0; i < num.length; i++) {
          var w = num.words[i] | 0;
          lo += w * 0x3d1;
          num.words[i] = lo & 0x3ffffff;
          lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        if (num.words[num.length - 1] === 0) {
          num.length--;
          if (num.words[num.length - 1] === 0) {
            num.length--;
          }
        }
        return num;
      };
      function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
      }
      inherits(P224, MPrime);
      function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
      }
      inherits(P192, MPrime);
      function P25519() {
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
      }
      inherits(P25519, MPrime);
      P25519.prototype.imulK = function imulK(num) {
        var carry = 0;
        for (var i = 0; i < num.length; i++) {
          var hi = (num.words[i] | 0) * 0x13 + carry;
          var lo = hi & 0x3ffffff;
          hi >>>= 26;
          num.words[i] = lo;
          carry = hi;
        }
        if (carry !== 0) {
          num.words[num.length++] = carry;
        }
        return num;
      };
      BN._prime = function prime(name) {
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') {
          prime = new K256();
        } else if (name === 'p224') {
          prime = new P224();
        } else if (name === 'p192') {
          prime = new P192();
        } else if (name === 'p25519') {
          prime = new P25519();
        } else {
          throw new Error('Unknown prime ' + name);
        }
        primes[name] = prime;
        return prime;
      };
      function Red(m) {
        if (typeof m === 'string') {
          var prime = BN._prime(m);
          this.m = prime.p;
          this.prime = prime;
        } else {
          assert(m.gtn(1), 'modulus must be greater than 1');
          this.m = m;
          this.prime = null;
        }
      }
      Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
      };
      Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
      };
      Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
      };
      Red.prototype.neg = function neg(a) {
        if (a.isZero()) {
          return a.clone();
        }
        return this.m.sub(a)._forceRed(this);
      };
      Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) {
          res.isub(this.m);
        }
        return res._forceRed(this);
      };
      Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) {
          res.isub(this.m);
        }
        return res;
      };
      Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) {
          res.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) {
          res.iadd(this.m);
        }
        return res;
      };
      Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
      };
      Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
      };
      Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
      };
      Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
      };
      Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
      };
      Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        if (mod3 === 3) {
          var pow = this.m.add(new BN(1)).iushrn(2);
          return this.pow(a, pow);
        }
        var q = this.m.subn(1);
        var s = 0;
        while (!q.isZero() && q.andln(1) === 0) {
          s++;
          q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while (this.pow(z, lpow).cmp(nOne) !== 0) {
          z.redIAdd(nOne);
        }
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while (t.cmp(one) !== 0) {
          var tmp = t;
          for (var i = 0; tmp.cmp(one) !== 0; i++) {
            tmp = tmp.redSqr();
          }
          assert(i < m);
          var b = this.pow(c, new BN(1).iushln(m - i - 1));
          r = r.redMul(b);
          c = b.redSqr();
          t = t.redMul(c);
          m = i;
        }
        return r;
      };
      Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
          inv.negative = 0;
          return this.imod(inv).redNeg();
        } else {
          return this.imod(inv);
        }
      };
      Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for (var i = 2; i < wnd.length; i++) {
          wnd[i] = this.mul(wnd[i - 1], a);
        }
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) {
          start = 26;
        }
        for (i = num.length - 1; i >= 0; i--) {
          var word = num.words[i];
          for (var j = start - 1; j >= 0; j--) {
            var bit = word >> j & 1;
            if (res !== wnd[0]) {
              res = this.sqr(res);
            }
            if (bit === 0 && current === 0) {
              currentLen = 0;
              continue;
            }
            current <<= 1;
            current |= bit;
            currentLen++;
            if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
            res = this.mul(res, wnd[current]);
            currentLen = 0;
            current = 0;
          }
          start = 26;
        }
        return res;
      };
      Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
      };
      Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
      };
      BN.mont = function mont(num) {
        return new Mont(num);
      };
      function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) {
          this.shift += 26 - this.shift % 26;
        }
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
      }
      inherits(Mont, Red);
      Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
      };
      Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
      };
      Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
          a.words[0] = 0;
          a.length = 1;
          return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) {
          res = u.isub(this.m);
        } else if (u.cmpn(0) < 0) {
          res = u.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) {
          res = u.isub(this.m);
        } else if (u.cmpn(0) < 0) {
          res = u.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Mont.prototype.invm = function invm(a) {
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
      };
    })(module, commonjsGlobal);
  })(bn);
  var bnExports = bn.exports;
  getDefaultExportFromCjs(bnExports);

  const BN$8 = bnExports;
  const Bytes$1 = bytes;
  const fromBN = bn => "0x" + bn.toString("hex");
  const toBN = str => new BN$8(str.slice(2), 16);
  const fromString = str => {
    const bn = "0x" + (str.slice(0, 2) === "0x" ? new BN$8(str.slice(2), 16) : new BN$8(str, 10)).toString("hex");
    return bn === "0x0" ? "0x" : bn;
  };
  const toEther = wei => toNumber(div(wei, fromString("10000000000"))) / 100000000;
  const fromEther = eth => mul(fromNumber(Math.floor(eth * 100000000)), fromString("10000000000"));
  const toString = a => toBN(a).toString(10);
  const fromNumber = a => typeof a === "string" ? /^0x/.test(a) ? a : "0x" + a : "0x" + new BN$8(a).toString("hex");
  const toNumber = a => toBN(a).toNumber();
  const toUint256 = a => Bytes$1.pad(32, a);
  const bin = method => (a, b) => fromBN(toBN(a)[method](toBN(b)));
  const add = bin("add");
  const mul = bin("mul");
  const div = bin("div");
  const sub = bin("sub");
  var nat = {
    toString,
    fromString,
    toNumber,
    fromNumber,
    toEther,
    fromEther,
    toUint256,
    add,
    mul,
    div,
    sub
  };
  getDefaultExportFromCjs(nat);

  var elliptic$1 = {};

  var name = "elliptic";
  var version$1 = "6.5.4";
  var description = "EC cryptography";
  var main = "lib/elliptic.js";
  var files = [
  	"lib"
  ];
  var scripts = {
  	lint: "eslint lib test",
  	"lint:fix": "npm run lint -- --fix",
  	unit: "istanbul test _mocha --reporter=spec test/index.js",
  	test: "npm run lint && npm run unit",
  	version: "grunt dist && git add dist/"
  };
  var repository = {
  	type: "git",
  	url: "git@github.com:indutny/elliptic"
  };
  var keywords = [
  	"EC",
  	"Elliptic",
  	"curve",
  	"Cryptography"
  ];
  var author = "Fedor Indutny <fedor@indutny.com>";
  var license = "MIT";
  var bugs = {
  	url: "https://github.com/indutny/elliptic/issues"
  };
  var homepage = "https://github.com/indutny/elliptic";
  var devDependencies = {
  	brfs: "^2.0.2",
  	coveralls: "^3.1.0",
  	eslint: "^7.6.0",
  	grunt: "^1.2.1",
  	"grunt-browserify": "^5.3.0",
  	"grunt-cli": "^1.3.2",
  	"grunt-contrib-connect": "^3.0.0",
  	"grunt-contrib-copy": "^1.0.0",
  	"grunt-contrib-uglify": "^5.0.0",
  	"grunt-mocha-istanbul": "^5.0.2",
  	"grunt-saucelabs": "^9.0.1",
  	istanbul: "^0.4.5",
  	mocha: "^8.0.1"
  };
  var dependencies$1 = {
  	"bn.js": "^4.11.9",
  	brorand: "^1.1.0",
  	"hash.js": "^1.0.0",
  	"hmac-drbg": "^1.0.1",
  	inherits: "^2.0.4",
  	"minimalistic-assert": "^1.0.1",
  	"minimalistic-crypto-utils": "^1.0.1"
  };
  var require$$0$2 = {
  	name: name,
  	version: version$1,
  	description: description,
  	main: main,
  	files: files,
  	scripts: scripts,
  	repository: repository,
  	keywords: keywords,
  	author: author,
  	license: license,
  	bugs: bugs,
  	homepage: homepage,
  	devDependencies: devDependencies,
  	dependencies: dependencies$1
  };

  var utils$m = {};

  var minimalisticAssert = assert$f;
  function assert$f(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }
  assert$f.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
  };
  getDefaultExportFromCjs(minimalisticAssert);

  var utils$l = {};

  (function (exports) {
    var utils = exports;
    function toArray(msg, enc) {
      if (Array.isArray(msg)) return msg.slice();
      if (!msg) return [];
      var res = [];
      if (typeof msg !== 'string') {
        for (var i = 0; i < msg.length; i++) res[i] = msg[i] | 0;
        return res;
      }
      if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for (var i = 0; i < msg.length; i += 2) res.push(parseInt(msg[i] + msg[i + 1], 16));
      } else {
        for (var i = 0; i < msg.length; i++) {
          var c = msg.charCodeAt(i);
          var hi = c >> 8;
          var lo = c & 0xff;
          if (hi) res.push(hi, lo);else res.push(lo);
        }
      }
      return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
      if (word.length === 1) return '0' + word;else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
      var res = '';
      for (var i = 0; i < msg.length; i++) res += zero2(msg[i].toString(16));
      return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
      if (enc === 'hex') return toHex(arr);else return arr;
    };
  })(utils$l);
  getDefaultExportFromCjs(utils$l);

  (function (exports) {
    var utils = exports;
    var BN = bnExports;
    var minAssert = minimalisticAssert;
    var minUtils = utils$l;
    utils.assert = minAssert;
    utils.toArray = minUtils.toArray;
    utils.zero2 = minUtils.zero2;
    utils.toHex = minUtils.toHex;
    utils.encode = minUtils.encode;
    function getNAF(num, w, bits) {
      var naf = new Array(Math.max(num.bitLength(), bits) + 1);
      naf.fill(0);
      var ws = 1 << w + 1;
      var k = num.clone();
      for (var i = 0; i < naf.length; i++) {
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
          if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;else z = mod;
          k.isubn(z);
        } else {
          z = 0;
        }
        naf[i] = z;
        k.iushrn(1);
      }
      return naf;
    }
    utils.getNAF = getNAF;
    function getJSF(k1, k2) {
      var jsf = [[], []];
      k1 = k1.clone();
      k2 = k2.clone();
      var d1 = 0;
      var d2 = 0;
      var m8;
      while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) {
          u1 = 0;
        } else {
          m8 = k1.andln(7) + d1 & 7;
          if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) {
          u2 = 0;
        } else {
          m8 = k2.andln(7) + d2 & 7;
          if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;else u2 = m24;
        }
        jsf[1].push(u2);
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
      }
      return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
      var key = '_' + name;
      obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
      };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
      return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
      return new BN(bytes, 'hex', 'le');
    }
    utils.intFromLE = intFromLE;
  })(utils$m);
  getDefaultExportFromCjs(utils$m);

  var brorand = {exports: {}};

  var empty = {};

  var empty$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: empty
  });

  var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(empty$1);

  var r$1;
  brorand.exports = function rand(len) {
    if (!r$1) r$1 = new Rand(null);
    return r$1.generate(len);
  };
  function Rand(rand) {
    this.rand = rand;
  }
  brorand.exports.Rand = Rand;
  Rand.prototype.generate = function generate(len) {
    return this._rand(len);
  };
  Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for (var i = 0; i < res.length; i++) res[i] = this.rand.getByte();
    return res;
  };
  if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) {
      Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
      };
    } else if (self.msCrypto && self.msCrypto.getRandomValues) {
      Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
      };
    } else if (typeof window === 'object') {
      Rand.prototype._rand = function () {
        throw new Error('Not implemented yet');
      };
    }
  } else {
    try {
      var crypto$1 = require$$0$1;
      if (typeof crypto$1.randomBytes !== 'function') throw new Error('Not supported');
      Rand.prototype._rand = function _rand(n) {
        return crypto$1.randomBytes(n);
      };
    } catch (e) {}
  }
  var brorandExports = brorand.exports;
  getDefaultExportFromCjs(brorandExports);

  var curve = {};

  var BN$7 = bnExports;
  var utils$k = utils$m;
  var getNAF = utils$k.getNAF;
  var getJSF = utils$k.getJSF;
  var assert$e = utils$k.assert;
  function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN$7(conf.p, 16);
    this.red = conf.prime ? BN$7.red(conf.prime) : BN$7.mont(this.p);
    this.zero = new BN$7(0).toRed(this.red);
    this.one = new BN$7(1).toRed(this.red);
    this.two = new BN$7(2).toRed(this.red);
    this.n = conf.n && new BN$7(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) {
      this.redN = null;
    } else {
      this._maxwellTrick = true;
      this.redN = this.n.toRed(this.red);
    }
  }
  var base = BaseCurve;
  BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
  };
  BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
  };
  BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert$e(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    var repr = [];
    var j;
    var nafW;
    for (j = 0; j < naf.length; j += doubles.step) {
      nafW = 0;
      for (var l = j + doubles.step - 1; l >= j; l--) nafW = (nafW << 1) + naf[l];
      repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for (var i = I; i > 0; i--) {
      for (j = 0; j < repr.length; j++) {
        nafW = repr[j];
        if (nafW === i) b = b.mixedAdd(doubles.points[j]);else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
      }
      a = a.add(b);
    }
    return a.toP();
  };
  BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    var naf = getNAF(k, w, this._bitLength);
    var acc = this.jpoint(null, null, null);
    for (var i = naf.length - 1; i >= 0; i--) {
      for (var l = 0; i >= 0 && naf[i] === 0; i--) l++;
      if (i >= 0) l++;
      acc = acc.dblp(l);
      if (i < 0) break;
      var z = naf[i];
      assert$e(z !== 0);
      if (p.type === 'affine') {
        if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
      } else {
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);else acc = acc.add(wnd[-z - 1 >> 1].neg());
      }
    }
    return p.type === 'affine' ? acc.toP() : acc;
  };
  BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    var max = 0;
    var i;
    var j;
    var p;
    for (i = 0; i < len; i++) {
      p = points[i];
      var nafPoints = p._getNAFPoints(defW);
      wndWidth[i] = nafPoints.wnd;
      wnd[i] = nafPoints.points;
    }
    for (i = len - 1; i >= 1; i -= 2) {
      var a = i - 1;
      var b = i;
      if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
        naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
        naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
        max = Math.max(naf[a].length, max);
        max = Math.max(naf[b].length, max);
        continue;
      }
      var comb = [points[a],
      null,
      null,
      points[b] ];
      if (points[a].y.cmp(points[b].y) === 0) {
        comb[1] = points[a].add(points[b]);
        comb[2] = points[a].toJ().mixedAdd(points[b].neg());
      } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
        comb[1] = points[a].toJ().mixedAdd(points[b]);
        comb[2] = points[a].add(points[b].neg());
      } else {
        comb[1] = points[a].toJ().mixedAdd(points[b]);
        comb[2] = points[a].toJ().mixedAdd(points[b].neg());
      }
      var index = [-3,
      -1,
      -5,
      -7,
      0,
      7,
      5,
      1,
      3 ];
      var jsf = getJSF(coeffs[a], coeffs[b]);
      max = Math.max(jsf[0].length, max);
      naf[a] = new Array(max);
      naf[b] = new Array(max);
      for (j = 0; j < max; j++) {
        var ja = jsf[0][j] | 0;
        var jb = jsf[1][j] | 0;
        naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
        naf[b][j] = 0;
        wnd[a] = comb;
      }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for (i = max; i >= 0; i--) {
      var k = 0;
      while (i >= 0) {
        var zero = true;
        for (j = 0; j < len; j++) {
          tmp[j] = naf[j][i] | 0;
          if (tmp[j] !== 0) zero = false;
        }
        if (!zero) break;
        k++;
        i--;
      }
      if (i >= 0) k++;
      acc = acc.dblp(k);
      if (i < 0) break;
      for (j = 0; j < len; j++) {
        var z = tmp[j];
        if (z === 0) continue;else if (z > 0) p = wnd[j][z - 1 >> 1];else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
        if (p.type === 'affine') acc = acc.mixedAdd(p);else acc = acc.add(p);
      }
    }
    for (i = 0; i < len; i++) wnd[i] = null;
    if (jacobianResult) return acc;else return acc.toP();
  };
  function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
  }
  BaseCurve.BasePoint = BasePoint;
  BasePoint.prototype.eq = function eq(
  ) {
    throw new Error('Not implemented');
  };
  BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
  };
  BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils$k.toArray(bytes, enc);
    var len = this.p.byteLength();
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
      if (bytes[0] === 0x06) assert$e(bytes[bytes.length - 1] % 2 === 0);else if (bytes[0] === 0x07) assert$e(bytes[bytes.length - 1] % 2 === 1);
      var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
      return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) {
      return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    }
    throw new Error('Unknown point format');
  };
  BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
  };
  BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [this.getY().isEven() ? 0x02 : 0x03].concat(x);
    return [0x04].concat(x, this.getY().toArray('be', len));
  };
  BasePoint.prototype.encode = function encode(enc, compact) {
    return utils$k.encode(this._encode(compact), enc);
  };
  BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
      doubles: null,
      naf: null,
      beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
  };
  BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
  };
  BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [this];
    var acc = this;
    for (var i = 0; i < power; i += step) {
      for (var j = 0; j < step; j++) acc = acc.dbl();
      doubles.push(acc);
    }
    return {
      step: step,
      points: doubles
    };
  };
  BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [this];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for (var i = 1; i < max; i++) res[i] = res[i - 1].add(dbl);
    return {
      wnd: wnd,
      points: res
    };
  };
  BasePoint.prototype._getBeta = function _getBeta() {
    return null;
  };
  BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for (var i = 0; i < k; i++) r = r.dbl();
    return r;
  };
  getDefaultExportFromCjs(base);

  var inherits$6 = {exports: {}};

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
  }
  if (typeof global.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
  }
  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      return setTimeout(fun, 0);
    }
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }
    try {
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }
  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      return clearTimeout(marker);
    }
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }
    try {
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        return cachedClearTimeout.call(this, marker);
      }
    }
  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }
    draining = false;
    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }
    if (queue.length) {
      drainQueue();
    }
  }
  function drainQueue() {
    if (draining) {
      return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
      currentQueue = queue;
      queue = [];
      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }
      queueIndex = -1;
      len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }
  function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  var title = 'browser';
  var platform = 'browser';
  var browser = true;
  var env = {};
  var argv = [];
  var version = '';
  var versions = {};
  var release = {};
  var config = {};
  function noop() {}
  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;
  function binding(name) {
    throw new Error('process.binding is not supported');
  }
  function cwd() {
    return '/';
  }
  function chdir(dir) {
    throw new Error('process.chdir is not supported');
  }
  function umask() {
    return 0;
  }
  var performance = global.performance || {};
  var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
    return new Date().getTime();
  };
  function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds < 0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }
    return [seconds, nanoseconds];
  }
  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
  }
  var process = {
    nextTick: nextTick,
    title: title,
    browser: browser,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
  };

  var inherits$4;
  if (typeof Object.create === 'function') {
    inherits$4 = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    inherits$4 = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  var inherits$5 = inherits$4;

  var formatRegExp = /%[sdj%]/g;
  function format(f) {
    if (!isString(f)) {
      var objects = [];
      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }
      return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') return '%';
      if (i >= len) return x;
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
        default:
          return x;
      }
    });
    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }
    return str;
  }
  function deprecate(fn, msg) {
    if (isUndefined(global.process)) {
      return function () {
        return deprecate(fn, msg).apply(this, arguments);
      };
    }
    if (process.noDeprecation === true) {
      return fn;
    }
    var warned = false;
    function deprecated() {
      if (!warned) {
        if (process.throwDeprecation) {
          throw new Error(msg);
        } else if (process.traceDeprecation) {
          console.trace(msg);
        } else {
          console.error(msg);
        }
        warned = true;
      }
      return fn.apply(this, arguments);
    }
    return deprecated;
  }
  var debugs = {};
  var debugEnviron;
  function debuglog(set) {
    if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = 0;
        debugs[set] = function () {
          var msg = format.apply(null, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function () {};
      }
    }
    return debugs[set];
  }
  function inspect(obj, opts) {
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    };
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) {
      ctx.showHidden = opts;
    } else if (opts) {
      _extend(ctx, opts);
    }
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }
  inspect.colors = {
    'bold': [1, 22],
    'italic': [3, 23],
    'underline': [4, 24],
    'inverse': [7, 27],
    'white': [37, 39],
    'grey': [90, 39],
    'black': [30, 39],
    'blue': [34, 39],
    'cyan': [36, 39],
    'green': [32, 39],
    'magenta': [35, 39],
    'red': [31, 39],
    'yellow': [33, 39]
  };
  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    'regexp': 'red'
  };
  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];
    if (style) {
      return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }
  function stylizeNoColor(str, styleType) {
    return str;
  }
  function arrayToHash(array) {
    var hash = {};
    array.forEach(function (val, idx) {
      hash[val] = true;
    });
    return hash;
  }
  function formatValue(ctx, value, recurseTimes) {
    if (ctx.customInspect && value && isFunction(value.inspect) &&
    value.inspect !== inspect &&
    !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);
      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }
      return ret;
    }
    var primitive = formatPrimitive(ctx, value);
    if (primitive) {
      return primitive;
    }
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    }
    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    }
    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }
      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }
      if (isError(value)) {
        return formatError(value);
      }
    }
    var base = '',
      array = false,
      braces = ['{', '}'];
    if (isArray(value)) {
      array = true;
      braces = ['[', ']'];
    }
    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    }
    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    }
    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    }
    if (isError(value)) {
      base = ' ' + formatError(value);
    }
    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }
    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }
    ctx.seen.push(value);
    var output;
    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function (key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
  }
  function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }
    if (isNumber(value)) return ctx.stylize('' + value, 'number');
    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    if (isNull(value)) return ctx.stylize('null', 'null');
  }
  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }
  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
      } else {
        output.push('');
      }
    }
    keys.forEach(function (key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
      }
    });
    return output;
  }
  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
      value: value[key]
    };
    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }
    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }
    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }
        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function (line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function (line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }
    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }
      name = JSON.stringify('' + key);
      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }
    return name + ': ' + str;
  }
  function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function (prev, cur) {
      if (cur.indexOf('\n') >= 0) ;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) {
      return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    }
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  }
  function isArray(ar) {
    return Array.isArray(ar);
  }
  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }
  function isNull(arg) {
    return arg === null;
  }
  function isNullOrUndefined(arg) {
    return arg == null;
  }
  function isNumber(arg) {
    return typeof arg === 'number';
  }
  function isString(arg) {
    return typeof arg === 'string';
  }
  function isSymbol(arg) {
    return typeof arg === 'symbol';
  }
  function isUndefined(arg) {
    return arg === void 0;
  }
  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }
  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }
  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }
  function isError(e) {
    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
  }
  function isFunction(arg) {
    return typeof arg === 'function';
  }
  function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' ||
    typeof arg === 'undefined';
  }
  function isBuffer(maybeBuf) {
    return Buffer.isBuffer(maybeBuf);
  }
  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }
  function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
  }
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function timestamp() {
    var d = new Date();
    var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
    return [d.getDate(), months[d.getMonth()], time].join(' ');
  }
  function log() {
    console.log('%s - %s', timestamp(), format.apply(null, arguments));
  }
  function _extend(origin, add) {
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }
    return origin;
  }
  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
  var util$1 = {
    inherits: inherits$5,
    _extend: _extend,
    log: log,
    isBuffer: isBuffer,
    isPrimitive: isPrimitive,
    isFunction: isFunction,
    isError: isError,
    isDate: isDate,
    isObject: isObject,
    isRegExp: isRegExp,
    isUndefined: isUndefined,
    isSymbol: isSymbol,
    isString: isString,
    isNumber: isNumber,
    isNullOrUndefined: isNullOrUndefined,
    isNull: isNull,
    isBoolean: isBoolean,
    isArray: isArray,
    inspect: inspect,
    deprecate: deprecate,
    format: format,
    debuglog: debuglog
  };

  var util$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    _extend: _extend,
    debuglog: debuglog,
    default: util$1,
    deprecate: deprecate,
    format: format,
    inherits: inherits$5,
    inspect: inspect,
    isArray: isArray,
    isBoolean: isBoolean,
    isBuffer: isBuffer,
    isDate: isDate,
    isError: isError,
    isFunction: isFunction,
    isNull: isNull,
    isNullOrUndefined: isNullOrUndefined,
    isNumber: isNumber,
    isObject: isObject,
    isPrimitive: isPrimitive,
    isRegExp: isRegExp,
    isString: isString,
    isSymbol: isSymbol,
    isUndefined: isUndefined,
    log: log
  });

  var require$$0 = /*@__PURE__*/getAugmentedNamespace(util$2);

  var inherits_browser = {exports: {}};

  var hasRequiredInherits_browser;
  function requireInherits_browser() {
    if (hasRequiredInherits_browser) return inherits_browser.exports;
    hasRequiredInherits_browser = 1;
    if (typeof Object.create === 'function') {
      inherits_browser.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
        }
      };
    } else {
      inherits_browser.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          var TempCtor = function () {};
          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        }
      };
    }
    return inherits_browser.exports;
  }

  try {
    var util = require$$0;
    if (typeof util.inherits !== 'function') throw '';
    inherits$6.exports = util.inherits;
  } catch (e) {
    inherits$6.exports = requireInherits_browser();
  }
  var inheritsExports = inherits$6.exports;
  getDefaultExportFromCjs(inheritsExports);

  var utils$j = utils$m;
  var BN$6 = bnExports;
  var inherits$3 = inheritsExports;
  var Base$2 = base;
  var assert$d = utils$j.assert;
  function ShortCurve(conf) {
    Base$2.call(this, 'short', conf);
    this.a = new BN$6(conf.a, 16).toRed(this.red);
    this.b = new BN$6(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
  }
  inherits$3(ShortCurve, Base$2);
  var short = ShortCurve;
  ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    var beta;
    var lambda;
    if (conf.beta) {
      beta = new BN$6(conf.beta, 16).toRed(this.red);
    } else {
      var betas = this._getEndoRoots(this.p);
      beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
      beta = beta.toRed(this.red);
    }
    if (conf.lambda) {
      lambda = new BN$6(conf.lambda, 16);
    } else {
      var lambdas = this._getEndoRoots(this.n);
      if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
        lambda = lambdas[0];
      } else {
        lambda = lambdas[1];
        assert$d(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
      }
    }
    var basis;
    if (conf.basis) {
      basis = conf.basis.map(function (vec) {
        return {
          a: new BN$6(vec.a, 16),
          b: new BN$6(vec.b, 16)
        };
      });
    } else {
      basis = this._getEndoBasis(lambda);
    }
    return {
      beta: beta,
      lambda: lambda,
      basis: basis
    };
  };
  ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    var red = num === this.p ? this.red : BN$6.mont(num);
    var tinv = new BN$6(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN$6(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [l1, l2];
  };
  ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN$6(1);
    var y1 = new BN$6(0);
    var x2 = new BN$6(0);
    var y2 = new BN$6(1);
    var a0;
    var b0;
    var a1;
    var b1;
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while (u.cmpn(0) !== 0) {
      var q = v.div(u);
      r = v.sub(q.mul(u));
      x = x2.sub(q.mul(x1));
      var y = y2.sub(q.mul(y1));
      if (!a1 && r.cmp(aprxSqrt) < 0) {
        a0 = prevR.neg();
        b0 = x1;
        a1 = r.neg();
        b1 = x;
      } else if (a1 && ++i === 2) {
        break;
      }
      prevR = r;
      v = u;
      u = r;
      x2 = x1;
      x1 = x;
      y2 = y1;
      y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
      a2 = a0;
      b2 = b0;
    }
    if (a1.negative) {
      a1 = a1.neg();
      b1 = b1.neg();
    }
    if (a2.negative) {
      a2 = a2.neg();
      b2 = b2.neg();
    }
    return [{
      a: a1,
      b: b1
    }, {
      a: a2,
      b: b2
    }];
  };
  ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
      k1: k1,
      k2: k2
    };
  };
  ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN$6(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
  };
  ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
  };
  ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for (var i = 0; i < points.length; i++) {
      var split = this._endoSplit(coeffs[i]);
      var p = points[i];
      var beta = p._getBeta();
      if (split.k1.negative) {
        split.k1.ineg();
        p = p.neg(true);
      }
      if (split.k2.negative) {
        split.k2.ineg();
        beta = beta.neg(true);
      }
      npoints[i * 2] = p;
      npoints[i * 2 + 1] = beta;
      ncoeffs[i * 2] = split.k1;
      ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    for (var j = 0; j < i * 2; j++) {
      npoints[j] = null;
      ncoeffs[j] = null;
    }
    return res;
  };
  function Point$2(curve, x, y, isRed) {
    Base$2.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
      this.x = null;
      this.y = null;
      this.inf = true;
    } else {
      this.x = new BN$6(x, 16);
      this.y = new BN$6(y, 16);
      if (isRed) {
        this.x.forceRed(this.curve.red);
        this.y.forceRed(this.curve.red);
      }
      if (!this.x.red) this.x = this.x.toRed(this.curve.red);
      if (!this.y.red) this.y = this.y.toRed(this.curve.red);
      this.inf = false;
    }
  }
  inherits$3(Point$2, Base$2.BasePoint);
  ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point$2(this, x, y, isRed);
  };
  ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point$2.fromJSON(this, obj, red);
  };
  Point$2.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
      var curve = this.curve;
      var endoMul = function (p) {
        return curve.point(p.x.redMul(curve.endo.beta), p.y);
      };
      pre.beta = beta;
      beta.precomputed = {
        beta: null,
        naf: pre.naf && {
          wnd: pre.naf.wnd,
          points: pre.naf.points.map(endoMul)
        },
        doubles: pre.doubles && {
          step: pre.doubles.step,
          points: pre.doubles.points.map(endoMul)
        }
      };
    }
    return beta;
  };
  Point$2.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [this.x, this.y];
    return [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }];
  };
  Point$2.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
      return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
      beta: null,
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: [res].concat(pre.doubles.points.map(obj2point))
      },
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: [res].concat(pre.naf.points.map(obj2point))
      }
    };
    return res;
  };
  Point$2.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
  };
  Point$2.prototype.isInfinity = function isInfinity() {
    return this.inf;
  };
  Point$2.prototype.add = function add(p) {
    if (this.inf) return p;
    if (p.inf) return this;
    if (this.eq(p)) return this.dbl();
    if (this.neg().eq(p)) return this.curve.point(null, null);
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
  };
  Point$2.prototype.dbl = function dbl() {
    if (this.inf) return this;
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
  };
  Point$2.prototype.getX = function getX() {
    return this.x.fromRed();
  };
  Point$2.prototype.getY = function getY() {
    return this.y.fromRed();
  };
  Point$2.prototype.mul = function mul(k) {
    k = new BN$6(k, 16);
    if (this.isInfinity()) return this;else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);else if (this.curve.endo) return this.curve._endoWnafMulAdd([this], [k]);else return this.curve._wnafMul(this, k);
  };
  Point$2.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [this, p2];
    var coeffs = [k1, k2];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);else return this.curve._wnafMulAdd(1, points, coeffs, 2);
  };
  Point$2.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [this, p2];
    var coeffs = [k1, k2];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
  };
  Point$2.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
  };
  Point$2.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
      var pre = this.precomputed;
      var negate = function (p) {
        return p.neg();
      };
      res.precomputed = {
        naf: pre.naf && {
          wnd: pre.naf.wnd,
          points: pre.naf.points.map(negate)
        },
        doubles: pre.doubles && {
          step: pre.doubles.step,
          points: pre.doubles.points.map(negate)
        }
      };
    }
    return res;
  };
  Point$2.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
  };
  function JPoint(curve, x, y, z) {
    Base$2.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
      this.x = this.curve.one;
      this.y = this.curve.one;
      this.z = new BN$6(0);
    } else {
      this.x = new BN$6(x, 16);
      this.y = new BN$6(y, 16);
      this.z = new BN$6(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
  }
  inherits$3(JPoint, Base$2.BasePoint);
  ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
  };
  JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
  };
  JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  };
  JPoint.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
      if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
  };
  JPoint.prototype.mixedAdd = function mixedAdd(p) {
    if (this.isInfinity()) return p.toJ();
    if (p.isInfinity()) return this;
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
      if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
  };
  JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
      var r = this;
      for (i = 0; i < pow; i++) r = r.dbl();
      return r;
    }
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jyd = jy.redAdd(jy);
    for (i = 0; i < pow; i++) {
      var jx2 = jx.redSqr();
      var jyd2 = jyd.redSqr();
      var jyd4 = jyd2.redSqr();
      var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
      var t1 = jx.redMul(jyd2);
      var nx = c.redSqr().redISub(t1.redAdd(t1));
      var t2 = t1.redISub(nx);
      var dny = c.redMul(t2);
      dny = dny.redIAdd(dny).redISub(jyd4);
      var nz = jyd.redMul(jz);
      if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
      jx = nx;
      jz = nz;
      jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
  };
  JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();else if (this.curve.threeA) return this._threeDbl();else return this._dbl();
  };
  JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    if (this.zOne) {
      var xx = this.x.redSqr();
      var yy = this.y.redSqr();
      var yyyy = yy.redSqr();
      var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
      s = s.redIAdd(s);
      var m = xx.redAdd(xx).redIAdd(xx);
      var t = m.redSqr().redISub(s).redISub(s);
      var yyyy8 = yyyy.redIAdd(yyyy);
      yyyy8 = yyyy8.redIAdd(yyyy8);
      yyyy8 = yyyy8.redIAdd(yyyy8);
      nx = t;
      ny = m.redMul(s.redISub(t)).redISub(yyyy8);
      nz = this.y.redAdd(this.y);
    } else {
      var a = this.x.redSqr();
      var b = this.y.redSqr();
      var c = b.redSqr();
      var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
      d = d.redIAdd(d);
      var e = a.redAdd(a).redIAdd(a);
      var f = e.redSqr();
      var c8 = c.redIAdd(c);
      c8 = c8.redIAdd(c8);
      c8 = c8.redIAdd(c8);
      nx = f.redISub(d).redISub(d);
      ny = e.redMul(d.redISub(nx)).redISub(c8);
      nz = this.y.redMul(this.z);
      nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
  };
  JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    if (this.zOne) {
      var xx = this.x.redSqr();
      var yy = this.y.redSqr();
      var yyyy = yy.redSqr();
      var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
      s = s.redIAdd(s);
      var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
      var t = m.redSqr().redISub(s).redISub(s);
      nx = t;
      var yyyy8 = yyyy.redIAdd(yyyy);
      yyyy8 = yyyy8.redIAdd(yyyy8);
      yyyy8 = yyyy8.redIAdd(yyyy8);
      ny = m.redMul(s.redISub(t)).redISub(yyyy8);
      nz = this.y.redAdd(this.y);
    } else {
      var delta = this.z.redSqr();
      var gamma = this.y.redSqr();
      var beta = this.x.redMul(gamma);
      var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
      alpha = alpha.redAdd(alpha).redIAdd(alpha);
      var beta4 = beta.redIAdd(beta);
      beta4 = beta4.redIAdd(beta4);
      var beta8 = beta4.redAdd(beta4);
      nx = alpha.redSqr().redISub(beta8);
      nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
      var ggamma8 = gamma.redSqr();
      ggamma8 = ggamma8.redIAdd(ggamma8);
      ggamma8 = ggamma8.redIAdd(ggamma8);
      ggamma8 = ggamma8.redIAdd(ggamma8);
      ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
  };
  JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
  };
  JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var xx = this.x.redSqr();
    var yy = this.y.redSqr();
    var zz = this.z.redSqr();
    var yyyy = yy.redSqr();
    var m = xx.redAdd(xx).redIAdd(xx);
    var mm = m.redSqr();
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    var ee = e.redSqr();
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
  };
  JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN$6(k, kbase);
    return this.curve._wnafMul(this, k);
  };
  JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
  };
  JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for (;;) {
      xc.iadd(this.curve.n);
      if (xc.cmp(this.curve.p) >= 0) return false;
      rx.redIAdd(t);
      if (this.x.cmp(rx) === 0) return true;
    }
  };
  JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
  };
  JPoint.prototype.isInfinity = function isInfinity() {
    return this.z.cmpn(0) === 0;
  };
  getDefaultExportFromCjs(short);

  var BN$5 = bnExports;
  var inherits$2 = inheritsExports;
  var Base$1 = base;
  var utils$i = utils$m;
  function MontCurve(conf) {
    Base$1.call(this, 'mont', conf);
    this.a = new BN$5(conf.a, 16).toRed(this.red);
    this.b = new BN$5(conf.b, 16).toRed(this.red);
    this.i4 = new BN$5(4).toRed(this.red).redInvm();
    this.two = new BN$5(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  inherits$2(MontCurve, Base$1);
  var mont = MontCurve;
  MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
  };
  function Point$1(curve, x, z) {
    Base$1.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
      this.x = this.curve.one;
      this.z = this.curve.zero;
    } else {
      this.x = new BN$5(x, 16);
      this.z = new BN$5(z, 16);
      if (!this.x.red) this.x = this.x.toRed(this.curve.red);
      if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
  }
  inherits$2(Point$1, Base$1.BasePoint);
  MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils$i.toArray(bytes, enc), 1);
  };
  MontCurve.prototype.point = function point(x, z) {
    return new Point$1(this, x, z);
  };
  MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point$1.fromJSON(this, obj);
  };
  Point$1.prototype.precompute = function precompute() {
  };
  Point$1.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
  };
  Point$1.fromJSON = function fromJSON(curve, obj) {
    return new Point$1(curve, obj[0], obj[1] || curve.one);
  };
  Point$1.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
  };
  Point$1.prototype.isInfinity = function isInfinity() {
    return this.z.cmpn(0) === 0;
  };
  Point$1.prototype.dbl = function dbl() {
    var a = this.x.redAdd(this.z);
    var aa = a.redSqr();
    var b = this.x.redSub(this.z);
    var bb = b.redSqr();
    var c = aa.redSub(bb);
    var nx = aa.redMul(bb);
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
  };
  Point$1.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
  };
  Point$1.prototype.diffAdd = function diffAdd(p, diff) {
    var a = this.x.redAdd(this.z);
    var b = this.x.redSub(this.z);
    var c = p.x.redAdd(p.z);
    var d = p.x.redSub(p.z);
    var da = d.redMul(a);
    var cb = c.redMul(b);
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
  };
  Point$1.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this;
    var b = this.curve.point(null, null);
    var c = this;
    for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1)) bits.push(t.andln(1));
    for (var i = bits.length - 1; i >= 0; i--) {
      if (bits[i] === 0) {
        a = a.diffAdd(b, c);
        b = b.dbl();
      } else {
        b = a.diffAdd(b, c);
        a = a.dbl();
      }
    }
    return b;
  };
  Point$1.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
  };
  Point$1.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
  };
  Point$1.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
  };
  Point$1.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
  };
  Point$1.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
  };
  getDefaultExportFromCjs(mont);

  var utils$h = utils$m;
  var BN$4 = bnExports;
  var inherits$1 = inheritsExports;
  var Base = base;
  var assert$c = utils$h.assert;
  function EdwardsCurve(conf) {
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, 'edwards', conf);
    this.a = new BN$4(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN$4(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN$4(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert$c(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
  }
  inherits$1(EdwardsCurve, Base);
  var edwards = EdwardsCurve;
  EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();else return this.a.redMul(num);
  };
  EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;else return this.c.redMul(num);
  };
  EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
  };
  EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN$4(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
  };
  EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN$4(y, 16);
    if (!y.red) y = y.toRed(this.red);
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
      if (odd) throw new Error('invalid point');else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
  };
  EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
  };
  function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
      this.x = this.curve.zero;
      this.y = this.curve.one;
      this.z = this.curve.one;
      this.t = this.curve.zero;
      this.zOne = true;
    } else {
      this.x = new BN$4(x, 16);
      this.y = new BN$4(y, 16);
      this.z = z ? new BN$4(z, 16) : this.curve.one;
      this.t = t && new BN$4(t, 16);
      if (!this.x.red) this.x = this.x.toRed(this.curve.red);
      if (!this.y.red) this.y = this.y.toRed(this.curve.red);
      if (!this.z.red) this.z = this.z.toRed(this.curve.red);
      if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
      this.zOne = this.z === this.curve.one;
      if (this.curve.extended && !this.t) {
        this.t = this.x.redMul(this.y);
        if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
      }
    }
  }
  inherits$1(Point, Base.BasePoint);
  EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
  };
  EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
  };
  Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
  };
  Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
  };
  Point.prototype.isInfinity = function isInfinity() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  };
  Point.prototype._extDbl = function _extDbl() {
    var a = this.x.redSqr();
    var b = this.y.redSqr();
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    var d = this.curve._mulA(a);
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    var g = d.redAdd(b);
    var f = g.redSub(c);
    var h = d.redSub(b);
    var nx = e.redMul(f);
    var ny = g.redMul(h);
    var nt = e.redMul(h);
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
  };
  Point.prototype._projDbl = function _projDbl() {
    var b = this.x.redAdd(this.y).redSqr();
    var c = this.x.redSqr();
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
      e = this.curve._mulA(c);
      var f = e.redAdd(d);
      if (this.zOne) {
        nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
        ny = f.redMul(e.redSub(d));
        nz = f.redSqr().redSub(f).redSub(f);
      } else {
        h = this.z.redSqr();
        j = f.redSub(h).redISub(h);
        nx = b.redSub(c).redISub(d).redMul(j);
        ny = f.redMul(e.redSub(d));
        nz = f.redMul(j);
      }
    } else {
      e = c.redAdd(d);
      h = this.curve._mulC(this.z).redSqr();
      j = e.redSub(h).redSub(h);
      nx = this.curve._mulC(b.redISub(e)).redMul(j);
      ny = this.curve._mulC(e).redMul(c.redISub(d));
      nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
  };
  Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.extended) return this._extDbl();else return this._projDbl();
  };
  Point.prototype._extAdd = function _extAdd(p) {
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    var d = this.z.redMul(p.z.redAdd(p.z));
    var e = b.redSub(a);
    var f = d.redSub(c);
    var g = d.redAdd(c);
    var h = b.redAdd(a);
    var nx = e.redMul(f);
    var ny = g.redMul(h);
    var nt = e.redMul(h);
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
  };
  Point.prototype._projAdd = function _projAdd(p) {
    var a = this.z.redMul(p.z);
    var b = a.redSqr();
    var c = this.x.redMul(p.x);
    var d = this.y.redMul(p.y);
    var e = this.curve.d.redMul(c).redMul(d);
    var f = b.redSub(e);
    var g = b.redAdd(e);
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
      ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
      nz = f.redMul(g);
    } else {
      ny = a.redMul(g).redMul(d.redSub(c));
      nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
  };
  Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);else return this._projAdd(p);
  };
  Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);else return this.curve._wnafMul(this, k);
  };
  Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, false);
  };
  Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, true);
  };
  Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
  };
  Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
  };
  Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
  };
  Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
  };
  Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
  };
  Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for (;;) {
      xc.iadd(this.curve.n);
      if (xc.cmp(this.curve.p) >= 0) return false;
      rx.redIAdd(t);
      if (this.x.cmp(rx) === 0) return true;
    }
  };
  Point.prototype.toP = Point.prototype.normalize;
  Point.prototype.mixedAdd = Point.prototype.add;
  getDefaultExportFromCjs(edwards);

  (function (exports) {
    var curve = exports;
    curve.base = base;
    curve.short = short;
    curve.mont = mont;
    curve.edwards = edwards;
  })(curve);
  getDefaultExportFromCjs(curve);

  var curves$2 = {};

  var hash$3 = {};

  var utils$g = {};

  var assert$b = minimalisticAssert;
  var inherits = inheritsExports;
  utils$g.inherits = inherits;
  function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
      return false;
    }
    if (i < 0 || i + 1 >= msg.length) {
      return false;
    }
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
  }
  function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
      if (!enc) {
        var p = 0;
        for (var i = 0; i < msg.length; i++) {
          var c = msg.charCodeAt(i);
          if (c < 128) {
            res[p++] = c;
          } else if (c < 2048) {
            res[p++] = c >> 6 | 192;
            res[p++] = c & 63 | 128;
          } else if (isSurrogatePair(msg, i)) {
            c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
            res[p++] = c >> 18 | 240;
            res[p++] = c >> 12 & 63 | 128;
            res[p++] = c >> 6 & 63 | 128;
            res[p++] = c & 63 | 128;
          } else {
            res[p++] = c >> 12 | 224;
            res[p++] = c >> 6 & 63 | 128;
            res[p++] = c & 63 | 128;
          }
        }
      } else if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for (i = 0; i < msg.length; i += 2) res.push(parseInt(msg[i] + msg[i + 1], 16));
      }
    } else {
      for (i = 0; i < msg.length; i++) res[i] = msg[i] | 0;
    }
    return res;
  }
  utils$g.toArray = toArray;
  function toHex(msg) {
    var res = '';
    for (var i = 0; i < msg.length; i++) res += zero2(msg[i].toString(16));
    return res;
  }
  utils$g.toHex = toHex;
  function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
  }
  utils$g.htonl = htonl;
  function toHex32(msg, endian) {
    var res = '';
    for (var i = 0; i < msg.length; i++) {
      var w = msg[i];
      if (endian === 'little') w = htonl(w);
      res += zero8(w.toString(16));
    }
    return res;
  }
  utils$g.toHex32 = toHex32;
  function zero2(word) {
    if (word.length === 1) return '0' + word;else return word;
  }
  utils$g.zero2 = zero2;
  function zero8(word) {
    if (word.length === 7) return '0' + word;else if (word.length === 6) return '00' + word;else if (word.length === 5) return '000' + word;else if (word.length === 4) return '0000' + word;else if (word.length === 3) return '00000' + word;else if (word.length === 2) return '000000' + word;else if (word.length === 1) return '0000000' + word;else return word;
  }
  utils$g.zero8 = zero8;
  function join32(msg, start, end, endian) {
    var len = end - start;
    assert$b(len % 4 === 0);
    var res = new Array(len / 4);
    for (var i = 0, k = start; i < res.length; i++, k += 4) {
      var w;
      if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
      res[i] = w >>> 0;
    }
    return res;
  }
  utils$g.join32 = join32;
  function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
      var m = msg[i];
      if (endian === 'big') {
        res[k] = m >>> 24;
        res[k + 1] = m >>> 16 & 0xff;
        res[k + 2] = m >>> 8 & 0xff;
        res[k + 3] = m & 0xff;
      } else {
        res[k + 3] = m >>> 24;
        res[k + 2] = m >>> 16 & 0xff;
        res[k + 1] = m >>> 8 & 0xff;
        res[k] = m & 0xff;
      }
    }
    return res;
  }
  utils$g.split32 = split32;
  function rotr32$1(w, b) {
    return w >>> b | w << 32 - b;
  }
  utils$g.rotr32 = rotr32$1;
  function rotl32$2(w, b) {
    return w << b | w >>> 32 - b;
  }
  utils$g.rotl32 = rotl32$2;
  function sum32$3(a, b) {
    return a + b >>> 0;
  }
  utils$g.sum32 = sum32$3;
  function sum32_3$1(a, b, c) {
    return a + b + c >>> 0;
  }
  utils$g.sum32_3 = sum32_3$1;
  function sum32_4$2(a, b, c, d) {
    return a + b + c + d >>> 0;
  }
  utils$g.sum32_4 = sum32_4$2;
  function sum32_5$2(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
  }
  utils$g.sum32_5 = sum32_5$2;
  function sum64$1(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
  }
  utils$g.sum64 = sum64$1;
  function sum64_hi$1(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
  }
  utils$g.sum64_hi = sum64_hi$1;
  function sum64_lo$1(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
  }
  utils$g.sum64_lo = sum64_lo$1;
  function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
  }
  utils$g.sum64_4_hi = sum64_4_hi$1;
  function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
  }
  utils$g.sum64_4_lo = sum64_4_lo$1;
  function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
  }
  utils$g.sum64_5_hi = sum64_5_hi$1;
  function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
  }
  utils$g.sum64_5_lo = sum64_5_lo$1;
  function rotr64_hi$1(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
  }
  utils$g.rotr64_hi = rotr64_hi$1;
  function rotr64_lo$1(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
  }
  utils$g.rotr64_lo = rotr64_lo$1;
  function shr64_hi$1(ah, al, num) {
    return ah >>> num;
  }
  utils$g.shr64_hi = shr64_hi$1;
  function shr64_lo$1(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
  }
  utils$g.shr64_lo = shr64_lo$1;

  var common$5 = {};

  var utils$f = utils$g;
  var assert$a = minimalisticAssert;
  function BlockHash$4() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
  }
  common$5.BlockHash = BlockHash$4;
  BlockHash$4.prototype.update = function update(msg, enc) {
    msg = utils$f.toArray(msg, enc);
    if (!this.pending) this.pending = msg;else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    if (this.pending.length >= this._delta8) {
      msg = this.pending;
      var r = msg.length % this._delta8;
      this.pending = msg.slice(msg.length - r, msg.length);
      if (this.pending.length === 0) this.pending = null;
      msg = utils$f.join32(msg, 0, msg.length - r, this.endian);
      for (var i = 0; i < msg.length; i += this._delta32) this._update(msg, i, i + this._delta32);
    }
    return this;
  };
  BlockHash$4.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert$a(this.pending === null);
    return this._digest(enc);
  };
  BlockHash$4.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for (var i = 1; i < k; i++) res[i] = 0;
    len <<= 3;
    if (this.endian === 'big') {
      for (var t = 8; t < this.padLength; t++) res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = len >>> 24 & 0xff;
      res[i++] = len >>> 16 & 0xff;
      res[i++] = len >>> 8 & 0xff;
      res[i++] = len & 0xff;
    } else {
      res[i++] = len & 0xff;
      res[i++] = len >>> 8 & 0xff;
      res[i++] = len >>> 16 & 0xff;
      res[i++] = len >>> 24 & 0xff;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      for (t = 8; t < this.padLength; t++) res[i++] = 0;
    }
    return res;
  };

  var sha = {};

  var common$4 = {};

  var utils$e = utils$g;
  var rotr32 = utils$e.rotr32;
  function ft_1$1(s, x, y, z) {
    if (s === 0) return ch32$1(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32$1(x, y, z);
  }
  common$4.ft_1 = ft_1$1;
  function ch32$1(x, y, z) {
    return x & y ^ ~x & z;
  }
  common$4.ch32 = ch32$1;
  function maj32$1(x, y, z) {
    return x & y ^ x & z ^ y & z;
  }
  common$4.maj32 = maj32$1;
  function p32(x, y, z) {
    return x ^ y ^ z;
  }
  common$4.p32 = p32;
  function s0_256$1(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
  }
  common$4.s0_256 = s0_256$1;
  function s1_256$1(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
  }
  common$4.s1_256 = s1_256$1;
  function g0_256$1(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
  }
  common$4.g0_256 = g0_256$1;
  function g1_256$1(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
  }
  common$4.g1_256 = g1_256$1;

  var utils$d = utils$g;
  var common$3 = common$5;
  var shaCommon$1 = common$4;
  var rotl32$1 = utils$d.rotl32;
  var sum32$2 = utils$d.sum32;
  var sum32_5$1 = utils$d.sum32_5;
  var ft_1 = shaCommon$1.ft_1;
  var BlockHash$3 = common$3.BlockHash;
  var sha1_K = [0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xCA62C1D6];
  function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash$3.call(this);
    this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
    this.W = new Array(80);
  }
  utils$d.inherits(SHA1, BlockHash$3);
  var _1 = SHA1;
  SHA1.blockSize = 512;
  SHA1.outSize = 160;
  SHA1.hmacStrength = 80;
  SHA1.padLength = 64;
  SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for (var i = 0; i < 16; i++) W[i] = msg[start + i];
    for (; i < W.length; i++) W[i] = rotl32$1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for (i = 0; i < W.length; i++) {
      var s = ~~(i / 20);
      var t = sum32_5$1(rotl32$1(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
      e = d;
      d = c;
      c = rotl32$1(b, 30);
      b = a;
      a = t;
    }
    this.h[0] = sum32$2(this.h[0], a);
    this.h[1] = sum32$2(this.h[1], b);
    this.h[2] = sum32$2(this.h[2], c);
    this.h[3] = sum32$2(this.h[3], d);
    this.h[4] = sum32$2(this.h[4], e);
  };
  SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils$d.toHex32(this.h, 'big');else return utils$d.split32(this.h, 'big');
  };
  getDefaultExportFromCjs(_1);

  var utils$c = utils$g;
  var common$2 = common$5;
  var shaCommon = common$4;
  var assert$9 = minimalisticAssert;
  var sum32$1 = utils$c.sum32;
  var sum32_4$1 = utils$c.sum32_4;
  var sum32_5 = utils$c.sum32_5;
  var ch32 = shaCommon.ch32;
  var maj32 = shaCommon.maj32;
  var s0_256 = shaCommon.s0_256;
  var s1_256 = shaCommon.s1_256;
  var g0_256 = shaCommon.g0_256;
  var g1_256 = shaCommon.g1_256;
  var BlockHash$2 = common$2.BlockHash;
  var sha256_K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
  function SHA256$1() {
    if (!(this instanceof SHA256$1)) return new SHA256$1();
    BlockHash$2.call(this);
    this.h = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
    this.k = sha256_K;
    this.W = new Array(64);
  }
  utils$c.inherits(SHA256$1, BlockHash$2);
  var _256 = SHA256$1;
  SHA256$1.blockSize = 512;
  SHA256$1.outSize = 256;
  SHA256$1.hmacStrength = 192;
  SHA256$1.padLength = 64;
  SHA256$1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for (var i = 0; i < 16; i++) W[i] = msg[start + i];
    for (; i < W.length; i++) W[i] = sum32_4$1(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert$9(this.k.length === W.length);
    for (i = 0; i < W.length; i++) {
      var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
      var T2 = sum32$1(s0_256(a), maj32(a, b, c));
      h = g;
      g = f;
      f = e;
      e = sum32$1(d, T1);
      d = c;
      c = b;
      b = a;
      a = sum32$1(T1, T2);
    }
    this.h[0] = sum32$1(this.h[0], a);
    this.h[1] = sum32$1(this.h[1], b);
    this.h[2] = sum32$1(this.h[2], c);
    this.h[3] = sum32$1(this.h[3], d);
    this.h[4] = sum32$1(this.h[4], e);
    this.h[5] = sum32$1(this.h[5], f);
    this.h[6] = sum32$1(this.h[6], g);
    this.h[7] = sum32$1(this.h[7], h);
  };
  SHA256$1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils$c.toHex32(this.h, 'big');else return utils$c.split32(this.h, 'big');
  };
  getDefaultExportFromCjs(_256);

  var utils$b = utils$g;
  var SHA256 = _256;
  function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4];
  }
  utils$b.inherits(SHA224, SHA256);
  var _224 = SHA224;
  SHA224.blockSize = 512;
  SHA224.outSize = 224;
  SHA224.hmacStrength = 192;
  SHA224.padLength = 64;
  SHA224.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils$b.toHex32(this.h.slice(0, 7), 'big');else return utils$b.split32(this.h.slice(0, 7), 'big');
  };
  getDefaultExportFromCjs(_224);

  var utils$a = utils$g;
  var common$1 = common$5;
  var assert$8 = minimalisticAssert;
  var rotr64_hi = utils$a.rotr64_hi;
  var rotr64_lo = utils$a.rotr64_lo;
  var shr64_hi = utils$a.shr64_hi;
  var shr64_lo = utils$a.shr64_lo;
  var sum64 = utils$a.sum64;
  var sum64_hi = utils$a.sum64_hi;
  var sum64_lo = utils$a.sum64_lo;
  var sum64_4_hi = utils$a.sum64_4_hi;
  var sum64_4_lo = utils$a.sum64_4_lo;
  var sum64_5_hi = utils$a.sum64_5_hi;
  var sum64_5_lo = utils$a.sum64_5_lo;
  var BlockHash$1 = common$1.BlockHash;
  var sha512_K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];
  function SHA512$1() {
    if (!(this instanceof SHA512$1)) return new SHA512$1();
    BlockHash$1.call(this);
    this.h = [0x6a09e667, 0xf3bcc908, 0xbb67ae85, 0x84caa73b, 0x3c6ef372, 0xfe94f82b, 0xa54ff53a, 0x5f1d36f1, 0x510e527f, 0xade682d1, 0x9b05688c, 0x2b3e6c1f, 0x1f83d9ab, 0xfb41bd6b, 0x5be0cd19, 0x137e2179];
    this.k = sha512_K;
    this.W = new Array(160);
  }
  utils$a.inherits(SHA512$1, BlockHash$1);
  var _512 = SHA512$1;
  SHA512$1.blockSize = 1024;
  SHA512$1.outSize = 512;
  SHA512$1.hmacStrength = 192;
  SHA512$1.padLength = 128;
  SHA512$1.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    for (var i = 0; i < 32; i++) W[i] = msg[start + i];
    for (; i < W.length; i += 2) {
      var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);
      var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
      var c1_hi = W[i - 14];
      var c1_lo = W[i - 13];
      var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);
      var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
      var c3_hi = W[i - 32];
      var c3_lo = W[i - 31];
      W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
      W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
  };
  SHA512$1.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert$8(this.k.length === W.length);
    for (var i = 0; i < W.length; i += 2) {
      var c0_hi = hh;
      var c0_lo = hl;
      var c1_hi = s1_512_hi(eh, el);
      var c1_lo = s1_512_lo(eh, el);
      var c2_hi = ch64_hi(eh, el, fh, fl, gh);
      var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
      var c3_hi = this.k[i];
      var c3_lo = this.k[i + 1];
      var c4_hi = W[i];
      var c4_lo = W[i + 1];
      var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
      var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
      c0_hi = s0_512_hi(ah, al);
      c0_lo = s0_512_lo(ah, al);
      c1_hi = maj64_hi(ah, al, bh, bl, ch);
      c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
      var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
      var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
      hh = gh;
      hl = gl;
      gh = fh;
      gl = fl;
      fh = eh;
      fl = el;
      eh = sum64_hi(dh, dl, T1_hi, T1_lo);
      el = sum64_lo(dl, dl, T1_hi, T1_lo);
      dh = ch;
      dl = cl;
      ch = bh;
      cl = bl;
      bh = ah;
      bl = al;
      ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
      al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
  };
  SHA512$1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils$a.toHex32(this.h, 'big');else return utils$a.split32(this.h, 'big');
  };
  function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2);
    var c2_hi = rotr64_hi(xl, xh, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2);
    var c2_lo = rotr64_lo(xl, xh, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29);
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
  }
  function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29);
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
  }
  getDefaultExportFromCjs(_512);

  var utils$9 = utils$g;
  var SHA512 = _512;
  function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [0xcbbb9d5d, 0xc1059ed8, 0x629a292a, 0x367cd507, 0x9159015a, 0x3070dd17, 0x152fecd8, 0xf70e5939, 0x67332667, 0xffc00b31, 0x8eb44a87, 0x68581511, 0xdb0c2e0d, 0x64f98fa7, 0x47b5481d, 0xbefa4fa4];
  }
  utils$9.inherits(SHA384, SHA512);
  var _384 = SHA384;
  SHA384.blockSize = 1024;
  SHA384.outSize = 384;
  SHA384.hmacStrength = 192;
  SHA384.padLength = 128;
  SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils$9.toHex32(this.h.slice(0, 12), 'big');else return utils$9.split32(this.h.slice(0, 12), 'big');
  };
  getDefaultExportFromCjs(_384);

  sha.sha1 = _1;
  sha.sha224 = _224;
  sha.sha256 = _256;
  sha.sha384 = _384;
  sha.sha512 = _512;

  var ripemd = {};

  var utils$8 = utils$g;
  var common = common$5;
  var rotl32 = utils$8.rotl32;
  var sum32 = utils$8.sum32;
  var sum32_3 = utils$8.sum32_3;
  var sum32_4 = utils$8.sum32_4;
  var BlockHash = common.BlockHash;
  function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
    this.endian = 'little';
  }
  utils$8.inherits(RIPEMD160, BlockHash);
  ripemd.ripemd160 = RIPEMD160;
  RIPEMD160.blockSize = 512;
  RIPEMD160.outSize = 160;
  RIPEMD160.hmacStrength = 192;
  RIPEMD160.padLength = 64;
  RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for (var j = 0; j < 80; j++) {
      var T = sum32(rotl32(sum32_4(A, f$1(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
      A = E;
      E = D;
      D = rotl32(C, 10);
      C = B;
      B = T;
      T = sum32(rotl32(sum32_4(Ah, f$1(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
      Ah = Eh;
      Eh = Dh;
      Dh = rotl32(Ch, 10);
      Ch = Bh;
      Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
  };
  RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils$8.toHex32(this.h, 'little');else return utils$8.split32(this.h, 'little');
  };
  function f$1(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;else if (j <= 31) return x & y | ~x & z;else if (j <= 47) return (x | ~y) ^ z;else if (j <= 63) return x & z | y & ~z;else return x ^ (y | ~z);
  }
  function K(j) {
    if (j <= 15) return 0x00000000;else if (j <= 31) return 0x5a827999;else if (j <= 47) return 0x6ed9eba1;else if (j <= 63) return 0x8f1bbcdc;else return 0xa953fd4e;
  }
  function Kh(j) {
    if (j <= 15) return 0x50a28be6;else if (j <= 31) return 0x5c4dd124;else if (j <= 47) return 0x6d703ef3;else if (j <= 63) return 0x7a6d76e9;else return 0x00000000;
  }
  var r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];
  var rh = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];
  var s = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];
  var sh = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];

  var utils$7 = utils$g;
  var assert$7 = minimalisticAssert;
  function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils$7.toArray(key, enc));
  }
  var hmac = Hmac;
  Hmac.prototype._init = function init(key) {
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert$7(key.length <= this.blockSize);
    for (var i = key.length; i < this.blockSize; i++) key.push(0);
    for (i = 0; i < key.length; i++) key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    for (i = 0; i < key.length; i++) key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
  };
  Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
  };
  Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
  };
  getDefaultExportFromCjs(hmac);

  (function (exports) {
    var hash = exports;
    hash.utils = utils$g;
    hash.common = common$5;
    hash.sha = sha;
    hash.ripemd = ripemd;
    hash.hmac = hmac;
    hash.sha1 = hash.sha.sha1;
    hash.sha256 = hash.sha.sha256;
    hash.sha224 = hash.sha.sha224;
    hash.sha384 = hash.sha.sha384;
    hash.sha512 = hash.sha.sha512;
    hash.ripemd160 = hash.ripemd.ripemd160;
  })(hash$3);
  getDefaultExportFromCjs(hash$3);

  var secp256k1$1;
  var hasRequiredSecp256k1;
  function requireSecp256k1() {
    if (hasRequiredSecp256k1) return secp256k1$1;
    hasRequiredSecp256k1 = 1;
    secp256k1$1 = {
      doubles: {
        step: 4,
        points: [['e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a', 'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'], ['8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508', '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'], ['175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739', 'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'], ['363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640', '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'], ['8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c', '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'], ['723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda', '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'], ['eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa', '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'], ['100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0', 'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'], ['e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d', '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'], ['feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d', 'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'], ['da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1', '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'], ['53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0', '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'], ['8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047', '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'], ['385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862', '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'], ['6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7', '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'], ['3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd', '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'], ['85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83', '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'], ['948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a', '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'], ['6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8', 'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'], ['e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d', '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'], ['e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725', '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'], ['213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754', '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'], ['4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c', '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'], ['fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6', '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'], ['76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39', 'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'], ['c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891', '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'], ['d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b', 'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'], ['b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03', '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'], ['e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d', 'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'], ['a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070', '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'], ['90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4', 'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'], ['8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da', '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'], ['e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11', '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'], ['8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e', 'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'], ['e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41', '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'], ['b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef', '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'], ['d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8', 'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'], ['324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d', '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'], ['4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96', '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'], ['9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd', 'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'], ['6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5', '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'], ['a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266', '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'], ['7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71', '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'], ['928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac', 'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'], ['85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751', '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'], ['ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e', '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'], ['827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241', 'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'], ['eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3', 'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'], ['e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f', '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'], ['1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19', 'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'], ['146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be', 'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'], ['fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9', '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'], ['da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2', '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'], ['a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13', '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'], ['174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c', 'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'], ['959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba', '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'], ['d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151', 'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'], ['64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073', 'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'], ['8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458', '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'], ['13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b', '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'], ['bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366', 'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'], ['8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa', '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'], ['8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0', '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'], ['dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787', '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'], ['f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e', 'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82']]
      },
      naf: {
        wnd: 7,
        points: [['f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9', '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'], ['2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4', 'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'], ['5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc', '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'], ['acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe', 'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'], ['774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb', 'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'], ['f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8', 'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'], ['d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e', '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'], ['defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34', '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'], ['2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c', '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'], ['352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5', '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'], ['2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f', '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'], ['9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714', '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'], ['daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729', 'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'], ['c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db', '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'], ['6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4', 'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'], ['1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5', 'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'], ['605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479', '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'], ['62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d', '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'], ['80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f', '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'], ['7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb', 'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'], ['d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9', 'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'], ['49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963', '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'], ['77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74', '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'], ['f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530', 'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'], ['463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b', '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'], ['f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247', 'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'], ['caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1', 'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'], ['2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120', '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'], ['7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435', '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'], ['754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18', '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'], ['e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8', '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'], ['186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb', '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'], ['df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f', '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'], ['5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143', 'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'], ['290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba', 'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'], ['af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45', 'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'], ['766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a', '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'], ['59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e', 'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'], ['f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8', 'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'], ['7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c', '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'], ['948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519', 'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'], ['7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab', '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'], ['3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca', 'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'], ['d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf', '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'], ['1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610', '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'], ['733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4', 'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'], ['15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c', 'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'], ['a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940', 'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'], ['e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980', 'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'], ['311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3', '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'], ['34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf', '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'], ['f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63', '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'], ['d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448', 'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'], ['32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf', '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'], ['7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5', '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'], ['ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6', '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'], ['16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5', '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'], ['eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99', 'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'], ['78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51', 'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'], ['494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5', '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'], ['a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5', '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'], ['c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997', '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'], ['841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881', '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'], ['5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5', '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'], ['36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66', 'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'], ['336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726', 'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'], ['8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede', '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'], ['1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94', '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'], ['85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31', '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'], ['29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51', 'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'], ['a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252', 'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'], ['4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5', 'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'], ['d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b', '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'], ['ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4', '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'], ['af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f', '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'], ['e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889', '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'], ['591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246', 'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'], ['11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984', '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'], ['3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a', 'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'], ['cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030', 'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'], ['c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197', '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'], ['c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593', 'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'], ['a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef', '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'], ['347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38', '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'], ['da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a', '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'], ['c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111', '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'], ['4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502', '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'], ['3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea', 'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'], ['cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26', '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'], ['b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986', '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'], ['d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e', '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'], ['48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4', '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'], ['dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda', 'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'], ['6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859', 'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'], ['e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f', 'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'], ['eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c', '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'], ['13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942', 'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'], ['ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a', '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'], ['b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80', '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'], ['ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d', '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'], ['8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1', 'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'], ['52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63', 'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'], ['e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352', '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'], ['7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193', 'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'], ['5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00', '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'], ['32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58', 'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'], ['e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7', 'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'], ['8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8', 'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'], ['4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e', '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'], ['3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d', 'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'], ['674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b', '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'], ['d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f', 'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'], ['30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6', '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'], ['be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297', '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'], ['93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a', '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'], ['b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c', 'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'], ['d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52', '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'], ['d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb', 'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'], ['463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065', 'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'], ['7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917', '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'], ['74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9', 'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'], ['30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3', '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'], ['9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57', '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'], ['176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66', 'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'], ['75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8', '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'], ['809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721', '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'], ['1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180', '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9']]
      }
    };
    return secp256k1$1;
  }

  (function (exports) {
    var curves = exports;
    var hash = hash$3;
    var curve$1 = curve;
    var utils = utils$m;
    var assert = utils.assert;
    function PresetCurve(options) {
      if (options.type === 'short') this.curve = new curve$1.short(options);else if (options.type === 'edwards') this.curve = new curve$1.edwards(options);else this.curve = new curve$1.mont(options);
      this.g = this.curve.g;
      this.n = this.curve.n;
      this.hash = options.hash;
      assert(this.g.validate(), 'Invalid curve');
      assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function () {
          var curve = new PresetCurve(options);
          Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            value: curve
          });
          return curve;
        }
      });
    }
    defineCurve('p192', {
      type: 'short',
      prime: 'p192',
      p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
      a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
      b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
      n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
      hash: hash.sha256,
      gRed: false,
      g: ['188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012', '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811']
    });
    defineCurve('p224', {
      type: 'short',
      prime: 'p224',
      p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
      a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
      b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
      n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
      hash: hash.sha256,
      gRed: false,
      g: ['b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21', 'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34']
    });
    defineCurve('p256', {
      type: 'short',
      prime: null,
      p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
      a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
      b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
      n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
      hash: hash.sha256,
      gRed: false,
      g: ['6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296', '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5']
    });
    defineCurve('p384', {
      type: 'short',
      prime: null,
      p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'fffffffe ffffffff 00000000 00000000 ffffffff',
      a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'fffffffe ffffffff 00000000 00000000 fffffffc',
      b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' + '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
      n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' + 'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
      hash: hash.sha384,
      gRed: false,
      g: ['aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' + '5502f25d bf55296c 3a545e38 72760ab7', '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' + '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f']
    });
    defineCurve('p521', {
      type: 'short',
      prime: null,
      p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff',
      a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff fffffffc',
      b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' + '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' + '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
      n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' + 'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
      hash: hash.sha512,
      gRed: false,
      g: ['000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' + '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' + 'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66', '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' + '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' + '3fad0761 353c7086 a272c240 88be9476 9fd16650']
    });
    defineCurve('curve25519', {
      type: 'mont',
      prime: 'p25519',
      p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
      a: '76d06',
      b: '1',
      n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
      hash: hash.sha256,
      gRed: false,
      g: ['9']
    });
    defineCurve('ed25519', {
      type: 'edwards',
      prime: 'p25519',
      p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
      a: '-1',
      c: '1',
      d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
      n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
      hash: hash.sha256,
      gRed: false,
      g: ['216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
      '6666666666666666666666666666666666666666666666666666666666666658']
    });
    var pre;
    try {
      pre = requireSecp256k1();
    } catch (e) {
      pre = undefined;
    }
    defineCurve('secp256k1', {
      type: 'short',
      prime: 'k256',
      p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
      a: '0',
      b: '7',
      n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
      h: '1',
      hash: hash.sha256,
      beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
      lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
      basis: [{
        a: '3086d221a7d46bcde86c90e49284eb15',
        b: '-e4437ed6010e88286f547fa90abfe4c3'
      }, {
        a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
        b: '3086d221a7d46bcde86c90e49284eb15'
      }],
      gRed: false,
      g: ['79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798', '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8', pre]
    });
  })(curves$2);
  getDefaultExportFromCjs(curves$2);

  var hash$2 = hash$3;
  var utils$6 = utils$l;
  var assert$6 = minimalisticAssert;
  function HmacDRBG$1(options) {
    if (!(this instanceof HmacDRBG$1)) return new HmacDRBG$1(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils$6.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = utils$6.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = utils$6.toArray(options.pers, options.persEnc || 'hex');
    assert$6(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
  }
  var hmacDrbg = HmacDRBG$1;
  HmacDRBG$1.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for (var i = 0; i < this.V.length; i++) {
      this.K[i] = 0x00;
      this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000;
  };
  HmacDRBG$1.prototype._hmac = function hmac() {
    return new hash$2.hmac(this.hash, this.K);
  };
  HmacDRBG$1.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([0x00]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([0x01]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
  };
  HmacDRBG$1.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    if (typeof entropyEnc !== 'string') {
      addEnc = add;
      add = entropyEnc;
      entropyEnc = null;
    }
    entropy = utils$6.toArray(entropy, entropyEnc);
    add = utils$6.toArray(add, addEnc);
    assert$6(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
  };
  HmacDRBG$1.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    if (typeof enc !== 'string') {
      addEnc = add;
      add = enc;
      enc = null;
    }
    if (add) {
      add = utils$6.toArray(add, addEnc || 'hex');
      this._update(add);
    }
    var temp = [];
    while (temp.length < len) {
      this.V = this._hmac().update(this.V).digest();
      temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils$6.encode(res, enc);
  };
  getDefaultExportFromCjs(hmacDrbg);

  var BN$3 = bnExports;
  var utils$5 = utils$m;
  var assert$5 = utils$5.assert;
  function KeyPair$3(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
  }
  var key$1 = KeyPair$3;
  KeyPair$3.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair$3) return pub;
    return new KeyPair$3(ec, {
      pub: pub,
      pubEnc: enc
    });
  };
  KeyPair$3.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair$3) return priv;
    return new KeyPair$3(ec, {
      priv: priv,
      privEnc: enc
    });
  };
  KeyPair$3.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
      result: false,
      reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
      result: false,
      reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
      result: false,
      reason: 'Public key * N != O'
    };
    return {
      result: true,
      reason: null
    };
  };
  KeyPair$3.prototype.getPublic = function getPublic(compact, enc) {
    if (typeof compact === 'string') {
      enc = compact;
      compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
  };
  KeyPair$3.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);else return this.priv;
  };
  KeyPair$3.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN$3(key, enc || 16);
    this.priv = this.priv.umod(this.ec.curve.n);
  };
  KeyPair$3.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
      if (this.ec.curve.type === 'mont') {
        assert$5(key.x, 'Need x coordinate');
      } else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') {
        assert$5(key.x && key.y, 'Need both x and y coordinate');
      }
      this.pub = this.ec.curve.point(key.x, key.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
  };
  KeyPair$3.prototype.derive = function derive(pub) {
    if (!pub.validate()) {
      assert$5(pub.validate(), 'public point not validated');
    }
    return pub.mul(this.priv).getX();
  };
  KeyPair$3.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
  };
  KeyPair$3.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
  };
  KeyPair$3.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
  };
  getDefaultExportFromCjs(key$1);

  var BN$2 = bnExports;
  var utils$4 = utils$m;
  var assert$4 = utils$4.assert;
  function Signature$3(options, enc) {
    if (options instanceof Signature$3) return options;
    if (this._importDER(options, enc)) return;
    assert$4(options.r && options.s, 'Signature without r or s');
    this.r = new BN$2(options.r, 16);
    this.s = new BN$2(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;else this.recoveryParam = options.recoveryParam;
  }
  var signature$1 = Signature$3;
  function Position() {
    this.place = 0;
  }
  function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) {
      return initial;
    }
    var octetLen = initial & 0xf;
    if (octetLen === 0 || octetLen > 4) {
      return false;
    }
    var val = 0;
    for (var i = 0, off = p.place; i < octetLen; i++, off++) {
      val <<= 8;
      val |= buf[off];
      val >>>= 0;
    }
    if (val <= 0x7f) {
      return false;
    }
    p.place = off;
    return val;
  }
  function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
      i++;
    }
    if (i === 0) {
      return buf;
    }
    return buf.slice(i);
  }
  Signature$3.prototype._importDER = function _importDER(data, enc) {
    data = utils$4.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) {
      return false;
    }
    var len = getLength(data, p);
    if (len === false) {
      return false;
    }
    if (len + p.place !== data.length) {
      return false;
    }
    if (data[p.place++] !== 0x02) {
      return false;
    }
    var rlen = getLength(data, p);
    if (rlen === false) {
      return false;
    }
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) {
      return false;
    }
    var slen = getLength(data, p);
    if (slen === false) {
      return false;
    }
    if (data.length !== slen + p.place) {
      return false;
    }
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
      if (r[1] & 0x80) {
        r = r.slice(1);
      } else {
        return false;
      }
    }
    if (s[0] === 0) {
      if (s[1] & 0x80) {
        s = s.slice(1);
      } else {
        return false;
      }
    }
    this.r = new BN$2(r);
    this.s = new BN$2(s);
    this.recoveryParam = null;
    return true;
  };
  function constructLength(arr, len) {
    if (len < 0x80) {
      arr.push(len);
      return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while (--octets) {
      arr.push(len >>> (octets << 3) & 0xff);
    }
    arr.push(len);
  }
  Signature$3.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    if (r[0] & 0x80) r = [0].concat(r);
    if (s[0] & 0x80) s = [0].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while (!s[0] && !(s[1] & 0x80)) {
      s = s.slice(1);
    }
    var arr = [0x02];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [0x30];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils$4.encode(res, enc);
  };
  getDefaultExportFromCjs(signature$1);

  var BN$1 = bnExports;
  var HmacDRBG = hmacDrbg;
  var utils$3 = utils$m;
  var curves$1 = curves$2;
  var rand = brorandExports;
  var assert$3 = utils$3.assert;
  var KeyPair$2 = key$1;
  var Signature$2 = signature$1;
  function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    if (typeof options === 'string') {
      assert$3(Object.prototype.hasOwnProperty.call(curves$1, options), 'Unknown curve ' + options);
      options = curves$1[options];
    }
    if (options instanceof curves$1.PresetCurve) options = {
      curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    this.hash = options.hash || options.curve.hash;
  }
  var ec = EC;
  EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair$2(this, options);
  };
  EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair$2.fromPrivate(this, priv, enc);
  };
  EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair$2.fromPublic(this, pub, enc);
  };
  EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    var drbg = new HmacDRBG({
      hash: this.hash,
      pers: options.pers,
      persEnc: options.persEnc || 'utf8',
      entropy: options.entropy || rand(this.hash.hmacStrength),
      entropyEnc: options.entropy && options.entropyEnc || 'utf8',
      nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN$1(2));
    for (;;) {
      var priv = new BN$1(drbg.generate(bytes));
      if (priv.cmp(ns2) > 0) continue;
      priv.iaddn(1);
      return this.keyFromPrivate(priv);
    }
  };
  EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);else return msg;
  };
  EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
      options = enc;
      enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN$1(msg, 16));
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    var nonce = msg.toArray('be', bytes);
    var drbg = new HmacDRBG({
      hash: this.hash,
      entropy: bkey,
      nonce: nonce,
      pers: options.pers,
      persEnc: options.persEnc || 'utf8'
    });
    var ns1 = this.n.sub(new BN$1(1));
    for (var iter = 0;; iter++) {
      var k = options.k ? options.k(iter) : new BN$1(drbg.generate(this.n.byteLength()));
      k = this._truncateToN(k, true);
      if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
      var kp = this.g.mul(k);
      if (kp.isInfinity()) continue;
      var kpX = kp.getX();
      var r = kpX.umod(this.n);
      if (r.cmpn(0) === 0) continue;
      var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
      s = s.umod(this.n);
      if (s.cmpn(0) === 0) continue;
      var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
      if (options.canonical && s.cmp(this.nh) > 0) {
        s = this.n.sub(s);
        recoveryParam ^= 1;
      }
      return new Signature$2({
        r: r,
        s: s,
        recoveryParam: recoveryParam
      });
    }
  };
  EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN$1(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature$2(signature, 'hex');
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
      p = this.g.mulAdd(u1, key.getPublic(), u2);
      if (p.isInfinity()) return false;
      return p.getX().umod(this.n).cmp(r) === 0;
    }
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    return p.eqXToP(r);
  };
  EC.prototype.recoverPubKey = function (msg, signature, j, enc) {
    assert$3((3 & j) === j, 'The recovery param is more than two bits');
    signature = new Signature$2(signature, enc);
    var n = this.n;
    var e = new BN$1(msg);
    var r = signature.r;
    var s = signature.s;
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    return this.g.mulAdd(s1, r, s2);
  };
  EC.prototype.getKeyRecoveryParam = function (e, signature, Q, enc) {
    signature = new Signature$2(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for (var i = 0; i < 4; i++) {
      var Qprime;
      try {
        Qprime = this.recoverPubKey(e, signature, i);
      } catch (e) {
        continue;
      }
      if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
  };
  getDefaultExportFromCjs(ec);

  var utils$2 = utils$m;
  var assert$2 = utils$2.assert;
  var parseBytes$2 = utils$2.parseBytes;
  var cachedProperty$1 = utils$2.cachedProperty;
  function KeyPair$1(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes$2(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;else this._pubBytes = parseBytes$2(params.pub);
  }
  KeyPair$1.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair$1) return pub;
    return new KeyPair$1(eddsa, {
      pub: pub
    });
  };
  KeyPair$1.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair$1) return secret;
    return new KeyPair$1(eddsa, {
      secret: secret
    });
  };
  KeyPair$1.prototype.secret = function secret() {
    return this._secret;
  };
  cachedProperty$1(KeyPair$1, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
  });
  cachedProperty$1(KeyPair$1, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
  });
  cachedProperty$1(KeyPair$1, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
  });
  cachedProperty$1(KeyPair$1, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
  });
  cachedProperty$1(KeyPair$1, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
  });
  cachedProperty$1(KeyPair$1, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
  });
  KeyPair$1.prototype.sign = function sign(message) {
    assert$2(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
  };
  KeyPair$1.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
  };
  KeyPair$1.prototype.getSecret = function getSecret(enc) {
    assert$2(this._secret, 'KeyPair is public only');
    return utils$2.encode(this.secret(), enc);
  };
  KeyPair$1.prototype.getPublic = function getPublic(enc) {
    return utils$2.encode(this.pubBytes(), enc);
  };
  var key = KeyPair$1;
  getDefaultExportFromCjs(key);

  var BN = bnExports;
  var utils$1 = utils$m;
  var assert$1 = utils$1.assert;
  var cachedProperty = utils$1.cachedProperty;
  var parseBytes$1 = utils$1.parseBytes;
  function Signature$1(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = parseBytes$1(sig);
    if (Array.isArray(sig)) {
      sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
      };
    }
    assert$1(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
  }
  cachedProperty(Signature$1, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
  });
  cachedProperty(Signature$1, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
  });
  cachedProperty(Signature$1, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
  });
  cachedProperty(Signature$1, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
  });
  Signature$1.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
  };
  Signature$1.prototype.toHex = function toHex() {
    return utils$1.encode(this.toBytes(), 'hex').toUpperCase();
  };
  var signature = Signature$1;
  getDefaultExportFromCjs(signature);

  var hash$1 = hash$3;
  var curves = curves$2;
  var utils = utils$m;
  var assert = utils.assert;
  var parseBytes = utils.parseBytes;
  var KeyPair = key;
  var Signature = signature;
  function EDDSA(curve) {
    assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash$1.sha512;
  }
  var eddsa = EDDSA;
  EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
      R: R,
      S: S,
      Rencoded: Rencoded
    });
  };
  EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
  };
  EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for (var i = 0; i < arguments.length; i++) hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
  };
  EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
  };
  EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
  };
  EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
  };
  EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
  };
  EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
  };
  EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
  };
  EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
  };
  EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
  };
  getDefaultExportFromCjs(eddsa);

  (function (exports) {
    var elliptic = exports;
    elliptic.version = require$$0$2.version;
    elliptic.utils = utils$m;
    elliptic.rand = brorandExports;
    elliptic.curve = curve;
    elliptic.curves = curves$2;
    elliptic.ec = ec;
    elliptic.eddsa = eddsa;
  })(elliptic$1);
  getDefaultExportFromCjs(elliptic$1);

  const encode = tree => {
    const padEven = str => str.length % 2 === 0 ? str : "0" + str;
    const uint = num => padEven(num.toString(16));
    const length = (len, add) => len < 56 ? uint(add + len) : uint(add + uint(len).length / 2 + 55) + uint(len);
    const dataTree = tree => {
      if (typeof tree === "string") {
        const hex = tree.slice(2);
        const pre = hex.length != 2 || hex >= "80" ? length(hex.length / 2, 128) : "";
        return pre + hex;
      } else {
        const hex = tree.map(dataTree).join("");
        const pre = length(hex.length / 2, 192);
        return pre + hex;
      }
    };
    return "0x" + dataTree(tree);
  };
  const decode = hex => {
    let i = 2;
    const parseTree = () => {
      if (i >= hex.length) throw "";
      const head = hex.slice(i, i + 2);
      return head < "80" ? (i += 2, "0x" + head) : head < "c0" ? parseHex() : parseList();
    };
    const parseLength = () => {
      const len = parseInt(hex.slice(i, i += 2), 16) % 64;
      return len < 56 ? len : parseInt(hex.slice(i, i += (len - 55) * 2), 16);
    };
    const parseHex = () => {
      const len = parseLength();
      return "0x" + hex.slice(i, i += len * 2);
    };
    const parseList = () => {
      const lim = parseLength() * 2 + i;
      let list = [];
      while (i < lim) list.push(parseTree());
      return list;
    };
    try {
      return parseTree();
    } catch (e) {
      return [];
    }
  };
  var rlp = {
    encode,
    decode
  };
  getDefaultExportFromCjs(rlp);

  const HEX_CHARS = '0123456789abcdef'.split('');
  const KECCAK_PADDING = [1, 256, 65536, 16777216];
  const SHIFT = [0, 8, 16, 24];
  const RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
  const Keccak = bits => ({
    blocks: [],
    reset: true,
    block: 0,
    start: 0,
    blockCount: 1600 - (bits << 1) >> 5,
    outputBlocks: bits >> 5,
    s: (s => [].concat(s, s, s, s, s))([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
  });
  const update = (state, message) => {
    var length = message.length,
      blocks = state.blocks,
      byteCount = state.blockCount << 2,
      blockCount = state.blockCount,
      outputBlocks = state.outputBlocks,
      s = state.s,
      index = 0,
      i,
      code;
    while (index < length) {
      if (state.reset) {
        state.reset = false;
        blocks[0] = state.block;
        for (i = 1; i < blockCount + 1; ++i) {
          blocks[i] = 0;
        }
      }
      if (typeof message !== "string") {
        for (i = state.start; index < length && i < byteCount; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = state.start; index < length && i < byteCount; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
            blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
          }
        }
      }
      state.lastByteIndex = i;
      if (i >= byteCount) {
        state.start = i - byteCount;
        state.block = blocks[blockCount];
        for (i = 0; i < blockCount; ++i) {
          s[i] ^= blocks[i];
        }
        f(s);
        state.reset = true;
      } else {
        state.start = i;
      }
    }
    i = state.lastByteIndex;
    blocks[i >> 2] |= KECCAK_PADDING[i & 3];
    if (state.lastByteIndex === byteCount) {
      blocks[0] = blocks[blockCount];
      for (i = 1; i < blockCount + 1; ++i) {
        blocks[i] = 0;
      }
    }
    blocks[blockCount - 1] |= 0x80000000;
    for (i = 0; i < blockCount; ++i) {
      s[i] ^= blocks[i];
    }
    f(s);
    var hex = '',
      i = 0,
      j = 0,
      block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        block = s[i];
        hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
      }
      if (j % blockCount === 0) {
        f(s);
        i = 0;
      }
    }
    return "0x" + hex;
  };
  const f = s => {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for (n = 0; n < 48; n += 2) {
      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
      h = c8 ^ (c2 << 1 | c3 >>> 31);
      l = c9 ^ (c3 << 1 | c2 >>> 31);
      s[0] ^= h;
      s[1] ^= l;
      s[10] ^= h;
      s[11] ^= l;
      s[20] ^= h;
      s[21] ^= l;
      s[30] ^= h;
      s[31] ^= l;
      s[40] ^= h;
      s[41] ^= l;
      h = c0 ^ (c4 << 1 | c5 >>> 31);
      l = c1 ^ (c5 << 1 | c4 >>> 31);
      s[2] ^= h;
      s[3] ^= l;
      s[12] ^= h;
      s[13] ^= l;
      s[22] ^= h;
      s[23] ^= l;
      s[32] ^= h;
      s[33] ^= l;
      s[42] ^= h;
      s[43] ^= l;
      h = c2 ^ (c6 << 1 | c7 >>> 31);
      l = c3 ^ (c7 << 1 | c6 >>> 31);
      s[4] ^= h;
      s[5] ^= l;
      s[14] ^= h;
      s[15] ^= l;
      s[24] ^= h;
      s[25] ^= l;
      s[34] ^= h;
      s[35] ^= l;
      s[44] ^= h;
      s[45] ^= l;
      h = c4 ^ (c8 << 1 | c9 >>> 31);
      l = c5 ^ (c9 << 1 | c8 >>> 31);
      s[6] ^= h;
      s[7] ^= l;
      s[16] ^= h;
      s[17] ^= l;
      s[26] ^= h;
      s[27] ^= l;
      s[36] ^= h;
      s[37] ^= l;
      s[46] ^= h;
      s[47] ^= l;
      h = c6 ^ (c0 << 1 | c1 >>> 31);
      l = c7 ^ (c1 << 1 | c0 >>> 31);
      s[8] ^= h;
      s[9] ^= l;
      s[18] ^= h;
      s[19] ^= l;
      s[28] ^= h;
      s[29] ^= l;
      s[38] ^= h;
      s[39] ^= l;
      s[48] ^= h;
      s[49] ^= l;
      b0 = s[0];
      b1 = s[1];
      b32 = s[11] << 4 | s[10] >>> 28;
      b33 = s[10] << 4 | s[11] >>> 28;
      b14 = s[20] << 3 | s[21] >>> 29;
      b15 = s[21] << 3 | s[20] >>> 29;
      b46 = s[31] << 9 | s[30] >>> 23;
      b47 = s[30] << 9 | s[31] >>> 23;
      b28 = s[40] << 18 | s[41] >>> 14;
      b29 = s[41] << 18 | s[40] >>> 14;
      b20 = s[2] << 1 | s[3] >>> 31;
      b21 = s[3] << 1 | s[2] >>> 31;
      b2 = s[13] << 12 | s[12] >>> 20;
      b3 = s[12] << 12 | s[13] >>> 20;
      b34 = s[22] << 10 | s[23] >>> 22;
      b35 = s[23] << 10 | s[22] >>> 22;
      b16 = s[33] << 13 | s[32] >>> 19;
      b17 = s[32] << 13 | s[33] >>> 19;
      b48 = s[42] << 2 | s[43] >>> 30;
      b49 = s[43] << 2 | s[42] >>> 30;
      b40 = s[5] << 30 | s[4] >>> 2;
      b41 = s[4] << 30 | s[5] >>> 2;
      b22 = s[14] << 6 | s[15] >>> 26;
      b23 = s[15] << 6 | s[14] >>> 26;
      b4 = s[25] << 11 | s[24] >>> 21;
      b5 = s[24] << 11 | s[25] >>> 21;
      b36 = s[34] << 15 | s[35] >>> 17;
      b37 = s[35] << 15 | s[34] >>> 17;
      b18 = s[45] << 29 | s[44] >>> 3;
      b19 = s[44] << 29 | s[45] >>> 3;
      b10 = s[6] << 28 | s[7] >>> 4;
      b11 = s[7] << 28 | s[6] >>> 4;
      b42 = s[17] << 23 | s[16] >>> 9;
      b43 = s[16] << 23 | s[17] >>> 9;
      b24 = s[26] << 25 | s[27] >>> 7;
      b25 = s[27] << 25 | s[26] >>> 7;
      b6 = s[36] << 21 | s[37] >>> 11;
      b7 = s[37] << 21 | s[36] >>> 11;
      b38 = s[47] << 24 | s[46] >>> 8;
      b39 = s[46] << 24 | s[47] >>> 8;
      b30 = s[8] << 27 | s[9] >>> 5;
      b31 = s[9] << 27 | s[8] >>> 5;
      b12 = s[18] << 20 | s[19] >>> 12;
      b13 = s[19] << 20 | s[18] >>> 12;
      b44 = s[29] << 7 | s[28] >>> 25;
      b45 = s[28] << 7 | s[29] >>> 25;
      b26 = s[38] << 8 | s[39] >>> 24;
      b27 = s[39] << 8 | s[38] >>> 24;
      b8 = s[48] << 14 | s[49] >>> 18;
      b9 = s[49] << 14 | s[48] >>> 18;
      s[0] = b0 ^ ~b2 & b4;
      s[1] = b1 ^ ~b3 & b5;
      s[10] = b10 ^ ~b12 & b14;
      s[11] = b11 ^ ~b13 & b15;
      s[20] = b20 ^ ~b22 & b24;
      s[21] = b21 ^ ~b23 & b25;
      s[30] = b30 ^ ~b32 & b34;
      s[31] = b31 ^ ~b33 & b35;
      s[40] = b40 ^ ~b42 & b44;
      s[41] = b41 ^ ~b43 & b45;
      s[2] = b2 ^ ~b4 & b6;
      s[3] = b3 ^ ~b5 & b7;
      s[12] = b12 ^ ~b14 & b16;
      s[13] = b13 ^ ~b15 & b17;
      s[22] = b22 ^ ~b24 & b26;
      s[23] = b23 ^ ~b25 & b27;
      s[32] = b32 ^ ~b34 & b36;
      s[33] = b33 ^ ~b35 & b37;
      s[42] = b42 ^ ~b44 & b46;
      s[43] = b43 ^ ~b45 & b47;
      s[4] = b4 ^ ~b6 & b8;
      s[5] = b5 ^ ~b7 & b9;
      s[14] = b14 ^ ~b16 & b18;
      s[15] = b15 ^ ~b17 & b19;
      s[24] = b24 ^ ~b26 & b28;
      s[25] = b25 ^ ~b27 & b29;
      s[34] = b34 ^ ~b36 & b38;
      s[35] = b35 ^ ~b37 & b39;
      s[44] = b44 ^ ~b46 & b48;
      s[45] = b45 ^ ~b47 & b49;
      s[6] = b6 ^ ~b8 & b0;
      s[7] = b7 ^ ~b9 & b1;
      s[16] = b16 ^ ~b18 & b10;
      s[17] = b17 ^ ~b19 & b11;
      s[26] = b26 ^ ~b28 & b20;
      s[27] = b27 ^ ~b29 & b21;
      s[36] = b36 ^ ~b38 & b30;
      s[37] = b37 ^ ~b39 & b31;
      s[46] = b46 ^ ~b48 & b40;
      s[47] = b47 ^ ~b49 & b41;
      s[8] = b8 ^ ~b0 & b2;
      s[9] = b9 ^ ~b1 & b3;
      s[18] = b18 ^ ~b10 & b12;
      s[19] = b19 ^ ~b11 & b13;
      s[28] = b28 ^ ~b20 & b22;
      s[29] = b29 ^ ~b21 & b23;
      s[38] = b38 ^ ~b30 & b32;
      s[39] = b39 ^ ~b31 & b33;
      s[48] = b48 ^ ~b40 & b42;
      s[49] = b49 ^ ~b41 & b43;
      s[0] ^= RC[n];
      s[1] ^= RC[n + 1];
    }
  };
  const keccak = bits => str => {
    var msg;
    if (str.slice(0, 2) === "0x") {
      msg = [];
      for (var i = 2, l = str.length; i < l; i += 2) msg.push(parseInt(str.slice(i, i + 2), 16));
    } else {
      msg = str;
    }
    return update(Keccak(bits), msg);
  };
  var hash = {
    keccak256: keccak(256),
    keccak512: keccak(512),
    keccak256s: keccak(256),
    keccak512s: keccak(512)
  };
  getDefaultExportFromCjs(hash);

  const Bytes = bytes;
  const Nat = nat;
  const elliptic = elliptic$1;
  const secp256k1 = new elliptic.ec("secp256k1");
  const {
    keccak256,
    keccak256s
  } = hash;
  const create = entropy => {
    const innerHex = keccak256(Bytes.concat(Bytes.random(32), entropy || Bytes.random(32)));
    const middleHex = Bytes.concat(Bytes.concat(Bytes.random(32), innerHex), Bytes.random(32));
    const outerHex = keccak256(middleHex);
    return fromPrivate(outerHex);
  };
  const toChecksum = address => {
    const addressHash = keccak256s(address.slice(2));
    let checksumAddress = "0x";
    for (let i = 0; i < 40; i++) checksumAddress += parseInt(addressHash[i + 2], 16) > 7 ? address[i + 2].toUpperCase() : address[i + 2];
    return checksumAddress;
  };
  const fromPrivate = privateKey => {
    const buffer = new Buffer(privateKey.slice(2), "hex");
    const ecKey = secp256k1.keyFromPrivate(buffer);
    const publicKey = "0x" + ecKey.getPublic(false, 'hex').slice(2);
    const publicHash = keccak256(publicKey);
    const address = toChecksum("0x" + publicHash.slice(-40));
    return {
      address: address,
      privateKey: privateKey
    };
  };
  const encodeSignature = ([v, r, s]) => Bytes.flatten([r, s, v]);
  const decodeSignature = hex => [Bytes.slice(64, Bytes.length(hex), hex), Bytes.slice(0, 32, hex), Bytes.slice(32, 64, hex)];
  const makeSigner = addToV => (hash, privateKey) => {
    const signature = secp256k1.keyFromPrivate(new Buffer(privateKey.slice(2), "hex")).sign(new Buffer(hash.slice(2), "hex"), {
      canonical: true
    });
    return encodeSignature([Nat.fromString(Bytes.fromNumber(addToV + signature.recoveryParam)), Bytes.pad(32, Bytes.fromNat("0x" + signature.r.toString(16))), Bytes.pad(32, Bytes.fromNat("0x" + signature.s.toString(16)))]);
  };
  const sign = makeSigner(27);
  const recover = (hash, signature) => {
    const vals = decodeSignature(signature);
    const vrs = {
      v: Bytes.toNumber(vals[0]),
      r: vals[1].slice(2),
      s: vals[2].slice(2)
    };
    const ecPublicKey = secp256k1.recoverPubKey(new Buffer(hash.slice(2), "hex"), vrs, vrs.v < 2 ? vrs.v : 1 - vrs.v % 2);
    const publicKey = "0x" + ecPublicKey.encode("hex", false).slice(2);
    const publicHash = keccak256(publicKey);
    const address = toChecksum("0x" + publicHash.slice(-40));
    return address;
  };
  var account = {
    create,
    toChecksum,
    fromPrivate,
    sign,
    makeSigner,
    recover,
    encodeSignature,
    decodeSignature
  };
  getDefaultExportFromCjs(account);

  function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
  function formatTypedData(to, value, data, operation, safeTxGas, dataGas, gasPrice, gasToken, refundReceiver, nonce, chainId, verifyingContract) {
    return {
      types: {
        EIP712Domain: [{
          type: 'uint256',
          name: 'chainId'
        }, {
          type: 'address',
          name: 'verifyingContract'
        }],
        SafeTx: [{
          type: 'address',
          name: 'to'
        }, {
          type: 'uint256',
          name: 'value'
        }, {
          type: 'bytes',
          name: 'data'
        }, {
          type: 'uint8',
          name: 'operation'
        }, {
          type: 'uint256',
          name: 'safeTxGas'
        }, {
          type: 'uint256',
          name: 'baseGas'
        }, {
          type: 'uint256',
          name: 'gasPrice'
        }, {
          type: 'address',
          name: 'gasToken'
        }, {
          type: 'address',
          name: 'refundReceiver'
        }, {
          type: 'uint256',
          name: 'nonce'
        }]
      },
      domain: {
        chainId: chainId,
        verifyingContract: verifyingContract
      },
      primaryType: 'SafeTx',
      message: {
        to: to,
        value: value,
        data: data,
        operation: operation,
        safeTxGas: safeTxGas,
        baseGas: dataGas,
        gasPrice: gasPrice,
        gasToken: gasToken,
        refundReceiver: refundReceiver,
        nonce: nonce
      }
    };
  }
  function formatTypedDataCRCVersion(to, value, data, operation, safeTxGas, dataGas, gasPrice, gasToken, refundReceiver, nonce, verifyingContract) {
    return {
      types: {
        EIP712Domain: [{
          type: 'address',
          name: 'verifyingContract'
        }],
        SafeTx: [{
          type: 'address',
          name: 'to'
        }, {
          type: 'uint256',
          name: 'value'
        }, {
          type: 'bytes',
          name: 'data'
        }, {
          type: 'uint8',
          name: 'operation'
        }, {
          type: 'uint256',
          name: 'safeTxGas'
        }, {
          type: 'uint256',
          name: 'baseGas'
        }, {
          type: 'uint256',
          name: 'gasPrice'
        }, {
          type: 'address',
          name: 'gasToken'
        }, {
          type: 'address',
          name: 'refundReceiver'
        }, {
          type: 'uint256',
          name: 'nonce'
        }]
      },
      domain: {
        verifyingContract: verifyingContract
      },
      primaryType: 'SafeTx',
      message: {
        to: to,
        value: value,
        data: data,
        operation: operation,
        safeTxGas: safeTxGas,
        baseGas: dataGas,
        gasPrice: gasPrice,
        gasToken: gasToken,
        refundReceiver: refundReceiver,
        nonce: nonce
      }
    };
  }
  function dependencies(typedData, primaryType) {
    var found = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (found.includes(primaryType)) {
      return found;
    }
    if (typedData.types[primaryType] === undefined) {
      return found;
    }
    found.push(primaryType);
    var _iterator = _createForOfIteratorHelper(typedData.types[primaryType]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var field = _step.value;
        var _iterator2 = _createForOfIteratorHelper(dependencies(typedData, field.type, found)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var dep = _step2.value;
            if (!found.includes(dep)) {
              found.push(dep);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return found;
  }
  function encodeType(typedData, primaryType) {
    var deps = dependencies(typedData, primaryType);
    deps = deps.filter(function (t) {
      return t != primaryType;
    });
    deps = [primaryType].concat(deps.sort());
    var result = '';
    var _iterator3 = _createForOfIteratorHelper(deps),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var type = _step3.value;
        result += "".concat(type, "(").concat(typedData.types[type].map(function (_ref) {
          var name = _ref.name,
            type = _ref.type;
          return "".concat(type, " ").concat(name);
        }).join(','), ")");
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return result;
  }
  function typeHash(web3, typedData, primaryType) {
    return web3.utils.keccak256(encodeType(typedData, primaryType));
  }
  function encodeData(web3, typedData, primaryType, data) {
    var types = [];
    var values = [];
    types.push('bytes32');
    values.push(typeHash(web3, typedData, primaryType));
    var _iterator4 = _createForOfIteratorHelper(typedData.types[primaryType]),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var field = _step4.value;
        var value = data[field.name];
        if (field.type == 'string' || field.type == 'bytes') {
          types.push('bytes32');
          value = web3.utils.keccak256(value);
        } else if (typedData.types[field.type] !== undefined) {
          types.push('bytes32');
          var test = encodeData(web3, typedData, field.type, data[field.name]);
          value = web3.utils.keccak256(test);
        } else {
          types.push(field.type);
        }
        values.push(value);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return web3.eth.abi.encodeParameters(types, values);
  }
  function structHash(web3, typedData, primaryType, data) {
    var hash = encodeData(web3, typedData, primaryType, data);
    return web3.utils.keccak256(hash).slice(2);
  }
  function signTypedData(web3, privateKey, typedData) {
    var typedDataHash = web3.utils.keccak256(['0x1901', structHash(web3, typedData, 'EIP712Domain', typedData.domain), structHash(web3, typedData, typedData.primaryType, typedData.message)].join(''));
    var signature = account.sign(typedDataHash, privateKey);
    var vrs = account.decodeSignature(signature);
    return {
      r: web3.utils.toBN(vrs[1]).toString(10),
      s: web3.utils.toBN(vrs[2]).toString(10),
      v: web3.utils.toDecimal(vrs[0])
    };
  }

  var transactionQueue = new TransactionQueue();
  function request(_x, _x2) {
    return _request.apply(this, arguments);
  }
  function _request() {
    _request = _asyncToGenerator( _regeneratorRuntime.mark(function _callee12(endpoint, userOptions) {
      var options, path, method, data, request, paramsStr, slash, url;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            options = checkOptions(userOptions, {
              path: {
                type: 'array'
              },
              method: {
                type: 'string',
                "default": 'GET'
              },
              data: {
                type: 'object',
                "default": {}
              },
              isTrailingSlash: {
                type: 'boolean',
                "default": true
              }
            });
            path = options.path, method = options.method, data = options.data;
            request = {
              method: method
            };
            paramsStr = '';
            if (data) {
              if (options.method === 'GET') {
                paramsStr = parameterize(data);
              } else if (typeof window !== 'undefined' && data instanceof FormData) {
                request.body = data;
              } else {
                request.body = JSON.stringify(data);
                request.headers = {
                  'Content-Type': 'application/json'
                };
              }
            }
            slash = options.isTrailingSlash ? '/' : '';
            url = "".concat(endpoint, "/").concat(path.join('/')).concat(slash).concat(paramsStr);
            _context12.prev = 7;
            return _context12.abrupt("return", fetch(url, request).then(function (response) {
              var contentType = response.headers.get('Content-Type');
              if (contentType && contentType.includes('application/json')) {
                return response.json().then(function (json) {
                  if (response.status >= 400) {
                    throw new RequestError(url, json, response.status);
                  }
                  return json;
                });
              } else {
                if (response.status >= 400) {
                  throw new RequestError(url, response.body, response.status);
                }
                return response.body;
              }
            }));
          case 11:
            _context12.prev = 11;
            _context12.t0 = _context12["catch"](7);
            throw new RequestError(url, _context12.t0.message);
          case 14:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[7, 11]]);
    }));
    return _request.apply(this, arguments);
  }
  function _requestRelayer2(_x3, _x4) {
    return _requestRelayer.apply(this, arguments);
  }
  function _requestRelayer() {
    _requestRelayer = _asyncToGenerator( _regeneratorRuntime.mark(function _callee13(endpoint, userOptions) {
      var options, path, method, data, version;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            options = checkOptions(userOptions, {
              path: {
                type: 'array'
              },
              version: {
                type: 'number',
                "default": 1
              },
              method: {
                type: 'string',
                "default": 'GET'
              },
              data: {
                type: 'object',
                "default": {}
              }
            });
            path = options.path, method = options.method, data = options.data, version = options.version;
            return _context13.abrupt("return", request(endpoint, {
              path: ['api', "v".concat(version)].concat(path),
              method: method,
              data: data
            }));
          case 3:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return _requestRelayer.apply(this, arguments);
  }
  function _requestGraph2(_x5, _x6, _x7) {
    return _requestGraph.apply(this, arguments);
  }
  function _requestGraph() {
    _requestGraph = _asyncToGenerator( _regeneratorRuntime.mark(function _callee14(endpoint, subgraphName, userOptions) {
      var options, query, variables, response;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            options = checkOptions(userOptions, {
              query: {
                type: 'string'
              },
              variables: {
                type: 'object',
                "default": {}
              }
            });
            query = options.query.replace(/\s\s+/g, ' ');
            variables = Object.keys(options.variables).length === 0 ? undefined : options.variables;
            _context14.next = 5;
            return request(endpoint, {
              path: ['subgraphs', 'name', subgraphName],
              method: 'POST',
              data: {
                query: query,
                variables: variables
              },
              isTrailingSlash: false
            });
          case 5:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);
          case 7:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return _requestGraph.apply(this, arguments);
  }
  function _requestIndexedDB2(_x8, _x9, _x10, _x11, _x12) {
    return _requestIndexedDB.apply(this, arguments);
  }
  function _requestIndexedDB() {
    _requestIndexedDB = _asyncToGenerator( _regeneratorRuntime.mark(function _callee15(graphNodeEndpoint, subgraphName, databaseSource, data, parameters) {
      var response;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.t0 = data;
            _context15.next = _context15.t0 === 'activity_stream' ? 3 : _context15.t0 === 'organization_status' ? 5 : _context15.t0 === 'safe_addresses' ? 7 : _context15.t0 === 'balances' ? 9 : _context15.t0 === 'trust_network' ? 11 : _context15.t0 === 'trust_status' ? 13 : 15;
            break;
          case 3:
            response = getNotificationsStatus(graphNodeEndpoint, subgraphName, databaseSource, parameters);
            return _context15.abrupt("break", 15);
          case 5:
            response = getOrganizationStatus(graphNodeEndpoint, subgraphName, databaseSource, parameters);
            return _context15.abrupt("break", 15);
          case 7:
            response = getSafeAddresses(graphNodeEndpoint, subgraphName, databaseSource, parameters);
            return _context15.abrupt("break", 15);
          case 9:
            response = getBalancesStatus(graphNodeEndpoint, subgraphName, databaseSource, parameters);
            return _context15.abrupt("break", 15);
          case 11:
            response = getTrustNetworkStatus(graphNodeEndpoint, subgraphName, databaseSource, parameters);
            return _context15.abrupt("break", 15);
          case 13:
            response = getTrustStatus(graphNodeEndpoint, subgraphName, databaseSource, parameters);
            return _context15.abrupt("break", 15);
          case 15:
            return _context15.abrupt("return", response);
          case 16:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _requestIndexedDB.apply(this, arguments);
  }
  function getNotificationsStatus(graphNodeEndpoint, subgraphName, databaseSource, parameters) {
    var query;
    switch (databaseSource) {
      case 'graph':
      default:
        query = {
          query: "{\n          notifications(".concat(parameters, ") {\n            id\n            transactionHash\n            safeAddress\n            type\n            time\n            trust {\n              user\n              canSendTo\n              limitPercentage\n            }\n            transfer {\n              from\n              to\n              amount\n            }\n            hubTransfer {\n              from\n              to\n              amount\n            }\n            ownership {\n              adds\n              removes\n            }\n          }\n        }")
        };
        break;
    }
    return _requestGraph2(graphNodeEndpoint, subgraphName, query);
  }
  function getOrganizationStatus(graphNodeEndpoint, subgraphName, databaseSource, ownerAddress) {
    var query;
    switch (databaseSource) {
      case 'graph':
      default:
        query = {
          query: "{\n          user(first: 1000 id: \"".concat(ownerAddress.toLowerCase(), "\") {\n            id,\n            safes {\n              id\n              organization\n            }\n          }\n        }")
        };
        break;
    }
    return _requestGraph2(graphNodeEndpoint, subgraphName, query);
  }
  function getSafeAddresses(graphNodeEndpoint, subgraphName, databaseSource, parameters) {
    var query;
    switch (databaseSource) {
      case 'graph':
      default:
        query = {
          query: "{\n          user(id: \"".concat(parameters.ownerAddress.toLowerCase(), "\") {\n            safeAddresses,\n          }\n        }")
        };
        break;
    }
    return _requestGraph2(graphNodeEndpoint, subgraphName, query);
  }
  function getBalancesStatus(graphNodeEndpoint, subgraphName, databaseSource, safeAddress) {
    var query;
    switch (databaseSource) {
      case 'graph':
      default:
        query = {
          query: "{\n          safe(id: \"".concat(safeAddress.toLowerCase(), "\") {\n            balances(first: 1000) {\n              token {\n                id\n              }\n              amount\n            }\n          }\n        }")
        };
        break;
    }
    return _requestGraph2(graphNodeEndpoint, subgraphName, query);
  }
  function getTrustNetworkStatus(graphNodeEndpoint, subgraphName, databaseSource, safeAddress) {
    var query;
    switch (databaseSource) {
      case 'graph':
      default:
        query = {
          query: "{\n          trusts (first: 1000 where: { userAddress: \"".concat(safeAddress, "\" }) {\n            id\n            limitPercentage\n          }\n        }")
        };
        break;
    }
    return _requestGraph2(graphNodeEndpoint, subgraphName, query);
  }
  function getTrustStatus(graphNodeEndpoint, subgraphName, databaseSource, safeAddress) {
    var query;
    switch (databaseSource) {
      case 'graph':
      default:
        query = {
          query: "{\n          safe(id: \"".concat(safeAddress, "\") {\n            outgoing (first: 1000 where: { limitPercentage_not: \"").concat(NO_LIMIT_PERCENTAGE, "\" canSendToAddress_not: \"").concat(safeAddress, "\" }) {\n              canSendToAddress\n            }\n            incoming (first: 1000 where: { limitPercentage_not: \"").concat(NO_LIMIT_PERCENTAGE, "\" userAddress_not: \"").concat(safeAddress, "\" }) {\n              userAddress\n              user {\n                outgoing (first: 1000 where: { limitPercentage_not: \"").concat(NO_LIMIT_PERCENTAGE, "\" }) {\n                  canSendToAddress\n                }\n              }\n            }\n          }\n        }")
        };
        break;
    }
    return _requestGraph2(graphNodeEndpoint, subgraphName, query);
  }
  function _estimateTransactionCosts2(_x13, _x14) {
    return _estimateTransactionCosts.apply(this, arguments);
  }
  function _estimateTransactionCosts() {
    _estimateTransactionCosts = _asyncToGenerator( _regeneratorRuntime.mark(function _callee16(endpoint, _ref) {
      var safeAddress, to, txData, _ref$value, value, _ref$gasToken, gasToken, _ref$operation, operation;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            safeAddress = _ref.safeAddress, to = _ref.to, txData = _ref.txData, _ref$value = _ref.value, value = _ref$value === void 0 ? 0 : _ref$value, _ref$gasToken = _ref.gasToken, gasToken = _ref$gasToken === void 0 ? ZERO_ADDRESS : _ref$gasToken, _ref$operation = _ref.operation, operation = _ref$operation === void 0 ? CALL_OP : _ref$operation;
            _context16.next = 3;
            return _requestRelayer2(endpoint, {
              path: ['safes', safeAddress, 'transactions', 'estimate'],
              method: 'POST',
              version: 2,
              data: {
                safe: safeAddress,
                data: txData,
                to: to,
                value: value,
                operation: operation,
                gasToken: gasToken
              }
            });
          case 3:
            return _context16.abrupt("return", _context16.sent);
          case 4:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return _estimateTransactionCosts.apply(this, arguments);
  }
  function waitForPendingTransactions(_x15, _x16, _x17, _x18) {
    return _waitForPendingTransactions.apply(this, arguments);
  }
  function _waitForPendingTransactions() {
    _waitForPendingTransactions = _asyncToGenerator( _regeneratorRuntime.mark(function _callee18(web3, endpoint, safeAddress, pendingTicketId) {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return loop( _asyncToGenerator( _regeneratorRuntime.mark(function _callee17() {
              var _transactionQueue$get, txHash, nonce, currentTicketId, response;
              return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                while (1) switch (_context17.prev = _context17.next) {
                  case 0:
                    if (transactionQueue.isLocked(safeAddress)) {
                      _context17.next = 2;
                      break;
                    }
                    return _context17.abrupt("return", transactionQueue.isNextInQueue(safeAddress, pendingTicketId));
                  case 2:
                    _transactionQueue$get = transactionQueue.getCurrentTransaction(safeAddress), txHash = _transactionQueue$get.txHash, nonce = _transactionQueue$get.nonce, currentTicketId = _transactionQueue$get.ticketId;
                    _context17.prev = 3;
                    _context17.next = 6;
                    return _requestRelayer2(endpoint, {
                      path: ['safes', safeAddress, 'transactions'],
                      method: 'GET',
                      version: 1,
                      data: {
                        limit: 1,
                        ethereum_tx__tx_hash: txHash,
                        nonce: nonce
                      }
                    });
                  case 6:
                    response = _context17.sent;
                    if (response.results.length === 1) {
                      transactionQueue.unlockTransaction(safeAddress, currentTicketId);
                      transactionQueue.unqueue(safeAddress, currentTicketId);
                    }
                    _context17.next = 12;
                    break;
                  case 10:
                    _context17.prev = 10;
                    _context17.t0 = _context17["catch"](3);
                  case 12:
                    return _context17.abrupt("return", false);
                  case 13:
                  case "end":
                    return _context17.stop();
                }
              }, _callee17, null, [[3, 10]]);
            })), function (isReady) {
              return isReady;
            });
          case 2:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    return _waitForPendingTransactions.apply(this, arguments);
  }
  function requestNonce(_x19, _x20, _x21) {
    return _requestNonce.apply(this, arguments);
  }
  function _requestNonce() {
    _requestNonce = _asyncToGenerator( _regeneratorRuntime.mark(function _callee19(web3, endpoint, safeAddress) {
      var nonce, response;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            nonce = null;
            _context19.prev = 1;
            _context19.next = 4;
            return _requestRelayer2(endpoint, {
              path: ['safes', safeAddress],
              method: 'GET',
              version: 1,
              data: {
                limit: 1
              }
            });
          case 4:
            response = _context19.sent;
            nonce = response.nonce || null;
            _context19.next = 10;
            break;
          case 8:
            _context19.prev = 8;
            _context19.t0 = _context19["catch"](1);
          case 10:
            if (!(nonce === null)) {
              _context19.next = 14;
              break;
            }
            _context19.next = 13;
            return getSafeContract(web3, safeAddress).methods.nonce().call();
          case 13:
            return _context19.abrupt("return", _context19.sent);
          case 14:
            return _context19.abrupt("return", "".concat(parseInt(nonce, 10)));
          case 15:
          case "end":
            return _context19.stop();
        }
      }, _callee19, null, [[1, 8]]);
    }));
    return _requestNonce.apply(this, arguments);
  }
  function createUtilsModule(web3, contracts, globalOptions) {
    var apiServiceEndpoint = globalOptions.apiServiceEndpoint,
      pathfinderServiceEndpoint = globalOptions.pathfinderServiceEndpoint,
      databaseSource = globalOptions.databaseSource,
      graphNodeEndpoint = globalOptions.graphNodeEndpoint,
      relayServiceEndpoint = globalOptions.relayServiceEndpoint,
      subgraphName = globalOptions.subgraphName;
    var hub = contracts.hub;
    function _listAllTokens2(_x22) {
      return _listAllTokens.apply(this, arguments);
    }
    function _listAllTokens() {
      _listAllTokens = _asyncToGenerator( _regeneratorRuntime.mark(function _callee11(safeAddress) {
        var tokens, tokenAddress, tokenContract, amount, tokensResponse;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              tokens = [];
              _context11.next = 3;
              return hub.methods.userToToken(safeAddress).call();
            case 3:
              tokenAddress = _context11.sent;
              if (!(tokenAddress !== ZERO_ADDRESS)) {
                _context11.next = 10;
                break;
              }
              tokenContract = getTokenContract(web3, tokenAddress);
              _context11.next = 8;
              return tokenContract.methods.balanceOf(safeAddress).call();
            case 8:
              amount = _context11.sent;
              tokens.push({
                amount: web3.utils.toBN(amount.toString()),
                address: web3.utils.toChecksumAddress(tokenAddress),
                ownerAddress: safeAddress
              });
            case 10:
              _context11.prev = 10;
              _context11.next = 13;
              return _requestGraph2(graphNodeEndpoint, subgraphName, {
                query: "{\n            safe(id: \"".concat(safeAddress.toLowerCase(), "\") {\n              balances(\n              first: 1000\n              orderBy: amount\n              orderDirection: desc\n              where: {amount_not: \"0\"} )\n                {\n                token {\n                  id\n                  owner {\n                    id\n                  }\n                }\n                amount\n              }\n            }\n          }")
              });
            case 13:
              tokensResponse = _context11.sent;
              if (tokensResponse && tokensResponse.safe) {
                tokensResponse.safe.balances.forEach(function (balance) {
                  var tokenAddress = web3.utils.toChecksumAddress(balance.token.id);
                  var ownerAddress = web3.utils.toChecksumAddress(balance.token.owner.id);
                  if (tokens.find(function (_ref5) {
                    var address = _ref5.address;
                    return address === tokenAddress;
                  })) {
                    return;
                  }
                  tokens.push({
                    amount: web3.utils.toBN(balance.amount),
                    address: tokenAddress,
                    ownerAddress: ownerAddress
                  });
                });
              }
              _context11.next = 19;
              break;
            case 17:
              _context11.prev = 17;
              _context11.t0 = _context11["catch"](10);
            case 19:
              return _context11.abrupt("return", tokens.sort(function (_ref6, _ref7) {
                var amountA = _ref6.amount;
                var amountB = _ref7.amount;
                return web3.utils.toBN(amountA).cmp(web3.utils.toBN(amountB));
              }));
            case 20:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[10, 17]]);
      }));
      return _listAllTokens.apply(this, arguments);
    }
    return {
      loop: loop,
      matchAddress: function matchAddress(str) {
        var results = str.match(/0x[a-fA-F0-9]{40}/);
        if (results && results.length > 0) {
          return results[0];
        } else {
          return null;
        }
      },
      toFreckles: function toFreckles(value) {
        return web3.utils.toWei("".concat(value), 'ether');
      },
      fromFreckles: function fromFreckles(value) {
        return parseInt(web3.utils.fromWei("".concat(value), 'ether'), 10);
      },
      requestRelayer: function () {
        var _requestRelayer3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee(userOptions) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _requestRelayer2(relayServiceEndpoint, userOptions));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function requestRelayer(_x23) {
          return _requestRelayer3.apply(this, arguments);
        }
        return requestRelayer;
      }(),
      requestGraph: function () {
        var _requestGraph3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee2(userOptions) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _requestGraph2(graphNodeEndpoint, subgraphName, userOptions));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function requestGraph(_x24) {
          return _requestGraph3.apply(this, arguments);
        }
        return requestGraph;
      }(),
      requestIndexedDB: function () {
        var _requestIndexedDB3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee3(data, parameters) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _requestIndexedDB2(graphNodeEndpoint, subgraphName, databaseSource, data, parameters));
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function requestIndexedDB(_x25, _x26) {
          return _requestIndexedDB3.apply(this, arguments);
        }
        return requestIndexedDB;
      }(),
      listAllTokens: function () {
        var _listAllTokens3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee4(userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  }
                });
                _context4.next = 3;
                return _listAllTokens2(options.safeAddress);
              case 3:
                return _context4.abrupt("return", _context4.sent);
              case 4:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function listAllTokens(_x27) {
          return _listAllTokens3.apply(this, arguments);
        }
        return listAllTokens;
      }(),
      executeTokenSafeTx: function () {
        var _executeTokenSafeTx = _asyncToGenerator( _regeneratorRuntime.mark(function _callee6(account, userOptions) {
          var options, txData, safeAddress, to, isCRCVersion, transferData, operation, refundReceiver, value, preEstimation, totalGasEstimate, tokens, foundToken, _loop, i, _yield$estimateTransa, dataGas, safeTxGas, gasPrice, gasToken, ticketId, nonce, typedData, chainId, signature, _yield$_requestRelaye, txHash;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  to: {
                    type: web3.utils.checkAddressChecksum
                  },
                  txData: {
                    type: web3.utils.isHexStrict
                  },
                  transferData: {
                    type: 'object',
                    "default": {
                      tokenOwners: [],
                      sources: [],
                      destinations: [],
                      values: []
                    },
                    required: ['tokenOwners', 'sources', 'destinations', 'values'],
                    properties: {
                      tokenOwners: {
                        type: 'array',
                        items: {
                          type: web3.utils.checkAddressChecksum
                        }
                      },
                      sources: {
                        type: 'array',
                        items: {
                          type: web3.utils.checkAddressChecksum
                        }
                      },
                      destinations: {
                        type: 'array',
                        items: {
                          type: web3.utils.checkAddressChecksum
                        }
                      },
                      values: {
                        type: 'array',
                        items: {
                          type: web3.utils.isBN
                        }
                      }
                    }
                  },
                  isCRCVersion: {
                    type: 'boolean',
                    "default": false
                  }
                });
                txData = options.txData, safeAddress = options.safeAddress, to = options.to, isCRCVersion = options.isCRCVersion, transferData = options.transferData;
                operation = CALL_OP;
                refundReceiver = ZERO_ADDRESS;
                value = 0;
                _context6.next = 8;
                return _estimateTransactionCosts2(relayServiceEndpoint, {
                  gasToken: ZERO_ADDRESS,
                  operation: operation,
                  safeAddress: safeAddress,
                  to: to,
                  txData: txData,
                  value: value
                });
              case 8:
                preEstimation = _context6.sent;
                totalGasEstimate = web3.utils.toBN(preEstimation.dataGas).add(new web3.utils.BN(preEstimation.safeTxGas)).mul(new web3.utils.BN(preEstimation.gasPrice));
                _context6.next = 12;
                return _listAllTokens2(safeAddress);
              case 12:
                tokens = _context6.sent;
                if (!(tokens.length === 0)) {
                  _context6.next = 15;
                  break;
                }
                throw new CoreError('No tokens given to pay transaction', ErrorCodes.INSUFFICIENT_FUNDS);
              case 15:
                foundToken = tokens.find(function (_ref2) {
                  var amount = _ref2.amount,
                    ownerAddress = _ref2.ownerAddress;
                  return !transferData.tokenOwners.includes(ownerAddress) && web3.utils.toBN(amount).gte(totalGasEstimate);
                });
                if (foundToken) {
                  _context6.next = 25;
                  break;
                }
                _loop = _regeneratorRuntime.mark(function _callee5(i) {
                  var tokenInTransfer;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (transferData.sources[i] === safeAddress) {
                          tokenInTransfer = tokens.find(function (_ref4) {
                            var ownerAddress = _ref4.ownerAddress;
                            ownerAddress === transferData.tokenOwners[i];
                          });
                          if (tokenInTransfer) {
                            tokenInTransfer.amount = tokenInTransfer.amount.sub(transferData.values[i]);
                          }
                        }
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                });
                i = 0;
              case 19:
                if (!(i < transferData.tokenOwners.length)) {
                  _context6.next = 24;
                  break;
                }
                return _context6.delegateYield(_loop(i), "t0", 21);
              case 21:
                i++;
                _context6.next = 19;
                break;
              case 24:
                foundToken = tokens.find(function (_ref3) {
                  var amount = _ref3.amount;
                  return web3.utils.toBN(amount).gte(totalGasEstimate);
                });
              case 25:
                if (foundToken) {
                  _context6.next = 27;
                  break;
                }
                throw new CoreError('No token found with sufficient funds to pay transaction', ErrorCodes.INSUFFICIENT_FUNDS);
              case 27:
                _context6.next = 29;
                return _estimateTransactionCosts2(relayServiceEndpoint, {
                  gasToken: foundToken.address,
                  operation: operation,
                  safeAddress: safeAddress,
                  to: to,
                  txData: txData,
                  value: value
                });
              case 29:
                _yield$estimateTransa = _context6.sent;
                dataGas = _yield$estimateTransa.dataGas;
                safeTxGas = _yield$estimateTransa.safeTxGas;
                gasPrice = _yield$estimateTransa.gasPrice;
                gasToken = foundToken.address;
                ticketId = transactionQueue.queue(safeAddress);
                _context6.next = 37;
                return waitForPendingTransactions(web3, relayServiceEndpoint, safeAddress, ticketId);
              case 37:
                _context6.next = 39;
                return requestNonce(web3, relayServiceEndpoint, safeAddress);
              case 39:
                nonce = _context6.sent;
                if (!(isCRCVersion == true)) {
                  _context6.next = 44;
                  break;
                }
                typedData = formatTypedDataCRCVersion(to, value, txData, operation, safeTxGas, dataGas, gasPrice, gasToken, refundReceiver, nonce, safeAddress);
                _context6.next = 48;
                break;
              case 44:
                _context6.next = 46;
                return web3.eth.getChainId();
              case 46:
                chainId = _context6.sent;
                typedData = formatTypedData(to, value, txData, operation, safeTxGas, dataGas, gasPrice, gasToken, refundReceiver, nonce, chainId, safeAddress);
              case 48:
                signature = signTypedData(web3, account.privateKey, typedData);
                _context6.prev = 49;
                _context6.next = 52;
                return _requestRelayer2(relayServiceEndpoint, {
                  path: ['safes', safeAddress, 'transactions'],
                  method: 'POST',
                  version: 1,
                  data: {
                    to: to,
                    value: value,
                    data: txData,
                    operation: operation,
                    signatures: [signature],
                    safeTxGas: safeTxGas,
                    dataGas: dataGas,
                    gasPrice: gasPrice,
                    nonce: nonce,
                    gasToken: gasToken
                  }
                });
              case 52:
                _yield$_requestRelaye = _context6.sent;
                txHash = _yield$_requestRelaye.txHash;
                transactionQueue.lockTransaction(safeAddress, {
                  nonce: nonce,
                  ticketId: ticketId,
                  txHash: txHash
                });
                return _context6.abrupt("return", txHash);
              case 58:
                _context6.prev = 58;
                _context6.t1 = _context6["catch"](49);
                transactionQueue.unlockTransaction(safeAddress, ticketId);
                transactionQueue.unqueue(safeAddress, ticketId);
                return _context6.abrupt("return", null);
              case 63:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[49, 58]]);
        }));
        function executeTokenSafeTx(_x28, _x29) {
          return _executeTokenSafeTx.apply(this, arguments);
        }
        return executeTokenSafeTx;
      }(),
      executeSafeTx: function () {
        var _executeSafeTx = _asyncToGenerator( _regeneratorRuntime.mark(function _callee7(account, userOptions) {
          var options, to, gasToken, txData, value, safeAddress, isCRCVersion, operation, refundReceiver, _yield$estimateTransa2, dataGas, gasPrice, safeTxGas, ticketId, totalGasEstimate, nonce, typedData, chainId, signature, _yield$_requestRelaye2, txHash;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  to: {
                    type: web3.utils.checkAddressChecksum
                  },
                  gasToken: {
                    type: web3.utils.checkAddressChecksum,
                    "default": ZERO_ADDRESS
                  },
                  txData: {
                    type: web3.utils.isHexStrict,
                    "default": '0x'
                  },
                  value: {
                    type: 'number',
                    "default": 0
                  },
                  isCRCVersion: {
                    type: 'boolean',
                    "default": false
                  }
                });
                to = options.to, gasToken = options.gasToken, txData = options.txData, value = options.value, safeAddress = options.safeAddress, isCRCVersion = options.isCRCVersion;
                operation = CALL_OP;
                refundReceiver = ZERO_ADDRESS;
                _context7.next = 7;
                return _estimateTransactionCosts2(relayServiceEndpoint, {
                  gasToken: gasToken,
                  operation: operation,
                  safeAddress: safeAddress,
                  to: to,
                  txData: txData,
                  value: value
                });
              case 7:
                _yield$estimateTransa2 = _context7.sent;
                dataGas = _yield$estimateTransa2.dataGas;
                gasPrice = _yield$estimateTransa2.gasPrice;
                safeTxGas = _yield$estimateTransa2.safeTxGas;
                ticketId = transactionQueue.queue(safeAddress);
                totalGasEstimate = web3.utils.toBN(dataGas).add(new web3.utils.BN(safeTxGas)).mul(new web3.utils.BN(gasPrice));
                _context7.next = 15;
                return loop(function () {
                  return web3.eth.getBalance(safeAddress);
                }, function (balance) {
                  return web3.utils.toBN(balance).gte(totalGasEstimate);
                });
              case 15:
                _context7.next = 17;
                return waitForPendingTransactions(web3, relayServiceEndpoint, safeAddress, ticketId);
              case 17:
                _context7.next = 19;
                return requestNonce(web3, relayServiceEndpoint, safeAddress);
              case 19:
                nonce = _context7.sent;
                if (!(isCRCVersion == true)) {
                  _context7.next = 24;
                  break;
                }
                typedData = formatTypedDataCRCVersion(to, value, txData, operation, safeTxGas, dataGas, gasPrice, gasToken, refundReceiver, nonce, safeAddress);
                _context7.next = 28;
                break;
              case 24:
                _context7.next = 26;
                return web3.eth.getChainId();
              case 26:
                chainId = _context7.sent;
                typedData = formatTypedData(to, value, txData, operation, safeTxGas, dataGas, gasPrice, gasToken, refundReceiver, nonce, chainId, safeAddress);
              case 28:
                signature = signTypedData(web3, account.privateKey, typedData);
                _context7.prev = 29;
                _context7.next = 32;
                return _requestRelayer2(relayServiceEndpoint, {
                  path: ['safes', safeAddress, 'transactions'],
                  method: 'POST',
                  version: 1,
                  data: {
                    to: to,
                    value: value,
                    data: txData,
                    operation: operation,
                    signatures: [signature],
                    safeTxGas: safeTxGas,
                    dataGas: dataGas,
                    gasPrice: gasPrice,
                    nonce: nonce,
                    gasToken: gasToken
                  }
                });
              case 32:
                _yield$_requestRelaye2 = _context7.sent;
                txHash = _yield$_requestRelaye2.txHash;
                transactionQueue.lockTransaction(safeAddress, {
                  nonce: nonce,
                  ticketId: ticketId,
                  txHash: txHash
                });
                return _context7.abrupt("return", txHash);
              case 38:
                _context7.prev = 38;
                _context7.t0 = _context7["catch"](29);
                transactionQueue.unlockTransaction(safeAddress, ticketId);
                transactionQueue.unqueue(safeAddress, ticketId);
                return _context7.abrupt("return", null);
              case 43:
              case "end":
                return _context7.stop();
            }
          }, _callee7, null, [[29, 38]]);
        }));
        function executeSafeTx(_x30, _x31) {
          return _executeSafeTx.apply(this, arguments);
        }
        return executeSafeTx;
      }(),
      requestAPI: function () {
        var _requestAPI = _asyncToGenerator( _regeneratorRuntime.mark(function _callee8(userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                options = checkOptions(userOptions, {
                  path: {
                    type: 'array'
                  },
                  method: {
                    type: 'string',
                    "default": 'GET'
                  },
                  data: {
                    type: 'object',
                    "default": {}
                  }
                });
                return _context8.abrupt("return", request(apiServiceEndpoint, {
                  data: options.data,
                  method: options.method,
                  path: ['api'].concat(options.path)
                }));
              case 2:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        function requestAPI(_x32) {
          return _requestAPI.apply(this, arguments);
        }
        return requestAPI;
      }(),
      requestPathfinderAPI: function () {
        var _requestPathfinderAPI = _asyncToGenerator( _regeneratorRuntime.mark(function _callee9(userOptions) {
          var options;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                options = checkOptions(userOptions, {
                  method: {
                    type: 'string',
                    "default": 'GET'
                  },
                  data: {
                    type: 'object',
                    "default": {}
                  }
                });
                return _context9.abrupt("return", request(pathfinderServiceEndpoint, {
                  data: options.data,
                  method: options.method,
                  path: [],
                  isTrailingSlash: false
                }));
              case 2:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        function requestPathfinderAPI(_x33) {
          return _requestPathfinderAPI.apply(this, arguments);
        }
        return requestPathfinderAPI;
      }(),
      estimateTransactionCosts: function () {
        var _estimateTransactionCosts3 = _asyncToGenerator( _regeneratorRuntime.mark(function _callee10(account, userOptions) {
          var options, txData, gasToken, safeAddress, to, value, operation, _yield$_estimateTrans, dataGas, safeTxGas, gasPrice;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                checkAccount(web3, account);
                options = checkOptions(userOptions, {
                  safeAddress: {
                    type: web3.utils.checkAddressChecksum
                  },
                  to: {
                    type: web3.utils.checkAddressChecksum
                  },
                  gasToken: {
                    type: web3.utils.checkAddressChecksum,
                    "default": ZERO_ADDRESS
                  },
                  txData: {
                    type: web3.utils.isHexStrict,
                    "default": '0x'
                  },
                  value: {
                    type: 'number',
                    "default": 0
                  }
                });
                txData = options.txData, gasToken = options.gasToken, safeAddress = options.safeAddress, to = options.to, value = options.value;
                operation = CALL_OP;
                _context10.next = 6;
                return _estimateTransactionCosts2(relayServiceEndpoint, {
                  gasToken: gasToken,
                  operation: operation,
                  safeAddress: safeAddress,
                  to: to,
                  txData: txData,
                  value: value
                });
              case 6:
                _yield$_estimateTrans = _context10.sent;
                dataGas = _yield$_estimateTrans.dataGas;
                safeTxGas = _yield$_estimateTrans.safeTxGas;
                gasPrice = _yield$_estimateTrans.gasPrice;
                return _context10.abrupt("return", web3.utils.toBN(dataGas).add(new web3.utils.BN(safeTxGas)).mul(new web3.utils.BN(gasPrice)));
              case 11:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        function estimateTransactionCosts(_x34, _x35) {
          return _estimateTransactionCosts3.apply(this, arguments);
        }
        return estimateTransactionCosts;
      }()
    };
  }

  var CirclesCore = _createClass(
  function CirclesCore(web3, options) {
    _classCallCheck(this, CirclesCore);
    if (!web3 || !web3.version) {
      throw new CoreError('Web3 instance missing');
    }
    this.web3 = web3;
    this.options = checkOptions(options, {
      hubAddress: {
        type: web3.utils.checkAddressChecksum
      },
      proxyFactoryAddress: {
        type: web3.utils.checkAddressChecksum
      },
      safeMasterAddress: {
        type: web3.utils.checkAddressChecksum
      },
      fallbackHandlerAddress: {
        type: web3.utils.checkAddressChecksum
      },
      graphNodeEndpoint: {
        type: 'string'
      },
      databaseSource: {
        type: 'string',
        "default": 'graph'
      },
      apiServiceEndpoint: {
        type: 'string'
      },
      pathfinderServiceEndpoint: {
        type: 'string'
      },
      relayServiceEndpoint: {
        type: 'string'
      },
      subgraphName: {
        type: 'string'
      },
      pathfinderType: {
        type: 'string',
        "default": 'server'
      },
      pathfinderMaxTransferSteps: {
        type: 'number',
        "default": 17
      }
    });
    this.CoreError = CoreError;
    this.TransferError = TransferError;
    this.RequestError = RequestError;
    this.ErrorCodes = ErrorCodes;
    this.contracts = getContracts(web3, this.options);
    this.utils = createUtilsModule(web3, this.contracts, this.options);
    this.activity = createActivityModule(web3, this.contracts, this.utils);
    this.news = createNewsModule(this.utils);
    this.organization = createOrganizationModule(web3, this.contracts, this.utils);
    this.safe = createSafeModule(web3, this.contracts, this.utils, this.options);
    this.token = createTokenModule(web3, this.contracts, this.utils, this.options);
    this.trust = createTrustModule(web3, this.contracts, this.utils);
    this.user = createUserModule(web3, this.contracts, this.utils);
    this.avatar = createAvatarModule(web3, this.utils);
  });

  return CirclesCore;

}));
